import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"
import * as React from "react"
import * as ApolloReactComponents from "@apollo/client/react/components"
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never }
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
    ID: { input: string; output: string }
    String: { input: string; output: string }
    Boolean: { input: boolean; output: boolean }
    Int: { input: number; output: number }
    Float: { input: number; output: number }
    Buffer: { input: any; output: any }
    DateTime: { input: any; output: any }
}

export enum AccionesEdicion {
    Agregar = "agregar",
    Eliminar = "eliminar",
    Modificar = "modificar",
}

export interface AcumulaPuntosInput {
    data: Array<AcumulaPuntosPartialInfoInput>
    easyrewards_id: Scalars["String"]["input"]
    hotel_id: Scalars["ID"]["input"]
}

export interface AcumulaPuntosPartialInfoInput {
    /** ID del ticket */
    folio_ticket: Scalars["String"]["input"]
    monto_alimentos?: Scalars["Float"]["input"]
    monto_bebidas?: Scalars["Float"]["input"]
    monto_extras?: Scalars["Float"]["input"]
    monto_habitacion?: Scalars["Float"]["input"]
    monto_sexspa?: Scalars["Float"]["input"]
    /** 0 = default, 1 = restaurante */
    origen: Scalars["Float"]["input"]
}

export interface AddColaboradorInHotelInput {
    area_id: Scalars["ID"]["input"]
    colaborador_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
    puesto_id: Scalars["ID"]["input"]
}

export interface AddComentarioHabitacionInput {
    comentario: ComentarioHabitacionInput
    habitacion_id: Scalars["ID"]["input"]
}

export interface AddComentarioIncidenciaInput {
    comentario: Scalars["String"]["input"]
    indicencia_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface AddComentarioRentaInput {
    comentario: Scalars["String"]["input"]
    renta_id: Scalars["ID"]["input"]
}

export interface AddComentarioReservaInput {
    comentario: Scalars["String"]["input"]
    reserva_id: Scalars["ID"]["input"]
}

export interface AddCommentToTaskInput {
    colaborador_tarea_id: Scalars["ID"]["input"]
    comentarios: Array<CommentTaskInput>
}

export interface AddExtrasReservaInput {
    hospedajes_extras_plus: Scalars["Int"]["input"]
    pago_hospedajes?: InputMaybe<CreatePagoInput>
    pago_personas?: InputMaybe<CreatePagoInput>
    personas_extras_plus: Scalars["Int"]["input"]
    reserva_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface AddHorasExtrasRentaInput {
    cantidad: Scalars["Float"]["input"]
    colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    pago?: InputMaybe<CreatePagoInput>
    propina?: InputMaybe<AddPropinaVentaInput>
    renta_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface AddHospedajesExtrasRentaInput {
    cantidad_hospedajes: Scalars["Float"]["input"]
    cantidad_personas: Scalars["Float"]["input"]
    colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    pago?: InputMaybe<CreatePagoInput>
    propina?: InputMaybe<AddPropinaVentaInput>
    renta_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface AddImageInput {
    image: ImagenIncidenciaInput
    indicencia_id: Scalars["ID"]["input"]
}

export interface AddPersonasExtrasRentaInput {
    cantidad: Scalars["Float"]["input"]
    colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    pago?: InputMaybe<CreatePagoInput>
    propina?: InputMaybe<AddPropinaVentaInput>
    renta_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface AddPropinaVentaInput {
    colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    detalles_pago: Array<DetallePagoPartialInfoObject>
}

export interface AddRoomToBookingInput {
    habitacion_id: Scalars["ID"]["input"]
    reserva_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface AjustarAsignacionPropinaInput {
    colaborador_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
    ingreso_hotel?: InputMaybe<Scalars["Boolean"]["input"]>
    monto_ajuste: Scalars["Float"]["input"]
    puesto_id: Scalars["ID"]["input"]
}

export interface AjustarAsignacionPropinaOutput {
    __typename?: "AjustarAsignacionPropinaOutput"
    limite_disponible: Scalars["Float"]["output"]
    monto_recaudado: Scalars["Float"]["output"]
    propinas_ajustadas: Array<RepartoPropinaItemOutput>
}

export interface AlertasCorteOutput {
    __typename?: "AlertasCorteOutput"
    alerta_por_pagos_pendientes: Scalars["Boolean"]["output"]
    registros_pagos_pendientes: Array<RegistroPagoPendienteOutput>
    registros_pendientes: AlertasPorRegistrosPendientesDetailOutput
}

export interface AlertasPorRegistrosPendientesDetailOutput {
    __typename?: "AlertasPorRegistrosPendientesDetailOutput"
    alerta_por_mantenimiento_pendiente: Scalars["Boolean"]["output"]
    alerta_por_placas_pendientes: Scalars["Boolean"]["output"]
    registro_obligatorio: Scalars["Boolean"]["output"]
}

export interface Almacen {
    __typename?: "Almacen"
    almacen_id: Scalars["ID"]["output"]
    categorias_almacenes: Array<CategoriaArticulo>
    descripcion: Scalars["String"]["output"]
    eliminado: Scalars["Boolean"]["output"]
    estado: EstadoAlmacen
    fecha_creacion: Scalars["DateTime"]["output"]
    fecha_modificacion?: Maybe<Scalars["DateTime"]["output"]>
    general: Scalars["Boolean"]["output"]
    hotel_id: Scalars["ID"]["output"]
    nombre: Scalars["String"]["output"]
    /** Cantidad de articulos que tiene en stock el almacen */
    stock?: Maybe<Scalars["Int"]["output"]>
    tipo_almacen: TipoAlmacen
    usuario_modifico_id: Scalars["ID"]["output"]
}

export interface AlmacenStockArgs {
    tipo_articulo?: InputMaybe<Array<TipoArticulo>>
}

export interface AlmacenArticulo {
    __typename?: "AlmacenArticulo"
    /** Almacen al que pertenece el articulo */
    almacen?: Maybe<Almacen>
    almacen_articulo_id: Scalars["ID"]["output"]
    almacen_id: Scalars["ID"]["output"]
    articulo?: Maybe<Articulo>
    articulo_id: Scalars["ID"]["output"]
    cantidad: Scalars["Float"]["output"]
    /** Categoria del articulo en el almacen */
    categoria_articulo?: Maybe<CategoriaArticulo>
    categoria_id?: Maybe<Scalars["ID"]["output"]>
    costo: Scalars["Float"]["output"]
    eliminado: Scalars["Boolean"]["output"]
    /** Retorna true si el articulo es ingrediente de alguna receta o proceso que no esté eliminado */
    es_parte_receta: Scalars["Boolean"]["output"]
    /** Retorna true si el articulo es de tipo proceso y tiene registros de produccion previos */
    es_produccion: Scalars["Boolean"]["output"]
    estado: EstadosAlmacenesArticulos
    fecha_movimiento: Scalars["DateTime"]["output"]
    foto?: Maybe<Scalars["String"]["output"]>
    hotel_id?: Maybe<Scalars["String"]["output"]>
    precio: Scalars["Float"]["output"]
    /** Retorna la fecha de la ultima preparacion registrada para articulos de tipo receta o proceso */
    ultima_preparacion?: Maybe<Scalars["DateTime"]["output"]>
    /** Registro del surtido mas reciente del articulo en su respectivo almacen */
    ultimo_surtido?: Maybe<Surtido>
    visible_venta: Scalars["Boolean"]["output"]
}

export interface ApiKey {
    __typename?: "ApiKey"
    activo: Scalars["Boolean"]["output"]
    api_key_id: Scalars["ID"]["output"]
    colaborador_id?: Maybe<Scalars["ID"]["output"]>
    descripcion?: Maybe<Scalars["String"]["output"]>
    fecha_actualizacion: Scalars["DateTime"]["output"]
    fecha_creacion: Scalars["DateTime"]["output"]
    key: Scalars["String"]["output"]
    tipo_autenticacion: TiposAutenticacion
    usuario_id?: Maybe<Scalars["ID"]["output"]>
}

export interface AportacionPropinaRsDetailInput {
    categoria_id: Scalars["ID"]["input"]
    porcentaje_aportacion_propinas: Scalars["Float"]["input"]
}

export interface Area {
    __typename?: "Area"
    area_id: Scalars["ID"]["output"]
    eliminado: Scalars["Boolean"]["output"]
    estado: Scalars["ID"]["output"]
    hotel: Hotel
    hotel_id: Scalars["ID"]["output"]
    nombre: Scalars["String"]["output"]
    puestos?: Maybe<Array<Puesto>>
}

export interface AreasPuestos {
    __typename?: "AreasPuestos"
    /** Información del área */
    area: Area
    /** Id del área */
    area_id: Scalars["ID"]["output"]
    /** Area Puesto Id */
    area_puesto_id: Scalars["ID"]["output"]
    /** Información del puesto */
    puesto: Puesto
    /** Id del puesto */
    puesto_id: Scalars["ID"]["output"]
}

export interface Articulo {
    __typename?: "Articulo"
    /** Todos los almacenes-articulos del hotel donde se encuentra el articulo */
    almacenes_articulos: Array<AlmacenArticulo>
    articulo_id: Scalars["ID"]["output"]
    cantidad_minima?: Maybe<Scalars["Float"]["output"]>
    cantidad_vendida: Scalars["Float"]["output"]
    categoria_articulo?: Maybe<CategoriaArticulo>
    categoria_id?: Maybe<Scalars["ID"]["output"]>
    contenido: Scalars["Float"]["output"]
    descripcion?: Maybe<Scalars["String"]["output"]>
    eliminado: Scalars["Boolean"]["output"]
    estado: EstadosArticulo
    extra: Scalars["Boolean"]["output"]
    fecha_eliminado?: Maybe<Scalars["DateTime"]["output"]>
    fecha_registro: Scalars["DateTime"]["output"]
    folio?: Maybe<Scalars["String"]["output"]>
    folio_articulo?: Maybe<Scalars["String"]["output"]>
    foto?: Maybe<Scalars["String"]["output"]>
    grupo_hotel_id: Scalars["ID"]["output"]
    ingredientes_recetas?: Maybe<Array<IngredienteReceta>>
    marca?: Maybe<Scalars["String"]["output"]>
    nombre: Scalars["String"]["output"]
    precio?: Maybe<Precio>
    sku?: Maybe<Scalars["String"]["output"]>
    stock?: Maybe<Scalars["Float"]["output"]>
    tipo: TipoArticulo
    unidad: UnidadMedidasArticulo
    /** Unidades en las que puede ser usado el articulo, tanto para recetas como procesos */
    unidades_disponibles?: Maybe<Array<UnidadMedidasArticulo>>
}

export interface ArticuloAlmacenes_ArticulosArgs {
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface ArticuloCantidad_VendidaArgs {
    fecha_registro?: InputMaybe<DateSearchInput>
}

export interface ArticuloCategoria_ArticuloArgs {
    almacen_articulo_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface ArticuloPrecioArgs {
    hotel_id: Scalars["ID"]["input"]
}

export interface ArticuloStockArgs {
    almacen_id?: InputMaybe<Array<Scalars["String"]["input"]>>
}

export interface ArticuloExterno {
    __typename?: "ArticuloExterno"
    articulo_externo_id: Scalars["ID"]["output"]
    descripcion?: Maybe<Scalars["String"]["output"]>
    eliminado: Scalars["Boolean"]["output"]
    estado: EstadosArticuloExterno
    fecha_actualizacion?: Maybe<Scalars["DateTime"]["output"]>
    fecha_registro: Scalars["DateTime"]["output"]
    foto?: Maybe<Scalars["String"]["output"]>
    hotel_id: Scalars["ID"]["output"]
    nombre: Scalars["String"]["output"]
    precio: Scalars["Float"]["output"]
}

export interface ArticuloExternoWithModificadoresInput {
    articulo_externo_id: Scalars["ID"]["input"]
    comentarios?: InputMaybe<Scalars["String"]["input"]>
    modificadores_con_cantidad?: InputMaybe<Array<ModificadorConCantidadInput>>
    modificadores_ids?: InputMaybe<Array<Scalars["ID"]["input"]>>
}

export interface ArticuloExternoWithRelationsOutput {
    __typename?: "ArticuloExternoWithRelationsOutput"
    articulo_externo_id: Scalars["ID"]["output"]
    categoria_id?: Maybe<Scalars["ID"]["output"]>
    eliminado: Scalars["Boolean"]["output"]
    estado: EstadosArticuloExterno
    fecha_actualizacion?: Maybe<Scalars["DateTime"]["output"]>
    fecha_registro: Scalars["DateTime"]["output"]
    foto?: Maybe<Scalars["String"]["output"]>
    grupos_modificadores: Array<GrupoModificadorWithModificadoresOutput>
    hotel_id: Scalars["ID"]["output"]
    nombre: Scalars["String"]["output"]
    precio: Scalars["Float"]["output"]
}

export interface ArticuloExtraTicket {
    __typename?: "ArticuloExtraTicket"
    /** Traer información de articulo del extra del ticket */
    articulo?: Maybe<Articulo>
    articulo_id: Scalars["ID"]["output"]
    cantidad: Scalars["Float"]["output"]
    costo: Scalars["Float"]["output"]
    nombre: Scalars["String"]["output"]
}

export interface ArticuloGrupoModificador {
    __typename?: "ArticuloGrupoModificador"
    articulo_externo_id: Scalars["ID"]["output"]
    articulo_grupo_modificador_id: Scalars["ID"]["output"]
    grupo_modificador_id: Scalars["ID"]["output"]
}

export interface ArticuloTicket {
    __typename?: "ArticuloTicket"
    /** Información detallada de los artículos en el ticket, incluyendo unidad */
    articulo?: Maybe<Articulo>
    articulo_id: Scalars["ID"]["output"]
    cantidad: Scalars["Int"]["output"]
    costo: Scalars["Float"]["output"]
    extras: Array<ArticuloExtraTicket>
    nombre: Scalars["String"]["output"]
}

export interface ArticulosResponse {
    __typename?: "ArticulosResponse"
    articulo_id: Scalars["String"]["output"]
    cantidad: Scalars["Float"]["output"]
    contenido: Scalars["String"]["output"]
    nombre: Scalars["String"]["output"]
    precio: Scalars["Float"]["output"]
    total: Scalars["Float"]["output"]
    unidad: Scalars["String"]["output"]
}

export interface AsignacionPropina {
    __typename?: "AsignacionPropina"
    asignacion_propina_id: Scalars["ID"]["output"]
    colaborador_id: Scalars["ID"]["output"]
    comision_bancaria: Scalars["Float"]["output"]
    fecha_asignacion: Scalars["DateTime"]["output"]
    fondo_de_propina: Scalars["Float"]["output"]
    fondo_original: Scalars["Float"]["output"]
    fondo_propina_a_repartir: Scalars["Float"]["output"]
    /** Bandera que indica si el monto del ajuste para el colaborador se aparto para el hotel */
    ingreso_hotel?: Maybe<Scalars["Boolean"]["output"]>
    monto_acumulado_propinas_id: Scalars["ID"]["output"]
    monto_bonus: Scalars["Float"]["output"]
    pagado: Scalars["Boolean"]["output"]
    penalizacion: Scalars["Float"]["output"]
    puesto_id: Scalars["ID"]["output"]
    remanente_por_ajuste: Scalars["Float"]["output"]
}

export interface Asistencia {
    __typename?: "Asistencia"
    asistencia_id: Scalars["ID"]["output"]
    asistio: Scalars["Boolean"]["output"]
    /** Información del colaborador */
    colaborador: Colaborador
    colaborador_id: Scalars["ID"]["output"]
    comentario?: Maybe<Scalars["String"]["output"]>
    fecha_entrada: Scalars["DateTime"]["output"]
    fecha_salida?: Maybe<Scalars["DateTime"]["output"]>
    /** Información del hotel */
    hotel: Hotel
    hotel_id: Scalars["ID"]["output"]
}

export interface AuthLoginInput {
    email: Scalars["String"]["input"]
    password: Scalars["String"]["input"]
}

export interface AuthLoginResponse {
    __typename?: "AuthLoginResponse"
    colaborador_activo?: Maybe<Scalars["Boolean"]["output"]>
    expires_in?: Maybe<Scalars["String"]["output"]>
    token: Scalars["String"]["output"]
    ultimo_hotel_id?: Maybe<Scalars["ID"]["output"]>
    usuario_id?: Maybe<Scalars["ID"]["output"]>
}

export interface AuthenticateCredencialInput {
    template_sample: Scalars["String"]["input"]
}

export interface AuthenticateCredentialOutput {
    __typename?: "AuthenticateCredentialOutput"
    usuario_id: Scalars["ID"]["output"]
}

export interface AutorizarFajillaInput {
    comentario?: InputMaybe<Scalars["String"]["input"]>
    fajilla_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface AuxPartialInfoRentaResponse {
    __typename?: "AuxPartialInfoRentaResponse"
    extra_id?: Maybe<Scalars["ID"]["output"]>
    ticket_id?: Maybe<Scalars["ID"]["output"]>
}

export interface BandejaNotificaciones {
    __typename?: "BandejaNotificaciones"
    bandeja_notificaciones_id: Scalars["ID"]["output"]
    fecha_registro: Scalars["DateTime"]["output"]
    hotel_id?: Maybe<Scalars["ID"]["output"]>
    incidencia?: Maybe<Incidencia>
    incidencia_id?: Maybe<Scalars["ID"]["output"]>
    leido: Scalars["Boolean"]["output"]
    mensaje: Scalars["String"]["output"]
    tipo: TipoNotificacion
    usuario_id: Scalars["ID"]["output"]
}

export interface BillingPerMonthGroupedByCategoryOutput {
    __typename?: "BillingPerMonthGroupedByCategoryOutput"
    categoria: CategoriaGasto
    porcentaje: Scalars["Float"]["output"]
    subcategorias?: Maybe<Array<SubcategoriaGasto>>
    total_gasto: Scalars["Float"]["output"]
}

export interface BillingPerMonthGroupedByCategoryWithMonthOutput {
    __typename?: "BillingPerMonthGroupedByCategoryWithMonthOutput"
    gastos_por_categoria: Array<BillingPerMonthGroupedByCategoryOutput>
    month: Scalars["String"]["output"]
}

export interface BillingPerMonthOutput {
    __typename?: "BillingPerMonthOutput"
    gastos?: Maybe<Array<Gastos>>
    total_gasto?: Maybe<Scalars["Float"]["output"]>
}

export interface Cama {
    __typename?: "Cama"
    numero: Scalars["Int"]["output"]
    tipo: TiposCamas
}

export interface CamaArgs {
    numero?: InputMaybe<Scalars["Int"]["input"]>
    tipo?: InputMaybe<TiposCamas>
}

export interface CamaInput {
    numero: Scalars["Int"]["input"]
    tipo: TiposCamas
}

export interface CambiarMesaAsignadaInput {
    colaborador_asignado_id?: InputMaybe<Scalars["ID"]["input"]>
    mesa_asignada_id: Scalars["ID"]["input"]
    mesa_id: Scalars["ID"]["input"]
    usuario_modifico_id: Scalars["ID"]["input"]
}

export enum CampoVehiculo {
    Color = "COLOR",
    Marca = "MARCA",
    Matricula = "MATRICULA",
    Modelo = "MODELO",
}

export interface CancelComandaInput {
    cancelaciones: CancelDetallesOrdenInput
    comanda_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
}

export interface CancelComandaOutput {
    __typename?: "CancelComandaOutput"
    comanda: Comanda
    ticket_id?: Maybe<Scalars["ID"]["output"]>
}

export interface CancelDetalleOrdenDetailInput {
    detalle_orden_id: Scalars["ID"]["input"]
    devolucion_a_inventario: Scalars["Boolean"]["input"]
    merma: Scalars["Boolean"]["input"]
}

export interface CancelDetalleOrdenInput {
    detalle_orden_id: Scalars["ID"]["input"]
    tipo_cancelacion: TiposCancelaciones
}

export interface CancelDetallesOrdenInput {
    detalles_orden: Array<CancelDetalleOrdenDetailInput>
    extras?: InputMaybe<Array<CancelExtraDetalleOrdenDetailInput>>
    motivo_cancelacion: Scalars["String"]["input"]
}

export interface CancelExtraDetalleOrdenDetailInput {
    devolucion_a_inventario: Scalars["Boolean"]["input"]
    extra_detalle_orden_id: Scalars["ID"]["input"]
    merma: Scalars["Boolean"]["input"]
}

export interface CancelExtraDetalleOrdenInput {
    cantidad: Scalars["Int"]["input"]
    extra_detalle_orden_id: Scalars["ID"]["input"]
    tipo_cancelacion: TiposCancelaciones
}

export interface CancelExtraInput {
    extra_id: Scalars["ID"]["input"]
    motivo_cancelacion: Scalars["String"]["input"]
}

export interface CancelOperationRentaItemInput {
    extra_id: Scalars["ID"]["input"]
    tipo_extra: TiposExtras
}

export interface CancelOperationsRentaInput {
    cancelar_renta: Scalars["Boolean"]["input"]
    extras?: InputMaybe<Array<CancelOperationRentaItemInput>>
    hotel_id: Scalars["ID"]["input"]
    motivo_cancelacion?: InputMaybe<Scalars["String"]["input"]>
    ordenes?: InputMaybe<Array<CancelRoomServiceRentaItemInput>>
    renta_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface CancelOperationsRentaOutput {
    __typename?: "CancelOperationsRentaOutput"
    extras_cancelled: Array<Extra>
    renta: Renta
    ticket_id: Array<Scalars["ID"]["output"]>
}

export interface CancelOrdenInput {
    cancelaciones: CancelDetallesOrdenInput
    orden_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface CancelOrdenOutput {
    __typename?: "CancelOrdenOutput"
    orden: Orden
    ticket_id?: Maybe<Scalars["ID"]["output"]>
}

export interface CancelRentaInput {
    hotel_id: Scalars["ID"]["input"]
    monto_devuelto_cancelacion?: InputMaybe<Scalars["Float"]["input"]>
    motivo_cancelacion: Scalars["String"]["input"]
    renta_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface CancelRentaOutput {
    __typename?: "CancelRentaOutput"
    renta: Renta
    ticket_id?: Maybe<Scalars["ID"]["output"]>
}

export interface CancelReservaInput {
    monto_devuelto_cancelacion?: InputMaybe<Scalars["Float"]["input"]>
    motivo_cancelacion: Scalars["String"]["input"]
    reserva_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface CancelReservaResponse {
    __typename?: "CancelReservaResponse"
    ticket_ids: Array<Scalars["String"]["output"]>
}

export interface CancelRoomServiceRentaItemInput {
    cancelaciones_detalles?: InputMaybe<Array<CancelDetalleOrdenDetailInput>>
    cancelaciones_extras?: InputMaybe<Array<CancelExtraDetalleOrdenDetailInput>>
    orden_id: Scalars["ID"]["input"]
}

export interface CardHabitacion {
    __typename?: "CardHabitacion"
    tamano?: Maybe<Scalars["String"]["output"]>
    tamano_fijo?: Maybe<Scalars["Boolean"]["output"]>
}

export interface CardHabitacionInput {
    tamano?: InputMaybe<Scalars["String"]["input"]>
    tamano_fijo?: InputMaybe<Scalars["Boolean"]["input"]>
}

export interface CategoriaArticulo {
    __typename?: "CategoriaArticulo"
    categoria_id: Scalars["ID"]["output"]
    descripcion: Scalars["String"]["output"]
    eliminado: Scalars["Boolean"]["output"]
    hotel_id: Scalars["ID"]["output"]
    nombre: Scalars["String"]["output"]
    porcentaje_aportacion_propinas: Scalars["Float"]["output"]
    subcategorias?: Maybe<Array<SubcategoriaProducto>>
    /** Indica si la categoria ya esta siendo surtida por otro almacen que no este eliminado ni desactivado */
    surtida_por_otro_almacen?: Maybe<Scalars["Boolean"]["output"]>
    total_articulos?: Maybe<Scalars["Int"]["output"]>
}

export interface CategoriaArticuloFilterArgs {
    in?: InputMaybe<Array<Scalars["ID"]["input"]>>
    not_in?: InputMaybe<Array<Scalars["ID"]["input"]>>
}

export interface CategoriaGasto {
    __typename?: "CategoriaGasto"
    categoria: Scalars["String"]["output"]
    categoria_id: Scalars["ID"]["output"]
    eliminado: Scalars["Boolean"]["output"]
    fecha_registro: Scalars["DateTime"]["output"]
    hotel_id: Scalars["ID"]["output"]
    limite_mensual: Scalars["Float"]["output"]
    predeterminado?: Maybe<Scalars["Boolean"]["output"]>
    presupuesto: Scalars["Float"]["output"]
    subcategorias_de_categoria: Array<SubcategoriaGasto>
    subcategorias_gasto?: Maybe<Array<SubcategoriaGasto>>
    usuario_id: Scalars["ID"]["output"]
}

export interface CategoriaGastoSubcategorias_De_CategoriaArgs {
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    mes_y_anio?: InputMaybe<MonthSearchInput>
}

export interface ChangeHabitacionReservaInput {
    habitacion_id: Scalars["ID"]["input"]
    reserva_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface ChangePasswordInput {
    email: Scalars["String"]["input"]
    new_password: Scalars["String"]["input"]
    old_password?: InputMaybe<Scalars["String"]["input"]>
}

export interface ChangeTurnoInput {
    hotel_id: Scalars["ID"]["input"]
    turno_a_abrir_id: Scalars["ID"]["input"]
    turno_a_cerrar_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface CheckInInput {
    early_checkin: Scalars["Boolean"]["input"]
    easyrewards_id?: InputMaybe<Scalars["String"]["input"]>
    fecha_salida: Scalars["DateTime"]["input"]
    horas_extra_renta: Scalars["Int"]["input"]
    hospedajes_extra_renta: Scalars["Int"]["input"]
    pago?: InputMaybe<CreatePagoInput>
    personas_extra_renta: Scalars["Int"]["input"]
    propina?: InputMaybe<CreatePropinaFromSale>
    reserva_id: Scalars["ID"]["input"]
    tipo_entrada: TiposEntradas
    usuario_id: Scalars["ID"]["input"]
    vehiculo?: InputMaybe<DataVehiculoInput>
}

export interface CheckOutInput {
    comentario_estado?: InputMaybe<Scalars["String"]["input"]>
    estado_habitacion: Estados_Habitaciones
    extra_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    fecha_estado: Scalars["DateTime"]["input"]
    orden_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    pago?: InputMaybe<CreatePagoInput>
    propina?: InputMaybe<CreatePropinaPartialInput>
    renta_id: Scalars["ID"]["input"]
    subestado_habitacion?: InputMaybe<SubestadosHabitaciones>
    usuario_id: Scalars["ID"]["input"]
}

export interface CheckReserveLimitOutput {
    __typename?: "CheckReserveLimitOutput"
    alerta_por_limite_reservas: Scalars["Boolean"]["output"]
    fecha_conflicto?: Maybe<Scalars["DateTime"]["output"]>
    tipo_habitacion?: Maybe<Scalars["ID"]["output"]>
}

export interface ClaveTipoBloqueo {
    __typename?: "ClaveTipoBloqueo"
    /** Clave asociada al tamaño de la card */
    clave: Scalars["String"]["output"]
    /** Tamaño de la card de habitación */
    tamano: Scalars["String"]["output"]
}

export interface ClaveTipoBloqueoArgs {
    /** Clave asociada al tamaño */
    clave: Scalars["String"]["input"]
    /** Tamaño de la card de habitación */
    tamano: Scalars["String"]["input"]
}

export interface ClaveTipoBloqueoInput {
    /** Clave asociada a la card */
    clave: Scalars["String"]["input"]
    /** Tamaño de la card de habitación */
    tamano: Scalars["String"]["input"]
}

export interface ClaveTipoMantenimiento {
    __typename?: "ClaveTipoMantenimiento"
    /** Clave asociada al tamaño de la card */
    clave: Scalars["String"]["output"]
    /** Tamaño de la card de habitación */
    tamano: Scalars["String"]["output"]
}

export interface ClaveTipoMantenimientoInput {
    /** Clave asociada a la card */
    clave: Scalars["String"]["input"]
    /** Tamaño de la card de habitación */
    tamano: Scalars["String"]["input"]
}

export interface Cliente {
    __typename?: "Cliente"
    /** Cliente id */
    cliente_id: Scalars["ID"]["output"]
    /** Correo del cliente */
    correo?: Maybe<Scalars["String"]["output"]>
    eliminado: Scalars["Boolean"]["output"]
    /** Nombre del cliente */
    nombre: Scalars["String"]["output"]
    /** Número de cliente */
    numero_cliente?: Maybe<Scalars["Float"]["output"]>
    /** Teléfono del cliente */
    telefono?: Maybe<Scalars["String"]["output"]>
}

export interface CloseBillMesaAsignadaInput {
    mesa_asignada_id: Scalars["ID"]["input"]
}

export interface CloseCorteInput {
    corte_id: Scalars["ID"]["input"]
    efectivo_ingresado: Scalars["Float"]["input"]
    usuario_cierra_corte: Scalars["ID"]["input"]
}

export interface CloseIncidenciaInput {
    colaborador_id_cierra: Scalars["ID"]["input"]
    comentario_cierre?: InputMaybe<Scalars["String"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    incidencia_id: Scalars["ID"]["input"]
}

export interface CloseMesaAsignadInput {
    mesa_asignada_id: Scalars["ID"]["input"]
}

export interface CloseTaskInput {
    colaboradores_tareas_ids?: InputMaybe<Array<Scalars["ID"]["input"]>>
    comentario_estado?: InputMaybe<Scalars["String"]["input"]>
    comentarios_tarea?: InputMaybe<Scalars["String"]["input"]>
    estado?: InputMaybe<Estados_Habitaciones>
    habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface CloseTurnoInput {
    hotel_id: Scalars["ID"]["input"]
    turno_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface Colaborador {
    __typename?: "Colaborador"
    apellido_materno: Scalars["String"]["output"]
    apellido_paterno: Scalars["String"]["output"]
    area?: Maybe<Area>
    asistencia_abierta?: Maybe<Asistencia>
    /** Numero de ordenes atendidas del colaborador por su turno diario */
    cantidad_ordenes?: Maybe<Scalars["Float"]["output"]>
    colaborador_id: Scalars["ID"]["output"]
    colaborador_in_hotel?: Maybe<Array<HotelColaborador>>
    correo?: Maybe<Scalars["String"]["output"]>
    direccion?: Maybe<Scalars["String"]["output"]>
    eliminado: Scalars["Boolean"]["output"]
    en_turno: Scalars["Boolean"]["output"]
    /** Indica si el colaborador tiene habilitadas las funciones de supervision (Puesto Supervisor) */
    es_supervisor?: Maybe<Scalars["Boolean"]["output"]>
    estado: Scalars["String"]["output"]
    fecha_baja?: Maybe<Scalars["DateTime"]["output"]>
    fecha_cumpleanios?: Maybe<Scalars["DateTime"]["output"]>
    fecha_registro?: Maybe<Scalars["DateTime"]["output"]>
    foto?: Maybe<Scalars["String"]["output"]>
    /** Retorna al menos 1 mesa-asignada activa para el colaborador, si es que existe */
    mesa_asignada_activa?: Maybe<HasActiveMesaAsignadaOutput>
    nombre: Scalars["String"]["output"]
    /** Numero de tareas asignadas al colaborador en el turno */
    numero_asignaciones?: Maybe<Scalars["Int"]["output"]>
    numero_colaborador?: Maybe<Scalars["String"]["output"]>
    numero_id: Scalars["String"]["output"]
    ordenes?: Maybe<Array<Orden>>
    puesto?: Maybe<Puesto>
    sueldo?: Maybe<Scalars["Float"]["output"]>
    telefono_emergencia?: Maybe<Scalars["String"]["output"]>
    telefono_personal: Scalars["String"]["output"]
    turno: Turno
    turno_id?: Maybe<Scalars["ID"]["output"]>
    ultima_asistencia_cerrada?: Maybe<Asistencia>
    ultima_orden?: Maybe<Orden>
    ultima_tarea?: Maybe<ColaboradorTarea>
    usuario?: Maybe<Usuario>
    usuario_id?: Maybe<Scalars["ID"]["output"]>
}

export interface ColaboradorEs_SupervisorArgs {
    hotel_id: Scalars["ID"]["input"]
}

export interface ColaboradorNumero_AsignacionesArgs {
    DateSearchInput: DateSearchInput
}

export interface ColaboradorOrdenesArgs {
    estado?: InputMaybe<Array<EstadosOrdenHistorial>>
}

export interface ColaboradorReportePropinaDetailOutput {
    __typename?: "ColaboradorReportePropinaDetailOutput"
    colaborador?: Maybe<Colaborador>
    colaborador_id: Scalars["ID"]["output"]
    comision_bancaria_tarjeta: Scalars["Float"]["output"]
    comision_por_puntos: Scalars["Float"]["output"]
    propinas_tarjetas_por_venta_rs: Scalars["Float"]["output"]
    puntos_a_pagar: Scalars["Float"]["output"]
    total_a_repartir: Scalars["Float"]["output"]
    ventas_por_categoria: Array<VentaColaboradorPorCategoriaDetailOutput>
}

export interface ColaboradorTarea {
    __typename?: "ColaboradorTarea"
    colaborador?: Maybe<Colaborador>
    colaborador_id?: Maybe<Scalars["String"]["output"]>
    colaborador_tarea_id: Scalars["ID"]["output"]
    comentarios?: Maybe<Array<ComentarioTarea>>
    descripcion_tarea?: Maybe<Scalars["String"]["output"]>
    eliminado: Scalars["Boolean"]["output"]
    fecha_inicio: Scalars["DateTime"]["output"]
    fecha_registro?: Maybe<Scalars["DateTime"]["output"]>
    fecha_termino?: Maybe<Scalars["DateTime"]["output"]>
    habitacion?: Maybe<Habitacion>
    habitacion_id?: Maybe<Scalars["String"]["output"]>
    /** Datos del colaborador que creo la tarea en primer instancia */
    reportada_por?: Maybe<Colaborador>
    tarea: Tarea
    tarea_id?: Maybe<Scalars["String"]["output"]>
    tipo_limpieza?: Maybe<TiposLimpiezas>
    /** Tipo de tarea en curso para el colaborador-tarea */
    tipo_tarea?: Maybe<TiposTarea>
    turno_id?: Maybe<Scalars["ID"]["output"]>
}

export interface Comanda {
    __typename?: "Comanda"
    comanda_id: Scalars["ID"]["output"]
    detalles_orden?: Maybe<Array<DetalleOrden>>
    estado_comanda?: Maybe<EstadosComandaHistorial>
    fecha_modificacion?: Maybe<Scalars["DateTime"]["output"]>
    fecha_registro: Scalars["DateTime"]["output"]
    folio: Scalars["Float"]["output"]
    /** Orden a la que pertenece la comanda */
    orden?: Maybe<Orden>
    orden_id: Scalars["ID"]["output"]
    /** Bandera que indica si la comanda sera o no mostrada en el panel de cocina */
    panel_no_visible: Scalars["Boolean"]["output"]
    total_comanda: Scalars["Float"]["output"]
    usuario_id: Scalars["ID"]["output"]
}

export interface ComandaDetalles_OrdenArgs {
    estado?: InputMaybe<Array<EstadosDetalleOrden>>
    filter_articulos_categoria_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface ComentarioHabitacion {
    __typename?: "ComentarioHabitacion"
    comentario: Scalars["String"]["output"]
    comentario_id: Scalars["ID"]["output"]
    fecha: Scalars["String"]["output"]
    usuario_id: Scalars["ID"]["output"]
}

export interface ComentarioHabitacionInput {
    comentario?: InputMaybe<Scalars["String"]["input"]>
    fecha?: InputMaybe<Scalars["String"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface ComentarioIncidenciaEntity {
    __typename?: "ComentarioIncidenciaEntity"
    comentario: Scalars["String"]["output"]
    fecha: Scalars["DateTime"]["output"]
    usuario_id: Scalars["ID"]["output"]
}

export interface ComentarioTarea {
    __typename?: "ComentarioTarea"
    comentario?: Maybe<Scalars["String"]["output"]>
    fecha?: Maybe<Scalars["String"]["output"]>
    usuario_id?: Maybe<Scalars["ID"]["output"]>
}

export interface ComentariosInfoRenta {
    __typename?: "ComentariosInfoRenta"
    comentario: Scalars["String"]["output"]
    fecha: Scalars["DateTime"]["output"]
}

export interface ComentariosInfoReserva {
    __typename?: "ComentariosInfoReserva"
    comentario: Scalars["String"]["output"]
    fecha: Scalars["DateTime"]["output"]
}

export interface CommentTaskInput {
    comentario: Scalars["String"]["input"]
    fecha: Scalars["String"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export enum ConceptosConfiguracionesCortes {
    RegistroEnergeticos = "registro_energeticos",
    RegistroPlacas = "registro_placas",
}

export interface ConceptosInclusionFilterArgs {
    in?: InputMaybe<Array<ConceptosConfiguracionesCortes>>
}

export interface ConfiguracionCorte {
    __typename?: "ConfiguracionCorte"
    activo: Scalars["Boolean"]["output"]
    concepto: ConceptosConfiguracionesCortes
    configuracion_corte_id: Scalars["ID"]["output"]
    hotel_id: Scalars["ID"]["output"]
}

export interface ConfiguracionFajilla {
    __typename?: "ConfiguracionFajilla"
    configuracion_fajilla_id: Scalars["ID"]["output"]
    eliminado: Scalars["Boolean"]["output"]
    fecha_creacion: Scalars["DateTime"]["output"]
    hotel_id: Scalars["ID"]["output"]
    usuario_id: Scalars["ID"]["output"]
    valor: Scalars["Float"]["output"]
}

export interface ConfiguracionInventario {
    __typename?: "ConfiguracionInventario"
    configuracion_inventario_id: Scalars["ID"]["output"]
    configuraciones: Configuraciones
    hotel_id: Scalars["ID"]["output"]
    inventario_negativo: Scalars["Boolean"]["output"]
}

export interface ConfiguracionNotificacionesOutput {
    __typename?: "ConfiguracionNotificacionesOutput"
    cortes: CortesNotificacionesConfigOutput
    gastos: GastosNotificacionesConfigOutput
    habitaciones: HabitacionesNotificacionesConfigOutput
    incidencias: IncidenciasNotificacionesConfigOutput
}

export interface ConfiguracionPropina {
    __typename?: "ConfiguracionPropina"
    configuracion_propina_id: Scalars["ID"]["output"]
    fecha_registro: Scalars["DateTime"]["output"]
    hotel_id: Scalars["ID"]["output"]
    paga_propina_en_turno: Scalars["Boolean"]["output"]
    porcentaje_aportacion_vendedores: Scalars["Float"]["output"]
    porcentaje_comision_por_puntos: Scalars["Float"]["output"]
    porcentaje_venta_efectivo: Scalars["Float"]["output"]
    porcentaje_venta_tarjeta: Scalars["Float"]["output"]
}

export interface Configuraciones {
    __typename?: "Configuraciones"
    /** Configuraciones de la card de Rs */
    cardRSNegativo: Scalars["Boolean"]["output"]
}

export interface ConfiguracionesInput {
    cardRSNegativo?: InputMaybe<Scalars["Boolean"]["input"]>
}

export interface Configurations {
    __typename?: "Configurations"
    /** Configuraciones de la habitación */
    cardHabitacion: CardHabitacion
    /** Configuraciones del panel */
    panel: Panel
}

export interface ConfigurationsInput {
    cardHabitacion?: InputMaybe<CardHabitacionInput>
    panel?: InputMaybe<PanelInput>
}

export interface ConteosOrdenesDetailsOutput {
    __typename?: "ConteosOrdenesDetailsOutput"
    mostrador?: Maybe<Scalars["Int"]["output"]>
    restaurante?: Maybe<Scalars["Int"]["output"]>
    room_service?: Maybe<Scalars["Int"]["output"]>
    total?: Maybe<Scalars["Int"]["output"]>
}

export interface Corte {
    __typename?: "Corte"
    anticipos_reservas?: Maybe<Scalars["Float"]["output"]>
    colaboradores: Array<Colaborador>
    corte_id: Scalars["ID"]["output"]
    efectivo_ingresado: Scalars["Float"]["output"]
    estatus: EstatusCorte
    fecha_cierre_corte?: Maybe<Scalars["String"]["output"]>
    /** Representa la fecha del dia a la que pertenece el corte sin importar cuando se cerro */
    fecha_corte?: Maybe<Scalars["String"]["output"]>
    fecha_fin_corte?: Maybe<Scalars["String"]["output"]>
    fecha_inicio_corte: Scalars["String"]["output"]
    folio: Scalars["Int"]["output"]
    habitaciones_vendidas?: Maybe<Scalars["Float"]["output"]>
    hotel_id: Scalars["ID"]["output"]
    incidencias?: Maybe<Array<Incidencia>>
    ingresos_hotel?: Maybe<IngresosHotelOutput>
    ingresos_room_service?: Maybe<IngresosRoomServiceOutput>
    metodos_pago?: Maybe<MetodosPago>
    resumen_utilidad?: Maybe<ResumenUtilidadOutput>
    saldos_reservas: Scalars["Float"]["output"]
    total_caja: Scalars["Float"]["output"]
    total_consumo_interno: Scalars["Float"]["output"]
    total_corte: Scalars["Float"]["output"]
    total_cortesias: Scalars["Float"]["output"]
    total_depositos: Scalars["Float"]["output"]
    total_fajillas: Scalars["Float"]["output"]
    total_gastos: Scalars["Float"]["output"]
    total_pagos_pendientes: Scalars["Float"]["output"]
    total_propinas_efectivo: Scalars["Float"]["output"]
    total_propinas_habitacion: Scalars["Float"]["output"]
    total_propinas_restaurantes: Scalars["Float"]["output"]
    total_propinas_room_service: Scalars["Float"]["output"]
    total_propinas_tarjeta: Scalars["Float"]["output"]
    total_venta_efectivo: Scalars["Float"]["output"]
    total_venta_habitaciones: Scalars["Float"]["output"]
    total_venta_horas_extra: Scalars["Float"]["output"]
    total_venta_hospedajes_extra: Scalars["Float"]["output"]
    total_venta_paquetes: Scalars["Float"]["output"]
    total_venta_personas_extra: Scalars["Float"]["output"]
    total_venta_restaurante: Scalars["Float"]["output"]
    total_venta_room_service: Scalars["Float"]["output"]
    total_venta_tarjetas: Scalars["Float"]["output"]
    turno: Turno
    turno_id: Scalars["ID"]["output"]
    /** Usuario que cierra el corte */
    usuario_cierra?: Maybe<Usuario>
    usuario_cierra_corte?: Maybe<Scalars["ID"]["output"]>
    /** Usuario creador del corte */
    usuario_crea?: Maybe<Usuario>
    usuario_realiza_corte: Scalars["ID"]["output"]
}

export interface CortesNotificacionesConfigOutput {
    __typename?: "CortesNotificacionesConfigOutput"
    caratula_mensual: Scalars["Boolean"]["output"]
    cortes_diarios: Scalars["Boolean"]["output"]
}

export interface CortesSummaryByMonthResponse {
    __typename?: "CortesSummaryByMonthResponse"
    cortes_cerrados: Scalars["Float"]["output"]
    gastos: Scalars["Float"]["output"]
    incidencias: Scalars["Float"]["output"]
    ingresos: Scalars["Float"]["output"]
    mes: Scalars["Float"]["output"]
    utilidad: Scalars["Float"]["output"]
}

export interface CreateAlmacenArticuloInput {
    almacen_id: Scalars["ID"]["input"]
    articulo_id: Scalars["ID"]["input"]
    cantidad: Scalars["Float"]["input"]
    costo: Scalars["Float"]["input"]
    foto?: InputMaybe<Scalars["String"]["input"]>
    precio: Scalars["Float"]["input"]
}

export interface CreateAlmacenInput {
    categorias_articulos_id: Array<Scalars["ID"]["input"]>
    descripcion: Scalars["String"]["input"]
    estado: EstadoAlmacen
    hotel_id: Scalars["ID"]["input"]
    nombre: Scalars["String"]["input"]
    tipo_almacen: TipoAlmacen
    usuario_modifico_id: Scalars["ID"]["input"]
}

export interface CreateApiKeyInput {
    descripcion: Scalars["String"]["input"]
}

export interface CreateApiKeyOutput {
    __typename?: "CreateApiKeyOutput"
    api_key_details: ApiKey
    key: Scalars["String"]["output"]
}

export interface CreateAreaInput {
    hotel_id: Scalars["ID"]["input"]
    nombre: Scalars["String"]["input"]
}

export interface CreateArticuloExternoEquivalenciaInput {
    almacen_articulo_id: Scalars["ID"]["input"]
    modificadores_ids?: InputMaybe<Array<Scalars["ID"]["input"]>>
}

export interface CreateArticuloExternoInput {
    descripcion?: InputMaybe<Scalars["String"]["input"]>
    equivalencias?: InputMaybe<Array<CreateArticuloExternoEquivalenciaInput>>
    estado?: InputMaybe<EstadosArticuloExterno>
    foto?: InputMaybe<Scalars["String"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    nombre: Scalars["String"]["input"]
}

export interface CreateArticuloGrupoModificadorInput {
    articulo_externo_id: Scalars["ID"]["input"]
    grupo_modificador_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
}

export interface CreateArticuloInput {
    almacen_id?: InputMaybe<Scalars["ID"]["input"]>
    cantidad: Scalars["Float"]["input"]
    cantidad_minima?: InputMaybe<Scalars["Float"]["input"]>
    categoria_id?: InputMaybe<Scalars["ID"]["input"]>
    contenido: Scalars["Float"]["input"]
    costo?: InputMaybe<Scalars["Float"]["input"]>
    estado: EstadosArticulo
    extra: Scalars["Boolean"]["input"]
    folio?: InputMaybe<Scalars["String"]["input"]>
    foto?: InputMaybe<Scalars["String"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    marca?: InputMaybe<Scalars["String"]["input"]>
    nombre: Scalars["String"]["input"]
    precio?: InputMaybe<Scalars["Float"]["input"]>
    promocion_id?: InputMaybe<Scalars["ID"]["input"]>
    sku?: InputMaybe<Scalars["String"]["input"]>
    tipo?: InputMaybe<TipoArticulo>
    unidad: UnidadMedidasArticulo
    usuario_id: Scalars["ID"]["input"]
}

export interface CreateCategoriaArticuloInput {
    descripcion?: InputMaybe<Scalars["String"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    nombre: Scalars["String"]["input"]
    porcentaje_aportacion_propinas?: InputMaybe<Scalars["Float"]["input"]>
}

export interface CreateCategoriasGastosInput {
    categoria: Scalars["String"]["input"]
    fecha_registro?: InputMaybe<Scalars["DateTime"]["input"]>
    hotel_id: Scalars["String"]["input"]
    limite_mensual: Scalars["Float"]["input"]
    presupuesto: Scalars["Float"]["input"]
    usuario_id: Scalars["String"]["input"]
}

export interface CreateClienteInput {
    correo?: InputMaybe<Scalars["String"]["input"]>
    nombre: Scalars["String"]["input"]
    telefono?: InputMaybe<Scalars["String"]["input"]>
}

export interface CreateColaboradorInput {
    apellido_materno: Scalars["String"]["input"]
    apellido_paterno: Scalars["String"]["input"]
    area_id: Scalars["ID"]["input"]
    codigo?: InputMaybe<Scalars["String"]["input"]>
    correo?: InputMaybe<Scalars["String"]["input"]>
    direccion?: InputMaybe<Scalars["String"]["input"]>
    /** Habilita/Deshabilita funciones de supervision (puesto Supervisor) para el colaborador */
    es_supervisor?: InputMaybe<Scalars["Boolean"]["input"]>
    fecha_cumpleanios?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_registro?: InputMaybe<Scalars["DateTime"]["input"]>
    foto?: InputMaybe<Scalars["String"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    nombre: Scalars["String"]["input"]
    numero_colaborador?: InputMaybe<Scalars["String"]["input"]>
    numero_id: Scalars["String"]["input"]
    puesto_id: Scalars["ID"]["input"]
    sueldo?: InputMaybe<Scalars["Float"]["input"]>
    telefono_emergencia?: InputMaybe<Scalars["String"]["input"]>
    telefono_personal: Scalars["String"]["input"]
    turno_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface CreateColaboradorTareaInput {
    colaborador_id: Array<Scalars["ID"]["input"]>
    descripcion_tarea?: InputMaybe<Scalars["String"]["input"]>
    estado?: InputMaybe<Estados_Habitaciones>
    fecha_inicio: Scalars["DateTime"]["input"]
    habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    reasignacion?: InputMaybe<Scalars["Boolean"]["input"]>
    tarea: CreateTareaInput
    tarea_id?: InputMaybe<Scalars["String"]["input"]>
    tipo_limpieza?: InputMaybe<TiposLimpiezas>
    turno_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id: Scalars["ID"]["input"]
}

export interface CreateColaboradorUsuarioInput {
    apellido_materno: Scalars["String"]["input"]
    apellido_paterno: Scalars["String"]["input"]
    area_id: Scalars["ID"]["input"]
    codigo?: InputMaybe<Scalars["String"]["input"]>
    correo?: InputMaybe<Scalars["String"]["input"]>
    direccion?: InputMaybe<Scalars["String"]["input"]>
    /** Habilita/Deshabilita funciones de supervision (puesto Supervisor) para el colaborador */
    es_supervisor?: InputMaybe<Scalars["Boolean"]["input"]>
    fecha_cumpleanios?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_registro?: InputMaybe<Scalars["DateTime"]["input"]>
    foto?: InputMaybe<Scalars["String"]["input"]>
    hotel_id: Scalars["String"]["input"]
    nombre: Scalars["String"]["input"]
    numero_colaborador?: InputMaybe<Scalars["String"]["input"]>
    numero_id: Scalars["String"]["input"]
    puesto_id: Scalars["ID"]["input"]
    rol_id?: InputMaybe<Scalars["ID"]["input"]>
    sueldo?: InputMaybe<Scalars["Float"]["input"]>
    telefono_emergencia?: InputMaybe<Scalars["String"]["input"]>
    telefono_personal: Scalars["String"]["input"]
    template_sample?: InputMaybe<Array<Scalars["String"]["input"]>>
    turno_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface CreateComandaInput {
    folio: Scalars["Float"]["input"]
    orden_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface CreateConfiguracionCorteItemInput {
    activo: Scalars["Boolean"]["input"]
    concepto: ConceptosConfiguracionesCortes
}

export interface CreateConfiguracionFajillaInput {
    hotel_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
    valor: Scalars["Float"]["input"]
}

export interface CreateConfiguracionInventarioInput {
    configuraciones?: InputMaybe<ConfiguracionesInput>
    hotel_id: Scalars["ID"]["input"]
    inventario_negativo: Scalars["Boolean"]["input"]
}

export interface CreateConfiguracionPropinaInput {
    hotel_id: Scalars["ID"]["input"]
    paga_propina_en_turno?: InputMaybe<Scalars["Boolean"]["input"]>
    porcentaje_aportacion_vendedores: Scalars["Float"]["input"]
    porcentaje_comision_por_puntos?: InputMaybe<Scalars["Float"]["input"]>
    porcentaje_venta_efectivo: Scalars["Float"]["input"]
    porcentaje_venta_tarjeta: Scalars["Float"]["input"]
}

export interface CreateConfiguracionesCorteInput {
    conceptos: Array<CreateConfiguracionCorteItemInput>
    hotel_id: Scalars["ID"]["input"]
}

export interface CreateCredencialInput {
    template_sample: Array<Scalars["String"]["input"]>
    usuario_id: Scalars["ID"]["input"]
}

export interface CreateDetalleOrdenPartialInfoInput {
    almacen_articulo_id: Scalars["ID"]["input"]
    comanda_id?: InputMaybe<Scalars["ID"]["input"]>
    comentarios?: InputMaybe<Scalars["String"]["input"]>
    costo_con_iva: Scalars["Float"]["input"]
    costo_sin_iva: Scalars["Float"]["input"]
    detalle_orden_id?: InputMaybe<Scalars["ID"]["input"]>
    extra_detalle_orden?: InputMaybe<Array<PartialInfoExtraDetalleOrdenInput>>
    monto_iva: Scalars["Float"]["input"]
}

export interface CreateDigestKeyInput {
    colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    correo: Scalars["String"]["input"]
    descripcion: Scalars["String"]["input"]
    password: Scalars["String"]["input"]
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface CreateDigestKeyOutput {
    __typename?: "CreateDigestKeyOutput"
    digest_key: Scalars["String"]["output"]
    digest_key_details: ApiKey
}

export interface CreateExtraInput {
    extras: Array<CreateExtraPartialInfoObject>
    fecha_pago?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_solicitud: Scalars["DateTime"]["input"]
    hotel_id: Scalars["ID"]["input"]
    renta_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface CreateExtraPartialInfoObject {
    monto_extra: Scalars["Float"]["input"]
    numero?: Scalars["Int"]["input"]
    tipo_extra: TiposExtras
    usuario_id: Scalars["ID"]["input"]
}

export interface CreateFajillaInput {
    comentario?: InputMaybe<Scalars["String"]["input"]>
    configuracion_fajilla_id: Scalars["ID"]["input"]
    folio_integracion?: InputMaybe<Scalars["String"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    monto: Scalars["Float"]["input"]
    turno_id: Scalars["ID"]["input"]
    usuario_creo_id: Scalars["ID"]["input"]
}

export interface CreateGastoInput {
    caja_chica: Scalars["Boolean"]["input"]
    categoria_id: Scalars["ID"]["input"]
    comentarios?: InputMaybe<Scalars["String"]["input"]>
    corte_id?: InputMaybe<Scalars["ID"]["input"]>
    fecha_gasto: Scalars["DateTime"]["input"]
    hotel_id: Scalars["ID"]["input"]
    metodo_pago: Scalars["String"]["input"]
    monto: Scalars["Float"]["input"]
    subcategoria_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id: Scalars["ID"]["input"]
}

export interface CreateGastoResponse {
    __typename?: "CreateGastoResponse"
    gasto: Gastos
    ticket_id: Scalars["ID"]["output"]
}

export interface CreateGrupoHotelInput {
    nombre_grupo: Scalars["String"]["input"]
}

export interface CreateGrupoModificadorInput {
    descripcion: Scalars["String"]["input"]
    estado: EstadoGrupoModificador
    hotel_id: Scalars["ID"]["input"]
    max_seleccion: Scalars["Int"]["input"]
    min_seleccion: Scalars["Int"]["input"]
    nombre: Scalars["String"]["input"]
    obligatorio: Scalars["Boolean"]["input"]
    tipo_selector?: InputMaybe<TipoSelector>
}

export interface CreateHabitacionInput {
    hotel_id: Scalars["ID"]["input"]
    numero_habitacion: Scalars["String"]["input"]
    piso: Scalars["String"]["input"]
    tipo_habitacion_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface CreateHotelInput {
    calle: Scalars["String"]["input"]
    ciudad: Scalars["String"]["input"]
    colonia: Scalars["String"]["input"]
    configurations?: InputMaybe<ConfigurationsInput>
    correo: Scalars["String"]["input"]
    cp: Scalars["String"]["input"]
    easyrewards_sucursal_id?: InputMaybe<Scalars["String"]["input"]>
    estado: Scalars["String"]["input"]
    grupo_hotel_id: Scalars["ID"]["input"]
    logo_hotel?: InputMaybe<Scalars["String"]["input"]>
    nombre_hotel: Scalars["String"]["input"]
    numero_exterior: Scalars["String"]["input"]
    numero_interior: Scalars["String"]["input"]
    razon_social: Scalars["String"]["input"]
    rfc: Scalars["String"]["input"]
    telefono: Scalars["String"]["input"]
    /** zona horaria del hotel */
    zona_horaria?: InputMaybe<Scalars["String"]["input"]>
}

export interface CreateIncidenciaInput {
    area?: InputMaybe<Scalars["String"]["input"]>
    cliente_url?: InputMaybe<Scalars["String"]["input"]>
    colaborador_id_reporta: Scalars["ID"]["input"]
    detalle: Scalars["String"]["input"]
    fecha_apertura?: InputMaybe<Scalars["DateTime"]["input"]>
    habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    huesped?: InputMaybe<Scalars["String"]["input"]>
    imagenes?: InputMaybe<Array<ImagenIncidenciaInput>>
    matricula?: InputMaybe<Scalars["String"]["input"]>
    severidad: Scalars["String"]["input"]
    tipo_incidencia?: InputMaybe<Scalars["String"]["input"]>
    turno_id: Scalars["ID"]["input"]
}

export interface CreateMantenimientoInput {
    /** Consumo de agua */
    agua: Scalars["Float"]["input"]
    colaborador_id: Scalars["ID"]["input"]
    /** Consumo de gas */
    gas: Scalars["Float"]["input"]
    /** Consumo de luz */
    luz: Scalars["Float"]["input"]
    /** ID del turno */
    turno_id: Scalars["ID"]["input"]
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface CreateManyPagosPropinasInput {
    caja_chica: Scalars["Boolean"]["input"]
    descripcion: Scalars["String"]["input"]
    detalles_pago: DetallePagoPartialInfoObject
    hotel_id: Scalars["ID"]["input"]
    limite_disponible: Scalars["Float"]["input"]
    pagos_propinas: Array<PagoPropinaItemInput>
    periodo_pago: Scalars["String"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface CreateManySurtidosInput {
    hotel_id: Scalars["ID"]["input"]
    numero_orden_factura?: InputMaybe<Scalars["String"]["input"]>
    surtidos: Array<CreateSurtidoPartialDetailInput>
    usuario_autorizo_id: Scalars["ID"]["input"]
}

export interface CreateManySurtidosOutput {
    __typename?: "CreateManySurtidosOutput"
    numero_articulos_surtidos: Scalars["Int"]["output"]
    surtidos: Array<Surtido>
}

export interface CreateMesaAsignadaInput {
    colaborador_asignado_id: Scalars["ID"]["input"]
    mesa_id: Scalars["ID"]["input"]
    orden_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_autorizo_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface CreateMesaInput {
    cantidad_personas: Scalars["Float"]["input"]
    estado: EstadoMesa
    hotel_id: Scalars["ID"]["input"]
    numero_mesa: Scalars["String"]["input"]
    usuario_modifico_id: Scalars["ID"]["input"]
}

export interface CreateModificadorGrupoModificadorInput {
    grupo_modificador_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
    modificador_id: Scalars["ID"]["input"]
}

export interface CreateModificadorInput {
    almacen_articulo_id?: InputMaybe<Scalars["ID"]["input"]>
    estado: EstadosModificador
    hotel_id: Scalars["ID"]["input"]
    nombre: Scalars["String"]["input"]
    tipo_modificador: TiposModificador
}

export interface CreateMonedaInput {
    /** Clave ISO 4217 (ej. MXN, USD, EUR) */
    clave: Scalars["String"]["input"]
    /** Icono de la moneda */
    icono?: InputMaybe<Scalars["String"]["input"]>
    /** Nombre completo de la moneda (ej. Peso Mexicano) */
    nombre: Scalars["String"]["input"]
    /** Símbolo de la moneda (ej. $, €, £) */
    simbolo: Scalars["String"]["input"]
}

export interface CreateMotivoIngresoVehiculoDto {
    /** Identificador del hotel al que pertenece el motivo de ingreso */
    hotel_id: Scalars["ID"]["input"]
    /** Nombre del motivo de ingreso de un vehículo  */
    nombre: Scalars["String"]["input"]
}

export interface CreateOrdenInput {
    colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    consumo_interno_colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    corte_id?: InputMaybe<Scalars["ID"]["input"]>
    detalles_orden: Array<CreateDetalleOrdenPartialInfoInput>
    easyrewards_id?: InputMaybe<Scalars["String"]["input"]>
    estado_orden?: InputMaybe<EstadosOrdenHistorial>
    hotel_id: Scalars["ID"]["input"]
    mesa_id?: InputMaybe<Scalars["ID"]["input"]>
    modalidad_de_pago?: InputMaybe<ModalidadDePago>
    monto_iva: Scalars["Float"]["input"]
    pago?: InputMaybe<CreatePagoInput>
    propina?: InputMaybe<CreatePropinaPartialInput>
    renta_id?: InputMaybe<Scalars["ID"]["input"]>
    total_con_iva: Scalars["Float"]["input"]
    total_sin_iva: Scalars["Float"]["input"]
    turno_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id: Scalars["ID"]["input"]
}

export interface CreateOrdenIntegracionDirectaInput {
    comentario?: InputMaybe<Scalars["String"]["input"]>
    detalles_orden: Array<CreateDetalleOrdenPartialInfoInput>
    easyrewards_id?: InputMaybe<Scalars["String"]["input"]>
    habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    mesa_id?: InputMaybe<Scalars["ID"]["input"]>
    monto_iva: Scalars["Float"]["input"]
    pago_lovepoints?: InputMaybe<Scalars["Boolean"]["input"]>
    total_con_iva: Scalars["Float"]["input"]
    total_sin_iva: Scalars["Float"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface CreateOrdenIntegrationInput {
    articulos: Array<ArticuloExternoWithModificadoresInput>
    comentario?: InputMaybe<Scalars["String"]["input"]>
    easyrewards_id?: InputMaybe<Scalars["String"]["input"]>
    habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    mesa_id?: InputMaybe<Scalars["ID"]["input"]>
    monto_iva: Scalars["Float"]["input"]
    pago_lovepoints?: InputMaybe<Scalars["Boolean"]["input"]>
    total_con_iva: Scalars["Float"]["input"]
    total_sin_iva: Scalars["Float"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface CreateOrdenIntegrationResponseEntity {
    __typename?: "CreateOrdenIntegrationResponseEntity"
    estado_orden: EstadosDetalleOrden
    estado_pago: EstadoPagoOrdenes
    orden: Scalars["String"]["output"]
    orden_id: Scalars["String"]["output"]
    pago_id: Scalars["String"]["output"]
    saldo_pendiente: Scalars["Float"]["output"]
    virtual_comanda_id: Scalars["String"]["output"]
}

export interface CreateOrdenResponse {
    __typename?: "CreateOrdenResponse"
    orden: Orden
    ticket: ReturnIdTicketResponse
}

export interface CreatePagoInput {
    detallesPago: Array<DetallePagoPartialInfoObject>
    hotel_id: Scalars["ID"]["input"]
    total: Scalars["Float"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface CreatePagoRentaInput {
    pago_id: Scalars["ID"]["input"]
    renta_id: Scalars["ID"]["input"]
}

export interface CreatePagoReservaInput {
    pago_id: Scalars["ID"]["input"]
    reserva_id: Scalars["ID"]["input"]
}

export interface CreatePersonalizacionTicketInput {
    hotel_id: Scalars["ID"]["input"]
    imagen_promocional?: InputMaybe<Scalars["String"]["input"]>
    mostrar_logo: Scalars["Boolean"]["input"]
    textos_informativos?: InputMaybe<TextosInformativosInput>
}

export interface CreateProductionProcesoInput {
    almacen_destino_id: Scalars["ID"]["input"]
    articulo_id: Scalars["ID"]["input"]
    cantidad_produccion_final: Scalars["Float"]["input"]
    costo_produccion: Scalars["Float"]["input"]
    hotel_id: Scalars["ID"]["input"]
    usuario_autorizo_id: Scalars["ID"]["input"]
}

export interface CreateProductionProcesoOutput {
    __typename?: "CreateProductionProcesoOutput"
    articulo: Articulo
    cantidad_produccion_final: Scalars["Float"]["output"]
    costo_produccion: Scalars["Float"]["output"]
}

export interface CreatePropinaFromSale {
    colaborador_id: Scalars["ID"]["input"]
    comentarios?: InputMaybe<Scalars["String"]["input"]>
    detalles_pago: Array<DetallePagoPartialInfoObject>
    turno_id: Scalars["ID"]["input"]
}

export interface CreatePropinaInput {
    colaborador_id: Scalars["ID"]["input"]
    comentarios?: InputMaybe<Scalars["String"]["input"]>
    detalles_pago: Array<DetallePagoPartialInfoObject>
    hotel_id: Scalars["ID"]["input"]
    procedencia: ProcedenciaPropina
    procedencia_id?: InputMaybe<Scalars["ID"]["input"]>
    total: Scalars["Float"]["input"]
    turno_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface CreatePropinaPartialInput {
    colaborador_id: Scalars["ID"]["input"]
    comentarios?: InputMaybe<Scalars["String"]["input"]>
    detalles_pago: Array<DetallePagoPartialInfoObject>
    hotel_id: Scalars["ID"]["input"]
    turno_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface CreatePuestoInput {
    /** UUID de las areas */
    areas_id: Array<Scalars["ID"]["input"]>
    /** Descripción del puesto */
    descripcion: Scalars["String"]["input"]
    /** Nombre del puesto */
    nombre: Scalars["String"]["input"]
    /** Porcentaje que le corresponde del total de propinas recaudadas */
    porcentaje_propina?: InputMaybe<Scalars["Float"]["input"]>
}

export interface CreateRecetaInput {
    categoria_id?: InputMaybe<Scalars["ID"]["input"]>
    contenido: Scalars["Float"]["input"]
    costo_actual?: InputMaybe<Scalars["Float"]["input"]>
    estado: EstadosArticulo
    extra: Scalars["Boolean"]["input"]
    folio?: InputMaybe<Scalars["String"]["input"]>
    foto?: InputMaybe<Scalars["String"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    ingredientes: Array<IngredienteRecetaInput>
    marca?: InputMaybe<Scalars["String"]["input"]>
    nombre: Scalars["String"]["input"]
    precio?: InputMaybe<Scalars["Float"]["input"]>
    tipo: TipoArticulo
    unidad: UnidadMedidasArticulo
    usuario_id: Scalars["ID"]["input"]
}

export interface CreateRentaInput {
    cliente_id?: InputMaybe<Scalars["ID"]["input"]>
    comentarios: Array<Scalars["String"]["input"]>
    consumo_interno_colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    early_checkin: Scalars["Boolean"]["input"]
    easyrewards_id?: InputMaybe<Scalars["String"]["input"]>
    fecha_checkin: Scalars["DateTime"]["input"]
    fecha_fin?: InputMaybe<Scalars["DateTime"]["input"]>
    habitacion_id: Scalars["ID"]["input"]
    horas_extra: Scalars["Int"]["input"]
    hospedajes_extra: Scalars["Int"]["input"]
    hotel_id: Scalars["ID"]["input"]
    nombre_huesped?: InputMaybe<Scalars["String"]["input"]>
    numero_personas: Scalars["Int"]["input"]
    pago?: InputMaybe<CreatePagoInput>
    personas_extra: Scalars["Int"]["input"]
    propina?: InputMaybe<CreatePropinaPartialInput>
    tarifa_id: Scalars["ID"]["input"]
    tipo_alojamiento: TiposAlojamientos
    tipo_entrada: TiposEntradas
    total: Scalars["Float"]["input"]
    usuario_id: Scalars["ID"]["input"]
    vehiculo?: InputMaybe<DataVehiculoInput>
}

export interface CreateRentaIntegracionInput {
    cliente_id?: InputMaybe<Scalars["ID"]["input"]>
    comentarios: Array<Scalars["String"]["input"]>
    consumo_interno_colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    early_checkin: Scalars["Boolean"]["input"]
    easyrewards_id?: InputMaybe<Scalars["String"]["input"]>
    fecha_checkin: Scalars["DateTime"]["input"]
    fecha_fin?: InputMaybe<Scalars["DateTime"]["input"]>
    habitacion_id: Scalars["ID"]["input"]
    horas_extra: Scalars["Int"]["input"]
    hospedajes_extra: Scalars["Int"]["input"]
    hotel_id: Scalars["ID"]["input"]
    integracion_operacion_id?: InputMaybe<Scalars["String"]["input"]>
    nombre_huesped?: InputMaybe<Scalars["String"]["input"]>
    numero_personas: Scalars["Int"]["input"]
    pago?: InputMaybe<CreatePagoInput>
    pago_total_lovepoints?: InputMaybe<Scalars["Boolean"]["input"]>
    personas_extra: Scalars["Int"]["input"]
    propina?: InputMaybe<CreatePropinaPartialInput>
    tarifa_id: Scalars["ID"]["input"]
    tipo_alojamiento: TiposAlojamientos
    tipo_entrada: TiposEntradas
    total: Scalars["Float"]["input"]
    usuario_id: Scalars["ID"]["input"]
    vehiculo?: InputMaybe<DataVehiculoInput>
}

export interface CreateRentaResponse {
    __typename?: "CreateRentaResponse"
    renta: Renta
    ticket: ReturnIdTicketResponse
}

export interface CreateReservaInput {
    cliente_id?: InputMaybe<Scalars["ID"]["input"]>
    codigo_ota?: InputMaybe<Scalars["String"]["input"]>
    comentarios: Array<Scalars["String"]["input"]>
    correo_huesped?: InputMaybe<Scalars["String"]["input"]>
    easyrewards_id?: InputMaybe<Scalars["String"]["input"]>
    experiencias_ids?: InputMaybe<Array<Scalars["ID"]["input"]>>
    fecha_entrada: Scalars["DateTime"]["input"]
    fecha_salida: Scalars["DateTime"]["input"]
    hospedajes_extra?: Scalars["Int"]["input"]
    hotel_id: Scalars["ID"]["input"]
    nombre_huesped: Scalars["String"]["input"]
    numero_personas: Scalars["Int"]["input"]
    origen: OrigenRservas
    pago?: InputMaybe<CreatePagoInput>
    personas_extras?: Scalars["Int"]["input"]
    servicios_reserva?: InputMaybe<Array<Scalars["String"]["input"]>>
    tarifa_id: Scalars["ID"]["input"]
    telefono_huesped?: InputMaybe<Scalars["String"]["input"]>
    tipo_habitacion_id: Scalars["ID"]["input"]
    total: Scalars["Float"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface CreateReservaResponse {
    __typename?: "CreateReservaResponse"
    reserva: Reserva
    ticket: ReturnIdTicketResponse
}

export interface CreateRolInput {
    /** UUID de las funcionalidades */
    funcionalidades_id: Array<Scalars["ID"]["input"]>
    /** UUID del grupo hotel al que pertenece el rol */
    grupo_hotel_id: Scalars["ID"]["input"]
    /** Nombre del rol */
    nombre: Scalars["String"]["input"]
}

export interface CreateSalidaInput {
    almacen_articulo_id: Scalars["ID"]["input"]
    cantidad: Scalars["Float"]["input"]
    colaborador_id: Scalars["ID"]["input"]
    comentario?: InputMaybe<Scalars["String"]["input"]>
    detalle_orden_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    motivo: Motivo
    unidad?: InputMaybe<UnidadMedidasArticulo>
}

export interface CreateServicioInput {
    hotel_id: Scalars["ID"]["input"]
    /** Nombre del servicio */
    nombre: Scalars["String"]["input"]
}

export interface CreateSubcategoriaProductoInput {
    categoria_id: Scalars["ID"]["input"]
    subcategoria: Scalars["String"]["input"]
}

export interface CreateSubcategoriasGastosInput {
    categoria_id: Scalars["ID"]["input"]
    subcategoria: Scalars["String"]["input"]
}

export interface CreateSurtidoInput {
    almacen_articulo_id: Scalars["ID"]["input"]
    cantidad: Scalars["Float"]["input"]
    colaborador_id: Scalars["ID"]["input"]
    comentario?: InputMaybe<Scalars["String"]["input"]>
    costo_total: Scalars["Float"]["input"]
    costo_unitario: Scalars["Float"]["input"]
    hotel_id: Scalars["ID"]["input"]
    numero_orden_factura?: InputMaybe<Scalars["String"]["input"]>
    tipo?: InputMaybe<TiposSurtido>
    unidad?: InputMaybe<UnidadMedidasArticulo>
}

export interface CreateSurtidoPartialDetailInput {
    a_surtir: Scalars["Float"]["input"]
    almacen_destino_id: Scalars["ID"]["input"]
    articulo_id: Scalars["ID"]["input"]
    costo_unitario: Scalars["Float"]["input"]
    unidad?: InputMaybe<UnidadMedidasArticulo>
}

export interface CreateSuscripcionInput {
    estatus: Scalars["String"]["input"]
    fecha_expiracion: Scalars["DateTime"]["input"]
    fecha_inicio: Scalars["DateTime"]["input"]
    hotel_id: Scalars["ID"]["input"]
}

export interface CreateTareaInput {
    descripcion: Scalars["String"]["input"]
    nombre: Scalars["String"]["input"]
    puesto_id: Scalars["ID"]["input"]
    tipo?: InputMaybe<TiposTarea>
}

export interface CreateTarifaDto {
    costo_early_checkin: Scalars["Float"]["input"]
    costo_habitacion: Scalars["Float"]["input"]
    costo_hora_extra: Scalars["Float"]["input"]
    costo_hospedaje_extra: Scalars["Float"]["input"]
    costo_persona_extra: Scalars["Float"]["input"]
    dias_disponibles: Array<DiasDisponibles>
    duracion_renta: Scalars["Float"]["input"]
    fecha_final: Scalars["DateTime"]["input"]
    fecha_inicio: Scalars["DateTime"]["input"]
    hora_checkin: Scalars["String"]["input"]
    hora_checkout: Scalars["String"]["input"]
    hora_final: Scalars["String"]["input"]
    hora_inicio: Scalars["String"]["input"]
    horas_extra_max: Scalars["Float"]["input"]
    hospedajes_extra_max: Scalars["Float"]["input"]
    hotel_id: Scalars["ID"]["input"]
    nombre: Scalars["String"]["input"]
    pantalla_disponibilidad: Scalars["Boolean"]["input"]
    personas_extra_max: Scalars["Float"]["input"]
    tipo_alojamiento: TiposAlojamientos
    tipo_habitacion_id: Scalars["ID"]["input"]
    tipo_tarifa: TipoTarifa
    visible_venta?: InputMaybe<Scalars["Boolean"]["input"]>
}

export interface CreateTipoBloqueoDto {
    /** Listado de claves del tipo de bloqueo */
    claves: Array<ClaveTipoBloqueoInput>
    /** Identificador del hotel al que pertenece el tipo de bloqueo */
    hotel_id: Scalars["ID"]["input"]
    /** Nombre del tipo de bloqueo */
    nombre: Scalars["String"]["input"]
}

export interface CreateTipoHabitacionDto {
    amenidades: Array<Scalars["String"]["input"]>
    camas: Array<CamaInput>
    clave: Scalars["String"]["input"]
    descripcion: Scalars["String"]["input"]
    /** Habitaciones de este tipo que se reservan para renta en recepcion (default 1) */
    habitaciones_reservadas_recepcion?: InputMaybe<Scalars["Int"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    /** Limite de reservas por dia */
    limite_reservas: Scalars["Float"]["input"]
    minutos_entrada: Scalars["Float"]["input"]
    minutos_limpieza_detallada: Scalars["Float"]["input"]
    minutos_limpieza_normal: Scalars["Float"]["input"]
    minutos_limpieza_retoque: Scalars["Float"]["input"]
    minutos_pendiente_supervision: Scalars["Float"]["input"]
    minutos_sucia: Scalars["Float"]["input"]
    minutos_supervision: Scalars["Float"]["input"]
    nombre: Scalars["String"]["input"]
    personas_incluidas: Scalars["Int"]["input"]
}

export interface CreateTipoMantenimientoDto {
    /** Listado de claves del tipo de mantenimiento */
    claves: Array<ClaveTipoMantenimientoInput>
    /** Identificador del hotel al que pertenece el tipo de mantenimiento */
    hotel_id: Scalars["ID"]["input"]
    /** Nombre del tipo de mantenimiento */
    nombre: Scalars["String"]["input"]
}

export interface CreateTurnoAtencionInput {
    estado: EstadosTurnosAtencion
    hotel_id: Scalars["ID"]["input"]
    nombre_o_matricula?: InputMaybe<Scalars["String"]["input"]>
    tipo_habitacion_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface CreateTurnoInput {
    hora_entrada: Scalars["String"]["input"]
    hora_salida: Scalars["String"]["input"]
    hotel_id: Scalars["ID"]["input"]
    nombre: Scalars["ID"]["input"]
    orden: Scalars["Int"]["input"]
}

export interface CreateUsuarioInput {
    apellido_materno?: InputMaybe<Scalars["String"]["input"]>
    apellido_paterno?: InputMaybe<Scalars["String"]["input"]>
    cliente_url?: InputMaybe<Scalars["String"]["input"]>
    codigo?: InputMaybe<Scalars["String"]["input"]>
    correo: Scalars["String"]["input"]
    empresa_hotel: Scalars["String"]["input"]
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    nombre: Scalars["String"]["input"]
    origen?: InputMaybe<Origen>
    pais: Scalars["String"]["input"]
    password?: InputMaybe<Scalars["String"]["input"]>
    puesto_rol?: InputMaybe<PuestoRol>
    rol_id?: InputMaybe<Scalars["ID"]["input"]>
    telefono?: InputMaybe<Scalars["String"]["input"]>
    usuario?: InputMaybe<Scalars["String"]["input"]>
}

export interface DataConceptoResumenUtilidad {
    __typename?: "DataConceptoResumenUtilidad"
    concepto: Scalars["String"]["output"]
    porcentaje_diario: Scalars["Float"]["output"]
    total: Scalars["Float"]["output"]
}

export interface DataConceptoResumenUtilidadPorcentaje {
    __typename?: "DataConceptoResumenUtilidadPorcentaje"
    concepto: Scalars["String"]["output"]
    total: Scalars["Float"]["output"]
}

export interface DataConceptoResumenUtilidadTotales {
    __typename?: "DataConceptoResumenUtilidadTotales"
    gastos: DataConceptoResumenUtilidadTotalesGastos
    ingresos: DataConceptoResumenUtilidadTotalesIngresos
}

export interface DataConceptoResumenUtilidadTotalesGastos {
    __typename?: "DataConceptoResumenUtilidadTotalesGastos"
    total: Scalars["Float"]["output"]
}

export interface DataConceptoResumenUtilidadTotalesIngresos {
    __typename?: "DataConceptoResumenUtilidadTotalesIngresos"
    porcentaje_diario: Scalars["Float"]["output"]
    total: Scalars["Float"]["output"]
}

export interface DataHistorialCambiosTicket {
    __typename?: "DataHistorialCambiosTicket"
    /** Métodos de pago anteriores */
    metodos_pago: Array<MetodosPagoTicket>
}

export interface DataIngresosHotelOutput {
    __typename?: "DataIngresosHotelOutput"
    cantidad: Scalars["Float"]["output"]
    concepto: Scalars["String"]["output"]
    precio_promedio: Scalars["Float"]["output"]
    total_de_venta: Scalars["Float"]["output"]
}

export interface DataRoomService {
    __typename?: "DataRoomService"
    cantidad: Scalars["Float"]["output"]
    concepto: Scalars["String"]["output"]
    precio_promedio: Scalars["Float"]["output"]
    total: Scalars["Float"]["output"]
}

export interface DataSubtotales {
    __typename?: "DataSubtotales"
    total_early_checkin: Scalars["Float"]["output"]
    total_habitacion: Scalars["Float"]["output"]
    total_horas_extra: Scalars["Float"]["output"]
    total_hospedajes_extra: Scalars["Float"]["output"]
    total_personas_extra: Scalars["Float"]["output"]
}

export interface DataTicket {
    __typename?: "DataTicket"
    articulos: Array<ArticuloTicket>
    experiencias: Array<ExperienciasTicket>
    extras: Array<ExtraTicket>
    folio_venta?: Maybe<Scalars["String"]["output"]>
    habitaciones: Array<HabitacionTicket>
    metodos_pago: Array<MetodosPagoTicket>
    nombre_tarifa?: Maybe<Scalars["String"]["output"]>
    orden_id?: Maybe<Array<Scalars["ID"]["output"]>>
    origen_ticket: OrigenTicket
    propinas: Array<PropinasDetalleTicket>
    renta: Array<RentaTicket>
    renta_id?: Maybe<Scalars["ID"]["output"]>
}

export interface DataVehiculoInput {
    /** Color del vehiculo */
    color: Scalars["String"]["input"]
    /** Marca del vehiculo */
    marca: Scalars["String"]["input"]
    /** Numero de vehiculo */
    matricula: Scalars["String"]["input"]
    /** Modelo del vehiculo */
    modelo: Scalars["String"]["input"]
}

/** Datos de vehiculo */
export interface Data_Vehiculo {
    __typename?: "Data_Vehiculo"
    /** Color del vehiculo */
    color: Scalars["String"]["output"]
    /** Marca del vehiculo */
    marca: Scalars["String"]["output"]
    /** Numero de vehiculo */
    matricula: Scalars["String"]["output"]
    /** Modelo del vehiculo */
    modelo: Scalars["String"]["output"]
}

export interface DateSearchInput {
    after?: InputMaybe<Scalars["DateTime"]["input"]>
    before?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_final?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_inicial?: InputMaybe<Scalars["DateTime"]["input"]>
}

export interface DatosHabitacion {
    __typename?: "DatosHabitacion"
    ultima_limpieza?: Maybe<Array<ColaboradorTarea>>
    ultima_supervision?: Maybe<ColaboradorTarea>
    ultimo_mantenimiento?: Maybe<ColaboradorTarea>
}

export interface DatosPaginationOutput {
    __typename?: "DatosPaginationOutput"
    pagina_actual: Scalars["Int"]["output"]
    total_paginas: Scalars["Int"]["output"]
    total_registros: Scalars["Int"]["output"]
}

export interface DaySearchInput {
    dia_final: Scalars["String"]["input"]
    dia_inicial: Scalars["String"]["input"]
}

export interface DeleteAlmacenInput {
    almacen_id: Array<Scalars["ID"]["input"]>
}

export interface DeleteAlmacenesArticulosInput {
    almacen_articulo_id: Array<Scalars["ID"]["input"]>
}

export interface DeleteApiKeyInput {
    api_key_id: Scalars["String"]["input"]
}

export interface DeleteAreaInput {
    area_id: Scalars["ID"]["input"]
}

export interface DeleteArticuloExternoInput {
    articulo_externo_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
}

export interface DeleteArticuloGrupoModificadorInput {
    articulo_grupo_modificador_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
}

export interface DeleteArticuloInput {
    articulo_id: Scalars["ID"]["input"]
}

export interface DeleteCategoriaArticuloInput {
    categoria_id: Scalars["ID"]["input"]
}

export interface DeleteCategoriaGastosInput {
    categoria_id: Scalars["ID"]["input"]
}

export interface DeleteClienteInput {
    cliente_id: Scalars["ID"]["input"]
}

export interface DeleteColaboradorInput {
    colaborador_id: Scalars["ID"]["input"]
}

export interface DeleteColaboradorTareaInput {
    colaborador_tarea_id: Scalars["ID"]["input"]
}

export interface DeleteComandaInput {
    comanda_id: Array<Scalars["ID"]["input"]>
}

export interface DeleteComentarioHabitacionInput {
    comentario_id: Scalars["ID"]["input"]
    habitacion_id: Scalars["ID"]["input"]
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface DeleteConfiguracionFajillaInput {
    configuracion_fajilla_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface DeleteCredencialInput {
    usuario_id: Scalars["ID"]["input"]
}

export interface DeleteCredentialHuellaPinInput {
    credenciales: Array<HuellaOPin>
    usuario_id: Scalars["ID"]["input"]
}

export interface DeleteGastoInput {
    gasto_id: Scalars["ID"]["input"]
}

export interface DeleteGrupoModificadorInput {
    grupo_modificador_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
}

/** Campos que pueden ser directamente modificados de la entidad Habitacion */
export interface DeleteHabitacionInput {
    habitacion_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface DeleteHotelInput {
    hotel_id: Scalars["ID"]["input"]
}

export interface DeleteImageInput {
    image: ImagenIncidenciaInput
    indicencia_id: Scalars["ID"]["input"]
}

export interface DeleteMantenimientoInput {
    /** ID del mantenimiento a eliminar */
    mantenimiento_id: Scalars["ID"]["input"]
}

export interface DeleteMesaInput {
    mesa_id: Scalars["ID"]["input"]
}

export interface DeleteMetodoDePagoInput {
    metododepago_id: Scalars["ID"]["input"]
}

export interface DeleteModificadorGrupoModificadorInput {
    hotel_id: Scalars["ID"]["input"]
    modificadores_grupos_modificadores_id: Scalars["ID"]["input"]
}

export interface DeleteModificadorInput {
    hotel_id: Scalars["ID"]["input"]
    modificador_id: Scalars["ID"]["input"]
}

export interface DeleteMotivoIngresoVehiculoArgs {
    motivo_ingreso_id: Scalars["ID"]["input"]
}

export interface DeletePropinaInput {
    propina_id: Scalars["ID"]["input"]
}

export interface DeletePuestoInput {
    puesto_id: Scalars["ID"]["input"]
}

export interface DeleteRecetaInput {
    articulo_id: Array<Scalars["ID"]["input"]>
}

export interface DeleteRolInput {
    rol_id: Scalars["ID"]["input"]
}

export interface DeleteSalidaInput {
    salida_id: Scalars["ID"]["input"]
}

export interface DeleteServicioInput {
    hotel_id: Scalars["ID"]["input"]
    servicio_id: Scalars["ID"]["input"]
}

export interface DeleteSubcategoriaGastoInput {
    subcategoria_gasto_id: Scalars["ID"]["input"]
}

export interface DeleteSubcategoriaProductoInput {
    subcategoria_id: Scalars["ID"]["input"]
}

export interface DeleteSuscripcionInput {
    suscripcion_id: Scalars["ID"]["input"]
}

export interface DeleteTareaInput {
    tarea_id: Scalars["ID"]["input"]
}

export interface DeleteTarifaDto {
    tarifa_id: Scalars["ID"]["input"]
}

export interface DeleteTipoBloqueoArgs {
    tipo_bloqueo_id: Scalars["ID"]["input"]
}

export interface DeleteTipoHabitacionArgs {
    tipo_habitacion_id: Scalars["ID"]["input"]
}

export interface DeleteTipoMantenimientoArgs {
    tipo_mantenimiento_id: Scalars["ID"]["input"]
}

export interface DeleteTurnoAtencionInput {
    turno_atencion_id: Scalars["ID"]["input"]
}

export interface DeleteTurnoInput {
    turno_id: Scalars["ID"]["input"]
}

export interface DeleteUsuarioInput {
    usuario_id: Scalars["ID"]["input"]
}

export interface DescuentaPuntosInput {
    easyrewards_id: Scalars["String"]["input"]
    folio_ticket: Scalars["String"]["input"]
    hotel_id: Scalars["ID"]["input"]
    puntos_descontar: Scalars["Float"]["input"]
}

export interface DetalleOrden {
    __typename?: "DetalleOrden"
    almacen_articulo?: Maybe<AlmacenArticulo>
    almacen_articulo_id: Scalars["ID"]["output"]
    cantidad: Scalars["Int"]["output"]
    comanda_id?: Maybe<Scalars["ID"]["output"]>
    comentarios?: Maybe<Scalars["String"]["output"]>
    costo_con_iva: Scalars["Float"]["output"]
    costo_sin_iva: Scalars["Float"]["output"]
    detalle_orden_id: Scalars["ID"]["output"]
    estado: EstadosDetalleOrden
    /** Representa el estado previo a la cancelacion del articulo. Sirve para poder filtrar el detalle en el panel de cocina */
    estado_anterior?: Maybe<EstadosDetalleOrden>
    extras?: Maybe<Array<ExtraDetalleOrden>>
    fecha_cancelacion?: Maybe<Scalars["DateTime"]["output"]>
    fecha_devolucion?: Maybe<Scalars["DateTime"]["output"]>
    merma?: Maybe<Scalars["Boolean"]["output"]>
    monto_iva: Scalars["Float"]["output"]
    motivo_cancelacion?: Maybe<Scalars["String"]["output"]>
    orden_id: Scalars["ID"]["output"]
    reembolso?: Maybe<Scalars["Boolean"]["output"]>
}

export interface DetallePago {
    __typename?: "DetallePago"
    cancelado: Scalars["Boolean"]["output"]
    detalle_pago_id: Scalars["ID"]["output"]
    easyrewards_id?: Maybe<Scalars["String"]["output"]>
    fecha_pago: Scalars["DateTime"]["output"]
    numero_referencia?: Maybe<Scalars["String"]["output"]>
    origen_orden: OrigenOrden
    pago?: Maybe<Pago>
    pago_id: Scalars["ID"]["output"]
    subtotal: Scalars["Float"]["output"]
    tipo_pago: TiposPagos
    ultimos_digitos?: Maybe<Scalars["String"]["output"]>
}

export interface DetallePagoPartialInfoObject {
    easyrewards_id?: InputMaybe<Scalars["String"]["input"]>
    numero_referencia?: InputMaybe<Scalars["String"]["input"]>
    subtotal: Scalars["Float"]["input"]
    tipo_pago: TiposPagos
    ultimos_digitos?: InputMaybe<Scalars["String"]["input"]>
}

export interface DetallePagoPreCargadoOutput {
    __typename?: "DetallePagoPreCargadoOutput"
    easyrewards_id?: Maybe<Scalars["ID"]["output"]>
    numero_referencia?: Maybe<Scalars["String"]["output"]>
    subtotal: Scalars["Float"]["output"]
    tipo_pago: TiposPagos
    ultimos_digitos?: Maybe<Scalars["String"]["output"]>
}

export interface DetalleRepartoPropinaItemOutput {
    __typename?: "DetalleRepartoPropinaItemOutput"
    aportacion_a_fondo: Scalars["Float"]["output"]
    colaborador?: Maybe<Colaborador>
    colaborador_id: Scalars["ID"]["output"]
    comision_bancaria_propina_por_venta: Scalars["Float"]["output"]
    comision_bancaria_sobre_fondo: Scalars["Float"]["output"]
    desglose_aportacion_a_fondo: Array<VentaColaboradorPorCategoriaDetailOutput>
    desglose_propina_recolectada: Array<PropinaRecolectadaColaboradorDetailOutput>
    fondo_de_propina: Scalars["Float"]["output"]
    neto_propina_por_ventas: Scalars["Float"]["output"]
    pago_correspondiente: Scalars["Float"]["output"]
    propina_recolectada: Scalars["Float"]["output"]
    subtotal_propina_por_ventas: Scalars["Float"]["output"]
}

export interface DetalleRepartoPropinasOutput {
    __typename?: "DetalleRepartoPropinasOutput"
    detalle_reparto_propinas: Array<DetalleRepartoPropinaItemOutput>
    monto_recaudado: Scalars["Float"]["output"]
    totales: TotalesRepartoPropinasItemOutput
}

export interface DetallesPagoPartialInfoOutput {
    __typename?: "DetallesPagoPartialInfoOutput"
    numero_referencia?: Maybe<Scalars["String"]["output"]>
    subtotal: Scalars["Float"]["output"]
    tipo_pago: TiposPagos
    ultimos_digitos?: Maybe<Scalars["String"]["output"]>
}

export enum DiasDisponibles {
    Domingo = "domingo",
    Jueves = "jueves",
    Lunes = "lunes",
    Martes = "martes",
    Miercoles = "miercoles",
    Sabado = "sabado",
    Viernes = "viernes",
}

export enum DisponibilidadPanelAction {
    Actualizar = "actualizar",
    Agregar = "agregar",
    Remover = "remover",
}

export interface EditComandaInput {
    cancelaciones_detalles?: InputMaybe<Array<CancelDetalleOrdenInput>>
    cancelaciones_extras?: InputMaybe<Array<CancelExtraDetalleOrdenInput>>
    comanda_id: Scalars["ID"]["input"]
    detalles?: InputMaybe<Array<EditDetalleOrdenInput>>
    hotel_id: Scalars["ID"]["input"]
}

export interface EditConfiguracionCorteItemInput {
    activo?: InputMaybe<Scalars["Boolean"]["input"]>
    concepto?: InputMaybe<ConceptosConfiguracionesCortes>
    configuracion_corte_id: Scalars["ID"]["input"]
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface EditConfiguracionesCorteInput {
    configuraciones_corte: Array<EditConfiguracionCorteItemInput>
}

export interface EditDetalleOrdenInput {
    accion: AccionesEdicion
    almacen_articulo_id: Scalars["ID"]["input"]
    comentarios?: InputMaybe<Scalars["String"]["input"]>
    detalle_orden_id?: InputMaybe<Scalars["ID"]["input"]>
    extras?: InputMaybe<Array<EditExtraDetalleOrdenInput>>
}

export interface EditExtraDetalleOrdenInput {
    accion: AccionesEdicion
    almacen_articulo_id: Scalars["ID"]["input"]
    cantidad: Scalars["Int"]["input"]
    extra_detalle_orden_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface EditMetodoPagoTicketInput {
    metodo_pago: Array<FormaDePagoDetailInput>
    ticket_id: Scalars["ID"]["input"]
}

export interface EditMetodoPagoTicketOutput {
    __typename?: "EditMetodoPagoTicketOutput"
    metodo_pago: Array<FormaDePagoDetailOutput>
    ticket_id: Scalars["ID"]["output"]
}

export interface EditOrdenInput {
    cancelaciones_detalles?: InputMaybe<Array<CancelDetalleOrdenInput>>
    cancelaciones_extras?: InputMaybe<Array<CancelExtraDetalleOrdenInput>>
    detalles?: InputMaybe<Array<EditDetalleOrdenInput>>
    hotel_id: Scalars["ID"]["input"]
    orden_id: Scalars["ID"]["input"]
    usuario_id?: InputMaybe<Scalars["String"]["input"]>
}

export interface EditVehiculoDataInput {
    renta_id: Scalars["ID"]["input"]
    vehiculo: VehiculoDataEditDetailInput
}

export enum EstadoAlmacen {
    Activado = "activado",
    Desactivado = "desactivado",
}

export enum EstadoGrupoModificador {
    Activado = "activado",
    Desactivado = "desactivado",
}

export enum EstadoMesa {
    Bloqueada = "bloqueada",
    Disponible = "disponible",
    EnServicio = "en_servicio",
    Sucia = "sucia",
}

export enum EstadoPago {
    Pagado = "pagado",
    PagoParcial = "pago_parcial",
    SinPagos = "sin_pagos",
}

export enum EstadoPagoOrdenes {
    Deposito = "deposito",
    NoPagada = "no_pagada",
    Pagada = "pagada",
    PagoParcial = "pago_parcial",
}

export enum EstadosAlmacenesArticulos {
    Activado = "activado",
    Agotado = "agotado",
    Desactivado = "desactivado",
    Disponible = "disponible",
    PorAgotarse = "por_agotarse",
}

export enum EstadosArticulo {
    Activado = "activado",
    Desactivado = "desactivado",
}

export enum EstadosArticuloExterno {
    Activado = "activado",
    Desactivado = "desactivado",
}

export enum EstadosComandaHistorial {
    Cancelada = "cancelada",
    Devolucion = "devolucion",
    EnEntrega = "en_entrega",
    EnPreparacion = "en_preparacion",
    Entregada = "entregada",
    PorEntregar = "por_entregar",
}

export enum EstadosDetalleOrden {
    Cancelada = "cancelada",
    CanceladaEdicion = "cancelada_edicion",
    Devolucion = "devolucion",
    EnEntrega = "en_entrega",
    EnPreparacion = "en_preparacion",
    Entregada = "entregada",
    PorEntregar = "por_entregar",
}

export enum EstadosDinamicosMesa {
    EnPreparacion = "en_preparacion",
    PagoPendiente = "pago_pendiente",
    PorEntregar = "por_entregar",
}

export enum EstadosExperiencias {
    Desactivado = "desactivado",
    Disponible = "disponible",
}

export enum EstadosExperienciasReservas {
    Cancelada = "cancelada",
    Pagado = "pagado",
    PagoParcial = "pago_parcial",
    SinPagos = "sin_pagos",
}

export enum EstadosModificador {
    Activado = "activado",
    Desactivado = "desactivado",
}

export enum EstadosOrdenHistorial {
    Cancelada = "cancelada",
    CanceladaEdicion = "cancelada_edicion",
    Devolucion = "devolucion",
    EnEntrega = "en_entrega",
    EnPreparacion = "en_preparacion",
    Entregada = "entregada",
    PorEntregar = "por_entregar",
}

export enum EstadosRentas {
    Cancelado = "cancelado",
    Finalizado = "finalizado",
    Pagado = "pagado",
    PendientePago = "pendiente_pago",
}

export enum EstadosReservas {
    Asignada = "asignada",
    Cancelada = "cancelada",
    CheckIn = "check_in",
    NoShow = "no_show",
    SinAsignar = "sin_asignar",
}

export enum EstadosTurno {
    Abierto = "abierto",
    Cerrado = "cerrado",
}

export enum EstadosTurnosAtencion {
    Cancelado = "cancelado",
    EnCurso = "en_curso",
    EnEspera = "en_espera",
    Finalizado = "finalizado",
}

export interface EstanciaPendienteRentaDetailOutput {
    __typename?: "EstanciaPendienteRentaDetailOutput"
    cantidad: Scalars["Int"]["output"]
    /** Datos del colaborador que registro el movimiento */
    colaborador?: Maybe<Colaborador>
    detalle: Scalars["String"]["output"]
    easyrewards_id?: Maybe<Scalars["String"]["output"]>
    extras_checkin: Array<ExtraPendienteRentaDetailOutput>
    folio: Scalars["String"]["output"]
    iva: Scalars["Float"]["output"]
    precio: Scalars["Float"]["output"]
    renta_id: Scalars["ID"]["output"]
    total: Scalars["Float"]["output"]
    usuario_id?: Maybe<Scalars["ID"]["output"]>
}

export enum EstatusCorte {
    Cerrado = "cerrado",
    Pendiente = "pendiente",
}

export enum EstatusFajillas {
    Cancelada = "cancelada",
    Creada = "creada",
    Rechazada = "rechazada",
    Recibida = "recibida",
    RecibirFajilla = "recibir_fajilla",
}

export enum EstatusTarifa {
    Activa = "Activa",
    Inactiva = "Inactiva",
}

export interface Experiencia {
    __typename?: "Experiencia"
    cobro_unico: Scalars["Boolean"]["output"]
    descripcion?: Maybe<Scalars["String"]["output"]>
    eliminado: Scalars["Boolean"]["output"]
    estado: EstadosExperiencias
    experiencia_id: Scalars["ID"]["output"]
    fecha_fin: Scalars["DateTime"]["output"]
    fecha_inicio: Scalars["DateTime"]["output"]
    fecha_registro: Scalars["DateTime"]["output"]
    hotel_id: Scalars["ID"]["output"]
    nombre: Scalars["String"]["output"]
    precio: Scalars["Float"]["output"]
    usuario_id: Scalars["ID"]["output"]
}

export interface ExperienciaReserva {
    __typename?: "ExperienciaReserva"
    estado: EstadosExperienciasReservas
    experiencia?: Maybe<Experiencia>
    experiencia_id: Scalars["ID"]["output"]
    experiencia_reserva_id: Scalars["ID"]["output"]
    fecha_cancelacion?: Maybe<Scalars["DateTime"]["output"]>
    fecha_registro: Scalars["DateTime"]["output"]
    hotel_id: Scalars["ID"]["output"]
    monto_cancelacion?: Maybe<Scalars["Float"]["output"]>
    motivo_cancelacion?: Maybe<Scalars["String"]["output"]>
    reserva_id: Scalars["ID"]["output"]
    total: Scalars["Float"]["output"]
}

export interface ExperienciasTicket {
    __typename?: "ExperienciasTicket"
    nombre: Scalars["String"]["output"]
    total: Scalars["Float"]["output"]
}

export interface Extra {
    __typename?: "Extra"
    corte_id?: Maybe<Scalars["ID"]["output"]>
    extra_id: Scalars["ID"]["output"]
    fecha_cancelacion?: Maybe<Scalars["DateTime"]["output"]>
    fecha_pago?: Maybe<Scalars["DateTime"]["output"]>
    fecha_solicitud: Scalars["DateTime"]["output"]
    folio?: Maybe<Scalars["String"]["output"]>
    hotel_id: Scalars["ID"]["output"]
    monto_devuelto_cancelacion?: Maybe<Scalars["Float"]["output"]>
    monto_extra: Scalars["Float"]["output"]
    motivo_cancelacion?: Maybe<Scalars["String"]["output"]>
    numero: Scalars["Int"]["output"]
    /** Es la propina recibida y asociada en la compra del extra */
    propina?: Maybe<Propina>
    renta?: Maybe<Renta>
    renta_id: Scalars["ID"]["output"]
    ticket_id?: Maybe<Scalars["String"]["output"]>
    tipo_extra: TiposExtras
    /** Es el total del extra + propina (si es que tiene) */
    total_con_propina: Scalars["Float"]["output"]
    /** Total del monto de extras tipo hora en la misma venta */
    total_venta_extra_horas?: Maybe<Scalars["Float"]["output"]>
    /** Total del monto de extras tipo hospedaje en la misma venta */
    total_venta_extra_hospedajes?: Maybe<Scalars["Float"]["output"]>
    /** Total del monto de extras tipo persona en la misma venta */
    total_venta_extra_personas?: Maybe<Scalars["Float"]["output"]>
    usuario_cancelacion_id?: Maybe<Scalars["ID"]["output"]>
    usuario_id?: Maybe<Scalars["ID"]["output"]>
    venta_checkin?: Maybe<Scalars["Boolean"]["output"]>
    /** Cantidad de horas en extra relacionado a si fueron en una misma venta */
    venta_extra_horas?: Maybe<Scalars["Float"]["output"]>
    /** Cantidad de hospedajes en extra relacionado a si fueron en una misma venta */
    venta_extra_hospedajes?: Maybe<Scalars["Float"]["output"]>
    /** Cantidad de personas en extra relacionado a si fueron en una misma venta */
    venta_extra_personas?: Maybe<Scalars["Float"]["output"]>
    venta_id?: Maybe<Scalars["ID"]["output"]>
}

export interface ExtraDetalleOrden {
    __typename?: "ExtraDetalleOrden"
    almacen_articulo?: Maybe<AlmacenArticulo>
    almacen_articulo_id: Scalars["ID"]["output"]
    cantidad: Scalars["Float"]["output"]
    costo_con_iva: Scalars["Float"]["output"]
    costo_sin_iva: Scalars["Float"]["output"]
    detalle_orden_id: Scalars["ID"]["output"]
    extra_detalle_orden_id: Scalars["ID"]["output"]
    monto_iva: Scalars["Float"]["output"]
}

export interface ExtraPendienteRentaDetailOutput {
    __typename?: "ExtraPendienteRentaDetailOutput"
    cantidad: Scalars["Int"]["output"]
    /** Datos del colaborador que registro el movimiento */
    colaborador?: Maybe<Colaborador>
    detalle: Scalars["String"]["output"]
    extra_id: Scalars["ID"]["output"]
    folio?: Maybe<Scalars["String"]["output"]>
    iva: Scalars["Float"]["output"]
    precio: Scalars["Float"]["output"]
    total: Scalars["Float"]["output"]
    usuario_id?: Maybe<Scalars["ID"]["output"]>
    venta_checkin: Scalars["Boolean"]["output"]
    venta_id: Scalars["ID"]["output"]
}

export interface ExtraTicket {
    __typename?: "ExtraTicket"
    cantidad: Scalars["Int"]["output"]
    costo: Scalars["Float"]["output"]
    tipo: Scalars["String"]["output"]
}

export interface Fajilla {
    __typename?: "Fajilla"
    comentario?: Maybe<Scalars["String"]["output"]>
    /** Información de la Configuracion-Fajilla de la Fajilla */
    configuracion_fajilla?: Maybe<ConfiguracionFajilla>
    configuracion_fajilla_id?: Maybe<Scalars["ID"]["output"]>
    /** Identificador generado por la maquina de efectivo que registro la fajilla */
    deposito_id?: Maybe<Scalars["String"]["output"]>
    estatus: EstatusFajillas
    fajilla_id: Scalars["ID"]["output"]
    fecha_autorizaicion?: Maybe<Scalars["DateTime"]["output"]>
    fecha_creacion: Scalars["DateTime"]["output"]
    folio: Scalars["Float"]["output"]
    folio_integracion?: Maybe<Scalars["String"]["output"]>
    hotel_id: Scalars["ID"]["output"]
    monto: Scalars["Float"]["output"]
    origen: OrigenesFajillas
    ticket_id: Scalars["ID"]["output"]
    turno_id: Scalars["ID"]["output"]
    /** Usuario que autorizo la fajilla */
    usuario_autorizo?: Maybe<Usuario>
    usuario_autorizo_id?: Maybe<Scalars["ID"]["output"]>
    /** Usuario creador de la fajilla */
    usuario_creo?: Maybe<Usuario>
    usuario_creo_id: Scalars["ID"]["output"]
}

export interface FiltrosReportesVehiculos {
    __typename?: "FiltrosReportesVehiculos"
    colores: Array<Scalars["String"]["output"]>
    marca: Array<Scalars["String"]["output"]>
    matriculas: Array<Scalars["String"]["output"]>
    modelo: Array<Scalars["String"]["output"]>
}

export interface FiltrosReportesVehiculosColoresArgs {
    buscar?: InputMaybe<Scalars["String"]["input"]>
    limit?: InputMaybe<Scalars["Float"]["input"]>
}

export interface FiltrosReportesVehiculosMarcaArgs {
    buscar?: InputMaybe<Scalars["String"]["input"]>
    limit?: InputMaybe<Scalars["Float"]["input"]>
}

export interface FiltrosReportesVehiculosMatriculasArgs {
    buscar?: InputMaybe<Scalars["String"]["input"]>
    limit?: InputMaybe<Scalars["Float"]["input"]>
}

export interface FiltrosReportesVehiculosModeloArgs {
    buscar?: InputMaybe<Scalars["String"]["input"]>
    limit?: InputMaybe<Scalars["Float"]["input"]>
}

export interface FindAllColaboradoresTareaRequest {
    colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    colaboradores_tareas_ids?: InputMaybe<Array<Scalars["ID"]["input"]>>
    descripcion_tarea?: InputMaybe<Scalars["String"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    fecha_inicio?: InputMaybe<DateSearchInput>
    fecha_termino?: InputMaybe<DateSearchInput>
    habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
    tarea_id?: InputMaybe<Scalars["ID"]["input"]>
    tipo_limpieza?: InputMaybe<TiposLimpiezas>
}

export interface FindAllHistorialMovimientosInventarioOutput {
    __typename?: "FindAllHistorialMovimientosInventarioOutput"
    historial_movimientos_inventario: Array<HistorialMovimientosInventario>
    paginacion: DatosPaginationOutput
}

export interface FindAllPaginatedOutput {
    __typename?: "FindAllPaginatedOutput"
    colaboradores: Array<Colaborador>
    paginacion?: Maybe<DatosPaginationOutput>
}

export interface FingerPrintLoginInput {
    template_sample: Scalars["String"]["input"]
}

export interface FingerPrintLoginOutput {
    __typename?: "FingerPrintLoginOutput"
    colaborador_activo?: Maybe<Scalars["Boolean"]["output"]>
    token: Scalars["String"]["output"]
    ultimo_hotel_id?: Maybe<Scalars["ID"]["output"]>
    usuario_id?: Maybe<Scalars["ID"]["output"]>
}

export interface FolioArticuloFiltersArgs {
    /** Ordena los resultados de forma ASC o DESC en base al folio del articulo */
    order?: InputMaybe<TipoOrdenamiento>
}

export interface FormaDePagoDetailInput {
    eliminar_propina?: InputMaybe<Scalars["Boolean"]["input"]>
    eliminar_tipo_pago?: InputMaybe<Scalars["Boolean"]["input"]>
    monto_propina?: InputMaybe<Scalars["Float"]["input"]>
    numero_referencia?: InputMaybe<Scalars["String"]["input"]>
    subtotal: Scalars["Float"]["input"]
    tipo_pago: TiposPagos
}

export interface FormaDePagoDetailOutput {
    __typename?: "FormaDePagoDetailOutput"
    eliminar_propina?: Maybe<Scalars["Boolean"]["output"]>
    monto_propina?: Maybe<Scalars["Float"]["output"]>
    numero_referencia?: Maybe<Scalars["String"]["output"]>
    subtotal: Scalars["Float"]["output"]
    tipo_pago: TiposPagos
}

export interface Funcionalidad {
    __typename?: "Funcionalidad"
    descripcion: Scalars["String"]["output"]
    funcionalidad_id: Scalars["ID"]["output"]
    modulo: Modulo
    modulo_id: Scalars["ID"]["output"]
    nombre_funcionalidad: Scalars["String"]["output"]
}

export interface GastoTicket {
    __typename?: "GastoTicket"
    caja_chica: Scalars["Boolean"]["output"]
    cantidad: Scalars["Int"]["output"]
    categoria: Scalars["String"]["output"]
    categoria_id: Scalars["ID"]["output"]
    concepto: Scalars["String"]["output"]
    folio: Scalars["String"]["output"]
    gasto_id?: Maybe<Scalars["ID"]["output"]>
    monto: Scalars["Float"]["output"]
    subcategoria_id: Scalars["ID"]["output"]
}

export interface Gastos {
    __typename?: "Gastos"
    caja_chica: Scalars["Boolean"]["output"]
    /** Categoria a la que pertenece el gasto */
    categoria_gasto: CategoriaGasto
    categoria_id: Scalars["ID"]["output"]
    comentarios?: Maybe<Scalars["String"]["output"]>
    corte_id?: Maybe<Scalars["ID"]["output"]>
    eliminado: Scalars["Boolean"]["output"]
    fecha_gasto: Scalars["DateTime"]["output"]
    fecha_registro: Scalars["DateTime"]["output"]
    folio: Scalars["Int"]["output"]
    gasto_id: Scalars["ID"]["output"]
    /** Hotel asociado al gasto */
    hotel: Hotel
    hotel_id: Scalars["ID"]["output"]
    metodo_pago: Scalars["String"]["output"]
    monto: Scalars["Float"]["output"]
    /** Sub-categoria a la que pertenece el gasto */
    subcategoria_gasto?: Maybe<SubcategoriaGasto>
    subcategoria_id?: Maybe<Scalars["ID"]["output"]>
    ticket_id?: Maybe<Scalars["ID"]["output"]>
    /** Usuario que registra el gasto */
    usuario: Usuario
    usuario_id: Scalars["ID"]["output"]
}

export interface GastosNotificacionesConfigOutput {
    __typename?: "GastosNotificacionesConfigOutput"
    presupuesto_excedido: Scalars["Boolean"]["output"]
}

export interface GetAggregationsAlmacenesArticulosOutput {
    __typename?: "GetAggregationsAlmacenesArticulosOutput"
    total_procesos: Scalars["Int"]["output"]
    total_recetas_alimentos: Scalars["Int"]["output"]
    total_recetas_bebidas: Scalars["Int"]["output"]
    total_recetas_procesos: Scalars["Int"]["output"]
}

export interface GetCancelableAmountsRentaOutput {
    __typename?: "GetCancelableAmountsRentaOutput"
    parcial: Scalars["Float"]["output"]
    total: Scalars["Float"]["output"]
}

export interface GetConceptosPendientesRentaOutput {
    __typename?: "GetConceptosPendientesRentaOutput"
    estancia_pendiente?: Maybe<EstanciaPendienteRentaDetailOutput>
    extras_pendientes: Array<VentaExtraRentaDetailOutput>
}

export interface GetGoogleUserInput {
    client_id: Scalars["String"]["input"]
    token: Scalars["String"]["input"]
}

export interface GetInformeHistorialMovimientosInventarioOutput {
    __typename?: "GetInformeHistorialMovimientosInventarioOutput"
    entradas_insumos: MovimientoInformeDetailOutput
    entradas_productos: MovimientoInformeDetailOutput
    merma: MovimientoInformeDetailOutput
    salidas_insumos: MovimientoInformeDetailOutput
    salidas_venta: MovimientoInformeDetailOutput
}

export interface GetInformeInventarioOutput {
    __typename?: "GetInformeInventarioOutput"
    articulos_agotados: Scalars["Int"]["output"]
    articulos_por_agotarse: Scalars["Int"]["output"]
    cantidad_articulos: Scalars["Int"]["output"]
    costo_total_inventario: Scalars["Float"]["output"]
    valor_comercial: Scalars["Float"]["output"]
}

export interface GetKpisHistorialProduccionesInventarioByArticuloIdOutput {
    __typename?: "GetKpisHistorialProduccionesInventarioByArticuloIdOutput"
    articulo_id: Scalars["String"]["output"]
    costo_total_inventario: Scalars["String"]["output"]
    costo_unitario_promedio: Scalars["String"]["output"]
    fecha_ultima_produccion?: Maybe<Scalars["DateTime"]["output"]>
    produccion_receta: Scalars["String"]["output"]
    unidad: UnidadMedidasArticulo
    unidades_inventario: Scalars["String"]["output"]
}

export interface GetKpisMantenimientoOutput {
    __typename?: "GetKpisMantenimientoOutput"
    habitaciones_bloqueadas: Scalars["Int"]["output"]
    incidencias_cerradas: Scalars["Int"]["output"]
    incidencias_pendientes: Scalars["Int"]["output"]
    total_agua: Scalars["Float"]["output"]
    total_gas: Scalars["Float"]["output"]
    total_luz: Scalars["Float"]["output"]
}

export interface GetLastOrdenOutput {
    __typename?: "GetLastOrdenOutput"
    estado_orden: EstadosOrdenHistorial
    orden?: Maybe<Orden>
    orden_activa: Scalars["Boolean"]["output"]
}

export interface GetMesaDynamicStateOutput {
    __typename?: "GetMesaDynamicStateOutput"
    comanda_activa?: Maybe<Comanda>
    estado_activo?: Maybe<EstadosDinamicosMesa>
}

export interface GetMovementsCountBeforeCorteOutput {
    __typename?: "GetMovementsCountBeforeCorteOutput"
    numero_total_movimientos: Scalars["Float"]["output"]
    suma_total_montos: Scalars["Float"]["output"]
}

export interface GetRentaTransactionsOutput {
    __typename?: "GetRentaTransactionsOutput"
    ordenes?: Maybe<Array<RentaOrdenTransactionItemOutput>>
    renta?: Maybe<Renta>
    transacciones?: Maybe<Array<RentaTransactionItemOutput>>
    transacciones_checkin: Array<RentaTransactionItemOutput>
}

export interface GetReportePropinasOutput {
    __typename?: "GetReportePropinasOutput"
    reporte_propinas: Array<ReportePropinasPorPuestoDetailOutput>
}

export interface GetTodayRentalSales {
    __typename?: "GetTodayRentalSales"
    acumulado_rentas: Array<SalesByTurno>
}

export interface GetTodaySalesInput {
    fecha_final?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_inicial?: InputMaybe<Scalars["DateTime"]["input"]>
    hotel_id: Scalars["ID"]["input"]
}

export interface GetVehiculoDataByPlacaInput {
    /** Placa del vehículo */
    placa: Scalars["String"]["input"]
}

export interface GetVehiculoDataByPlacaOutput {
    __typename?: "GetVehiculoDataByPlacaOutput"
    /** Datos del vehículo */
    vehiculo?: Maybe<Data_Vehiculo>
}

export interface GoogleUserResponse {
    __typename?: "GoogleUserResponse"
    email: Scalars["String"]["output"]
    family_name: Scalars["String"]["output"]
    given_name: Scalars["String"]["output"]
    picture: Scalars["String"]["output"]
}

export interface GroupCortes {
    __typename?: "GroupCortes"
    cortes: Array<Corte>
    fecha: Scalars["DateTime"]["output"]
    total_corte: Scalars["Float"]["output"]
}

export interface GrupoHotel {
    __typename?: "GrupoHotel"
    eliminado: Scalars["Boolean"]["output"]
    estatus: Scalars["String"]["output"]
    grupo_hotel_id: Scalars["ID"]["output"]
    hotel?: Maybe<Hotel>
    nombre_grupo: Scalars["String"]["output"]
    numero_hoteles: Scalars["Int"]["output"]
}

export interface GrupoModificador {
    __typename?: "GrupoModificador"
    descripcion: Scalars["String"]["output"]
    eliminado: Scalars["Boolean"]["output"]
    estado: EstadoGrupoModificador
    grupo_modificador_id: Scalars["ID"]["output"]
    hotel_id: Scalars["ID"]["output"]
    max_seleccion: Scalars["Int"]["output"]
    min_seleccion: Scalars["Int"]["output"]
    modificadores?: Maybe<Array<Modificador>>
    nombre: Scalars["String"]["output"]
    obligatorio: Scalars["Boolean"]["output"]
    tipo_selector: TipoSelector
}

export interface GrupoModificadorWithModificadoresOutput {
    __typename?: "GrupoModificadorWithModificadoresOutput"
    descripcion: Scalars["String"]["output"]
    eliminado: Scalars["Boolean"]["output"]
    estado: EstadoGrupoModificador
    grupo_modificador_id: Scalars["ID"]["output"]
    hotel_id: Scalars["ID"]["output"]
    max_seleccion: Scalars["Int"]["output"]
    min_seleccion: Scalars["Int"]["output"]
    modificadores: Array<ModificadorNestedOutput>
    nombre: Scalars["String"]["output"]
    obligatorio: Scalars["Boolean"]["output"]
    tipo_selector: TipoSelector
}

export interface Habitacion {
    __typename?: "Habitacion"
    /** Retorna la primer incidencia de la habitacion, del tipo indicado en los argumentos */
    alerta_incidencia?: Maybe<Incidencia>
    /** Ultimas tareas de colaborador asignadas a la habitacion */
    colaborador_tarea?: Maybe<Array<ColaboradorTarea>>
    /** Tareas de colaborador asignadas a la habitacion que no han terminado */
    colaborador_tareas_sin_finalizar?: Maybe<Array<ColaboradorTarea>>
    comentario_estado?: Maybe<Scalars["String"]["output"]>
    comentarios?: Maybe<Array<ComentarioHabitacion>>
    eliminado: Scalars["Boolean"]["output"]
    estado: Estados_Habitaciones
    fecha_estado?: Maybe<Scalars["DateTime"]["output"]>
    habitacion_id: Scalars["ID"]["output"]
    /** Información del Hotel de la Habitación */
    hotel: Hotel
    hotel_id: Scalars["ID"]["output"]
    /** Incidencias de la habitacion por tipo de estado */
    incidencias?: Maybe<Array<Incidencia>>
    incidencias_activas?: Maybe<Scalars["Float"]["output"]>
    /** Cantidad de incidencias activas registradas por el usuario para la habitacion */
    incidencias_activas_usuario: Scalars["Float"]["output"]
    numero_habitacion: Scalars["String"]["output"]
    piso: Scalars["String"]["output"]
    posicion?: Maybe<Posicion>
    /** Renta pasada de la habitacion */
    renta_pasada?: Maybe<Renta>
    rentas_today?: Maybe<Scalars["Int"]["output"]>
    reservas_today?: Maybe<Scalars["Int"]["output"]>
    subestado?: Maybe<SubestadosHabitaciones>
    /** Datos asociados al primer registro de colaborador-tarea en curso para la habitacion */
    tarea_en_curso?: Maybe<ColaboradorTarea>
    /** Información del tipo habitación de la Habitación */
    tipo_habitacion?: Maybe<TipoHabitacion>
    tipo_habitacion_id: Scalars["ID"]["output"]
    /** Ultima Renta de la habitacion */
    ultima_renta?: Maybe<Renta>
    /** Ultima reserva de la habitacion */
    ultima_reserva?: Maybe<UltimaReserva>
    ultimas_rentas?: Maybe<Array<Renta>>
    ultimos_datos?: Maybe<DatosHabitacion>
    /** Informacion del Usuario asociado a la habitacion */
    usuario: Usuario
    usuario_id: Scalars["ID"]["output"]
}

export interface HabitacionAlerta_IncidenciaArgs {
    tipo_incidencia?: InputMaybe<Array<TiposIncidencias>>
}

export interface HabitacionIncidenciasArgs {
    estado?: InputMaybe<Estados_Incidencias>
}

export interface HabitacionIncidencias_Activas_UsuarioArgs {
    usuario_id: Scalars["ID"]["input"]
}

export interface HabitacionTicket {
    __typename?: "HabitacionTicket"
    costo: Scalars["Float"]["output"]
    early_checkin: Scalars["Float"]["output"]
    numero: Scalars["String"]["output"]
    tipo: Scalars["String"]["output"]
}

export interface HabitacionesMesasOutput {
    __typename?: "HabitacionesMesasOutput"
    habitaciones: Array<Habitacion>
    mesas: Array<Mesa>
}

export interface HabitacionesNotificacionesConfigOutput {
    __typename?: "HabitacionesNotificacionesConfigOutput"
    ocupacion_maxima_alcanzada: Scalars["Boolean"]["output"]
    sin_habitaciones_disponibles: Scalars["Boolean"]["output"]
}

export interface HasActiveMesaAsignadaOutput {
    __typename?: "HasActiveMesaAsignadaOutput"
    has_mesa_activa: Scalars["Boolean"]["output"]
    mesa_asignada?: Maybe<MesaAsignada>
}

export interface HistorialEstadoComanda {
    __typename?: "HistorialEstadoComanda"
    comanda?: Maybe<Comanda>
    comanda_id: Scalars["ID"]["output"]
    estado_comanda: EstadosComandaHistorial
    fecha_fin: Scalars["DateTime"]["output"]
    fecha_registro: Scalars["DateTime"]["output"]
    historial_estado_comanda_id: Scalars["ID"]["output"]
    hotel_id: Scalars["ID"]["output"]
    tiempo_en_preparacion?: Maybe<Scalars["String"]["output"]>
    tiempo_por_entregar?: Maybe<Scalars["String"]["output"]>
    tiempo_total?: Maybe<Scalars["String"]["output"]>
}

export interface HistorialEstadoOrden {
    __typename?: "HistorialEstadoOrden"
    estado_orden: EstadosOrdenHistorial
    fecha_fin: Scalars["DateTime"]["output"]
    fecha_registro: Scalars["DateTime"]["output"]
    historial_estado_orden_id: Scalars["ID"]["output"]
    hotel_id: Scalars["ID"]["output"]
    orden?: Maybe<Orden>
    orden_id: Scalars["ID"]["output"]
    tiempo_en_entrega?: Maybe<Scalars["String"]["output"]>
    tiempo_en_preparacion?: Maybe<Scalars["String"]["output"]>
    tiempo_por_entregar?: Maybe<Scalars["String"]["output"]>
    tiempo_total?: Maybe<Scalars["String"]["output"]>
}

export interface HistorialHabitacion {
    __typename?: "HistorialHabitacion"
    accion: Scalars["String"]["output"]
    data?: Maybe<HistorialHabitacionData>
    fecha: Scalars["DateTime"]["output"]
    habitacion: Habitacion
    habitacion_id: Scalars["ID"]["output"]
    historial_habitacion_id: Scalars["ID"]["output"]
    hotel?: Maybe<Hotel>
    tipoHabitacion?: Maybe<TipoHabitacion>
    usuario?: Maybe<Usuario>
    usuario_id: Scalars["ID"]["output"]
}

export interface HistorialHabitacionData {
    __typename?: "HistorialHabitacionData"
    comentario_estado?: Maybe<Scalars["String"]["output"]>
    eliminado: Scalars["Boolean"]["output"]
    estado_id?: Maybe<Scalars["ID"]["output"]>
    fecha_estado?: Maybe<Scalars["DateTime"]["output"]>
    hotel_id: Scalars["ID"]["output"]
    numero_habitacion: Scalars["String"]["output"]
    piso: Scalars["String"]["output"]
    subestado?: Maybe<Scalars["String"]["output"]>
    tipo_habitacion_id: Scalars["ID"]["output"]
}

export interface HistorialHabitacionesData {
    comentario_estado?: InputMaybe<Scalars["String"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    estado_id?: InputMaybe<Scalars["ID"]["input"]>
    fecha_estado?: InputMaybe<Scalars["DateTime"]["input"]>
    habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    numero_habitacion?: InputMaybe<Scalars["String"]["input"]>
    piso?: InputMaybe<Scalars["String"]["input"]>
    subestado?: InputMaybe<Scalars["String"]["input"]>
    tipo_habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface HistorialMovimientosInventario {
    __typename?: "HistorialMovimientosInventario"
    almacen_articulo_id?: Maybe<Scalars["String"]["output"]>
    articulo?: Maybe<Articulo>
    articulo_id: Scalars["ID"]["output"]
    cantidad: Scalars["Float"]["output"]
    costo_actual: Scalars["Float"]["output"]
    fecha_registro: Scalars["DateTime"]["output"]
    folio: Scalars["Int"]["output"]
    historial_movimiento_inventario_id: Scalars["ID"]["output"]
    hotel_id: Scalars["ID"]["output"]
    movimiento: MovimientoHistorialInventario
    nombre_articulo: Scalars["String"]["output"]
    /** Almacen(es) de origen y destino dependiendo del tipo de movimiento del historial */
    origen_destino?: Maybe<Scalars["String"]["output"]>
    precio: Scalars["Float"]["output"]
    responsable?: Maybe<Colaborador>
    salida_id?: Maybe<Scalars["ID"]["output"]>
    surtido_id?: Maybe<Scalars["ID"]["output"]>
    tipo: TipoMovimientoHistorialInventario
}

export interface HistorialProduccionInventario {
    __typename?: "HistorialProduccionInventario"
    articulo_id: Scalars["ID"]["output"]
    cantidad_producida: Scalars["Float"]["output"]
    colaborador_id: Scalars["ID"]["output"]
    costo_produccion: Scalars["Float"]["output"]
    costo_unidad_minima_produccion: Scalars["Float"]["output"]
    fecha_produccion: Scalars["DateTime"]["output"]
    folio: Scalars["Int"]["output"]
    historial_produccion_inventario_id: Scalars["ID"]["output"]
    hotel_id: Scalars["ID"]["output"]
    /** Colaborador que autorizo la acción de producción */
    responsable?: Maybe<Colaborador>
    unidad: UnidadMedidasProduccion
}

export interface HistorialVehiculo {
    __typename?: "HistorialVehiculo"
    concepto?: Maybe<Scalars["String"]["output"]>
    fecha_entrada: Scalars["DateTime"]["output"]
    historial_vehiculo_id: Scalars["ID"]["output"]
    hotel_id: Scalars["ID"]["output"]
    motivo_ingreso_id?: Maybe<Scalars["ID"]["output"]>
    renta_id?: Maybe<Scalars["ID"]["output"]>
    turno_id: Scalars["ID"]["output"]
    /** Datos del vehiculo asociado al registro de entrada */
    vehiculo: Vehiculo
    vehiculo_id: Scalars["ID"]["output"]
}

export interface Hotel {
    __typename?: "Hotel"
    calle: Scalars["String"]["output"]
    ciudad: Scalars["String"]["output"]
    colonia: Scalars["String"]["output"]
    /** Configuraciones del hotel */
    configurations?: Maybe<Configurations>
    correo: Scalars["String"]["output"]
    cp: Scalars["String"]["output"]
    /** Sucursal EasyRewards */
    easyrewards_sucursal_id: Scalars["String"]["output"]
    eliminado: Scalars["Boolean"]["output"]
    estado: Scalars["String"]["output"]
    estatus: Scalars["String"]["output"]
    fecha_creacion: Scalars["DateTime"]["output"]
    fecha_modificacion: Scalars["DateTime"]["output"]
    grupo_hotel: GrupoHotel
    grupo_hotel_id: Scalars["ID"]["output"]
    hotel_id: Scalars["ID"]["output"]
    imas_config: ImasConfiguration
    imas_transaccion_status: Scalars["Boolean"]["output"]
    /** Logo del hotel */
    logo_hotel?: Maybe<Scalars["String"]["output"]>
    moneda?: Maybe<Moneda>
    /** ID de la moneda del hotel */
    moneda_id?: Maybe<Scalars["ID"]["output"]>
    nombre_hotel: Scalars["String"]["output"]
    numero_exterior: Scalars["String"]["output"]
    numero_interior: Scalars["String"]["output"]
    razon_social: Scalars["String"]["output"]
    rfc: Scalars["String"]["output"]
    suscripciones?: Maybe<Array<Suscripcion>>
    telefono: Scalars["String"]["output"]
    /** zona horaria del hotel */
    zona_horaria?: Maybe<Scalars["String"]["output"]>
}

export interface HotelColaborador {
    __typename?: "HotelColaborador"
    area_id: Scalars["ID"]["output"]
    colaborador: Colaborador
    colaborador_id: Scalars["ID"]["output"]
    eliminado: Scalars["Boolean"]["output"]
    hotel: Hotel
    hotel_colaborador_id: Scalars["ID"]["output"]
    hotel_id: Scalars["ID"]["output"]
    puesto?: Maybe<Puesto>
    puesto_id: Scalars["ID"]["output"]
}

export interface HotelImage {
    __typename?: "HotelImage"
    hotel_id: Scalars["ID"]["output"]
    imagen_url: Scalars["String"]["output"]
}

export enum HuellaOPin {
    Huella = "huella",
    Pin = "pin",
}

export interface ImageIncidenciaEntity {
    __typename?: "ImageIncidenciaEntity"
    id?: Maybe<Scalars["String"]["output"]>
    imagen?: Maybe<Scalars["String"]["output"]>
}

export interface ImagenIncidenciaInput {
    id?: InputMaybe<Scalars["ID"]["input"]>
    imagen?: InputMaybe<Scalars["String"]["input"]>
}

export interface ImagenPromo {
    __typename?: "ImagenPromo"
    horizontal?: Maybe<Array<Scalars["String"]["output"]>>
    vertical?: Maybe<Array<Scalars["String"]["output"]>>
}

export interface ImagenPromoInput {
    horizontal?: InputMaybe<Array<Scalars["String"]["input"]>>
    vertical?: InputMaybe<Array<Scalars["String"]["input"]>>
}

export interface ImasConfiguration {
    __typename?: "ImasConfiguration"
    iAlmacen: Scalars["Int"]["output"]
    iEmpresa: Scalars["Int"]["output"]
    iSucursal: Scalars["Int"]["output"]
    sBD: Scalars["String"]["output"]
    sLinea: Scalars["String"]["output"]
}

export interface Incidencia {
    __typename?: "Incidencia"
    area?: Maybe<Scalars["String"]["output"]>
    colaborador_cierra?: Maybe<Colaborador>
    colaborador_id_cierra?: Maybe<Scalars["ID"]["output"]>
    colaborador_id_reporta: Scalars["ID"]["output"]
    colaborador_reporta: Colaborador
    comentario_cierre?: Maybe<Scalars["String"]["output"]>
    comentarios: Array<ComentarioIncidenciaEntity>
    detalle: Scalars["String"]["output"]
    estado?: Maybe<Estados_Incidencias>
    fecha_apertura?: Maybe<Scalars["DateTime"]["output"]>
    fecha_cierre?: Maybe<Scalars["DateTime"]["output"]>
    fecha_registro: Scalars["DateTime"]["output"]
    fecha_ultima_apertura?: Maybe<Scalars["DateTime"]["output"]>
    folio: Scalars["Int"]["output"]
    habitacion?: Maybe<Habitacion>
    habitacion_id?: Maybe<Scalars["ID"]["output"]>
    hotel_id: Scalars["ID"]["output"]
    huesped?: Maybe<Scalars["String"]["output"]>
    imagenes?: Maybe<Array<ImageIncidenciaEntity>>
    incidencia_id: Scalars["ID"]["output"]
    matricula?: Maybe<Scalars["String"]["output"]>
    severidad: Scalars["String"]["output"]
    tipo_incidencia?: Maybe<Scalars["String"]["output"]>
    turno: Turno
    turno_id: Scalars["ID"]["output"]
    /** Vehículo asociado a la incidencia mediante la matrícula */
    vehiculo?: Maybe<Data_Vehiculo>
}

export interface IncidenciasNotificacionesConfigOutput {
    __typename?: "IncidenciasNotificacionesConfigOutput"
    incidencias_altas: Scalars["Boolean"]["output"]
}

export interface InclusionSearchInput {
    in?: InputMaybe<Array<Scalars["String"]["input"]>>
    not_in?: InputMaybe<Array<Scalars["String"]["input"]>>
}

export interface IngredienteReceta {
    __typename?: "IngredienteReceta"
    almacen_articulo?: Maybe<AlmacenArticulo>
    almacen_articulo_id: Scalars["ID"]["output"]
    articulo?: Maybe<Articulo>
    cantidad: Scalars["Float"]["output"]
    /** Cantidad equivalente del ingrediente, en la medida de la existencia del articulo */
    cantidad_equivalente: Scalars["Float"]["output"]
    /** Costo equivalente del uso de la cantidad especificada del ingrediente */
    costo_por_cantidad_ingrediente?: Maybe<Scalars["Float"]["output"]>
    /** Resultado entre la cantidad en almacen x el contenido del articulo */
    disponible_inventario: Scalars["Float"]["output"]
    ingrediente_receta_id: Scalars["ID"]["output"]
    receta_id: Scalars["ID"]["output"]
    unidad: UnidadMedidasArticulo
}

export interface IngredienteRecetaInput {
    almacen_articulo_id: Scalars["ID"]["input"]
    cantidad: Scalars["Float"]["input"]
    ingrediente_receta_id?: InputMaybe<Scalars["ID"]["input"]>
    receta_id?: InputMaybe<Scalars["ID"]["input"]>
    unidad: UnidadMedidasArticulo
}

export interface IngresosHotelOutput {
    __typename?: "IngresosHotelOutput"
    desgloce: Array<DataIngresosHotelOutput>
    totales: TotalesHotelOutput
}

export interface IngresosRoomServiceOutput {
    __typename?: "IngresosRoomServiceOutput"
    desgloce: Array<DataRoomService>
    totales: TotalesRoomService
}

export interface ListenDisponibilidadHabitacionesSubOutput {
    __typename?: "ListenDisponibilidadHabitacionesSubOutput"
    disponibilidad_habitaciones?: Maybe<TipoHabitacionSubDetail>
    lista_de_espera?: Maybe<TurnosAtencionSubModesOutput>
}

export interface ListenOrdenesStateSubOutput {
    __typename?: "ListenOrdenesStateSubOutput"
    error_message?: Maybe<Scalars["String"]["output"]>
    orden_en_preparacion?: Maybe<OrdenSubDetail>
    orden_por_entregar?: Maybe<OrdenSubDetail>
    status?: Maybe<Scalars["String"]["output"]>
}

export interface LockHabitacionInput {
    comentario_estado?: InputMaybe<Scalars["String"]["input"]>
    habitacion_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
    tipo_bloqueo_id?: InputMaybe<Scalars["String"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface LoginGoogleInput {
    client_id: Scalars["String"]["input"]
    token: Scalars["String"]["input"]
}

export interface LoginGoogleResponse {
    __typename?: "LoginGoogleResponse"
    expires_in?: Maybe<Scalars["String"]["output"]>
    token: Scalars["ID"]["output"]
    ultimo_hotel_id?: Maybe<Scalars["ID"]["output"]>
    usuario_id?: Maybe<Scalars["ID"]["output"]>
}

export interface LovePointsResponse {
    __typename?: "LovePointsResponse"
    saldo?: Maybe<Scalars["Float"]["output"]>
}

export interface Mantenimiento {
    __typename?: "Mantenimiento"
    agua: Scalars["Float"]["output"]
    colaborador: Colaborador
    colaborador_id: Scalars["ID"]["output"]
    corte: Corte
    corte_id?: Maybe<Scalars["ID"]["output"]>
    fecha_actualizacion?: Maybe<Scalars["DateTime"]["output"]>
    fecha_registro: Scalars["DateTime"]["output"]
    gas: Scalars["Float"]["output"]
    luz: Scalars["Float"]["output"]
    mantenimiento_id: Scalars["ID"]["output"]
    turno: Turno
    turno_id: Scalars["ID"]["output"]
    usuario_id: Scalars["ID"]["output"]
}

export interface MensajePlantilla {
    __typename?: "MensajePlantilla"
    general?: Maybe<Scalars["String"]["output"]>
    habitacion?: Maybe<Scalars["String"]["output"]>
    huesped?: Maybe<Scalars["String"]["output"]>
}

export interface MensajePlantillaPushNotification {
    __typename?: "MensajePlantillaPushNotification"
    general?: Maybe<Scalars["String"]["output"]>
    habitacion?: Maybe<Scalars["String"]["output"]>
    huesped?: Maybe<Scalars["String"]["output"]>
}

export interface Mesa {
    __typename?: "Mesa"
    /** Asignacion actual/en curso de la mesa */
    asignacion_actual?: Maybe<MesaAsignada>
    cantidad_personas: Scalars["Float"]["output"]
    eliminado: Scalars["Boolean"]["output"]
    estado: EstadoMesa
    /** Retorna el estado de la mesa de forma dinámica y la comanda activa para la orden actual de la mesa */
    estado_dinamico?: Maybe<GetMesaDynamicStateOutput>
    fecha_modificacion?: Maybe<Scalars["DateTime"]["output"]>
    fecha_registro: Scalars["DateTime"]["output"]
    hotel_id: Scalars["ID"]["output"]
    mesa_id: Scalars["ID"]["output"]
    motivo_bloqueo?: Maybe<Scalars["String"]["output"]>
    numero_mesa: Scalars["String"]["output"]
    posicion?: Maybe<PosicionMesa>
    /** Asignación mas reciente de la mesa */
    ultima_asignacion?: Maybe<MesaAsignada>
    usuario_modifico_id?: Maybe<Scalars["ID"]["output"]>
}

export interface MesaAsignada {
    __typename?: "MesaAsignada"
    colaborador_asignado_id: Scalars["ID"]["output"]
    /** Colaborador que atendio la mesa */
    colaborador_atendio?: Maybe<Colaborador>
    fecha_cuenta_cerrada?: Maybe<Scalars["DateTime"]["output"]>
    fecha_registro: Scalars["DateTime"]["output"]
    fecha_salida?: Maybe<Scalars["DateTime"]["output"]>
    mesa_asignada_id: Scalars["ID"]["output"]
    mesa_id: Scalars["ID"]["output"]
    /** Orden de la mesa */
    orden?: Maybe<Orden>
    orden_id?: Maybe<Scalars["ID"]["output"]>
}

export interface MetodoDePago {
    __typename?: "MetodoDePago"
    default: Scalars["Boolean"]["output"]
    eliminado: Scalars["Boolean"]["output"]
    estatus: Scalars["String"]["output"]
    metododepago_id: Scalars["ID"]["output"]
    payment_token: Scalars["String"]["output"]
    usuario: Usuario
    usuario_id: Scalars["ID"]["output"]
}

export interface MetodoDePagoInput {
    default: Scalars["Boolean"]["input"]
    payment_token: Scalars["String"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface MetodoDePagoUpdateInput {
    default?: InputMaybe<Scalars["Boolean"]["input"]>
    estatus?: InputMaybe<Scalars["String"]["input"]>
    metododepago_id: Scalars["ID"]["input"]
    payment_token?: InputMaybe<Scalars["String"]["input"]>
}

export interface MetodosPago {
    __typename?: "MetodosPago"
    amex: Scalars["Float"]["output"]
    deposito_o_transferencia: Scalars["Float"]["output"]
    efectivo: Scalars["Float"]["output"]
    visa_o_mastercard: Scalars["Float"]["output"]
}

export interface MetodosPagoTicket {
    __typename?: "MetodosPagoTicket"
    numero_referencia?: Maybe<Scalars["String"]["output"]>
    tipo: Scalars["String"]["output"]
    total: Scalars["Float"]["output"]
    ultimos_digitos?: Maybe<Scalars["String"]["output"]>
}

export enum ModalidadDePago {
    DepositoEnGarantia = "deposito_en_garantia",
    Parcial = "parcial",
    Pendiente = "pendiente",
    Total = "total",
}

export interface Modificador {
    __typename?: "Modificador"
    almacen_articulo_id?: Maybe<Scalars["ID"]["output"]>
    eliminado: Scalars["Boolean"]["output"]
    estado: EstadosModificador
    hotel_id: Scalars["ID"]["output"]
    modificador_id: Scalars["ID"]["output"]
    nombre: Scalars["String"]["output"]
    precio?: Maybe<Scalars["Float"]["output"]>
    tipo_modificador: TiposModificador
}

export interface ModificadorConCantidadInput {
    cantidad: Scalars["Int"]["input"]
    modificador_id: Scalars["ID"]["input"]
}

export interface ModificadorGrupoModificador {
    __typename?: "ModificadorGrupoModificador"
    grupo_modificador_id: Scalars["ID"]["output"]
    modificador_id: Scalars["ID"]["output"]
    modificadores_grupos_modificadores_id: Scalars["ID"]["output"]
}

export interface ModificadorNestedOutput {
    __typename?: "ModificadorNestedOutput"
    almacen_articulo_id?: Maybe<Scalars["ID"]["output"]>
    descripcion?: Maybe<Scalars["String"]["output"]>
    eliminado: Scalars["Boolean"]["output"]
    estado: EstadosModificador
    hotel_id: Scalars["ID"]["output"]
    modificador_id: Scalars["ID"]["output"]
    nombre: Scalars["String"]["output"]
    precio?: Maybe<Scalars["Float"]["output"]>
    tipo_modificador: TiposModificador
}

export interface Modulo {
    __typename?: "Modulo"
    descripcion: Scalars["String"]["output"]
    funcionalidades?: Maybe<Array<Funcionalidad>>
    modulo_id: Scalars["ID"]["output"]
    nombre_modulo: Scalars["String"]["output"]
}

export interface Moneda {
    __typename?: "Moneda"
    clave: Scalars["String"]["output"]
    eliminado: Scalars["Boolean"]["output"]
    icono?: Maybe<Scalars["String"]["output"]>
    moneda_id: Scalars["ID"]["output"]
    nombre: Scalars["String"]["output"]
    simbolo: Scalars["String"]["output"]
}

export interface MonthSearchInput {
    mes_y_anio: Scalars["String"]["input"]
}

export enum Motivo {
    Caducado = "caducado",
    ConsumoInterno = "consumo_interno",
    Faltante = "faltante",
    Merma = "merma",
    Proceso = "proceso",
    Receta = "receta",
    Transferencia = "transferencia",
    Venta = "venta",
}

export interface MotivoIngresoVehiculo {
    __typename?: "MotivoIngresoVehiculo"
    /** Indica si el registro está eliminado */
    eliminado: Scalars["Boolean"]["output"]
    /** Identificador del hotel al que pertenece */
    hotel_id: Scalars["ID"]["output"]
    /** Identificador único del motivo de ingreso de un vehículo */
    motivo_ingreso_id: Scalars["ID"]["output"]
    /** Nombre del motivo de ingreso del vehículo */
    nombre: Scalars["String"]["output"]
}

export enum MovimientoHistorialInventario {
    Entrada = "entrada",
    Salida = "salida",
}

export interface MovimientoInformeDetailOutput {
    __typename?: "MovimientoInformeDetailOutput"
    total: Scalars["Float"]["output"]
    unidades: Scalars["Int"]["output"]
}

export interface Mutation {
    __typename?: "Mutation"
    CheckOut: PartialInfoCheckoutResponseOutput
    abrir_turno: Scalars["String"]["output"]
    abrir_turno_colaborador: Colaborador
    actualizar_almacen: Array<Almacen>
    actualizar_almacen_articulo: Array<AlmacenArticulo>
    actualizar_aportaciones_propinas_por_categoria: Array<CategoriaArticulo>
    actualizar_area: Area
    actualizar_articulo: Articulo
    actualizar_articulo_externo: ArticuloExterno
    actualizar_articulo_grupo_modificador: ArticuloGrupoModificador
    actualizar_asistencia: Asistencia
    actualizar_categoria_articulo: CategoriaArticulo
    actualizar_categoria_gasto: CategoriaGasto
    actualizar_cliente: Cliente
    actualizar_colaborador_turno: Colaborador
    actualizar_colaboradores_tareas: Array<ColaboradorTarea>
    actualizar_comanda: Comanda
    actualizar_comentario_habitacion: Habitacion
    actualizar_configuracion_fajilla: ConfiguracionFajilla
    actualizar_configuracion_inventario: ConfiguracionInventario
    /** Actualiza la configuracion de notificaciones para el usuario en la app mobile */
    actualizar_configuracion_notificaciones?: Maybe<Array<UsuariosNotificacionesConfigOutput>>
    actualizar_configuracion_propina: ConfiguracionPropina
    /** Actualiza el estado de una orden completa, comanda completa o solo de algún detalle-orden */
    actualizar_estado_orden_o_detalle?: Maybe<UpdateEstadoOrdenOrDetalleOutput>
    actualizar_extra: Extra
    actualizar_extra_detalle_orden: Scalars["String"]["output"]
    actualizar_extras_detalle_orden_detalle_orden_id: UpdateExtrasByDetalleOrdenIdResponse
    actualizar_fajilla: Fajilla
    actualizar_gasto: Gastos
    actualizar_grupo_hotel: GrupoHotel
    actualizar_grupo_modificador: GrupoModificador
    actualizar_habitacion: Habitacion
    actualizar_habitacion_en_renta: Renta
    actualizar_habitacion_estado: Habitacion
    actualizar_habitacion_hotel: Habitacion
    actualizar_habitacion_tipoHabitacion: Habitacion
    actualizar_historialHabitacion: HistorialHabitacion
    actualizar_hotel: Hotel
    actualizar_huella: Scalars["String"]["output"]
    actualizar_incidencia: Incidencia
    actualizar_mantenimiento: Mantenimiento
    actualizar_mesa: Mesa
    actualizar_mesa_asignada: MesaAsignada
    actualizar_metodo_de_pago: MetodoDePago
    actualizar_modificador: Modificador
    actualizar_modificador_grupo_modificador: ModificadorGrupoModificador
    actualizar_moneda: Moneda
    actualizar_motivo_ingreso_vehiculo: MotivoIngresoVehiculo
    actualizar_orden: Scalars["String"]["output"]
    actualizar_pago: Pago
    actualizar_personalizacion_ticket: PersonalizacionTicket
    actualizar_posicion_habitacion: Habitacion
    actualizar_posicion_mesa: Mesa
    actualizar_puesto: Puesto
    actualizar_receta: Receta
    actualizar_renta: Renta
    actualizar_reserva: UpdateReservaResponse
    actualizar_rol: Rol
    actualizar_salida_inventario: Salida
    actualizar_servicio: Servicio
    actualizar_subcategoria_producto: SubcategoriaProducto
    actualizar_surtido: Surtido
    actualizar_suscripcion: Suscripcion
    actualizar_tarea: Tarea
    actualizar_tarifa: Tarifa
    actualizar_tipo_bloqueo: TipoBloqueo
    actualizar_tipo_habitacion: TipoHabitacion
    /** Es la actualizacion de la tipo de limpieza de una tarea de colaborador */
    actualizar_tipo_limpieza: Array<ColaboradorTarea>
    actualizar_tipo_mantenimiento: TipoMantenimiento
    actualizar_turno: Turno
    actualizar_turno_atencion: TurnoAtencion
    actualizar_usuario: Usuario
    actualizar_varios_articulos: Scalars["Boolean"]["output"]
    actulizar_subcategoria_gasto: SubcategoriaGasto
    acumula_puntos: LovePointsResponse
    agregar_colaborador_a_hotel: HotelColaborador
    agregar_comentario: Scalars["String"]["output"]
    agregar_comentario_habitacion: Habitacion
    agregar_comentario_renta: Scalars["String"]["output"]
    agregar_comentario_reserva: Scalars["String"]["output"]
    agregar_comentarios_a_tarea: ColaboradorTarea
    agregar_extras_reserva: Array<Scalars["String"]["output"]>
    agregar_horas_renta: AuxPartialInfoRentaResponse
    agregar_hospedajes_renta: AuxPartialInfoRentaResponse
    agregar_imagen_incidencia: Scalars["String"]["output"]
    agregar_personas_renta: AuxPartialInfoRentaResponse
    /** Ajusta/Modifica el monto a pagar por aportaciones de propinas a colaboradores que participan en el esquema de reparticion */
    ajustar_asignacion_propina: AjustarAsignacionPropinaOutput
    asignar_habitacion_a_reserva: Reserva
    autenticar_huella: AuthenticateCredentialOutput
    autorizar_fajilla: Scalars["String"]["output"]
    bloquear_habitacion: Habitacion
    borrar_gasto: Gastos
    /** Elimina de forma física el registro de entrada del vehiculo */
    borrar_historial_vehiculo: Scalars["Boolean"]["output"]
    cambiar_habitacion_reserva: Scalars["String"]["output"]
    cambiar_mesa_asignada: MesaAsignada
    cambiar_tarea_con_estado: Scalars["String"]["output"]
    cambiar_tarea_entre_colaboradores: Scalars["String"]["output"]
    cambiar_tarea_habitacion: Scalars["String"]["output"]
    cambiar_turno: Scalars["String"]["output"]
    cancelar_comanda: CancelComandaOutput
    cancelar_extra: Scalars["String"]["output"]
    /** Permite cancelar una renta completa o parcialmente */
    cancelar_operaciones_renta: CancelOperationsRentaOutput
    /** Cancela una orden completa en base al ID de la misma */
    cancelar_orden?: Maybe<CancelOrdenOutput>
    cancelar_renta: CancelRentaOutput
    cancelar_reserva: CancelReservaResponse
    cerrar_corte?: Maybe<Corte>
    /** Cierra la cuenta de la mesa pero la mesa se mantiene en_servicio */
    cerrar_cuenta_mesa_asignada: MesaAsignada
    cerrar_incidencia: Incidencia
    /** Cierra la cuenta y la asignacion/servicio de la mesa */
    cerrar_mesa_asignada: MesaAsignada
    cerrar_turno: Scalars["String"]["output"]
    cerrar_turno_colaborador: Array<Colaborador>
    changePassword: Scalars["String"]["output"]
    checkIn: Array<Scalars["String"]["output"]>
    crear_almacen: Almacen
    crear_almacen_articulo: AlmacenArticulo
    crear_area: Area
    crear_articulo: Articulo
    crear_articulo_externo: ArticuloExterno
    crear_articulo_grupo_modificador: ArticuloGrupoModificador
    crear_categoria_articulo: CategoriaArticulo
    crear_categoria_gasto: CategoriaGasto
    crear_cliente: Cliente
    crear_colaborador: Colaborador
    crear_colaborador_tarea: Array<ColaboradorTarea>
    crear_colaborador_usuario: Colaborador
    crear_comanda: Comanda
    crear_configuracion_fajilla: ConfiguracionFajilla
    crear_configuracion_inventario: ConfiguracionInventario
    crear_configuracion_propina: ConfiguracionPropina
    /** Registra conceptos de configuracion de corte para el hotel */
    crear_configuraciones_corte: Scalars["Boolean"]["output"]
    /** Crea una llave de autenticacion HTTP de tipo digest_ha1 para autenticar/autorizar peticiones HTTP */
    crear_digest_key: CreateDigestKeyOutput
    crear_extra: Extra
    crear_fajilla: Fajilla
    crear_gasto: CreateGastoResponse
    crear_grupo_hotel: GrupoHotel
    crear_grupo_modificador: GrupoModificador
    crear_habitacion: Habitacion
    crear_hotel: Hotel
    crear_incidencia: Incidencia
    crear_mantenimiento: Mantenimiento
    crear_mesa: Mesa
    crear_mesa_asignada: MesaAsignada
    crear_metodo_de_pago: MetodoDePago
    crear_modificador: Modificador
    crear_modificador_grupo_modificador: ModificadorGrupoModificador
    crear_moneda: Moneda
    crear_motivo_ingreso_vehiculo: MotivoIngresoVehiculo
    crear_orden: CreateOrdenResponse
    crear_orden_integracion_directa: CreateOrdenIntegrationResponseEntity
    crear_orden_parcial_lovepoints: CreateOrdenResponse
    crear_personalizacion_ticket: PersonalizacionTicket
    /** Genera las salidas de insumos/ingredientes del proceso y la produccion resultante se surte al almacen destino */
    crear_produccion_proceso: CreateProductionProcesoOutput
    crear_propina: Propina
    crear_puesto: Puesto
    crear_receta: Receta
    crear_renta: CreateRentaResponse
    crear_renta_integracion: CreateRentaResponse
    crear_reserva: CreateReservaResponse
    crear_rol: Rol
    crear_salida_inventario: Salida
    crear_servicio: Servicio
    crear_subcategoria_gasto: SubcategoriaGasto
    crear_subcategoria_producto: SubcategoriaProducto
    crear_surtido: Surtido
    /** Crea "n" registros de surtidos para "n" almacenes */
    crear_surtidos: CreateManySurtidosOutput
    crear_suscripcion: Suscripcion
    crear_tarea: Tarea
    crear_tarifa: Tarifa
    crear_tipo_bloqueo: TipoBloqueo
    crear_tipo_habitacion: TipoHabitacion
    crear_tipo_mantenimiento: TipoMantenimiento
    crear_turno: Turno
    crear_turno_atencion: TurnoAtencion
    crear_usuario: Usuario
    createPagoRenta: PagosRentas
    createPagosReservas: Array<PagosReservas>
    create_api_key: CreateApiKeyOutput
    create_orden_integration: CreateOrdenIntegrationResponseEntity
    deleteApiKey: Scalars["String"]["output"]
    descuenta_puntos: LovePointsResponse
    devolucion_orden: Orden
    editar_colaborador: Colaborador
    /** Permite editar los detalles de la comanda, incluyendo sus extras */
    editar_comanda: Comanda
    /** Modifica las configuraciones de cortes en base a la clave primaria */
    editar_configuraciones_corte: Scalars["Boolean"]["output"]
    /** Permite modificar los datos del vehiculo registrado para la renta */
    editar_datos_vehiculo: VehiculoDataEditDetailOutput
    /** Edita los datos de registro de entrada de vehiculo */
    editar_historial_vehiculo: Scalars["Boolean"]["output"]
    /** Edita el metodo de pago del ticket y sus registros asociados (detalle-pago, propina, reporte_propinas) */
    editar_metodo_pago: EditMetodoPagoTicketOutput
    /** Permite editar los detalles de la orden, incluyendo sus extras */
    editar_orden: Orden
    eliminar_almacen: Scalars["String"]["output"]
    eliminar_almacen_articulo: Scalars["String"]["output"]
    eliminar_area: Scalars["String"]["output"]
    eliminar_articulo: Scalars["String"]["output"]
    eliminar_articulo_externo: Scalars["String"]["output"]
    eliminar_articulo_grupo_modificador: Scalars["String"]["output"]
    eliminar_categoria_articulo: CategoriaArticulo
    eliminar_categoria_gasto: CategoriaGasto
    eliminar_cliente: Cliente
    eliminar_colaborador: Colaborador
    eliminar_colaborador_de_hotel: HotelColaborador
    eliminar_colaborador_tarea: ColaboradorTarea
    eliminar_comanda: Scalars["String"]["output"]
    eliminar_comentario_habitacion: Habitacion
    eliminar_configuracion_fajilla: Scalars["String"]["output"]
    eliminar_grupo_modificador: Scalars["String"]["output"]
    eliminar_habitacion: Scalars["String"]["output"]
    eliminar_hotel: Scalars["Boolean"]["output"]
    eliminar_huella: Scalars["String"]["output"]
    eliminar_huella_pin: Scalars["String"]["output"]
    eliminar_imagen_incidencia: Scalars["String"]["output"]
    eliminar_mantenimiento: Scalars["Boolean"]["output"]
    eliminar_mesa: Scalars["String"]["output"]
    eliminar_metodo_de_pago: Scalars["Boolean"]["output"]
    eliminar_modificador: Scalars["String"]["output"]
    eliminar_modificador_grupo_modificador: Scalars["String"]["output"]
    eliminar_moneda: Moneda
    eliminar_motivo_ingreso_vehiculo: MotivoIngresoVehiculo
    eliminar_propina: Propina
    eliminar_puesto: Puesto
    eliminar_receta: Scalars["String"]["output"]
    eliminar_rol: Rol
    eliminar_salida_inventario: Salida
    eliminar_servicio: Servicio
    eliminar_subcategoria_gasto: SubcategoriaGasto
    eliminar_subcategoria_producto: SubcategoriaProducto
    eliminar_suscripcion: Suscripcion
    eliminar_tarea: Tarea
    eliminar_tarifa: Tarifa
    eliminar_tipo_bloqueo: TipoBloqueo
    eliminar_tipo_habitacion: TipoHabitacion
    eliminar_tipo_mantenimiento: TipoMantenimiento
    eliminar_turno: Scalars["String"]["output"]
    eliminar_turno_atencion: Scalars["String"]["output"]
    eliminar_usuario: Scalars["Boolean"]["output"]
    liberar_habitacion: Habitacion
    login: AuthLoginResponse
    login_google: LoginGoogleResponse
    login_huella: FingerPrintLoginOutput
    logout: Scalars["String"]["output"]
    marcar_como_leida: Scalars["Boolean"]["output"]
    /** Esquema de repartición de porcentaje de propinas que corresponde a cada puesto */
    modificar_esquema_propinas: Array<Puesto>
    obtener_usuario_google: GoogleUserResponse
    pagar_extra: PagoExtra
    pagar_ordenes_pendientes: Array<Scalars["String"]["output"]>
    /** Registro de pagos de propinas y generación del gasto correspondiente al pago */
    pagar_propinas: Array<PagoPropina>
    /** Realiza el pago de propinas por ventas y retorna el id del reporte creado y almacenado */
    pagar_propinas_ventas: PayPropinasVentasOutput
    pagar_renta: Array<Scalars["String"]["output"]>
    pagar_reserva: Array<Scalars["String"]["output"]>
    pendiente_autorizar_fajilla: Scalars["String"]["output"]
    reabrir_incidencia: Incidencia
    rechazar_fajilla: Scalars["String"]["output"]
    /** Registra eventos en el historial de login */
    registrar_evento_login: Scalars["Boolean"]["output"]
    registrar_huella: Scalars["String"]["output"]
    /** Registra/Actualiza un dispositivo del usuario donde tenga instancia de la app */
    registrar_usuario_dispositivo: Scalars["Boolean"]["output"]
    /** Deshace las operaciones por ajustes en el pago de propinas */
    reiniciar_asignaciones_propinas: Scalars["Boolean"]["output"]
    /** Remueve el puesto indicado del esquema de repartición de propinas */
    remover_puesto_esquema_propinas: Puesto
    remover_reserva_de_habitacion: Scalars["String"]["output"]
    sendChangePasswordViaEmail: Scalars["String"]["output"]
    sendNotificationCaratulaMensual: Scalars["String"]["output"]
    sincronizar_inventarios_imas: Scalars["String"]["output"]
    /** Transfiere articulos de "n" almacenes origen a "n" almacenes destino */
    transferir_articulos: TransferArticulosOutput
    updateApiKey: Scalars["String"]["output"]
    updatePagoRenta: PagosRentas
    updatePagosReservas: PagosReservas
    /**
     *
     *     Valida si el usuario esta autorizado para ejecutar ciertas operaciones
     *     a traves del codigo de autorizacion o huella.
     *     Si es administrador se salta la validacion.
     */
    validar_codigo_huella_autorizacion: ValidarCodigoAutorizacionOutput
}

export interface MutationCheckOutArgs {
    checkOutInput: CheckOutInput
}

export interface MutationAbrir_TurnoArgs {
    open_turno_input: OpenTurnoInput
}

export interface MutationAbrir_Turno_ColaboradorArgs {
    turnOnTurnoColaboradorInput: TurnOnTurnoColaboradorInput
}

export interface MutationActualizar_AlmacenArgs {
    updateAlmacenInput: UpdateAlmacenInput
}

export interface MutationActualizar_Almacen_ArticuloArgs {
    updateAlmacenArticuloInput: UpdateAlmacenesArticulosInput
}

export interface MutationActualizar_Aportaciones_Propinas_Por_CategoriaArgs {
    aportaciones_roomservice: UpdateAportacionesPropinasRsInput
}

export interface MutationActualizar_AreaArgs {
    actualizar_area_input: UpdateAreaInput
}

export interface MutationActualizar_ArticuloArgs {
    updateArticuloInput: UpdateArticuloInput
}

export interface MutationActualizar_Articulo_ExternoArgs {
    updateArticuloExternoInput: UpdateArticuloExternoInput
}

export interface MutationActualizar_Articulo_Grupo_ModificadorArgs {
    updateArticuloGrupoModificadorInput: UpdateArticuloGrupoModificadorInput
}

export interface MutationActualizar_AsistenciaArgs {
    datos_asistencia: UpdateAsistenciaInput
}

export interface MutationActualizar_Categoria_ArticuloArgs {
    datos_categoria: UpdateCategoriaArticuloInput
}

export interface MutationActualizar_Categoria_GastoArgs {
    categoria_gasto_data: UpdateCategoriaGastosInput
}

export interface MutationActualizar_ClienteArgs {
    datos_cliente: UpdateClienteInput
}

export interface MutationActualizar_Colaborador_TurnoArgs {
    updateColaboradorTurnoInput: UpdateColaboradorTurnoInput
}

export interface MutationActualizar_Colaboradores_TareasArgs {
    datos_tarea: CloseTaskInput
}

export interface MutationActualizar_ComandaArgs {
    UpdateComandaInput: UpdateComandaInput
}

export interface MutationActualizar_Comentario_HabitacionArgs {
    actualizar_comentario_habitacion_input: UpdateComentarioHabitacionInput
}

export interface MutationActualizar_Configuracion_FajillaArgs {
    actualizar_configuracion_fajilla_input: UpdateConfiguracionFajillaInput
}

export interface MutationActualizar_Configuracion_InventarioArgs {
    update_configuracion_inventario: UpdateConfiguracionInventarioInput
}

export interface MutationActualizar_Configuracion_NotificacionesArgs {
    configNotificacionesInput: UpdateUsuariosNotificacionesInput
}

export interface MutationActualizar_Configuracion_PropinaArgs {
    UpdateConfiguracionPropinaInput: UpdateConfiguracionPropinaInput
}

export interface MutationActualizar_Estado_Orden_O_DetalleArgs {
    update_estado_data: UpdateEstadoOrdenOrDetalleInput
    usuario_autorizo_id?: InputMaybe<Scalars["String"]["input"]>
}

export interface MutationActualizar_ExtraArgs {
    actualizar_extra_input: UpdateExtraInput
}

export interface MutationActualizar_Extra_Detalle_OrdenArgs {
    updateExtraDetalleOrdenInput: UpdateExtraDetalleOrdenInput
}

export interface MutationActualizar_Extras_Detalle_Orden_Detalle_Orden_IdArgs {
    updateExtrasByDetalleOrdenIdInput: UpdateExtrasByDetalleOrdenIdRequest
}

export interface MutationActualizar_FajillaArgs {
    actualizar_fajilla_input: UpdateFajillaInput
}

export interface MutationActualizar_GastoArgs {
    datos_gastos: UpdateGastoInput
}

export interface MutationActualizar_Grupo_HotelArgs {
    actualizar_grupo_hotel_input: UpdateGrupoHotelInput
}

export interface MutationActualizar_Grupo_ModificadorArgs {
    updateGrupoModificadorInput: UpdateGrupoModificadorInput
}

export interface MutationActualizar_HabitacionArgs {
    actualizar_habitacion_input: UpdateHabitacionInput
}

export interface MutationActualizar_Habitacion_En_RentaArgs {
    datos_renta: UpdateHabitacionInRentaInput
}

export interface MutationActualizar_Habitacion_EstadoArgs {
    actualizar_habitacion_estado_input: UpdateEstadoHabitacionInput
}

export interface MutationActualizar_Habitacion_HotelArgs {
    actualizar_habitacion_hotel_input: UpdateHabitacionHotelInput
}

export interface MutationActualizar_Habitacion_TipoHabitacionArgs {
    actualizar_habitacion_tipoHabitacion_input: UpdateHabitacionTipoHabitacionInput
}

export interface MutationActualizar_HistorialHabitacionArgs {
    datos_historialHabitacion: UpdateHistorialHabitacionDto
}

export interface MutationActualizar_HotelArgs {
    datos_hotel: UpdateHotelInput
}

export interface MutationActualizar_HuellaArgs {
    UpdateCredencialInput: UpdateCredencialInput
}

export interface MutationActualizar_IncidenciaArgs {
    updateIncidenciaInput: UpdateIncidenciaInput
}

export interface MutationActualizar_MantenimientoArgs {
    datos_mantenimiento: UpdateMantenimientoInput
}

export interface MutationActualizar_MesaArgs {
    UpdateMesaInput: UpdateMesaInput
    usuario_autorizo_id?: InputMaybe<Scalars["String"]["input"]>
}

export interface MutationActualizar_Mesa_AsignadaArgs {
    UpdateMesaAsignadaInput: UpdateMesaAsignadaInput
    usuario_autorizo_id?: InputMaybe<Scalars["String"]["input"]>
}

export interface MutationActualizar_Metodo_De_PagoArgs {
    datos_metodos_de_pago: MetodoDePagoUpdateInput
}

export interface MutationActualizar_ModificadorArgs {
    updateModificadorInput: UpdateModificadorInput
}

export interface MutationActualizar_Modificador_Grupo_ModificadorArgs {
    updateModificadorGrupoModificadorInput: UpdateModificadorGrupoModificadorInput
}

export interface MutationActualizar_MonedaArgs {
    actualizar_moneda_input: UpdateMonedaInput
}

export interface MutationActualizar_Motivo_Ingreso_VehiculoArgs {
    datos_motivo_ingreso: UpdateMotivoIngresoVehiculoDto
}

export interface MutationActualizar_OrdenArgs {
    UpdateOrdenInput: UpdateOrdenInput
}

export interface MutationActualizar_PagoArgs {
    actualizar_pago_input: UpdatePagoInput
}

export interface MutationActualizar_Personalizacion_TicketArgs {
    datos: UpdatePersonalizacionTicketInput
}

export interface MutationActualizar_Posicion_HabitacionArgs {
    updatePosicionHabitacionRequest: UpdatePosicionHabitacionInput
}

export interface MutationActualizar_Posicion_MesaArgs {
    updatePosicionMesaRequest: UpdatePosicionMesaInput
}

export interface MutationActualizar_PuestoArgs {
    datos_puesto: UpdatePuestoInput
}

export interface MutationActualizar_RecetaArgs {
    updateRecetaInput: UpdateRecetaInput
}

export interface MutationActualizar_RentaArgs {
    datos_renta: UpdateRentaInput
}

export interface MutationActualizar_ReservaArgs {
    actualizar_reserva_input: UpdateReservaInput
}

export interface MutationActualizar_RolArgs {
    datos_rol: UpdateRolInput
}

export interface MutationActualizar_Salida_InventarioArgs {
    updateSalidaInput: UpdateSalidaInput
}

export interface MutationActualizar_ServicioArgs {
    datos_servicio: UpdateServicioInput
}

export interface MutationActualizar_Subcategoria_ProductoArgs {
    datos_subcategoria: UpdateSubcategoriaProductoInput
}

export interface MutationActualizar_SurtidoArgs {
    updateSurtidoInput: UpdateSurtidoInput
}

export interface MutationActualizar_SuscripcionArgs {
    datos_suscripcion: UpdateSuscripcionInput
}

export interface MutationActualizar_TareaArgs {
    datos_tarea: UpdateTareaInput
}

export interface MutationActualizar_TarifaArgs {
    datos_tarifa: UpdateTarifaDto
}

export interface MutationActualizar_Tipo_BloqueoArgs {
    datos_tipo_bloqueo: UpdateTipoBloqueoDto
}

export interface MutationActualizar_Tipo_HabitacionArgs {
    datos_tipo_habitacion: UpdateTipoHabitacionDto
}

export interface MutationActualizar_Tipo_LimpiezaArgs {
    updateTipoLimpiezaInput: UpdateTipoLimpiezaInput
}

export interface MutationActualizar_Tipo_MantenimientoArgs {
    datos_tipo_mantenimiento: UpdateTipoMantenimientoDto
}

export interface MutationActualizar_TurnoArgs {
    actualizar_turno_input: UpdateTurnoInput
}

export interface MutationActualizar_Turno_AtencionArgs {
    actualizar_turno_atencion_input: UpdateTurnoAtencionInput
}

export interface MutationActualizar_UsuarioArgs {
    datos_usuario: UpdateUsuarioInput
}

export interface MutationActualizar_Varios_ArticulosArgs {
    datos_articulos: UpdateArticulosInput
}

export interface MutationActulizar_Subcategoria_GastoArgs {
    subcategoria_gasto_data: UpdateSubcategoriaGastosInput
}

export interface MutationAcumula_PuntosArgs {
    AcumulaPuntosInput: AcumulaPuntosInput
}

export interface MutationAgregar_Colaborador_A_HotelArgs {
    datos_hotel_colaborador: AddColaboradorInHotelInput
}

export interface MutationAgregar_ComentarioArgs {
    addComentarioInput: AddComentarioIncidenciaInput
}

export interface MutationAgregar_Comentario_HabitacionArgs {
    agregar_comentario_habitacion_input: AddComentarioHabitacionInput
}

export interface MutationAgregar_Comentario_RentaArgs {
    AddComentarioRentaInput: AddComentarioRentaInput
}

export interface MutationAgregar_Comentario_ReservaArgs {
    AddComentarioReservaInput: AddComentarioReservaInput
}

export interface MutationAgregar_Comentarios_A_TareaArgs {
    comentarios: AddCommentToTaskInput
}

export interface MutationAgregar_Extras_ReservaArgs {
    add_extras_reserva_input: AddExtrasReservaInput
}

export interface MutationAgregar_Horas_RentaArgs {
    AddHorasExtrasRentaInput: AddHorasExtrasRentaInput
}

export interface MutationAgregar_Hospedajes_RentaArgs {
    AddHospedajesExtrasRentaInput: AddHospedajesExtrasRentaInput
}

export interface MutationAgregar_Imagen_IncidenciaArgs {
    addImageInput: AddImageInput
}

export interface MutationAgregar_Personas_RentaArgs {
    AddPersonasExtrasRentaInput: AddPersonasExtrasRentaInput
}

export interface MutationAjustar_Asignacion_PropinaArgs {
    ajustarAsignacionPropinaInput: AjustarAsignacionPropinaInput
}

export interface MutationAsignar_Habitacion_A_ReservaArgs {
    datos_reserva: AddRoomToBookingInput
}

export interface MutationAutenticar_HuellaArgs {
    AuthenticateCredencialInput: AuthenticateCredencialInput
}

export interface MutationAutorizar_FajillaArgs {
    autorizar_fajilla_input: AutorizarFajillaInput
}

export interface MutationBloquear_HabitacionArgs {
    bloquear_habitacion_input: LockHabitacionInput
    codigo?: InputMaybe<Scalars["String"]["input"]>
    template_sample?: InputMaybe<Scalars["String"]["input"]>
}

export interface MutationBorrar_GastoArgs {
    datos_gasto: DeleteGastoInput
}

export interface MutationBorrar_Historial_VehiculoArgs {
    historial_vehiculo_id: Scalars["ID"]["input"]
}

export interface MutationCambiar_Habitacion_ReservaArgs {
    cambiar_habitacion_reserva_input: ChangeHabitacionReservaInput
}

export interface MutationCambiar_Mesa_AsignadaArgs {
    CambiarMesaAsignadaInput: CambiarMesaAsignadaInput
    codigo?: InputMaybe<Scalars["String"]["input"]>
    template_sample?: InputMaybe<Scalars["String"]["input"]>
}

export interface MutationCambiar_Tarea_Con_EstadoArgs {
    switch_task_with_room_state_input: SwitchTaskWithRoomStateInput
}

export interface MutationCambiar_Tarea_Entre_ColaboradoresArgs {
    switch_task_btw_colab_input: SwitchTaskBtwColabInput
}

export interface MutationCambiar_Tarea_HabitacionArgs {
    switch_task_room_input: SwitchTaskRoomInput
}

export interface MutationCambiar_TurnoArgs {
    cambiar_turno_input: ChangeTurnoInput
}

export interface MutationCancelar_ComandaArgs {
    CancelComandaInput: CancelComandaInput
}

export interface MutationCancelar_ExtraArgs {
    cancelar_extra_input: CancelExtraInput
}

export interface MutationCancelar_Operaciones_RentaArgs {
    cancelar_renta_input: CancelOperationsRentaInput
}

export interface MutationCancelar_OrdenArgs {
    cancel_orden_input: CancelOrdenInput
}

export interface MutationCancelar_RentaArgs {
    cancelar_renta_input: CancelRentaInput
    codigo?: InputMaybe<Scalars["String"]["input"]>
}

export interface MutationCancelar_ReservaArgs {
    cancelar_reserva_input: CancelReservaInput
    codigo?: InputMaybe<Scalars["String"]["input"]>
    template_sample?: InputMaybe<Scalars["String"]["input"]>
}

export interface MutationCerrar_CorteArgs {
    datos_corte: CloseCorteInput
    hotel_id: Scalars["ID"]["input"]
}

export interface MutationCerrar_Cuenta_Mesa_AsignadaArgs {
    cerrarCuentaMesaAsignadaInput: CloseBillMesaAsignadaInput
    usuario_autorizo_id?: InputMaybe<Scalars["String"]["input"]>
}

export interface MutationCerrar_IncidenciaArgs {
    closeIncidenciaInput: CloseIncidenciaInput
}

export interface MutationCerrar_Mesa_AsignadaArgs {
    closeMesaAsignadInput: CloseMesaAsignadInput
    usuario_autorizo_id?: InputMaybe<Scalars["String"]["input"]>
}

export interface MutationCerrar_TurnoArgs {
    close_turno_input: CloseTurnoInput
}

export interface MutationCerrar_Turno_ColaboradorArgs {
    turnOffColaboradorInput: TurnOffTurnoColaboradoresInput
}

export interface MutationChangePasswordArgs {
    changePasswordInput: ChangePasswordInput
}

export interface MutationCheckInArgs {
    ChekInInput: CheckInInput
}

export interface MutationCrear_AlmacenArgs {
    createAlmacenInput: CreateAlmacenInput
}

export interface MutationCrear_Almacen_ArticuloArgs {
    createAlmacenArticuloInput: CreateAlmacenArticuloInput
}

export interface MutationCrear_AreaArgs {
    crear_area_input: CreateAreaInput
}

export interface MutationCrear_ArticuloArgs {
    createArticuloInput: CreateArticuloInput
}

export interface MutationCrear_Articulo_ExternoArgs {
    createArticuloExternoInput: CreateArticuloExternoInput
}

export interface MutationCrear_Articulo_Grupo_ModificadorArgs {
    createArticuloGrupoModificadorInput: CreateArticuloGrupoModificadorInput
}

export interface MutationCrear_Categoria_ArticuloArgs {
    datos_categoria: CreateCategoriaArticuloInput
}

export interface MutationCrear_Categoria_GastoArgs {
    categoria_gasto_data: CreateCategoriasGastosInput
}

export interface MutationCrear_ClienteArgs {
    datos_cliente: CreateClienteInput
}

export interface MutationCrear_ColaboradorArgs {
    datos_colaborador: CreateColaboradorInput
}

export interface MutationCrear_Colaborador_TareaArgs {
    datos_colaborador_tarea: CreateColaboradorTareaInput
}

export interface MutationCrear_Colaborador_UsuarioArgs {
    datos_colaborador: CreateColaboradorUsuarioInput
}

export interface MutationCrear_ComandaArgs {
    CreateComandaInput: CreateComandaInput
}

export interface MutationCrear_Configuracion_FajillaArgs {
    crear_configuracion_fajilla_input: CreateConfiguracionFajillaInput
}

export interface MutationCrear_Configuracion_InventarioArgs {
    create_configuracion_inventario: CreateConfiguracionInventarioInput
}

export interface MutationCrear_Configuracion_PropinaArgs {
    CreateConfiguracionPropinaInput: CreateConfiguracionPropinaInput
}

export interface MutationCrear_Configuraciones_CorteArgs {
    input: CreateConfiguracionesCorteInput
}

export interface MutationCrear_Digest_KeyArgs {
    input: CreateDigestKeyInput
}

export interface MutationCrear_ExtraArgs {
    crear_extra_input: CreateExtraInput
}

export interface MutationCrear_FajillaArgs {
    crear_fajilla_input: CreateFajillaInput
}

export interface MutationCrear_GastoArgs {
    datos_gastos: CreateGastoInput
}

export interface MutationCrear_Grupo_HotelArgs {
    crear_grupo_hotel_input: CreateGrupoHotelInput
}

export interface MutationCrear_Grupo_ModificadorArgs {
    createGrupoModificadorInput: CreateGrupoModificadorInput
}

export interface MutationCrear_HabitacionArgs {
    crear_habitacion_input: CreateHabitacionInput
}

export interface MutationCrear_HotelArgs {
    datos_hotel: CreateHotelInput
}

export interface MutationCrear_IncidenciaArgs {
    createIncidenciaInput: CreateIncidenciaInput
}

export interface MutationCrear_MantenimientoArgs {
    datos_mantenimiento: CreateMantenimientoInput
}

export interface MutationCrear_MesaArgs {
    CreateMesaInput: CreateMesaInput
}

export interface MutationCrear_Mesa_AsignadaArgs {
    CreateMesaAsignadaInput: CreateMesaAsignadaInput
}

export interface MutationCrear_Metodo_De_PagoArgs {
    datos_metodo_de_pago: MetodoDePagoInput
}

export interface MutationCrear_ModificadorArgs {
    createModificadorInput: CreateModificadorInput
}

export interface MutationCrear_Modificador_Grupo_ModificadorArgs {
    createModificadorGrupoModificadorInput: CreateModificadorGrupoModificadorInput
}

export interface MutationCrear_MonedaArgs {
    crear_moneda_input: CreateMonedaInput
}

export interface MutationCrear_Motivo_Ingreso_VehiculoArgs {
    datos_motivo_ingreso: CreateMotivoIngresoVehiculoDto
}

export interface MutationCrear_OrdenArgs {
    create_orden_input: CreateOrdenInput
    template_sample?: InputMaybe<Scalars["String"]["input"]>
    usuario_autorizo_id?: InputMaybe<Scalars["String"]["input"]>
}

export interface MutationCrear_Orden_Integracion_DirectaArgs {
    input: CreateOrdenIntegracionDirectaInput
}

export interface MutationCrear_Orden_Parcial_LovepointsArgs {
    create_orden_input: CreateOrdenInput
    template_sample?: InputMaybe<Scalars["String"]["input"]>
    usuario_autorizo_id?: InputMaybe<Scalars["String"]["input"]>
}

export interface MutationCrear_Personalizacion_TicketArgs {
    datos: CreatePersonalizacionTicketInput
}

export interface MutationCrear_Produccion_ProcesoArgs {
    createProductionProceso: CreateProductionProcesoInput
}

export interface MutationCrear_PropinaArgs {
    CreatePropinaInput: CreatePropinaInput
}

export interface MutationCrear_PuestoArgs {
    datos_puesto: CreatePuestoInput
}

export interface MutationCrear_RecetaArgs {
    createRecetaInput: CreateRecetaInput
}

export interface MutationCrear_RentaArgs {
    datos_renta: CreateRentaInput
}

export interface MutationCrear_Renta_IntegracionArgs {
    datos_renta: CreateRentaIntegracionInput
}

export interface MutationCrear_ReservaArgs {
    crear_reserva_input: CreateReservaInput
}

export interface MutationCrear_RolArgs {
    datos_rol: CreateRolInput
}

export interface MutationCrear_Salida_InventarioArgs {
    createSalidaInput: CreateSalidaInput
}

export interface MutationCrear_ServicioArgs {
    datos_servicio: CreateServicioInput
}

export interface MutationCrear_Subcategoria_GastoArgs {
    subcategoria_gasto_data: CreateSubcategoriasGastosInput
}

export interface MutationCrear_Subcategoria_ProductoArgs {
    datos_subcategoria: CreateSubcategoriaProductoInput
}

export interface MutationCrear_SurtidoArgs {
    createSurtidoInput: CreateSurtidoInput
}

export interface MutationCrear_SurtidosArgs {
    createManySurtidosInput: CreateManySurtidosInput
}

export interface MutationCrear_SuscripcionArgs {
    datos_suscripcion: CreateSuscripcionInput
}

export interface MutationCrear_TareaArgs {
    datos_tarea: CreateTareaInput
}

export interface MutationCrear_TarifaArgs {
    datos_tarifa: CreateTarifaDto
}

export interface MutationCrear_Tipo_BloqueoArgs {
    datos_tipo_bloqueo: CreateTipoBloqueoDto
}

export interface MutationCrear_Tipo_HabitacionArgs {
    datos_tipo_habitacion: CreateTipoHabitacionDto
}

export interface MutationCrear_Tipo_MantenimientoArgs {
    datos_tipo_mantenimiento: CreateTipoMantenimientoDto
}

export interface MutationCrear_TurnoArgs {
    crear_turno_input: CreateTurnoInput
}

export interface MutationCrear_Turno_AtencionArgs {
    crear_turno_atencion_input: CreateTurnoAtencionInput
}

export interface MutationCrear_UsuarioArgs {
    datos_usuario: CreateUsuarioInput
}

export interface MutationCreatePagoRentaArgs {
    pago_renta_data: CreatePagoRentaInput
}

export interface MutationCreatePagosReservasArgs {
    pagos_reserva_data: CreatePagoReservaInput
}

export interface MutationCreate_Api_KeyArgs {
    createApiKeyInput: CreateApiKeyInput
}

export interface MutationCreate_Orden_IntegrationArgs {
    input: CreateOrdenIntegrationInput
}

export interface MutationDeleteApiKeyArgs {
    deleteApiKeyInput: DeleteApiKeyInput
}

export interface MutationDescuenta_PuntosArgs {
    DescuentaPuntosInput: DescuentaPuntosInput
}

export interface MutationDevolucion_OrdenArgs {
    refund_orden_input: RefundOrdenInput
}

export interface MutationEditar_ColaboradorArgs {
    datos_colaborador: UpdateColaboradorInput
}

export interface MutationEditar_ComandaArgs {
    editComandaInput: EditComandaInput
}

export interface MutationEditar_Configuraciones_CorteArgs {
    input: EditConfiguracionesCorteInput
}

export interface MutationEditar_Datos_VehiculoArgs {
    EditVehiculoDataInput: EditVehiculoDataInput
}

export interface MutationEditar_Historial_VehiculoArgs {
    input: UpdateHistorialVehiculoInput
}

export interface MutationEditar_Metodo_PagoArgs {
    editMetodoPagoTicketInput: EditMetodoPagoTicketInput
}

export interface MutationEditar_OrdenArgs {
    EditOrdenInput: EditOrdenInput
}

export interface MutationEliminar_AlmacenArgs {
    deleteAlmacenInput: DeleteAlmacenInput
}

export interface MutationEliminar_Almacen_ArticuloArgs {
    deleteAlmacenArticuloInput: DeleteAlmacenesArticulosInput
}

export interface MutationEliminar_AreaArgs {
    eliminar_area_input: DeleteAreaInput
}

export interface MutationEliminar_ArticuloArgs {
    deleteArticuloInput: DeleteArticuloInput
}

export interface MutationEliminar_Articulo_ExternoArgs {
    deleteArticuloExternoInput: DeleteArticuloExternoInput
}

export interface MutationEliminar_Articulo_Grupo_ModificadorArgs {
    deleteArticuloGrupoModificadorInput: DeleteArticuloGrupoModificadorInput
}

export interface MutationEliminar_Categoria_ArticuloArgs {
    datos_categoria: DeleteCategoriaArticuloInput
}

export interface MutationEliminar_Categoria_GastoArgs {
    categoria_gasto_data: DeleteCategoriaGastosInput
}

export interface MutationEliminar_ClienteArgs {
    cliente: DeleteClienteInput
}

export interface MutationEliminar_ColaboradorArgs {
    colaborador: DeleteColaboradorInput
}

export interface MutationEliminar_Colaborador_De_HotelArgs {
    datos_hotel_colaborador: RemoveColaboradorFromHotelInput
}

export interface MutationEliminar_Colaborador_TareaArgs {
    colaborador_tarea: DeleteColaboradorTareaInput
}

export interface MutationEliminar_ComandaArgs {
    DeleteComandaInput: DeleteComandaInput
}

export interface MutationEliminar_Comentario_HabitacionArgs {
    eliminar_comentario_habitacion_input: DeleteComentarioHabitacionInput
}

export interface MutationEliminar_Configuracion_FajillaArgs {
    delete_configuracion_fajilla_input: DeleteConfiguracionFajillaInput
}

export interface MutationEliminar_Grupo_ModificadorArgs {
    deleteGrupoModificadorInput: DeleteGrupoModificadorInput
}

export interface MutationEliminar_HabitacionArgs {
    eliminar_habitacion_input: DeleteHabitacionInput
}

export interface MutationEliminar_HotelArgs {
    hotel: DeleteHotelInput
}

export interface MutationEliminar_HuellaArgs {
    DeleteCredencialInput: DeleteCredencialInput
}

export interface MutationEliminar_Huella_PinArgs {
    deleteCredentialhuellaPinInput: DeleteCredentialHuellaPinInput
}

export interface MutationEliminar_Imagen_IncidenciaArgs {
    deleteImageInput: DeleteImageInput
}

export interface MutationEliminar_MantenimientoArgs {
    mantenimiento: DeleteMantenimientoInput
}

export interface MutationEliminar_MesaArgs {
    DeleteMesaInput: DeleteMesaInput
}

export interface MutationEliminar_Metodo_De_PagoArgs {
    metodo_de_pago: DeleteMetodoDePagoInput
}

export interface MutationEliminar_ModificadorArgs {
    deleteModificadorInput: DeleteModificadorInput
}

export interface MutationEliminar_Modificador_Grupo_ModificadorArgs {
    deleteModificadorGrupoModificadorInput: DeleteModificadorGrupoModificadorInput
}

export interface MutationEliminar_MonedaArgs {
    moneda_id: Scalars["ID"]["input"]
}

export interface MutationEliminar_Motivo_Ingreso_VehiculoArgs {
    motivo_ingreso: DeleteMotivoIngresoVehiculoArgs
}

export interface MutationEliminar_PropinaArgs {
    DeletePropinaInput: DeletePropinaInput
    codigo?: InputMaybe<Scalars["String"]["input"]>
    template_sample?: InputMaybe<Scalars["String"]["input"]>
}

export interface MutationEliminar_PuestoArgs {
    puesto: DeletePuestoInput
}

export interface MutationEliminar_RecetaArgs {
    deleteRecetaInput: DeleteRecetaInput
}

export interface MutationEliminar_RolArgs {
    rol: DeleteRolInput
}

export interface MutationEliminar_Salida_InventarioArgs {
    deleteSalidaInput: DeleteSalidaInput
}

export interface MutationEliminar_ServicioArgs {
    datos_servicio: DeleteServicioInput
}

export interface MutationEliminar_Subcategoria_GastoArgs {
    subcategoria_gasto_data: DeleteSubcategoriaGastoInput
}

export interface MutationEliminar_Subcategoria_ProductoArgs {
    datos_subcategoria: DeleteSubcategoriaProductoInput
}

export interface MutationEliminar_SuscripcionArgs {
    suscripcion: DeleteSuscripcionInput
}

export interface MutationEliminar_TareaArgs {
    tarea: DeleteTareaInput
}

export interface MutationEliminar_TarifaArgs {
    tarifaO: DeleteTarifaDto
}

export interface MutationEliminar_Tipo_BloqueoArgs {
    tipo_bloqueo: DeleteTipoBloqueoArgs
}

export interface MutationEliminar_Tipo_HabitacionArgs {
    tipo_habitacion: DeleteTipoHabitacionArgs
}

export interface MutationEliminar_Tipo_MantenimientoArgs {
    tipo_mantenimiento: DeleteTipoMantenimientoArgs
}

export interface MutationEliminar_TurnoArgs {
    eliminar_turno_input: DeleteTurnoInput
}

export interface MutationEliminar_Turno_AtencionArgs {
    eliminar_turno_atencion_input: DeleteTurnoAtencionInput
}

export interface MutationEliminar_UsuarioArgs {
    usuario: DeleteUsuarioInput
}

export interface MutationLiberar_HabitacionArgs {
    codigo?: InputMaybe<Scalars["String"]["input"]>
    liberar_habitacion_input: ReleaseHabitacionInput
    template_sample?: InputMaybe<Scalars["String"]["input"]>
}

export interface MutationLoginArgs {
    loginInput: AuthLoginInput
}

export interface MutationLogin_GoogleArgs {
    loginGoogleInput: LoginGoogleInput
}

export interface MutationLogin_HuellaArgs {
    FingerPrintLoginInput: FingerPrintLoginInput
}

export interface MutationLogoutArgs {
    cerrar_turno?: InputMaybe<Scalars["Boolean"]["input"]>
    hotel_id?: InputMaybe<Scalars["String"]["input"]>
    sesion_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface MutationMarcar_Como_LeidaArgs {
    bandeja_notificaciones_id: Scalars["String"]["input"]
}

export interface MutationModificar_Esquema_PropinasArgs {
    propinas_esquema: UpdatePropinasEsquemaInput
}

export interface MutationObtener_Usuario_GoogleArgs {
    getGoogleUserInput: GetGoogleUserInput
}

export interface MutationPagar_ExtraArgs {
    pago_extra_detalles: PayPagoExtraInput
}

export interface MutationPagar_Ordenes_PendientesArgs {
    PayOrdenInput: PayRentaInput
}

export interface MutationPagar_PropinasArgs {
    pagos_propinas: CreateManyPagosPropinasInput
}

export interface MutationPagar_Propinas_VentasArgs {
    payPropinasVentasInput: PayPropinasVentasInput
}

export interface MutationPagar_RentaArgs {
    PayRentaInput: PayRentaInput
}

export interface MutationPagar_ReservaArgs {
    datos_reserva: PayReservaInput
}

export interface MutationPendiente_Autorizar_FajillaArgs {
    pendiente_autorizar_fajilla_input: PendienteAutorizarInput
}

export interface MutationReabrir_IncidenciaArgs {
    datos_incidencia: OpenIncidenciaInput
}

export interface MutationRechazar_FajillaArgs {
    rechazar_fajilla_input: RechazarFajillaInput
}

export interface MutationRegistrar_Evento_LoginArgs {
    input: TraceStartHistorialLoginInput
}

export interface MutationRegistrar_HuellaArgs {
    CreateCredencialInput: CreateCredencialInput
}

export interface MutationRegistrar_Usuario_DispositivoArgs {
    registerUsuarioDispositivoInput: RegisterUsuarioDispositivoInput
}

export interface MutationReiniciar_Asignaciones_PropinasArgs {
    hotel_id: Scalars["ID"]["input"]
}

export interface MutationRemover_Puesto_Esquema_PropinasArgs {
    puesto_id: Scalars["String"]["input"]
}

export interface MutationRemover_Reserva_De_HabitacionArgs {
    remover_reserva_de_habitacion_input: RemoveBookingFromRoomInput
}

export interface MutationSendChangePasswordViaEmailArgs {
    sendChangePasswordViaEmailInput: SendChangePasswordViaEmailInput
}

export interface MutationSendNotificationCaratulaMensualArgs {
    sendNotificationCaratulaMensualInput: SendNotificationInput
}

export interface MutationTransferir_ArticulosArgs {
    transferArticulosInput: TransferArticulosInput
}

export interface MutationUpdateApiKeyArgs {
    updateApiKeyInput: UpdateApiKeyInput
}

export interface MutationUpdatePagoRentaArgs {
    pago_renta_data: UpdatePagoRentaInput
}

export interface MutationUpdatePagosReservasArgs {
    pagos_reserva_data: UpdatePagoReservasInput
}

export interface MutationValidar_Codigo_Huella_AutorizacionArgs {
    codigo?: InputMaybe<Scalars["String"]["input"]>
    huella?: InputMaybe<Scalars["String"]["input"]>
}

export interface NombreArticuloFilterArgs {
    like?: InputMaybe<Scalars["String"]["input"]>
    /** Ordena los resultados de forma ASC o DESC en base al nombre del articulo */
    order?: InputMaybe<TipoOrdenamiento>
}

export interface NombreColaboradorFilterArgs {
    like?: InputMaybe<Scalars["String"]["input"]>
    /** Ordena los resultados de forma ASC o DESC en base al nombre del colaborador */
    order?: InputMaybe<TipoOrdenamiento>
}

export interface Notificacion {
    __typename?: "Notificacion"
    hotel_id?: Maybe<Scalars["ID"]["output"]>
    mensaje_plantilla: MensajePlantilla
    mensaje_plantilla_push_notification: MensajePlantillaPushNotification
    notificacion_id: Scalars["ID"]["output"]
    tipo: TipoNotificacion
    topic: Scalars["String"]["output"]
}

export enum Order {
    Asc = "ASC",
    Desc = "DESC",
}

export interface ObtenSaldoOutput {
    __typename?: "ObtenSaldoOutput"
    saldo?: Maybe<Scalars["Float"]["output"]>
}

export interface OpenIncidenciaInput {
    incidencia_id: Scalars["ID"]["input"]
}

export interface OpenTurnoInput {
    hotel_id: Scalars["ID"]["input"]
    turno_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface Orden {
    __typename?: "Orden"
    articulos?: Maybe<Array<ArticulosResponse>>
    /** Colaborador que hizo el consumo interno */
    colaborador_consumo_interno?: Maybe<Colaborador>
    /** Colaborador que hizo la entrega de la orden de room-service */
    colaborador_entrega?: Maybe<Colaborador>
    /** ID del colaborador que hizo la entrega de la orden de room-service */
    colaborador_id?: Maybe<Scalars["ID"]["output"]>
    /** Comanda asociada a la orden */
    comanda?: Maybe<Comanda>
    /** Comandas asociadas a la orden */
    comandas?: Maybe<Array<Comanda>>
    comentario?: Maybe<Scalars["String"]["output"]>
    /** ID del colaborador asociado al consumo interno */
    consumo_interno_colaborador_id?: Maybe<Scalars["ID"]["output"]>
    corte_id?: Maybe<Scalars["ID"]["output"]>
    /** Devuelve `true` si se trata de una orden con estado_pago `deposito` */
    deposito?: Maybe<Scalars["Boolean"]["output"]>
    /** Retorna los detalles del pago pre-cargado al comprar el articulo con modalidad de pago Deposito en garantia */
    detalle_pago_pre_cargado?: Maybe<Array<DetallePagoPreCargadoOutput>>
    detalles_orden?: Maybe<Array<DetalleOrden>>
    easyrewards_id?: Maybe<Scalars["String"]["output"]>
    estado_orden?: Maybe<EstadosOrdenHistorial>
    estado_pago: EstadoPagoOrdenes
    fecha_cobro?: Maybe<Scalars["DateTime"]["output"]>
    fecha_modificacion?: Maybe<Scalars["DateTime"]["output"]>
    fecha_registro: Scalars["DateTime"]["output"]
    hotel: Hotel
    hotel_id: Scalars["ID"]["output"]
    /** Mesa asociada a la orden */
    mesa?: Maybe<Mesa>
    monto_iva: Scalars["Float"]["output"]
    orden: Scalars["String"]["output"]
    orden_id: Scalars["ID"]["output"]
    /** Modulo donde se creo la orden (room-service, mostrador o restaurante) */
    origen_orden?: Maybe<Scalars["String"]["output"]>
    pago?: Maybe<Pago>
    pago_id?: Maybe<Scalars["ID"]["output"]>
    /** Retorna todos los pagos de la orden(totales y parciales) */
    pagos: Array<Pago>
    /** Bandera que indica si la orden sera o no mostrada en el panel de cocina */
    panel_no_visible: Scalars["Boolean"]["output"]
    /** Es la propina recibida y asociada a la orden en caso de que la hubo */
    propina?: Maybe<Propina>
    renta?: Maybe<Renta>
    renta_id?: Maybe<Scalars["ID"]["output"]>
    saldo_pendiente?: Maybe<Scalars["Float"]["output"]>
    total_con_iva: Scalars["Float"]["output"]
    total_productos: Scalars["Int"]["output"]
    total_sin_iva: Scalars["Float"]["output"]
    /** Turno en el que se registro la orden */
    turno?: Maybe<Turno>
    turno_id?: Maybe<Scalars["ID"]["output"]>
    usuario: Usuario
    usuario_id: Scalars["ID"]["output"]
    /** Propiedad calculada para obtener la relación con la comanda */
    virtual_comanda_id?: Maybe<Scalars["ID"]["output"]>
}

export interface OrdenDetalles_OrdenArgs {
    estado?: InputMaybe<Array<EstadosDetalleOrden>>
    filter_articulos_categoria_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface OrdenSubDetail {
    __typename?: "OrdenSubDetail"
    accion: OrdenesPanelAction
    orden: Orden
    tipo: TipoOrdenPanelCocina
}

export enum OrdenesPanelAction {
    Actualizar = "actualizar",
    Agregar = "agregar",
    Cancelar = "cancelar",
    Editar = "editar",
    Remover = "remover",
}

export enum Origen {
    Email = "email",
    Google = "google",
}

export enum OrigenOrden {
    Deposito = "deposito",
    ExtrasRenta = "extras_renta",
    ExtrasReserva = "extras_reserva",
    Renta = "renta",
    Reserva = "reserva",
    Restaurante = "restaurante",
    RoomService = "room_service",
}

export enum OrigenRservas {
    Bestday = "bestday",
    Booking = "booking",
    Checkfront = "checkfront",
    Despegar = "despegar",
    Email = "email",
    Expedia = "expedia",
    Hotels = "hotels",
    Hotwire = "hotwire",
    Kayak = "kayak",
    Otros = "otros",
    Priceline = "priceline",
    Recepcion = "recepcion",
    Telefono = "telefono",
    Tripadvisor = "tripadvisor",
    Trivago = "trivago",
}

export interface OrigenTicket {
    __typename?: "OrigenTicket"
    /** Datos de los extras asociados al ticket de compra/pago */
    extras?: Maybe<Array<Extra>>
    id: Scalars["String"]["output"]
    origen: OrigenesTicket
    /** Datos de la renta asociada al ticket de compra/pago */
    renta?: Maybe<Renta>
}

export enum OrigenesFajillas {
    Manual = "manual",
    MaquinaEfectivo = "maquina_efectivo",
}

export enum OrigenesOrden {
    Mostrador = "mostrador",
    Restaurante = "restaurante",
    RoomService = "room_service",
}

export enum OrigenesTicket {
    ExtraRenta = "extra_renta",
    ExtraReserva = "extra_reserva",
    Gasto = "gasto",
    Propina = "propina",
    Renta = "renta",
    Reserva = "reserva",
    Restaurante = "restaurante",
    RoomService = "room_service",
}

export interface PageMetaDto {
    __typename?: "PageMetaDto"
    hasNextPage: Scalars["Boolean"]["output"]
    hasPreviousPage: Scalars["Boolean"]["output"]
    itemCount: Scalars["Int"]["output"]
    page: Scalars["Int"]["output"]
    pageCount: Scalars["Int"]["output"]
    take: Scalars["Int"]["output"]
}

export interface PageOptionsArgs {
    order?: InputMaybe<Order>
    page?: Scalars["Int"]["input"]
    take?: Scalars["Int"]["input"]
}

export interface PaginatedSearchOrdenesOutput {
    __typename?: "PaginatedSearchOrdenesOutput"
    conteos: ConteosOrdenesDetailsOutput
    ordenes: Array<Orden>
    paginacion: DatosPaginationOutput
}

export interface PaginationColaboradoresTareaDto {
    __typename?: "PaginationColaboradoresTareaDto"
    colaboradores_tarea: Array<ColaboradorTarea>
    pageMetaDto: PageMetaDto
}

export interface Pago {
    __typename?: "Pago"
    detalles_pago?: Maybe<Array<DetallePago>>
    extras?: Maybe<Array<Extra>>
    fecha_pago: Scalars["DateTime"]["output"]
    hotel?: Maybe<Hotel>
    hotel_id: Scalars["ID"]["output"]
    pago_id: Scalars["ID"]["output"]
    rentas?: Maybe<Array<Renta>>
    reservas?: Maybe<Array<Reserva>>
    ticket_id?: Maybe<Scalars["ID"]["output"]>
    total: Scalars["Float"]["output"]
    usuario?: Maybe<Usuario>
    usuario_id: Scalars["ID"]["output"]
}

export interface PagoExtra {
    __typename?: "PagoExtra"
    extra_id: Scalars["ID"]["output"]
    pago_extra_id: Scalars["ID"]["output"]
    pago_id: Scalars["ID"]["output"]
}

export interface PagoPropina {
    __typename?: "PagoPropina"
    /** Retorna los datos de la propina asignada por reparticion de aportaciones de propinas */
    asignacion_propina?: Maybe<AsignacionPropina>
    asignacion_propina_id: Scalars["ID"]["output"]
    fecha_registro: Scalars["DateTime"]["output"]
    folio: Scalars["Int"]["output"]
    hotel_id: Scalars["ID"]["output"]
    pago_propina_id: Scalars["ID"]["output"]
    periodo_pago: Scalars["String"]["output"]
    /** Personal que recibió el pago de propina */
    personal?: Maybe<Colaborador>
}

export interface PagoPropinaItemInput {
    asignacion_propina_id: Scalars["ID"]["input"]
    colaborador_id: Scalars["ID"]["input"]
    comision_bancaria_propina_por_venta: Scalars["Float"]["input"]
    comision_bancaria_sobre_fondo: Scalars["Float"]["input"]
    monto_pagado: Scalars["Float"]["input"]
}

export interface PagosRentas {
    __typename?: "PagosRentas"
    pago_id: Scalars["ID"]["output"]
    pago_renta_id: Scalars["ID"]["output"]
    renta?: Maybe<Renta>
    renta_id: Scalars["ID"]["output"]
}

export interface PagosReservas {
    __typename?: "PagosReservas"
    pago_id: Scalars["ID"]["output"]
    pago_reserva_id: Scalars["ID"]["output"]
    reserva?: Maybe<Reserva>
    reserva_id: Scalars["ID"]["output"]
}

export interface Panel {
    __typename?: "Panel"
    banner?: Maybe<Scalars["String"]["output"]>
    imagen_promo?: Maybe<ImagenPromo>
}

export interface PanelInput {
    banner?: InputMaybe<Scalars["String"]["input"]>
    imagen_promo?: InputMaybe<ImagenPromoInput>
}

export interface PartialInfoCheckoutResponseOutput {
    __typename?: "PartialInfoCheckoutResponseOutput"
    habitacion?: Maybe<Habitacion>
    ticket_id?: Maybe<Array<Scalars["String"]["output"]>>
}

export interface PartialInfoExtraDetalleOrdenInput {
    almacen_articulo_id: Scalars["ID"]["input"]
    cantidad: Scalars["Float"]["input"]
    costo_con_iva: Scalars["Float"]["input"]
    costo_sin_iva: Scalars["Float"]["input"]
    extra_detalle_orden_id?: InputMaybe<Scalars["ID"]["input"]>
    monto_iva: Scalars["Float"]["input"]
}

export interface PayPagoExtraInput {
    detallesPago: Array<DetallePagoPartialInfoObject>
    extra_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
    total: Scalars["Float"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface PayPropinasVentasInput {
    hotel_id: Scalars["ID"]["input"]
}

export interface PayPropinasVentasOutput {
    __typename?: "PayPropinasVentasOutput"
    reporte_propina_venta_id?: Maybe<Scalars["ID"]["output"]>
}

export interface PayRentaInput {
    colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    extra_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    mesa_id?: InputMaybe<Scalars["ID"]["input"]>
    orden_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    pago: CreatePagoInput
    propina?: InputMaybe<CreatePropinaPartialInput>
    renta_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id: Scalars["ID"]["input"]
}

export interface PayReservaInput {
    pago: CreatePagoInput
    reserva_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface PendienteAutorizarInput {
    fajilla_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface PersonalizacionTicket {
    __typename?: "PersonalizacionTicket"
    hotel_id: Scalars["ID"]["output"]
    imagen_promocional?: Maybe<Scalars["String"]["output"]>
    mostrar_logo: Scalars["Boolean"]["output"]
    personalizacion_ticket_id: Scalars["ID"]["output"]
    textos_informativos?: Maybe<TextosInformativos>
}

export interface Posicion {
    __typename?: "Posicion"
    tamano: Tamano
    x: Scalars["Float"]["output"]
    y: Scalars["Float"]["output"]
}

export interface PosicionInput {
    tamano: Tamano
    x: Scalars["Float"]["input"]
    y: Scalars["Float"]["input"]
}

export interface PosicionMesa {
    __typename?: "PosicionMesa"
    tamano: TamanoMesa
    x: Scalars["Float"]["output"]
    y: Scalars["Float"]["output"]
}

export interface PosicionMesaInput {
    tamano: TamanoMesa
    x: Scalars["Float"]["input"]
    y: Scalars["Float"]["input"]
}

export interface Precio {
    __typename?: "Precio"
    activo: Scalars["Boolean"]["output"]
    almacen_articulo_id: Scalars["ID"]["output"]
    fecha_fin?: Maybe<Scalars["DateTime"]["output"]>
    fecha_inicio?: Maybe<Scalars["DateTime"]["output"]>
    monto: Scalars["Float"]["output"]
    precio_id: Scalars["ID"]["output"]
}

export enum ProcedenciaPropina {
    ExtraRenta = "extra_renta",
    Otro = "otro",
    Renta = "renta",
    Reserva = "reserva",
    Restaurante = "restaurante",
    Roomservice = "roomservice",
}

export interface Propina {
    __typename?: "Propina"
    /** Información del colaborador que recibió la propina */
    colaborador?: Maybe<Colaborador>
    colaborador_id: Scalars["ID"]["output"]
    comentarios?: Maybe<Scalars["String"]["output"]>
    corte_id?: Maybe<Scalars["ID"]["output"]>
    detalles_pago: Array<DetallesPagoPartialInfoOutput>
    eliminado: Scalars["Boolean"]["output"]
    /** Estado del pago de la propina */
    estado?: Maybe<Scalars["String"]["output"]>
    fecha_eliminado?: Maybe<Scalars["DateTime"]["output"]>
    fecha_registro: Scalars["DateTime"]["output"]
    folio: Scalars["Float"]["output"]
    /** Información de la habitacion asociada al pago de la propina en renta, reserva u orden */
    habitacion?: Maybe<Habitacion>
    hotel_id: Scalars["ID"]["output"]
    /** Información de la mesa asociada al pago de la propina en restaurante */
    mesa?: Maybe<Mesa>
    procedencia: ProcedenciaPropina
    procedencia_id?: Maybe<Scalars["ID"]["output"]>
    propina_id: Scalars["ID"]["output"]
    ticket_id?: Maybe<Scalars["ID"]["output"]>
    total: Scalars["Float"]["output"]
    /** Información del turno en el que fue registrada la propina */
    turno?: Maybe<Turno>
    turno_id: Scalars["ID"]["output"]
}

export interface PropinaEsquemaItemInput {
    porcentaje_propina: Scalars["Float"]["input"]
    puesto_id: Scalars["ID"]["input"]
}

export interface PropinaRecolectadaColaboradorDetailOutput {
    __typename?: "PropinaRecolectadaColaboradorDetailOutput"
    categoria: Scalars["String"]["output"]
    monto: Scalars["String"]["output"]
}

export interface PropinasDetalleTicket {
    __typename?: "PropinasDetalleTicket"
    numero_referencia?: Maybe<Scalars["String"]["output"]>
    procedencia: ProcedenciaPropina
    tipo_pago: TiposPagos
    total: Scalars["Float"]["output"]
    ultimos_digitos?: Maybe<Scalars["String"]["output"]>
}

export interface Puesto {
    __typename?: "Puesto"
    /** Devuelve la primer area asociada al puesto */
    area?: Maybe<Area>
    areas?: Maybe<Array<Area>>
    /** Descripción del puesto */
    descripcion: Scalars["String"]["output"]
    /** Indica si el puesto está eliminado */
    eliminado: Scalars["Boolean"]["output"]
    /** Estado del puesto */
    estado?: Maybe<Scalars["String"]["output"]>
    /** Nombre del puesto */
    nombre: Scalars["String"]["output"]
    /** Porcentaje que le corresponde del total de propinas recaudadas */
    porcentaje_propina: Scalars["Float"]["output"]
    /** Puesto id */
    puesto_id: Scalars["ID"]["output"]
}

export enum PuestoRol {
    Administrador = "administrador",
    Colaborador = "colaborador",
    Otro = "otro",
    SocioODuenoDeHotel = "socio_o_dueno_de_hotel",
}

export interface Query {
    __typename?: "Query"
    /** Retorna conteos sobre la tabla de almacenes-articulos. Ej. total_procesos, total_recetas_alimentos, etc. */
    agregaciones_almacenes_articulos?: Maybe<GetAggregationsAlmacenesArticulosOutput>
    /** Indica si hay alertas activas por pagos pendientes, placas pendientes o energeticos pendientes en el cierre de corte */
    alertas_corte: AlertasCorteOutput
    almacen: Almacen
    almacen_articulo: AlmacenArticulo
    almacenes: Array<Almacen>
    almacenes_articulos: SearchAlmacenesArticulosOutput
    area: Area
    areas: Array<Area>
    areasPuestos: Array<AreasPuestos>
    articulo: Articulo
    articulo_externo: ArticuloExterno
    articulos: Array<Articulo>
    articulos_externos: Array<ArticuloExternoWithRelationsOutput>
    asistencia: Asistencia
    asistencias: Array<Asistencia>
    /** Retorna los valores de la repartición de propinas correspondientes a cada colaborador por corte */
    calcular_reparto_propinas: RepartoPropinasOutput
    categoria_articulo: CategoriaArticulo
    categoria_gasto: CategoriaGasto
    categorias_articulos: Array<CategoriaArticulo>
    categorias_gasto: Array<CategoriaGasto>
    cliente: Cliente
    clientes: Array<Cliente>
    colaborador: Colaborador
    colaborador_tarea: ColaboradorTarea
    colaboradores: Array<Colaborador>
    colaboradores_by_area: FindAllPaginatedOutput
    colaboradores_disponibles_por_puesto?: Maybe<Array<Colaborador>>
    colaboradores_disponibles_por_puestos: Array<Colaborador>
    colaboradores_por_id: Array<Colaborador>
    colaboradores_tareas?: Maybe<Array<ColaboradorTarea>>
    comanda: Comanda
    comandas: Array<Comanda>
    configuracion_fajilla: ConfiguracionFajilla
    configuracion_propina: ConfiguracionPropina
    /** Configuraciones para acciones durante el cierre de corte de turno en el hotel */
    configuraciones_corte: Array<ConfiguracionCorte>
    configuraciones_fajilla: Array<ConfiguracionFajilla>
    configuraciones_inventario: Array<ConfiguracionInventario>
    configuraciones_propina: Array<ConfiguracionPropina>
    /** Retorna el detalle de reparto de propinas del turno para perfiles de venta en base al ID */
    consultar_reporte_propinas?: Maybe<GetReportePropinasOutput>
    corte: Corte
    cortes: Array<Corte>
    cortes_agrupados: Array<GroupCortes>
    cortes_por_anio: Array<CortesSummaryByMonthResponse>
    detalle_orden: DetalleOrden
    detalle_pago: DetallePago
    /** Retorna el desglose a detalle de la repartición de propinas */
    detalle_reparto_propinas?: Maybe<DetalleRepartoPropinasOutput>
    detalles_orden: Array<DetalleOrden>
    detalles_pago: Array<DetallePago>
    /** Verifica si hay alertas por habitaciones disponibles vs reservas del dia por tipo de habitación y por turnos de atencion en espera */
    disponibilidad_habitacion: RoomAvailabilityOutput
    /** Información de los tipos de habitaciones existentes y su disponibilidad en el hotel */
    disponibilidad_habitaciones?: Maybe<Array<TipoHabitacionPartialDetail>>
    existe_hotel: Scalars["Boolean"]["output"]
    existe_metodo_de_pago: Scalars["Boolean"]["output"]
    existe_usuario: Scalars["Boolean"]["output"]
    experiencias: Array<Experiencia>
    extra: Extra
    extras: Array<Extra>
    fajilla: Fajilla
    fajillas: Array<Fajilla>
    filtros_reportes: FiltrosReportesVehiculos
    findAllPagoRenta: Array<PagosRentas>
    findAllPagosReservas: Array<PagosReservas>
    findDistinctVehiculoField: Array<Scalars["String"]["output"]>
    findOnePagosReservasByIdInput: PagosReservas
    funcionalidad: Funcionalidad
    funcionalidades: Array<Funcionalidad>
    gasto: Gastos
    gastos: SearchGastosOutputDto
    gastos_categoria_por_mes?: Maybe<Array<BillingPerMonthGroupedByCategoryOutput>>
    gastos_categoria_por_meses?: Maybe<Array<BillingPerMonthGroupedByCategoryWithMonthOutput>>
    gastos_por_mes?: Maybe<BillingPerMonthOutput>
    generar_pin: Scalars["String"]["output"]
    /** Obtiene los datos del vehículo por placa */
    getVehiculoDataByPlaca?: Maybe<GetVehiculoDataByPlacaOutput>
    grupo_hotel: GrupoHotel
    grupos_hoteles: Array<GrupoHotel>
    habitacion: Habitacion
    habitacion_mas_vendida?: Maybe<Habitacion>
    habitacion_top_rentas_del_dia?: Maybe<TopRentalRoom>
    habitacion_top_reservas_del_dia: TopBookingRoom
    habitaciones: Array<Habitacion>
    habitaciones_mesas: HabitacionesMesasOutput
    /** Retorna el historial de estados de las comandas y los intervalos de tiempo por estado */
    historial_estados_comanda: SearchHistorialEstadosComandaOutput
    /** Retorna el historial de estados de las ordenes y los intervalos de tiempo por estado */
    historial_estados_orden: SearchHistorialEstadosOrdenOutput
    historial_habitacion: HistorialHabitacion
    historial_habitaciones: Array<HistorialHabitacion>
    historial_movimiento_inventario: HistorialMovimientosInventario
    historial_movimientos_inventario: FindAllHistorialMovimientosInventarioOutput
    /** Retorna 1 registro del historial de producciones del inventario en base a su ID */
    historial_produccion_inventario?: Maybe<HistorialProduccionInventario>
    /** Retorna el historial de producciones del inventario, tanto de forma general como con filtros */
    historial_producciones_inventarios?: Maybe<Array<HistorialProduccionInventario>>
    hotel: Hotel
    hotel_colaborador?: Maybe<HotelColaborador>
    hotel_colaboradores?: Maybe<Array<HotelColaborador>>
    hoteles: Array<Hotel>
    imagenes_hoteles_grupo_hotel: Array<HotelImage>
    incidencia: Incidencia
    incidencias: Array<Incidencia>
    informe_historial_movimientos_inventario: GetInformeHistorialMovimientosInventarioOutput
    informe_inventario?: Maybe<GetInformeInventarioOutput>
    ingredientes_recetas: Array<IngredienteReceta>
    /** Retorna los KPIs de producción de un articulo en base a su ID */
    kpis_historial_producciones_inventarios?: Maybe<GetKpisHistorialProduccionesInventarioByArticuloIdOutput>
    /** Obtiene los KPIs de mantenimientos (agua, luz, gas, incidencias pendientes y cerradas) para un hotel en un rango de fechas */
    kpis_mantenimientos: GetKpisMantenimientoOutput
    mantenimiento: Mantenimiento
    mantenimientos: Array<Mantenimiento>
    mesa: Mesa
    mesa_asignada: MesaAsignada
    mesas: Array<Mesa>
    mesas_asignadas: Array<MesaAsignada>
    metodo_de_pago: MetodoDePago
    metodos_de_pago: Array<MetodoDePago>
    mi_perfil: Usuario
    modulo: Modulo
    modulos: Array<Modulo>
    moneda: Moneda
    monedas: Array<Moneda>
    motivo_ingreso_vehiculo: MotivoIngresoVehiculo
    motivos_ingreso_vehiculos: Array<MotivoIngresoVehiculo>
    movimientos_antes_corte: GetMovementsCountBeforeCorteOutput
    notificaciones: Array<Notificacion>
    /** Devolver booleano si hay notificaciones no leidas */
    notificaciones_no_leidas_alerta?: Maybe<Scalars["Boolean"]["output"]>
    obten_saldo: ObtenSaldoOutput
    /** Obtener bandeja de incidencias */
    obtener_bandeja_incidencias?: Maybe<Array<BandejaNotificaciones>>
    /** Obtener bandeja de notificaciones */
    obtener_bandeja_notificaciones?: Maybe<Array<BandejaNotificaciones>>
    obtener_ordenes_no_pagadas: Array<Orden>
    obtener_porcentaje_promedio_ocupacion: Scalars["Float"]["output"]
    obtener_ventas: Array<SalesTicketsByTurno>
    obtener_ventas_extras: TodayExtrasSales
    obtener_ventas_ordenes: TodayOrdenesSales
    obtener_ventas_rentas: GetTodayRentalSales
    obtener_ventas_reservas?: Maybe<TodayReservasSales>
    orden: Orden
    ordenes: Array<Orden>
    /** Devuelve la lista de ordenes con datos de paginacion incluidos */
    ordenes_paginadas: PaginatedSearchOrdenesOutput
    paginacion_colaboradores_tarea?: Maybe<PaginationColaboradoresTareaDto>
    pagos: Array<Pago>
    /** Historial de pagos de propinas por colaborador */
    pagos_propinas: Array<PagoPropina>
    personalizacion_ticket?: Maybe<PersonalizacionTicket>
    /** Retorna las entradas de placas que faltan por completar para el hotel */
    placas_pendientes: Array<HistorialVehiculo>
    propinas: Array<Propina>
    puesto: Puesto
    puestos: Array<Puesto>
    puestos_de_hotel: Array<HotelColaborador>
    receta: Receta
    recetas: Array<Receta>
    renta: Renta
    rentas: Array<Renta>
    /** Retorna el detalle de reparto de propinas del turno para perfiles de venta con los datos actuales */
    reporte_propinas?: Maybe<GetReportePropinasOutput>
    reserva: Reserva
    reservas: Array<Reserva>
    reservas_sin_asignar_del_dia: Array<Reserva>
    rol: Rol
    roles: Array<Rol>
    salida_inventario: Salida
    salidas_inventario: SearchSalidasOutput
    /** Fecha actual del servidor (UTC) */
    serverDate: Scalars["DateTime"]["output"]
    servicio: Servicio
    servicios: Array<Servicio>
    subcategoria_gasto: SubcategoriaGasto
    subcategoria_producto: SubcategoriaProducto
    subcategorias_gasto: Array<SubcategoriaGasto>
    subcategorias_productos: Array<SubcategoriaProducto>
    surtido: Surtido
    surtidos: Array<Surtido>
    suscripcion: Suscripcion
    suscripciones: Array<Suscripcion>
    tarea: Tarea
    tareas: Array<Tarea>
    tarifa: Tarifa
    tarifas: Array<Tarifa>
    ticket: Ticket
    tickets: Array<Ticket>
    tipo_bloqueo: TipoBloqueo
    tipo_habitacion: TipoHabitacion
    tipo_habitaciones: Array<TipoHabitacion>
    tipo_mantenimiento: TipoMantenimiento
    tipos_bloqueo: Array<TipoBloqueo>
    tipos_mantenimiento: Array<TipoMantenimiento>
    total_gastos_por_dia_recepcionista: TotalBillingPerDayRecepcionstOutput
    totales_gastos_subcategoria_por_categoria: BillingPerMonthGroupedByCategoryOutput
    totales_propinas: TotalesPropinasOutput
    transaccion: Transaccion
    transacciones: Array<Transaccion>
    /** Retorna toda la información de las transacciones de la renta (pagadas y pendientes) para cancelacion */
    transacciones_renta?: Maybe<GetRentaTransactionsOutput>
    turno: Turno
    turno_atencion: TurnoAtencion
    turnos: Array<Turno>
    turnos_atencion: Array<TurnoAtencion>
    ultima_tarea_asignada_a_colaborador?: Maybe<Array<ColaboradorTarea>>
    ultimo_corte?: Maybe<Corte>
    unidades_conversion_articulos: Array<UnidadConversionArticulo>
    usuario: Usuario
    usuarios: Array<Usuario>
    /** Obtiene la configuracion de notificaciones para el usuario */
    usuarios_notificaciones?: Maybe<Array<UsuariosNotificacionesConfigOutput>>
    validateApiKey: ApiKey
    ventas_habitaciones_por_turno: Array<SalesRoomsCountByTurno>
    /** Verifica si se sobrepasa el limite de reservas por dia de acuerdo al tipo de habitación */
    verificar_limite_reservas: CheckReserveLimitOutput
}

export interface QueryAgregaciones_Almacenes_ArticulosArgs {
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryAlertas_CorteArgs {
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryAlmacenArgs {
    almacen_id: Scalars["ID"]["input"]
}

export interface QueryAlmacen_ArticuloArgs {
    almacen_articulo_id: Scalars["ID"]["input"]
}

export interface QueryAlmacenesArgs {
    almacen_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    estado?: InputMaybe<EstadoAlmacen>
    fecha_creacion?: InputMaybe<DateSearchInput>
    fecha_modificacion?: InputMaybe<DateSearchInput>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    tipo_almacen?: InputMaybe<TipoAlmacen>
    usuario_modifico_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryAlmacenes_ArticulosArgs {
    almacen_articulo_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    almacen_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    articulo_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    categoria_articulo_filters?: InputMaybe<CategoriaArticuloFilterArgs>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    estado_almacen_articulo?: InputMaybe<Array<EstadosAlmacenesArticulos>>
    fecha_movimiento?: InputMaybe<DateSearchInput>
    filter_articulo_eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    filter_duplicados?: InputMaybe<Scalars["Boolean"]["input"]>
    filter_estado_articulo?: InputMaybe<EstadosArticulo>
    filter_extra_articulo?: InputMaybe<Scalars["Boolean"]["input"]>
    filter_producciones?: InputMaybe<Scalars["Boolean"]["input"]>
    filter_tipo_almacen?: InputMaybe<TipoAlmacen>
    filter_tipo_articulo?: InputMaybe<Array<TipoArticulo>>
    folio_articulo_filters?: InputMaybe<FolioArticuloFiltersArgs>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    nombre_articulo_filters?: InputMaybe<NombreArticuloFilterArgs>
    pagination_options?: InputMaybe<PageOptionsArgs>
}

export interface QueryAreaArgs {
    area_id: Scalars["ID"]["input"]
}

export interface QueryAreasArgs {
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    estado?: InputMaybe<Scalars["String"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
}

export interface QueryAreasPuestosArgs {
    area_id?: InputMaybe<Scalars["ID"]["input"]>
    area_puesto_id?: InputMaybe<Scalars["ID"]["input"]>
    puesto_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryArticuloArgs {
    articulo_id: Scalars["ID"]["input"]
}

export interface QueryArticulo_ExternoArgs {
    articulo_externo_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryArticulosArgs {
    articulo_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    cantidad_minima?: InputMaybe<Scalars["Float"]["input"]>
    categoria_id?: InputMaybe<Scalars["ID"]["input"]>
    contenido?: InputMaybe<Scalars["Float"]["input"]>
    costo_actual?: InputMaybe<Scalars["Float"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    estado?: InputMaybe<EstadosArticulo>
    fecha_eliminado?: InputMaybe<DateSearchInput>
    fecha_registro?: InputMaybe<DateSearchInput>
    folio?: InputMaybe<Scalars["String"]["input"]>
    foto?: InputMaybe<Scalars["String"]["input"]>
    grupo_hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    insumo?: InputMaybe<Scalars["Boolean"]["input"]>
    marca?: InputMaybe<Scalars["String"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    precio?: InputMaybe<Scalars["Float"]["input"]>
    unidad?: InputMaybe<UnidadMedidasArticulo>
}

export interface QueryArticulos_ExternosArgs {
    articulo_externo_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    estado?: InputMaybe<Array<EstadosArticuloExterno>>
    fecha_actualizacion?: InputMaybe<DateSearchInput>
    fecha_registro?: InputMaybe<DateSearchInput>
    hotel_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    precio?: InputMaybe<Scalars["Float"]["input"]>
}

export interface QueryAsistenciaArgs {
    asistencia_id: Scalars["ID"]["input"]
}

export interface QueryAsistenciasArgs {
    asistencia_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    asistio?: InputMaybe<Scalars["Boolean"]["input"]>
    colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    comentario?: InputMaybe<Scalars["String"]["input"]>
    dia?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_entrada?: InputMaybe<DateSearchInput>
    fecha_salida?: InputMaybe<DateSearchInput>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryCalcular_Reparto_PropinasArgs {
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryCategoria_ArticuloArgs {
    categoria_id: Scalars["ID"]["input"]
}

export interface QueryCategoria_GastoArgs {
    categoria_id: Scalars["ID"]["input"]
}

export interface QueryCategorias_ArticulosArgs {
    categoria_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
}

export interface QueryCategorias_GastoArgs {
    categoria?: InputMaybe<Scalars["String"]["input"]>
    categoria_id?: InputMaybe<Scalars["ID"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    limite_mensual?: InputMaybe<Scalars["Float"]["input"]>
    predeterminado?: InputMaybe<Scalars["Boolean"]["input"]>
    presupuesto?: InputMaybe<Scalars["Float"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryClienteArgs {
    cliente_id: Scalars["ID"]["input"]
}

export interface QueryClientesArgs {
    correo?: InputMaybe<Scalars["String"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    numero_cliente?: InputMaybe<Scalars["Float"]["input"]>
    telefono?: InputMaybe<Scalars["String"]["input"]>
}

export interface QueryColaboradorArgs {
    colaborador_id: Scalars["ID"]["input"]
}

export interface QueryColaborador_TareaArgs {
    colaborador_tarea_id: Scalars["ID"]["input"]
}

export interface QueryColaboradoresArgs {
    apellido_materno?: InputMaybe<Scalars["String"]["input"]>
    apellido_paterno?: InputMaybe<Scalars["String"]["input"]>
    area_id?: InputMaybe<Scalars["ID"]["input"]>
    colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    correo?: InputMaybe<Scalars["String"]["input"]>
    direccion?: InputMaybe<Scalars["String"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    en_turno?: InputMaybe<Scalars["Boolean"]["input"]>
    estado?: InputMaybe<Scalars["String"]["input"]>
    fecha_baja?: InputMaybe<DateSearchInput>
    fecha_cumpleanios?: InputMaybe<DateSearchInput>
    fecha_registro?: InputMaybe<DateSearchInput>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    numero_colaborador?: InputMaybe<Scalars["String"]["input"]>
    numero_id?: InputMaybe<Scalars["String"]["input"]>
    pagination_options?: InputMaybe<PageOptionsArgs>
    puesto_id?: InputMaybe<Scalars["ID"]["input"]>
    telefono_emergencia?: InputMaybe<Scalars["String"]["input"]>
    telefono_personal?: InputMaybe<Scalars["String"]["input"]>
    turno_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryColaboradores_By_AreaArgs {
    area_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    colaborador_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    en_turno?: InputMaybe<Scalars["Boolean"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    nombre_colaborador_filter?: InputMaybe<NombreColaboradorFilterArgs>
    pagination_options?: InputMaybe<PageOptionsArgs>
    puesto_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
}

export interface QueryColaboradores_Disponibles_Por_PuestoArgs {
    datos_busqueda: SearchColaboradoresForTaskInput
}

export interface QueryColaboradores_Disponibles_Por_PuestosArgs {
    datos_busqueda: SearchColaboradoresForTaskByNombrePuestosInput
}

export interface QueryColaboradores_Por_IdArgs {
    colaboradores_ids?: InputMaybe<Array<Scalars["ID"]["input"]>>
}

export interface QueryColaboradores_TareasArgs {
    search_colaboradores_tareas_args: FindAllColaboradoresTareaRequest
}

export interface QueryComandaArgs {
    comanda_id: Scalars["ID"]["input"]
}

export interface QueryComandasArgs {
    comanda_id: Array<Scalars["ID"]["input"]>
    fecha_modificacion?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_registro?: InputMaybe<Scalars["DateTime"]["input"]>
    folio?: InputMaybe<Scalars["Float"]["input"]>
    orden_id: Array<Scalars["ID"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryConfiguracion_FajillaArgs {
    configuracion_fajilla_id: Scalars["ID"]["input"]
}

export interface QueryConfiguracion_PropinaArgs {
    configuracion_propina_id: Scalars["ID"]["input"]
}

export interface QueryConfiguraciones_CorteArgs {
    activo?: InputMaybe<Scalars["Boolean"]["input"]>
    concepto?: InputMaybe<ConceptosInclusionFilterArgs>
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryConfiguraciones_FajillaArgs {
    fecha_creacion?: InputMaybe<Scalars["DateTime"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
    valor?: InputMaybe<Scalars["Float"]["input"]>
}

export interface QueryConfiguraciones_InventarioArgs {
    configuracion_inventario_id?: InputMaybe<Scalars["ID"]["input"]>
    configuraciones?: InputMaybe<ConfiguracionesInput>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    inventario_negativo?: InputMaybe<Scalars["Boolean"]["input"]>
}

export interface QueryConfiguraciones_PropinaArgs {
    configuracion_propina_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    fecha_registro?: InputMaybe<DateSearchInput>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryConsultar_Reporte_PropinasArgs {
    corte_id?: InputMaybe<Scalars["ID"]["input"]>
    reporte_propina_venta_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryCorteArgs {
    corte_id: Scalars["ID"]["input"]
}

export interface QueryCortesArgs {
    corte_id?: InputMaybe<Scalars["ID"]["input"]>
    estatus?: InputMaybe<EstatusCorte>
    fecha_cierre_corte?: InputMaybe<DateSearchInput>
    fecha_corte?: InputMaybe<DaySearchInput>
    fecha_fin_corte?: InputMaybe<DateSearchInput>
    fecha_inicio_corte?: InputMaybe<DateSearchInput>
    folio?: InputMaybe<Scalars["Float"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    total_corte?: InputMaybe<Scalars["Float"]["input"]>
    total_venta_habitaciones?: InputMaybe<Scalars["Float"]["input"]>
    turno_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_cierra_corte?: InputMaybe<Scalars["String"]["input"]>
    usuario_realiza_corte?: InputMaybe<Scalars["String"]["input"]>
}

export interface QueryCortes_AgrupadosArgs {
    estatus?: InputMaybe<EstatusCorte>
    fecha_cierre_corte?: InputMaybe<DateSearchInput>
    fecha_corte?: InputMaybe<DaySearchInput>
    fecha_fin_corte?: InputMaybe<DateSearchInput>
    fecha_inicio_corte?: InputMaybe<DateSearchInput>
    hotel_id: Scalars["ID"]["input"]
    unidad_tiempo?: InputMaybe<UnidadTiempoFiltro>
}

export interface QueryCortes_Por_AnioArgs {
    fecha_inicio_corte?: InputMaybe<DateSearchInput>
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryDetalle_OrdenArgs {
    detalle_orden_id: Scalars["ID"]["input"]
}

export interface QueryDetalle_PagoArgs {
    detalle_pago_id: Scalars["ID"]["input"]
}

export interface QueryDetalle_Reparto_PropinasArgs {
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryDetalles_OrdenArgs {
    almacen_articulo_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    detalle_orden_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    estado?: InputMaybe<Array<EstadosDetalleOrden>>
    fecha_cancelacion?: InputMaybe<DateSearchInput>
    fecha_devolucion?: InputMaybe<DateSearchInput>
    merma?: InputMaybe<Scalars["Boolean"]["input"]>
    orden_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    reembolso?: InputMaybe<Scalars["Boolean"]["input"]>
}

export interface QueryDetalles_PagoArgs {
    cancelado?: InputMaybe<Scalars["Boolean"]["input"]>
    detalle_pago_id?: InputMaybe<Scalars["ID"]["input"]>
    easyrewards_id?: InputMaybe<Scalars["String"]["input"]>
    fecha_pago?: InputMaybe<DateSearchInput>
    numero_referencia?: InputMaybe<Scalars["String"]["input"]>
    origen_orden: OrigenOrden
    pago_id?: InputMaybe<Scalars["ID"]["input"]>
    tipo_pago?: InputMaybe<TiposPagos>
    ultimos_digitos?: InputMaybe<Scalars["String"]["input"]>
}

export interface QueryDisponibilidad_HabitacionArgs {
    hotel_id: Scalars["ID"]["input"]
    tipo_habitacion_id: Scalars["ID"]["input"]
}

export interface QueryDisponibilidad_HabitacionesArgs {
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryExiste_HotelArgs {
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryExiste_Metodo_De_PagoArgs {
    metodo_de_pago_id: Scalars["ID"]["input"]
}

export interface QueryExiste_UsuarioArgs {
    usuario_id: Scalars["ID"]["input"]
}

export interface QueryExperienciasArgs {
    cobro_unico?: InputMaybe<Scalars["Boolean"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    estado?: InputMaybe<EstadosExperiencias>
    experiencia_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryExtraArgs {
    extra_id: Scalars["ID"]["input"]
}

export interface QueryExtrasArgs {
    extra_id: Array<Scalars["ID"]["input"]>
    fecha_cancelacion?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_pago?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_solicitud?: InputMaybe<Scalars["DateTime"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    monto_devuelto_cancelacion?: InputMaybe<Scalars["Float"]["input"]>
    monto_extra?: InputMaybe<Scalars["Float"]["input"]>
    motivo_cancelacion?: InputMaybe<Scalars["String"]["input"]>
    numero?: InputMaybe<Scalars["Int"]["input"]>
    renta_id?: InputMaybe<Scalars["ID"]["input"]>
    tipo_extra?: InputMaybe<TiposExtras>
    venta_checkin?: InputMaybe<Scalars["Boolean"]["input"]>
    venta_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryFajillaArgs {
    fajilla_id: Scalars["ID"]["input"]
}

export interface QueryFajillasArgs {
    configuracion_fajilla_id?: InputMaybe<Scalars["ID"]["input"]>
    estatus?: InputMaybe<EstatusFajillas>
    estatus_not_in?: InputMaybe<Array<EstatusFajillas>>
    fecha_autorizaicion?: InputMaybe<DateSearchInput>
    fecha_creacion?: InputMaybe<DateSearchInput>
    folio_integracion?: InputMaybe<Scalars["String"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    monto?: InputMaybe<Scalars["Float"]["input"]>
    origen?: InputMaybe<OrigenesFajillas>
    ticket_id?: InputMaybe<Scalars["ID"]["input"]>
    turno_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_autorizo_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_creo_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryFindAllPagoRentaArgs {
    pago_id: Array<Scalars["ID"]["input"]>
    renta_id: Array<Scalars["ID"]["input"]>
}

export interface QueryFindAllPagosReservasArgs {
    pago_id: Array<Scalars["ID"]["input"]>
    reserva_id: Array<Scalars["ID"]["input"]>
}

export interface QueryFindDistinctVehiculoFieldArgs {
    campo: CampoVehiculo
    limite?: InputMaybe<Scalars["Float"]["input"]>
}

export interface QueryFindOnePagosReservasByIdInputArgs {
    pago_reserva_id: Scalars["ID"]["input"]
}

export interface QueryFuncionalidadArgs {
    funcionalidad_id: Scalars["ID"]["input"]
}

export interface QueryFuncionalidadesArgs {
    modulo_id?: InputMaybe<Scalars["ID"]["input"]>
    nombre_funcionalidad?: InputMaybe<Scalars["String"]["input"]>
}

export interface QueryGastoArgs {
    gasto_id: Scalars["ID"]["input"]
}

export interface QueryGastosArgs {
    caja_chica?: InputMaybe<Scalars["Boolean"]["input"]>
    categoria_id?: InputMaybe<Scalars["ID"]["input"]>
    corte_id?: InputMaybe<Scalars["ID"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    fecha_gasto?: InputMaybe<DateSearchInput>
    fecha_registro?: InputMaybe<DateSearchInput>
    folio?: InputMaybe<Scalars["Float"]["input"]>
    gasto_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    metodo_pago?: InputMaybe<Scalars["String"]["input"]>
    monto?: InputMaybe<Scalars["Float"]["input"]>
    pagination_options?: InputMaybe<PageOptionsArgs>
    rol?: InputMaybe<Scalars["String"]["input"]>
    search_text?: InputMaybe<Scalars["String"]["input"]>
    subcategoria_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryGastos_Categoria_Por_MesArgs {
    cantidad_categorias?: InputMaybe<Scalars["Int"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    mes_y_anio?: InputMaybe<Scalars["String"]["input"]>
    month?: InputMaybe<Scalars["String"]["input"]>
}

export interface QueryGastos_Categoria_Por_MesesArgs {
    caja_chica?: InputMaybe<Scalars["Boolean"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    month: Array<Scalars["String"]["input"]>
}

export interface QueryGastos_Por_MesArgs {
    caja_chica?: InputMaybe<Scalars["Boolean"]["input"]>
    cantidad_categorias?: InputMaybe<Scalars["Int"]["input"]>
    categoria_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    mes_y_anio?: InputMaybe<Scalars["String"]["input"]>
    month?: InputMaybe<Scalars["String"]["input"]>
}

export interface QueryGetVehiculoDataByPlacaArgs {
    placa: GetVehiculoDataByPlacaInput
}

export interface QueryGrupo_HotelArgs {
    grupo_hotel_id: Scalars["ID"]["input"]
}

export interface QueryGrupos_HotelesArgs {
    nombre_grupo?: InputMaybe<Scalars["String"]["input"]>
}

export interface QueryHabitacionArgs {
    habitacion_id: Scalars["ID"]["input"]
}

export interface QueryHabitacion_Mas_VendidaArgs {
    hotel_id: Scalars["String"]["input"]
}

export interface QueryHabitacion_Top_Rentas_Del_DiaArgs {
    hotel_id: Scalars["String"]["input"]
}

export interface QueryHabitacion_Top_Reservas_Del_DiaArgs {
    hotel_id: Scalars["String"]["input"]
}

export interface QueryHabitacionesArgs {
    comentario_estado?: InputMaybe<Scalars["String"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    estado?: InputMaybe<Estados_Habitaciones>
    expirado?: InputMaybe<Scalars["Boolean"]["input"]>
    fecha_estado?: InputMaybe<Scalars["DateTime"]["input"]>
    habitacion_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    numero_habitacion?: InputMaybe<Scalars["String"]["input"]>
    piso?: InputMaybe<Scalars["String"]["input"]>
    subestado?: InputMaybe<SubestadosHabitaciones>
    tipo_habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryHabitaciones_MesasArgs {
    comentario_estado?: InputMaybe<Scalars["String"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    estado?: InputMaybe<Estados_Habitaciones>
    expirado?: InputMaybe<Scalars["Boolean"]["input"]>
    fecha_estado?: InputMaybe<Scalars["DateTime"]["input"]>
    habitacion_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    numero_habitacion?: InputMaybe<Scalars["String"]["input"]>
    piso?: InputMaybe<Scalars["String"]["input"]>
    subestado?: InputMaybe<SubestadosHabitaciones>
    tipo_habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryHistorial_Estados_ComandaArgs {
    comanda_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    estado_comanda?: InputMaybe<EstadosComandaHistorial>
    fecha_fin?: InputMaybe<DateSearchInput>
    fecha_registro?: InputMaybe<DateSearchInput>
    historial_estado_comanda_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    numero_mesa?: InputMaybe<Array<Scalars["String"]["input"]>>
    numero_orden?: InputMaybe<Scalars["String"]["input"]>
    pagination_options?: InputMaybe<PageOptionsArgs>
}

export interface QueryHistorial_Estados_OrdenArgs {
    estado_orden?: InputMaybe<Array<EstadosOrdenHistorial>>
    fecha_fin?: InputMaybe<DateSearchInput>
    fecha_registro?: InputMaybe<DateSearchInput>
    historial_estado_orden_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    numero_orden?: InputMaybe<Scalars["String"]["input"]>
    orden_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    pagination_options?: InputMaybe<PageOptionsArgs>
    tipo_orden?: InputMaybe<TipoOrden>
}

export interface QueryHistorial_HabitacionArgs {
    historial_habitacion_id: Scalars["ID"]["input"]
}

export interface QueryHistorial_HabitacionesArgs {
    accion?: InputMaybe<Scalars["String"]["input"]>
    data?: InputMaybe<HistorialHabitacionesData>
    fecha?: InputMaybe<Scalars["DateTime"]["input"]>
    habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
    historial_habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryHistorial_Movimiento_InventarioArgs {
    historial_movimiento_inventario_id: Scalars["ID"]["input"]
}

export interface QueryHistorial_Movimientos_InventarioArgs {
    articulo_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    cantidad?: InputMaybe<Scalars["Float"]["input"]>
    costo_actual?: InputMaybe<Scalars["Float"]["input"]>
    fecha_registro?: InputMaybe<MonthSearchInput>
    folio?: InputMaybe<Scalars["Int"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    movimiento?: InputMaybe<MovimientoHistorialInventario>
    nombre_articulo?: InputMaybe<Scalars["String"]["input"]>
    pagination_options?: InputMaybe<PageOptionsArgs>
    precio?: InputMaybe<Scalars["Float"]["input"]>
    salida_id?: InputMaybe<Scalars["ID"]["input"]>
    surtido_id?: InputMaybe<Scalars["ID"]["input"]>
    tipo?: InputMaybe<TipoMovimientoHistorialInventario>
    tipo_articulo?: InputMaybe<TipoArticulo>
}

export interface QueryHistorial_Produccion_InventarioArgs {
    historial_produccion_inventario_id: Scalars["ID"]["input"]
}

export interface QueryHistorial_Producciones_InventariosArgs {
    articulo_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    fecha_produccion?: InputMaybe<MonthSearchInput>
    folio?: InputMaybe<Scalars["Int"]["input"]>
    historial_produccion_inventario_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryHotelArgs {
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryHotel_ColaboradorArgs {
    hotel_colaborador_id: Scalars["ID"]["input"]
}

export interface QueryHotel_ColaboradoresArgs {
    area_id?: InputMaybe<Scalars["ID"]["input"]>
    colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    hotel_colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    puesto_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryHotelesArgs {
    calle?: InputMaybe<Scalars["String"]["input"]>
    ciudad?: InputMaybe<Scalars["String"]["input"]>
    colonia?: InputMaybe<Scalars["String"]["input"]>
    correo?: InputMaybe<Scalars["String"]["input"]>
    cp?: InputMaybe<Scalars["String"]["input"]>
    easyrewards_sucursal_id?: InputMaybe<Scalars["String"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    estado?: InputMaybe<Scalars["String"]["input"]>
    estatus?: InputMaybe<Scalars["String"]["input"]>
    fecha_creacion?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_modificacion?: InputMaybe<Scalars["DateTime"]["input"]>
    grupo_hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    logo_hotel?: InputMaybe<Scalars["String"]["input"]>
    nombre_hotel?: InputMaybe<Scalars["String"]["input"]>
    numero_exterior?: InputMaybe<Scalars["String"]["input"]>
    numero_interior?: InputMaybe<Scalars["String"]["input"]>
    razon_social?: InputMaybe<Scalars["String"]["input"]>
    rfc?: InputMaybe<Scalars["String"]["input"]>
    telefono?: InputMaybe<Scalars["String"]["input"]>
    zona_horaria?: InputMaybe<Scalars["String"]["input"]>
}

export interface QueryImagenes_Hoteles_Grupo_HotelArgs {
    grupo_hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryIncidenciaArgs {
    incidencia_id: Scalars["ID"]["input"]
}

export interface QueryIncidenciasArgs {
    area?: InputMaybe<Scalars["String"]["input"]>
    colaborador_id_cierra?: InputMaybe<Scalars["ID"]["input"]>
    colaborador_id_reporta?: InputMaybe<Scalars["ID"]["input"]>
    detalle?: InputMaybe<Scalars["String"]["input"]>
    estado?: InputMaybe<Estados_Incidencias>
    fecha_apertura?: InputMaybe<DateSearchInput>
    fecha_cierre?: InputMaybe<DateSearchInput>
    fecha_operacion?: InputMaybe<DateSearchInput>
    fecha_registro?: InputMaybe<DateSearchInput>
    folio?: InputMaybe<Scalars["Int"]["input"]>
    habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    huesped?: InputMaybe<Scalars["String"]["input"]>
    incidencia_id?: InputMaybe<Scalars["ID"]["input"]>
    matricula?: InputMaybe<Scalars["String"]["input"]>
    search?: InputMaybe<Scalars["String"]["input"]>
    severidad?: InputMaybe<Scalars["String"]["input"]>
    tipo_incidencia?: InputMaybe<Scalars["String"]["input"]>
    turno_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryInforme_Historial_Movimientos_InventarioArgs {
    fecha_registro?: InputMaybe<DateSearchInput>
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryInforme_InventarioArgs {
    almacen_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryIngredientes_RecetasArgs {
    articulo_id?: InputMaybe<Scalars["ID"]["input"]>
    cantidad?: InputMaybe<Scalars["Float"]["input"]>
    ingrediente_receta_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    receta_id?: InputMaybe<Scalars["ID"]["input"]>
    unidad?: InputMaybe<UnidadMedidasArticulo>
}

export interface QueryKpis_Historial_Producciones_InventariosArgs {
    articulo_id: Scalars["ID"]["input"]
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryKpis_MantenimientosArgs {
    fecha_registro: DateSearchInput
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryMantenimientoArgs {
    mantenimiento_id: Scalars["ID"]["input"]
}

export interface QueryMantenimientosArgs {
    agua?: InputMaybe<Scalars["Float"]["input"]>
    corte_id?: InputMaybe<Scalars["ID"]["input"]>
    fecha_actualizacion?: InputMaybe<DateSearchInput>
    fecha_registro?: InputMaybe<DateSearchInput>
    gas?: InputMaybe<Scalars["Float"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    luz?: InputMaybe<Scalars["Float"]["input"]>
    mantenimiento_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    turno_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
}

export interface QueryMesaArgs {
    mesa_id: Scalars["ID"]["input"]
}

export interface QueryMesa_AsignadaArgs {
    mesa_asignada_id: Scalars["ID"]["input"]
}

export interface QueryMesasArgs {
    cantidad_personas?: InputMaybe<Scalars["Float"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    estado?: InputMaybe<Array<EstadoMesa>>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    mesa_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    numero_mesa?: InputMaybe<Scalars["String"]["input"]>
    usuario_modifico_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryMesas_AsignadasArgs {
    colaborador_asignado_id?: InputMaybe<Scalars["ID"]["input"]>
    fecha_registro?: InputMaybe<DateSearchInput>
    fecha_salida?: InputMaybe<DateSearchInput>
    mesa_asignada_id?: InputMaybe<Scalars["ID"]["input"]>
    mesa_id?: InputMaybe<Scalars["ID"]["input"]>
    orden_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryMetodo_De_PagoArgs {
    metododepago_id: Scalars["ID"]["input"]
}

export interface QueryMetodos_De_PagoArgs {
    default?: InputMaybe<Scalars["Boolean"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    estatus?: InputMaybe<Scalars["String"]["input"]>
    metododepago_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryModuloArgs {
    modulo_id: Scalars["ID"]["input"]
}

export interface QueryModulosArgs {
    descripcion?: InputMaybe<Scalars["String"]["input"]>
    nombre_modulo?: InputMaybe<Scalars["String"]["input"]>
}

export interface QueryMonedaArgs {
    moneda_id: Scalars["ID"]["input"]
}

export interface QueryMonedasArgs {
    clave?: InputMaybe<Scalars["String"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    icono?: InputMaybe<Scalars["String"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    simbolo?: InputMaybe<Scalars["String"]["input"]>
}

export interface QueryMotivo_Ingreso_VehiculoArgs {
    motivo_ingreso_id: Scalars["ID"]["input"]
}

export interface QueryMotivos_Ingreso_VehiculosArgs {
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    motivo_ingreso_id?: InputMaybe<Scalars["ID"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
}

export interface QueryMovimientos_Antes_CorteArgs {
    fecha_fin: Scalars["DateTime"]["input"]
    fecha_inicio: Scalars["DateTime"]["input"]
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryNotificacionesArgs {
    hotel_id?: InputMaybe<Array<Scalars["String"]["input"]>>
    notificacion_id?: InputMaybe<Array<Scalars["String"]["input"]>>
    tipo?: InputMaybe<TipoNotificacion>
    topic?: InputMaybe<Scalars["String"]["input"]>
}

export interface QueryNotificaciones_No_Leidas_AlertaArgs {
    hotel_id: Scalars["String"]["input"]
    usuario_id: Scalars["String"]["input"]
}

export interface QueryObten_SaldoArgs {
    easyrewards_id: Scalars["String"]["input"]
}

export interface QueryObtener_Bandeja_IncidenciasArgs {
    bandeja_notificaciones_id?: InputMaybe<Scalars["String"]["input"]>
    fecha_registro?: InputMaybe<Scalars["DateTime"]["input"]>
    hotel_id?: InputMaybe<Array<Scalars["String"]["input"]>>
    incidencia_id?: InputMaybe<Scalars["String"]["input"]>
    leido?: InputMaybe<Scalars["Boolean"]["input"]>
    notificacion_id?: InputMaybe<Array<Scalars["String"]["input"]>>
    tipo?: InputMaybe<Array<TipoNotificacion>>
    usuario_id?: InputMaybe<Array<Scalars["String"]["input"]>>
}

export interface QueryObtener_Bandeja_NotificacionesArgs {
    bandeja_notificaciones_id?: InputMaybe<Scalars["String"]["input"]>
    fecha_registro?: InputMaybe<Scalars["DateTime"]["input"]>
    hotel_id?: InputMaybe<Array<Scalars["String"]["input"]>>
    incidencia_id?: InputMaybe<Scalars["String"]["input"]>
    leido?: InputMaybe<Scalars["Boolean"]["input"]>
    notificacion_id?: InputMaybe<Array<Scalars["String"]["input"]>>
    tipo?: InputMaybe<Array<TipoNotificacion>>
    usuario_id?: InputMaybe<Array<Scalars["String"]["input"]>>
}

export interface QueryObtener_Ordenes_No_PagadasArgs {
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryObtener_Porcentaje_Promedio_OcupacionArgs {
    fecha_final: Scalars["DateTime"]["input"]
    fecha_inicial: Scalars["DateTime"]["input"]
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryObtener_VentasArgs {
    get_today_sales_input: GetTodaySalesInput
}

export interface QueryObtener_Ventas_ExtrasArgs {
    fecha_final: Scalars["DateTime"]["input"]
    fecha_inicial: Scalars["DateTime"]["input"]
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryObtener_Ventas_OrdenesArgs {
    fecha_final: Scalars["DateTime"]["input"]
    fecha_inicial: Scalars["DateTime"]["input"]
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryObtener_Ventas_RentasArgs {
    fecha_final: Scalars["DateTime"]["input"]
    fecha_inicial: Scalars["DateTime"]["input"]
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryObtener_Ventas_ReservasArgs {
    fecha_final: Scalars["DateTime"]["input"]
    fecha_inicial: Scalars["DateTime"]["input"]
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryOrdenArgs {
    orden_id: Scalars["ID"]["input"]
}

export interface QueryOrdenesArgs {
    colaborador_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    consumo_interno_colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    corte_id?: InputMaybe<Scalars["ID"]["input"]>
    easyrewards_id?: InputMaybe<Scalars["String"]["input"]>
    estado_orden?: InputMaybe<EstadosOrdenHistorial>
    estado_pago?: InputMaybe<Array<EstadoPagoOrdenes>>
    fecha_cobro?: InputMaybe<DateSearchInput>
    fecha_registro?: InputMaybe<DateSearchInput>
    filter_by_detalle_orden_state?: InputMaybe<Array<EstadosDetalleOrden>>
    filter_comanda?: InputMaybe<Scalars["Boolean"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    orden?: InputMaybe<Scalars["String"]["input"]>
    orden_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    pago_id?: InputMaybe<Scalars["ID"]["input"]>
    panel_no_visible?: InputMaybe<Scalars["Boolean"]["input"]>
    renta_id?: InputMaybe<Scalars["ID"]["input"]>
    turno_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryOrdenes_PaginadasArgs {
    estado?: InputMaybe<Array<EstadosOrdenHistorial>>
    estado_pago?: InputMaybe<Array<EstadoPagoOrdenes>>
    fecha_registro?: InputMaybe<DateSearchInput>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    metodo_pago?: InputMaybe<Array<TiposPagos>>
    orden?: InputMaybe<Scalars["String"]["input"]>
    origen?: InputMaybe<Array<OrigenesOrden>>
    pagination_options?: InputMaybe<PageOptionsArgs>
    turno_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
}

export interface QueryPaginacion_Colaboradores_TareaArgs {
    pageOptions?: InputMaybe<PageOptionsArgs>
    search?: InputMaybe<FindAllColaboradoresTareaRequest>
}

export interface QueryPagosArgs {
    cancelados?: InputMaybe<Scalars["Boolean"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    not_in_origen_orden?: InputMaybe<Array<OrigenOrden>>
    pago_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    ticket_id?: InputMaybe<Scalars["ID"]["input"]>
    total?: InputMaybe<Scalars["Float"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryPagos_PropinasArgs {
    colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    fecha_registro?: InputMaybe<MonthSearchInput>
    hotel_id: Scalars["ID"]["input"]
    pago_propina_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
}

export interface QueryPersonalizacion_TicketArgs {
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryPlacas_PendientesArgs {
    hotel_id: Scalars["ID"]["input"]
    limite?: InputMaybe<Scalars["Int"]["input"]>
    matricula: Scalars["String"]["input"]
}

export interface QueryPropinasArgs {
    colaborador_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    fecha_eliminado?: InputMaybe<DateSearchInput>
    fecha_registro?: InputMaybe<DateSearchInput>
    folio?: InputMaybe<Array<Scalars["Float"]["input"]>>
    hotel_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    procedencia?: InputMaybe<Array<ProcedenciaPropina>>
    procedencia_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    propina_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    turno_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryPuestoArgs {
    puesto_id: Scalars["ID"]["input"]
}

export interface QueryPuestosArgs {
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    esquema_propinas_activo?: InputMaybe<Scalars["Boolean"]["input"]>
    estado?: InputMaybe<Scalars["String"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    puesto_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryPuestos_De_HotelArgs {
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryRecetaArgs {
    articulo_id: Scalars["ID"]["input"]
}

export interface QueryRecetasArgs {
    almacen_articulo_id?: InputMaybe<Scalars["ID"]["input"]>
    articulo_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
}

export interface QueryRentaArgs {
    renta_id: Scalars["ID"]["input"]
}

export interface QueryRentasArgs {
    easyrewards_id?: InputMaybe<Scalars["String"]["input"]>
    estado?: InputMaybe<EstadosRentas>
    fecha_cancelacion?: InputMaybe<DateSearchInput>
    fecha_condensada?: InputMaybe<DateSearchInput>
    fecha_fin?: InputMaybe<DateSearchInput>
    fecha_registro?: InputMaybe<DateSearchInput>
    fecha_salida?: InputMaybe<DateSearchInput>
    habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
    horas_extra?: InputMaybe<Scalars["Float"]["input"]>
    hospedajes_extra?: InputMaybe<Scalars["Float"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    monto_devuelto_cancelacion?: InputMaybe<Scalars["Float"]["input"]>
    numero_personas?: InputMaybe<Scalars["Float"]["input"]>
    personas_extra?: InputMaybe<Scalars["Float"]["input"]>
    placas?: InputMaybe<Scalars["String"]["input"]>
    renta_id: Array<Scalars["ID"]["input"]>
    reserva_id?: InputMaybe<Scalars["ID"]["input"]>
    tarifa_id?: InputMaybe<Scalars["ID"]["input"]>
    tipo_alojamiento?: InputMaybe<TiposAlojamientos>
    tipo_entrada?: InputMaybe<TiposEntradas>
    tipos_alojamientos?: InputMaybe<TiposAlojamientos>
    total?: InputMaybe<Scalars["Float"]["input"]>
    usar_corte_nocturno?: InputMaybe<Scalars["Boolean"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryReporte_PropinasArgs {
    hotel_id: Scalars["ID"]["input"]
}

export interface QueryReservaArgs {
    reserva_id: Scalars["ID"]["input"]
}

export interface QueryReservasArgs {
    cliente_id?: InputMaybe<Scalars["ID"]["input"]>
    codigo?: InputMaybe<Scalars["String"]["input"]>
    codigo_ota?: InputMaybe<Scalars["String"]["input"]>
    correo_huesped?: InputMaybe<Scalars["String"]["input"]>
    corte_id?: InputMaybe<Scalars["ID"]["input"]>
    easyrewards_id?: InputMaybe<Scalars["String"]["input"]>
    estado?: InputMaybe<EstadosReservas>
    estado_pago?: InputMaybe<EstadoPago>
    fecha_cancelacion?: InputMaybe<DateSearchInput>
    fecha_entrada?: InputMaybe<DateSearchInput>
    fecha_registro?: InputMaybe<DateSearchInput>
    fecha_salida?: InputMaybe<DateSearchInput>
    folio?: InputMaybe<Scalars["String"]["input"]>
    habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    nombre_huesped?: InputMaybe<Scalars["String"]["input"]>
    numero_personas?: InputMaybe<Scalars["Int"]["input"]>
    origen?: InputMaybe<OrigenRservas>
    personas_extras?: InputMaybe<Scalars["Int"]["input"]>
    reserva_id: Array<Scalars["ID"]["input"]>
    search?: InputMaybe<Scalars["String"]["input"]>
    tarifa_id?: InputMaybe<Scalars["ID"]["input"]>
    telefono_huesped?: InputMaybe<Scalars["String"]["input"]>
    tipo_habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryReservas_Sin_Asignar_Del_DiaArgs {
    fecha_entrada: Scalars["DateTime"]["input"]
    hotel_id: Scalars["String"]["input"]
    tipo_habitacion_id?: InputMaybe<Scalars["String"]["input"]>
}

export interface QueryRolArgs {
    rol_id: Scalars["ID"]["input"]
}

export interface QueryRolesArgs {
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    grupo_hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
}

export interface QuerySalida_InventarioArgs {
    salida_id: Scalars["ID"]["input"]
}

export interface QuerySalidas_InventarioArgs {
    almacen_articulo_id?: InputMaybe<Scalars["ID"]["input"]>
    cantidad?: InputMaybe<Scalars["Float"]["input"]>
    colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    detalle_orden_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    fecha_salida?: InputMaybe<DateSearchInput>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    motivo?: InputMaybe<Motivo>
    salida_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
}

export interface QueryServicioArgs {
    servicio_id: Scalars["ID"]["input"]
}

export interface QueryServiciosArgs {
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    servicio_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QuerySubcategoria_GastoArgs {
    subcategoria_gasto_id: Scalars["ID"]["input"]
}

export interface QuerySubcategoria_ProductoArgs {
    subcategoria_id: Scalars["ID"]["input"]
}

export interface QuerySubcategorias_GastoArgs {
    categoria_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    mes_y_anio?: InputMaybe<MonthSearchInput>
    subcategoria?: InputMaybe<Scalars["String"]["input"]>
    subcategoria_gasto_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QuerySubcategorias_ProductosArgs {
    categoria_id: Array<Scalars["ID"]["input"]>
    subcategoria?: InputMaybe<Scalars["String"]["input"]>
    subcategoria_id: Array<Scalars["ID"]["input"]>
}

export interface QuerySurtidoArgs {
    surtido_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QuerySurtidosArgs {
    almacen_articulo_id?: InputMaybe<Scalars["ID"]["input"]>
    cantidad?: InputMaybe<Scalars["Float"]["input"]>
    colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    comentario?: InputMaybe<Scalars["String"]["input"]>
    costo_total?: InputMaybe<Scalars["Float"]["input"]>
    costo_unitario?: InputMaybe<Scalars["Float"]["input"]>
    fecha_ingreso?: InputMaybe<DateSearchInput>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    numero_orden_factura?: InputMaybe<Scalars["String"]["input"]>
    surtido_id?: InputMaybe<Scalars["ID"]["input"]>
    tipo?: InputMaybe<TiposSurtido>
}

export interface QuerySuscripcionArgs {
    suscripcion_id: Scalars["ID"]["input"]
}

export interface QuerySuscripcionesArgs {
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    estatus?: InputMaybe<Scalars["String"]["input"]>
    fecha_expiracion?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_inicio?: InputMaybe<Scalars["DateTime"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    suscripcion_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryTareaArgs {
    tarea_id: Scalars["ID"]["input"]
}

export interface QueryTareasArgs {
    descripcion?: InputMaybe<Scalars["String"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    puesto_id?: InputMaybe<Scalars["ID"]["input"]>
    tarea_id?: InputMaybe<Scalars["ID"]["input"]>
    tipo?: InputMaybe<TiposTarea>
}

export interface QueryTarifaArgs {
    tarifa_id: Scalars["ID"]["input"]
}

export interface QueryTarifasArgs {
    costo_habitacion?: InputMaybe<Scalars["Float"]["input"]>
    costo_hora_extra?: InputMaybe<Scalars["Float"]["input"]>
    costo_hospedaje_extra?: InputMaybe<Scalars["Float"]["input"]>
    costo_persona_extra?: InputMaybe<Scalars["Float"]["input"]>
    dias_disponibles?: InputMaybe<Array<DiasDisponibles>>
    domingo?: InputMaybe<Scalars["Boolean"]["input"]>
    duracion_renta?: InputMaybe<Scalars["Float"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    estatus?: InputMaybe<EstatusTarifa>
    fecha_final?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_inicio?: InputMaybe<Scalars["DateTime"]["input"]>
    hora_final?: InputMaybe<Scalars["String"]["input"]>
    hora_inicio?: InputMaybe<Scalars["String"]["input"]>
    horas_extra_max?: InputMaybe<Scalars["Float"]["input"]>
    hospedajes_extra_max?: InputMaybe<Scalars["Float"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    jueves?: InputMaybe<Scalars["Boolean"]["input"]>
    lunes?: InputMaybe<Scalars["Boolean"]["input"]>
    martes?: InputMaybe<Scalars["Boolean"]["input"]>
    miercoles?: InputMaybe<Scalars["Boolean"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    pantalla_disponibilidad?: InputMaybe<Scalars["Boolean"]["input"]>
    personas_extra_max?: InputMaybe<Scalars["Float"]["input"]>
    sabado?: InputMaybe<Scalars["Boolean"]["input"]>
    tarifa_id?: InputMaybe<Scalars["ID"]["input"]>
    tarifa_imas?: InputMaybe<Scalars["String"]["input"]>
    tipo_alojamiento?: InputMaybe<TiposAlojamientos>
    tipo_habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
    tipo_tarifa?: InputMaybe<TipoTarifa>
    viernes?: InputMaybe<Scalars["Boolean"]["input"]>
    visible_venta?: InputMaybe<Scalars["Boolean"]["input"]>
}

export interface QueryTicketArgs {
    ticket_id: Scalars["ID"]["input"]
}

export interface QueryTicketsArgs {
    cancelado?: InputMaybe<Scalars["Boolean"]["input"]>
    colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    consumo_interno?: InputMaybe<Scalars["Boolean"]["input"]>
    corte_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    cortesia?: InputMaybe<Scalars["Boolean"]["input"]>
    fecha_cancelacion?: InputMaybe<DateSearchInput>
    fecha_impresion?: InputMaybe<DateSearchInput>
    folio?: InputMaybe<Scalars["Int"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    reserva_id?: InputMaybe<Scalars["ID"]["input"]>
    ticket_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    usuario_cancelacion_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryTipo_BloqueoArgs {
    tipo_bloqueo_id: Scalars["ID"]["input"]
}

export interface QueryTipo_HabitacionArgs {
    tipo_habitacion_id: Scalars["ID"]["input"]
}

export interface QueryTipo_HabitacionesArgs {
    amenidades?: InputMaybe<Array<Scalars["String"]["input"]>>
    camas?: InputMaybe<Array<CamaArgs>>
    clave?: InputMaybe<Scalars["String"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    personas_incluidas?: InputMaybe<Scalars["Int"]["input"]>
    tipo_habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryTipo_MantenimientoArgs {
    tipo_mantenimiento_id: Scalars["ID"]["input"]
}

export interface QueryTipos_BloqueoArgs {
    claves?: InputMaybe<Array<ClaveTipoBloqueoArgs>>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    tipo_bloqueo_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryTipos_MantenimientoArgs {
    claves?: InputMaybe<Array<ClaveTipoMantenimientoInput>>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    tipo_mantenimiento_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryTotal_Gastos_Por_Dia_RecepcionistaArgs {
    categoria_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryTotales_Gastos_Subcategoria_Por_CategoriaArgs {
    caja_chica?: InputMaybe<Scalars["Boolean"]["input"]>
    cantidad_categorias?: InputMaybe<Scalars["Int"]["input"]>
    categoria_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    mes_y_anio?: InputMaybe<Scalars["String"]["input"]>
    month?: InputMaybe<Scalars["String"]["input"]>
}

export interface QueryTotales_PropinasArgs {
    colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    fecha_propina?: InputMaybe<DateSearchInput>
    hotel_id: Scalars["ID"]["input"]
    turno_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryTransaccionArgs {
    transaccion_id: Scalars["ID"]["input"]
}

export interface QueryTransaccionesArgs {
    cantidad?: InputMaybe<Scalars["Int"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    estatus?: InputMaybe<Scalars["String"]["input"]>
    fecha_creacion?: InputMaybe<Scalars["DateTime"]["input"]>
    metododepago_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryTransacciones_RentaArgs {
    renta_id: Scalars["ID"]["input"]
}

export interface QueryTurnoArgs {
    turno_id: Scalars["ID"]["input"]
}

export interface QueryTurno_AtencionArgs {
    turno_atencion_id: Scalars["ID"]["input"]
}

export interface QueryTurnosArgs {
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    estado?: InputMaybe<EstadosTurno>
    hora_entrada?: InputMaybe<Scalars["String"]["input"]>
    hora_salida?: InputMaybe<Scalars["String"]["input"]>
    hotel_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    orden?: InputMaybe<Scalars["Int"]["input"]>
    turno_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
}

export interface QueryTurnos_AtencionArgs {
    estado?: InputMaybe<Array<EstadosTurnosAtencion>>
    fecha_registro?: InputMaybe<DateSearchInput>
    hotel_id: Scalars["ID"]["input"]
    tipo_habitacion_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    turno_atencion_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
}

export interface QueryUltima_Tarea_Asignada_A_ColaboradorArgs {
    colaboradores_ids: Array<Scalars["ID"]["input"]>
}

export interface QueryUltimo_CorteArgs {
    hotel_id: Scalars["ID"]["input"]
    turno_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface QueryUsuarioArgs {
    usuario_id: Scalars["ID"]["input"]
}

export interface QueryUsuariosArgs {
    apellido_materno?: InputMaybe<Scalars["String"]["input"]>
    apellido_paterno?: InputMaybe<Scalars["String"]["input"]>
    correo?: InputMaybe<Scalars["String"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    estatus?: InputMaybe<Scalars["String"]["input"]>
    fecha_modificacion?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_registro?: InputMaybe<Scalars["DateTime"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    origen?: InputMaybe<Scalars["String"]["input"]>
    pais?: InputMaybe<Scalars["String"]["input"]>
    puesto?: InputMaybe<Scalars["String"]["input"]>
    telefono?: InputMaybe<Scalars["String"]["input"]>
    usuario?: InputMaybe<Scalars["String"]["input"]>
    verificado?: InputMaybe<Scalars["Boolean"]["input"]>
}

export interface QueryUsuarios_NotificacionesArgs {
    hotel_id: Scalars["String"]["input"]
    usuario_id: Scalars["String"]["input"]
}

export interface QueryValidateApiKeyArgs {
    input: ValidateApiKeyInput
}

export interface QueryVentas_Habitaciones_Por_TurnoArgs {
    sales_rooms_count_by_turnos_input: SalesRoomsCountByTurnosInput
}

export interface QueryVerificar_Limite_ReservasArgs {
    fechas_reserva: DateSearchInput
    hotel_id: Scalars["ID"]["input"]
    tipo_habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface Receta {
    __typename?: "Receta"
    almacen_articulo?: Maybe<AlmacenArticulo>
    articulo?: Maybe<Articulo>
    articulo_id: Scalars["ID"]["output"]
    ingredientes?: Maybe<Array<IngredienteReceta>>
    ingredientes_recetas?: Maybe<Array<IngredienteReceta>>
    precio?: Maybe<Scalars["Float"]["output"]>
}

export interface RecetaAlmacen_ArticuloArgs {
    hotel_id: Scalars["ID"]["input"]
}

export interface RecetaPrecioArgs {
    almacen_articulo_id?: InputMaybe<Scalars["String"]["input"]>
}

export interface RechazarFajillaInput {
    comentario?: InputMaybe<Scalars["String"]["input"]>
    fajilla_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface RefundDetalleOrdenDetailInput {
    detalle_orden_id: Scalars["ID"]["input"]
    merma: Scalars["Boolean"]["input"]
    reembolso: Scalars["Boolean"]["input"]
}

export interface RefundDetallesOrdenInput {
    detalles_orden: Array<RefundDetalleOrdenDetailInput>
    motivo_cancelacion: Scalars["String"]["input"]
}

export interface RefundOrdenInput {
    detalles_orden?: InputMaybe<RefundDetallesOrdenInput>
    orden_id: Scalars["ID"]["input"]
}

export interface RegisterUsuarioDispositivoInput {
    dispositivo_id: Scalars["ID"]["input"]
    token_fcm: Scalars["String"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface RegistroPagoPendienteOutput {
    __typename?: "RegistroPagoPendienteOutput"
    categoria: Scalars["String"]["output"]
    concepto: Scalars["String"]["output"]
    fecha: Scalars["DateTime"]["output"]
    folio: Scalars["String"]["output"]
    monto: Scalars["Float"]["output"]
    orden?: Maybe<Orden>
    orden_id?: Maybe<Scalars["ID"]["output"]>
    renta?: Maybe<Renta>
    renta_id?: Maybe<Scalars["ID"]["output"]>
}

export interface ReleaseHabitacionInput {
    estado: Release_Estados_Habitaciones
    habitacion_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface RemoveBookingFromRoomInput {
    habitacion_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface RemoveColaboradorFromHotelInput {
    area_id: Scalars["ID"]["input"]
    colaborador_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
    puesto_id: Scalars["ID"]["input"]
}

export interface Renta {
    __typename?: "Renta"
    cliente_id?: Maybe<Scalars["ID"]["output"]>
    comentarios: Array<ComentariosInfoRenta>
    /** Conceptos pendientes de la renta (estancia y/o extras) */
    conceptos_pendientes?: Maybe<GetConceptosPendientesRentaOutput>
    /** Colaborador asociado al consumo interno de la renta */
    consumo_interno_colaborador?: Maybe<Colaborador>
    /** colaborador_id asociado al consumo interno de la renta */
    consumo_interno_colaborador_id?: Maybe<Scalars["ID"]["output"]>
    corte_id?: Maybe<Scalars["String"]["output"]>
    early_checkin?: Maybe<Scalars["Boolean"]["output"]>
    easyrewards_id?: Maybe<Scalars["String"]["output"]>
    /** Indica si la renta puede ser cancelada según las reglas de cancelacion entre cortes */
    es_renta_cancelable: Scalars["Boolean"]["output"]
    estado: EstadosRentas
    extras?: Maybe<Array<Extra>>
    /** Fecha más antigua en la que una orden asociada a la renta pasó a estado en_entrega */
    fecha_antigua_en_entrega?: Maybe<Scalars["DateTime"]["output"]>
    /** Fecha más antigua en la que una orden asociada a la renta pasó a estado por_entregar */
    fecha_antigua_por_entregar?: Maybe<Scalars["DateTime"]["output"]>
    fecha_cancelacion?: Maybe<Scalars["DateTime"]["output"]>
    /** Fecha en la que final de la renta condensando las horas y hospedajes extras */
    fecha_condensada: Scalars["DateTime"]["output"]
    /** Fecha fin de la renta */
    fecha_fin: Scalars["DateTime"]["output"]
    fecha_registro: Scalars["DateTime"]["output"]
    /** Fecha en la que sale el cliente */
    fecha_salida?: Maybe<Scalars["DateTime"]["output"]>
    folio: Scalars["Int"]["output"]
    habitacion?: Maybe<Habitacion>
    habitacion_id: Scalars["ID"]["output"]
    horas_extra?: Maybe<Scalars["Float"]["output"]>
    hospedajes_extra: Scalars["Float"]["output"]
    hotel?: Maybe<Hotel>
    hotel_id: Scalars["ID"]["output"]
    monto_devuelto_cancelacion?: Maybe<Scalars["Float"]["output"]>
    /** Montos calculados de cancelacion total o parcial de renta */
    montos_cancelacion?: Maybe<GetCancelableAmountsRentaOutput>
    motivo_cancelacion?: Maybe<Scalars["String"]["output"]>
    nombre_huesped?: Maybe<Scalars["String"]["output"]>
    numero_personas: Scalars["Float"]["output"]
    ordenes?: Maybe<Array<Orden>>
    pagos?: Maybe<Array<Pago>>
    personas_extra: Scalars["Float"]["output"]
    /** Es la propina recibida y asociada a la renta en caso de que la hubo */
    propina?: Maybe<Propina>
    /** Retorna todas las propinas de la renta (estancia y extras) */
    propinas?: Maybe<Array<Propina>>
    renta_id: Scalars["ID"]["output"]
    reserva?: Maybe<Reserva>
    reserva_id?: Maybe<Scalars["ID"]["output"]>
    saldo?: Maybe<Scalars["Float"]["output"]>
    /** Total por saldar del pago de la estancia */
    saldo_pendiente_estancia: Scalars["Float"]["output"]
    /** Monto pendiente de pago de ordenes de la habitación */
    saldo_pendiente_ordenes: Scalars["Float"]["output"]
    subtotales: DataSubtotales
    tarifa?: Maybe<Tarifa>
    tarifa_id: Scalars["ID"]["output"]
    ticket_id?: Maybe<Scalars["String"]["output"]>
    /** Indica si la renta tiene al menos 1 ticket/venta cancelable */
    tiene_ventas_cancelables: Scalars["Boolean"]["output"]
    tipo_alojamiento: TiposAlojamientos
    tipo_entrada: TiposEntradas
    total: Scalars["Float"]["output"]
    /** Ultima orden registrada y activa(en_preparacion, por_entregar) para la habitacion */
    ultima_orden?: Maybe<GetLastOrdenOutput>
    /** Retorna el concepto mas antiguo por cada tipo(renta, orden, extra) para la renta si es que tiene */
    ultimos_conceptos_pendientes?: Maybe<UltimosConceptosPendientesDetailOutput>
    usuario?: Maybe<Usuario>
    usuario_id: Scalars["ID"]["output"]
    /** Vehiculo registrado para la renta */
    vehiculo?: Maybe<Data_Vehiculo>
}

export interface RentaOrdenTransactionItemOutput {
    __typename?: "RentaOrdenTransactionItemOutput"
    /** Retorna toda la información de la orden del ticket/transacción */
    orden?: Maybe<Orden>
    orden_id: Scalars["ID"]["output"]
    /** Retorna toda la información del ticket de la transacción */
    ticket?: Maybe<Ticket>
    ticket_id?: Maybe<Scalars["ID"]["output"]>
}

export interface RentaTicket {
    __typename?: "RentaTicket"
    descripcion: Scalars["String"]["output"]
    habitacion_id: Scalars["ID"]["output"]
    numero_habitacion: Scalars["String"]["output"]
}

export interface RentaTransactionItemOutput {
    __typename?: "RentaTransactionItemOutput"
    /** Retorna toda la información de los extras del ticket/transacción */
    extras?: Maybe<Array<Extra>>
    extras_ids: Array<Scalars["ID"]["output"]>
    /** Retorna toda la información del ticket de la transacción */
    ticket?: Maybe<Ticket>
    ticket_id?: Maybe<Scalars["ID"]["output"]>
}

export interface RepartoPropinaItemOutput {
    __typename?: "RepartoPropinaItemOutput"
    asignacion_propina?: Maybe<AsignacionPropina>
    asignacion_propina_id: Scalars["ID"]["output"]
    colaborador?: Maybe<Colaborador>
    colaborador_id: Scalars["ID"]["output"]
    comision_bancaria_propina_por_venta: Scalars["Float"]["output"]
    comision_bancaria_sobre_fondo: Scalars["Float"]["output"]
    fondo_de_propinas: Scalars["Float"]["output"]
    pago_correspondiente: Scalars["Float"]["output"]
    propina_por_ventas: Scalars["Float"]["output"]
}

export interface RepartoPropinasOutput {
    __typename?: "RepartoPropinasOutput"
    limite_disponible: Scalars["Float"]["output"]
    monto_recaudado: Scalars["Float"]["output"]
    reparto_propinas: Array<RepartoPropinaItemOutput>
}

export interface ReportePropinasPorPuestoDetailOutput {
    __typename?: "ReportePropinasPorPuestoDetailOutput"
    puesto?: Maybe<Puesto>
    puesto_id: Scalars["ID"]["output"]
    reporte_colaboradores: Array<ColaboradorReportePropinaDetailOutput>
}

export interface Reserva {
    __typename?: "Reserva"
    /** Información del cliente asociado a la reserva */
    cliente: Cliente
    cliente_id?: Maybe<Scalars["ID"]["output"]>
    codigo_ota: Scalars["String"]["output"]
    comentarios: Array<ComentariosInfoReserva>
    correo_huesped?: Maybe<Scalars["String"]["output"]>
    corte_id?: Maybe<Scalars["ID"]["output"]>
    easyrewards_id?: Maybe<Scalars["String"]["output"]>
    estado: EstadosReservas
    estado_pago: EstadoPago
    /** Experiencias compradas para la reserva */
    experiencias_reserva: Array<ExperienciaReserva>
    fecha_cancelacion?: Maybe<Scalars["DateTime"]["output"]>
    fecha_entrada: Scalars["DateTime"]["output"]
    fecha_registro: Scalars["DateTime"]["output"]
    fecha_salida: Scalars["DateTime"]["output"]
    folio: Scalars["Int"]["output"]
    /** Informacion de la habitacion asociada a la reserva */
    habitacion: Habitacion
    habitacion_id?: Maybe<Scalars["ID"]["output"]>
    hospedajes_extra: Scalars["Int"]["output"]
    /** Informacion del hotel asociado a la reserva */
    hotel: Hotel
    hotel_id: Scalars["ID"]["output"]
    monto_devuelto_cancelacion?: Maybe<Scalars["Float"]["output"]>
    motivo_cancelacion?: Maybe<Scalars["String"]["output"]>
    nombre_huesped: Scalars["String"]["output"]
    numero_personas: Scalars["Int"]["output"]
    origen: OrigenRservas
    pagos?: Maybe<Array<Pago>>
    personas_extras: Scalars["Int"]["output"]
    reserva_id: Scalars["ID"]["output"]
    saldo: Scalars["Float"]["output"]
    subtotales: SubtotalesReserva
    /** Informacion de la tarifa asociada a la reserva */
    tarifa?: Maybe<Tarifa>
    tarifa_id: Scalars["ID"]["output"]
    telefono_huesped: Scalars["String"]["output"]
    tipo_de_habitacion: TipoHabitacion
    tipo_habitacion_id: Scalars["ID"]["output"]
    total: Scalars["Float"]["output"]
    /** Información del usuario asociado a la reserva */
    usuario: Usuario
    usuario_id: Scalars["ID"]["output"]
}

export interface ResumenUtilidadOutput {
    __typename?: "ResumenUtilidadOutput"
    gastos: Array<DataConceptoResumenUtilidadPorcentaje>
    ingresos: Array<DataConceptoResumenUtilidad>
    totales: DataConceptoResumenUtilidadTotales
}

export interface ReturnIdTicketResponse {
    __typename?: "ReturnIdTicketResponse"
    ticket_id: Array<Scalars["ID"]["output"]>
}

export interface Rol {
    __typename?: "Rol"
    /** Indica si el rol está eliminado */
    eliminado: Scalars["Boolean"]["output"]
    funcionalidades?: Maybe<Array<Funcionalidad>>
    grupo_hotel: GrupoHotel
    /** Id del grupo hotel */
    grupo_hotel_id: Scalars["String"]["output"]
    /** Nombre del rol */
    nombre: Scalars["String"]["output"]
    /** Rol id */
    rol_id: Scalars["ID"]["output"]
}

export interface RoomAvailabilityOutput {
    __typename?: "RoomAvailabilityOutput"
    alerta_por_disponibilidad: Scalars["Boolean"]["output"]
    alerta_por_turnos_atencion?: Maybe<Scalars["Boolean"]["output"]>
    reservas_del_dia: Scalars["Float"]["output"]
    tipo_habitacion: Scalars["String"]["output"]
    turnos_en_espera?: Maybe<Scalars["Float"]["output"]>
}

export interface SalesByTurno {
    __typename?: "SalesByTurno"
    subtotal: Scalars["Float"]["output"]
    turno: Scalars["String"]["output"]
}

export interface SalesRoomsCountByTurno {
    __typename?: "SalesRoomsCountByTurno"
    accumulated_sale: Scalars["String"]["output"]
    count_rentas: Scalars["Int"]["output"]
    count_reservas: Scalars["Int"]["output"]
    nombre: Scalars["String"]["output"]
    /** Turno asociado al resumen de ventas de habitaciones */
    turno?: Maybe<Turno>
    turno_id: Scalars["ID"]["output"]
}

export interface SalesRoomsCountByTurnosInput {
    fecha_final?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_inicial?: InputMaybe<Scalars["DateTime"]["input"]>
    hotel_id: Scalars["ID"]["input"]
}

export interface SalesTicketsByTurno {
    __typename?: "SalesTicketsByTurno"
    nombre: Scalars["String"]["output"]
    total_extras: Scalars["Float"]["output"]
    total_ordenes: Scalars["Float"]["output"]
    total_propinas: Scalars["Float"]["output"]
    total_rentas: Scalars["Float"]["output"]
    total_reservas: Scalars["Float"]["output"]
    total_restaurante: Scalars["Float"]["output"]
}

export interface Salida {
    __typename?: "Salida"
    /** Almacen-articulo sobre el cual se efectuó el movimiento de salida */
    almacen_articulo?: Maybe<AlmacenArticulo>
    almacen_articulo_id: Scalars["ID"]["output"]
    articulo?: Maybe<Articulo>
    cantidad: Scalars["Float"]["output"]
    colaborador_id: Scalars["ID"]["output"]
    comentario?: Maybe<Scalars["String"]["output"]>
    detalle_orden_id?: Maybe<Scalars["ID"]["output"]>
    fecha_salida: Scalars["DateTime"]["output"]
    hotel_id: Scalars["ID"]["output"]
    motivo: Motivo
    responsable?: Maybe<Colaborador>
    salida_id: Scalars["ID"]["output"]
}

export interface SearchAlmacenesArticulosOutput {
    __typename?: "SearchAlmacenesArticulosOutput"
    almacenes_articulos: Array<AlmacenArticulo>
    paginacion: DatosPaginationOutput
}

export interface SearchColaboradoresForTaskByNombrePuestosInput {
    hotel_id: Scalars["ID"]["input"]
    nombre_puesto: Array<Scalars["String"]["input"]>
}

export interface SearchColaboradoresForTaskInput {
    hotel_id: Scalars["ID"]["input"]
    nombre_puesto?: InputMaybe<Scalars["String"]["input"]>
    nombres_puestos?: InputMaybe<InclusionSearchInput>
}

export interface SearchGastosOutputDto {
    __typename?: "SearchGastosOutputDto"
    gastos: Array<Gastos>
    paginacion: DatosPaginationOutput
}

export interface SearchHistorialEstadosComandaOutput {
    __typename?: "SearchHistorialEstadosComandaOutput"
    historial_estados_comanda: Array<HistorialEstadoComanda>
    paginacion: DatosPaginationOutput
}

export interface SearchHistorialEstadosOrdenOutput {
    __typename?: "SearchHistorialEstadosOrdenOutput"
    historial_estados_orden: Array<HistorialEstadoOrden>
    paginacion: DatosPaginationOutput
}

export interface SearchSalidasOutput {
    __typename?: "SearchSalidasOutput"
    salidas: Array<Salida>
}

export interface SendNotificationInput {
    notificacion_id: Scalars["ID"]["input"]
}

export interface Servicio {
    __typename?: "Servicio"
    eliminado: Scalars["Boolean"]["output"]
    hotel: Hotel
    hotel_id: Scalars["ID"]["output"]
    /** Nombre del servicio */
    nombre: Scalars["String"]["output"]
    servicio_id: Scalars["ID"]["output"]
}

export interface SubcategoriaGasto {
    __typename?: "SubcategoriaGasto"
    categoria_gasto: CategoriaGasto
    categoria_id: Scalars["ID"]["output"]
    eliminado: Scalars["Boolean"]["output"]
    monto: Scalars["Float"]["output"]
    porcentaje?: Maybe<Scalars["Float"]["output"]>
    /** Identifica subcategoria predeterminada */
    predeterminado: Scalars["Boolean"]["output"]
    subcategoria: Scalars["String"]["output"]
    subcategoria_gasto_id: Scalars["ID"]["output"]
}

export interface SubcategoriaProducto {
    __typename?: "SubcategoriaProducto"
    categoria: CategoriaArticulo
    categoria_id: Scalars["ID"]["output"]
    subcategoria: Scalars["String"]["output"]
    subcategoria_id: Scalars["ID"]["output"]
}

export enum SubestadosHabitaciones {
    OcupadaLimpieza = "ocupada_limpieza",
}

export interface Subscription {
    __typename?: "Subscription"
    checkColaborador: Colaborador
    checkColaboradores: Array<Colaborador>
    /** Suscripción para obtener la disponibilidad de habitaciones en tiempo real */
    checkDisponibilidadHabitaciones?: Maybe<ListenDisponibilidadHabitacionesSubOutput>
    checkHabitaciones: Array<Habitacion>
    checkHotel: Hotel
    checkMesas: Mesa
    checkOrdenes?: Maybe<ListenOrdenesStateSubOutput>
}

export interface SubscriptionCheckColaboradorArgs {
    colaborador_id: Scalars["ID"]["input"]
}

export interface SubscriptionCheckColaboradoresArgs {
    apellido_materno?: InputMaybe<Scalars["String"]["input"]>
    apellido_paterno?: InputMaybe<Scalars["String"]["input"]>
    area_id?: InputMaybe<Scalars["ID"]["input"]>
    colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    correo?: InputMaybe<Scalars["String"]["input"]>
    direccion?: InputMaybe<Scalars["String"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    en_turno?: InputMaybe<Scalars["Boolean"]["input"]>
    estado?: InputMaybe<Scalars["String"]["input"]>
    fecha_baja?: InputMaybe<DateSearchInput>
    fecha_cumpleanios?: InputMaybe<DateSearchInput>
    fecha_registro?: InputMaybe<DateSearchInput>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id_filter: Scalars["ID"]["input"]
    nombre?: InputMaybe<Scalars["String"]["input"]>
    numero_colaborador?: InputMaybe<Scalars["String"]["input"]>
    numero_id?: InputMaybe<Scalars["String"]["input"]>
    pagination_options?: InputMaybe<PageOptionsArgs>
    puesto_id?: InputMaybe<Scalars["ID"]["input"]>
    telefono_emergencia?: InputMaybe<Scalars["String"]["input"]>
    telefono_personal?: InputMaybe<Scalars["String"]["input"]>
    turno_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface SubscriptionCheckDisponibilidadHabitacionesArgs {
    hotel_id: Scalars["ID"]["input"]
}

export interface SubscriptionCheckHabitacionesArgs {
    hotel_id_filter: Scalars["ID"]["input"]
}

export interface SubscriptionCheckHotelArgs {
    hotel_id_filter: Scalars["ID"]["input"]
}

export interface SubscriptionCheckOrdenesArgs {
    colaborador_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    consumo_interno_colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    corte_id?: InputMaybe<Scalars["ID"]["input"]>
    easyrewards_id?: InputMaybe<Scalars["String"]["input"]>
    estado_orden?: InputMaybe<EstadosOrdenHistorial>
    estado_pago?: InputMaybe<Array<EstadoPagoOrdenes>>
    fecha_cobro?: InputMaybe<DateSearchInput>
    fecha_registro?: InputMaybe<DateSearchInput>
    filter_by_detalle_orden_state?: InputMaybe<Array<EstadosDetalleOrden>>
    filter_comanda?: InputMaybe<Scalars["Boolean"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    orden?: InputMaybe<Scalars["String"]["input"]>
    orden_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    pago_id?: InputMaybe<Scalars["ID"]["input"]>
    panel_no_visible?: InputMaybe<Scalars["Boolean"]["input"]>
    renta_id?: InputMaybe<Scalars["ID"]["input"]>
    turno_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface SubtotalesReserva {
    __typename?: "SubtotalesReserva"
    total_experiencias: Scalars["Float"]["output"]
    total_habitacion: Scalars["Float"]["output"]
    total_hospedajes_extra: Scalars["Float"]["output"]
    total_personas_extra: Scalars["Float"]["output"]
}

export interface Surtido {
    __typename?: "Surtido"
    almacen: Almacen
    /** Almacen-articulo sobre el cual se efectuó el movimiento de surtido */
    almacen_articulo?: Maybe<AlmacenArticulo>
    almacen_articulo_id: Scalars["ID"]["output"]
    articulo: Articulo
    cantidad: Scalars["Float"]["output"]
    colaborador: Colaborador
    colaborador_id: Scalars["String"]["output"]
    comentario?: Maybe<Scalars["String"]["output"]>
    costo_total: Scalars["Float"]["output"]
    costo_unitario: Scalars["Float"]["output"]
    fecha_ingreso: Scalars["DateTime"]["output"]
    folio: Scalars["Int"]["output"]
    hotel: Hotel
    hotel_id: Scalars["ID"]["output"]
    numero_orden_factura?: Maybe<Scalars["String"]["output"]>
    surtido_id: Scalars["ID"]["output"]
    tipo: TiposSurtido
}

export interface Suscripcion {
    __typename?: "Suscripcion"
    eliminado: Scalars["Boolean"]["output"]
    estatus: Scalars["String"]["output"]
    fecha_expiracion: Scalars["DateTime"]["output"]
    fecha_inicio: Scalars["DateTime"]["output"]
    hotel: Hotel
    hotel_id: Scalars["ID"]["output"]
    modulos?: Maybe<Array<Modulo>>
    suscripcion_id: Scalars["ID"]["output"]
}

export interface SwitchTaskBtwColabInput {
    colaborador_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    colaborador_tarea_id: Array<Scalars["ID"]["input"]>
    descripcion_tarea: Scalars["String"]["input"]
    habitacion_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
    sin_personal_asignado: Scalars["Boolean"]["input"]
    tarea: CreateTareaInput
    tarea_id?: InputMaybe<Scalars["ID"]["input"]>
    tipo_limpieza?: InputMaybe<TiposLimpiezas>
    turno_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface SwitchTaskPartialInput {
    colaborador_id: Scalars["ID"]["input"]
    colaborador_tarea_id: Scalars["ID"]["input"]
}

export interface SwitchTaskRoomInput {
    estado_habitacion_actual: Estados_Habitaciones
    estado_habitacion_nueva: Estados_Habitaciones
    habitacion_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
    switch_colaboradores: Array<SwitchTaskPartialInput>
    usuario_id: Scalars["ID"]["input"]
}

export interface SwitchTaskWithRoomStateInput {
    colaborador_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    colaborador_tarea_id: Array<Scalars["ID"]["input"]>
    comentarios?: InputMaybe<Array<CommentTaskInput>>
    estado_habitacion: Estados_Habitaciones
    habitacion_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
    tarea: CreateTareaInput
    tarea_id?: InputMaybe<Scalars["ID"]["input"]>
    tipo_limpieza?: InputMaybe<TiposLimpiezas>
    usuario_id: Scalars["ID"]["input"]
}

export enum Tamano {
    Lg = "lg",
    Md = "md",
    Mxl = "mxl",
    Sm = "sm",
    Xl = "xl",
    Xs = "xs",
}

export enum TamanoMesa {
    Lg = "lg",
    Md = "md",
    Mxl = "mxl",
    Sm = "sm",
    Xl = "xl",
    Xs = "xs",
}

export interface Tarea {
    __typename?: "Tarea"
    descripcion: Scalars["String"]["output"]
    eliminado: Scalars["Boolean"]["output"]
    nombre: Scalars["String"]["output"]
    /** Puesto de trabajo asociado a la tarea */
    puesto?: Maybe<Puesto>
    puesto_id: Scalars["ID"]["output"]
    tarea_id: Scalars["ID"]["output"]
    tipo: TiposTarea
}

export interface Tarifa {
    __typename?: "Tarifa"
    costo_early_checkin: Scalars["Float"]["output"]
    costo_habitacion: Scalars["Float"]["output"]
    costo_hora_extra: Scalars["Float"]["output"]
    costo_hospedaje_extra: Scalars["Float"]["output"]
    costo_persona_extra: Scalars["Float"]["output"]
    /** Costo de la reserva para la tarifa según los dias de disponibilidad */
    costo_reserva?: Maybe<Scalars["Float"]["output"]>
    dias_disponibles: Array<DiasDisponibles>
    duracion_renta: Scalars["Float"]["output"]
    eliminado: Scalars["Boolean"]["output"]
    estatus: EstatusTarifa
    fecha_final: Scalars["DateTime"]["output"]
    fecha_inicio: Scalars["DateTime"]["output"]
    hora_checkin: Scalars["String"]["output"]
    hora_checkout: Scalars["String"]["output"]
    hora_final: Scalars["String"]["output"]
    hora_inicio: Scalars["String"]["output"]
    horas_extra_max?: Maybe<Scalars["Float"]["output"]>
    hospedajes_extra_max?: Maybe<Scalars["Float"]["output"]>
    hotel: Hotel
    hotel_id: Scalars["ID"]["output"]
    nombre: Scalars["String"]["output"]
    pantalla_disponibilidad?: Maybe<Scalars["Boolean"]["output"]>
    personas_extra_max?: Maybe<Scalars["Float"]["output"]>
    tarifa_id: Scalars["ID"]["output"]
    tarifa_imas?: Maybe<Scalars["String"]["output"]>
    tipo_alojamiento: TiposAlojamientos
    tipo_habitacion_id: Scalars["ID"]["output"]
    tipo_tarifa: TipoTarifa
    visible_venta?: Maybe<Scalars["Boolean"]["output"]>
}

export interface TextosInformativos {
    __typename?: "TextosInformativos"
    tickets_lista_espera?: Maybe<TextosListaEspera>
    tickets_venta?: Maybe<TextosVenta>
}

export interface TextosInformativosInput {
    tickets_lista_espera?: InputMaybe<TextosListaEsperaInput>
    tickets_venta?: InputMaybe<TextosVentaInput>
}

export interface TextosListaEspera {
    __typename?: "TextosListaEspera"
    texto_informativo?: Maybe<Scalars["String"]["output"]>
}

export interface TextosListaEsperaInput {
    texto_informativo?: InputMaybe<Scalars["String"]["input"]>
}

export interface TextosVenta {
    __typename?: "TextosVenta"
    texto_informativo1?: Maybe<Scalars["String"]["output"]>
    texto_informativo2?: Maybe<Scalars["String"]["output"]>
}

export interface TextosVentaInput {
    texto_informativo1?: InputMaybe<Scalars["String"]["input"]>
    texto_informativo2?: InputMaybe<Scalars["String"]["input"]>
}

export interface Ticket {
    __typename?: "Ticket"
    anticipo?: Maybe<Scalars["Float"]["output"]>
    anticipos_validos?: Maybe<Scalars["Float"]["output"]>
    cancelado: Scalars["Boolean"]["output"]
    /** colaborador_id responsable/asociado a la venta del ticket */
    colaborador_id?: Maybe<Scalars["ID"]["output"]>
    comanda?: Maybe<Scalars["String"]["output"]>
    consumo_interno: Scalars["Boolean"]["output"]
    /** corte_id al que pertenece el ticket */
    corte_id?: Maybe<Scalars["ID"]["output"]>
    cortesia: Scalars["Boolean"]["output"]
    data: DataTicket
    easyrewards_id?: Maybe<Scalars["String"]["output"]>
    /** Obtiene los extras asociados al ticket cuando el origen es extra_renta */
    extras_ids?: Maybe<Array<Extra>>
    fecha_cancelacion?: Maybe<Scalars["DateTime"]["output"]>
    fecha_impresion: Scalars["DateTime"]["output"]
    folio: Scalars["Int"]["output"]
    folio_orden?: Maybe<Scalars["String"]["output"]>
    folio_renta?: Maybe<Scalars["String"]["output"]>
    gasto?: Maybe<GastoTicket>
    historial_cambios?: Maybe<DataHistorialCambiosTicket>
    /** Información del Hotel de la Habitación */
    hotel?: Maybe<Hotel>
    hotel_id: Scalars["ID"]["output"]
    monto_fajilla?: Maybe<Scalars["Float"]["output"]>
    motivo_cancelacion?: Maybe<Scalars["String"]["output"]>
    numero_mesa?: Maybe<Scalars["String"]["output"]>
    /** Ordenes asociadas al ticket */
    ordenes?: Maybe<Array<Orden>>
    /** Renta asociada al ticket */
    renta?: Maybe<Renta>
    /** Información de la Reserva asociada al ticket */
    reserva?: Maybe<Reserva>
    reserva_id?: Maybe<Scalars["ID"]["output"]>
    saldo?: Maybe<Scalars["Float"]["output"]>
    ticket_id: Scalars["ID"]["output"]
    usuario?: Maybe<Usuario>
    usuario_cancelacion?: Maybe<Usuario>
    /** Usuario que autorizo/ejecuto la cancelacion del ticket */
    usuario_cancelacion_id?: Maybe<Scalars["ID"]["output"]>
    usuario_id: Scalars["ID"]["output"]
}

export enum TipoAlmacen {
    Deposito = "deposito",
    Suministro = "suministro",
}

export enum TipoArticulo {
    Insumo = "insumo",
    Proceso = "proceso",
    Receta = "receta",
    Venta = "venta",
}

export interface TipoBloqueo {
    __typename?: "TipoBloqueo"
    /** Listado de claves para abreviaciones en cards */
    claves?: Maybe<Array<ClaveTipoBloqueo>>
    /** Indica si el registro está eliminado */
    eliminado: Scalars["Boolean"]["output"]
    /** Identificador del hotel al que pertenece */
    hotel_id: Scalars["ID"]["output"]
    /** Nombre del tipo de bloqueo */
    nombre: Scalars["String"]["output"]
    /** Identificador único del tipo de bloqueo */
    tipo_bloqueo_id: Scalars["ID"]["output"]
}

export interface TipoHabitacion {
    __typename?: "TipoHabitacion"
    amenidades: Array<Scalars["String"]["output"]>
    camas: Array<Cama>
    clave: Scalars["String"]["output"]
    descripcion: Scalars["String"]["output"]
    eliminado: Scalars["Boolean"]["output"]
    foto?: Maybe<Scalars["String"]["output"]>
    habitaciones?: Maybe<Array<Habitacion>>
    /** Habitaciones de este tipo que se reservan para renta en recepcion */
    habitaciones_reservadas_recepcion: Scalars["Int"]["output"]
    hotel_id: Scalars["ID"]["output"]
    /** Limite de reservas por dia */
    limite_reservas: Scalars["Float"]["output"]
    minutos_entrada: Scalars["Float"]["output"]
    minutos_limpieza_detallada: Scalars["Float"]["output"]
    minutos_limpieza_normal: Scalars["Float"]["output"]
    minutos_limpieza_retoque: Scalars["Float"]["output"]
    minutos_pendiente_supervision: Scalars["Float"]["output"]
    minutos_sucia: Scalars["Float"]["output"]
    minutos_supervision: Scalars["Float"]["output"]
    nombre: Scalars["String"]["output"]
    nomenclatura?: Maybe<Scalars["String"]["output"]>
    personas_incluidas: Scalars["Int"]["output"]
    tipo_habitacion_id: Scalars["ID"]["output"]
}

export interface TipoHabitacionPartialDetail {
    __typename?: "TipoHabitacionPartialDetail"
    amenidades: Array<Scalars["String"]["output"]>
    camas: Array<Cama>
    clave: Scalars["String"]["output"]
    descripcion: Scalars["String"]["output"]
    /** Numero de habitaciones disponibles del tipo de habitacion */
    disponibles?: Maybe<Scalars["Int"]["output"]>
    eliminado: Scalars["Boolean"]["output"]
    foto?: Maybe<Scalars["String"]["output"]>
    habitaciones?: Maybe<Array<Habitacion>>
    /** Habitaciones de este tipo que se reservan para renta en recepcion */
    habitaciones_reservadas_recepcion: Scalars["Int"]["output"]
    hotel_id: Scalars["ID"]["output"]
    /** Limite de reservas por dia */
    limite_reservas: Scalars["Float"]["output"]
    minutos_entrada: Scalars["Float"]["output"]
    minutos_limpieza_detallada: Scalars["Float"]["output"]
    minutos_limpieza_normal: Scalars["Float"]["output"]
    minutos_limpieza_retoque: Scalars["Float"]["output"]
    minutos_pendiente_supervision: Scalars["Float"]["output"]
    minutos_sucia: Scalars["Float"]["output"]
    minutos_supervision: Scalars["Float"]["output"]
    nombre: Scalars["String"]["output"]
    nomenclatura?: Maybe<Scalars["String"]["output"]>
    personas_incluidas: Scalars["Int"]["output"]
    /** Tarifa, de tipo renta por defecto, para el tipo de habitacion */
    tarifa?: Maybe<Tarifa>
    tarifa_id?: Maybe<Scalars["ID"]["output"]>
    tipo_habitacion_id: Scalars["ID"]["output"]
    /** Todos los turnos en_espera y en_curso para el tipo de habitacion */
    turnos_atencion?: Maybe<Array<TurnoAtencion>>
}

export interface TipoHabitacionPartialDetailTurnos_AtencionArgs {
    estado?: InputMaybe<Array<EstadosTurnosAtencion>>
}

export interface TipoHabitacionSubDetail {
    __typename?: "TipoHabitacionSubDetail"
    accion: DisponibilidadPanelAction
    tipo_habitacion: TipoHabitacionPartialDetail
}

export interface TipoMantenimiento {
    __typename?: "TipoMantenimiento"
    /** Listado de claves para abreviaciones en cards */
    claves?: Maybe<Array<ClaveTipoMantenimiento>>
    /** Indica si el registro está eliminado */
    eliminado: Scalars["Boolean"]["output"]
    /** Identificador del hotel al que pertenece */
    hotel_id: Scalars["ID"]["output"]
    /** Nombre del tipo de mantenimiento */
    nombre: Scalars["String"]["output"]
    /** Identificador único del tipo de mantenimiento */
    tipo_mantenimiento_id: Scalars["ID"]["output"]
}

export enum TipoMovimientoHistorialInventario {
    Caducado = "caducado",
    ConsumoInterno = "consumo_interno",
    Devolucion = "devolucion",
    Faltante = "faltante",
    Merma = "merma",
    Nuevo = "nuevo",
    Proceso = "proceso",
    Receta = "receta",
    Resurtido = "resurtido",
    Transferencia = "transferencia",
    Venta = "venta",
}

export enum TipoNotificacion {
    CortesCaratulaMensual = "cortes_caratula_mensual",
    CortesCortesDiarios = "cortes_cortes_diarios",
    GastosPresupuestoExcedido = "gastos_presupuesto_excedido",
    HabitacionesOcupacionMaximaAlcanzada = "habitaciones_ocupacion_maxima_alcanzada",
    HabitacionesSinHabitacionesDisponibles = "habitaciones_sin_habitaciones_disponibles",
    IncidenciasGeneral = "incidencias_general",
    IncidenciasIncidenciasAltas = "incidencias_incidencias_altas",
}

export enum TipoOrden {
    Mostrador = "mostrador",
    Restaurante = "restaurante",
    RoomService = "room_service",
}

export enum TipoOrdenPanelCocina {
    Comanda = "comanda",
    Orden = "orden",
}

export enum TipoOrdenamiento {
    Asc = "ASC",
    Desc = "DESC",
}

export enum TipoSelector {
    Default = "Default",
    Repetido = "Repetido",
}

export enum TipoTarifa {
    Renta = "renta",
    RentaReserva = "renta_reserva",
    Reserva = "reserva",
}

export enum TiposAlojamientos {
    Hotel = "hotel",
    Motel = "motel",
}

export enum TiposAutenticacion {
    ApiKey = "API_KEY",
    DigestAuth = "DIGEST_AUTH",
}

export enum TiposCamas {
    CaliforniaKing = "california_king",
    Individual = "individual",
    King = "king",
    Matrimonial = "matrimonial",
    PresidentialKing = "presidential_king",
    Queen = "queen",
}

export enum TiposCancelaciones {
    Devolucion = "devolucion",
    Merma = "merma",
}

export enum TiposEntradas {
    APie = "A_Pie",
    Auto = "Auto",
}

export enum TiposExtras {
    Hora = "hora",
    Hospedaje = "hospedaje",
    Persona = "persona",
}

export enum TiposIncidencias {
    Limpieza = "limpieza",
    MalComportamiento = "mal_comportamiento",
    Mantenimiento = "mantenimiento",
    ObjetoOlvidado = "objeto_olvidado",
}

export enum TiposLimpiezas {
    Detallada = "detallada",
    Normal = "normal",
    Retoque = "retoque",
}

export enum TiposModificador {
    Complemento = "complemento",
    Extra = "extra",
    Preparacion = "preparacion",
    Proteina = "proteina",
}

export enum TiposPagos {
    Amex = "amex",
    ConsumoInterno = "consumo_interno",
    Cortesia = "cortesia",
    DepositoOTransferencia = "deposito_o_transferencia",
    Efectivo = "efectivo",
    LovePoints = "love_points",
    VisaOMastercard = "visa_o_mastercard",
}

export enum TiposSurtido {
    Surtido = "surtido",
    Transferencia = "transferencia",
}

export enum TiposTarea {
    Limpieza = "limpieza",
    Mantenimiento = "mantenimiento",
    Supervision = "supervision",
}

export interface TodayExtrasSales {
    __typename?: "TodayExtrasSales"
    acumulado_extras: Array<SalesByTurno>
}

export interface TodayOrdenesSales {
    __typename?: "TodayOrdenesSales"
    acumulado_ordenes: Array<SalesByTurno>
}

export interface TodayReservasSales {
    __typename?: "TodayReservasSales"
    acumulado_reservas: Array<SalesByTurno>
}

export interface TopBookingRoom {
    __typename?: "TopBookingRoom"
    habitacion_id: Scalars["ID"]["output"]
    ventas: Scalars["Float"]["output"]
}

export interface TopRentalRoom {
    __typename?: "TopRentalRoom"
    habitacion: Habitacion
    ventas: Scalars["Float"]["output"]
}

export interface TotalBillingPerDayRecepcionstOutput {
    __typename?: "TotalBillingPerDayRecepcionstOutput"
    total_gasto: Scalars["Float"]["output"]
}

export interface TotalesHotelOutput {
    __typename?: "TotalesHotelOutput"
    cantidad_total: Scalars["Float"]["output"]
    sumatoria_total: Scalars["Float"]["output"]
}

export interface TotalesPropinasOutput {
    __typename?: "TotalesPropinasOutput"
    total_efectivo: Scalars["Float"]["output"]
    total_otros: Scalars["Float"]["output"]
    total_propinas_recaudadas: Scalars["Float"]["output"]
    total_roomservice: Scalars["Float"]["output"]
    total_tarjeta: Scalars["Float"]["output"]
    total_venta_habitacion: Scalars["Float"]["output"]
}

export interface TotalesRepartoPropinasItemOutput {
    __typename?: "TotalesRepartoPropinasItemOutput"
    total_aportaciones_a_fondo: Scalars["Float"]["output"]
    total_comisiones_bancarias_propinas_por_ventas: Scalars["Float"]["output"]
    total_comisiones_bancarias_sobre_fondo: Scalars["Float"]["output"]
    total_fondos_de_propina: Scalars["Float"]["output"]
    total_neto_propinas_por_ventas: Scalars["Float"]["output"]
    total_pagos_correspondientes: Scalars["Float"]["output"]
    total_propinas_recolectadas: Scalars["Float"]["output"]
    total_subtotales_propina_por_ventas: Scalars["Float"]["output"]
}

export interface TotalesRoomService {
    __typename?: "TotalesRoomService"
    cantidad_total: Scalars["Float"]["output"]
    monto_total: Scalars["Float"]["output"]
}

export interface TraceStartHistorialLoginInput {
    hotel_id: Scalars["ID"]["input"]
    sesion_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface Transaccion {
    __typename?: "Transaccion"
    cantidad: Scalars["Float"]["output"]
    eliminado: Scalars["Boolean"]["output"]
    estatus: Scalars["String"]["output"]
    fecha_creacion: Scalars["DateTime"]["output"]
    metododepago_id: Scalars["ID"]["output"]
    transaccion_id: Scalars["ID"]["output"]
}

export interface TransferArticuloPartialDetailInput {
    almacen_destino_id: Scalars["ID"]["input"]
    almacen_origen_id: Scalars["ID"]["input"]
    articulo_id: Scalars["ID"]["input"]
    cantidad: Scalars["Float"]["input"]
    unidad?: InputMaybe<UnidadMedidasArticulo>
}

export interface TransferArticulosInput {
    hotel_id: Scalars["ID"]["input"]
    transferencias: Array<TransferArticuloPartialDetailInput>
    usuario_autorizo_id: Scalars["ID"]["input"]
}

export interface TransferArticulosOutput {
    __typename?: "TransferArticulosOutput"
    numero_articulos_transferidos: Scalars["Int"]["output"]
}

export interface TurnOffTurnoColaboradoresInput {
    asistencia_id: Array<Scalars["ID"]["input"]>
    colaborador_id: Array<Scalars["ID"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface TurnOnTurnoColaboradorInput {
    colaborador_id: Scalars["ID"]["input"]
    comentarios?: InputMaybe<Scalars["String"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface Turno {
    __typename?: "Turno"
    eliminado: Scalars["Boolean"]["output"]
    estado: EstadosTurno
    hora_entrada: Scalars["String"]["output"]
    hora_salida: Scalars["String"]["output"]
    hotel_id: Scalars["ID"]["output"]
    nombre: Scalars["String"]["output"]
    orden: Scalars["Int"]["output"]
    turno_id: Scalars["ID"]["output"]
}

export interface TurnoAtencion {
    __typename?: "TurnoAtencion"
    colaborador?: Maybe<Colaborador>
    estado: EstadosTurnosAtencion
    fecha_registro: Scalars["DateTime"]["output"]
    folio: Scalars["Int"]["output"]
    /** Folio nomenclatura del tipo de habitacion con el numero de turno */
    folio_turno?: Maybe<Scalars["String"]["output"]>
    hotel?: Maybe<Hotel>
    hotel_id: Scalars["ID"]["output"]
    nombre_o_matricula?: Maybe<Scalars["String"]["output"]>
    renta_id?: Maybe<Scalars["ID"]["output"]>
    tipo_habitacion?: Maybe<TipoHabitacion>
    tipo_habitacion_id: Scalars["ID"]["output"]
    turno_atencion_id: Scalars["ID"]["output"]
    usuario_finaliza_turno?: Maybe<Scalars["ID"]["output"]>
    usuario_id: Scalars["ID"]["output"]
}

export interface TurnosAtencionSubModesOutput {
    __typename?: "TurnosAtencionSubModesOutput"
    evento?: Maybe<TipoHabitacionSubDetail>
    lista?: Maybe<Array<TipoHabitacionPartialDetail>>
    turno_en_curso?: Maybe<TurnoAtencion>
}

export interface UltimaReserva {
    __typename?: "UltimaReserva"
    reserva?: Maybe<Reserva>
}

export interface UltimosConceptosPendientesDetailOutput {
    __typename?: "UltimosConceptosPendientesDetailOutput"
    extra?: Maybe<Extra>
    extra_id?: Maybe<Scalars["ID"]["output"]>
    orden?: Maybe<Orden>
    orden_id?: Maybe<Scalars["ID"]["output"]>
    renta?: Maybe<Renta>
    renta_id?: Maybe<Scalars["ID"]["output"]>
}

export interface UnidadConversionArticulo {
    __typename?: "UnidadConversionArticulo"
    eliminado: Scalars["Boolean"]["output"]
    factor_conversion: Scalars["Float"]["output"]
    fecha_eliminado?: Maybe<Scalars["DateTime"]["output"]>
    fecha_registro: Scalars["DateTime"]["output"]
    unidad_conversion_articulo_id: Scalars["ID"]["output"]
    unidad_destino: Scalars["String"]["output"]
    unidad_origen: Scalars["String"]["output"]
}

export enum UnidadMedidasArticulo {
    Kg = "Kg",
    L = "L",
    Pz = "Pz",
    G = "g",
    M = "m",
    ML = "mL",
    Mg = "mg",
    Mm = "mm",
    Oz = "oz",
}

export enum UnidadMedidasProduccion {
    Kg = "Kg",
    L = "L",
    Pz = "Pz",
    G = "g",
    M = "m",
    ML = "mL",
    Mg = "mg",
    Mm = "mm",
    Oz = "oz",
}

export enum UnidadTiempoFiltro {
    Dia = "dia",
    Mes = "mes",
}

export interface UpdateAlmacenInput {
    almacen_id: Array<Scalars["ID"]["input"]>
    categorias_articulos_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    descripcion?: InputMaybe<Scalars["String"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    estado?: InputMaybe<EstadoAlmacen>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    tipo_almacen?: InputMaybe<TipoAlmacen>
    usuario_modifico_id: Scalars["ID"]["input"]
}

export interface UpdateAlmacenesArticulosInput {
    almacen_articulo_id: Array<Scalars["ID"]["input"]>
    almacen_id?: InputMaybe<Scalars["ID"]["input"]>
    articulo_id?: InputMaybe<Scalars["ID"]["input"]>
    cantidad?: InputMaybe<Scalars["Float"]["input"]>
    costo?: InputMaybe<Scalars["Float"]["input"]>
    fecha_movimiento?: InputMaybe<Scalars["DateTime"]["input"]>
    foto?: InputMaybe<Scalars["String"]["input"]>
    precio?: InputMaybe<Scalars["Float"]["input"]>
}

export interface UpdateApiKeyInput {
    activo?: InputMaybe<Scalars["Boolean"]["input"]>
    api_key_id: Scalars["String"]["input"]
    descripcion?: InputMaybe<Scalars["String"]["input"]>
    key: Scalars["String"]["input"]
}

export interface UpdateAportacionesPropinasRsInput {
    aportaciones_propinas_by_categoria: Array<AportacionPropinaRsDetailInput>
}

/** Campos que pueden ser directamente modificados de la entidad Area */
export interface UpdateAreaInput {
    area_id: Scalars["ID"]["input"]
    estado?: InputMaybe<Scalars["String"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
}

export interface UpdateArticuloExternoInput {
    articulo_externo_id: Scalars["ID"]["input"]
    descripcion?: InputMaybe<Scalars["String"]["input"]>
    estado?: InputMaybe<EstadosArticuloExterno>
    foto?: InputMaybe<Scalars["String"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    nombre?: InputMaybe<Scalars["String"]["input"]>
}

export interface UpdateArticuloGrupoModificadorInput {
    articulo_externo_id?: InputMaybe<Scalars["ID"]["input"]>
    articulo_grupo_modificador_id: Scalars["ID"]["input"]
    grupo_modificador_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id: Scalars["ID"]["input"]
}

export interface UpdateArticuloInput {
    almacen_id?: InputMaybe<Scalars["ID"]["input"]>
    articulo_id: Scalars["ID"]["input"]
    cantidad_minima?: InputMaybe<Scalars["Float"]["input"]>
    categoria_id?: InputMaybe<Scalars["String"]["input"]>
    contenido?: InputMaybe<Scalars["Float"]["input"]>
    costo?: InputMaybe<Scalars["Float"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    estado?: InputMaybe<EstadosArticulo>
    extra?: InputMaybe<Scalars["Boolean"]["input"]>
    fecha_eliminado?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_registro?: InputMaybe<Scalars["DateTime"]["input"]>
    folio?: InputMaybe<Scalars["String"]["input"]>
    foto?: InputMaybe<Scalars["String"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    marca?: InputMaybe<Scalars["String"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    precio?: InputMaybe<Scalars["Float"]["input"]>
    produccion?: InputMaybe<Scalars["Boolean"]["input"]>
    sku?: InputMaybe<Scalars["String"]["input"]>
    tipo?: InputMaybe<TipoArticulo>
    unidad?: InputMaybe<UnidadMedidasArticulo>
}

export interface UpdateArticulosInput {
    articulos: Array<UpdateArticuloInput>
}

export interface UpdateAsistenciaInput {
    asistencia_id: Scalars["ID"]["input"]
    asistio?: InputMaybe<Scalars["Boolean"]["input"]>
    colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    comentario?: InputMaybe<Scalars["String"]["input"]>
    hora_salida?: InputMaybe<Scalars["String"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface UpdateCategoriaArticuloInput {
    categoria_id: Scalars["ID"]["input"]
    descripcion?: InputMaybe<Scalars["String"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    porcentaje_aportacion_propinas?: InputMaybe<Scalars["Float"]["input"]>
}

export interface UpdateCategoriaGastosInput {
    categoria?: InputMaybe<Scalars["String"]["input"]>
    categoria_id: Scalars["ID"]["input"]
    limite_mensual?: InputMaybe<Scalars["Float"]["input"]>
    presupuesto?: InputMaybe<Scalars["Float"]["input"]>
}

export interface UpdateClienteInput {
    cliente_id: Scalars["ID"]["input"]
    correo?: InputMaybe<Scalars["String"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    telefono?: InputMaybe<Scalars["String"]["input"]>
}

export interface UpdateColaboradorInput {
    apellido_materno?: InputMaybe<Scalars["String"]["input"]>
    apellido_paterno?: InputMaybe<Scalars["String"]["input"]>
    area_id?: InputMaybe<Scalars["ID"]["input"]>
    codigo?: InputMaybe<Scalars["String"]["input"]>
    colaborador_id: Scalars["ID"]["input"]
    correo?: InputMaybe<Scalars["String"]["input"]>
    direccion?: InputMaybe<Scalars["String"]["input"]>
    en_turno?: InputMaybe<Scalars["Boolean"]["input"]>
    /** Habilita/Deshabilita funciones de supervision (puesto Supervisor) para el colaborador */
    es_supervisor?: InputMaybe<Scalars["Boolean"]["input"]>
    fecha_baja?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_cumpleanios?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_registro?: InputMaybe<Scalars["DateTime"]["input"]>
    foto?: InputMaybe<Scalars["String"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    nombre?: InputMaybe<Scalars["String"]["input"]>
    numero_colaborador?: InputMaybe<Scalars["String"]["input"]>
    numero_id?: InputMaybe<Scalars["String"]["input"]>
    puesto_id?: InputMaybe<Scalars["ID"]["input"]>
    remover_foto?: InputMaybe<Scalars["Boolean"]["input"]>
    rol_id?: InputMaybe<Scalars["ID"]["input"]>
    sueldo?: InputMaybe<Scalars["Float"]["input"]>
    telefono_emergencia?: InputMaybe<Scalars["String"]["input"]>
    telefono_personal?: InputMaybe<Scalars["String"]["input"]>
    template_sample?: InputMaybe<Array<Scalars["String"]["input"]>>
    turno_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface UpdateColaboradorTurnoInput {
    colaborador_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
    turno_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface UpdateComandaInput {
    comanda_id: Scalars["ID"]["input"]
    fecha_modificacion?: InputMaybe<Scalars["DateTime"]["input"]>
    folio?: InputMaybe<Scalars["Float"]["input"]>
    orden_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface UpdateComentarioHabitacionInput {
    comentario?: InputMaybe<Scalars["String"]["input"]>
    comentario_id: Scalars["ID"]["input"]
    habitacion_id: Scalars["ID"]["input"]
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface UpdateConfiguracionFajillaInput {
    configuracion_fajilla_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
    valor: Scalars["Float"]["input"]
}

export interface UpdateConfiguracionInventarioInput {
    configuracion_inventario_id: Scalars["ID"]["input"]
    configuraciones?: InputMaybe<ConfiguracionesInput>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    inventario_negativo?: InputMaybe<Scalars["Boolean"]["input"]>
}

export interface UpdateConfiguracionPropinaInput {
    configuracion_propina_id: Scalars["ID"]["input"]
    fecha_registro?: InputMaybe<Scalars["DateTime"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    paga_propina_en_turno?: InputMaybe<Scalars["Boolean"]["input"]>
    porcentaje_aportacion_vendedores?: InputMaybe<Scalars["Float"]["input"]>
    porcentaje_comision_por_puntos?: InputMaybe<Scalars["Float"]["input"]>
    porcentaje_venta_efectivo?: InputMaybe<Scalars["Float"]["input"]>
    porcentaje_venta_tarjeta?: InputMaybe<Scalars["Float"]["input"]>
}

export interface UpdateCredencialInput {
    activo?: InputMaybe<Scalars["Boolean"]["input"]>
    /** Se debe enviar cuatro huellas */
    template_sample: Array<Scalars["String"]["input"]>
    usuario_id: Scalars["ID"]["input"]
}

/** Campos que pueden ser directamente modificados de la entidad Habitacion */
export interface UpdateEstadoHabitacionInput {
    comentario_estado?: InputMaybe<Scalars["String"]["input"]>
    easyrewards_id?: InputMaybe<Scalars["String"]["input"]>
    estado: Estados_Habitaciones
    fecha_estado: Scalars["DateTime"]["input"]
    habitacion_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
    subestado?: InputMaybe<SubestadosHabitaciones>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface UpdateEstadoOrdenOrDetalleInput {
    comanda_id?: InputMaybe<Scalars["ID"]["input"]>
    detalle_orden_id?: InputMaybe<Array<Scalars["ID"]["input"]>>
    estado: EstadosOrdenHistorial
    orden_id?: InputMaybe<Scalars["ID"]["input"]>
    /** Marca una orden para que ya no sea mostrada en el panel de cocina */
    panel_no_visible?: InputMaybe<Scalars["Boolean"]["input"]>
}

export interface UpdateEstadoOrdenOrDetalleOutput {
    __typename?: "UpdateEstadoOrdenOrDetalleOutput"
    estado_destino: EstadosOrdenHistorial
    estado_origen: EstadosOrdenHistorial
    folio_orden?: Maybe<Scalars["String"]["output"]>
    nombre_articulo?: Maybe<Scalars["String"]["output"]>
    orden: Orden
}

export interface UpdateExtraDetalleOrdenInput {
    extra_detalle_orden: Array<UpdateExtraDetalleOrdenPartialInfo>
}

export interface UpdateExtraDetalleOrdenPartialInfo {
    almacen_articulo_id?: InputMaybe<Scalars["ID"]["input"]>
    cantidad: Scalars["Float"]["input"]
    costo_con_iva: Scalars["Float"]["input"]
    costo_sin_iva: Scalars["Float"]["input"]
    detalle_orden_id?: InputMaybe<Scalars["ID"]["input"]>
    extra_detalle_orden_id?: InputMaybe<Scalars["ID"]["input"]>
    monto_iva: Scalars["Float"]["input"]
}

export interface UpdateExtraDetalleOrdenPartialInfoOutput {
    __typename?: "UpdateExtraDetalleOrdenPartialInfoOutput"
    almacen_articulo_id?: Maybe<Scalars["ID"]["output"]>
    cantidad: Scalars["Float"]["output"]
    costo_con_iva: Scalars["Float"]["output"]
    costo_sin_iva: Scalars["Float"]["output"]
    detalle_orden_id?: Maybe<Scalars["ID"]["output"]>
    extra_detalle_orden_id: Scalars["ID"]["output"]
    monto_iva: Scalars["Float"]["output"]
}

export interface UpdateExtraInput {
    extra_id: Scalars["ID"]["input"]
    fecha_pago?: InputMaybe<Scalars["DateTime"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    motivo_cancelacion?: InputMaybe<Scalars["String"]["input"]>
    numero?: InputMaybe<Scalars["Int"]["input"]>
    tipo_extra?: InputMaybe<TiposExtras>
}

export interface UpdateExtrasByDetalleOrdenIdRequest {
    detalle_orden_id: Scalars["ID"]["input"]
    extra_detalle_orden: Array<UpdateExtraDetalleOrdenPartialInfo>
}

export interface UpdateExtrasByDetalleOrdenIdResponse {
    __typename?: "UpdateExtrasByDetalleOrdenIdResponse"
    detalle_orden_id: Scalars["ID"]["output"]
    extra_detalle_orden: Array<UpdateExtraDetalleOrdenPartialInfoOutput>
}

export interface UpdateFajillaInput {
    comentario?: InputMaybe<Scalars["String"]["input"]>
    configuracion_fajilla_id: Scalars["ID"]["input"]
    fajilla_id: Scalars["ID"]["input"]
    folio_integracion?: InputMaybe<Scalars["String"]["input"]>
    monto: Scalars["Float"]["input"]
    turno_id: Scalars["ID"]["input"]
}

export interface UpdateGastoInput {
    caja_chica: Scalars["Boolean"]["input"]
    categoria_id?: InputMaybe<Scalars["ID"]["input"]>
    comentarios?: InputMaybe<Scalars["String"]["input"]>
    corte_id?: InputMaybe<Scalars["ID"]["input"]>
    fecha_gasto?: InputMaybe<Scalars["DateTime"]["input"]>
    gasto_id: Scalars["ID"]["input"]
    metodo_pago?: InputMaybe<Scalars["String"]["input"]>
    monto?: InputMaybe<Scalars["Float"]["input"]>
    subcategoria_id?: InputMaybe<Scalars["String"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

/** Campos que pueden ser directamente modificados de la entidad Habitacion */
export interface UpdateGrupoHotelInput {
    grupo_hotel_id: Scalars["ID"]["input"]
    nombre_grupo: Scalars["String"]["input"]
}

export interface UpdateGrupoModificadorInput {
    descripcion?: InputMaybe<Scalars["String"]["input"]>
    estado?: InputMaybe<EstadoGrupoModificador>
    grupo_modificador_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
    max_seleccion?: InputMaybe<Scalars["Int"]["input"]>
    min_seleccion?: InputMaybe<Scalars["Int"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    obligatorio?: InputMaybe<Scalars["Boolean"]["input"]>
    tipo_selector?: InputMaybe<TipoSelector>
}

/** Campos que pueden ser directamente modificados de la entidad Habitacion */
export interface UpdateHabitacionHotelInput {
    habitacion_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface UpdateHabitacionInRentaInput {
    habitacion_id: Scalars["ID"]["input"]
    renta_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

/** Campos que pueden ser directamente modificados de la entidad Habitacion */
export interface UpdateHabitacionInput {
    habitacion_id: Scalars["ID"]["input"]
    numero_habitacion?: InputMaybe<Scalars["String"]["input"]>
    piso?: InputMaybe<Scalars["String"]["input"]>
    usuario_id: Scalars["ID"]["input"]
}

/** Campos que pueden ser directamente modificados de la entidad Habitacion */
export interface UpdateHabitacionTipoHabitacionInput {
    habitacion_id: Scalars["ID"]["input"]
    tipo_habitacion_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}

export interface UpdateHistorialHabitacionDto {
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    estado_id?: InputMaybe<Scalars["ID"]["input"]>
    fecha_estado?: InputMaybe<Scalars["DateTime"]["input"]>
    habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
    historial_habitacion_id: Scalars["ID"]["input"]
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    numero_habitacion?: InputMaybe<Scalars["String"]["input"]>
    piso?: InputMaybe<Scalars["String"]["input"]>
    subestado?: InputMaybe<Scalars["String"]["input"]>
    tipo_habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface UpdateHistorialVehiculoInput {
    habitacion?: InputMaybe<Scalars["String"]["input"]>
    historial_vehiculo_id: Scalars["ID"]["input"]
    motivo_entrada?: InputMaybe<Scalars["String"]["input"]>
    motivo_ingreso_id?: InputMaybe<Scalars["ID"]["input"]>
    vehiculo: VehiculoDataEditDetailInput
}

export interface UpdateHotelInput {
    calle?: InputMaybe<Scalars["String"]["input"]>
    ciudad?: InputMaybe<Scalars["String"]["input"]>
    colonia?: InputMaybe<Scalars["String"]["input"]>
    configurations?: InputMaybe<ConfigurationsInput>
    correo?: InputMaybe<Scalars["String"]["input"]>
    cp?: InputMaybe<Scalars["String"]["input"]>
    easyrewards_sucursal_id?: InputMaybe<Scalars["String"]["input"]>
    estado?: InputMaybe<Scalars["String"]["input"]>
    estatus?: InputMaybe<Scalars["String"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    logo_hotel?: InputMaybe<Scalars["String"]["input"]>
    nombre_hotel?: InputMaybe<Scalars["String"]["input"]>
    numero_exterior?: InputMaybe<Scalars["Float"]["input"]>
    numero_interior?: InputMaybe<Scalars["String"]["input"]>
    razon_social?: InputMaybe<Scalars["String"]["input"]>
    rfc?: InputMaybe<Scalars["String"]["input"]>
    telefono?: InputMaybe<Scalars["String"]["input"]>
    /** zona horaria del hotel */
    zona_horaria?: InputMaybe<Scalars["String"]["input"]>
}

export interface UpdateIncidenciaInput {
    area?: InputMaybe<Scalars["String"]["input"]>
    detalle?: InputMaybe<Scalars["String"]["input"]>
    fecha_apertura?: InputMaybe<Scalars["DateTime"]["input"]>
    habitacion_id?: InputMaybe<Scalars["String"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    huesped?: InputMaybe<Scalars["String"]["input"]>
    imagenes?: InputMaybe<Array<ImagenIncidenciaInput>>
    incidencia_id: Scalars["ID"]["input"]
    matricula?: InputMaybe<Scalars["String"]["input"]>
    severidad?: InputMaybe<Scalars["String"]["input"]>
    tipo_incidencia?: InputMaybe<Scalars["String"]["input"]>
    turno_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface UpdateMantenimientoInput {
    /** Consumo de agua */
    agua?: InputMaybe<Scalars["Float"]["input"]>
    colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    fecha_actualizacion?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_registro?: InputMaybe<Scalars["DateTime"]["input"]>
    /** Consumo de gas */
    gas?: InputMaybe<Scalars["Float"]["input"]>
    /** Consumo de luz */
    luz?: InputMaybe<Scalars["Float"]["input"]>
    mantenimiento_id: Scalars["ID"]["input"]
    turno_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface UpdateMesaAsignadaInput {
    colaborador_asignado_id?: InputMaybe<Scalars["ID"]["input"]>
    mesa_asignada_id: Scalars["ID"]["input"]
    mesa_id?: InputMaybe<Scalars["ID"]["input"]>
    orden_id?: InputMaybe<Scalars["ID"]["input"]>
    usuario_modifico_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface UpdateMesaInput {
    cantidad_personas?: InputMaybe<Scalars["Float"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    estado?: InputMaybe<EstadoMesa>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    mesa_id: Scalars["ID"]["input"]
    motivo_bloqueo?: InputMaybe<Scalars["String"]["input"]>
    numero_mesa?: InputMaybe<Scalars["String"]["input"]>
    usuario_modifico_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface UpdateModificadorGrupoModificadorInput {
    grupo_modificador_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    modificador_id?: InputMaybe<Scalars["ID"]["input"]>
    modificadores_grupos_modificadores_id: Scalars["ID"]["input"]
}

export interface UpdateModificadorInput {
    almacen_articulo_id?: InputMaybe<Scalars["ID"]["input"]>
    estado?: InputMaybe<EstadosModificador>
    hotel_id: Scalars["ID"]["input"]
    modificador_id: Scalars["ID"]["input"]
    nombre?: InputMaybe<Scalars["String"]["input"]>
    tipo_modificador?: InputMaybe<TiposModificador>
}

export interface UpdateMonedaInput {
    clave?: InputMaybe<Scalars["String"]["input"]>
    icono?: InputMaybe<Scalars["String"]["input"]>
    moneda_id: Scalars["ID"]["input"]
    nombre?: InputMaybe<Scalars["String"]["input"]>
    simbolo?: InputMaybe<Scalars["String"]["input"]>
}

export interface UpdateMotivoIngresoVehiculoDto {
    /** Identificador del hotel al que pertenece el motivo de ingreso */
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    motivo_ingreso_id: Scalars["ID"]["input"]
    /** Nombre del motivo de ingreso */
    nombre?: InputMaybe<Scalars["String"]["input"]>
}

export interface UpdateOrdenInput {
    consumo_interno_colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    detalles_orden: Array<CreateDetalleOrdenPartialInfoInput>
    easyrewards_id?: InputMaybe<Scalars["String"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    monto_iva: Scalars["Float"]["input"]
    orden_id: Scalars["ID"]["input"]
    /** Marca una orden para que ya no sea mostrada en el panel de cocina */
    panel_no_visible?: InputMaybe<Scalars["Boolean"]["input"]>
    total_con_iva: Scalars["Float"]["input"]
    total_sin_iva: Scalars["Float"]["input"]
    usuario_id: Scalars["String"]["input"]
}

export interface UpdatePagoInput {
    fecha_pago?: InputMaybe<Scalars["DateTime"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    pago_id: Scalars["ID"]["input"]
    total?: InputMaybe<Scalars["Float"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface UpdatePagoRentaInput {
    pago_id?: InputMaybe<Scalars["ID"]["input"]>
    pago_renta_id: Scalars["ID"]["input"]
    renta_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface UpdatePagoReservasInput {
    pago_id?: InputMaybe<Scalars["ID"]["input"]>
    pago_reserva_id: Scalars["ID"]["input"]
    reserva_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface UpdatePersonalizacionTicketInput {
    hotel_id: Scalars["ID"]["input"]
    imagen_promocional?: InputMaybe<Scalars["String"]["input"]>
    mostrar_logo?: InputMaybe<Scalars["Boolean"]["input"]>
    textos_informativos?: InputMaybe<TextosInformativosInput>
}

export interface UpdatePosicionHabitacionInput {
    habitacion_id: Scalars["ID"]["input"]
    posicion: PosicionInput
}

export interface UpdatePosicionMesaInput {
    mesa_id: Scalars["ID"]["input"]
    posicion: PosicionMesaInput
}

export interface UpdatePropinasEsquemaInput {
    propinas_esquema: Array<PropinaEsquemaItemInput>
}

export interface UpdatePuestoInput {
    descripcion?: InputMaybe<Scalars["String"]["input"]>
    estado?: InputMaybe<Scalars["String"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    /** Porcentaje que le corresponde del total de propinas recaudadas */
    porcentaje_propina?: InputMaybe<Scalars["Float"]["input"]>
    puesto_id: Scalars["ID"]["input"]
}

export interface UpdateRecetaInput {
    articulo_id: Scalars["ID"]["input"]
    categoria_id?: InputMaybe<Scalars["ID"]["input"]>
    contenido?: InputMaybe<Scalars["Float"]["input"]>
    costo_actual?: InputMaybe<Scalars["Float"]["input"]>
    estado?: InputMaybe<EstadosArticulo>
    extra?: InputMaybe<Scalars["Boolean"]["input"]>
    folio?: InputMaybe<Scalars["String"]["input"]>
    foto?: InputMaybe<Scalars["String"]["input"]>
    ingredientes?: InputMaybe<Array<IngredienteRecetaInput>>
    marca?: InputMaybe<Scalars["String"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    precio?: InputMaybe<Scalars["Float"]["input"]>
    unidad?: InputMaybe<UnidadMedidasArticulo>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface UpdateRentaInput {
    comentarios?: InputMaybe<Scalars["String"]["input"]>
    easyrewards_id?: InputMaybe<Scalars["String"]["input"]>
    estado?: InputMaybe<EstadosRentas>
    fecha_cancelacion?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_fin?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_salida?: InputMaybe<Scalars["DateTime"]["input"]>
    horas_extra?: InputMaybe<Scalars["Float"]["input"]>
    hospedajes_extra?: InputMaybe<Scalars["Float"]["input"]>
    monto_devuelto_cancelacion?: InputMaybe<Scalars["Float"]["input"]>
    motivo_cancelacion?: InputMaybe<Scalars["String"]["input"]>
    nombre_huesped?: InputMaybe<Scalars["String"]["input"]>
    numero_personas?: InputMaybe<Scalars["Float"]["input"]>
    personas_extra?: InputMaybe<Scalars["Float"]["input"]>
    placas?: InputMaybe<Scalars["String"]["input"]>
    renta_id: Scalars["ID"]["input"]
    tipo_entrada?: InputMaybe<TiposEntradas>
    total?: InputMaybe<Scalars["Float"]["input"]>
}

export interface UpdateReservaInput {
    cliente_id?: InputMaybe<Scalars["ID"]["input"]>
    codigo_ota?: InputMaybe<Scalars["String"]["input"]>
    comentarios: Array<Scalars["String"]["input"]>
    correo_huesped?: InputMaybe<Scalars["String"]["input"]>
    corte_id?: InputMaybe<Scalars["ID"]["input"]>
    easyrewards_id?: InputMaybe<Scalars["String"]["input"]>
    estado?: InputMaybe<EstadosReservas>
    experiencias_ids?: InputMaybe<Array<Scalars["ID"]["input"]>>
    fecha_entrada?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_salida?: InputMaybe<Scalars["DateTime"]["input"]>
    habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
    hospedajes_extra?: Scalars["Int"]["input"]
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    nombre_huesped: Scalars["String"]["input"]
    numero_personas?: InputMaybe<Scalars["Int"]["input"]>
    origen?: InputMaybe<OrigenRservas>
    pago?: InputMaybe<CreatePagoInput>
    personas_extras?: InputMaybe<Scalars["Int"]["input"]>
    reserva_id: Scalars["ID"]["input"]
    servicios_reserva: Array<Scalars["String"]["input"]>
    tarifa_id?: InputMaybe<Scalars["ID"]["input"]>
    telefono_huesped?: InputMaybe<Scalars["String"]["input"]>
    tipo_habitacion_id: Scalars["ID"]["input"]
    total: Scalars["Float"]["input"]
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface UpdateReservaResponse {
    __typename?: "UpdateReservaResponse"
    reserva: Reserva
    ticket: ReturnIdTicketResponse
}

export interface UpdateRolInput {
    nombre: Scalars["String"]["input"]
    rol_id: Scalars["ID"]["input"]
}

export interface UpdateSalidaInput {
    almacen_articulo_id?: InputMaybe<Scalars["ID"]["input"]>
    cantidad?: InputMaybe<Scalars["Float"]["input"]>
    colaborador_id?: InputMaybe<Scalars["ID"]["input"]>
    comentario?: InputMaybe<Scalars["String"]["input"]>
    detalle_orden_id?: InputMaybe<Scalars["ID"]["input"]>
    fecha_salida?: InputMaybe<Scalars["DateTime"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    motivo?: InputMaybe<Motivo>
    salida_id: Array<Scalars["ID"]["input"]>
}

export interface UpdateServicioInput {
    hotel_id: Scalars["ID"]["input"]
    /** Nombre del servicio */
    nombre?: InputMaybe<Scalars["String"]["input"]>
    servicio_id: Scalars["ID"]["input"]
}

export interface UpdateSubcategoriaGastosInput {
    categoria_id?: InputMaybe<Scalars["ID"]["input"]>
    subcategoria?: InputMaybe<Scalars["String"]["input"]>
    subcategoria_gasto_id: Scalars["ID"]["input"]
}

export interface UpdateSubcategoriaProductoInput {
    categoria_id?: InputMaybe<Scalars["ID"]["input"]>
    subcategoria?: InputMaybe<Scalars["String"]["input"]>
    subcategoria_id: Scalars["ID"]["input"]
}

export interface UpdateSurtidoInput {
    almacen_articulo_id?: InputMaybe<Scalars["ID"]["input"]>
    cantidad?: InputMaybe<Scalars["Float"]["input"]>
    colaborador_id: Scalars["ID"]["input"]
    comentario?: InputMaybe<Scalars["String"]["input"]>
    costo_total?: InputMaybe<Scalars["Float"]["input"]>
    costo_unitario?: InputMaybe<Scalars["Float"]["input"]>
    fecha_ingreso?: InputMaybe<Scalars["DateTime"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    numero_orden_factura?: InputMaybe<Scalars["String"]["input"]>
    surtido_id: Scalars["ID"]["input"]
    tipo?: InputMaybe<TiposSurtido>
}

export interface UpdateSuscripcionInput {
    estatus?: InputMaybe<Scalars["String"]["input"]>
    fecha_expiracion?: InputMaybe<Scalars["DateTime"]["input"]>
    suscripcion_id: Scalars["ID"]["input"]
}

export interface UpdateTareaInput {
    descripcion?: InputMaybe<Scalars["String"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    puesto_id?: InputMaybe<Scalars["ID"]["input"]>
    tarea_id: Scalars["ID"]["input"]
    tipo?: InputMaybe<TiposTarea>
}

export interface UpdateTarifaDto {
    costo_early_checkin?: InputMaybe<Scalars["Float"]["input"]>
    costo_habitacion?: InputMaybe<Scalars["Float"]["input"]>
    costo_hora_extra?: InputMaybe<Scalars["Float"]["input"]>
    costo_hospedaje_extra?: InputMaybe<Scalars["Float"]["input"]>
    costo_persona_extra?: InputMaybe<Scalars["Float"]["input"]>
    dias_disponibles?: InputMaybe<Array<DiasDisponibles>>
    duracion_renta?: InputMaybe<Scalars["Float"]["input"]>
    fecha_final?: InputMaybe<Scalars["DateTime"]["input"]>
    fecha_inicio?: InputMaybe<Scalars["DateTime"]["input"]>
    hora_checkin?: InputMaybe<Scalars["String"]["input"]>
    hora_checkout?: InputMaybe<Scalars["String"]["input"]>
    hora_final?: InputMaybe<Scalars["String"]["input"]>
    hora_inicio?: InputMaybe<Scalars["String"]["input"]>
    horas_extra_max?: InputMaybe<Scalars["Float"]["input"]>
    hospedajes_extra_max?: InputMaybe<Scalars["Float"]["input"]>
    nombre: Scalars["String"]["input"]
    pantalla_disponibilidad?: InputMaybe<Scalars["Boolean"]["input"]>
    personas_extra_max?: InputMaybe<Scalars["Float"]["input"]>
    tarifa_id: Scalars["ID"]["input"]
    tipo_alojamiento?: InputMaybe<TiposAlojamientos>
    tipo_tarifa?: InputMaybe<TipoTarifa>
    visible_venta?: InputMaybe<Scalars["Boolean"]["input"]>
}

export interface UpdateTipoBloqueoDto {
    /** Listado de claves del tipo de bloqueo */
    claves?: InputMaybe<Array<ClaveTipoBloqueoInput>>
    /** Identificador del hotel al que pertenece el tipo de bloqueo */
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    /** Nombre del tipo de bloqueo */
    nombre?: InputMaybe<Scalars["String"]["input"]>
    tipo_bloqueo_id: Scalars["ID"]["input"]
}

export interface UpdateTipoHabitacionDto {
    amenidades: Array<Scalars["String"]["input"]>
    camas?: InputMaybe<Array<CamaInput>>
    clave?: InputMaybe<Scalars["String"]["input"]>
    descripcion?: InputMaybe<Scalars["String"]["input"]>
    /** Habitaciones de este tipo que se reservan para renta en recepcion */
    habitaciones_reservadas_recepcion?: InputMaybe<Scalars["Int"]["input"]>
    /** Limite de reservas por dia */
    limite_reservas?: InputMaybe<Scalars["Float"]["input"]>
    minutos_entrada?: InputMaybe<Scalars["Float"]["input"]>
    minutos_limpieza_detallada?: InputMaybe<Scalars["Float"]["input"]>
    minutos_limpieza_normal?: InputMaybe<Scalars["Float"]["input"]>
    minutos_limpieza_retoque?: InputMaybe<Scalars["Float"]["input"]>
    minutos_pendiente_supervision: Scalars["Float"]["input"]
    minutos_sucia: Scalars["Float"]["input"]
    minutos_supervision: Scalars["Float"]["input"]
    nombre?: InputMaybe<Scalars["String"]["input"]>
    personas_incluidas: Scalars["Int"]["input"]
    tipo_habitacion_id: Scalars["ID"]["input"]
}

export interface UpdateTipoLimpiezaInput {
    colaboradores_tareas_ids: Array<Scalars["ID"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    tipo_limpieza?: InputMaybe<TiposLimpiezas>
}

export interface UpdateTipoMantenimientoDto {
    /** Listado de claves del tipo de mantenimiento */
    claves?: InputMaybe<Array<ClaveTipoMantenimientoInput>>
    /** Identificador del hotel al que pertenece el tipo de mantenimiento */
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    /** Nombre del tipo de mantenimiento */
    nombre?: InputMaybe<Scalars["String"]["input"]>
    tipo_mantenimiento_id: Scalars["ID"]["input"]
}

export interface UpdateTurnoAtencionInput {
    estado?: InputMaybe<EstadosTurnosAtencion>
    fecha_registro?: InputMaybe<Scalars["DateTime"]["input"]>
    folio?: InputMaybe<Scalars["Int"]["input"]>
    nombre_o_matricula?: InputMaybe<Scalars["String"]["input"]>
    renta_id?: InputMaybe<Scalars["ID"]["input"]>
    tipo_habitacion_id?: InputMaybe<Scalars["ID"]["input"]>
    turno_atencion_id: Scalars["ID"]["input"]
    usuario_finaliza_turno?: InputMaybe<Scalars["ID"]["input"]>
    usuario_id?: InputMaybe<Scalars["ID"]["input"]>
}

/** Campos que pueden ser directamente modificados de la entidad Turno */
export interface UpdateTurnoInput {
    estado?: InputMaybe<Scalars["String"]["input"]>
    hora_entrada?: InputMaybe<Scalars["String"]["input"]>
    hora_salida?: InputMaybe<Scalars["String"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    orden?: InputMaybe<Scalars["Int"]["input"]>
    turno_id: Scalars["ID"]["input"]
}

export interface UpdateUsuarioInput {
    apellido_materno?: InputMaybe<Scalars["String"]["input"]>
    apellido_paterno?: InputMaybe<Scalars["String"]["input"]>
    cliente_url?: InputMaybe<Scalars["String"]["input"]>
    codigo?: InputMaybe<Scalars["String"]["input"]>
    correo?: InputMaybe<Scalars["String"]["input"]>
    estatus?: InputMaybe<Scalars["String"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
    origen?: InputMaybe<Scalars["String"]["input"]>
    pais?: InputMaybe<Scalars["String"]["input"]>
    password?: InputMaybe<Scalars["String"]["input"]>
    puesto?: InputMaybe<Scalars["String"]["input"]>
    telefono?: InputMaybe<Scalars["String"]["input"]>
    usuario?: InputMaybe<Scalars["String"]["input"]>
    usuario_id: Scalars["ID"]["input"]
    verificado?: InputMaybe<Scalars["Boolean"]["input"]>
}

export interface UpdateUsuariosNotificacionesInput {
    hotel_id?: InputMaybe<Scalars["String"]["input"]>
    notificacion_id?: InputMaybe<Scalars["String"]["input"]>
    /** Array de notificaciones a activar */
    notificaciones_activar?: InputMaybe<Array<TipoNotificacion>>
    /** Array de notificaciones a desactivar */
    notificaciones_desactivar?: InputMaybe<Array<TipoNotificacion>>
    usuario_id?: InputMaybe<Scalars["String"]["input"]>
    usuario_notificaciones_id?: InputMaybe<Scalars["String"]["input"]>
}

export interface Usuario {
    __typename?: "Usuario"
    apellido_materno?: Maybe<Scalars["String"]["output"]>
    apellido_paterno?: Maybe<Scalars["String"]["output"]>
    codigo: Scalars["String"]["output"]
    colaborador?: Maybe<Colaborador>
    /** Configuración de las notificaciones del usuario en app mobile */
    configuracion_notificaciones?: Maybe<ConfiguracionNotificacionesOutput>
    correo: Scalars["String"]["output"]
    eliminado: Scalars["Boolean"]["output"]
    /** dato estadístico */
    empresa_hotel: Scalars["String"]["output"]
    estatus: Scalars["String"]["output"]
    fecha_modificacion: Scalars["DateTime"]["output"]
    fecha_registro: Scalars["DateTime"]["output"]
    hotel?: Maybe<Array<Hotel>>
    metodos_de_pago?: Maybe<Array<MetodoDePago>>
    nombre: Scalars["String"]["output"]
    origen?: Maybe<Origen>
    pais: Scalars["String"]["output"]
    /** dato estadístico */
    puesto_rol?: Maybe<PuestoRol>
    roles?: Maybe<Array<Rol>>
    telefono?: Maybe<Scalars["String"]["output"]>
    tiene_huella?: Maybe<Scalars["Boolean"]["output"]>
    turno?: Maybe<Turno>
    usuario?: Maybe<Scalars["String"]["output"]>
    usuario_id: Scalars["ID"]["output"]
    verificado: Scalars["Boolean"]["output"]
}

export interface UsuarioHotelArgs {
    sesion_id?: InputMaybe<Scalars["ID"]["input"]>
}

export interface UsuariosNotificacionesConfigOutput {
    __typename?: "UsuariosNotificacionesConfigOutput"
    activado: Scalars["Boolean"]["output"]
    tipo: TipoNotificacion
    usuario_notificaciones_id?: Maybe<Scalars["String"]["output"]>
}

export interface ValidarCodigoAutorizacionOutput {
    __typename?: "ValidarCodigoAutorizacionOutput"
    usuario?: Maybe<Usuario>
    usuario_autorizado: Scalars["Boolean"]["output"]
}

export interface ValidateApiKeyInput {
    key: Scalars["String"]["input"]
}

export interface Vehiculo {
    __typename?: "Vehiculo"
    data: Data_Vehiculo
    vehiculo_id: Scalars["ID"]["output"]
}

export interface VehiculoDataEditDetailInput {
    color?: InputMaybe<Scalars["String"]["input"]>
    marca?: InputMaybe<Scalars["String"]["input"]>
    matricula?: InputMaybe<Scalars["String"]["input"]>
    modelo?: InputMaybe<Scalars["String"]["input"]>
}

export interface VehiculoDataEditDetailOutput {
    __typename?: "VehiculoDataEditDetailOutput"
    color?: Maybe<Scalars["String"]["output"]>
    marca?: Maybe<Scalars["String"]["output"]>
    matricula?: Maybe<Scalars["String"]["output"]>
    modelo?: Maybe<Scalars["String"]["output"]>
}

export interface VentaColaboradorPorCategoriaDetailOutput {
    __typename?: "VentaColaboradorPorCategoriaDetailOutput"
    aportacion?: Maybe<Scalars["Float"]["output"]>
    categoria: Scalars["ID"]["output"]
    monto: Scalars["Float"]["output"]
}

export interface VentaExtraRentaDetailOutput {
    __typename?: "VentaExtraRentaDetailOutput"
    /** Datos del colaborador que registro la venta */
    colaborador?: Maybe<Colaborador>
    conceptos: Array<ExtraPendienteRentaDetailOutput>
    folio: Scalars["String"]["output"]
    usuario_id?: Maybe<Scalars["ID"]["output"]>
    venta_id: Scalars["ID"]["output"]
}

export enum Estados_Habitaciones {
    ALaVenta = "a_la_venta",
    Apartada = "apartada",
    Bloqueada = "bloqueada",
    Limpieza = "limpieza",
    Mantenimiento = "mantenimiento",
    Ocupada = "ocupada",
    Preparada = "preparada",
    Reservada = "reservada",
    RoomService = "room_service",
    Sucia = "sucia",
    Supervision = "supervision",
    SupervisionEnCurso = "supervision_en_curso",
    SupervisionPendiente = "supervision_pendiente",
    VentaEnLinea = "venta_en_linea",
}

export enum Estados_Incidencias {
    Activa = "activa",
    Cerrada = "cerrada",
}

export enum Release_Estados_Habitaciones {
    ALaVenta = "a_la_venta",
    Preparada = "preparada",
}

export interface SendChangePasswordViaEmailInput {
    email: Scalars["String"]["input"]
    link: Scalars["String"]["input"]
}

export type OrdenFieldsFragment = {
    __typename?: "Orden"
    comentario?: string | null
    corte_id?: string | null
    estado_orden?: EstadosOrdenHistorial | null
    usuario_id: string
    estado_pago: EstadoPagoOrdenes
    fecha_cobro?: any | null
    fecha_modificacion?: any | null
    fecha_registro: any
    orden: string
    orden_id: string
    renta_id?: string | null
    origen_orden?: string | null
    virtual_comanda_id?: string | null
    comanda?: {
        __typename?: "Comanda"
        comanda_id: string
        estado_comanda?: EstadosComandaHistorial | null
        folio: number
        fecha_modificacion?: any | null
        fecha_registro: any
    } | null
    mesa?: { __typename?: "Mesa"; numero_mesa: string } | null
    renta?: {
        __typename?: "Renta"
        habitacion_id: string
        habitacion?: {
            __typename?: "Habitacion"
            habitacion_id: string
            numero_habitacion: string
            tipo_habitacion_id: string
            usuario_id: string
            tipo_habitacion?: { __typename?: "TipoHabitacion"; nombre: string; tipo_habitacion_id: string } | null
        } | null
    } | null
}

export type DetallesOrdenFieldsFragment = {
    __typename?: "DetalleOrden"
    almacen_articulo_id: string
    cantidad: number
    comanda_id?: string | null
    comentarios?: string | null
    detalle_orden_id: string
    estado: EstadosDetalleOrden
    orden_id: string
    almacen_articulo?: {
        __typename?: "AlmacenArticulo"
        almacen_articulo_id: string
        almacen_id: string
        articulo_id: string
        articulo?: {
            __typename?: "Articulo"
            articulo_id: string
            nombre: string
            foto?: string | null
            tipo: TipoArticulo
            categoria_articulo?: { __typename?: "CategoriaArticulo"; categoria_id: string; nombre: string } | null
        } | null
    } | null
    extras?: Array<{
        __typename?: "ExtraDetalleOrden"
        almacen_articulo_id: string
        cantidad: number
        costo_con_iva: number
        costo_sin_iva: number
        detalle_orden_id: string
        extra_detalle_orden_id: string
        monto_iva: number
        almacen_articulo?: {
            __typename?: "AlmacenArticulo"
            almacen_articulo_id: string
            articulo_id: string
            articulo?: { __typename?: "Articulo"; articulo_id: string; nombre: string } | null
        } | null
    }> | null
}

export type LoginGoogleMutationVariables = Exact<{
    loginGoogleInput: LoginGoogleInput
}>

export type LoginGoogleMutation = {
    __typename?: "Mutation"
    login_google: {
        __typename?: "LoginGoogleResponse"
        token: string
        usuario_id?: string | null
        ultimo_hotel_id?: string | null
        expires_in?: string | null
    }
}

export type CrearUsuarioMutationVariables = Exact<{
    createUsuarioInput: CreateUsuarioInput
}>

export type CrearUsuarioMutation = {
    __typename?: "Mutation"
    crear_usuario: {
        __typename?: "Usuario"
        correo: string
        eliminado: boolean
        estatus: string
        fecha_registro: any
        nombre: string
        puesto_rol?: PuestoRol | null
    }
}

export type Obtener_Usuario_GoogleMutationVariables = Exact<{
    getGoogleUserInput: GetGoogleUserInput
}>

export type Obtener_Usuario_GoogleMutation = {
    __typename?: "Mutation"
    obtener_usuario_google: {
        __typename?: "GoogleUserResponse"
        email: string
        family_name: string
        given_name: string
        picture: string
    }
}

export type ActualizarUsuarioMutationVariables = Exact<{
    updateUsuarioInput: UpdateUsuarioInput
}>

export type ActualizarUsuarioMutation = {
    __typename?: "Mutation"
    actualizar_usuario: { __typename?: "Usuario"; verificado: boolean }
}

export type Validar_Codigo_AutorizacionMutationVariables = Exact<{
    codigo?: InputMaybe<Scalars["String"]["input"]>
    huella?: InputMaybe<Scalars["String"]["input"]>
}>

export type Validar_Codigo_AutorizacionMutation = {
    __typename?: "Mutation"
    validar_codigo_huella_autorizacion: {
        __typename?: "ValidarCodigoAutorizacionOutput"
        usuario_autorizado: boolean
        usuario?: {
            __typename?: "Usuario"
            usuario_id: string
            roles?: Array<{ __typename: "Rol"; nombre: string }> | null
        } | null
    }
}

export type AutenticarHuellaMutationVariables = Exact<{
    input: AuthenticateCredencialInput
}>

export type AutenticarHuellaMutation = {
    __typename?: "Mutation"
    autenticar_huella: { __typename?: "AuthenticateCredentialOutput"; usuario_id: string }
}

export type LogoutMutationVariables = Exact<{
    cerrar_turno?: InputMaybe<Scalars["Boolean"]["input"]>
    hotel_id: Scalars["String"]["input"]
    sesion_id: Scalars["ID"]["input"]
}>

export type LogoutMutation = { __typename?: "Mutation"; logout: string }

export type LoginMutationVariables = Exact<{
    loginInput: AuthLoginInput
}>

export type LoginMutation = {
    __typename?: "Mutation"
    login: {
        __typename?: "AuthLoginResponse"
        token: string
        colaborador_activo?: boolean | null
        usuario_id?: string | null
        ultimo_hotel_id?: string | null
        expires_in?: string | null
    }
}

export type RegistrarEventoLoginMutationVariables = Exact<{
    input: TraceStartHistorialLoginInput
}>

export type RegistrarEventoLoginMutation = { __typename?: "Mutation"; registrar_evento_login: boolean }

export type CambiarTareaDeHabitacionMutationVariables = Exact<{
    datos_cambio: SwitchTaskRoomInput
}>

export type CambiarTareaDeHabitacionMutation = { __typename?: "Mutation"; cambiar_tarea_habitacion: string }

export type CambiarTareaConEstadoMutationVariables = Exact<{
    switch_task_with_room_state_input: SwitchTaskWithRoomStateInput
}>

export type CambiarTareaConEstadoMutation = { __typename?: "Mutation"; cambiar_tarea_con_estado: string }

export type CambiarTareaEntreColaboradoresMutationVariables = Exact<{
    switch_task_btw_colab_input: SwitchTaskBtwColabInput
}>

export type CambiarTareaEntreColaboradoresMutation = {
    __typename?: "Mutation"
    cambiar_tarea_entre_colaboradores: string
}

export type GetHotelStatusQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type GetHotelStatusQuery = {
    __typename?: "Query"
    hotel: {
        __typename?: "Hotel"
        hotel_id: string
        imas_transaccion_status: boolean
        suscripciones?: Array<{
            __typename?: "Suscripcion"
            suscripcion_id: string
            eliminado: boolean
            estatus: string
            modulos?: Array<{ __typename?: "Modulo"; modulo_id: string; nombre_modulo: string }> | null
        }> | null
    }
}

export type CloseCorteAvailableSubscriptionVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type CloseCorteAvailableSubscription = {
    __typename?: "Subscription"
    checkHotel: { __typename?: "Hotel"; imas_transaccion_status: boolean }
}

export type ListenMyColaboradorSubscriptionVariables = Exact<{
    colaborador_id: Scalars["ID"]["input"]
}>

export type ListenMyColaboradorSubscription = {
    __typename?: "Subscription"
    checkColaborador: {
        __typename?: "Colaborador"
        colaborador_id: string
        nombre: string
        en_turno: boolean
        estado: string
    }
}

export type GetTicketForCancelacionQueryVariables = Exact<{
    ticket_id: Scalars["ID"]["input"]
}>

export type GetTicketForCancelacionQuery = {
    __typename?: "Query"
    ticket: {
        __typename?: "Ticket"
        ticket_id: string
        data: {
            __typename?: "DataTicket"
            renta_id?: string | null
            origen_ticket: {
                __typename?: "OrigenTicket"
                id: string
                origen: OrigenesTicket
                renta?: {
                    __typename?: "Renta"
                    renta_id: string
                    estado: EstadosRentas
                    habitacion_id: string
                    habitacion?: {
                        __typename?: "Habitacion"
                        habitacion_id: string
                        estado: Estados_Habitaciones
                        ultima_renta?: { __typename?: "Renta"; renta_id: string } | null
                    } | null
                } | null
            }
        }
    }
}

export type GetTransaccionesForCancelacionQueryVariables = Exact<{
    renta_id: Scalars["ID"]["input"]
}>

export type GetTransaccionesForCancelacionQuery = {
    __typename?: "Query"
    transacciones_renta?: {
        __typename?: "GetRentaTransactionsOutput"
        ordenes?: Array<{
            __typename?: "RentaOrdenTransactionItemOutput"
            ticket_id?: string | null
            orden_id: string
            orden?: {
                __typename?: "Orden"
                orden: string
                orden_id: string
                corte_id?: string | null
                total_con_iva: number
                fecha_registro: any
                detalles_orden?: Array<{
                    __typename?: "DetalleOrden"
                    detalle_orden_id: string
                    cantidad: number
                    almacen_articulo_id: string
                    almacen_articulo?: {
                        __typename?: "AlmacenArticulo"
                        almacen_articulo_id: string
                        articulo_id: string
                        articulo?: {
                            __typename?: "Articulo"
                            articulo_id: string
                            nombre: string
                            categoria_id?: string | null
                            categoria_articulo?: {
                                __typename?: "CategoriaArticulo"
                                categoria_id: string
                                nombre: string
                            } | null
                        } | null
                    } | null
                    extras?: Array<{
                        __typename?: "ExtraDetalleOrden"
                        extra_detalle_orden_id: string
                        cantidad: number
                        almacen_articulo_id: string
                        almacen_articulo?: {
                            __typename?: "AlmacenArticulo"
                            almacen_articulo_id: string
                            articulo_id: string
                            articulo?: {
                                __typename?: "Articulo"
                                articulo_id: string
                                nombre: string
                                categoria_id?: string | null
                                categoria_articulo?: {
                                    __typename?: "CategoriaArticulo"
                                    categoria_id: string
                                    nombre: string
                                } | null
                            } | null
                        } | null
                    }> | null
                }> | null
            } | null
            ticket?: { __typename?: "Ticket"; ticket_id: string; folio: number } | null
        }> | null
        transacciones?: Array<{
            __typename?: "RentaTransactionItemOutput"
            ticket_id?: string | null
            extras?: Array<{
                __typename?: "Extra"
                extra_id: string
                tipo_extra: TiposExtras
                ticket_id?: string | null
            }> | null
        }> | null
        transacciones_checkin: Array<{
            __typename?: "RentaTransactionItemOutput"
            ticket_id?: string | null
            extras?: Array<{
                __typename?: "Extra"
                extra_id: string
                tipo_extra: TiposExtras
                ticket_id?: string | null
            }> | null
        }>
    } | null
}

export type GetDataTicketQueryVariables = Exact<{
    ticket_id: Scalars["ID"]["input"]
}>

export type GetDataTicketQuery = {
    __typename?: "Query"
    ticket: {
        __typename?: "Ticket"
        ticket_id: string
        data: {
            __typename?: "DataTicket"
            metodos_pago: Array<{
                __typename?: "MetodosPagoTicket"
                numero_referencia?: string | null
                tipo: string
                total: number
                ultimos_digitos?: string | null
            }>
            propinas: Array<{
                __typename?: "PropinasDetalleTicket"
                numero_referencia?: string | null
                total: number
                ultimos_digitos?: string | null
                tipo_pago: TiposPagos
            }>
        }
    }
}

export type AutorizarFajillaMutationVariables = Exact<{
    dataAutorizar: AutorizarFajillaInput
}>

export type AutorizarFajillaMutation = { __typename?: "Mutation"; autorizar_fajilla: string }

export type RechazarFajillaMutationVariables = Exact<{
    dataRechazar: RechazarFajillaInput
}>

export type RechazarFajillaMutation = { __typename?: "Mutation"; rechazar_fajilla: string }

export type Cerrar_CorteMutationVariables = Exact<{
    datos_corte: CloseCorteInput
    hotel_id: Scalars["ID"]["input"]
}>

export type Cerrar_CorteMutation = {
    __typename?: "Mutation"
    cerrar_corte?: { __typename?: "Corte"; corte_id: string } | null
}

export type CrearFajillaMutationVariables = Exact<{
    crearFajillaInput: CreateFajillaInput
}>

export type CrearFajillaMutation = {
    __typename?: "Mutation"
    crear_fajilla: {
        __typename?: "Fajilla"
        fajilla_id: string
        ticket_id: string
        fecha_autorizaicion?: any | null
        fecha_creacion: any
    }
}

export type AlertaPagosPendientesQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type AlertaPagosPendientesQuery = {
    __typename?: "Query"
    alertas_corte: {
        __typename?: "AlertasCorteOutput"
        alerta_por_pagos_pendientes: boolean
        registros_pendientes: {
            __typename?: "AlertasPorRegistrosPendientesDetailOutput"
            registro_obligatorio: boolean
            alerta_por_placas_pendientes: boolean
            alerta_por_mantenimiento_pendiente: boolean
        }
        registros_pagos_pendientes: Array<{
            __typename?: "RegistroPagoPendienteOutput"
            folio: string
            categoria: string
            concepto: string
            monto: number
            fecha: any
        }>
    }
}

export type GetFajillasQueryVariables = Exact<{ [key: string]: never }>

export type GetFajillasQuery = {
    __typename?: "Query"
    fajillas: Array<{
        __typename?: "Fajilla"
        monto: number
        estatus: EstatusFajillas
        fajilla_id: string
        fecha_creacion: any
        fecha_autorizaicion?: any | null
        usuario_creo_id: string
        usuario_autorizo_id?: string | null
        turno_id: string
        comentario?: string | null
        folio: number
        usuario_autorizo?: {
            __typename?: "Usuario"
            nombre: string
            apellido_materno?: string | null
            apellido_paterno?: string | null
        } | null
        usuario_creo?: {
            __typename?: "Usuario"
            nombre: string
            apellido_paterno?: string | null
            apellido_materno?: string | null
        } | null
    }>
}

export type GetCorteQueryVariables = Exact<{
    corte_id: Scalars["ID"]["input"]
}>

export type GetCorteQuery = {
    __typename?: "Query"
    corte: {
        __typename?: "Corte"
        corte_id: string
        fecha_cierre_corte?: string | null
        fecha_fin_corte?: string | null
        fecha_inicio_corte: string
        efectivo_ingresado: number
        folio: number
        turno_id: string
        total_caja: number
        estatus: EstatusCorte
        usuario_cierra_corte?: string | null
        usuario_realiza_corte: string
        total_corte: number
        turno: { __typename?: "Turno"; nombre: string }
        incidencias?: Array<{ __typename?: "Incidencia"; incidencia_id: string }> | null
        usuario_crea?: {
            __typename?: "Usuario"
            apellido_materno?: string | null
            apellido_paterno?: string | null
            nombre: string
        } | null
        usuario_cierra?: {
            __typename?: "Usuario"
            apellido_materno?: string | null
            apellido_paterno?: string | null
            nombre: string
        } | null
    }
}

export type EditarMetodoDePagoMovimientoMutationVariables = Exact<{
    editMetodoPagoTicketInput: EditMetodoPagoTicketInput
}>

export type EditarMetodoDePagoMovimientoMutation = {
    __typename?: "Mutation"
    editar_metodo_pago: { __typename?: "EditMetodoPagoTicketOutput"; ticket_id: string }
}

export type Resumen_Movimientos_Antes_CorteQueryVariables = Exact<{
    fecha_inicio: Scalars["DateTime"]["input"]
    fecha_fin: Scalars["DateTime"]["input"]
    hotel_id: Scalars["ID"]["input"]
}>

export type Resumen_Movimientos_Antes_CorteQuery = {
    __typename?: "Query"
    movimientos_antes_corte: {
        __typename?: "GetMovementsCountBeforeCorteOutput"
        numero_total_movimientos: number
        suma_total_montos: number
    }
}

export type GetCortesQueryVariables = Exact<{ [key: string]: never }>

export type GetCortesQuery = {
    __typename?: "Query"
    cortes: Array<{
        __typename?: "Corte"
        corte_id: string
        fecha_cierre_corte?: string | null
        fecha_fin_corte?: string | null
        fecha_inicio_corte: string
        efectivo_ingresado: number
        folio: number
        turno_id: string
        usuario_cierra_corte?: string | null
        usuario_realiza_corte: string
        total_corte: number
        turno: { __typename?: "Turno"; nombre: string }
        incidencias?: Array<{ __typename?: "Incidencia"; incidencia_id: string }> | null
        usuario_crea?: {
            __typename?: "Usuario"
            apellido_materno?: string | null
            apellido_paterno?: string | null
            nombre: string
        } | null
        usuario_cierra?: {
            __typename?: "Usuario"
            apellido_materno?: string | null
            apellido_paterno?: string | null
            nombre: string
        } | null
    }>
}

export type Ultimo_CorteQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type Ultimo_CorteQuery = {
    __typename?: "Query"
    ultimo_corte?: {
        __typename?: "Corte"
        corte_id: string
        fecha_cierre_corte?: string | null
        fecha_fin_corte?: string | null
        fecha_inicio_corte: string
        efectivo_ingresado: number
        folio: number
        turno_id: string
        usuario_cierra_corte?: string | null
        usuario_realiza_corte: string
        total_corte: number
        turno: { __typename?: "Turno"; nombre: string }
        incidencias?: Array<{ __typename?: "Incidencia"; incidencia_id: string }> | null
        usuario_crea?: {
            __typename?: "Usuario"
            apellido_materno?: string | null
            apellido_paterno?: string | null
            nombre: string
        } | null
        usuario_cierra?: {
            __typename?: "Usuario"
            apellido_materno?: string | null
            apellido_paterno?: string | null
            nombre: string
        } | null
    } | null
}

export type ArticulosQueryVariables = Exact<{
    fecha_registro?: InputMaybe<DateSearchInput>
    pagination_options: PageOptionsArgs
}>

export type ArticulosQuery = {
    __typename?: "Query"
    almacenes_articulos: {
        __typename?: "SearchAlmacenesArticulosOutput"
        almacenes_articulos: Array<{
            __typename?: "AlmacenArticulo"
            articulo_id: string
            costo: number
            precio: number
            articulo?: {
                __typename?: "Articulo"
                cantidad_minima?: number | null
                cantidad_vendida: number
                categoria_id?: string | null
                contenido: number
                descripcion?: string | null
                eliminado: boolean
                estado: EstadosArticulo
                fecha_eliminado?: any | null
                fecha_registro: any
                folio?: string | null
                foto?: string | null
                tipo: TipoArticulo
                marca?: string | null
                nombre: string
                stock?: number | null
                unidad: UnidadMedidasArticulo
            } | null
        }>
    }
}

export type GetUsuariosQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type GetUsuariosQuery = {
    __typename?: "Query"
    usuarios: Array<{
        __typename?: "Usuario"
        nombre: string
        apellido_materno?: string | null
        apellido_paterno?: string | null
        usuario_id: string
    }>
}

export type GetCortesHistorialQueryVariables = Exact<{
    fecha_inicio_corte?: InputMaybe<DateSearchInput>
    fecha_corte?: InputMaybe<DaySearchInput>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    estatus?: InputMaybe<EstatusCorte>
}>

export type GetCortesHistorialQuery = {
    __typename?: "Query"
    cortes: Array<{
        __typename?: "Corte"
        corte_id: string
        folio: number
        total_corte: number
        total_pagos_pendientes: number
        fecha_cierre_corte?: string | null
        fecha_inicio_corte: string
        fecha_fin_corte?: string | null
        usuario_cierra_corte?: string | null
        usuario_realiza_corte: string
        turno_id: string
        usuario_crea?: {
            __typename?: "Usuario"
            nombre: string
            apellido_materno?: string | null
            apellido_paterno?: string | null
        } | null
        usuario_cierra?: {
            __typename?: "Usuario"
            nombre: string
            apellido_materno?: string | null
            apellido_paterno?: string | null
        } | null
        turno: { __typename?: "Turno"; nombre: string }
        incidencias?: Array<{ __typename?: "Incidencia"; incidencia_id: string }> | null
    }>
}

export type GetTicketForDetailQueryVariables = Exact<{
    ticket_id: Scalars["ID"]["input"]
}>

export type GetTicketForDetailQuery = {
    __typename?: "Query"
    ticket: {
        __typename?: "Ticket"
        cancelado: boolean
        consumo_interno: boolean
        cortesia: boolean
        fecha_cancelacion?: any | null
        motivo_cancelacion?: string | null
        fecha_impresion: any
        folio: number
        hotel_id: string
        monto_fajilla?: number | null
        reserva_id?: string | null
        saldo?: number | null
        ticket_id: string
        usuario_id: string
        data: {
            __typename: "DataTicket"
            nombre_tarifa?: string | null
            articulos: Array<{
                __typename?: "ArticuloTicket"
                articulo_id: string
                cantidad: number
                costo: number
                nombre: string
            }>
            extras: Array<{ __typename: "ExtraTicket"; cantidad: number; costo: number; tipo: string }>
            habitaciones: Array<{
                __typename: "HabitacionTicket"
                costo: number
                early_checkin: number
                numero: string
                tipo: string
            }>
            metodos_pago: Array<{
                __typename: "MetodosPagoTicket"
                numero_referencia?: string | null
                tipo: string
                total: number
                ultimos_digitos?: string | null
            }>
            propinas: Array<{
                __typename: "PropinasDetalleTicket"
                procedencia: ProcedenciaPropina
                tipo_pago: TiposPagos
                total: number
                ultimos_digitos?: string | null
            }>
            renta: Array<{
                __typename: "RentaTicket"
                descripcion: string
                habitacion_id: string
                numero_habitacion: string
            }>
        }
        reserva?: {
            __typename: "Reserva"
            cliente_id?: string | null
            codigo_ota: string
            estado: EstadosReservas
            estado_pago: EstadoPago
            fecha_cancelacion?: any | null
            fecha_entrada: any
            fecha_registro: any
            fecha_salida: any
            hospedajes_extra: number
            monto_devuelto_cancelacion?: number | null
            motivo_cancelacion?: string | null
            nombre_huesped: string
            origen: OrigenRservas
            saldo: number
            tipo_habitacion_id: string
            total: number
        } | null
        ordenes?: Array<{
            __typename?: "Orden"
            orden_id: string
            origen_orden?: string | null
            renta_id?: string | null
            renta?: {
                __typename?: "Renta"
                renta_id: string
                habitacion_id: string
                habitacion?: {
                    __typename?: "Habitacion"
                    habitacion_id: string
                    tipo_habitacion_id: string
                    numero_habitacion: string
                    tipo_habitacion?: {
                        __typename?: "TipoHabitacion"
                        tipo_habitacion_id: string
                        nombre: string
                    } | null
                } | null
            } | null
        }> | null
        gasto?: {
            __typename?: "GastoTicket"
            folio: string
            caja_chica: boolean
            concepto: string
            categoria: string
        } | null
    }
}

export type LoginHuellaMutationVariables = Exact<{
    template_sample: Scalars["String"]["input"]
}>

export type LoginHuellaMutation = {
    __typename?: "Mutation"
    login_huella: {
        __typename?: "FingerPrintLoginOutput"
        token: string
        usuario_id?: string | null
        ultimo_hotel_id?: string | null
        colaborador_activo?: boolean | null
    }
}

export type GetOrdenesEnPreparacionQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type GetOrdenesEnPreparacionQuery = {
    __typename?: "Query"
    ordenes: Array<{
        __typename?: "Orden"
        comentario?: string | null
        corte_id?: string | null
        estado_orden?: EstadosOrdenHistorial | null
        estado_pago: EstadoPagoOrdenes
        fecha_cobro?: any | null
        fecha_modificacion?: any | null
        fecha_registro: any
        orden: string
        orden_id: string
        consumo_interno_colaborador_id?: string | null
        renta_id?: string | null
        origen_orden?: string | null
        virtual_comanda_id?: string | null
        colaborador_consumo_interno?: { __typename?: "Colaborador"; nombre: string; apellido_paterno: string } | null
        comanda?: {
            __typename?: "Comanda"
            comanda_id: string
            estado_comanda?: EstadosComandaHistorial | null
            folio: number
            fecha_modificacion?: any | null
            fecha_registro: any
        } | null
        mesa?: { __typename?: "Mesa"; numero_mesa: string } | null
        renta?: {
            __typename?: "Renta"
            habitacion_id: string
            habitacion?: {
                __typename?: "Habitacion"
                habitacion_id: string
                numero_habitacion: string
                tipo_habitacion_id: string
                usuario_id: string
                tipo_habitacion?: { __typename?: "TipoHabitacion"; nombre: string; tipo_habitacion_id: string } | null
            } | null
        } | null
        detalles_orden?: Array<{
            __typename?: "DetalleOrden"
            almacen_articulo_id: string
            cantidad: number
            comanda_id?: string | null
            comentarios?: string | null
            detalle_orden_id: string
            estado: EstadosDetalleOrden
            orden_id: string
            almacen_articulo?: {
                __typename?: "AlmacenArticulo"
                almacen_articulo_id: string
                almacen_id: string
                articulo_id: string
                articulo?: {
                    __typename?: "Articulo"
                    articulo_id: string
                    nombre: string
                    foto?: string | null
                    tipo: TipoArticulo
                    categoria_articulo?: {
                        __typename?: "CategoriaArticulo"
                        categoria_id: string
                        nombre: string
                    } | null
                } | null
            } | null
            extras?: Array<{
                __typename?: "ExtraDetalleOrden"
                almacen_articulo_id: string
                cantidad: number
                costo_con_iva: number
                costo_sin_iva: number
                detalle_orden_id: string
                extra_detalle_orden_id: string
                monto_iva: number
                almacen_articulo?: {
                    __typename?: "AlmacenArticulo"
                    almacen_articulo_id: string
                    articulo_id: string
                    articulo?: { __typename?: "Articulo"; articulo_id: string; nombre: string } | null
                } | null
            }> | null
        }> | null
    }>
}

export type GetOrdenesEnEntregaQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type GetOrdenesEnEntregaQuery = {
    __typename?: "Query"
    ordenes: Array<{
        __typename?: "Orden"
        comentario?: string | null
        corte_id?: string | null
        estado_orden?: EstadosOrdenHistorial | null
        estado_pago: EstadoPagoOrdenes
        fecha_cobro?: any | null
        fecha_modificacion?: any | null
        fecha_registro: any
        orden: string
        orden_id: string
        consumo_interno_colaborador_id?: string | null
        renta_id?: string | null
        origen_orden?: string | null
        virtual_comanda_id?: string | null
        colaborador_consumo_interno?: { __typename?: "Colaborador"; nombre: string; apellido_paterno: string } | null
        comanda?: {
            __typename?: "Comanda"
            comanda_id: string
            estado_comanda?: EstadosComandaHistorial | null
            folio: number
            fecha_modificacion?: any | null
            fecha_registro: any
        } | null
        mesa?: { __typename?: "Mesa"; numero_mesa: string } | null
        renta?: {
            __typename?: "Renta"
            habitacion_id: string
            habitacion?: {
                __typename?: "Habitacion"
                habitacion_id: string
                numero_habitacion: string
                tipo_habitacion_id: string
                usuario_id: string
                tipo_habitacion?: { __typename?: "TipoHabitacion"; nombre: string; tipo_habitacion_id: string } | null
            } | null
        } | null
        detalles_orden?: Array<{
            __typename?: "DetalleOrden"
            almacen_articulo_id: string
            cantidad: number
            comanda_id?: string | null
            comentarios?: string | null
            detalle_orden_id: string
            estado: EstadosDetalleOrden
            orden_id: string
            almacen_articulo?: {
                __typename?: "AlmacenArticulo"
                almacen_articulo_id: string
                almacen_id: string
                articulo_id: string
                articulo?: {
                    __typename?: "Articulo"
                    articulo_id: string
                    nombre: string
                    foto?: string | null
                    tipo: TipoArticulo
                    categoria_articulo?: {
                        __typename?: "CategoriaArticulo"
                        categoria_id: string
                        nombre: string
                    } | null
                } | null
            } | null
            extras?: Array<{
                __typename?: "ExtraDetalleOrden"
                almacen_articulo_id: string
                cantidad: number
                costo_con_iva: number
                costo_sin_iva: number
                detalle_orden_id: string
                extra_detalle_orden_id: string
                monto_iva: number
                almacen_articulo?: {
                    __typename?: "AlmacenArticulo"
                    almacen_articulo_id: string
                    articulo_id: string
                    articulo?: { __typename?: "Articulo"; articulo_id: string; nombre: string } | null
                } | null
            }> | null
        }> | null
    }>
}

export type ActualizarEstadoOrdenDetalleMutationVariables = Exact<{
    input: UpdateEstadoOrdenOrDetalleInput
    usuario_autorizo_id?: InputMaybe<Scalars["String"]["input"]>
}>

export type ActualizarEstadoOrdenDetalleMutation = {
    __typename?: "Mutation"
    actualizar_estado_orden_o_detalle?: {
        __typename?: "UpdateEstadoOrdenOrDetalleOutput"
        estado_origen: EstadosOrdenHistorial
        estado_destino: EstadosOrdenHistorial
        folio_orden?: string | null
        nombre_articulo?: string | null
    } | null
}

export type ListenCheckOrdenesSubscriptionVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type ListenCheckOrdenesSubscription = {
    __typename?: "Subscription"
    checkOrdenes?: {
        __typename?: "ListenOrdenesStateSubOutput"
        orden_en_preparacion?: {
            __typename?: "OrdenSubDetail"
            tipo: TipoOrdenPanelCocina
            accion: OrdenesPanelAction
            orden: {
                __typename?: "Orden"
                comentario?: string | null
                corte_id?: string | null
                estado_orden?: EstadosOrdenHistorial | null
                usuario_id: string
                estado_pago: EstadoPagoOrdenes
                fecha_cobro?: any | null
                fecha_modificacion?: any | null
                fecha_registro: any
                orden: string
                orden_id: string
                renta_id?: string | null
                origen_orden?: string | null
                virtual_comanda_id?: string | null
                consumo_interno_colaborador_id?: string | null
                comanda?: {
                    __typename?: "Comanda"
                    comanda_id: string
                    estado_comanda?: EstadosComandaHistorial | null
                    folio: number
                    fecha_modificacion?: any | null
                    fecha_registro: any
                } | null
                mesa?: { __typename?: "Mesa"; numero_mesa: string } | null
                renta?: {
                    __typename?: "Renta"
                    habitacion_id: string
                    habitacion?: {
                        __typename?: "Habitacion"
                        habitacion_id: string
                        numero_habitacion: string
                        tipo_habitacion_id: string
                        usuario_id: string
                        tipo_habitacion?: {
                            __typename?: "TipoHabitacion"
                            nombre: string
                            tipo_habitacion_id: string
                        } | null
                    } | null
                } | null
                detalles_orden?: Array<{
                    __typename?: "DetalleOrden"
                    almacen_articulo_id: string
                    cantidad: number
                    comanda_id?: string | null
                    comentarios?: string | null
                    detalle_orden_id: string
                    estado: EstadosDetalleOrden
                    orden_id: string
                    almacen_articulo?: {
                        __typename?: "AlmacenArticulo"
                        almacen_articulo_id: string
                        almacen_id: string
                        articulo_id: string
                        articulo?: {
                            __typename?: "Articulo"
                            articulo_id: string
                            nombre: string
                            foto?: string | null
                            tipo: TipoArticulo
                            categoria_articulo?: {
                                __typename?: "CategoriaArticulo"
                                categoria_id: string
                                nombre: string
                            } | null
                        } | null
                    } | null
                    extras?: Array<{
                        __typename?: "ExtraDetalleOrden"
                        almacen_articulo_id: string
                        cantidad: number
                        costo_con_iva: number
                        costo_sin_iva: number
                        detalle_orden_id: string
                        extra_detalle_orden_id: string
                        monto_iva: number
                        almacen_articulo?: {
                            __typename?: "AlmacenArticulo"
                            almacen_articulo_id: string
                            articulo_id: string
                            articulo?: { __typename?: "Articulo"; articulo_id: string; nombre: string } | null
                        } | null
                    }> | null
                }> | null
                colaborador_consumo_interno?: {
                    __typename?: "Colaborador"
                    nombre: string
                    apellido_paterno: string
                } | null
                pago?: { __typename?: "Pago"; pago_id: string; ticket_id?: string | null } | null
            }
        } | null
        orden_por_entregar?: {
            __typename?: "OrdenSubDetail"
            tipo: TipoOrdenPanelCocina
            accion: OrdenesPanelAction
            orden: {
                __typename?: "Orden"
                comentario?: string | null
                corte_id?: string | null
                estado_orden?: EstadosOrdenHistorial | null
                usuario_id: string
                estado_pago: EstadoPagoOrdenes
                fecha_cobro?: any | null
                fecha_modificacion?: any | null
                fecha_registro: any
                orden: string
                orden_id: string
                renta_id?: string | null
                origen_orden?: string | null
                virtual_comanda_id?: string | null
                consumo_interno_colaborador_id?: string | null
                comanda?: {
                    __typename?: "Comanda"
                    comanda_id: string
                    estado_comanda?: EstadosComandaHistorial | null
                    folio: number
                    fecha_modificacion?: any | null
                    fecha_registro: any
                } | null
                mesa?: { __typename?: "Mesa"; numero_mesa: string } | null
                renta?: {
                    __typename?: "Renta"
                    habitacion_id: string
                    habitacion?: {
                        __typename?: "Habitacion"
                        habitacion_id: string
                        numero_habitacion: string
                        tipo_habitacion_id: string
                        usuario_id: string
                        tipo_habitacion?: {
                            __typename?: "TipoHabitacion"
                            nombre: string
                            tipo_habitacion_id: string
                        } | null
                    } | null
                } | null
                detalles_orden?: Array<{
                    __typename?: "DetalleOrden"
                    almacen_articulo_id: string
                    cantidad: number
                    comanda_id?: string | null
                    comentarios?: string | null
                    detalle_orden_id: string
                    estado: EstadosDetalleOrden
                    orden_id: string
                    almacen_articulo?: {
                        __typename?: "AlmacenArticulo"
                        almacen_articulo_id: string
                        almacen_id: string
                        articulo_id: string
                        articulo?: {
                            __typename?: "Articulo"
                            articulo_id: string
                            nombre: string
                            foto?: string | null
                            tipo: TipoArticulo
                            categoria_articulo?: {
                                __typename?: "CategoriaArticulo"
                                categoria_id: string
                                nombre: string
                            } | null
                        } | null
                    } | null
                    extras?: Array<{
                        __typename?: "ExtraDetalleOrden"
                        almacen_articulo_id: string
                        cantidad: number
                        costo_con_iva: number
                        costo_sin_iva: number
                        detalle_orden_id: string
                        extra_detalle_orden_id: string
                        monto_iva: number
                        almacen_articulo?: {
                            __typename?: "AlmacenArticulo"
                            almacen_articulo_id: string
                            articulo_id: string
                            articulo?: { __typename?: "Articulo"; articulo_id: string; nombre: string } | null
                        } | null
                    }> | null
                }> | null
                colaborador_consumo_interno?: {
                    __typename: "Colaborador"
                    nombre: string
                    apellido_paterno: string
                } | null
            }
        } | null
    } | null
}

export type GetDisponibilidadHabitacionesQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type GetDisponibilidadHabitacionesQuery = {
    __typename?: "Query"
    disponibilidad_habitaciones?: Array<{
        __typename?: "TipoHabitacionPartialDetail"
        tipo_habitacion_id: string
        nombre: string
        foto?: string | null
        personas_incluidas: number
        disponibles?: number | null
    }> | null
}

export type GetDisponibilidadTarifasQueryVariables = Exact<{
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
}>

export type GetDisponibilidadTarifasQuery = {
    __typename?: "Query"
    tarifas: Array<{
        __typename?: "Tarifa"
        nombre: string
        tarifa_id: string
        dias_disponibles: Array<DiasDisponibles>
        tipo_habitacion_id: string
        tipo_tarifa: TipoTarifa
        costo_habitacion: number
        costo_persona_extra: number
        costo_reserva?: number | null
        duracion_renta: number
        personas_extra_max?: number | null
        pantalla_disponibilidad?: boolean | null
    }>
}

export type GetDisponibilidadTurnosAtencionQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    estado?: InputMaybe<Array<EstadosTurnosAtencion> | EstadosTurnosAtencion>
}>

export type GetDisponibilidadTurnosAtencionQuery = {
    __typename?: "Query"
    turnos_atencion: Array<{
        __typename?: "TurnoAtencion"
        tipo_habitacion_id: string
        folio: number
        folio_turno?: string | null
        estado: EstadosTurnosAtencion
        tipo_habitacion?: { __typename?: "TipoHabitacion"; nombre: string } | null
    }>
}

export type ListenCheckDisponibilidadHabitacionesSubscriptionVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type ListenCheckDisponibilidadHabitacionesSubscription = {
    __typename?: "Subscription"
    checkDisponibilidadHabitaciones?: {
        __typename?: "ListenDisponibilidadHabitacionesSubOutput"
        disponibilidad_habitaciones?: {
            __typename?: "TipoHabitacionSubDetail"
            accion: DisponibilidadPanelAction
        } | null
        lista_de_espera?: {
            __typename?: "TurnosAtencionSubModesOutput"
            turno_en_curso?: {
                __typename?: "TurnoAtencion"
                turno_atencion_id: string
                folio: number
                folio_turno?: string | null
            } | null
            lista?: Array<{
                __typename?: "TipoHabitacionPartialDetail"
                tipo_habitacion_id: string
                nombre: string
                turnos_atencion?: Array<{
                    __typename?: "TurnoAtencion"
                    folio: number
                    folio_turno?: string | null
                    estado: EstadosTurnosAtencion
                }> | null
            }> | null
        } | null
    } | null
}

export type GetEasyrewardsQueryVariables = Exact<{
    easyrewards_id: Scalars["String"]["input"]
}>

export type GetEasyrewardsQuery = {
    __typename?: "Query"
    obten_saldo: { __typename?: "ObtenSaldoOutput"; saldo?: number | null }
}

export type AbonarSaldoEasyrewardsMutationVariables = Exact<{
    easyrewards_id: Scalars["String"]["input"]
    folio_ticket: Scalars["String"]["input"]
    hotel_id: Scalars["ID"]["input"]
    monto_alimentos: Scalars["Float"]["input"]
    monto_bebidas: Scalars["Float"]["input"]
    monto_extras: Scalars["Float"]["input"]
    monto_habitacion: Scalars["Float"]["input"]
    monto_sexspa: Scalars["Float"]["input"]
    origen: Scalars["Float"]["input"]
}>

export type AbonarSaldoEasyrewardsMutation = {
    __typename?: "Mutation"
    acumula_puntos: { __typename?: "LovePointsResponse"; saldo?: number | null }
}

export type DescontarSaldoEasyrewardsMutationVariables = Exact<{
    easyrewards_id: Scalars["String"]["input"]
    folio_ticket: Scalars["String"]["input"]
    hotel_id: Scalars["ID"]["input"]
    puntos_descontar: Scalars["Float"]["input"]
}>

export type DescontarSaldoEasyrewardsMutation = {
    __typename?: "Mutation"
    descuenta_puntos: { __typename?: "LovePointsResponse"; saldo?: number | null }
}

export type Categorias_GastoQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    subcat_eliminados: Scalars["Boolean"]["input"]
}>

export type Categorias_GastoQuery = {
    __typename?: "Query"
    categorias_gasto: Array<{
        __typename?: "CategoriaGasto"
        categoria: string
        categoria_id: string
        eliminado: boolean
        fecha_registro: any
        hotel_id: string
        limite_mensual: number
        predeterminado?: boolean | null
        presupuesto: number
        usuario_id: string
        subcategorias_de_categoria: Array<{
            __typename?: "SubcategoriaGasto"
            categoria_id: string
            eliminado: boolean
            subcategoria: string
            subcategoria_gasto_id: string
        }>
    }>
}

export type GetGastoUnicoQueryVariables = Exact<{
    gastoId: Scalars["ID"]["input"]
}>

export type GetGastoUnicoQuery = {
    __typename?: "Query"
    gasto: {
        __typename?: "Gastos"
        categoria_id: string
        fecha_gasto: any
        fecha_registro: any
        hotel_id: string
        metodo_pago: string
        monto: number
        folio: number
        usuario_id: string
        categoria_gasto: {
            __typename?: "CategoriaGasto"
            categoria: string
            categoria_id: string
            subcategorias_gasto?: Array<{
                __typename?: "SubcategoriaGasto"
                subcategoria: string
                subcategoria_gasto_id: string
            }> | null
        }
    }
}

export type GetCategoriaGastosQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    predeterminado: Scalars["Boolean"]["input"]
    usuario_id: Scalars["ID"]["input"]
}>

export type GetCategoriaGastosQuery = {
    __typename?: "Query"
    categorias_gasto: Array<{
        __typename?: "CategoriaGasto"
        categoria: string
        categoria_id: string
        presupuesto: number
        limite_mensual: number
        subcategorias_de_categoria: Array<{
            __typename?: "SubcategoriaGasto"
            subcategoria: string
            subcategoria_gasto_id: string
        }>
    }>
}

export type GetSubCategoriasQueryVariables = Exact<{ [key: string]: never }>

export type GetSubCategoriasQuery = {
    __typename?: "Query"
    subcategorias_gasto: Array<{
        __typename?: "SubcategoriaGasto"
        subcategoria: string
        subcategoria_gasto_id: string
        categoria_gasto: { __typename?: "CategoriaGasto"; categoria: string; categoria_id: string }
    }>
}

export type CrearGastosMutationVariables = Exact<{
    datosGasto: CreateGastoInput
}>

export type CrearGastosMutation = {
    __typename?: "Mutation"
    crear_gasto: {
        __typename?: "CreateGastoResponse"
        ticket_id: string
        gasto: { __typename?: "Gastos"; fecha_gasto: any; gasto_id: string }
    }
}

export type CrearCategoriaGastoMutationVariables = Exact<{
    crearCategoriaGasto: CreateCategoriasGastosInput
}>

export type CrearCategoriaGastoMutation = {
    __typename?: "Mutation"
    crear_categoria_gasto: { __typename?: "CategoriaGasto"; categoria: string }
}

export type CreateSubCategoriMutationVariables = Exact<{
    subCat: CreateSubcategoriasGastosInput
}>

export type CreateSubCategoriMutation = {
    __typename?: "Mutation"
    crear_subcategoria_gasto: { __typename?: "SubcategoriaGasto"; subcategoria: string; subcategoria_gasto_id: string }
}

export type DeleteCategoriaGastosMutationVariables = Exact<{
    deleteGastoCatergoria: DeleteCategoriaGastosInput
}>

export type DeleteCategoriaGastosMutation = {
    __typename?: "Mutation"
    eliminar_categoria_gasto: { __typename?: "CategoriaGasto"; categoria: string; categoria_id: string }
}

export type DeleteSubCategoriaMutationVariables = Exact<{
    id: DeleteSubcategoriaGastoInput
}>

export type DeleteSubCategoriaMutation = {
    __typename?: "Mutation"
    eliminar_subcategoria_gasto: { __typename?: "SubcategoriaGasto"; subcategoria: string; categoria_id: string }
}

export type DeleteGastoMutationVariables = Exact<{
    idGasto: DeleteGastoInput
}>

export type DeleteGastoMutation = { __typename?: "Mutation"; borrar_gasto: { __typename?: "Gastos"; gasto_id: string } }

export type ActualizasGastoMutationVariables = Exact<{
    ActualizarGasto: UpdateGastoInput
}>

export type ActualizasGastoMutation = {
    __typename?: "Mutation"
    actualizar_gasto: { __typename?: "Gastos"; folio: number; gasto_id: string }
}

export type GetGastosDelMesQueryVariables = Exact<{
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    month: Scalars["String"]["input"]
    caja_chica?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type GetGastosDelMesQuery = {
    __typename?: "Query"
    gastos_por_mes?: {
        __typename?: "BillingPerMonthOutput"
        total_gasto?: number | null
        gastos?: Array<{
            __typename?: "Gastos"
            gasto_id: string
            metodo_pago: string
            usuario_id: string
            folio: number
            monto: number
            comentarios?: string | null
            categoria_id: string
            hotel_id: string
            subcategoria_id?: string | null
            fecha_gasto: any
            fecha_registro: any
            usuario: {
                __typename?: "Usuario"
                nombre: string
                apellido_materno?: string | null
                apellido_paterno?: string | null
            }
            categoria_gasto: {
                __typename?: "CategoriaGasto"
                categoria: string
                categoria_id: string
                subcategorias_gasto?: Array<{
                    __typename?: "SubcategoriaGasto"
                    subcategoria: string
                    subcategoria_gasto_id: string
                }> | null
            }
        }> | null
    } | null
}

export type GetGastosCategorasPorMesQueryVariables = Exact<{
    gastosCategoria: Scalars["String"]["input"]
    hotel_id: Scalars["ID"]["input"]
}>

export type GetGastosCategorasPorMesQuery = {
    __typename?: "Query"
    gastos_categoria_por_mes?: Array<{
        __typename?: "BillingPerMonthGroupedByCategoryOutput"
        porcentaje: number
        total_gasto: number
        categoria: {
            __typename?: "CategoriaGasto"
            categoria: string
            presupuesto: number
            subcategorias_de_categoria: Array<{
                __typename?: "SubcategoriaGasto"
                subcategoria: string
                subcategoria_gasto_id: string
            }>
        }
        subcategorias?: Array<{
            __typename?: "SubcategoriaGasto"
            monto: number
            subcategoria: string
            subcategoria_gasto_id: string
        }> | null
    }> | null
}

export type GetGastosCategorasPorMesCardsQueryVariables = Exact<{
    gastosCategoria: Scalars["String"]["input"]
    hotel_id: Scalars["ID"]["input"]
    mes_y_anio: Scalars["String"]["input"]
}>

export type GetGastosCategorasPorMesCardsQuery = {
    __typename?: "Query"
    gastos_categoria_por_mes?: Array<{
        __typename?: "BillingPerMonthGroupedByCategoryOutput"
        porcentaje: number
        total_gasto: number
        categoria: { __typename?: "CategoriaGasto"; categoria: string; presupuesto: number }
    }> | null
}

export type TotalesGastosSubcategoriaPorCategoriaCardsQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    mes_y_anio: Scalars["String"]["input"]
    categoria_id: Scalars["ID"]["input"]
    cantidad_categorias: Scalars["Int"]["input"]
}>

export type TotalesGastosSubcategoriaPorCategoriaCardsQuery = {
    __typename?: "Query"
    totales_gastos_subcategoria_por_categoria: {
        __typename?: "BillingPerMonthGroupedByCategoryOutput"
        total_gasto: number
        porcentaje: number
        categoria: { __typename?: "CategoriaGasto"; categoria_id: string; categoria: string }
        subcategorias?: Array<{
            __typename?: "SubcategoriaGasto"
            subcategoria_gasto_id: string
            subcategoria: string
            monto: number
            porcentaje?: number | null
        }> | null
    }
}

export type Total_Gastos_Por_Dia_RecepcionistaQueryVariables = Exact<{
    category_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id: Scalars["ID"]["input"]
}>

export type Total_Gastos_Por_Dia_RecepcionistaQuery = {
    __typename?: "Query"
    total_gastos_por_dia_recepcionista: { __typename?: "TotalBillingPerDayRecepcionstOutput"; total_gasto: number }
}

export type Categorias_Gasto_Con_EliminadasQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    mes_y_anio: Scalars["String"]["input"]
}>

export type Categorias_Gasto_Con_EliminadasQuery = {
    __typename?: "Query"
    categorias_gasto: Array<{
        __typename?: "CategoriaGasto"
        categoria: string
        categoria_id: string
        eliminado: boolean
        fecha_registro: any
        hotel_id: string
        limite_mensual: number
        predeterminado?: boolean | null
        presupuesto: number
        usuario_id: string
        subcategorias_de_categoria: Array<{
            __typename?: "SubcategoriaGasto"
            categoria_id: string
            eliminado: boolean
            subcategoria: string
            subcategoria_gasto_id: string
        }>
    }>
}

export type Categorias_Gasto_Sin_EliminadasQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type Categorias_Gasto_Sin_EliminadasQuery = {
    __typename?: "Query"
    categorias_gasto: Array<{
        __typename?: "CategoriaGasto"
        categoria: string
        categoria_id: string
        eliminado: boolean
        fecha_registro: any
        hotel_id: string
        limite_mensual: number
        predeterminado?: boolean | null
        presupuesto: number
        usuario_id: string
        subcategorias_de_categoria: Array<{
            __typename?: "SubcategoriaGasto"
            categoria_id: string
            eliminado: boolean
            subcategoria: string
            subcategoria_gasto_id: string
        }>
    }>
}

export type GetCategorasGastosPorMesQueryVariables = Exact<{
    gastosCategoria: Scalars["String"]["input"]
    hotel_id: Scalars["ID"]["input"]
    mes_y_anio: Scalars["String"]["input"]
}>

export type GetCategorasGastosPorMesQuery = {
    __typename?: "Query"
    gastos_categoria_por_mes?: Array<{
        __typename?: "BillingPerMonthGroupedByCategoryOutput"
        porcentaje: number
        total_gasto: number
        categoria: {
            __typename?: "CategoriaGasto"
            categoria: string
            presupuesto: number
            subcategorias_de_categoria: Array<{
                __typename?: "SubcategoriaGasto"
                subcategoria: string
                subcategoria_gasto_id: string
            }>
        }
        subcategorias?: Array<{
            __typename?: "SubcategoriaGasto"
            monto: number
            subcategoria: string
            subcategoria_gasto_id: string
        }> | null
    }> | null
}

export type Categorias_GastoFilterQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type Categorias_GastoFilterQuery = {
    __typename?: "Query"
    categorias_gasto: Array<{ __typename?: "CategoriaGasto"; categoria: string; categoria_id: string }>
}

export type GetGastosListQueryVariables = Exact<{
    categoria_id?: InputMaybe<Scalars["ID"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    subcategoria_id?: InputMaybe<Scalars["ID"]["input"]>
    search_text?: InputMaybe<Scalars["String"]["input"]>
    caja_chica?: InputMaybe<Scalars["Boolean"]["input"]>
    rol_name?: InputMaybe<Scalars["String"]["input"]>
    fecha_gasto?: InputMaybe<DateSearchInput>
    pagination_options: PageOptionsArgs
}>

export type GetGastosListQuery = {
    __typename?: "Query"
    gastos: {
        __typename?: "SearchGastosOutputDto"
        paginacion: { __typename?: "DatosPaginationOutput"; total_paginas: number; pagina_actual: number }
        gastos: Array<{
            __typename?: "Gastos"
            caja_chica: boolean
            gasto_id: string
            metodo_pago: string
            usuario_id: string
            eliminado: boolean
            folio: number
            monto: number
            comentarios?: string | null
            corte_id?: string | null
            subcategoria_id?: string | null
            categoria_id: string
            fecha_gasto: any
            fecha_registro: any
            usuario: {
                __typename?: "Usuario"
                apellido_materno?: string | null
                apellido_paterno?: string | null
                nombre: string
                usuario_id: string
                roles?: Array<{
                    __typename?: "Rol"
                    eliminado: boolean
                    grupo_hotel_id: string
                    nombre: string
                    rol_id: string
                }> | null
            }
            categoria_gasto: { __typename?: "CategoriaGasto"; categoria: string; categoria_id: string }
            subcategoria_gasto?: { __typename?: "SubcategoriaGasto"; subcategoria: string } | null
        }>
    }
}

export type HabitacionesConfigQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type HabitacionesConfigQuery = {
    __typename?: "Query"
    habitaciones: Array<{
        __typename?: "Habitacion"
        habitacion_id: string
        numero_habitacion: string
        tipo_habitacion_id: string
        tipo_habitacion?: { __typename?: "TipoHabitacion"; nombre: string } | null
    }>
}

export type UpdatePosicionHabitacionMutationVariables = Exact<{
    updatePosicionHabitacionInput: UpdatePosicionHabitacionInput
}>

export type UpdatePosicionHabitacionMutation = {
    __typename?: "Mutation"
    actualizar_posicion_habitacion: {
        __typename?: "Habitacion"
        habitacion_id: string
        posicion?: { __typename?: "Posicion"; x: number; y: number; tamano: Tamano } | null
    }
}

export type ActualizarHotelMinimalMutationVariables = Exact<{
    datos_hotel: UpdateHotelInput
}>

export type ActualizarHotelMinimalMutation = {
    __typename?: "Mutation"
    actualizar_hotel: {
        __typename?: "Hotel"
        hotel_id: string
        nombre_hotel: string
        configurations?: {
            __typename?: "Configurations"
            cardHabitacion: { __typename?: "CardHabitacion"; tamano_fijo?: boolean | null; tamano?: string | null }
        } | null
    }
}

export type CrearColaboradorTareaMutationVariables = Exact<{
    datos_colaborador_tarea: CreateColaboradorTareaInput
}>

export type CrearColaboradorTareaMutation = {
    __typename?: "Mutation"
    crear_colaborador_tarea: Array<{
        __typename?: "ColaboradorTarea"
        colaborador_id?: string | null
        colaborador_tarea_id: string
        fecha_inicio: any
        fecha_termino?: any | null
        tarea_id?: string | null
        tipo_limpieza?: TiposLimpiezas | null
        colaborador?: {
            __typename?: "Colaborador"
            apellido_materno: string
            apellido_paterno: string
            nombre: string
        } | null
    }>
}

export type Actualizar_Colaboradores_TareasMutationVariables = Exact<{
    datos_tarea: CloseTaskInput
}>

export type Actualizar_Colaboradores_TareasMutation = {
    __typename?: "Mutation"
    actualizar_colaboradores_tareas: Array<{
        __typename?: "ColaboradorTarea"
        colaborador_id?: string | null
        colaborador_tarea_id: string
        fecha_inicio: any
        fecha_termino?: any | null
        tarea_id?: string | null
        tipo_limpieza?: TiposLimpiezas | null
        colaborador?: {
            __typename?: "Colaborador"
            apellido_materno: string
            apellido_paterno: string
            nombre: string
        } | null
        comentarios?: Array<{ __typename?: "ComentarioTarea"; comentario?: string | null }> | null
    }>
}

export type CancelarReservaMutationVariables = Exact<{
    cancelar_reserva_input: CancelReservaInput
    codigo: Scalars["String"]["input"]
    template_sample: Scalars["String"]["input"]
}>

export type CancelarReservaMutation = {
    __typename?: "Mutation"
    cancelar_reserva: { __typename?: "CancelReservaResponse"; ticket_ids: Array<string> }
}

export type AgregarComentarioHabitacionMutationVariables = Exact<{
    input: AddComentarioHabitacionInput
}>

export type AgregarComentarioHabitacionMutation = {
    __typename?: "Mutation"
    agregar_comentario_habitacion: {
        __typename?: "Habitacion"
        habitacion_id: string
        comentarios?: Array<{
            __typename?: "ComentarioHabitacion"
            comentario_id: string
            usuario_id: string
            comentario: string
            fecha: string
        }> | null
    }
}

export type ActualizarComentarioHabitacionMutationVariables = Exact<{
    input: UpdateComentarioHabitacionInput
}>

export type ActualizarComentarioHabitacionMutation = {
    __typename?: "Mutation"
    actualizar_comentario_habitacion: {
        __typename?: "Habitacion"
        habitacion_id: string
        comentarios?: Array<{
            __typename?: "ComentarioHabitacion"
            comentario_id: string
            usuario_id: string
            comentario: string
            fecha: string
        }> | null
    }
}

export type EliminarComentarioHabitacionMutationVariables = Exact<{
    input: DeleteComentarioHabitacionInput
}>

export type EliminarComentarioHabitacionMutation = {
    __typename?: "Mutation"
    eliminar_comentario_habitacion: {
        __typename?: "Habitacion"
        habitacion_id: string
        comentarios?: Array<{
            __typename?: "ComentarioHabitacion"
            comentario_id: string
            usuario_id: string
            comentario: string
            fecha: string
        }> | null
    }
}

export type AgregarNochesExtraMutationVariables = Exact<{
    datos_extra: AddHospedajesExtrasRentaInput
}>

export type AgregarNochesExtraMutation = {
    __typename?: "Mutation"
    agregar_hospedajes_renta: {
        __typename?: "AuxPartialInfoRentaResponse"
        extra_id?: string | null
        ticket_id?: string | null
    }
}

export type Agregar_Horas_RentaMutationVariables = Exact<{
    addHorasExtrasRentaInput: AddHorasExtrasRentaInput
}>

export type Agregar_Horas_RentaMutation = {
    __typename?: "Mutation"
    agregar_horas_renta: {
        __typename?: "AuxPartialInfoRentaResponse"
        extra_id?: string | null
        ticket_id?: string | null
    }
}

export type AgregarPersonasExtraMutationVariables = Exact<{
    datos_renta: AddPersonasExtrasRentaInput
}>

export type AgregarPersonasExtraMutation = {
    __typename?: "Mutation"
    agregar_personas_renta: {
        __typename?: "AuxPartialInfoRentaResponse"
        extra_id?: string | null
        ticket_id?: string | null
    }
}

export type CambiarRentaDeHabitacionMutationVariables = Exact<{
    datos_renta: UpdateHabitacionInRentaInput
}>

export type CambiarRentaDeHabitacionMutation = {
    __typename?: "Mutation"
    actualizar_habitacion_en_renta: { __typename?: "Renta"; habitacion_id: string }
}

export type CancelarRentaHabitacionMutationVariables = Exact<{
    datos_cancelar: CancelOperationsRentaInput
}>

export type CancelarRentaHabitacionMutation = {
    __typename?: "Mutation"
    cancelar_operaciones_renta: {
        __typename?: "CancelOperationsRentaOutput"
        ticket_id: Array<string>
        renta: { __typename?: "Renta"; cliente_id?: string | null }
        extras_cancelled: Array<{ __typename?: "Extra"; extra_id: string; ticket_id?: string | null }>
    }
}

export type CheckoutMutationVariables = Exact<{
    checkOutInput: CheckOutInput
}>

export type CheckoutMutation = {
    __typename?: "Mutation"
    CheckOut: { __typename?: "PartialInfoCheckoutResponseOutput"; ticket_id?: Array<string> | null }
}

export type GetColaboradoresQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    en_turno?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type GetColaboradoresQuery = {
    __typename?: "Query"
    colaboradores: Array<{
        __typename?: "Colaborador"
        apellido_materno: string
        apellido_paterno: string
        nombre: string
        colaborador_id: string
        en_turno: boolean
        usuario_id?: string | null
        colaborador_in_hotel?: Array<{
            __typename?: "HotelColaborador"
            puesto?: { __typename?: "Puesto"; puesto_id: string; nombre: string } | null
        }> | null
        ultima_tarea?: {
            __typename?: "ColaboradorTarea"
            fecha_inicio: any
            fecha_termino?: any | null
            colaborador_tarea_id: string
            habitacion_id?: string | null
            habitacion?: {
                __typename?: "Habitacion"
                numero_habitacion: string
                tipo_habitacion_id: string
                tipo_habitacion?: { __typename?: "TipoHabitacion"; nombre: string } | null
            } | null
        } | null
        puesto?: {
            __typename?: "Puesto"
            puesto_id: string
            nombre: string
            area?: { __typename?: "Area"; area_id: string; nombre: string } | null
        } | null
        area?: { __typename?: "Area"; area_id: string; nombre: string } | null
    }>
}

export type GetColaboradoresForValidationQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    en_turno?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type GetColaboradoresForValidationQuery = {
    __typename?: "Query"
    colaboradores: Array<{
        __typename?: "Colaborador"
        colaborador_id: string
        en_turno: boolean
        puesto?: {
            __typename?: "Puesto"
            puesto_id: string
            nombre: string
            area?: { __typename?: "Area"; area_id: string; nombre: string } | null
        } | null
    }>
}

export type GetColaboradoresByAreasQueryVariables = Exact<{
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    area_id?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>
}>

export type GetColaboradoresByAreasQuery = {
    __typename?: "Query"
    colaboradores_by_area: {
        __typename?: "FindAllPaginatedOutput"
        colaboradores: Array<{
            __typename?: "Colaborador"
            colaborador_id: string
            nombre: string
            apellido_materno: string
            apellido_paterno: string
            foto?: string | null
        }>
    }
}

export type CurrentDateQueryVariables = Exact<{ [key: string]: never }>

export type CurrentDateQuery = { __typename?: "Query"; serverDate: any }

export type GetExperienciasQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    experiencia_id?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>
}>

export type GetExperienciasQuery = {
    __typename?: "Query"
    experiencias: Array<{
        __typename?: "Experiencia"
        experiencia_id: string
        nombre: string
        precio: number
        descripcion?: string | null
        estado: EstadosExperiencias
        hotel_id: string
        fecha_registro: any
    }>
}

export type TiposBloqueoQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type TiposBloqueoQuery = {
    __typename?: "Query"
    tipos_bloqueo: Array<{
        __typename?: "TipoBloqueo"
        tipo_bloqueo_id: string
        nombre: string
        claves?: Array<{ __typename?: "ClaveTipoBloqueo"; tamano: string; clave: string }> | null
    }>
}

export type GetReservasDelDiaSinAsignarQueryVariables = Exact<{
    hotel_id: Scalars["String"]["input"]
    fecha_entrada: Scalars["DateTime"]["input"]
}>

export type GetReservasDelDiaSinAsignarQuery = {
    __typename?: "Query"
    reservas_sin_asignar_del_dia: Array<{
        __typename?: "Reserva"
        codigo_ota: string
        folio: number
        habitacion_id?: string | null
        nombre_huesped: string
        tipo_habitacion_id: string
        reserva_id: string
        estado: EstadosReservas
        fecha_entrada: any
    }>
}

export type GetHabitacionQueryVariables = Exact<{
    habitacion_id: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}>

export type GetHabitacionQuery = {
    __typename?: "Query"
    habitacion: {
        __typename?: "Habitacion"
        comentario_estado?: string | null
        eliminado: boolean
        estado: Estados_Habitaciones
        incidencias_activas?: number | null
        incidencias_activas_usuario: number
        fecha_estado?: any | null
        habitacion_id: string
        hotel_id: string
        numero_habitacion: string
        rentas_today?: number | null
        reservas_today?: number | null
        piso: string
        usuario_id: string
        tipo_habitacion_id: string
        tipo_habitacion?: {
            __typename?: "TipoHabitacion"
            clave: string
            descripcion: string
            eliminado: boolean
            hotel_id: string
            minutos_entrada: number
            minutos_limpieza_detallada: number
            minutos_limpieza_normal: number
            minutos_limpieza_retoque: number
            nombre: string
            minutos_supervision: number
            personas_incluidas: number
            tipo_habitacion_id: string
            camas: Array<{ __typename?: "Cama"; numero: number; tipo: TiposCamas }>
        } | null
        ultima_reserva?: {
            __typename?: "UltimaReserva"
            reserva?: {
                __typename?: "Reserva"
                reserva_id: string
                folio: number
                estado: EstadosReservas
                fecha_cancelacion?: any | null
                fecha_salida: any
                fecha_entrada: any
                origen: OrigenRservas
                tipo_habitacion_id: string
                habitacion_id?: string | null
                tarifa_id: string
                correo_huesped?: string | null
                nombre_huesped: string
                telefono_huesped: string
                numero_personas: number
                personas_extras: number
                estado_pago: EstadoPago
                total: number
                easyrewards_id?: string | null
                tipo_de_habitacion: { __typename?: "TipoHabitacion"; nombre: string }
                habitacion: {
                    __typename?: "Habitacion"
                    numero_habitacion: string
                    habitacion_id: string
                    tipo_habitacion?: { __typename?: "TipoHabitacion"; nombre: string } | null
                }
                tarifa?: {
                    __typename?: "Tarifa"
                    nombre: string
                    personas_extra_max?: number | null
                    costo_persona_extra: number
                    tipo_alojamiento: TiposAlojamientos
                    tarifa_id: string
                } | null
                usuario: { __typename?: "Usuario"; nombre: string }
                pagos?: Array<{
                    __typename?: "Pago"
                    pago_id: string
                    total: number
                    detalles_pago?: Array<{
                        __typename?: "DetallePago"
                        detalle_pago_id: string
                        subtotal: number
                        tipo_pago: TiposPagos
                        ultimos_digitos?: string | null
                        numero_referencia?: string | null
                        easyrewards_id?: string | null
                    }> | null
                    extras?: Array<{
                        __typename?: "Extra"
                        monto_devuelto_cancelacion?: number | null
                        fecha_cancelacion?: any | null
                        fecha_pago?: any | null
                        fecha_solicitud: any
                        monto_extra: number
                        motivo_cancelacion?: string | null
                        numero: number
                        tipo_extra: TiposExtras
                    }> | null
                }> | null
                experiencias_reserva: Array<{
                    __typename?: "ExperienciaReserva"
                    experiencia_reserva_id: string
                    experiencia_id: string
                    total: number
                    estado: EstadosExperienciasReservas
                    experiencia?: { __typename?: "Experiencia"; nombre: string } | null
                }>
                comentarios: Array<{ __typename?: "ComentariosInfoReserva"; comentario: string }>
            } | null
        } | null
        ultima_renta?: {
            __typename?: "Renta"
            horas_extra?: number | null
            ticket_id?: string | null
            fecha_fin: any
            estado: EstadosRentas
            fecha_condensada: any
            nombre_huesped?: string | null
            hospedajes_extra: number
            fecha_registro: any
            fecha_salida?: any | null
            total: number
            renta_id: string
            folio: number
            numero_personas: number
            personas_extra: number
            cliente_id?: string | null
            reserva_id?: string | null
            tipo_entrada: TiposEntradas
            easyrewards_id?: string | null
            tarifa_id: string
            tipo_alojamiento: TiposAlojamientos
            vehiculo?: { __typename?: "Data_Vehiculo"; matricula: string } | null
            comentarios: Array<{ __typename?: "ComentariosInfoRenta"; comentario: string; fecha: any }>
            reserva?: {
                __typename?: "Reserva"
                nombre_huesped: string
                origen: OrigenRservas
                correo_huesped?: string | null
                telefono_huesped: string
                easyrewards_id?: string | null
                pagos?: Array<{
                    __typename?: "Pago"
                    pago_id: string
                    detalles_pago?: Array<{
                        __typename?: "DetallePago"
                        subtotal: number
                        numero_referencia?: string | null
                        easyrewards_id?: string | null
                    }> | null
                }> | null
            } | null
            extras?: Array<{
                __typename?: "Extra"
                tipo_extra: TiposExtras
                monto_extra: number
                numero: number
                extra_id: string
                fecha_pago?: any | null
            }> | null
            pagos?: Array<{
                __typename?: "Pago"
                fecha_pago: any
                pago_id: string
                total: number
                extras?: Array<{
                    __typename?: "Extra"
                    tipo_extra: TiposExtras
                    monto_extra: number
                    numero: number
                    extra_id: string
                }> | null
                detalles_pago?: Array<{
                    __typename?: "DetallePago"
                    subtotal: number
                    ultimos_digitos?: string | null
                    tipo_pago: TiposPagos
                    numero_referencia?: string | null
                    easyrewards_id?: string | null
                }> | null
            }> | null
            tarifa?: {
                __typename?: "Tarifa"
                nombre: string
                costo_persona_extra: number
                costo_hora_extra: number
                costo_hospedaje_extra: number
                personas_extra_max?: number | null
                duracion_renta: number
                horas_extra_max?: number | null
                costo_habitacion: number
                hospedajes_extra_max?: number | null
                costo_early_checkin: number
            } | null
            propinas?: Array<{
                __typename?: "Propina"
                total: number
                detalles_pago: Array<{
                    __typename?: "DetallesPagoPartialInfoOutput"
                    tipo_pago: TiposPagos
                    ultimos_digitos?: string | null
                    subtotal: number
                    numero_referencia?: string | null
                }>
            }> | null
            ordenes?: Array<{
                __typename?: "Orden"
                orden: string
                orden_id: string
                fecha_registro: any
                total_con_iva: number
                total_sin_iva: number
                estado_orden?: EstadosOrdenHistorial | null
                pago_id?: string | null
                easyrewards_id?: string | null
                propina?: { __typename?: "Propina"; propina_id: string; total: number } | null
                pago?: {
                    __typename?: "Pago"
                    ticket_id?: string | null
                    pago_id: string
                    detalles_pago?: Array<{
                        __typename?: "DetallePago"
                        ultimos_digitos?: string | null
                        tipo_pago: TiposPagos
                        subtotal: number
                        numero_referencia?: string | null
                        easyrewards_id?: string | null
                    }> | null
                } | null
                detalles_orden?: Array<{
                    __typename?: "DetalleOrden"
                    detalle_orden_id: string
                    estado: EstadosDetalleOrden
                    almacen_articulo_id: string
                    cantidad: number
                    costo_con_iva: number
                    comentarios?: string | null
                    almacen_articulo?: {
                        __typename?: "AlmacenArticulo"
                        articulo_id: string
                        almacen_id: string
                        precio: number
                        categoria_id?: string | null
                        categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                        articulo?: {
                            __typename?: "Articulo"
                            nombre: string
                            contenido: number
                            descripcion?: string | null
                            unidad: UnidadMedidasArticulo
                            articulo_id: string
                            categoria_id?: string | null
                            tipo: TipoArticulo
                            extra: boolean
                            categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                        } | null
                    } | null
                    extras?: Array<{
                        __typename?: "ExtraDetalleOrden"
                        extra_detalle_orden_id: string
                        detalle_orden_id: string
                        almacen_articulo_id: string
                        costo_con_iva: number
                        cantidad: number
                        almacen_articulo?: {
                            __typename?: "AlmacenArticulo"
                            almacen_articulo_id: string
                            articulo_id: string
                            precio: number
                            articulo?: {
                                __typename?: "Articulo"
                                nombre: string
                                contenido: number
                                descripcion?: string | null
                                unidad: UnidadMedidasArticulo
                                articulo_id: string
                                categoria_id?: string | null
                                tipo: TipoArticulo
                                extra: boolean
                                categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                            } | null
                        } | null
                    }> | null
                }> | null
            }> | null
            subtotales: {
                __typename?: "DataSubtotales"
                total_early_checkin: number
                total_habitacion: number
                total_horas_extra: number
                total_hospedajes_extra: number
                total_personas_extra: number
            }
        } | null
        ultimas_rentas?: Array<{ __typename?: "Renta"; cliente_id?: string | null; horas_extra?: number | null }> | null
        colaborador_tareas_sin_finalizar?: Array<{
            __typename?: "ColaboradorTarea"
            tarea_id?: string | null
            colaborador_tarea_id: string
            descripcion_tarea?: string | null
            fecha_inicio: any
            fecha_termino?: any | null
            tipo_limpieza?: TiposLimpiezas | null
            colaborador_id?: string | null
            colaborador?: {
                __typename?: "Colaborador"
                foto?: string | null
                nombre: string
                apellido_materno: string
                apellido_paterno: string
                colaborador_in_hotel?: Array<{
                    __typename?: "HotelColaborador"
                    puesto?: { __typename?: "Puesto"; descripcion: string; nombre: string; puesto_id: string } | null
                }> | null
            } | null
        }> | null
        ultimos_datos?: {
            __typename?: "DatosHabitacion"
            ultima_limpieza?: Array<{
                __typename?: "ColaboradorTarea"
                colaborador_id?: string | null
                fecha_termino?: any | null
                tipo_limpieza?: TiposLimpiezas | null
                fecha_inicio: any
                colaborador_tarea_id: string
                colaborador?: {
                    __typename?: "Colaborador"
                    apellido_materno: string
                    apellido_paterno: string
                    nombre: string
                    foto?: string | null
                } | null
                comentarios?: Array<{
                    __typename?: "ComentarioTarea"
                    comentario?: string | null
                    fecha?: string | null
                }> | null
            }> | null
            ultimo_mantenimiento?: {
                __typename?: "ColaboradorTarea"
                colaborador_id?: string | null
                fecha_termino?: any | null
                colaborador?: {
                    __typename?: "Colaborador"
                    apellido_materno: string
                    apellido_paterno: string
                    nombre: string
                    foto?: string | null
                } | null
            } | null
            ultima_supervision?: {
                __typename?: "ColaboradorTarea"
                colaborador_id?: string | null
                colaborador?: {
                    __typename?: "Colaborador"
                    apellido_materno: string
                    apellido_paterno: string
                    nombre: string
                    foto?: string | null
                } | null
            } | null
        } | null
        tarea_en_curso?: {
            __typename?: "ColaboradorTarea"
            tarea_id?: string | null
            fecha_inicio: any
            colaborador_tarea_id: string
            tipo_tarea?: TiposTarea | null
            reportada_por?: {
                __typename?: "Colaborador"
                nombre: string
                apellido_paterno: string
                apellido_materno: string
            } | null
        } | null
    }
}

export type TiposMantenimientoQueryVariables = Exact<{
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
}>

export type TiposMantenimientoQuery = {
    __typename?: "Query"
    tipos_mantenimiento: Array<{
        __typename?: "TipoMantenimiento"
        nombre: string
        tipo_mantenimiento_id: string
        claves?: Array<{ __typename?: "ClaveTipoMantenimiento"; clave: string; tamano: string }> | null
    }>
}

export type ListenHabitacionesSubscriptionVariables = Exact<{
    hotelIdFilter: Scalars["ID"]["input"]
    usuario_id: Scalars["ID"]["input"]
}>

export type ListenHabitacionesSubscription = {
    __typename?: "Subscription"
    checkHabitaciones: Array<{
        __typename?: "Habitacion"
        numero_habitacion: string
        estado: Estados_Habitaciones
        comentario_estado?: string | null
        incidencias_activas?: number | null
        incidencias_activas_usuario: number
        fecha_estado?: any | null
        habitacion_id: string
        hotel_id: string
        tipo_habitacion_id: string
        alerta_incidencia?: { __typename?: "Incidencia"; incidencia_id: string; severidad: string } | null
        posicion?: { __typename?: "Posicion"; tamano: Tamano; x: number; y: number } | null
        incidencias?: Array<{ __typename?: "Incidencia"; severidad: string }> | null
        tipo_habitacion?: {
            __typename?: "TipoHabitacion"
            minutos_limpieza_detallada: number
            minutos_limpieza_normal: number
            minutos_limpieza_retoque: number
            minutos_pendiente_supervision: number
            minutos_sucia: number
            minutos_supervision: number
            nombre: string
        } | null
        ultima_reserva?: {
            __typename?: "UltimaReserva"
            reserva?: {
                __typename?: "Reserva"
                nombre_huesped: string
                fecha_entrada: any
                fecha_salida: any
                numero_personas: number
                reserva_id: string
                tarifa_id: string
                comentarios: Array<{ __typename?: "ComentariosInfoReserva"; comentario: string }>
                tarifa?: { __typename?: "Tarifa"; hora_checkin: string; hora_checkout: string } | null
                experiencias_reserva: Array<{
                    __typename?: "ExperienciaReserva"
                    experiencia_reserva_id: string
                    experiencia_id: string
                    total: number
                    estado: EstadosExperienciasReservas
                    experiencia?: { __typename?: "Experiencia"; nombre: string } | null
                }>
            } | null
        } | null
        ultima_renta?: {
            __typename?: "Renta"
            fecha_antigua_por_entregar?: any | null
            fecha_registro: any
            fecha_fin: any
            horas_extra?: number | null
            estado: EstadosRentas
            nombre_huesped?: string | null
            numero_personas: number
            hospedajes_extra: number
            cliente_id?: string | null
            fecha_condensada: any
            renta_id: string
            folio: number
            reserva_id?: string | null
            tipo_entrada: TiposEntradas
            tarifa_id: string
            easyrewards_id?: string | null
            ultimos_conceptos_pendientes?: {
                __typename?: "UltimosConceptosPendientesDetailOutput"
                renta_id?: string | null
                extra_id?: string | null
                orden_id?: string | null
                renta?: { __typename?: "Renta"; fecha_registro: any } | null
                extra?: { __typename?: "Extra"; tipo_extra: TiposExtras; fecha_solicitud: any } | null
                orden?: {
                    __typename?: "Orden"
                    orden: string
                    deposito?: boolean | null
                    estado_pago: EstadoPagoOrdenes
                    fecha_registro: any
                } | null
            } | null
            ultima_orden?: {
                __typename?: "GetLastOrdenOutput"
                orden_activa: boolean
                orden?: {
                    __typename?: "Orden"
                    fecha_registro: any
                    estado_pago: EstadoPagoOrdenes
                    estado_orden?: EstadosOrdenHistorial | null
                } | null
            } | null
            vehiculo?: {
                __typename?: "Data_Vehiculo"
                matricula: string
                color: string
                marca: string
                modelo: string
            } | null
            tarifa?: { __typename?: "Tarifa"; duracion_renta: number } | null
            pagos?: Array<{
                __typename?: "Pago"
                pago_id: string
                detalles_pago?: Array<{ __typename?: "DetallePago"; easyrewards_id?: string | null }> | null
            }> | null
            subtotales: {
                __typename?: "DataSubtotales"
                total_early_checkin: number
                total_habitacion: number
                total_hospedajes_extra: number
                total_horas_extra: number
                total_personas_extra: number
            }
        } | null
        colaborador_tareas_sin_finalizar?: Array<{
            __typename?: "ColaboradorTarea"
            tarea_id?: string | null
            descripcion_tarea?: string | null
            fecha_inicio: any
            fecha_termino?: any | null
            tipo_limpieza?: TiposLimpiezas | null
            colaborador_tarea_id: string
            colaborador_id?: string | null
            colaborador?: {
                __typename?: "Colaborador"
                foto?: string | null
                nombre: string
                apellido_materno: string
                apellido_paterno: string
            } | null
        }> | null
    }>
}

export type GetModalTurnosAtencionQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    tipo_habitacion_id?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>
}>

export type GetModalTurnosAtencionQuery = {
    __typename?: "Query"
    turnos_atencion: Array<{
        __typename?: "TurnoAtencion"
        tipo_habitacion_id: string
        folio: number
        folio_turno?: string | null
        turno_atencion_id: string
    }>
}

export type GetHabitacionTurnosAtencionQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    turno_atencion_id?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>
}>

export type GetHabitacionTurnosAtencionQuery = {
    __typename?: "Query"
    turnos_atencion: Array<{
        __typename?: "TurnoAtencion"
        tipo_habitacion_id: string
        folio: number
        folio_turno?: string | null
        nombre_o_matricula?: string | null
        estado: EstadosTurnosAtencion
    }>
}

export type Transacciones_RentaQueryVariables = Exact<{
    renta_id: Scalars["ID"]["input"]
}>

export type Transacciones_RentaQuery = {
    __typename?: "Query"
    transacciones_renta?: {
        __typename?: "GetRentaTransactionsOutput"
        renta?: {
            __typename?: "Renta"
            estado: EstadosRentas
            folio: number
            early_checkin?: boolean | null
            es_renta_cancelable: boolean
            renta_id: string
            corte_id?: string | null
            ticket_id?: string | null
            tipo_alojamiento: TiposAlojamientos
            total: number
            montos_cancelacion?: {
                __typename?: "GetCancelableAmountsRentaOutput"
                total: number
                parcial: number
            } | null
            habitacion?: {
                __typename?: "Habitacion"
                tipo_habitacion?: { __typename?: "TipoHabitacion"; nombre: string } | null
            } | null
            tarifa?: { __typename?: "Tarifa"; nombre: string } | null
        } | null
        transacciones_checkin: Array<{
            __typename?: "RentaTransactionItemOutput"
            extras?: Array<{
                __typename?: "Extra"
                extra_id: string
                corte_id?: string | null
                tipo_extra: TiposExtras
                numero: number
                monto_extra: number
            }> | null
            ticket?: { __typename?: "Ticket"; ticket_id: string; folio: number; fecha_impresion: any } | null
        }>
        transacciones?: Array<{
            __typename?: "RentaTransactionItemOutput"
            ticket?: { __typename?: "Ticket"; ticket_id: string; folio: number; fecha_impresion: any } | null
            extras?: Array<{
                __typename?: "Extra"
                extra_id: string
                corte_id?: string | null
                tipo_extra: TiposExtras
                numero: number
                monto_extra: number
                total_con_propina: number
            }> | null
        }> | null
        ordenes?: Array<{
            __typename?: "RentaOrdenTransactionItemOutput"
            ticket_id?: string | null
            orden_id: string
            orden?: {
                __typename?: "Orden"
                orden: string
                orden_id: string
                corte_id?: string | null
                total_con_iva: number
                fecha_registro: any
                detalles_orden?: Array<{
                    __typename?: "DetalleOrden"
                    detalle_orden_id: string
                    cantidad: number
                    almacen_articulo_id: string
                    almacen_articulo?: {
                        __typename?: "AlmacenArticulo"
                        almacen_articulo_id: string
                        articulo_id: string
                        articulo?: {
                            __typename?: "Articulo"
                            articulo_id: string
                            nombre: string
                            categoria_id?: string | null
                            categoria_articulo?: {
                                __typename?: "CategoriaArticulo"
                                categoria_id: string
                                nombre: string
                            } | null
                        } | null
                    } | null
                    extras?: Array<{
                        __typename?: "ExtraDetalleOrden"
                        extra_detalle_orden_id: string
                        cantidad: number
                        almacen_articulo_id: string
                        almacen_articulo?: {
                            __typename?: "AlmacenArticulo"
                            almacen_articulo_id: string
                            articulo_id: string
                            articulo?: {
                                __typename?: "Articulo"
                                articulo_id: string
                                nombre: string
                                categoria_id?: string | null
                                categoria_articulo?: {
                                    __typename?: "CategoriaArticulo"
                                    categoria_id: string
                                    nombre: string
                                } | null
                            } | null
                        } | null
                    }> | null
                }> | null
            } | null
            ticket?: { __typename?: "Ticket"; ticket_id: string; folio: number } | null
        }> | null
    } | null
}

export type Cambiar_Tipo_LimpiezaMutationVariables = Exact<{
    updateTipoLimpiezaInput: UpdateTipoLimpiezaInput
}>

export type Cambiar_Tipo_LimpiezaMutation = {
    __typename?: "Mutation"
    actualizar_tipo_limpieza: Array<{
        __typename?: "ColaboradorTarea"
        tarea_id?: string | null
        fecha_registro?: any | null
    }>
}

export type GetComentariosColaboradorQueryVariables = Exact<{
    colaborador_tarea_id: Scalars["ID"]["input"]
}>

export type GetComentariosColaboradorQuery = {
    __typename?: "Query"
    colaborador_tarea: {
        __typename?: "ColaboradorTarea"
        colaborador_tarea_id: string
        comentarios?: Array<{
            __typename?: "ComentarioTarea"
            comentario?: string | null
            fecha?: string | null
        }> | null
    }
}

export type AgregarComentarioATareaMutationVariables = Exact<{
    comentarios: AddCommentToTaskInput
}>

export type AgregarComentarioATareaMutation = {
    __typename?: "Mutation"
    agregar_comentarios_a_tarea: {
        __typename?: "ColaboradorTarea"
        comentarios?: Array<{
            __typename?: "ComentarioTarea"
            comentario?: string | null
            fecha?: string | null
        }> | null
    }
}

export type EditarDatosVehiculoMutationVariables = Exact<{
    editVehiculoInput: EditVehiculoDataInput
}>

export type EditarDatosVehiculoMutation = {
    __typename?: "Mutation"
    editar_datos_vehiculo: {
        __typename?: "VehiculoDataEditDetailOutput"
        matricula?: string | null
        color?: string | null
        marca?: string | null
        modelo?: string | null
    }
}

export type GetReservacionByIdQueryVariables = Exact<{
    id: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]
}>

export type GetReservacionByIdQuery = {
    __typename?: "Query"
    reservas: Array<{
        __typename?: "Reserva"
        reserva_id: string
        codigo_ota: string
        corte_id?: string | null
        folio: number
        estado: EstadosReservas
        fecha_cancelacion?: any | null
        fecha_salida: any
        fecha_entrada: any
        origen: OrigenRservas
        personas_extras: number
        tipo_habitacion_id: string
        habitacion_id?: string | null
        hospedajes_extra: number
        tarifa_id: string
        correo_huesped?: string | null
        nombre_huesped: string
        telefono_huesped: string
        numero_personas: number
        estado_pago: EstadoPago
        total: number
        easyrewards_id?: string | null
        comentarios: Array<{ __typename?: "ComentariosInfoReserva"; comentario: string }>
        tipo_de_habitacion: { __typename?: "TipoHabitacion"; nombre: string }
        habitacion: {
            __typename?: "Habitacion"
            numero_habitacion: string
            habitacion_id: string
            tipo_habitacion?: { __typename?: "TipoHabitacion"; nombre: string } | null
        }
        tarifa?: {
            __typename?: "Tarifa"
            nombre: string
            personas_extra_max?: number | null
            costo_persona_extra: number
            tipo_alojamiento: TiposAlojamientos
            costo_habitacion: number
            tarifa_id: string
        } | null
        usuario: { __typename?: "Usuario"; nombre: string }
        pagos?: Array<{
            __typename?: "Pago"
            pago_id: string
            total: number
            fecha_pago: any
            detalles_pago?: Array<{
                __typename?: "DetallePago"
                detalle_pago_id: string
                subtotal: number
                tipo_pago: TiposPagos
                ultimos_digitos?: string | null
                numero_referencia?: string | null
                easyrewards_id?: string | null
            }> | null
            extras?: Array<{
                __typename?: "Extra"
                monto_devuelto_cancelacion?: number | null
                fecha_cancelacion?: any | null
                fecha_pago?: any | null
                fecha_solicitud: any
                monto_extra: number
                motivo_cancelacion?: string | null
                numero: number
                tipo_extra: TiposExtras
            }> | null
        }> | null
        experiencias_reserva: Array<{
            __typename?: "ExperienciaReserva"
            experiencia_reserva_id: string
            experiencia_id: string
            total: number
            estado: EstadosExperienciasReservas
            experiencia?: { __typename?: "Experiencia"; nombre: string } | null
        }>
    }>
}

export type RemoverReservaHabitacionMutationVariables = Exact<{
    input: RemoveBookingFromRoomInput
}>

export type RemoverReservaHabitacionMutation = { __typename?: "Mutation"; remover_reserva_de_habitacion: string }

export type GetIncidenciasQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    fecha_operacion?: InputMaybe<DateSearchInput>
    search?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetIncidenciasQuery = {
    __typename?: "Query"
    incidencias: Array<{
        __typename?: "Incidencia"
        incidencia_id: string
        detalle: string
        habitacion_id?: string | null
        folio: number
        fecha_registro: any
        fecha_cierre?: any | null
        colaborador_id_reporta: string
        estado?: Estados_Incidencias | null
        huesped?: string | null
        matricula?: string | null
        tipo_incidencia?: string | null
        colaborador_id_cierra?: string | null
        area?: string | null
        severidad: string
        turno_id: string
        colaborador_reporta: {
            __typename?: "Colaborador"
            nombre: string
            apellido_paterno: string
            apellido_materno: string
            puesto?: { __typename?: "Puesto"; nombre: string } | null
        }
        colaborador_cierra?: {
            __typename?: "Colaborador"
            nombre: string
            apellido_paterno: string
            apellido_materno: string
        } | null
        turno: { __typename?: "Turno"; nombre: string }
        habitacion?: {
            __typename?: "Habitacion"
            habitacion_id: string
            numero_habitacion: string
            tipo_habitacion_id: string
            tipo_habitacion?: { __typename?: "TipoHabitacion"; tipo_habitacion_id: string; nombre: string } | null
        } | null
    }>
}

export type GetIncidenciaByIdQueryVariables = Exact<{
    incidencia_id: Scalars["ID"]["input"]
}>

export type GetIncidenciaByIdQuery = {
    __typename?: "Query"
    incidencias: Array<{
        __typename?: "Incidencia"
        incidencia_id: string
        detalle: string
        habitacion_id?: string | null
        folio: number
        fecha_registro: any
        fecha_cierre?: any | null
        colaborador_id_reporta: string
        estado?: Estados_Incidencias | null
        huesped?: string | null
        matricula?: string | null
        tipo_incidencia?: string | null
        colaborador_id_cierra?: string | null
        area?: string | null
        severidad: string
        turno_id: string
        comentario_cierre?: string | null
        vehiculo?: { __typename?: "Data_Vehiculo"; color: string; marca: string; modelo: string } | null
        colaborador_reporta: {
            __typename?: "Colaborador"
            nombre: string
            apellido_paterno: string
            apellido_materno: string
        }
        colaborador_cierra?: {
            __typename?: "Colaborador"
            nombre: string
            apellido_paterno: string
            apellido_materno: string
        } | null
        turno: { __typename?: "Turno"; nombre: string }
        habitacion?: {
            __typename?: "Habitacion"
            habitacion_id: string
            numero_habitacion: string
            tipo_habitacion_id: string
            tipo_habitacion?: { __typename?: "TipoHabitacion"; tipo_habitacion_id: string; nombre: string } | null
        } | null
        imagenes?: Array<{ __typename?: "ImageIncidenciaEntity"; id?: string | null; imagen?: string | null }> | null
    }>
}

export type ReabrirIncidenciaMutationVariables = Exact<{
    datos_incidencia: OpenIncidenciaInput
}>

export type ReabrirIncidenciaMutation = {
    __typename?: "Mutation"
    reabrir_incidencia: { __typename?: "Incidencia"; incidencia_id: string }
}

export type GetIncidenciaByFiltersQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    matricula?: InputMaybe<Scalars["String"]["input"]>
    huesped?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetIncidenciaByFiltersQuery = {
    __typename?: "Query"
    incidencias: Array<{
        __typename?: "Incidencia"
        incidencia_id: string
        folio: number
        huesped?: string | null
        matricula?: string | null
    }>
}

export type TableArticulosQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    almacen_id?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>
    filter_tipo_articulo?: InputMaybe<Array<TipoArticulo> | TipoArticulo>
    pagination_options: PageOptionsArgs
    nombreArticuloFilterOrder?: InputMaybe<TipoOrdenamiento>
    filterEstadoArticulo?: InputMaybe<EstadosArticulo>
    filterEstadoAlmacenArticulo?: InputMaybe<Array<EstadosAlmacenesArticulos> | EstadosAlmacenesArticulos>
}>

export type TableArticulosQuery = {
    __typename?: "Query"
    almacenes_articulos: {
        __typename?: "SearchAlmacenesArticulosOutput"
        paginacion: { __typename?: "DatosPaginationOutput"; pagina_actual: number; total_paginas: number }
        almacenes_articulos: Array<{
            __typename?: "AlmacenArticulo"
            almacen_articulo_id: string
            almacen_id: string
            articulo_id: string
            cantidad: number
            costo: number
            eliminado: boolean
            estado: EstadosAlmacenesArticulos
            fecha_movimiento: any
            hotel_id?: string | null
            precio: number
            articulo?: {
                __typename?: "Articulo"
                articulo_id: string
                cantidad_minima?: number | null
                cantidad_vendida: number
                categoria_id?: string | null
                contenido: number
                descripcion?: string | null
                eliminado: boolean
                estado: EstadosArticulo
                extra: boolean
                fecha_eliminado?: any | null
                fecha_registro: any
                folio?: string | null
                folio_articulo?: string | null
                foto?: string | null
                marca?: string | null
                nombre: string
                sku?: string | null
                stock?: number | null
                tipo: TipoArticulo
                unidad: UnidadMedidasArticulo
            } | null
            almacen?: { __typename?: "Almacen"; almacen_id: string; nombre: string } | null
            ultimo_surtido?: {
                __typename?: "Surtido"
                almacen_articulo_id: string
                cantidad: number
                colaborador_id: string
                comentario?: string | null
                costo_total: number
                costo_unitario: number
                fecha_ingreso: any
                folio: number
                hotel_id: string
                numero_orden_factura?: string | null
                surtido_id: string
                tipo: TiposSurtido
            } | null
        }>
    }
}

export type CrearConfiguracionInventarioMutationVariables = Exact<{
    create_configuracion_inventario: CreateConfiguracionInventarioInput
}>

export type CrearConfiguracionInventarioMutation = {
    __typename?: "Mutation"
    crear_configuracion_inventario: {
        __typename?: "ConfiguracionInventario"
        configuracion_inventario_id: string
        hotel_id: string
        inventario_negativo: boolean
    }
}

export type ActualizarConfiguracionInventarioInputMutationVariables = Exact<{
    update_configuracion_inventario: UpdateConfiguracionInventarioInput
}>

export type ActualizarConfiguracionInventarioInputMutation = {
    __typename?: "Mutation"
    actualizar_configuracion_inventario: {
        __typename?: "ConfiguracionInventario"
        configuracion_inventario_id: string
        hotel_id: string
        inventario_negativo: boolean
    }
}

export type CrearCategoriaArticuloMutationVariables = Exact<{
    datos_categoria: CreateCategoriaArticuloInput
}>

export type CrearCategoriaArticuloMutation = {
    __typename?: "Mutation"
    crear_categoria_articulo: {
        __typename?: "CategoriaArticulo"
        hotel_id: string
        nombre: string
        descripcion: string
    }
}

export type ActualizarCategoriaArticuloMutationVariables = Exact<{
    datos_categoria: UpdateCategoriaArticuloInput
}>

export type ActualizarCategoriaArticuloMutation = {
    __typename?: "Mutation"
    actualizar_categoria_articulo: {
        __typename?: "CategoriaArticulo"
        categoria_id: string
        hotel_id: string
        nombre: string
        descripcion: string
    }
}

export type EliminarCategoriaArticuloMutationVariables = Exact<{
    datos_categoria: DeleteCategoriaArticuloInput
}>

export type EliminarCategoriaArticuloMutation = {
    __typename?: "Mutation"
    eliminar_categoria_articulo: { __typename?: "CategoriaArticulo"; categoria_id: string }
}

export type CrearAlmacenMutationVariables = Exact<{
    createAlmacenInput: CreateAlmacenInput
}>

export type CrearAlmacenMutation = {
    __typename?: "Mutation"
    crear_almacen: {
        __typename?: "Almacen"
        almacen_id: string
        descripcion: string
        hotel_id: string
        nombre: string
        tipo_almacen: TipoAlmacen
        usuario_modifico_id: string
    }
}

export type ActualizarAlmacenMutationVariables = Exact<{
    updateAlmacenInput: UpdateAlmacenInput
}>

export type ActualizarAlmacenMutation = {
    __typename?: "Mutation"
    actualizar_almacen: Array<{
        __typename?: "Almacen"
        almacen_id: string
        descripcion: string
        hotel_id: string
        nombre: string
        tipo_almacen: TipoAlmacen
        usuario_modifico_id: string
    }>
}

export type EliminarAlmacenMutationVariables = Exact<{
    deleteAlmacenInput: DeleteAlmacenInput
}>

export type EliminarAlmacenMutation = { __typename?: "Mutation"; eliminar_almacen: string }

export type ConfiguracionInventarioQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type ConfiguracionInventarioQuery = {
    __typename?: "Query"
    configuraciones_inventario: Array<{
        __typename?: "ConfiguracionInventario"
        configuracion_inventario_id: string
        inventario_negativo: boolean
        configuraciones: { __typename?: "Configuraciones"; cardRSNegativo: boolean }
    }>
}

export type AlmacenesQueryVariables = Exact<{
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
    tipos_articulos: Array<TipoArticulo> | TipoArticulo
}>

export type AlmacenesQuery = {
    __typename?: "Query"
    almacenes: Array<{
        __typename?: "Almacen"
        almacen_id: string
        nombre: string
        descripcion: string
        stock?: number | null
        tipo_almacen: TipoAlmacen
        general: boolean
        categorias_almacenes: Array<{
            __typename?: "CategoriaArticulo"
            categoria_id: string
            nombre: string
            total_articulos?: number | null
        }>
    }>
}

export type Almacenes_ArticulosQueryVariables = Exact<{
    pagination_options: PageOptionsArgs
}>

export type Almacenes_ArticulosQuery = {
    __typename?: "Query"
    almacenes_articulos: {
        __typename?: "SearchAlmacenesArticulosOutput"
        paginacion: {
            __typename?: "DatosPaginationOutput"
            pagina_actual: number
            total_paginas: number
            total_registros: number
        }
        almacenes_articulos: Array<{
            __typename?: "AlmacenArticulo"
            almacen_articulo_id: string
            almacen_id: string
            articulo_id: string
            cantidad: number
            costo: number
            fecha_movimiento: any
            hotel_id?: string | null
            precio: number
            estado: EstadosAlmacenesArticulos
        }>
    }
}

export type GetAlmacenArticuloMedidasQueryVariables = Exact<{
    almacen_articulo_id: Scalars["ID"]["input"]
}>

export type GetAlmacenArticuloMedidasQuery = {
    __typename?: "Query"
    almacen_articulo: {
        __typename?: "AlmacenArticulo"
        articulo?: { __typename?: "Articulo"; unidades_disponibles?: Array<UnidadMedidasArticulo> | null } | null
    }
}

export type CrearArticuloMutationVariables = Exact<{
    createArticuloInput: CreateArticuloInput
}>

export type CrearArticuloMutation = {
    __typename?: "Mutation"
    crear_articulo: { __typename?: "Articulo"; articulo_id: string }
}

export type GetAlmacenArticuloByArrayIdQueryVariables = Exact<{
    articulo_id?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>
    pagination_options: PageOptionsArgs
}>

export type GetAlmacenArticuloByArrayIdQuery = {
    __typename?: "Query"
    almacenes_articulos: {
        __typename?: "SearchAlmacenesArticulosOutput"
        paginacion: {
            __typename?: "DatosPaginationOutput"
            pagina_actual: number
            total_paginas: number
            total_registros: number
        }
        almacenes_articulos: Array<{
            __typename?: "AlmacenArticulo"
            almacen_articulo_id: string
            almacen_id: string
            articulo_id: string
            costo: number
            precio: number
            articulo?: {
                __typename?: "Articulo"
                articulo_id: string
                categoria_id?: string | null
                foto?: string | null
                marca?: string | null
                nombre: string
                unidad: UnidadMedidasArticulo
                contenido: number
                cantidad_minima?: number | null
                stock?: number | null
                estado: EstadosArticulo
                tipo: TipoArticulo
                extra: boolean
                sku?: string | null
            } | null
        }>
    }
}

export type GetAlmacenArticuloForEditQueryVariables = Exact<{
    almacen_articulo_id: Scalars["ID"]["input"]
}>

export type GetAlmacenArticuloForEditQuery = {
    __typename?: "Query"
    almacen_articulo: {
        __typename?: "AlmacenArticulo"
        almacen_articulo_id: string
        almacen_id: string
        articulo_id: string
        costo: number
        precio: number
        articulo?: {
            __typename?: "Articulo"
            articulo_id: string
            categoria_id?: string | null
            foto?: string | null
            marca?: string | null
            nombre: string
            unidad: UnidadMedidasArticulo
            contenido: number
            cantidad_minima?: number | null
            stock?: number | null
            estado: EstadosArticulo
            tipo: TipoArticulo
            extra: boolean
            sku?: string | null
        } | null
    }
}

export type ActualizarArticuloMutationVariables = Exact<{
    updateArticuloInput: UpdateArticuloInput
}>

export type ActualizarArticuloMutation = {
    __typename?: "Mutation"
    actualizar_articulo: { __typename?: "Articulo"; articulo_id: string }
}

export type GetAlmacenesForDropQueryVariables = Exact<{
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
}>

export type GetAlmacenesForDropQuery = {
    __typename?: "Query"
    almacenes: Array<{
        __typename?: "Almacen"
        almacen_id: string
        nombre: string
        tipo_almacen: TipoAlmacen
        categorias_almacenes: Array<{ __typename?: "CategoriaArticulo"; categoria_id: string; nombre: string }>
    }>
}

export type CrearRecetaProcesoMutationVariables = Exact<{
    createRecetaInput: CreateRecetaInput
}>

export type CrearRecetaProcesoMutation = {
    __typename?: "Mutation"
    crear_receta: { __typename?: "Receta"; articulo_id: string }
}

export type CategoriasArticulosNuevaRecetaProcesoQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type CategoriasArticulosNuevaRecetaProcesoQuery = {
    __typename?: "Query"
    categorias_articulos: Array<{ __typename?: "CategoriaArticulo"; categoria_id: string; nombre: string }>
}

export type ArticulosNuevaRecetaProcesoQueryVariables = Exact<{
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    pagination_options: PageOptionsArgs
    nameFilter: Scalars["String"]["input"]
}>

export type ArticulosNuevaRecetaProcesoQuery = {
    __typename?: "Query"
    almacenes_articulos: {
        __typename?: "SearchAlmacenesArticulosOutput"
        paginacion: { __typename?: "DatosPaginationOutput"; pagina_actual: number; total_paginas: number }
        almacenes_articulos: Array<{
            __typename?: "AlmacenArticulo"
            almacen_articulo_id: string
            articulo_id: string
            almacen_id: string
            cantidad: number
            costo: number
            almacen?: { __typename?: "Almacen"; nombre: string } | null
            articulo?: {
                __typename?: "Articulo"
                nombre: string
                tipo: TipoArticulo
                foto?: string | null
                contenido: number
                unidad: UnidadMedidasArticulo
                unidades_disponibles?: Array<UnidadMedidasArticulo> | null
            } | null
        }>
    }
}

export type ActualizarRecetaProcesoMutationVariables = Exact<{
    updateRecetaInput: UpdateRecetaInput
}>

export type ActualizarRecetaProcesoMutation = {
    __typename?: "Mutation"
    actualizar_receta: { __typename?: "Receta"; articulo_id: string }
}

export type GetRecetaForDetailQueryVariables = Exact<{
    articulo_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
}>

export type GetRecetaForDetailQuery = {
    __typename?: "Query"
    receta: {
        __typename?: "Receta"
        articulo_id: string
        almacen_articulo?: { __typename?: "AlmacenArticulo"; costo: number; precio: number } | null
        articulo?: {
            __typename?: "Articulo"
            nombre: string
            extra: boolean
            estado: EstadosArticulo
            foto?: string | null
            unidad: UnidadMedidasArticulo
            contenido: number
        } | null
        ingredientes_recetas?: Array<{
            __typename?: "IngredienteReceta"
            almacen_articulo_id: string
            cantidad: number
            ingrediente_receta_id: string
            receta_id: string
            unidad: UnidadMedidasArticulo
            disponible_inventario: number
            costo_por_cantidad_ingrediente?: number | null
            cantidad_equivalente: number
            articulo?: {
                __typename?: "Articulo"
                nombre: string
                unidad: UnidadMedidasArticulo
                contenido: number
            } | null
            almacen_articulo?: {
                __typename?: "AlmacenArticulo"
                almacen_articulo_id: string
                costo: number
                cantidad: number
                estado: EstadosAlmacenesArticulos
            } | null
        }> | null
    }
}

export type GetRecetaToEditQueryVariables = Exact<{
    articulo_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
}>

export type GetRecetaToEditQuery = {
    __typename?: "Query"
    receta: {
        __typename?: "Receta"
        articulo_id: string
        almacen_articulo?: {
            __typename?: "AlmacenArticulo"
            categoria_id?: string | null
            precio: number
            categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
        } | null
        articulo?: {
            __typename?: "Articulo"
            nombre: string
            extra: boolean
            estado: EstadosArticulo
            foto?: string | null
            unidad: UnidadMedidasArticulo
            contenido: number
            categoria_id?: string | null
            categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
        } | null
        ingredientes_recetas?: Array<{
            __typename?: "IngredienteReceta"
            almacen_articulo_id: string
            cantidad: number
            unidad: UnidadMedidasArticulo
            ingrediente_receta_id: string
            receta_id: string
            almacen_articulo?: { __typename?: "AlmacenArticulo"; costo: number } | null
            articulo?: { __typename?: "Articulo"; unidad: UnidadMedidasArticulo; nombre: string } | null
        }> | null
    }
}

export type GetRecetasProcesosQueryVariables = Exact<{
    filter_tipo_articulo: Array<TipoArticulo> | TipoArticulo
    pagination_options: PageOptionsArgs
    filterEstadoArticulo?: InputMaybe<EstadosArticulo>
    categoria_articulo_ids?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    nombreArticuloFilterOrder?: InputMaybe<TipoOrdenamiento>
}>

export type GetRecetasProcesosQuery = {
    __typename?: "Query"
    almacenes_articulos: {
        __typename?: "SearchAlmacenesArticulosOutput"
        paginacion: {
            __typename?: "DatosPaginationOutput"
            pagina_actual: number
            total_paginas: number
            total_registros: number
        }
        almacenes_articulos: Array<{
            __typename?: "AlmacenArticulo"
            almacen_id: string
            almacen_articulo_id: string
            articulo_id: string
            estado: EstadosAlmacenesArticulos
            ultima_preparacion?: any | null
            cantidad: number
            precio: number
            costo: number
            articulo?: {
                __typename?: "Articulo"
                nombre: string
                foto?: string | null
                categoria_id?: string | null
                contenido: number
                stock?: number | null
                folio?: string | null
                tipo: TipoArticulo
                unidad: UnidadMedidasArticulo
                estado: EstadosArticulo
                extra: boolean
                categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
            } | null
        }>
    }
}

export type UnidadesConversionArticulosQueryVariables = Exact<{ [key: string]: never }>

export type UnidadesConversionArticulosQuery = {
    __typename?: "Query"
    unidades_conversion_articulos: Array<{
        __typename?: "UnidadConversionArticulo"
        unidad_origen: string
        unidad_destino: string
        factor_conversion: number
    }>
}

export type AgregacionesAlmacenesArticulosQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type AgregacionesAlmacenesArticulosQuery = {
    __typename?: "Query"
    agregaciones_almacenes_articulos?: {
        __typename?: "GetAggregationsAlmacenesArticulosOutput"
        total_procesos: number
        total_recetas_alimentos: number
        total_recetas_bebidas: number
        total_recetas_procesos: number
    } | null
}

export type SearchRecipesProcessQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    nameFilter: Scalars["String"]["input"]
    pagination_options: PageOptionsArgs
}>

export type SearchRecipesProcessQuery = {
    __typename?: "Query"
    almacenes_articulos: {
        __typename?: "SearchAlmacenesArticulosOutput"
        paginacion: {
            __typename?: "DatosPaginationOutput"
            pagina_actual: number
            total_paginas: number
            total_registros: number
        }
        almacenes_articulos: Array<{
            __typename?: "AlmacenArticulo"
            almacen_id: string
            almacen_articulo_id: string
            articulo_id: string
            ultima_preparacion?: any | null
            cantidad: number
            precio: number
            costo: number
            articulo?: {
                __typename?: "Articulo"
                nombre: string
                foto?: string | null
                categoria_id?: string | null
                contenido: number
                stock?: number | null
                descripcion?: string | null
                folio?: string | null
                tipo: TipoArticulo
                unidad: UnidadMedidasArticulo
                estado: EstadosArticulo
                extra: boolean
                categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
            } | null
        }>
    }
}

export type CrearProduccionProcesoMutationVariables = Exact<{
    createProductionProceso: CreateProductionProcesoInput
}>

export type CrearProduccionProcesoMutation = {
    __typename?: "Mutation"
    crear_produccion_proceso: { __typename?: "CreateProductionProcesoOutput"; cantidad_produccion_final: number }
}

export type GetArticuloForProductionQueryVariables = Exact<{
    almacen_articulo_id: Scalars["ID"]["input"]
}>

export type GetArticuloForProductionQuery = {
    __typename?: "Query"
    almacen_articulo: {
        __typename?: "AlmacenArticulo"
        almacen_articulo_id: string
        almacen_id: string
        articulo_id: string
        costo: number
        articulo?: {
            __typename?: "Articulo"
            articulo_id: string
            nombre: string
            unidad: UnidadMedidasArticulo
            contenido: number
        } | null
    }
}

export type HistorialProduccionInventarioQueryVariables = Exact<{
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    articulo_id?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>
    fecha_produccion?: InputMaybe<MonthSearchInput>
}>

export type HistorialProduccionInventarioQuery = {
    __typename?: "Query"
    historial_producciones_inventarios?: Array<{
        __typename?: "HistorialProduccionInventario"
        historial_produccion_inventario_id: string
        articulo_id: string
        folio: number
        fecha_produccion: any
        cantidad_producida: number
        unidad: UnidadMedidasProduccion
        costo_produccion: number
        costo_unidad_minima_produccion: number
        colaborador_id: string
        responsable?: {
            __typename?: "Colaborador"
            apellido_materno: string
            apellido_paterno: string
            nombre: string
            usuario_id?: string | null
        } | null
    }> | null
}

export type KpisHistorialProduccionQueryVariables = Exact<{
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    articulo_id: Scalars["ID"]["input"]
}>

export type KpisHistorialProduccionQuery = {
    __typename?: "Query"
    kpis_historial_producciones_inventarios?: {
        __typename?: "GetKpisHistorialProduccionesInventarioByArticuloIdOutput"
        articulo_id: string
        costo_total_inventario: string
        costo_unitario_promedio: string
        fecha_ultima_produccion?: any | null
        produccion_receta: string
        unidades_inventario: string
        unidad: UnidadMedidasArticulo
    } | null
}

export type GetSurtidosByAlmacenArtIdQueryVariables = Exact<{
    almacen_articulo_id?: InputMaybe<Scalars["ID"]["input"]>
    fecha_ingreso?: InputMaybe<DateSearchInput>
}>

export type GetSurtidosByAlmacenArtIdQuery = {
    __typename?: "Query"
    surtidos: Array<{
        __typename?: "Surtido"
        surtido_id: string
        almacen_articulo_id: string
        cantidad: number
        colaborador_id: string
        costo_total: number
        costo_unitario: number
        fecha_ingreso: any
        folio: number
        numero_orden_factura?: string | null
        tipo: TiposSurtido
        colaborador: { __typename?: "Colaborador"; nombre: string; apellido_paterno: string; apellido_materno: string }
    }>
}

export type GetAlmacenArticuloForSurtidoQueryVariables = Exact<{
    almacen_articulo_id: Scalars["ID"]["input"]
}>

export type GetAlmacenArticuloForSurtidoQuery = {
    __typename?: "Query"
    almacen_articulo: {
        __typename?: "AlmacenArticulo"
        almacen_articulo_id: string
        almacen_id: string
        articulo_id: string
        costo: number
        precio: number
        cantidad: number
        almacen?: { __typename?: "Almacen"; almacen_id: string; nombre: string } | null
        articulo?: {
            __typename?: "Articulo"
            articulo_id: string
            marca?: string | null
            nombre: string
            cantidad_minima?: number | null
            stock?: number | null
        } | null
        ultimo_surtido?: { __typename?: "Surtido"; fecha_ingreso: any } | null
    }
}

export type CrearSurtidosMutationVariables = Exact<{
    createManySurtidosInput: CreateManySurtidosInput
}>

export type CrearSurtidosMutation = {
    __typename?: "Mutation"
    crear_surtidos: {
        __typename?: "CreateManySurtidosOutput"
        numero_articulos_surtidos: number
        surtidos: Array<{ __typename?: "Surtido"; surtido_id: string }>
    }
}

export type GetAlmacenArticulosMosaicQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    pagination_options: PageOptionsArgs
    almacen_id?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>
    filterEstadoArticulo?: InputMaybe<EstadosArticulo>
    filterEstadoAlmacenArticulo?: InputMaybe<Array<EstadosAlmacenesArticulos> | EstadosAlmacenesArticulos>
}>

export type GetAlmacenArticulosMosaicQuery = {
    __typename?: "Query"
    almacenes_articulos: {
        __typename?: "SearchAlmacenesArticulosOutput"
        paginacion: {
            __typename?: "DatosPaginationOutput"
            pagina_actual: number
            total_paginas: number
            total_registros: number
        }
        almacenes_articulos: Array<{
            __typename?: "AlmacenArticulo"
            estado: EstadosAlmacenesArticulos
            almacen_articulo_id: string
            articulo_id: string
            precio: number
            cantidad: number
            almacen_id: string
            articulo?: {
                __typename?: "Articulo"
                articulo_id: string
                categoria_id?: string | null
                cantidad_minima?: number | null
                nombre: string
                foto?: string | null
                marca?: string | null
                folio?: string | null
                eliminado: boolean
                estado: EstadosArticulo
                tipo: TipoArticulo
                unidad: UnidadMedidasArticulo
                contenido: number
            } | null
        }>
    }
}

export type GetArticuloByIdQueryVariables = Exact<{
    articulo_id: Scalars["ID"]["input"]
}>

export type GetArticuloByIdQuery = {
    __typename?: "Query"
    almacenes_articulos: {
        __typename?: "SearchAlmacenesArticulosOutput"
        almacenes_articulos: Array<{
            __typename?: "AlmacenArticulo"
            almacen_articulo_id: string
            almacen_id: string
            costo: number
            precio: number
            articulo_id: string
            articulo?: {
                __typename?: "Articulo"
                articulo_id: string
                categoria_id?: string | null
                foto?: string | null
                marca?: string | null
                nombre: string
                unidad: UnidadMedidasArticulo
                contenido: number
                cantidad_minima?: number | null
                stock?: number | null
                estado: EstadosArticulo
                tipo: TipoArticulo
                extra: boolean
                sku?: string | null
                fecha_registro: any
                fecha_eliminado?: any | null
                folio?: string | null
            } | null
        }>
    }
}

export type GetAlmacenArticuloByArticuloIdQueryVariables = Exact<{
    articulo_id: Scalars["ID"]["input"]
}>

export type GetAlmacenArticuloByArticuloIdQuery = {
    __typename?: "Query"
    almacenes_articulos: {
        __typename?: "SearchAlmacenesArticulosOutput"
        almacenes_articulos: Array<{
            __typename?: "AlmacenArticulo"
            almacen_articulo_id: string
            almacen_id: string
            articulo_id: string
            costo: number
            precio: number
            eliminado: boolean
            estado: EstadosAlmacenesArticulos
            almacen?: { __typename?: "Almacen"; almacen_id: string; nombre: string } | null
            articulo?: {
                __typename?: "Articulo"
                articulo_id: string
                categoria_id?: string | null
                foto?: string | null
                marca?: string | null
                nombre: string
                unidad: UnidadMedidasArticulo
                contenido: number
                cantidad_minima?: number | null
                stock?: number | null
                estado: EstadosArticulo
                tipo: TipoArticulo
                extra: boolean
                sku?: string | null
                fecha_registro: any
                fecha_eliminado?: any | null
                folio?: string | null
                descripcion?: string | null
            } | null
        }>
    }
}

export type GetAlmacenArticuloByIdQueryVariables = Exact<{
    almacen_articulo_id: Scalars["ID"]["input"]
}>

export type GetAlmacenArticuloByIdQuery = {
    __typename?: "Query"
    almacen_articulo: {
        __typename?: "AlmacenArticulo"
        precio: number
        estado: EstadosAlmacenesArticulos
        es_parte_receta: boolean
        almacen_id: string
        almacen_articulo_id: string
        articulo_id: string
        fecha_movimiento: any
        cantidad: number
        ultima_preparacion?: any | null
        costo: number
        almacen?: { __typename?: "Almacen"; nombre: string } | null
        articulo?: {
            __typename?: "Articulo"
            articulo_id: string
            categoria_id?: string | null
            descripcion?: string | null
            cantidad_minima?: number | null
            nombre: string
            foto?: string | null
            marca?: string | null
            eliminado: boolean
            estado: EstadosArticulo
            fecha_eliminado?: any | null
            fecha_registro: any
            folio?: string | null
            tipo: TipoArticulo
            unidad: UnidadMedidasArticulo
            unidades_disponibles?: Array<UnidadMedidasArticulo> | null
            contenido: number
            stock?: number | null
            sku?: string | null
            categoria_articulo?: { __typename?: "CategoriaArticulo"; categoria_id: string; nombre: string } | null
        } | null
        ultimo_surtido?: { __typename?: "Surtido"; fecha_ingreso: any } | null
    }
}

export type ActualizarProductoMutationVariables = Exact<{
    articulo_input: UpdateArticuloInput
}>

export type ActualizarProductoMutation = {
    __typename?: "Mutation"
    actualizar_articulo: { __typename?: "Articulo"; articulo_id: string }
}

export type EliminarArticuloMutationVariables = Exact<{
    almacen_articulo_input: DeleteAlmacenesArticulosInput
}>

export type EliminarArticuloMutation = { __typename?: "Mutation"; eliminar_almacen_articulo: string }

export type EliminarRecetaMutationVariables = Exact<{
    deleteRecetaInput: DeleteRecetaInput
}>

export type EliminarRecetaMutation = { __typename?: "Mutation"; eliminar_receta: string }

export type Categorias_ArticulosQueryVariables = Exact<{
    categoria_id: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]
}>

export type Categorias_ArticulosQuery = {
    __typename?: "Query"
    categorias_articulos: Array<{
        __typename?: "CategoriaArticulo"
        categoria_id: string
        hotel_id: string
        nombre: string
        total_articulos?: number | null
    }>
}

export type Historial_Movimientos_InventarioQueryVariables = Exact<{
    fecha_registro?: InputMaybe<MonthSearchInput>
    hotel_id: Scalars["ID"]["input"]
    pagination_options: PageOptionsArgs
    nombre_articulo?: InputMaybe<Scalars["String"]["input"]>
    tipo_articulo?: InputMaybe<TipoArticulo>
    movimiento?: InputMaybe<MovimientoHistorialInventario>
    tipo?: InputMaybe<TipoMovimientoHistorialInventario>
}>

export type Historial_Movimientos_InventarioQuery = {
    __typename?: "Query"
    historial_movimientos_inventario: {
        __typename?: "FindAllHistorialMovimientosInventarioOutput"
        paginacion: { __typename?: "DatosPaginationOutput"; pagina_actual: number; total_paginas: number }
        historial_movimientos_inventario: Array<{
            __typename?: "HistorialMovimientosInventario"
            historial_movimiento_inventario_id: string
            articulo_id: string
            cantidad: number
            costo_actual: number
            fecha_registro: any
            folio: number
            hotel_id: string
            movimiento: MovimientoHistorialInventario
            nombre_articulo: string
            precio: number
            salida_id?: string | null
            surtido_id?: string | null
            tipo: TipoMovimientoHistorialInventario
            almacen_articulo_id?: string | null
            origen_destino?: string | null
            articulo?: {
                __typename?: "Articulo"
                unidad: UnidadMedidasArticulo
                folio?: string | null
                tipo: TipoArticulo
            } | null
            responsable?: {
                __typename?: "Colaborador"
                nombre: string
                apellido_paterno: string
                apellido_materno: string
            } | null
        }>
    }
}

export type SurtidoQueryVariables = Exact<{
    surtido_id: Scalars["ID"]["input"]
}>

export type SurtidoQuery = {
    __typename?: "Query"
    surtido: {
        __typename?: "Surtido"
        cantidad: number
        colaborador_id: string
        costo_total: number
        costo_unitario: number
        fecha_ingreso: any
        hotel_id: string
        surtido_id: string
        almacen: { __typename?: "Almacen"; almacen_id: string }
        articulo: { __typename?: "Articulo"; articulo_id: string }
    }
}

export type ColaboradorQueryVariables = Exact<{
    colaborador_id: Scalars["ID"]["input"]
}>

export type ColaboradorQuery = {
    __typename?: "Query"
    colaborador: { __typename?: "Colaborador"; apellido_materno: string; apellido_paterno: string; nombre: string }
}

export type Salida_InventarioQueryVariables = Exact<{
    salida_id: Scalars["ID"]["input"]
}>

export type Salida_InventarioQuery = {
    __typename?: "Query"
    salida_inventario: {
        __typename?: "Salida"
        almacen_articulo_id: string
        cantidad: number
        colaborador_id: string
        comentario?: string | null
        fecha_salida: any
        hotel_id: string
        motivo: Motivo
        salida_id: string
        articulo?: { __typename?: "Articulo"; articulo_id: string } | null
    }
}

export type Informe_InventarioQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    almacen_id?: InputMaybe<Scalars["ID"]["input"]>
}>

export type Informe_InventarioQuery = {
    __typename?: "Query"
    informe_inventario?: {
        __typename?: "GetInformeInventarioOutput"
        cantidad_articulos: number
        costo_total_inventario: number
        articulos_agotados: number
        articulos_por_agotarse: number
        valor_comercial: number
    } | null
}

export type Informe_Historial_Movimientos_InventarioQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    fecha_registro?: InputMaybe<DateSearchInput>
}>

export type Informe_Historial_Movimientos_InventarioQuery = {
    __typename?: "Query"
    informe_historial_movimientos_inventario: {
        __typename?: "GetInformeHistorialMovimientosInventarioOutput"
        salidas_venta: { __typename?: "MovimientoInformeDetailOutput"; total: number; unidades: number }
        salidas_insumos: { __typename?: "MovimientoInformeDetailOutput"; total: number; unidades: number }
        merma: { __typename?: "MovimientoInformeDetailOutput"; total: number; unidades: number }
        entradas_productos: { __typename?: "MovimientoInformeDetailOutput"; total: number; unidades: number }
        entradas_insumos: { __typename?: "MovimientoInformeDetailOutput"; total: number; unidades: number }
    }
}

export type SurtirArticuloMutationVariables = Exact<{
    crear_surtido_input: CreateSurtidoInput
}>

export type SurtirArticuloMutation = {
    __typename?: "Mutation"
    crear_surtido: {
        __typename?: "Surtido"
        almacen_articulo?: {
            __typename?: "AlmacenArticulo"
            cantidad: number
            estado: EstadosAlmacenesArticulos
        } | null
        articulo: { __typename?: "Articulo"; estado: EstadosArticulo }
    }
}

export type Crear_SalidaMutationVariables = Exact<{
    salidaInventarioInput: CreateSalidaInput
}>

export type Crear_SalidaMutation = {
    __typename?: "Mutation"
    crear_salida_inventario: {
        __typename?: "Salida"
        almacen_articulo?: {
            __typename?: "AlmacenArticulo"
            cantidad: number
            estado: EstadosAlmacenesArticulos
        } | null
        articulo?: { __typename?: "Articulo"; estado: EstadosArticulo } | null
    }
}

export type GetAlmacenesArticulosForSearchQueryVariables = Exact<{
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    pagination_options: PageOptionsArgs
}>

export type GetAlmacenesArticulosForSearchQuery = {
    __typename?: "Query"
    almacenes_articulos: {
        __typename?: "SearchAlmacenesArticulosOutput"
        almacenes_articulos: Array<{
            __typename?: "AlmacenArticulo"
            almacen_articulo_id: string
            almacen_id: string
            articulo_id: string
            precio: number
            cantidad: number
            almacen?: { __typename?: "Almacen"; almacen_id: string; nombre: string } | null
            articulo?: {
                __typename?: "Articulo"
                articulo_id: string
                categoria_id?: string | null
                foto?: string | null
                nombre: string
                marca?: string | null
                contenido: number
                unidad: UnidadMedidasArticulo
                descripcion?: string | null
            } | null
        }>
    }
}

export type TransferirArticulosMutationVariables = Exact<{
    transferArticulosInput: TransferArticulosInput
}>

export type TransferirArticulosMutation = {
    __typename?: "Mutation"
    transferir_articulos: { __typename?: "TransferArticulosOutput"; numero_articulos_transferidos: number }
}

export type GetArticuloForSearchQueryVariables = Exact<{
    articulo_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
}>

export type GetArticuloForSearchQuery = {
    __typename?: "Query"
    almacenes_articulos: {
        __typename?: "SearchAlmacenesArticulosOutput"
        almacenes_articulos: Array<{
            __typename?: "AlmacenArticulo"
            almacen_articulo_id: string
            almacen_id: string
            articulo_id: string
            articulo?: { __typename?: "Articulo"; nombre: string; descripcion?: string | null } | null
        }>
    }
}

export type GetEnergeticosQueryVariables = Exact<{
    fecha_registro: DateSearchInput
    hotel_id: Scalars["ID"]["input"]
}>

export type GetEnergeticosQuery = {
    __typename?: "Query"
    mantenimientos: Array<{
        __typename?: "Mantenimiento"
        agua: number
        gas: number
        mantenimiento_id: string
        luz: number
        colaborador_id: string
        turno_id: string
        fecha_registro: any
        corte_id?: string | null
        colaborador: { __typename?: "Colaborador"; nombre: string; apellido_paterno: string; apellido_materno: string }
        turno: { __typename?: "Turno"; nombre: string }
        corte: { __typename?: "Corte"; estatus: EstatusCorte; folio: number }
    }>
}

export type RegistrarEnergeticosMutationVariables = Exact<{
    datos_mantenimiento: CreateMantenimientoInput
}>

export type RegistrarEnergeticosMutation = {
    __typename?: "Mutation"
    crear_mantenimiento: {
        __typename?: "Mantenimiento"
        agua: number
        gas: number
        luz: number
        colaborador_id: string
        turno_id: string
        fecha_registro: any
    }
}

export type ActualizarEnergeticosMutationVariables = Exact<{
    datos_mantenimiento: UpdateMantenimientoInput
}>

export type ActualizarEnergeticosMutation = {
    __typename?: "Mutation"
    actualizar_mantenimiento: {
        __typename?: "Mantenimiento"
        agua: number
        gas: number
        luz: number
        colaborador_id: string
        turno_id: string
        fecha_registro: any
    }
}

export type GetKpisMantenimientoQueryVariables = Exact<{
    fecha_registro: DateSearchInput
    hotel_id: Scalars["ID"]["input"]
}>

export type GetKpisMantenimientoQuery = {
    __typename?: "Query"
    kpis_mantenimientos: {
        __typename?: "GetKpisMantenimientoOutput"
        incidencias_cerradas: number
        incidencias_pendientes: number
        habitaciones_bloqueadas: number
        total_agua: number
        total_gas: number
        total_luz: number
    }
}

export type Eliminar_HuellaMutationVariables = Exact<{
    input: DeleteCredencialInput
}>

export type Eliminar_HuellaMutation = { __typename?: "Mutation"; eliminar_huella: string }

export type HabitacionesToCleanQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    estado: Estados_Habitaciones
}>

export type HabitacionesToCleanQuery = {
    __typename?: "Query"
    habitaciones: Array<{
        __typename?: "Habitacion"
        habitacion_id: string
        numero_habitacion: string
        tipo_habitacion_id: string
        ultimos_datos?: {
            __typename?: "DatosHabitacion"
            ultima_limpieza?: Array<{ __typename?: "ColaboradorTarea"; fecha_inicio: any }> | null
        } | null
        tipo_habitacion?: {
            __typename?: "TipoHabitacion"
            nombre: string
            minutos_limpieza_retoque: number
            minutos_limpieza_detallada: number
            minutos_limpieza_normal: number
        } | null
    }>
}

export type HabitacionesToMaintenanceOrCleanQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type HabitacionesToMaintenanceOrCleanQuery = {
    __typename?: "Query"
    habitaciones: Array<{
        __typename?: "Habitacion"
        habitacion_id: string
        estado: Estados_Habitaciones
        numero_habitacion: string
        tipo_habitacion_id: string
        colaborador_tareas_sin_finalizar?: Array<{
            __typename?: "ColaboradorTarea"
            tarea_id?: string | null
            colaborador_tarea_id: string
            fecha_termino?: any | null
        }> | null
        ultimos_datos?: {
            __typename?: "DatosHabitacion"
            ultima_limpieza?: Array<{ __typename?: "ColaboradorTarea"; fecha_inicio: any }> | null
        } | null
        tipo_habitacion?: {
            __typename?: "TipoHabitacion"
            nombre: string
            minutos_limpieza_retoque: number
            minutos_limpieza_detallada: number
            minutos_limpieza_normal: number
        } | null
    }>
}

export type Cambiar_EstadoMutationVariables = Exact<{
    actualizar_habitacion_estado_input: UpdateEstadoHabitacionInput
}>

export type Cambiar_EstadoMutation = {
    __typename?: "Mutation"
    actualizar_habitacion_estado: {
        __typename?: "Habitacion"
        estado: Estados_Habitaciones
        fecha_estado?: any | null
        posicion?: { __typename?: "Posicion"; x: number; y: number; tamano: Tamano } | null
        colaborador_tareas_sin_finalizar?: Array<{
            __typename?: "ColaboradorTarea"
            tarea_id?: string | null
            colaborador_tarea_id: string
            descripcion_tarea?: string | null
            fecha_inicio: any
            tipo_limpieza?: TiposLimpiezas | null
            colaborador?: {
                __typename?: "Colaborador"
                nombre: string
                apellido_materno: string
                apellido_paterno: string
            } | null
        }> | null
        ultimos_datos?: {
            __typename?: "DatosHabitacion"
            ultima_limpieza?: Array<{
                __typename?: "ColaboradorTarea"
                fecha_termino?: any | null
                colaborador?: {
                    __typename?: "Colaborador"
                    apellido_materno: string
                    apellido_paterno: string
                    nombre: string
                } | null
                comentarios?: Array<{
                    __typename?: "ComentarioTarea"
                    comentario?: string | null
                    fecha?: string | null
                }> | null
            }> | null
            ultimo_mantenimiento?: {
                __typename?: "ColaboradorTarea"
                fecha_termino?: any | null
                colaborador?: {
                    __typename?: "Colaborador"
                    apellido_materno: string
                    apellido_paterno: string
                    nombre: string
                } | null
            } | null
            ultima_supervision?: {
                __typename?: "ColaboradorTarea"
                colaborador?: {
                    __typename?: "Colaborador"
                    apellido_materno: string
                    apellido_paterno: string
                    nombre: string
                } | null
            } | null
        } | null
    }
}

export type GetTurnosQueryVariables = Exact<{
    hotel_id: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]
}>

export type GetTurnosQuery = {
    __typename?: "Query"
    turnos: Array<{
        __typename?: "Turno"
        nombre: string
        hora_entrada: string
        hora_salida: string
        hotel_id: string
        turno_id: string
        estado: EstadosTurno
    }>
}

export type ColaboradoresIdNumQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type ColaboradoresIdNumQuery = {
    __typename?: "Query"
    colaboradores: Array<{
        __typename: "Colaborador"
        numero_id: string
        numero_colaborador?: string | null
        colaborador_id: string
        turno_id?: string | null
        cantidad_ordenes?: number | null
        usuario_id?: string | null
        ultima_orden?: { __typename?: "Orden"; orden_id: string } | null
    }>
}

export type ColaboradoresPorHotelQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type ColaboradoresPorHotelQuery = {
    __typename?: "Query"
    colaboradores: Array<{
        __typename?: "Colaborador"
        apellido_materno: string
        apellido_paterno: string
        nombre: string
        foto?: string | null
        usuario_id?: string | null
        es_supervisor?: boolean | null
        fecha_registro?: any | null
        telefono_personal: string
        fecha_cumpleanios?: any | null
        numero_id: string
        sueldo?: number | null
        numero_colaborador?: string | null
        colaborador_id: string
        correo?: string | null
        direccion?: string | null
        estado: string
        fecha_baja?: any | null
        eliminado: boolean
        telefono_emergencia?: string | null
        en_turno: boolean
        turno_id?: string | null
        cantidad_ordenes?: number | null
        usuario?: { __typename?: "Usuario"; tiene_huella?: boolean | null } | null
        ultima_tarea?: {
            __typename?: "ColaboradorTarea"
            tarea_id?: string | null
            descripcion_tarea?: string | null
            fecha_inicio: any
            fecha_termino?: any | null
            colaborador_tarea_id: string
            habitacion_id?: string | null
            habitacion?: {
                __typename?: "Habitacion"
                numero_habitacion: string
                tipo_habitacion_id: string
                tipo_habitacion?: { __typename?: "TipoHabitacion"; nombre: string } | null
            } | null
        } | null
        area?: { __typename?: "Area"; area_id: string; nombre: string } | null
        colaborador_in_hotel?: Array<{
            __typename?: "HotelColaborador"
            area_id: string
            puesto_id: string
            puesto?: { __typename?: "Puesto"; descripcion: string; nombre: string; puesto_id: string } | null
        }> | null
        turno: {
            __typename?: "Turno"
            hora_entrada: string
            hora_salida: string
            nombre: string
            turno_id: string
            estado: EstadosTurno
        }
        asistencia_abierta?: {
            __typename?: "Asistencia"
            asistencia_id: string
            fecha_entrada: any
            fecha_salida?: any | null
        } | null
        ultima_orden?: { __typename?: "Orden"; orden_id: string; orden: string; fecha_registro: any } | null
    }>
}

export type ActualizarColaboradorTurnoMutationVariables = Exact<{
    datos_turno_colaborador: UpdateColaboradorTurnoInput
}>

export type ActualizarColaboradorTurnoMutation = {
    __typename?: "Mutation"
    actualizar_colaborador_turno: { __typename?: "Colaborador"; colaborador_id: string }
}

export type GetPuestosByHotelIdQueryVariables = Exact<{ [key: string]: never }>

export type GetPuestosByHotelIdQuery = {
    __typename?: "Query"
    puestos: Array<{
        __typename?: "Puesto"
        puesto_id: string
        nombre: string
        area?: { __typename?: "Area"; area_id: string; nombre: string } | null
    }>
}

export type EliminarColaboradorMutationVariables = Exact<{
    colaborador: DeleteColaboradorInput
}>

export type EliminarColaboradorMutation = {
    __typename?: "Mutation"
    eliminar_colaborador: { __typename?: "Colaborador"; colaborador_id: string }
}

export type GetAreasQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type GetAreasQuery = {
    __typename?: "Query"
    areas: Array<{
        __typename?: "Area"
        nombre: string
        area_id: string
        puestos?: Array<{ __typename?: "Puesto"; puesto_id: string; nombre: string }> | null
    }>
}

export type CrearColaboradorMutationVariables = Exact<{
    ColaboradorInput: CreateColaboradorInput
}>

export type CrearColaboradorMutation = {
    __typename?: "Mutation"
    crear_colaborador: { __typename?: "Colaborador"; apellido_materno: string; colaborador_id: string }
}

export type CrearColaboradorConUsuarioMutationVariables = Exact<{
    ColaboradorInput: CreateColaboradorUsuarioInput
}>

export type CrearColaboradorConUsuarioMutation = {
    __typename?: "Mutation"
    crear_colaborador_usuario: { __typename?: "Colaborador"; apellido_materno: string; colaborador_id: string }
}

export type ActualizarColaboradorMutationVariables = Exact<{
    datos_colaborador: UpdateColaboradorInput
}>

export type ActualizarColaboradorMutation = {
    __typename?: "Mutation"
    editar_colaborador: {
        __typename?: "Colaborador"
        colaborador_id: string
        usuario_id?: string | null
        nombre: string
        apellido_paterno: string
        apellido_materno: string
        numero_colaborador?: string | null
        estado: string
        en_turno: boolean
        fecha_registro?: any | null
        eliminado: boolean
    }
}

export type AbrirTurnoColaboradorMutationVariables = Exact<{
    turnOnTurnoColaboradorInput: TurnOnTurnoColaboradorInput
}>

export type AbrirTurnoColaboradorMutation = {
    __typename?: "Mutation"
    abrir_turno_colaborador: {
        __typename?: "Colaborador"
        estado: string
        asistencia_abierta?: {
            __typename?: "Asistencia"
            asistencia_id: string
            fecha_entrada: any
            fecha_salida?: any | null
        } | null
    }
}

export type CerrarTurnoColaboradorMutationVariables = Exact<{
    turnOffColaboradoresInput: TurnOffTurnoColaboradoresInput
}>

export type CerrarTurnoColaboradorMutation = {
    __typename?: "Mutation"
    cerrar_turno_colaborador: Array<{
        __typename?: "Colaborador"
        estado: string
        asistencia_abierta?: {
            __typename?: "Asistencia"
            asistencia_id: string
            fecha_entrada: any
            fecha_salida?: any | null
        } | null
    }>
}

export type AbrirTurnoMutationVariables = Exact<{
    open_turno_input: OpenTurnoInput
}>

export type AbrirTurnoMutation = { __typename?: "Mutation"; abrir_turno: string }

export type CerrarTurnoMutationVariables = Exact<{
    cerrar_turno_input: CloseTurnoInput
}>

export type CerrarTurnoMutation = { __typename?: "Mutation"; cerrar_turno: string }

export type CambiarTurnoMutationVariables = Exact<{
    cambiar_turno_input: ChangeTurnoInput
}>

export type CambiarTurnoMutation = { __typename?: "Mutation"; cambiar_turno: string }

export type ColaboradoresPorHotelTableQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    date_asignaciones: DateSearchInput
    pagination_options?: InputMaybe<PageOptionsArgs>
    areas_filter?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>
    puesto_id?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>
    nombre?: InputMaybe<Scalars["String"]["input"]>
}>

export type ColaboradoresPorHotelTableQuery = {
    __typename?: "Query"
    colaboradores_by_area: {
        __typename?: "FindAllPaginatedOutput"
        paginacion?: { __typename?: "DatosPaginationOutput"; total_paginas: number } | null
        colaboradores: Array<{
            __typename?: "Colaborador"
            apellido_materno: string
            apellido_paterno: string
            nombre: string
            numero_id: string
            usuario_id?: string | null
            colaborador_id: string
            estado: string
            en_turno: boolean
            foto?: string | null
            es_supervisor?: boolean | null
            turno_id?: string | null
            cantidad_ordenes?: number | null
            numero_asignaciones?: number | null
            ultima_asistencia_cerrada?: { __typename?: "Asistencia"; asistencia_id: string; fecha_entrada: any } | null
            ultima_tarea?: {
                __typename?: "ColaboradorTarea"
                tarea_id?: string | null
                fecha_inicio: any
                fecha_termino?: any | null
                colaborador_tarea_id: string
                habitacion_id?: string | null
                habitacion?: {
                    __typename?: "Habitacion"
                    numero_habitacion: string
                    estado: Estados_Habitaciones
                    tipo_habitacion_id: string
                    tipo_habitacion?: { __typename?: "TipoHabitacion"; nombre: string } | null
                } | null
            } | null
            mesa_asignada_activa?: { __typename?: "HasActiveMesaAsignadaOutput"; has_mesa_activa: boolean } | null
            colaborador_in_hotel?: Array<{
                __typename?: "HotelColaborador"
                puesto_id: string
                puesto?: { __typename?: "Puesto"; descripcion: string; nombre: string; puesto_id: string } | null
            }> | null
            turno: { __typename?: "Turno"; nombre: string; estado: EstadosTurno }
            asistencia_abierta?: {
                __typename?: "Asistencia"
                asistencia_id: string
                fecha_entrada: any
                fecha_salida?: any | null
            } | null
            ultima_orden?: { __typename?: "Orden"; orden_id: string; orden: string; fecha_registro: any } | null
        }>
    }
}

export type ColaboradoresCountPorAreaQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    areas_filter?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>
}>

export type ColaboradoresCountPorAreaQuery = {
    __typename?: "Query"
    colaboradores_by_area: {
        __typename?: "FindAllPaginatedOutput"
        paginacion?: { __typename?: "DatosPaginationOutput"; total_registros: number } | null
    }
}

export type EliminarHuellaMutationVariables = Exact<{
    input: DeleteCredentialHuellaPinInput
}>

export type EliminarHuellaMutation = { __typename?: "Mutation"; eliminar_huella_pin: string }

export type GenerarPinQueryVariables = Exact<{ [key: string]: never }>

export type GenerarPinQuery = { __typename?: "Query"; generar_pin: string }

export type RegistrarHuellaMutationVariables = Exact<{
    input: CreateCredencialInput
}>

export type RegistrarHuellaMutation = { __typename?: "Mutation"; registrar_huella: string }

export type GetConfigPagoPropinasQueryVariables = Exact<{ [key: string]: never }>

export type GetConfigPagoPropinasQuery = {
    __typename?: "Query"
    puestos: Array<{
        __typename?: "Puesto"
        puesto_id: string
        nombre: string
        porcentaje_propina: number
        area?: { __typename?: "Area"; nombre: string } | null
    }>
}

export type GetPuestosPropinasQueryVariables = Exact<{ [key: string]: never }>

export type GetPuestosPropinasQuery = {
    __typename?: "Query"
    puestos: Array<{ __typename?: "Puesto"; nombre: string; porcentaje_propina: number; puesto_id: string }>
}

export type ModificarEsquemaPropinasMutationVariables = Exact<{
    propinas_esquema: Array<PropinaEsquemaItemInput> | PropinaEsquemaItemInput
}>

export type ModificarEsquemaPropinasMutation = {
    __typename?: "Mutation"
    modificar_esquema_propinas: Array<{
        __typename?: "Puesto"
        descripcion: string
        eliminado: boolean
        estado?: string | null
        nombre: string
        porcentaje_propina: number
        puesto_id: string
    }>
}

export type GetCategoriasArticulosPropinasQueryVariables = Exact<{
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
}>

export type GetCategoriasArticulosPropinasQuery = {
    __typename?: "Query"
    categorias_articulos: Array<{
        __typename?: "CategoriaArticulo"
        categoria_id: string
        nombre: string
        porcentaje_aportacion_propinas: number
    }>
}

export type GetConfiguracionesPropinaQueryVariables = Exact<{
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
}>

export type GetConfiguracionesPropinaQuery = {
    __typename?: "Query"
    configuraciones_propina: Array<{
        __typename?: "ConfiguracionPropina"
        configuracion_propina_id: string
        fecha_registro: any
        porcentaje_venta_efectivo: number
        porcentaje_venta_tarjeta: number
        porcentaje_aportacion_vendedores: number
        porcentaje_comision_por_puntos: number
        paga_propina_en_turno: boolean
    }>
}

export type ActualizarConfiguracionPropinaMutationVariables = Exact<{
    UpdateConfiguracionPropinaInput: UpdateConfiguracionPropinaInput
}>

export type ActualizarConfiguracionPropinaMutation = {
    __typename?: "Mutation"
    actualizar_configuracion_propina: { __typename?: "ConfiguracionPropina"; configuracion_propina_id: string }
}

export type ActualizarAportacionesPropinasPorCategoriaMutationVariables = Exact<{
    aportaciones_roomservice: UpdateAportacionesPropinasRsInput
}>

export type ActualizarAportacionesPropinasPorCategoriaMutation = {
    __typename?: "Mutation"
    actualizar_aportaciones_propinas_por_categoria: Array<{ __typename?: "CategoriaArticulo"; categoria_id: string }>
}

export type Pagos_PropinasQueryVariables = Exact<{
    pago_propinas_input: MonthSearchInput
    hotel_id: Scalars["ID"]["input"]
}>

export type Pagos_PropinasQuery = {
    __typename?: "Query"
    pagos_propinas: Array<{
        __typename?: "PagoPropina"
        asignacion_propina_id: string
        fecha_registro: any
        folio: number
        hotel_id: string
        pago_propina_id: string
        periodo_pago: string
        asignacion_propina?: { __typename?: "AsignacionPropina"; monto_pagado: number } | null
        personal?: {
            __typename?: "Colaborador"
            colaborador_id: string
            apellido_materno: string
            apellido_paterno: string
            nombre: string
            area?: { __typename?: "Area"; nombre: string } | null
            puesto?: { __typename?: "Puesto"; nombre: string } | null
        } | null
    }>
}

export type AjustarAsignacionPropinaMutationVariables = Exact<{
    ajustarAsignacionPropinaInput: AjustarAsignacionPropinaInput
}>

export type AjustarAsignacionPropinaMutation = {
    __typename?: "Mutation"
    ajustar_asignacion_propina: {
        __typename?: "AjustarAsignacionPropinaOutput"
        limite_disponible: number
        monto_recaudado: number
        propinas_ajustadas: Array<{
            __typename?: "RepartoPropinaItemOutput"
            asignacion_propina_id: string
            propina_por_ventas: number
            fondo_de_propinas: number
            comision_bancaria_sobre_fondo: number
            pago_correspondiente: number
            asignacion_propina?: {
                __typename?: "AsignacionPropina"
                remanente_por_ajuste: number
                ingreso_hotel?: boolean | null
                fondo_original: number
                monto_ajuste: number
            } | null
            colaborador?: {
                __typename?: "Colaborador"
                colaborador_id: string
                nombre: string
                apellido_materno: string
                apellido_paterno: string
                foto?: string | null
                puesto?: { __typename?: "Puesto"; puesto_id: string; nombre: string } | null
            } | null
        }>
    }
}

export type Detalle_Reparto_PropinasQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type Detalle_Reparto_PropinasQuery = {
    __typename?: "Query"
    detalle_reparto_propinas?: {
        __typename?: "DetalleRepartoPropinasOutput"
        monto_recaudado: number
        detalle_reparto_propinas: Array<{
            __typename?: "DetalleRepartoPropinaItemOutput"
            propina_recolectada: number
            comision_bancaria_propina_por_venta: number
            aportacion_a_fondo: number
            subtotal_propina_por_ventas: number
            neto_propina_por_ventas: number
            fondo_de_propina: number
            comision_bancaria_sobre_fondo: number
            pago_correspondiente: number
            colaborador?: {
                __typename?: "Colaborador"
                colaborador_id: string
                nombre: string
                apellido_materno: string
                apellido_paterno: string
                puesto?: { __typename?: "Puesto"; nombre: string } | null
            } | null
            desglose_propina_recolectada: Array<{
                __typename?: "PropinaRecolectadaColaboradorDetailOutput"
                categoria: string
                monto: string
            }>
            desglose_aportacion_a_fondo: Array<{
                __typename?: "VentaColaboradorPorCategoriaDetailOutput"
                categoria: string
                monto: number
                aportacion?: number | null
            }>
        }>
        totales: {
            __typename?: "TotalesRepartoPropinasItemOutput"
            total_propinas_recolectadas: number
            total_aportaciones_a_fondo: number
            total_subtotales_propina_por_ventas: number
            total_comisiones_bancarias_propinas_por_ventas: number
            total_neto_propinas_por_ventas: number
            total_fondos_de_propina: number
            total_comisiones_bancarias_sobre_fondo: number
            total_pagos_correspondientes: number
        }
    } | null
}

export type Pagar_PropinasMutationVariables = Exact<{
    pagar_propinas_input: CreateManyPagosPropinasInput
}>

export type Pagar_PropinasMutation = {
    __typename?: "Mutation"
    pagar_propinas: Array<{
        __typename?: "PagoPropina"
        asignacion_propina_id: string
        fecha_registro: any
        folio: number
        hotel_id: string
        pago_propina_id: string
        periodo_pago: string
        asignacion_propina?: { __typename?: "AsignacionPropina"; monto_pagado: number } | null
        personal?: {
            __typename?: "Colaborador"
            colaborador_id: string
            apellido_materno: string
            apellido_paterno: string
            nombre: string
            area?: { __typename?: "Area"; nombre: string } | null
            puesto?: { __typename?: "Puesto"; nombre: string } | null
        } | null
    }>
}

export type Calcular_Pagos_PropinasQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type Calcular_Pagos_PropinasQuery = {
    __typename?: "Query"
    calcular_reparto_propinas: {
        __typename?: "RepartoPropinasOutput"
        limite_disponible: number
        monto_recaudado: number
        reparto_propinas: Array<{
            __typename?: "RepartoPropinaItemOutput"
            asignacion_propina_id: string
            propina_por_ventas: number
            fondo_de_propinas: number
            comision_bancaria_sobre_fondo: number
            pago_correspondiente: number
            asignacion_propina?: {
                __typename?: "AsignacionPropina"
                remanente_por_ajuste: number
                ingreso_hotel?: boolean | null
                fondo_original: number
                monto_ajuste: number
            } | null
            colaborador?: {
                __typename?: "Colaborador"
                colaborador_id: string
                nombre: string
                apellido_materno: string
                apellido_paterno: string
                foto?: string | null
                puesto?: { __typename?: "Puesto"; puesto_id: string; nombre: string } | null
            } | null
        }>
    }
}

export type ReiniciarAsignacionesPropinasMutationVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type ReiniciarAsignacionesPropinasMutation = {
    __typename?: "Mutation"
    reiniciar_asignaciones_propinas: boolean
}

export type ReportePropinasQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type ReportePropinasQuery = {
    __typename?: "Query"
    reporte_propinas?: {
        __typename?: "GetReportePropinasOutput"
        reporte_propinas: Array<{
            __typename?: "ReportePropinasPorPuestoDetailOutput"
            puesto_id: string
            puesto?: { __typename?: "Puesto"; nombre: string } | null
            reporte_colaboradores: Array<{
                __typename?: "ColaboradorReportePropinaDetailOutput"
                colaborador_id: string
                propinas_tarjetas_por_venta_rs: number
                puntos_a_pagar: number
                comision_bancaria_tarjeta: number
                total_a_repartir: number
                colaborador?: {
                    __typename?: "Colaborador"
                    nombre: string
                    apellido_paterno: string
                    apellido_materno: string
                } | null
                ventas_por_categoria: Array<{
                    __typename?: "VentaColaboradorPorCategoriaDetailOutput"
                    categoria: string
                    monto: number
                }>
            }>
        }>
    } | null
}

export type ConsultarReportePropinasVentasQueryVariables = Exact<{
    reporte_propina_venta_id?: InputMaybe<Scalars["ID"]["input"]>
    corte_id?: InputMaybe<Scalars["ID"]["input"]>
}>

export type ConsultarReportePropinasVentasQuery = {
    __typename?: "Query"
    consultar_reporte_propinas?: {
        __typename?: "GetReportePropinasOutput"
        reporte_propinas: Array<{
            __typename?: "ReportePropinasPorPuestoDetailOutput"
            puesto_id: string
            puesto?: { __typename?: "Puesto"; nombre: string } | null
            reporte_colaboradores: Array<{
                __typename?: "ColaboradorReportePropinaDetailOutput"
                colaborador_id: string
                propinas_tarjetas_por_venta_rs: number
                puntos_a_pagar: number
                comision_bancaria_tarjeta: number
                total_a_repartir: number
                colaborador?: {
                    __typename?: "Colaborador"
                    nombre: string
                    apellido_paterno: string
                    apellido_materno: string
                } | null
                ventas_por_categoria: Array<{
                    __typename?: "VentaColaboradorPorCategoriaDetailOutput"
                    categoria: string
                    monto: number
                }>
            }>
        }>
    } | null
}

export type PagarPropinasVentasMutationVariables = Exact<{
    payPropinasVentasInput: PayPropinasVentasInput
}>

export type PagarPropinasVentasMutation = {
    __typename?: "Mutation"
    pagar_propinas_ventas: { __typename?: "PayPropinasVentasOutput"; reporte_propina_venta_id?: string | null }
}

export type AreasForReportQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type AreasForReportQuery = {
    __typename?: "Query"
    areas: Array<{ __typename?: "Area"; area_id: string; nombre: string }>
}

export type CategoriasArticulosForReportQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type CategoriasArticulosForReportQuery = {
    __typename?: "Query"
    categorias_articulos: Array<{ __typename?: "CategoriaArticulo"; categoria_id: string; nombre: string }>
}

export type CategoriasGastosForReportQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type CategoriasGastosForReportQuery = {
    __typename?: "Query"
    categorias_gasto: Array<{ __typename?: "CategoriaGasto"; categoria_id: string; categoria: string }>
}

export type ColaboradoresPorHotelForReportQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type ColaboradoresPorHotelForReportQuery = {
    __typename?: "Query"
    colaboradores: Array<{
        __typename?: "Colaborador"
        apellido_materno: string
        apellido_paterno: string
        nombre: string
        usuario_id?: string | null
        colaborador_id: string
    }>
}

export type PuestosForReportQueryVariables = Exact<{ [key: string]: never }>

export type PuestosForReportQuery = {
    __typename?: "Query"
    puestos: Array<{ __typename?: "Puesto"; puesto_id: string; nombre: string }>
}

export type HabitacionesForReportQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type HabitacionesForReportQuery = {
    __typename?: "Query"
    habitaciones: Array<{ __typename?: "Habitacion"; numero_habitacion: string; habitacion_id: string }>
}

export type MesasForReportQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type MesasForReportQuery = {
    __typename?: "Query"
    mesas: Array<{ __typename?: "Mesa"; numero_mesa: string; mesa_id: string }>
}

export type SearchArticuloForReportQueryVariables = Exact<{
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    pagination_options: PageOptionsArgs
    nameFilter?: InputMaybe<Scalars["String"]["input"]>
}>

export type SearchArticuloForReportQuery = {
    __typename?: "Query"
    almacenes_articulos: {
        __typename?: "SearchAlmacenesArticulosOutput"
        paginacion: { __typename?: "DatosPaginationOutput"; pagina_actual: number; total_paginas: number }
        almacenes_articulos: Array<{
            __typename?: "AlmacenArticulo"
            articulo_id: string
            articulo?: { __typename?: "Articulo"; nombre: string } | null
        }>
    }
}

export type SubcategoriasGastosForReportQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    eliminado?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type SubcategoriasGastosForReportQuery = {
    __typename?: "Query"
    categorias_gasto: Array<{
        __typename?: "CategoriaGasto"
        categoria_id: string
        categoria: string
        subcategorias_de_categoria: Array<{
            __typename?: "SubcategoriaGasto"
            subcategoria_gasto_id: string
            subcategoria: string
        }>
    }>
}

export type Tipos_HabitacionesForReportQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type Tipos_HabitacionesForReportQuery = {
    __typename?: "Query"
    tipo_habitaciones: Array<{ __typename?: "TipoHabitacion"; nombre: string; tipo_habitacion_id: string }>
}

export type TiposMttoForReportQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type TiposMttoForReportQuery = {
    __typename?: "Query"
    tipos_mantenimiento: Array<{ __typename?: "TipoMantenimiento"; tipo_mantenimiento_id: string; nombre: string }>
}

export type TurnosForReportQueryVariables = Exact<{
    hotel_id?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>
}>

export type TurnosForReportQuery = {
    __typename?: "Query"
    turnos: Array<{ __typename?: "Turno"; turno_id: string; nombre: string }>
}

export type UsuariosPorHotelForReportQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type UsuariosPorHotelForReportQuery = {
    __typename?: "Query"
    usuarios: Array<{
        __typename?: "Usuario"
        apellido_materno?: string | null
        apellido_paterno?: string | null
        nombre: string
        usuario_id: string
    }>
}

export type GetComentariosIncidenciaForReportQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    folio: Scalars["Int"]["input"]
}>

export type GetComentariosIncidenciaForReportQuery = {
    __typename?: "Query"
    incidencias: Array<{
        __typename?: "Incidencia"
        incidencia_id: string
        folio: number
        comentarios: Array<{
            __typename?: "ComentarioIncidenciaEntity"
            comentario: string
            fecha: any
            usuario_id: string
        }>
    }>
}

export type BorrarHistorialVehiculoMutationVariables = Exact<{
    historial_vehiculo_id: Scalars["ID"]["input"]
}>

export type BorrarHistorialVehiculoMutation = { __typename?: "Mutation"; borrar_historial_vehiculo: boolean }

export type GetFiltrosMatriculasQueryVariables = Exact<{
    limit?: InputMaybe<Scalars["Float"]["input"]>
    filter_text?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetFiltrosMatriculasQuery = {
    __typename?: "Query"
    filtros_reportes: { __typename?: "FiltrosReportesVehiculos"; matriculas: Array<string> }
}

export type GetFiltrosColoresQueryVariables = Exact<{
    limit?: InputMaybe<Scalars["Float"]["input"]>
    filter_text?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetFiltrosColoresQuery = {
    __typename?: "Query"
    filtros_reportes: { __typename?: "FiltrosReportesVehiculos"; colores: Array<string> }
}

export type GetFiltrosMarcasQueryVariables = Exact<{
    filter_text?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetFiltrosMarcasQuery = {
    __typename?: "Query"
    filtros_reportes: { __typename?: "FiltrosReportesVehiculos"; marca: Array<string> }
}

export type GetFiltrosModelosQueryVariables = Exact<{
    limit?: InputMaybe<Scalars["Float"]["input"]>
    filter_text?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetFiltrosModelosQuery = {
    __typename?: "Query"
    filtros_reportes: { __typename?: "FiltrosReportesVehiculos"; modelo: Array<string> }
}

export type EditarHistorialVehiculoMutationVariables = Exact<{
    input: UpdateHistorialVehiculoInput
}>

export type EditarHistorialVehiculoMutation = { __typename?: "Mutation"; editar_historial_vehiculo: boolean }

export type MotivosIngresoQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type MotivosIngresoQuery = {
    __typename?: "Query"
    motivos_ingreso_vehiculos: Array<{
        __typename?: "MotivoIngresoVehiculo"
        motivo_ingreso_id: string
        nombre: string
        hotel_id: string
    }>
}

export type Crear_ReservaMutationVariables = Exact<{
    crearReservaInput: CreateReservaInput
}>

export type Crear_ReservaMutation = {
    __typename?: "Mutation"
    crear_reserva: {
        __typename?: "CreateReservaResponse"
        reserva: { __typename?: "Reserva"; folio: number }
        ticket: { __typename?: "ReturnIdTicketResponse"; ticket_id: Array<string> }
    }
}

export type GetHabitacionesDisponiblesDrawerQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type GetHabitacionesDisponiblesDrawerQuery = {
    __typename?: "Query"
    habitaciones: Array<{
        __typename?: "Habitacion"
        numero_habitacion: string
        habitacion_id: string
        estado: Estados_Habitaciones
        tipo_habitacion_id: string
        ultima_renta?: { __typename?: "Renta"; horas_extra?: number | null } | null
        tipo_habitacion?: { __typename?: "TipoHabitacion"; nombre: string } | null
        ultima_reserva?: {
            __typename?: "UltimaReserva"
            reserva?: { __typename?: "Reserva"; fecha_registro: any } | null
        } | null
    }>
}

export type AsignarReservaMutationVariables = Exact<{
    asignacion: AddRoomToBookingInput
}>

export type AsignarReservaMutation = {
    __typename?: "Mutation"
    asignar_habitacion_a_reserva: {
        __typename?: "Reserva"
        habitacion: { __typename?: "Habitacion"; numero_habitacion: string }
    }
}

export type CambiarHabitacionReservaMutationVariables = Exact<{
    cambiarHabReservaInput: ChangeHabitacionReservaInput
}>

export type CambiarHabitacionReservaMutation = { __typename?: "Mutation"; cambiar_habitacion_reserva: string }

export type GetNumeroHabitacionQueryVariables = Exact<{
    habitacion_id: Scalars["ID"]["input"]
}>

export type GetNumeroHabitacionQuery = {
    __typename?: "Query"
    habitacion: { __typename?: "Habitacion"; numero_habitacion: string }
}

export type GetReservacionesTableQueryVariables = Exact<{
    id: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
    fecha_entrada?: InputMaybe<DateSearchInput>
    search?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetReservacionesTableQuery = {
    __typename?: "Query"
    reservas: Array<{
        __typename?: "Reserva"
        reserva_id: string
        codigo_ota: string
        corte_id?: string | null
        folio: number
        estado: EstadosReservas
        fecha_cancelacion?: any | null
        fecha_registro: any
        fecha_salida: any
        motivo_cancelacion?: string | null
        fecha_entrada: any
        personas_extras: number
        origen: OrigenRservas
        tipo_habitacion_id: string
        habitacion_id?: string | null
        tarifa_id: string
        correo_huesped?: string | null
        nombre_huesped: string
        telefono_huesped: string
        numero_personas: number
        estado_pago: EstadoPago
        total: number
        tipo_de_habitacion: { __typename?: "TipoHabitacion"; nombre: string }
        habitacion: {
            __typename?: "Habitacion"
            numero_habitacion: string
            habitacion_id: string
            tipo_habitacion?: { __typename?: "TipoHabitacion"; nombre: string } | null
        }
        tarifa?: {
            __typename?: "Tarifa"
            nombre: string
            personas_extra_max?: number | null
            costo_persona_extra: number
            costo_habitacion: number
            hora_checkin: string
            hora_checkout: string
        } | null
        usuario: { __typename?: "Usuario"; nombre: string }
        pagos?: Array<{
            __typename?: "Pago"
            pago_id: string
            total: number
            fecha_pago: any
            detalles_pago?: Array<{
                __typename?: "DetallePago"
                detalle_pago_id: string
                subtotal: number
                tipo_pago: TiposPagos
                ultimos_digitos?: string | null
                numero_referencia?: string | null
                easyrewards_id?: string | null
            }> | null
            extras?: Array<{
                __typename?: "Extra"
                monto_devuelto_cancelacion?: number | null
                fecha_cancelacion?: any | null
                fecha_pago?: any | null
                fecha_solicitud: any
                monto_extra: number
                motivo_cancelacion?: string | null
                numero: number
                tipo_extra: TiposExtras
            }> | null
        }> | null
        experiencias_reserva: Array<{
            __typename?: "ExperienciaReserva"
            experiencia_reserva_id: string
            experiencia_id: string
            total: number
            estado: EstadosExperienciasReservas
            experiencia?: { __typename?: "Experiencia"; nombre: string } | null
        }>
        comentarios: Array<{ __typename?: "ComentariosInfoReserva"; comentario: string; fecha: any }>
    }>
}

export type GetHabitacionTableQueryVariables = Exact<{
    idHabitacin: Scalars["ID"]["input"]
}>

export type GetHabitacionTableQuery = {
    __typename?: "Query"
    habitacion: {
        __typename?: "Habitacion"
        numero_habitacion: string
        tipo_habitacion?: { __typename?: "TipoHabitacion"; nombre: string } | null
    }
}

export type GetClienteResTableQueryVariables = Exact<{
    idCliente: Scalars["ID"]["input"]
}>

export type GetClienteResTableQuery = { __typename?: "Query"; cliente: { __typename?: "Cliente"; nombre: string } }

export type Actualizar_ReservaMutationVariables = Exact<{
    actualizarReservaInput: UpdateReservaInput
}>

export type Actualizar_ReservaMutation = {
    __typename?: "Mutation"
    actualizar_reserva: {
        __typename?: "UpdateReservaResponse"
        reserva: { __typename?: "Reserva"; reserva_id: string; folio: number }
    }
}

export type GetTiposHabitacionQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type GetTiposHabitacionQuery = {
    __typename?: "Query"
    tipo_habitaciones: Array<{
        __typename?: "TipoHabitacion"
        nombre: string
        personas_incluidas: number
        tipo_habitacion_id: string
    }>
}

export type GetServiciosResewrvaQueryVariables = Exact<{ [key: string]: never }>

export type GetServiciosResewrvaQuery = {
    __typename?: "Query"
    servicios: Array<{ __typename?: "Servicio"; nombre: string; servicio_id: string }>
}

export type AddPayReservaMutationVariables = Exact<{
    pago: PayReservaInput
}>

export type AddPayReservaMutation = { __typename?: "Mutation"; pagar_reserva: Array<string> }

export type AgregarPersonaExtraReservaMutationVariables = Exact<{
    add_extras_reserva_input: AddExtrasReservaInput
}>

export type AgregarPersonaExtraReservaMutation = { __typename?: "Mutation"; agregar_extras_reserva: Array<string> }

export type AddComenMutationVariables = Exact<{
    commentReserva: AddComentarioReservaInput
}>

export type AddComenMutation = { __typename?: "Mutation"; agregar_comentario_reserva: string }

export type GetReservacionesCalendarQueryVariables = Exact<{
    id: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
}>

export type GetReservacionesCalendarQuery = {
    __typename?: "Query"
    reservas: Array<{ __typename?: "Reserva"; fecha_entrada: any; fecha_salida: any }>
}

export type UpdateReservaMutationVariables = Exact<{
    AddPersonas: UpdateReservaInput
}>

export type UpdateReservaMutation = {
    __typename?: "Mutation"
    actualizar_reserva: {
        __typename?: "UpdateReservaResponse"
        reserva: { __typename?: "Reserva"; reserva_id: string }
    }
}

export type GetHabitacionReservaQueryVariables = Exact<{
    habitacion_id: Scalars["ID"]["input"]
}>

export type GetHabitacionReservaQuery = {
    __typename?: "Query"
    habitacion: {
        __typename?: "Habitacion"
        ultima_renta?: { __typename?: "Renta"; reserva_id?: string | null } | null
    }
}

export type GetComandaQueryVariables = Exact<{
    comanda_id: Scalars["ID"]["input"]
}>

export type GetComandaQuery = {
    __typename?: "Query"
    comanda: {
        __typename?: "Comanda"
        comanda_id: string
        estado_comanda?: EstadosComandaHistorial | null
        orden_id: string
        folio: number
        orden?: { __typename?: "Orden"; orden: string } | null
        detalles_orden?: Array<{
            __typename?: "DetalleOrden"
            detalle_orden_id: string
            comanda_id?: string | null
            orden_id: string
            cantidad: number
            estado: EstadosDetalleOrden
            costo_con_iva: number
            costo_sin_iva: number
            monto_iva: number
            comentarios?: string | null
            almacen_articulo_id: string
            almacen_articulo?: {
                __typename?: "AlmacenArticulo"
                almacen_articulo_id: string
                precio: number
                articulo_id: string
                articulo?: {
                    __typename?: "Articulo"
                    articulo_id: string
                    nombre: string
                    contenido: number
                    unidad: UnidadMedidasArticulo
                    descripcion?: string | null
                    tipo: TipoArticulo
                    extra: boolean
                    categoria_id?: string | null
                    categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                } | null
            } | null
            extras?: Array<{
                __typename?: "ExtraDetalleOrden"
                extra_detalle_orden_id: string
                detalle_orden_id: string
                almacen_articulo_id: string
                costo_con_iva: number
                costo_sin_iva: number
                monto_iva: number
                cantidad: number
                almacen_articulo?: {
                    __typename?: "AlmacenArticulo"
                    almacen_articulo_id: string
                    articulo_id: string
                    precio: number
                    articulo?: {
                        __typename?: "Articulo"
                        nombre: string
                        contenido: number
                        unidad: UnidadMedidasArticulo
                        descripcion?: string | null
                        categoria_id?: string | null
                        tipo: TipoArticulo
                        extra: boolean
                        categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                    } | null
                } | null
            }> | null
        }> | null
    }
}

export type EditarComandaMutationVariables = Exact<{
    input: EditComandaInput
}>

export type EditarComandaMutation = {
    __typename?: "Mutation"
    editar_comanda: { __typename?: "Comanda"; comanda_id: string }
}

export type UpdatePosicionMesaMutationVariables = Exact<{
    updatePosicionMesaInput: UpdatePosicionMesaInput
}>

export type UpdatePosicionMesaMutation = {
    __typename?: "Mutation"
    actualizar_posicion_mesa: {
        __typename?: "Mesa"
        mesa_id: string
        posicion?: { __typename?: "PosicionMesa"; x: number; y: number; tamano: TamanoMesa } | null
    }
}

export type GetMesasConfigQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type GetMesasConfigQuery = {
    __typename?: "Query"
    mesas: Array<{ __typename?: "Mesa"; mesa_id: string; numero_mesa: string }>
}

export type CrearMesaAsignadaMutationVariables = Exact<{
    input: CreateMesaAsignadaInput
}>

export type CrearMesaAsignadaMutation = {
    __typename?: "Mutation"
    crear_mesa_asignada: { __typename?: "MesaAsignada"; mesa_id: string }
}

export type GetRestaurantAreaColaboradoresQueryVariables = Exact<{
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    area_id?: InputMaybe<Scalars["ID"]["input"]>
}>

export type GetRestaurantAreaColaboradoresQuery = {
    __typename?: "Query"
    colaboradores: Array<{
        __typename?: "Colaborador"
        colaborador_id: string
        nombre: string
        apellido_materno: string
        apellido_paterno: string
        foto?: string | null
    }>
}

export type GetAreaRestauranteQueryVariables = Exact<{
    nombre?: InputMaybe<Scalars["String"]["input"]>
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
}>

export type GetAreaRestauranteQuery = { __typename?: "Query"; areas: Array<{ __typename?: "Area"; area_id: string }> }

export type CambiarMesaAsignadaMutationVariables = Exact<{
    input: CambiarMesaAsignadaInput
    template_sample?: InputMaybe<Scalars["String"]["input"]>
    codigo?: InputMaybe<Scalars["String"]["input"]>
}>

export type CambiarMesaAsignadaMutation = {
    __typename?: "Mutation"
    cambiar_mesa_asignada: { __typename?: "MesaAsignada"; mesa_id: string }
}

export type ActualizarMesaAsignadaMutationVariables = Exact<{
    input: UpdateMesaAsignadaInput
}>

export type ActualizarMesaAsignadaMutation = {
    __typename?: "Mutation"
    actualizar_mesa_asignada: { __typename?: "MesaAsignada"; mesa_id: string }
}

export type CerrarCuentaMesaAsignadaMutationVariables = Exact<{
    cerrarCuentaMesaAsignadaInput: CloseBillMesaAsignadaInput
}>

export type CerrarCuentaMesaAsignadaMutation = {
    __typename?: "Mutation"
    cerrar_cuenta_mesa_asignada: {
        __typename?: "MesaAsignada"
        mesa_asignada_id: string
        mesa_id: string
        orden_id?: string | null
        fecha_cuenta_cerrada?: any | null
        fecha_registro: any
        fecha_salida?: any | null
        colaborador_asignado_id: string
        colaborador_atendio?: {
            __typename?: "Colaborador"
            nombre: string
            apellido_paterno: string
            apellido_materno: string
        } | null
    }
}

export type GetRestaurantOrdenQueryVariables = Exact<{
    orden_id: Scalars["ID"]["input"]
}>

export type GetRestaurantOrdenQuery = {
    __typename?: "Query"
    orden: {
        __typename?: "Orden"
        orden_id: string
        orden: string
        total_con_iva: number
        total_sin_iva: number
        pago_id?: string | null
        pagos: Array<{
            __typename?: "Pago"
            pago_id: string
            detalles_pago?: Array<{
                __typename?: "DetallePago"
                subtotal: number
                easyrewards_id?: string | null
            }> | null
        }>
        pago?: { __typename?: "Pago"; pago_id: string; total: number } | null
        comandas?: Array<{
            __typename?: "Comanda"
            comanda_id: string
            estado_comanda?: EstadosComandaHistorial | null
            orden_id: string
            folio: number
            total_comanda: number
            detalles_orden?: Array<{
                __typename?: "DetalleOrden"
                detalle_orden_id: string
                comanda_id?: string | null
                cantidad: number
                estado: EstadosDetalleOrden
                costo_con_iva: number
                monto_iva: number
                almacen_articulo_id: string
                almacen_articulo?: {
                    __typename?: "AlmacenArticulo"
                    almacen_articulo_id: string
                    precio: number
                    articulo_id: string
                    categoria_id?: string | null
                    categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                    articulo?: {
                        __typename?: "Articulo"
                        articulo_id: string
                        nombre: string
                        contenido: number
                        unidad: UnidadMedidasArticulo
                        descripcion?: string | null
                        tipo: TipoArticulo
                        extra: boolean
                        categoria_id?: string | null
                        categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                    } | null
                } | null
                extras?: Array<{
                    __typename?: "ExtraDetalleOrden"
                    extra_detalle_orden_id: string
                    detalle_orden_id: string
                    almacen_articulo_id: string
                    costo_con_iva: number
                    monto_iva: number
                    cantidad: number
                    almacen_articulo?: {
                        __typename?: "AlmacenArticulo"
                        almacen_articulo_id: string
                        articulo_id: string
                        precio: number
                        articulo?: {
                            __typename?: "Articulo"
                            nombre: string
                            contenido: number
                            unidad: UnidadMedidasArticulo
                            descripcion?: string | null
                            categoria_id?: string | null
                            tipo: TipoArticulo
                            extra: boolean
                            categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                        } | null
                    } | null
                }> | null
            }> | null
        }> | null
    }
}

export type GetRestaurantColaboradoresQueryVariables = Exact<{
    datos_busqueda: SearchColaboradoresForTaskInput
}>

export type GetRestaurantColaboradoresQuery = {
    __typename?: "Query"
    colaboradores_disponibles_por_puesto?: Array<{
        __typename?: "Colaborador"
        apellido_materno: string
        apellido_paterno: string
        nombre: string
        foto?: string | null
        colaborador_id: string
        en_turno: boolean
        colaborador_in_hotel?: Array<{
            __typename?: "HotelColaborador"
            puesto?: { __typename?: "Puesto"; puesto_id: string; nombre: string } | null
        }> | null
        ultima_tarea?: {
            __typename?: "ColaboradorTarea"
            fecha_inicio: any
            fecha_termino?: any | null
            colaborador_tarea_id: string
        } | null
    }> | null
}

export type UsuarioQueryVariables = Exact<{
    usuario_id: Scalars["ID"]["input"]
}>

export type UsuarioQuery = {
    __typename?: "Query"
    usuario: {
        __typename?: "Usuario"
        apellido_materno?: string | null
        apellido_paterno?: string | null
        nombre: string
    }
}

export type GetMesasQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type GetMesasQuery = {
    __typename?: "Query"
    mesas: Array<{
        __typename?: "Mesa"
        cantidad_personas: number
        eliminado: boolean
        estado: EstadoMesa
        fecha_modificacion?: any | null
        fecha_registro: any
        hotel_id: string
        mesa_id: string
        motivo_bloqueo?: string | null
        numero_mesa: string
        usuario_modifico_id?: string | null
        posicion?: { __typename?: "PosicionMesa"; x: number; y: number } | null
        ultima_asignacion?: {
            __typename?: "MesaAsignada"
            fecha_salida?: any | null
            colaborador_asignado_id: string
            colaborador_atendio?: {
                __typename?: "Colaborador"
                nombre: string
                apellido_paterno: string
                apellido_materno: string
            } | null
        } | null
        asignacion_actual?: {
            __typename?: "MesaAsignada"
            colaborador_asignado_id: string
            fecha_registro: any
            fecha_cuenta_cerrada?: any | null
            fecha_salida?: any | null
            mesa_asignada_id: string
            mesa_id: string
            orden_id?: string | null
            colaborador_atendio?: {
                __typename?: "Colaborador"
                nombre: string
                apellido_paterno: string
                apellido_materno: string
            } | null
        } | null
        estado_dinamico?: {
            __typename?: "GetMesaDynamicStateOutput"
            estado_activo?: EstadosDinamicosMesa | null
            comanda_activa?: {
                __typename?: "Comanda"
                comanda_id: string
                estado_comanda?: EstadosComandaHistorial | null
                fecha_modificacion?: any | null
                fecha_registro: any
                folio: number
                orden_id: string
                total_comanda: number
                usuario_id: string
                orden?: {
                    __typename?: "Orden"
                    pago?: {
                        __typename?: "Pago"
                        hotel_id: string
                        pago_id: string
                        ticket_id?: string | null
                        usuario_id: string
                        detalles_pago?: Array<{
                            __typename?: "DetallePago"
                            detalle_pago_id: string
                            fecha_pago: any
                            numero_referencia?: string | null
                            origen_orden: OrigenOrden
                            pago_id: string
                            subtotal: number
                            tipo_pago: TiposPagos
                            ultimos_digitos?: string | null
                        }> | null
                    } | null
                } | null
            } | null
        } | null
    }>
}

export type ActualizarMesaMutationVariables = Exact<{
    updateMesaInput: UpdateMesaInput
}>

export type ActualizarMesaMutation = {
    __typename?: "Mutation"
    actualizar_mesa: {
        __typename?: "Mesa"
        hotel_id: string
        mesa_id: string
        numero_mesa: string
        cantidad_personas: number
        eliminado: boolean
        estado: EstadoMesa
        motivo_bloqueo?: string | null
        fecha_modificacion?: any | null
        usuario_modifico_id?: string | null
        ultima_asignacion?: {
            __typename?: "MesaAsignada"
            colaborador_asignado_id: string
            colaborador_atendio?: {
                __typename?: "Colaborador"
                nombre: string
                apellido_paterno: string
                apellido_materno: string
            } | null
        } | null
    }
}

export type ListenCheckMesasSubscriptionVariables = Exact<{ [key: string]: never }>

export type ListenCheckMesasSubscription = {
    __typename?: "Subscription"
    checkMesas: {
        __typename?: "Mesa"
        hotel_id: string
        mesa_id: string
        numero_mesa: string
        cantidad_personas: number
        eliminado: boolean
        estado: EstadoMesa
        motivo_bloqueo?: string | null
        fecha_modificacion?: any | null
        usuario_modifico_id?: string | null
        posicion?: { __typename?: "PosicionMesa"; x: number; y: number } | null
        ultima_asignacion?: {
            __typename?: "MesaAsignada"
            fecha_salida?: any | null
            colaborador_asignado_id: string
            colaborador_atendio?: {
                __typename?: "Colaborador"
                nombre: string
                apellido_paterno: string
                apellido_materno: string
            } | null
        } | null
        asignacion_actual?: {
            __typename?: "MesaAsignada"
            colaborador_asignado_id: string
            fecha_registro: any
            fecha_cuenta_cerrada?: any | null
            mesa_asignada_id: string
            mesa_id: string
            orden_id?: string | null
            colaborador_atendio?: {
                __typename?: "Colaborador"
                nombre: string
                apellido_paterno: string
                apellido_materno: string
            } | null
        } | null
        estado_dinamico?: {
            __typename?: "GetMesaDynamicStateOutput"
            estado_activo?: EstadosDinamicosMesa | null
            comanda_activa?: {
                __typename?: "Comanda"
                comanda_id: string
                estado_comanda?: EstadosComandaHistorial | null
                fecha_modificacion?: any | null
                fecha_registro: any
                folio: number
                orden_id: string
                total_comanda: number
                usuario_id: string
            } | null
        } | null
    }
}

export type CancelarOrdenMutationVariables = Exact<{
    cancel_orden_input: CancelOrdenInput
}>

export type CancelarOrdenMutation = {
    __typename?: "Mutation"
    cancelar_orden?: {
        __typename?: "CancelOrdenOutput"
        ticket_id?: string | null
        orden: {
            __typename?: "Orden"
            colaborador_id?: string | null
            comentario?: string | null
            corte_id?: string | null
            easyrewards_id?: string | null
            estado_orden?: EstadosOrdenHistorial | null
            estado_pago: EstadoPagoOrdenes
            fecha_cobro?: any | null
            fecha_modificacion?: any | null
            fecha_registro: any
            hotel_id: string
            monto_iva: number
            orden: string
            orden_id: string
            origen_orden?: string | null
            pago_id?: string | null
            panel_no_visible: boolean
            renta_id?: string | null
            total_con_iva: number
            total_productos: number
            total_sin_iva: number
            turno_id?: string | null
            usuario_id: string
        }
    } | null
}

export type CancelarComandaMutationVariables = Exact<{
    cancelar_comanda: CancelComandaInput
}>

export type CancelarComandaMutation = {
    __typename?: "Mutation"
    cancelar_comanda: {
        __typename?: "CancelComandaOutput"
        ticket_id?: string | null
        comanda: { __typename?: "Comanda"; comanda_id: string; orden_id: string }
    }
}

export type GetComandaCancelacionQueryVariables = Exact<{
    comanda_id: Scalars["ID"]["input"]
}>

export type GetComandaCancelacionQuery = {
    __typename?: "Query"
    comanda: {
        __typename?: "Comanda"
        folio: number
        comanda_id: string
        orden?: { __typename?: "Orden"; orden: string } | null
        detalles_orden?: Array<{
            __typename?: "DetalleOrden"
            motivo_cancelacion?: string | null
            fecha_cancelacion?: any | null
            reembolso?: boolean | null
            detalle_orden_id: string
            comentarios?: string | null
            almacen_articulo_id: string
            cantidad: number
            costo_con_iva: number
            monto_iva: number
            almacen_articulo?: {
                __typename?: "AlmacenArticulo"
                precio: number
                articulo_id: string
                categoria_id?: string | null
                articulo?: {
                    __typename?: "Articulo"
                    articulo_id: string
                    nombre: string
                    contenido: number
                    unidad: UnidadMedidasArticulo
                    descripcion?: string | null
                    tipo: TipoArticulo
                    extra: boolean
                    categoria_id?: string | null
                    categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                } | null
            } | null
            extras?: Array<{
                __typename?: "ExtraDetalleOrden"
                extra_detalle_orden_id: string
                detalle_orden_id: string
                almacen_articulo_id: string
                costo_con_iva: number
                monto_iva: number
                cantidad: number
                almacen_articulo?: {
                    __typename?: "AlmacenArticulo"
                    almacen_articulo_id: string
                    articulo_id: string
                    precio: number
                    articulo?: {
                        __typename?: "Articulo"
                        nombre: string
                        contenido: number
                        unidad: UnidadMedidasArticulo
                        descripcion?: string | null
                        categoria_id?: string | null
                        tipo: TipoArticulo
                        extra: boolean
                        categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                    } | null
                } | null
            }> | null
        }> | null
    }
}

export type CancelacionOrdenesQueryVariables = Exact<{
    orden_id: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
    fecha_registro?: InputMaybe<DateSearchInput>
}>

export type CancelacionOrdenesQuery = {
    __typename?: "Query"
    ordenes: Array<{
        __typename?: "Orden"
        orden: string
        orden_id: string
        estado_pago: EstadoPagoOrdenes
        estado_orden?: EstadosOrdenHistorial | null
        origen_orden?: string | null
        fecha_registro: any
        fecha_modificacion?: any | null
        total_con_iva: number
        total_sin_iva: number
        colaborador_id?: string | null
        renta_id?: string | null
        turno_id?: string | null
        easyrewards_id?: string | null
        pago_id?: string | null
        turno?: { __typename?: "Turno"; nombre: string } | null
        colaborador_entrega?: {
            __typename?: "Colaborador"
            nombre: string
            apellido_materno: string
            apellido_paterno: string
        } | null
        renta?: {
            __typename?: "Renta"
            habitacion_id: string
            habitacion?: {
                __typename?: "Habitacion"
                numero_habitacion: string
                tipo_habitacion_id: string
                tipo_habitacion?: { __typename?: "TipoHabitacion"; nombre: string } | null
            } | null
        } | null
        detalles_orden?: Array<{
            __typename?: "DetalleOrden"
            motivo_cancelacion?: string | null
            fecha_cancelacion?: any | null
            reembolso?: boolean | null
            detalle_orden_id: string
            comentarios?: string | null
            almacen_articulo_id: string
            cantidad: number
            costo_con_iva: number
            monto_iva: number
            almacen_articulo?: {
                __typename?: "AlmacenArticulo"
                categoria_id?: string | null
                precio: number
                articulo_id: string
                categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                articulo?: {
                    __typename?: "Articulo"
                    articulo_id: string
                    nombre: string
                    contenido: number
                    unidad: UnidadMedidasArticulo
                    descripcion?: string | null
                    tipo: TipoArticulo
                    extra: boolean
                    categoria_id?: string | null
                    categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                } | null
            } | null
            extras?: Array<{
                __typename?: "ExtraDetalleOrden"
                extra_detalle_orden_id: string
                detalle_orden_id: string
                almacen_articulo_id: string
                costo_con_iva: number
                monto_iva: number
                cantidad: number
                almacen_articulo?: {
                    __typename?: "AlmacenArticulo"
                    almacen_articulo_id: string
                    articulo_id: string
                    precio: number
                    articulo?: {
                        __typename?: "Articulo"
                        nombre: string
                        contenido: number
                        unidad: UnidadMedidasArticulo
                        descripcion?: string | null
                        categoria_id?: string | null
                        tipo: TipoArticulo
                        extra: boolean
                        categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                    } | null
                } | null
            }> | null
        }> | null
        pago?: {
            __typename?: "Pago"
            pago_id: string
            fecha_pago: any
            total: number
            ticket_id?: string | null
            detalles_pago?: Array<{
                __typename?: "DetallePago"
                detalle_pago_id: string
                pago_id: string
                ultimos_digitos?: string | null
                subtotal: number
                tipo_pago: TiposPagos
                numero_referencia?: string | null
                easyrewards_id?: string | null
            }> | null
        } | null
        propina?: {
            __typename?: "Propina"
            total: number
            propina_id: string
            detalles_pago: Array<{
                __typename?: "DetallesPagoPartialInfoOutput"
                ultimos_digitos?: string | null
                tipo_pago: TiposPagos
                subtotal: number
            }>
        } | null
        mesa?: { __typename?: "Mesa"; numero_mesa: string } | null
    }>
}

export type CategoriasArticulosQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type CategoriasArticulosQuery = {
    __typename?: "Query"
    categorias_articulos: Array<{
        __typename?: "CategoriaArticulo"
        nombre: string
        descripcion: string
        hotel_id: string
        categoria_id: string
        total_articulos?: number | null
        eliminado: boolean
        porcentaje_aportacion_propinas: number
    }>
}

export type CrearOrdenMutationVariables = Exact<{
    create_orden_input: CreateOrdenInput
}>

export type CrearOrdenMutation = {
    __typename?: "Mutation"
    crear_orden: {
        __typename: "CreateOrdenResponse"
        orden: {
            __typename: "Orden"
            orden: string
            orden_id: string
            virtual_comanda_id?: string | null
            consumo_interno_colaborador_id?: string | null
            pago_id?: string | null
            easyrewards_id?: string | null
            comanda?: { __typename?: "Comanda"; folio: number } | null
            pago?: {
                __typename: "Pago"
                ticket_id?: string | null
                detalles_pago?: Array<{ __typename: "DetallePago"; easyrewards_id?: string | null }> | null
            } | null
        }
    }
}

export type ActualizarOrdenMutationVariables = Exact<{
    update_orden_input: UpdateOrdenInput
}>

export type ActualizarOrdenMutation = { __typename?: "Mutation"; actualizar_orden: string }

export type GetOrdenEditQueryVariables = Exact<{
    input: Scalars["ID"]["input"]
}>

export type GetOrdenEditQuery = {
    __typename?: "Query"
    orden: {
        __typename?: "Orden"
        orden_id: string
        orden: string
        detalles_orden?: Array<{
            __typename?: "DetalleOrden"
            costo_con_iva: number
            costo_sin_iva: number
            comanda_id?: string | null
            comentarios?: string | null
            detalle_orden_id: string
            cantidad: number
            almacen_articulo_id: string
            extras?: Array<{
                __typename?: "ExtraDetalleOrden"
                extra_detalle_orden_id: string
                cantidad: number
                almacen_articulo_id: string
                almacen_articulo?: {
                    __typename?: "AlmacenArticulo"
                    costo: number
                    precio: number
                    articulo?: {
                        __typename?: "Articulo"
                        nombre: string
                        categoria_id?: string | null
                        categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                    } | null
                } | null
            }> | null
            almacen_articulo?: {
                __typename?: "AlmacenArticulo"
                almacen_articulo_id: string
                articulo_id: string
                costo: number
                precio: number
                articulo?: {
                    __typename?: "Articulo"
                    articulo_id: string
                    nombre: string
                    categoria_id?: string | null
                    categoria_articulo?: {
                        __typename?: "CategoriaArticulo"
                        categoria_id: string
                        nombre: string
                    } | null
                } | null
            } | null
        }> | null
    }
}

export type GetOrdenForUpdateQueryVariables = Exact<{
    orden_id: Scalars["ID"]["input"]
}>

export type GetOrdenForUpdateQuery = {
    __typename?: "Query"
    orden: {
        __typename?: "Orden"
        orden: string
        estado_orden?: EstadosOrdenHistorial | null
        orden_id: string
        detalles_orden?: Array<{
            __typename?: "DetalleOrden"
            detalle_orden_id: string
            comanda_id?: string | null
            orden_id: string
            cantidad: number
            estado: EstadosDetalleOrden
            costo_con_iva: number
            costo_sin_iva: number
            monto_iva: number
            comentarios?: string | null
            almacen_articulo_id: string
            almacen_articulo?: {
                __typename?: "AlmacenArticulo"
                almacen_articulo_id: string
                precio: number
                articulo_id: string
                articulo?: {
                    __typename?: "Articulo"
                    articulo_id: string
                    nombre: string
                    contenido: number
                    unidad: UnidadMedidasArticulo
                    descripcion?: string | null
                    tipo: TipoArticulo
                    extra: boolean
                    categoria_id?: string | null
                    categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                } | null
            } | null
            extras?: Array<{
                __typename?: "ExtraDetalleOrden"
                extra_detalle_orden_id: string
                detalle_orden_id: string
                almacen_articulo_id: string
                costo_con_iva: number
                costo_sin_iva: number
                monto_iva: number
                cantidad: number
                almacen_articulo?: {
                    __typename?: "AlmacenArticulo"
                    almacen_articulo_id: string
                    articulo_id: string
                    precio: number
                    articulo?: {
                        __typename?: "Articulo"
                        nombre: string
                        contenido: number
                        unidad: UnidadMedidasArticulo
                        descripcion?: string | null
                        categoria_id?: string | null
                        tipo: TipoArticulo
                        extra: boolean
                        categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                    } | null
                } | null
            }> | null
        }> | null
    }
}

export type EditarOrdenMutationVariables = Exact<{
    input: EditOrdenInput
}>

export type EditarOrdenMutation = { __typename?: "Mutation"; editar_orden: { __typename?: "Orden"; orden_id: string } }

export type GetOrdenesHistorialQueryVariables = Exact<{
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    fecha_registro?: InputMaybe<DateSearchInput>
    pagination_options: PageOptionsArgs
    tipo_orden: TipoOrden
    numero_orden?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetOrdenesHistorialQuery = {
    __typename?: "Query"
    historial_estados_orden: {
        __typename?: "SearchHistorialEstadosOrdenOutput"
        paginacion: {
            __typename?: "DatosPaginationOutput"
            pagina_actual: number
            total_paginas: number
            total_registros: number
        }
        historial_estados_orden: Array<{
            __typename?: "HistorialEstadoOrden"
            estado_orden: EstadosOrdenHistorial
            fecha_registro: any
            historial_estado_orden_id: string
            orden_id: string
            tiempo_en_entrega?: string | null
            tiempo_en_preparacion?: string | null
            tiempo_por_entregar?: string | null
            tiempo_total?: string | null
            orden?: {
                __typename?: "Orden"
                orden_id: string
                orden: string
                turno_id?: string | null
                estado_orden?: EstadosOrdenHistorial | null
                estado_pago: EstadoPagoOrdenes
                origen_orden?: string | null
                renta_id?: string | null
                fecha_cobro?: any | null
                fecha_registro: any
                colaborador_id?: string | null
                total_con_iva: number
                pago_id?: string | null
                turno?: { __typename?: "Turno"; nombre: string } | null
                renta?: {
                    __typename?: "Renta"
                    habitacion_id: string
                    habitacion?: {
                        __typename?: "Habitacion"
                        numero_habitacion: string
                        tipo_habitacion_id: string
                        tipo_habitacion?: { __typename?: "TipoHabitacion"; nombre: string } | null
                    } | null
                } | null
                colaborador_entrega?: {
                    __typename?: "Colaborador"
                    nombre: string
                    apellido_paterno: string
                    apellido_materno: string
                } | null
                pago?: {
                    __typename?: "Pago"
                    pago_id: string
                    total: number
                    detalles_pago?: Array<{ __typename?: "DetallePago"; tipo_pago: TiposPagos }> | null
                } | null
                comanda?: { __typename?: "Comanda"; folio: number } | null
                mesa?: { __typename?: "Mesa"; numero_mesa: string } | null
            } | null
        }>
    }
}

export type GetComandasHistorialQueryVariables = Exact<{
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    fecha_registro?: InputMaybe<DateSearchInput>
    pagination_options: PageOptionsArgs
    numero_orden?: InputMaybe<Scalars["String"]["input"]>
    numero_mesa?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>
}>

export type GetComandasHistorialQuery = {
    __typename?: "Query"
    historial_estados_comanda: {
        __typename?: "SearchHistorialEstadosComandaOutput"
        paginacion: {
            __typename?: "DatosPaginationOutput"
            pagina_actual: number
            total_paginas: number
            total_registros: number
        }
        historial_estados_comanda: Array<{
            __typename?: "HistorialEstadoComanda"
            historial_estado_comanda_id: string
            comanda_id: string
            hotel_id: string
            tiempo_en_preparacion?: string | null
            tiempo_por_entregar?: string | null
            tiempo_total?: string | null
            comanda?: {
                __typename?: "Comanda"
                orden_id: string
                comanda_id: string
                fecha_registro: any
                folio: number
                total_comanda: number
                orden?: {
                    __typename?: "Orden"
                    orden_id: string
                    orden: string
                    colaborador_id?: string | null
                    estado_pago: EstadoPagoOrdenes
                    estado_orden?: EstadosOrdenHistorial | null
                    origen_orden?: string | null
                    pago_id?: string | null
                    turno_id?: string | null
                    colaborador_entrega?: {
                        __typename?: "Colaborador"
                        nombre: string
                        apellido_paterno: string
                        apellido_materno: string
                    } | null
                    mesa?: { __typename?: "Mesa"; numero_mesa: string } | null
                    pago?: {
                        __typename?: "Pago"
                        pago_id: string
                        detalles_pago?: Array<{ __typename?: "DetallePago"; tipo_pago: TiposPagos }> | null
                    } | null
                    turno?: { __typename?: "Turno"; nombre: string } | null
                } | null
            } | null
        }>
    }
}

export type GetOrdenesHistorialCountQueryVariables = Exact<{
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    fecha_registro: DateSearchInput
    tipo_orden: TipoOrden
}>

export type GetOrdenesHistorialCountQuery = {
    __typename?: "Query"
    historial_estados_orden: {
        __typename?: "SearchHistorialEstadosOrdenOutput"
        paginacion: { __typename?: "DatosPaginationOutput"; total_registros: number }
    }
}

export type GetComandasHistorialCountQueryVariables = Exact<{
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    fecha_registro: DateSearchInput
}>

export type GetComandasHistorialCountQuery = {
    __typename?: "Query"
    historial_estados_comanda: {
        __typename?: "SearchHistorialEstadosComandaOutput"
        paginacion: { __typename?: "DatosPaginationOutput"; total_registros: number }
    }
}

export type GetNumeroMesasQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type GetNumeroMesasQuery = {
    __typename?: "Query"
    mesas: Array<{ __typename?: "Mesa"; mesa_id: string; numero_mesa: string }>
}

export type OrdenesQueryVariables = Exact<{
    orden_id: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
    fecha_registro?: InputMaybe<DateSearchInput>
}>

export type OrdenesQuery = {
    __typename?: "Query"
    ordenes: Array<{
        __typename?: "Orden"
        orden: string
        orden_id: string
        estado_pago: EstadoPagoOrdenes
        estado_orden?: EstadosOrdenHistorial | null
        origen_orden?: string | null
        fecha_registro: any
        fecha_modificacion?: any | null
        total_con_iva: number
        total_sin_iva: number
        colaborador_id?: string | null
        renta_id?: string | null
        turno_id?: string | null
        consumo_interno_colaborador_id?: string | null
        usuario_id: string
        easyrewards_id?: string | null
        pago_id?: string | null
        turno?: { __typename?: "Turno"; nombre: string } | null
        usuario: { __typename?: "Usuario"; nombre: string }
        colaborador_entrega?: {
            __typename?: "Colaborador"
            nombre: string
            apellido_materno: string
            apellido_paterno: string
        } | null
        renta?: {
            __typename?: "Renta"
            habitacion_id: string
            habitacion?: {
                __typename?: "Habitacion"
                numero_habitacion: string
                tipo_habitacion_id: string
                tipo_habitacion?: { __typename?: "TipoHabitacion"; nombre: string } | null
            } | null
        } | null
        detalles_orden?: Array<{
            __typename?: "DetalleOrden"
            detalle_orden_id: string
            estado: EstadosDetalleOrden
            motivo_cancelacion?: string | null
            fecha_cancelacion?: any | null
            reembolso?: boolean | null
            comentarios?: string | null
            almacen_articulo_id: string
            cantidad: number
            costo_con_iva: number
            monto_iva: number
            almacen_articulo?: {
                __typename?: "AlmacenArticulo"
                precio: number
                articulo_id: string
                articulo?: {
                    __typename?: "Articulo"
                    articulo_id: string
                    nombre: string
                    contenido: number
                    unidad: UnidadMedidasArticulo
                    descripcion?: string | null
                    tipo: TipoArticulo
                    extra: boolean
                    categoria_id?: string | null
                    categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                } | null
            } | null
            extras?: Array<{
                __typename?: "ExtraDetalleOrden"
                extra_detalle_orden_id: string
                detalle_orden_id: string
                almacen_articulo_id: string
                costo_con_iva: number
                monto_iva: number
                cantidad: number
                almacen_articulo?: {
                    __typename?: "AlmacenArticulo"
                    almacen_articulo_id: string
                    articulo_id: string
                    precio: number
                    articulo?: {
                        __typename?: "Articulo"
                        nombre: string
                        contenido: number
                        unidad: UnidadMedidasArticulo
                        descripcion?: string | null
                        categoria_id?: string | null
                        tipo: TipoArticulo
                        extra: boolean
                        categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                    } | null
                } | null
            }> | null
        }> | null
        pagos: Array<{
            __typename?: "Pago"
            pago_id: string
            fecha_pago: any
            total: number
            ticket_id?: string | null
            detalles_pago?: Array<{
                __typename?: "DetallePago"
                detalle_pago_id: string
                pago_id: string
                ultimos_digitos?: string | null
                subtotal: number
                tipo_pago: TiposPagos
                numero_referencia?: string | null
                easyrewards_id?: string | null
            }> | null
        }>
        propina?: {
            __typename?: "Propina"
            total: number
            propina_id: string
            detalles_pago: Array<{
                __typename?: "DetallesPagoPartialInfoOutput"
                numero_referencia?: string | null
                ultimos_digitos?: string | null
                tipo_pago: TiposPagos
                subtotal: number
            }>
        } | null
        mesa?: { __typename?: "Mesa"; numero_mesa: string } | null
    }>
}

export type OrdenQueryVariables = Exact<{
    orden_id: Scalars["ID"]["input"]
}>

export type OrdenQuery = {
    __typename?: "Query"
    orden: {
        __typename?: "Orden"
        orden: string
        orden_id: string
        estado_pago: EstadoPagoOrdenes
        estado_orden?: EstadosOrdenHistorial | null
        origen_orden?: string | null
        fecha_registro: any
        fecha_modificacion?: any | null
        total_con_iva: number
        total_sin_iva: number
        colaborador_id?: string | null
        renta_id?: string | null
        corte_id?: string | null
        turno_id?: string | null
        consumo_interno_colaborador_id?: string | null
        easyrewards_id?: string | null
        pago_id?: string | null
        usuario_id: string
        turno?: { __typename?: "Turno"; nombre: string } | null
        colaborador_consumo_interno?: { __typename?: "Colaborador"; nombre: string; apellido_paterno: string } | null
        colaborador_entrega?: {
            __typename?: "Colaborador"
            nombre: string
            apellido_materno: string
            apellido_paterno: string
        } | null
        renta?: {
            __typename?: "Renta"
            habitacion_id: string
            habitacion?: {
                __typename?: "Habitacion"
                numero_habitacion: string
                tipo_habitacion_id: string
                tipo_habitacion?: { __typename?: "TipoHabitacion"; nombre: string } | null
            } | null
        } | null
        detalles_orden?: Array<{
            __typename?: "DetalleOrden"
            detalle_orden_id: string
            estado: EstadosDetalleOrden
            motivo_cancelacion?: string | null
            fecha_cancelacion?: any | null
            reembolso?: boolean | null
            comentarios?: string | null
            almacen_articulo_id: string
            cantidad: number
            costo_con_iva: number
            monto_iva: number
            almacen_articulo?: {
                __typename?: "AlmacenArticulo"
                precio: number
                articulo_id: string
                almacen_articulo_id: string
                articulo?: {
                    __typename?: "Articulo"
                    articulo_id: string
                    nombre: string
                    contenido: number
                    unidad: UnidadMedidasArticulo
                    descripcion?: string | null
                    tipo: TipoArticulo
                    extra: boolean
                    categoria_id?: string | null
                    categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                } | null
            } | null
            extras?: Array<{
                __typename?: "ExtraDetalleOrden"
                extra_detalle_orden_id: string
                detalle_orden_id: string
                almacen_articulo_id: string
                costo_con_iva: number
                monto_iva: number
                cantidad: number
                almacen_articulo?: {
                    __typename?: "AlmacenArticulo"
                    almacen_articulo_id: string
                    articulo_id: string
                    precio: number
                    articulo?: {
                        __typename?: "Articulo"
                        nombre: string
                        contenido: number
                        unidad: UnidadMedidasArticulo
                        descripcion?: string | null
                        categoria_id?: string | null
                        tipo: TipoArticulo
                        extra: boolean
                        categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                    } | null
                } | null
            }> | null
        }> | null
        pagos: Array<{
            __typename?: "Pago"
            pago_id: string
            fecha_pago: any
            total: number
            ticket_id?: string | null
            detalles_pago?: Array<{
                __typename?: "DetallePago"
                detalle_pago_id: string
                pago_id: string
                ultimos_digitos?: string | null
                subtotal: number
                tipo_pago: TiposPagos
                numero_referencia?: string | null
                easyrewards_id?: string | null
            }> | null
        }>
        propina?: {
            __typename?: "Propina"
            total: number
            propina_id: string
            detalles_pago: Array<{
                __typename?: "DetallesPagoPartialInfoOutput"
                numero_referencia?: string | null
                ultimos_digitos?: string | null
                tipo_pago: TiposPagos
                subtotal: number
            }>
        } | null
        usuario: {
            __typename?: "Usuario"
            nombre: string
            apellido_materno?: string | null
            apellido_paterno?: string | null
        }
        mesa?: {
            __typename?: "Mesa"
            mesa_id: string
            numero_mesa: string
            asignacion_actual?: {
                __typename?: "MesaAsignada"
                mesa_asignada_id: string
                orden_id?: string | null
                colaborador_asignado_id: string
                fecha_cuenta_cerrada?: any | null
            } | null
        } | null
        comandas?: Array<{
            __typename?: "Comanda"
            comanda_id: string
            estado_comanda?: EstadosComandaHistorial | null
            orden_id: string
            folio: number
            total_comanda: number
            detalles_orden?: Array<{
                __typename?: "DetalleOrden"
                detalle_orden_id: string
                comanda_id?: string | null
                cantidad: number
                estado: EstadosDetalleOrden
                costo_con_iva: number
                monto_iva: number
                almacen_articulo_id: string
                almacen_articulo?: {
                    __typename?: "AlmacenArticulo"
                    almacen_articulo_id: string
                    precio: number
                    articulo_id: string
                    articulo?: {
                        __typename?: "Articulo"
                        articulo_id: string
                        nombre: string
                        contenido: number
                        unidad: UnidadMedidasArticulo
                        descripcion?: string | null
                        tipo: TipoArticulo
                        extra: boolean
                        categoria_id?: string | null
                        categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                    } | null
                } | null
                extras?: Array<{
                    __typename?: "ExtraDetalleOrden"
                    extra_detalle_orden_id: string
                    detalle_orden_id: string
                    almacen_articulo_id: string
                    costo_con_iva: number
                    monto_iva: number
                    cantidad: number
                    almacen_articulo?: {
                        __typename?: "AlmacenArticulo"
                        almacen_articulo_id: string
                        articulo_id: string
                        precio: number
                        articulo?: {
                            __typename?: "Articulo"
                            nombre: string
                            contenido: number
                            unidad: UnidadMedidasArticulo
                            descripcion?: string | null
                            categoria_id?: string | null
                            tipo: TipoArticulo
                            extra: boolean
                            categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                        } | null
                    } | null
                }> | null
            }> | null
        }> | null
    }
}

export type OrdenesPaginadasQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    fecha_registro?: InputMaybe<DateSearchInput>
    pagination_options?: InputMaybe<PageOptionsArgs>
    estado?: InputMaybe<Array<EstadosOrdenHistorial> | EstadosOrdenHistorial>
    estado_pago?: InputMaybe<Array<EstadoPagoOrdenes> | EstadoPagoOrdenes>
    origen?: InputMaybe<Array<OrigenesOrden> | OrigenesOrden>
    turno_id?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>
    metodo_pago?: InputMaybe<Array<TiposPagos> | TiposPagos>
    orden?: InputMaybe<Scalars["String"]["input"]>
}>

export type OrdenesPaginadasQuery = {
    __typename?: "Query"
    ordenes_paginadas: {
        __typename?: "PaginatedSearchOrdenesOutput"
        paginacion: {
            __typename?: "DatosPaginationOutput"
            pagina_actual: number
            total_paginas: number
            total_registros: number
        }
        conteos: {
            __typename?: "ConteosOrdenesDetailsOutput"
            total?: number | null
            room_service?: number | null
            mostrador?: number | null
            restaurante?: number | null
        }
        ordenes: Array<{
            __typename?: "Orden"
            orden: string
            orden_id: string
            estado_pago: EstadoPagoOrdenes
            estado_orden?: EstadosOrdenHistorial | null
            origen_orden?: string | null
            fecha_registro: any
            fecha_modificacion?: any | null
            total_con_iva: number
            total_sin_iva: number
            colaborador_id?: string | null
            renta_id?: string | null
            turno_id?: string | null
            consumo_interno_colaborador_id?: string | null
            usuario_id: string
            easyrewards_id?: string | null
            pago_id?: string | null
            turno?: { __typename?: "Turno"; nombre: string } | null
            colaborador_entrega?: {
                __typename?: "Colaborador"
                nombre: string
                apellido_materno: string
                apellido_paterno: string
            } | null
            usuario: { __typename?: "Usuario"; nombre: string }
            renta?: {
                __typename?: "Renta"
                habitacion_id: string
                habitacion?: {
                    __typename?: "Habitacion"
                    numero_habitacion: string
                    tipo_habitacion_id: string
                    tipo_habitacion?: { __typename?: "TipoHabitacion"; nombre: string } | null
                } | null
            } | null
            detalles_orden?: Array<{
                __typename?: "DetalleOrden"
                detalle_orden_id: string
                estado: EstadosDetalleOrden
                motivo_cancelacion?: string | null
                fecha_cancelacion?: any | null
                reembolso?: boolean | null
                comentarios?: string | null
                almacen_articulo_id: string
                cantidad: number
                costo_con_iva: number
                monto_iva: number
                almacen_articulo?: {
                    __typename?: "AlmacenArticulo"
                    precio: number
                    articulo_id: string
                    articulo?: {
                        __typename?: "Articulo"
                        articulo_id: string
                        nombre: string
                        contenido: number
                        unidad: UnidadMedidasArticulo
                        descripcion?: string | null
                        tipo: TipoArticulo
                        extra: boolean
                        categoria_id?: string | null
                        categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                    } | null
                } | null
                extras?: Array<{
                    __typename?: "ExtraDetalleOrden"
                    extra_detalle_orden_id: string
                    detalle_orden_id: string
                    almacen_articulo_id: string
                    costo_con_iva: number
                    monto_iva: number
                    cantidad: number
                    almacen_articulo?: {
                        __typename?: "AlmacenArticulo"
                        almacen_articulo_id: string
                        articulo_id: string
                        precio: number
                        articulo?: {
                            __typename?: "Articulo"
                            nombre: string
                            contenido: number
                            unidad: UnidadMedidasArticulo
                            descripcion?: string | null
                            categoria_id?: string | null
                            tipo: TipoArticulo
                            extra: boolean
                            categoria_articulo?: { __typename?: "CategoriaArticulo"; nombre: string } | null
                        } | null
                    } | null
                }> | null
            }> | null
            pagos: Array<{
                __typename?: "Pago"
                pago_id: string
                fecha_pago: any
                total: number
                ticket_id?: string | null
                detalles_pago?: Array<{
                    __typename?: "DetallePago"
                    detalle_pago_id: string
                    pago_id: string
                    ultimos_digitos?: string | null
                    subtotal: number
                    tipo_pago: TiposPagos
                    numero_referencia?: string | null
                    easyrewards_id?: string | null
                }> | null
            }>
            propina?: {
                __typename?: "Propina"
                total: number
                propina_id: string
                detalles_pago: Array<{
                    __typename?: "DetallesPagoPartialInfoOutput"
                    numero_referencia?: string | null
                    ultimos_digitos?: string | null
                    tipo_pago: TiposPagos
                    subtotal: number
                }>
            } | null
            mesa?: { __typename?: "Mesa"; numero_mesa: string } | null
        }>
    }
}

export type GetRentaForPagosPendientesQueryVariables = Exact<{
    renta_id: Scalars["ID"]["input"]
}>

export type GetRentaForPagosPendientesQuery = {
    __typename?: "Query"
    renta: {
        __typename?: "Renta"
        renta_id: string
        usuario_id: string
        estado: EstadosRentas
        saldo_pendiente_estancia: number
        saldo_pendiente_ordenes: number
        habitacion_id: string
        easyrewards_id?: string | null
        tarifa_id: string
        conceptos_pendientes?: {
            __typename?: "GetConceptosPendientesRentaOutput"
            estancia_pendiente?: {
                __typename?: "EstanciaPendienteRentaDetailOutput"
                usuario_id?: string | null
                folio: string
                detalle: string
                precio: number
                cantidad: number
                iva: number
                total: number
                easyrewards_id?: string | null
                extras_checkin: Array<{
                    __typename?: "ExtraPendienteRentaDetailOutput"
                    extra_id: string
                    detalle: string
                    precio: number
                    cantidad: number
                    iva: number
                    total: number
                }>
                colaborador?: { __typename?: "Colaborador"; colaborador_id: string; nombre: string } | null
            } | null
            extras_pendientes: Array<{
                __typename?: "VentaExtraRentaDetailOutput"
                venta_id: string
                usuario_id?: string | null
                folio: string
                conceptos: Array<{
                    __typename?: "ExtraPendienteRentaDetailOutput"
                    extra_id: string
                    detalle: string
                    precio: number
                    cantidad: number
                    iva: number
                    total: number
                }>
                colaborador?: { __typename?: "Colaborador"; colaborador_id: string; nombre: string } | null
            }>
        } | null
        habitacion?: {
            __typename?: "Habitacion"
            numero_habitacion: string
            tipo_habitacion_id: string
            tipo_habitacion?: { __typename?: "TipoHabitacion"; nombre: string } | null
        } | null
        tarifa?: { __typename?: "Tarifa"; costo_early_checkin: number } | null
    }
}

export type GetOrdenesPagosPendientesQueryVariables = Exact<{
    renta_id?: InputMaybe<Scalars["ID"]["input"]>
    orden_id?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>
    estado_pago?: InputMaybe<Array<EstadoPagoOrdenes> | EstadoPagoOrdenes>
}>

export type GetOrdenesPagosPendientesQuery = {
    __typename?: "Query"
    ordenes: Array<{
        __typename: "Orden"
        orden_id: string
        orden: string
        total_con_iva: number
        saldo_pendiente?: number | null
        estado_pago: EstadoPagoOrdenes
        estado_orden?: EstadosOrdenHistorial | null
        usuario_id: string
        colaborador_id?: string | null
        easyrewards_id?: string | null
        colaborador_entrega?: {
            __typename: "Colaborador"
            colaborador_id: string
            nombre: string
            apellido_materno: string
            apellido_paterno: string
        } | null
        detalles_orden?: Array<{
            __typename: "DetalleOrden"
            detalle_orden_id: string
            estado: EstadosDetalleOrden
            almacen_articulo_id: string
            cantidad: number
            costo_con_iva: number
            monto_iva: number
            almacen_articulo?: {
                __typename: "AlmacenArticulo"
                almacen_articulo_id: string
                articulo_id: string
                articulo?: {
                    __typename: "Articulo"
                    nombre: string
                    contenido: number
                    unidad: UnidadMedidasArticulo
                    descripcion?: string | null
                    tipo: TipoArticulo
                    extra: boolean
                    categoria_id?: string | null
                    categoria_articulo?: { __typename: "CategoriaArticulo"; nombre: string } | null
                } | null
            } | null
            extras?: Array<{
                __typename: "ExtraDetalleOrden"
                extra_detalle_orden_id: string
                detalle_orden_id: string
                almacen_articulo_id: string
                costo_con_iva: number
                monto_iva: number
                cantidad: number
                almacen_articulo?: {
                    __typename: "AlmacenArticulo"
                    almacen_articulo_id: string
                    articulo_id: string
                    articulo?: {
                        __typename: "Articulo"
                        nombre: string
                        contenido: number
                        unidad: UnidadMedidasArticulo
                        descripcion?: string | null
                        categoria_id?: string | null
                        categoria_articulo?: { __typename: "CategoriaArticulo"; nombre: string } | null
                    } | null
                } | null
            }> | null
        }> | null
        detalle_pago_pre_cargado?: Array<{
            __typename?: "DetallePagoPreCargadoOutput"
            subtotal: number
            tipo_pago: TiposPagos
            ultimos_digitos?: string | null
            numero_referencia?: string | null
        }> | null
    }>
}

export type PagarOrdenesMutationVariables = Exact<{
    pay_orden_input: PayRentaInput
}>

export type PagarOrdenesMutation = { __typename?: "Mutation"; pagar_ordenes_pendientes: Array<string> }

export type GetCategoriasRsQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
}>

export type GetCategoriasRsQuery = {
    __typename?: "Query"
    categorias_articulos: Array<{ __typename?: "CategoriaArticulo"; categoria_id: string; nombre: string }>
}

export type GetArticulosRoomServiceQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    pagination_options: PageOptionsArgs
    filter_in_categories?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>
    nombre_articulo?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetArticulosRoomServiceQuery = {
    __typename?: "Query"
    almacenes_articulos: {
        __typename?: "SearchAlmacenesArticulosOutput"
        paginacion: { __typename?: "DatosPaginationOutput"; pagina_actual: number; total_paginas: number }
        almacenes_articulos: Array<{
            __typename?: "AlmacenArticulo"
            costo: number
            almacen_articulo_id: string
            almacen_id: string
            articulo_id: string
            precio: number
            estado: EstadosAlmacenesArticulos
            cantidad: number
            categoria_id?: string | null
            categoria_articulo?: { __typename?: "CategoriaArticulo"; categoria_id: string; nombre: string } | null
            almacen?: { __typename?: "Almacen"; almacen_id: string; nombre: string } | null
            articulo?: {
                __typename?: "Articulo"
                articulo_id: string
                cantidad_minima?: number | null
                categoria_id?: string | null
                contenido: number
                descripcion?: string | null
                tipo: TipoArticulo
                extra: boolean
                foto?: string | null
                fecha_registro: any
                marca?: string | null
                nombre: string
                unidad: UnidadMedidasArticulo
                sku?: string | null
                ingredientes_recetas?: Array<{
                    __typename?: "IngredienteReceta"
                    almacen_articulo_id: string
                    articulo?: { __typename?: "Articulo"; nombre: string } | null
                    almacen_articulo?: { __typename?: "AlmacenArticulo"; estado: EstadosAlmacenesArticulos } | null
                }> | null
                categoria_articulo?: { __typename?: "CategoriaArticulo"; categoria_id: string; nombre: string } | null
            } | null
        }>
    }
}

export type CreateRentaMutationVariables = Exact<{
    datos_renta: CreateRentaInput
}>

export type CreateRentaMutation = {
    __typename?: "Mutation"
    crear_renta: {
        __typename?: "CreateRentaResponse"
        renta: {
            __typename?: "Renta"
            renta_id: string
            folio: number
            horas_extra?: number | null
            fecha_fin: any
            fecha_registro: any
            fecha_salida?: any | null
            numero_personas: number
            saldo?: number | null
        }
        ticket: { __typename?: "ReturnIdTicketResponse"; ticket_id: Array<string> }
    }
}

export type CheckInMutationVariables = Exact<{
    datos_checkIn: CheckInInput
}>

export type CheckInMutation = { __typename?: "Mutation"; checkIn: Array<string> }

export type TarifasQueryVariables = Exact<{
    tipo_habitacion_id: Scalars["ID"]["input"]
    hotel_id: Scalars["ID"]["input"]
}>

export type TarifasQuery = {
    __typename?: "Query"
    tarifas: Array<{
        __typename?: "Tarifa"
        tarifa_id: string
        nombre: string
        eliminado: boolean
        estatus: EstatusTarifa
        duracion_renta: number
        costo_habitacion: number
        costo_persona_extra: number
        costo_early_checkin: number
        costo_hospedaje_extra: number
        costo_hora_extra: number
        personas_extra_max?: number | null
        tipo_habitacion_id: string
        horas_extra_max?: number | null
        hora_checkin: string
        hora_checkout: string
        tipo_alojamiento: TiposAlojamientos
        tipo_tarifa: TipoTarifa
        fecha_final: any
        fecha_inicio: any
        hora_final: string
        hora_inicio: string
        dias_disponibles: Array<DiasDisponibles>
    }>
}

export type GetVehiculoDataQueryVariables = Exact<{
    placaInput: GetVehiculoDataByPlacaInput
}>

export type GetVehiculoDataQuery = {
    __typename?: "Query"
    getVehiculoDataByPlaca?: {
        __typename?: "GetVehiculoDataByPlacaOutput"
        vehiculo?: {
            __typename?: "Data_Vehiculo"
            matricula: string
            marca: string
            modelo: string
            color: string
        } | null
    } | null
}

export type PlacasPendientesQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    matricula: Scalars["String"]["input"]
    limite?: InputMaybe<Scalars["Int"]["input"]>
}>

export type PlacasPendientesQuery = {
    __typename?: "Query"
    placas_pendientes: Array<{
        __typename?: "HistorialVehiculo"
        historial_vehiculo_id: string
        vehiculo_id: string
        vehiculo: {
            __typename?: "Vehiculo"
            data: { __typename?: "Data_Vehiculo"; matricula: string; marca: string; color: string; modelo: string }
        }
    }>
}

export type GetArticulosSearchTableQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    pagination_options: PageOptionsArgs
    nameFilter: Scalars["String"]["input"]
}>

export type GetArticulosSearchTableQuery = {
    __typename?: "Query"
    almacenes_articulos: {
        __typename?: "SearchAlmacenesArticulosOutput"
        paginacion: { __typename?: "DatosPaginationOutput"; pagina_actual: number; total_paginas: number }
        almacenes_articulos: Array<{
            __typename?: "AlmacenArticulo"
            costo: number
            almacen_articulo_id: string
            almacen_id: string
            articulo_id: string
            precio: number
            estado: EstadosAlmacenesArticulos
            cantidad: number
            eliminado: boolean
            fecha_movimiento: any
            hotel_id?: string | null
            almacen?: { __typename?: "Almacen"; almacen_id: string; nombre: string } | null
            articulo?: {
                __typename?: "Articulo"
                articulo_id: string
                cantidad_minima?: number | null
                categoria_id?: string | null
                contenido: number
                descripcion?: string | null
                eliminado: boolean
                estado: EstadosArticulo
                extra: boolean
                fecha_eliminado?: any | null
                fecha_registro: any
                folio?: string | null
                folio_articulo?: string | null
                foto?: string | null
                marca?: string | null
                nombre: string
                sku?: string | null
                stock?: number | null
                tipo: TipoArticulo
                unidad: UnidadMedidasArticulo
                categoria_articulo?: { __typename?: "CategoriaArticulo"; categoria_id: string; nombre: string } | null
                almacenes_articulos: Array<{
                    __typename?: "AlmacenArticulo"
                    almacen_articulo_id: string
                    almacen_id: string
                    cantidad: number
                }>
            } | null
            ultimo_surtido?: {
                __typename?: "Surtido"
                almacen_articulo_id: string
                cantidad: number
                colaborador_id: string
                comentario?: string | null
                costo_total: number
                costo_unitario: number
                fecha_ingreso: any
                folio: number
                hotel_id: string
                numero_orden_factura?: string | null
                surtido_id: string
                tipo: TiposSurtido
            } | null
        }>
    }
}

export type GetTurnosAtencionQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    estado?: InputMaybe<Array<EstadosTurnosAtencion> | EstadosTurnosAtencion>
}>

export type GetTurnosAtencionQuery = {
    __typename?: "Query"
    turnos_atencion: Array<{
        __typename?: "TurnoAtencion"
        turno_atencion_id: string
        usuario_id: string
        fecha_registro: any
        folio: number
        nombre_o_matricula?: string | null
        folio_turno?: string | null
        tipo_habitacion_id: string
        tipo_habitacion?: { __typename?: "TipoHabitacion"; tipo_habitacion_id: string; nombre: string } | null
        colaborador?: { __typename?: "Colaborador"; nombre: string } | null
    }>
}

export type CrearTurnoAtencionMutationVariables = Exact<{
    input: CreateTurnoAtencionInput
}>

export type CrearTurnoAtencionMutation = {
    __typename?: "Mutation"
    crear_turno_atencion: { __typename?: "TurnoAtencion"; turno_atencion_id: string; folio_turno?: string | null }
}

export type EliminarTurnoAtencionMutationVariables = Exact<{
    input: DeleteTurnoAtencionInput
}>

export type EliminarTurnoAtencionMutation = { __typename?: "Mutation"; eliminar_turno_atencion: string }

export type ActualizarTurnoAtencionMutationVariables = Exact<{
    input: UpdateTurnoAtencionInput
}>

export type ActualizarTurnoAtencionMutation = {
    __typename?: "Mutation"
    actualizar_turno_atencion: {
        __typename?: "TurnoAtencion"
        turno_atencion_id: string
        folio_turno?: string | null
        estado: EstadosTurnosAtencion
    }
}

export type Auth_UserMutationVariables = Exact<{
    codigo?: InputMaybe<Scalars["String"]["input"]>
    template_sample?: InputMaybe<Scalars["String"]["input"]>
}>

export type Auth_UserMutation = {
    __typename?: "Mutation"
    validar_codigo_huella_autorizacion: {
        __typename?: "ValidarCodigoAutorizacionOutput"
        usuario_autorizado: boolean
        usuario?: {
            __typename?: "Usuario"
            apellido_materno?: string | null
            apellido_paterno?: string | null
            fecha_registro: any
            nombre: string
            origen?: Origen | null
            pais: string
            puesto_rol?: PuestoRol | null
            telefono?: string | null
            tiene_huella?: boolean | null
            usuario?: string | null
            usuario_id: string
            verificado: boolean
            roles?: Array<{ __typename: "Rol"; nombre: string }> | null
        } | null
    }
}

export type GetColaboradoresForPropinaDropQueryVariables = Exact<{
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
}>

export type GetColaboradoresForPropinaDropQuery = {
    __typename?: "Query"
    hotel_colaboradores?: Array<{
        __typename?: "HotelColaborador"
        colaborador_id: string
        colaborador: {
            __typename?: "Colaborador"
            colaborador_id: string
            nombre: string
            apellido_paterno: string
            apellido_materno: string
            area?: { __typename?: "Area"; area_id: string; nombre: string } | null
        }
    }> | null
}

export type GetAlmacenesArticulosSuggetionsQueryVariables = Exact<{
    hotel_id?: InputMaybe<Scalars["ID"]["input"]>
    pagination_options: PageOptionsArgs
    nameFilter: Scalars["String"]["input"]
    filter_tipo_articulo?: InputMaybe<Array<TipoArticulo> | TipoArticulo>
}>

export type GetAlmacenesArticulosSuggetionsQuery = {
    __typename?: "Query"
    almacenes_articulos: {
        __typename?: "SearchAlmacenesArticulosOutput"
        almacenes_articulos: Array<{
            __typename?: "AlmacenArticulo"
            almacen_articulo_id: string
            almacen_id: string
            articulo_id: string
            hotel_id?: string | null
            articulo?: { __typename?: "Articulo"; articulo_id: string; nombre: string } | null
        }>
    }
}

export type GetArticulosSearchRoomServiceQueryVariables = Exact<{
    hotel_id: Scalars["ID"]["input"]
    pagination_options: PageOptionsArgs
    nameFilter: Scalars["String"]["input"]
    filter_tipo_articulo: Array<TipoArticulo> | TipoArticulo
    filter_tipo_almacen?: InputMaybe<TipoAlmacen>
    filter_estado_articulo?: InputMaybe<EstadosArticulo>
}>

export type GetArticulosSearchRoomServiceQuery = {
    __typename?: "Query"
    almacenes_articulos: {
        __typename?: "SearchAlmacenesArticulosOutput"
        paginacion: { __typename?: "DatosPaginationOutput"; pagina_actual: number; total_paginas: number }
        almacenes_articulos: Array<{
            __typename?: "AlmacenArticulo"
            costo: number
            almacen_articulo_id: string
            almacen_id: string
            articulo_id: string
            precio: number
            estado: EstadosAlmacenesArticulos
            cantidad: number
            eliminado: boolean
            fecha_movimiento: any
            hotel_id?: string | null
            almacen?: { __typename?: "Almacen"; almacen_id: string; nombre: string } | null
            articulo?: {
                __typename?: "Articulo"
                articulo_id: string
                cantidad_minima?: number | null
                categoria_id?: string | null
                contenido: number
                descripcion?: string | null
                eliminado: boolean
                estado: EstadosArticulo
                extra: boolean
                fecha_eliminado?: any | null
                fecha_registro: any
                folio?: string | null
                folio_articulo?: string | null
                foto?: string | null
                marca?: string | null
                nombre: string
                sku?: string | null
                stock?: number | null
                tipo: TipoArticulo
                unidad: UnidadMedidasArticulo
                categoria_articulo?: { __typename?: "CategoriaArticulo"; categoria_id: string; nombre: string } | null
            } | null
            ultimo_surtido?: {
                __typename?: "Surtido"
                almacen_articulo_id: string
                cantidad: number
                colaborador_id: string
                comentario?: string | null
                costo_total: number
                costo_unitario: number
                fecha_ingreso: any
                folio: number
                hotel_id: string
                numero_orden_factura?: string | null
                surtido_id: string
                tipo: TiposSurtido
            } | null
        }>
    }
}

export type Obtener_VentasQueryVariables = Exact<{
    get_today_sales_input: GetTodaySalesInput
}>

export type Obtener_VentasQuery = {
    __typename?: "Query"
    obtener_ventas: Array<{
        __typename?: "SalesTicketsByTurno"
        nombre: string
        total_extras: number
        total_ordenes: number
        total_restaurante: number
        total_propinas: number
        total_rentas: number
        total_reservas: number
    }>
}

export type VentasHabitacionesPorTurnoQueryVariables = Exact<{
    sales_rooms_count_by_turnos_input: SalesRoomsCountByTurnosInput
}>

export type VentasHabitacionesPorTurnoQuery = {
    __typename?: "Query"
    ventas_habitaciones_por_turno: Array<{
        __typename?: "SalesRoomsCountByTurno"
        turno_id: string
        nombre: string
        count_rentas: number
        count_reservas: number
        accumulated_sale: string
        turno?: { __typename?: "Turno"; hora_entrada: string; hora_salida: string } | null
    }>
}

export const OrdenFieldsFragmentDoc = gql`
    fragment OrdenFields on Orden {
        comentario
        corte_id
        estado_orden
        usuario_id
        estado_pago
        fecha_cobro
        fecha_modificacion
        fecha_registro
        orden
        orden_id
        renta_id
        origen_orden
        virtual_comanda_id
        comanda {
            comanda_id
            estado_comanda
            folio
            fecha_modificacion
            fecha_registro
        }
        mesa {
            numero_mesa
        }
        renta {
            habitacion_id
            habitacion {
                habitacion_id
                numero_habitacion
                tipo_habitacion_id
                usuario_id
                tipo_habitacion {
                    nombre
                    tipo_habitacion_id
                }
            }
        }
    }
`
export const DetallesOrdenFieldsFragmentDoc = gql`
    fragment DetallesOrdenFields on DetalleOrden {
        almacen_articulo_id
        cantidad
        comanda_id
        comentarios
        detalle_orden_id
        estado
        orden_id
        almacen_articulo {
            almacen_articulo_id
            almacen_id
            articulo_id
            articulo {
                articulo_id
                nombre
                foto
                tipo
                categoria_articulo {
                    categoria_id
                    nombre
                }
            }
        }
        extras {
            almacen_articulo_id
            cantidad
            costo_con_iva
            costo_sin_iva
            detalle_orden_id
            extra_detalle_orden_id
            monto_iva
            almacen_articulo {
                almacen_articulo_id
                articulo_id
                articulo {
                    articulo_id
                    nombre
                }
            }
        }
    }
`
export const LoginGoogleDocument = gql`
    mutation loginGoogle($loginGoogleInput: LoginGoogleInput!) {
        login_google(loginGoogleInput: $loginGoogleInput) {
            token
            usuario_id
            ultimo_hotel_id
            expires_in
        }
    }
`
export type LoginGoogleMutationFn = Apollo.MutationFunction<LoginGoogleMutation, LoginGoogleMutationVariables>
export type LoginGoogleComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<LoginGoogleMutation, LoginGoogleMutationVariables>,
    "mutation"
>

export const LoginGoogleComponent = (props: LoginGoogleComponentProps) => (
    <ApolloReactComponents.Mutation<LoginGoogleMutation, LoginGoogleMutationVariables>
        mutation={LoginGoogleDocument}
        {...props}
    />
)

/**
 * __useLoginGoogleMutation__
 *
 * To run a mutation, you first call `useLoginGoogleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginGoogleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginGoogleMutation, { data, loading, error }] = useLoginGoogleMutation({
 *   variables: {
 *      loginGoogleInput: // value for 'loginGoogleInput'
 *   },
 * });
 */
export function useLoginGoogleMutation(
    baseOptions?: Apollo.MutationHookOptions<LoginGoogleMutation, LoginGoogleMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<LoginGoogleMutation, LoginGoogleMutationVariables>(LoginGoogleDocument, options)
}
export type LoginGoogleMutationHookResult = ReturnType<typeof useLoginGoogleMutation>
export type LoginGoogleMutationResult = Apollo.MutationResult<LoginGoogleMutation>
export type LoginGoogleMutationOptions = Apollo.BaseMutationOptions<LoginGoogleMutation, LoginGoogleMutationVariables>
export const CrearUsuarioDocument = gql`
    mutation CrearUsuario($createUsuarioInput: CreateUsuarioInput!) {
        crear_usuario(datos_usuario: $createUsuarioInput) {
            correo
            eliminado
            estatus
            fecha_registro
            nombre
            puesto_rol
        }
    }
`
export type CrearUsuarioMutationFn = Apollo.MutationFunction<CrearUsuarioMutation, CrearUsuarioMutationVariables>
export type CrearUsuarioComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CrearUsuarioMutation, CrearUsuarioMutationVariables>,
    "mutation"
>

export const CrearUsuarioComponent = (props: CrearUsuarioComponentProps) => (
    <ApolloReactComponents.Mutation<CrearUsuarioMutation, CrearUsuarioMutationVariables>
        mutation={CrearUsuarioDocument}
        {...props}
    />
)

/**
 * __useCrearUsuarioMutation__
 *
 * To run a mutation, you first call `useCrearUsuarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrearUsuarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crearUsuarioMutation, { data, loading, error }] = useCrearUsuarioMutation({
 *   variables: {
 *      createUsuarioInput: // value for 'createUsuarioInput'
 *   },
 * });
 */
export function useCrearUsuarioMutation(
    baseOptions?: Apollo.MutationHookOptions<CrearUsuarioMutation, CrearUsuarioMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CrearUsuarioMutation, CrearUsuarioMutationVariables>(CrearUsuarioDocument, options)
}
export type CrearUsuarioMutationHookResult = ReturnType<typeof useCrearUsuarioMutation>
export type CrearUsuarioMutationResult = Apollo.MutationResult<CrearUsuarioMutation>
export type CrearUsuarioMutationOptions = Apollo.BaseMutationOptions<
    CrearUsuarioMutation,
    CrearUsuarioMutationVariables
>
export const Obtener_Usuario_GoogleDocument = gql`
    mutation Obtener_usuario_google($getGoogleUserInput: GetGoogleUserInput!) {
        obtener_usuario_google(getGoogleUserInput: $getGoogleUserInput) {
            email
            family_name
            given_name
            picture
        }
    }
`
export type Obtener_Usuario_GoogleMutationFn = Apollo.MutationFunction<
    Obtener_Usuario_GoogleMutation,
    Obtener_Usuario_GoogleMutationVariables
>
export type Obtener_Usuario_GoogleComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        Obtener_Usuario_GoogleMutation,
        Obtener_Usuario_GoogleMutationVariables
    >,
    "mutation"
>

export const Obtener_Usuario_GoogleComponent = (props: Obtener_Usuario_GoogleComponentProps) => (
    <ApolloReactComponents.Mutation<Obtener_Usuario_GoogleMutation, Obtener_Usuario_GoogleMutationVariables>
        mutation={Obtener_Usuario_GoogleDocument}
        {...props}
    />
)

/**
 * __useObtener_Usuario_GoogleMutation__
 *
 * To run a mutation, you first call `useObtener_Usuario_GoogleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useObtener_Usuario_GoogleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [obtenerUsuarioGoogleMutation, { data, loading, error }] = useObtener_Usuario_GoogleMutation({
 *   variables: {
 *      getGoogleUserInput: // value for 'getGoogleUserInput'
 *   },
 * });
 */
export function useObtener_Usuario_GoogleMutation(
    baseOptions?: Apollo.MutationHookOptions<Obtener_Usuario_GoogleMutation, Obtener_Usuario_GoogleMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<Obtener_Usuario_GoogleMutation, Obtener_Usuario_GoogleMutationVariables>(
        Obtener_Usuario_GoogleDocument,
        options
    )
}
export type Obtener_Usuario_GoogleMutationHookResult = ReturnType<typeof useObtener_Usuario_GoogleMutation>
export type Obtener_Usuario_GoogleMutationResult = Apollo.MutationResult<Obtener_Usuario_GoogleMutation>
export type Obtener_Usuario_GoogleMutationOptions = Apollo.BaseMutationOptions<
    Obtener_Usuario_GoogleMutation,
    Obtener_Usuario_GoogleMutationVariables
>
export const ActualizarUsuarioDocument = gql`
    mutation ActualizarUsuario($updateUsuarioInput: UpdateUsuarioInput!) {
        actualizar_usuario(datos_usuario: $updateUsuarioInput) {
            verificado
        }
    }
`
export type ActualizarUsuarioMutationFn = Apollo.MutationFunction<
    ActualizarUsuarioMutation,
    ActualizarUsuarioMutationVariables
>
export type ActualizarUsuarioComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<ActualizarUsuarioMutation, ActualizarUsuarioMutationVariables>,
    "mutation"
>

export const ActualizarUsuarioComponent = (props: ActualizarUsuarioComponentProps) => (
    <ApolloReactComponents.Mutation<ActualizarUsuarioMutation, ActualizarUsuarioMutationVariables>
        mutation={ActualizarUsuarioDocument}
        {...props}
    />
)

/**
 * __useActualizarUsuarioMutation__
 *
 * To run a mutation, you first call `useActualizarUsuarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizarUsuarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizarUsuarioMutation, { data, loading, error }] = useActualizarUsuarioMutation({
 *   variables: {
 *      updateUsuarioInput: // value for 'updateUsuarioInput'
 *   },
 * });
 */
export function useActualizarUsuarioMutation(
    baseOptions?: Apollo.MutationHookOptions<ActualizarUsuarioMutation, ActualizarUsuarioMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ActualizarUsuarioMutation, ActualizarUsuarioMutationVariables>(
        ActualizarUsuarioDocument,
        options
    )
}
export type ActualizarUsuarioMutationHookResult = ReturnType<typeof useActualizarUsuarioMutation>
export type ActualizarUsuarioMutationResult = Apollo.MutationResult<ActualizarUsuarioMutation>
export type ActualizarUsuarioMutationOptions = Apollo.BaseMutationOptions<
    ActualizarUsuarioMutation,
    ActualizarUsuarioMutationVariables
>
export const Validar_Codigo_AutorizacionDocument = gql`
    mutation Validar_codigo_autorizacion($codigo: String, $huella: String) {
        validar_codigo_huella_autorizacion(codigo: $codigo, huella: $huella) {
            usuario {
                usuario_id
                roles {
                    nombre
                    __typename
                }
            }
            usuario_autorizado
        }
    }
`
export type Validar_Codigo_AutorizacionMutationFn = Apollo.MutationFunction<
    Validar_Codigo_AutorizacionMutation,
    Validar_Codigo_AutorizacionMutationVariables
>
export type Validar_Codigo_AutorizacionComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        Validar_Codigo_AutorizacionMutation,
        Validar_Codigo_AutorizacionMutationVariables
    >,
    "mutation"
>

export const Validar_Codigo_AutorizacionComponent = (props: Validar_Codigo_AutorizacionComponentProps) => (
    <ApolloReactComponents.Mutation<Validar_Codigo_AutorizacionMutation, Validar_Codigo_AutorizacionMutationVariables>
        mutation={Validar_Codigo_AutorizacionDocument}
        {...props}
    />
)

/**
 * __useValidar_Codigo_AutorizacionMutation__
 *
 * To run a mutation, you first call `useValidar_Codigo_AutorizacionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidar_Codigo_AutorizacionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validarCodigoAutorizacionMutation, { data, loading, error }] = useValidar_Codigo_AutorizacionMutation({
 *   variables: {
 *      codigo: // value for 'codigo'
 *      huella: // value for 'huella'
 *   },
 * });
 */
export function useValidar_Codigo_AutorizacionMutation(
    baseOptions?: Apollo.MutationHookOptions<
        Validar_Codigo_AutorizacionMutation,
        Validar_Codigo_AutorizacionMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<Validar_Codigo_AutorizacionMutation, Validar_Codigo_AutorizacionMutationVariables>(
        Validar_Codigo_AutorizacionDocument,
        options
    )
}
export type Validar_Codigo_AutorizacionMutationHookResult = ReturnType<typeof useValidar_Codigo_AutorizacionMutation>
export type Validar_Codigo_AutorizacionMutationResult = Apollo.MutationResult<Validar_Codigo_AutorizacionMutation>
export type Validar_Codigo_AutorizacionMutationOptions = Apollo.BaseMutationOptions<
    Validar_Codigo_AutorizacionMutation,
    Validar_Codigo_AutorizacionMutationVariables
>
export const AutenticarHuellaDocument = gql`
    mutation AutenticarHuella($input: AuthenticateCredencialInput!) {
        autenticar_huella(AuthenticateCredencialInput: $input) {
            usuario_id
        }
    }
`
export type AutenticarHuellaMutationFn = Apollo.MutationFunction<
    AutenticarHuellaMutation,
    AutenticarHuellaMutationVariables
>
export type AutenticarHuellaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<AutenticarHuellaMutation, AutenticarHuellaMutationVariables>,
    "mutation"
>

export const AutenticarHuellaComponent = (props: AutenticarHuellaComponentProps) => (
    <ApolloReactComponents.Mutation<AutenticarHuellaMutation, AutenticarHuellaMutationVariables>
        mutation={AutenticarHuellaDocument}
        {...props}
    />
)

/**
 * __useAutenticarHuellaMutation__
 *
 * To run a mutation, you first call `useAutenticarHuellaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutenticarHuellaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autenticarHuellaMutation, { data, loading, error }] = useAutenticarHuellaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAutenticarHuellaMutation(
    baseOptions?: Apollo.MutationHookOptions<AutenticarHuellaMutation, AutenticarHuellaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<AutenticarHuellaMutation, AutenticarHuellaMutationVariables>(
        AutenticarHuellaDocument,
        options
    )
}
export type AutenticarHuellaMutationHookResult = ReturnType<typeof useAutenticarHuellaMutation>
export type AutenticarHuellaMutationResult = Apollo.MutationResult<AutenticarHuellaMutation>
export type AutenticarHuellaMutationOptions = Apollo.BaseMutationOptions<
    AutenticarHuellaMutation,
    AutenticarHuellaMutationVariables
>
export const LogoutDocument = gql`
    mutation Logout($cerrar_turno: Boolean, $hotel_id: String!, $sesion_id: ID!) {
        logout(cerrar_turno: $cerrar_turno, hotel_id: $hotel_id, sesion_id: $sesion_id)
    }
`
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>
export type LogoutComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<LogoutMutation, LogoutMutationVariables>,
    "mutation"
>

export const LogoutComponent = (props: LogoutComponentProps) => (
    <ApolloReactComponents.Mutation<LogoutMutation, LogoutMutationVariables> mutation={LogoutDocument} {...props} />
)

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *      cerrar_turno: // value for 'cerrar_turno'
 *      hotel_id: // value for 'hotel_id'
 *      sesion_id: // value for 'sesion_id'
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options)
}
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>
export const LoginDocument = gql`
    mutation Login($loginInput: AuthLoginInput!) {
        login(loginInput: $loginInput) {
            token
            colaborador_activo
            usuario_id
            ultimo_hotel_id
            expires_in
        }
    }
`
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>
export type LoginComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<LoginMutation, LoginMutationVariables>,
    "mutation"
>

export const LoginComponent = (props: LoginComponentProps) => (
    <ApolloReactComponents.Mutation<LoginMutation, LoginMutationVariables> mutation={LoginDocument} {...props} />
)

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      loginInput: // value for 'loginInput'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options)
}
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>
export const RegistrarEventoLoginDocument = gql`
    mutation RegistrarEventoLogin($input: TraceStartHistorialLoginInput!) {
        registrar_evento_login(input: $input)
    }
`
export type RegistrarEventoLoginMutationFn = Apollo.MutationFunction<
    RegistrarEventoLoginMutation,
    RegistrarEventoLoginMutationVariables
>
export type RegistrarEventoLoginComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<RegistrarEventoLoginMutation, RegistrarEventoLoginMutationVariables>,
    "mutation"
>

export const RegistrarEventoLoginComponent = (props: RegistrarEventoLoginComponentProps) => (
    <ApolloReactComponents.Mutation<RegistrarEventoLoginMutation, RegistrarEventoLoginMutationVariables>
        mutation={RegistrarEventoLoginDocument}
        {...props}
    />
)

/**
 * __useRegistrarEventoLoginMutation__
 *
 * To run a mutation, you first call `useRegistrarEventoLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegistrarEventoLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registrarEventoLoginMutation, { data, loading, error }] = useRegistrarEventoLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegistrarEventoLoginMutation(
    baseOptions?: Apollo.MutationHookOptions<RegistrarEventoLoginMutation, RegistrarEventoLoginMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<RegistrarEventoLoginMutation, RegistrarEventoLoginMutationVariables>(
        RegistrarEventoLoginDocument,
        options
    )
}
export type RegistrarEventoLoginMutationHookResult = ReturnType<typeof useRegistrarEventoLoginMutation>
export type RegistrarEventoLoginMutationResult = Apollo.MutationResult<RegistrarEventoLoginMutation>
export type RegistrarEventoLoginMutationOptions = Apollo.BaseMutationOptions<
    RegistrarEventoLoginMutation,
    RegistrarEventoLoginMutationVariables
>
export const CambiarTareaDeHabitacionDocument = gql`
    mutation CambiarTareaDeHabitacion($datos_cambio: SwitchTaskRoomInput!) {
        cambiar_tarea_habitacion(switch_task_room_input: $datos_cambio)
    }
`
export type CambiarTareaDeHabitacionMutationFn = Apollo.MutationFunction<
    CambiarTareaDeHabitacionMutation,
    CambiarTareaDeHabitacionMutationVariables
>
export type CambiarTareaDeHabitacionComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        CambiarTareaDeHabitacionMutation,
        CambiarTareaDeHabitacionMutationVariables
    >,
    "mutation"
>

export const CambiarTareaDeHabitacionComponent = (props: CambiarTareaDeHabitacionComponentProps) => (
    <ApolloReactComponents.Mutation<CambiarTareaDeHabitacionMutation, CambiarTareaDeHabitacionMutationVariables>
        mutation={CambiarTareaDeHabitacionDocument}
        {...props}
    />
)

/**
 * __useCambiarTareaDeHabitacionMutation__
 *
 * To run a mutation, you first call `useCambiarTareaDeHabitacionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCambiarTareaDeHabitacionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cambiarTareaDeHabitacionMutation, { data, loading, error }] = useCambiarTareaDeHabitacionMutation({
 *   variables: {
 *      datos_cambio: // value for 'datos_cambio'
 *   },
 * });
 */
export function useCambiarTareaDeHabitacionMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CambiarTareaDeHabitacionMutation,
        CambiarTareaDeHabitacionMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CambiarTareaDeHabitacionMutation, CambiarTareaDeHabitacionMutationVariables>(
        CambiarTareaDeHabitacionDocument,
        options
    )
}
export type CambiarTareaDeHabitacionMutationHookResult = ReturnType<typeof useCambiarTareaDeHabitacionMutation>
export type CambiarTareaDeHabitacionMutationResult = Apollo.MutationResult<CambiarTareaDeHabitacionMutation>
export type CambiarTareaDeHabitacionMutationOptions = Apollo.BaseMutationOptions<
    CambiarTareaDeHabitacionMutation,
    CambiarTareaDeHabitacionMutationVariables
>
export const CambiarTareaConEstadoDocument = gql`
    mutation CambiarTareaConEstado($switch_task_with_room_state_input: SwitchTaskWithRoomStateInput!) {
        cambiar_tarea_con_estado(switch_task_with_room_state_input: $switch_task_with_room_state_input)
    }
`
export type CambiarTareaConEstadoMutationFn = Apollo.MutationFunction<
    CambiarTareaConEstadoMutation,
    CambiarTareaConEstadoMutationVariables
>
export type CambiarTareaConEstadoComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        CambiarTareaConEstadoMutation,
        CambiarTareaConEstadoMutationVariables
    >,
    "mutation"
>

export const CambiarTareaConEstadoComponent = (props: CambiarTareaConEstadoComponentProps) => (
    <ApolloReactComponents.Mutation<CambiarTareaConEstadoMutation, CambiarTareaConEstadoMutationVariables>
        mutation={CambiarTareaConEstadoDocument}
        {...props}
    />
)

/**
 * __useCambiarTareaConEstadoMutation__
 *
 * To run a mutation, you first call `useCambiarTareaConEstadoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCambiarTareaConEstadoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cambiarTareaConEstadoMutation, { data, loading, error }] = useCambiarTareaConEstadoMutation({
 *   variables: {
 *      switch_task_with_room_state_input: // value for 'switch_task_with_room_state_input'
 *   },
 * });
 */
export function useCambiarTareaConEstadoMutation(
    baseOptions?: Apollo.MutationHookOptions<CambiarTareaConEstadoMutation, CambiarTareaConEstadoMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CambiarTareaConEstadoMutation, CambiarTareaConEstadoMutationVariables>(
        CambiarTareaConEstadoDocument,
        options
    )
}
export type CambiarTareaConEstadoMutationHookResult = ReturnType<typeof useCambiarTareaConEstadoMutation>
export type CambiarTareaConEstadoMutationResult = Apollo.MutationResult<CambiarTareaConEstadoMutation>
export type CambiarTareaConEstadoMutationOptions = Apollo.BaseMutationOptions<
    CambiarTareaConEstadoMutation,
    CambiarTareaConEstadoMutationVariables
>
export const CambiarTareaEntreColaboradoresDocument = gql`
    mutation CambiarTareaEntreColaboradores($switch_task_btw_colab_input: SwitchTaskBtwColabInput!) {
        cambiar_tarea_entre_colaboradores(switch_task_btw_colab_input: $switch_task_btw_colab_input)
    }
`
export type CambiarTareaEntreColaboradoresMutationFn = Apollo.MutationFunction<
    CambiarTareaEntreColaboradoresMutation,
    CambiarTareaEntreColaboradoresMutationVariables
>
export type CambiarTareaEntreColaboradoresComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        CambiarTareaEntreColaboradoresMutation,
        CambiarTareaEntreColaboradoresMutationVariables
    >,
    "mutation"
>

export const CambiarTareaEntreColaboradoresComponent = (props: CambiarTareaEntreColaboradoresComponentProps) => (
    <ApolloReactComponents.Mutation<
        CambiarTareaEntreColaboradoresMutation,
        CambiarTareaEntreColaboradoresMutationVariables
    >
        mutation={CambiarTareaEntreColaboradoresDocument}
        {...props}
    />
)

/**
 * __useCambiarTareaEntreColaboradoresMutation__
 *
 * To run a mutation, you first call `useCambiarTareaEntreColaboradoresMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCambiarTareaEntreColaboradoresMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cambiarTareaEntreColaboradoresMutation, { data, loading, error }] = useCambiarTareaEntreColaboradoresMutation({
 *   variables: {
 *      switch_task_btw_colab_input: // value for 'switch_task_btw_colab_input'
 *   },
 * });
 */
export function useCambiarTareaEntreColaboradoresMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CambiarTareaEntreColaboradoresMutation,
        CambiarTareaEntreColaboradoresMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CambiarTareaEntreColaboradoresMutation, CambiarTareaEntreColaboradoresMutationVariables>(
        CambiarTareaEntreColaboradoresDocument,
        options
    )
}
export type CambiarTareaEntreColaboradoresMutationHookResult = ReturnType<
    typeof useCambiarTareaEntreColaboradoresMutation
>
export type CambiarTareaEntreColaboradoresMutationResult = Apollo.MutationResult<CambiarTareaEntreColaboradoresMutation>
export type CambiarTareaEntreColaboradoresMutationOptions = Apollo.BaseMutationOptions<
    CambiarTareaEntreColaboradoresMutation,
    CambiarTareaEntreColaboradoresMutationVariables
>
export const GetHotelStatusDocument = gql`
    query getHotelStatus($hotel_id: ID!) {
        hotel(hotel_id: $hotel_id) {
            hotel_id
            imas_transaccion_status
            suscripciones {
                suscripcion_id
                eliminado
                estatus
                modulos {
                    modulo_id
                    nombre_modulo
                }
            }
        }
    }
`
export type GetHotelStatusComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetHotelStatusQuery, GetHotelStatusQueryVariables>,
    "query"
> &
    ({ variables: GetHotelStatusQueryVariables; skip?: boolean } | { skip: boolean })

export const GetHotelStatusComponent = (props: GetHotelStatusComponentProps) => (
    <ApolloReactComponents.Query<GetHotelStatusQuery, GetHotelStatusQueryVariables>
        query={GetHotelStatusDocument}
        {...props}
    />
)

/**
 * __useGetHotelStatusQuery__
 *
 * To run a query within a React component, call `useGetHotelStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHotelStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHotelStatusQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetHotelStatusQuery(
    baseOptions: Apollo.QueryHookOptions<GetHotelStatusQuery, GetHotelStatusQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetHotelStatusQuery, GetHotelStatusQueryVariables>(GetHotelStatusDocument, options)
}
export function useGetHotelStatusLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetHotelStatusQuery, GetHotelStatusQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetHotelStatusQuery, GetHotelStatusQueryVariables>(GetHotelStatusDocument, options)
}
export type GetHotelStatusQueryHookResult = ReturnType<typeof useGetHotelStatusQuery>
export type GetHotelStatusLazyQueryHookResult = ReturnType<typeof useGetHotelStatusLazyQuery>
export type GetHotelStatusQueryResult = Apollo.QueryResult<GetHotelStatusQuery, GetHotelStatusQueryVariables>
export const CloseCorteAvailableDocument = gql`
    subscription closeCorteAvailable($hotel_id: ID!) {
        checkHotel(hotel_id_filter: $hotel_id) {
            imas_transaccion_status
        }
    }
`
export type CloseCorteAvailableComponentProps = Omit<
    ApolloReactComponents.SubscriptionComponentOptions<
        CloseCorteAvailableSubscription,
        CloseCorteAvailableSubscriptionVariables
    >,
    "subscription"
>

export const CloseCorteAvailableComponent = (props: CloseCorteAvailableComponentProps) => (
    <ApolloReactComponents.Subscription<CloseCorteAvailableSubscription, CloseCorteAvailableSubscriptionVariables>
        subscription={CloseCorteAvailableDocument}
        {...props}
    />
)

/**
 * __useCloseCorteAvailableSubscription__
 *
 * To run a query within a React component, call `useCloseCorteAvailableSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCloseCorteAvailableSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCloseCorteAvailableSubscription({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useCloseCorteAvailableSubscription(
    baseOptions: Apollo.SubscriptionHookOptions<
        CloseCorteAvailableSubscription,
        CloseCorteAvailableSubscriptionVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useSubscription<CloseCorteAvailableSubscription, CloseCorteAvailableSubscriptionVariables>(
        CloseCorteAvailableDocument,
        options
    )
}
export type CloseCorteAvailableSubscriptionHookResult = ReturnType<typeof useCloseCorteAvailableSubscription>
export type CloseCorteAvailableSubscriptionResult = Apollo.SubscriptionResult<CloseCorteAvailableSubscription>
export const ListenMyColaboradorDocument = gql`
    subscription ListenMyColaborador($colaborador_id: ID!) {
        checkColaborador(colaborador_id: $colaborador_id) {
            colaborador_id
            nombre
            en_turno
            estado
        }
    }
`
export type ListenMyColaboradorComponentProps = Omit<
    ApolloReactComponents.SubscriptionComponentOptions<
        ListenMyColaboradorSubscription,
        ListenMyColaboradorSubscriptionVariables
    >,
    "subscription"
>

export const ListenMyColaboradorComponent = (props: ListenMyColaboradorComponentProps) => (
    <ApolloReactComponents.Subscription<ListenMyColaboradorSubscription, ListenMyColaboradorSubscriptionVariables>
        subscription={ListenMyColaboradorDocument}
        {...props}
    />
)

/**
 * __useListenMyColaboradorSubscription__
 *
 * To run a query within a React component, call `useListenMyColaboradorSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenMyColaboradorSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenMyColaboradorSubscription({
 *   variables: {
 *      colaborador_id: // value for 'colaborador_id'
 *   },
 * });
 */
export function useListenMyColaboradorSubscription(
    baseOptions: Apollo.SubscriptionHookOptions<
        ListenMyColaboradorSubscription,
        ListenMyColaboradorSubscriptionVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useSubscription<ListenMyColaboradorSubscription, ListenMyColaboradorSubscriptionVariables>(
        ListenMyColaboradorDocument,
        options
    )
}
export type ListenMyColaboradorSubscriptionHookResult = ReturnType<typeof useListenMyColaboradorSubscription>
export type ListenMyColaboradorSubscriptionResult = Apollo.SubscriptionResult<ListenMyColaboradorSubscription>
export const GetTicketForCancelacionDocument = gql`
    query getTicketForCancelacion($ticket_id: ID!) {
        ticket(ticket_id: $ticket_id) {
            ticket_id
            data {
                renta_id
                origen_ticket {
                    id
                    origen
                    renta {
                        renta_id
                        estado
                        habitacion_id
                        habitacion {
                            habitacion_id
                            estado
                            ultima_renta {
                                renta_id
                            }
                        }
                    }
                }
            }
        }
    }
`
export type GetTicketForCancelacionComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetTicketForCancelacionQuery, GetTicketForCancelacionQueryVariables>,
    "query"
> &
    ({ variables: GetTicketForCancelacionQueryVariables; skip?: boolean } | { skip: boolean })

export const GetTicketForCancelacionComponent = (props: GetTicketForCancelacionComponentProps) => (
    <ApolloReactComponents.Query<GetTicketForCancelacionQuery, GetTicketForCancelacionQueryVariables>
        query={GetTicketForCancelacionDocument}
        {...props}
    />
)

/**
 * __useGetTicketForCancelacionQuery__
 *
 * To run a query within a React component, call `useGetTicketForCancelacionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketForCancelacionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketForCancelacionQuery({
 *   variables: {
 *      ticket_id: // value for 'ticket_id'
 *   },
 * });
 */
export function useGetTicketForCancelacionQuery(
    baseOptions: Apollo.QueryHookOptions<GetTicketForCancelacionQuery, GetTicketForCancelacionQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetTicketForCancelacionQuery, GetTicketForCancelacionQueryVariables>(
        GetTicketForCancelacionDocument,
        options
    )
}
export function useGetTicketForCancelacionLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetTicketForCancelacionQuery, GetTicketForCancelacionQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetTicketForCancelacionQuery, GetTicketForCancelacionQueryVariables>(
        GetTicketForCancelacionDocument,
        options
    )
}
export type GetTicketForCancelacionQueryHookResult = ReturnType<typeof useGetTicketForCancelacionQuery>
export type GetTicketForCancelacionLazyQueryHookResult = ReturnType<typeof useGetTicketForCancelacionLazyQuery>
export type GetTicketForCancelacionQueryResult = Apollo.QueryResult<
    GetTicketForCancelacionQuery,
    GetTicketForCancelacionQueryVariables
>
export const GetTransaccionesForCancelacionDocument = gql`
    query getTransaccionesForCancelacion($renta_id: ID!) {
        transacciones_renta(renta_id: $renta_id) {
            ordenes {
                ticket_id
                orden_id
                orden {
                    orden
                    orden_id
                    corte_id
                    total_con_iva
                    fecha_registro
                    detalles_orden {
                        detalle_orden_id
                        cantidad
                        almacen_articulo_id
                        almacen_articulo {
                            almacen_articulo_id
                            articulo_id
                            articulo {
                                articulo_id
                                nombre
                                categoria_id
                                categoria_articulo {
                                    categoria_id
                                    nombre
                                }
                            }
                        }
                        extras {
                            extra_detalle_orden_id
                            cantidad
                            almacen_articulo_id
                            almacen_articulo {
                                almacen_articulo_id
                                articulo_id
                                articulo {
                                    articulo_id
                                    nombre
                                    categoria_id
                                    categoria_articulo {
                                        categoria_id
                                        nombre
                                    }
                                }
                            }
                        }
                    }
                }
                ticket {
                    ticket_id
                    folio
                }
            }
            transacciones {
                ticket_id
                extras {
                    extra_id
                    tipo_extra
                    ticket_id
                }
            }
            transacciones_checkin {
                ticket_id
                extras {
                    extra_id
                    tipo_extra
                    ticket_id
                }
            }
        }
    }
`
export type GetTransaccionesForCancelacionComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetTransaccionesForCancelacionQuery,
        GetTransaccionesForCancelacionQueryVariables
    >,
    "query"
> &
    ({ variables: GetTransaccionesForCancelacionQueryVariables; skip?: boolean } | { skip: boolean })

export const GetTransaccionesForCancelacionComponent = (props: GetTransaccionesForCancelacionComponentProps) => (
    <ApolloReactComponents.Query<GetTransaccionesForCancelacionQuery, GetTransaccionesForCancelacionQueryVariables>
        query={GetTransaccionesForCancelacionDocument}
        {...props}
    />
)

/**
 * __useGetTransaccionesForCancelacionQuery__
 *
 * To run a query within a React component, call `useGetTransaccionesForCancelacionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransaccionesForCancelacionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransaccionesForCancelacionQuery({
 *   variables: {
 *      renta_id: // value for 'renta_id'
 *   },
 * });
 */
export function useGetTransaccionesForCancelacionQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetTransaccionesForCancelacionQuery,
        GetTransaccionesForCancelacionQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetTransaccionesForCancelacionQuery, GetTransaccionesForCancelacionQueryVariables>(
        GetTransaccionesForCancelacionDocument,
        options
    )
}
export function useGetTransaccionesForCancelacionLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetTransaccionesForCancelacionQuery,
        GetTransaccionesForCancelacionQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetTransaccionesForCancelacionQuery, GetTransaccionesForCancelacionQueryVariables>(
        GetTransaccionesForCancelacionDocument,
        options
    )
}
export type GetTransaccionesForCancelacionQueryHookResult = ReturnType<typeof useGetTransaccionesForCancelacionQuery>
export type GetTransaccionesForCancelacionLazyQueryHookResult = ReturnType<
    typeof useGetTransaccionesForCancelacionLazyQuery
>
export type GetTransaccionesForCancelacionQueryResult = Apollo.QueryResult<
    GetTransaccionesForCancelacionQuery,
    GetTransaccionesForCancelacionQueryVariables
>
export const GetDataTicketDocument = gql`
    query GetDataTicket($ticket_id: ID!) {
        ticket(ticket_id: $ticket_id) {
            ticket_id
            data {
                metodos_pago {
                    numero_referencia
                    tipo
                    total
                    ultimos_digitos
                }
                propinas {
                    numero_referencia
                    total
                    ultimos_digitos
                    tipo_pago
                }
            }
        }
    }
`
export type GetDataTicketComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetDataTicketQuery, GetDataTicketQueryVariables>,
    "query"
> &
    ({ variables: GetDataTicketQueryVariables; skip?: boolean } | { skip: boolean })

export const GetDataTicketComponent = (props: GetDataTicketComponentProps) => (
    <ApolloReactComponents.Query<GetDataTicketQuery, GetDataTicketQueryVariables>
        query={GetDataTicketDocument}
        {...props}
    />
)

/**
 * __useGetDataTicketQuery__
 *
 * To run a query within a React component, call `useGetDataTicketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataTicketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataTicketQuery({
 *   variables: {
 *      ticket_id: // value for 'ticket_id'
 *   },
 * });
 */
export function useGetDataTicketQuery(
    baseOptions: Apollo.QueryHookOptions<GetDataTicketQuery, GetDataTicketQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetDataTicketQuery, GetDataTicketQueryVariables>(GetDataTicketDocument, options)
}
export function useGetDataTicketLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetDataTicketQuery, GetDataTicketQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetDataTicketQuery, GetDataTicketQueryVariables>(GetDataTicketDocument, options)
}
export type GetDataTicketQueryHookResult = ReturnType<typeof useGetDataTicketQuery>
export type GetDataTicketLazyQueryHookResult = ReturnType<typeof useGetDataTicketLazyQuery>
export type GetDataTicketQueryResult = Apollo.QueryResult<GetDataTicketQuery, GetDataTicketQueryVariables>
export const AutorizarFajillaDocument = gql`
    mutation AutorizarFajilla($dataAutorizar: AutorizarFajillaInput!) {
        autorizar_fajilla(autorizar_fajilla_input: $dataAutorizar)
    }
`
export type AutorizarFajillaMutationFn = Apollo.MutationFunction<
    AutorizarFajillaMutation,
    AutorizarFajillaMutationVariables
>
export type AutorizarFajillaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<AutorizarFajillaMutation, AutorizarFajillaMutationVariables>,
    "mutation"
>

export const AutorizarFajillaComponent = (props: AutorizarFajillaComponentProps) => (
    <ApolloReactComponents.Mutation<AutorizarFajillaMutation, AutorizarFajillaMutationVariables>
        mutation={AutorizarFajillaDocument}
        {...props}
    />
)

/**
 * __useAutorizarFajillaMutation__
 *
 * To run a mutation, you first call `useAutorizarFajillaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutorizarFajillaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autorizarFajillaMutation, { data, loading, error }] = useAutorizarFajillaMutation({
 *   variables: {
 *      dataAutorizar: // value for 'dataAutorizar'
 *   },
 * });
 */
export function useAutorizarFajillaMutation(
    baseOptions?: Apollo.MutationHookOptions<AutorizarFajillaMutation, AutorizarFajillaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<AutorizarFajillaMutation, AutorizarFajillaMutationVariables>(
        AutorizarFajillaDocument,
        options
    )
}
export type AutorizarFajillaMutationHookResult = ReturnType<typeof useAutorizarFajillaMutation>
export type AutorizarFajillaMutationResult = Apollo.MutationResult<AutorizarFajillaMutation>
export type AutorizarFajillaMutationOptions = Apollo.BaseMutationOptions<
    AutorizarFajillaMutation,
    AutorizarFajillaMutationVariables
>
export const RechazarFajillaDocument = gql`
    mutation RechazarFajilla($dataRechazar: RechazarFajillaInput!) {
        rechazar_fajilla(rechazar_fajilla_input: $dataRechazar)
    }
`
export type RechazarFajillaMutationFn = Apollo.MutationFunction<
    RechazarFajillaMutation,
    RechazarFajillaMutationVariables
>
export type RechazarFajillaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<RechazarFajillaMutation, RechazarFajillaMutationVariables>,
    "mutation"
>

export const RechazarFajillaComponent = (props: RechazarFajillaComponentProps) => (
    <ApolloReactComponents.Mutation<RechazarFajillaMutation, RechazarFajillaMutationVariables>
        mutation={RechazarFajillaDocument}
        {...props}
    />
)

/**
 * __useRechazarFajillaMutation__
 *
 * To run a mutation, you first call `useRechazarFajillaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRechazarFajillaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rechazarFajillaMutation, { data, loading, error }] = useRechazarFajillaMutation({
 *   variables: {
 *      dataRechazar: // value for 'dataRechazar'
 *   },
 * });
 */
export function useRechazarFajillaMutation(
    baseOptions?: Apollo.MutationHookOptions<RechazarFajillaMutation, RechazarFajillaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<RechazarFajillaMutation, RechazarFajillaMutationVariables>(
        RechazarFajillaDocument,
        options
    )
}
export type RechazarFajillaMutationHookResult = ReturnType<typeof useRechazarFajillaMutation>
export type RechazarFajillaMutationResult = Apollo.MutationResult<RechazarFajillaMutation>
export type RechazarFajillaMutationOptions = Apollo.BaseMutationOptions<
    RechazarFajillaMutation,
    RechazarFajillaMutationVariables
>
export const Cerrar_CorteDocument = gql`
    mutation Cerrar_corte($datos_corte: CloseCorteInput!, $hotel_id: ID!) {
        cerrar_corte(datos_corte: $datos_corte, hotel_id: $hotel_id) {
            corte_id
        }
    }
`
export type Cerrar_CorteMutationFn = Apollo.MutationFunction<Cerrar_CorteMutation, Cerrar_CorteMutationVariables>
export type Cerrar_CorteComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<Cerrar_CorteMutation, Cerrar_CorteMutationVariables>,
    "mutation"
>

export const Cerrar_CorteComponent = (props: Cerrar_CorteComponentProps) => (
    <ApolloReactComponents.Mutation<Cerrar_CorteMutation, Cerrar_CorteMutationVariables>
        mutation={Cerrar_CorteDocument}
        {...props}
    />
)

/**
 * __useCerrar_CorteMutation__
 *
 * To run a mutation, you first call `useCerrar_CorteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCerrar_CorteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cerrarCorteMutation, { data, loading, error }] = useCerrar_CorteMutation({
 *   variables: {
 *      datos_corte: // value for 'datos_corte'
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useCerrar_CorteMutation(
    baseOptions?: Apollo.MutationHookOptions<Cerrar_CorteMutation, Cerrar_CorteMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<Cerrar_CorteMutation, Cerrar_CorteMutationVariables>(Cerrar_CorteDocument, options)
}
export type Cerrar_CorteMutationHookResult = ReturnType<typeof useCerrar_CorteMutation>
export type Cerrar_CorteMutationResult = Apollo.MutationResult<Cerrar_CorteMutation>
export type Cerrar_CorteMutationOptions = Apollo.BaseMutationOptions<
    Cerrar_CorteMutation,
    Cerrar_CorteMutationVariables
>
export const CrearFajillaDocument = gql`
    mutation CrearFajilla($crearFajillaInput: CreateFajillaInput!) {
        crear_fajilla(crear_fajilla_input: $crearFajillaInput) {
            fajilla_id
            ticket_id
            fecha_autorizaicion
            fecha_creacion
        }
    }
`
export type CrearFajillaMutationFn = Apollo.MutationFunction<CrearFajillaMutation, CrearFajillaMutationVariables>
export type CrearFajillaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CrearFajillaMutation, CrearFajillaMutationVariables>,
    "mutation"
>

export const CrearFajillaComponent = (props: CrearFajillaComponentProps) => (
    <ApolloReactComponents.Mutation<CrearFajillaMutation, CrearFajillaMutationVariables>
        mutation={CrearFajillaDocument}
        {...props}
    />
)

/**
 * __useCrearFajillaMutation__
 *
 * To run a mutation, you first call `useCrearFajillaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrearFajillaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crearFajillaMutation, { data, loading, error }] = useCrearFajillaMutation({
 *   variables: {
 *      crearFajillaInput: // value for 'crearFajillaInput'
 *   },
 * });
 */
export function useCrearFajillaMutation(
    baseOptions?: Apollo.MutationHookOptions<CrearFajillaMutation, CrearFajillaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CrearFajillaMutation, CrearFajillaMutationVariables>(CrearFajillaDocument, options)
}
export type CrearFajillaMutationHookResult = ReturnType<typeof useCrearFajillaMutation>
export type CrearFajillaMutationResult = Apollo.MutationResult<CrearFajillaMutation>
export type CrearFajillaMutationOptions = Apollo.BaseMutationOptions<
    CrearFajillaMutation,
    CrearFajillaMutationVariables
>
export const AlertaPagosPendientesDocument = gql`
    query AlertaPagosPendientes($hotel_id: ID!) {
        alertas_corte(hotel_id: $hotel_id) {
            alerta_por_pagos_pendientes
            registros_pendientes {
                registro_obligatorio
                alerta_por_placas_pendientes
                alerta_por_mantenimiento_pendiente
            }
            registros_pagos_pendientes {
                folio
                categoria
                concepto
                monto
                fecha
            }
        }
    }
`
export type AlertaPagosPendientesComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<AlertaPagosPendientesQuery, AlertaPagosPendientesQueryVariables>,
    "query"
> &
    ({ variables: AlertaPagosPendientesQueryVariables; skip?: boolean } | { skip: boolean })

export const AlertaPagosPendientesComponent = (props: AlertaPagosPendientesComponentProps) => (
    <ApolloReactComponents.Query<AlertaPagosPendientesQuery, AlertaPagosPendientesQueryVariables>
        query={AlertaPagosPendientesDocument}
        {...props}
    />
)

/**
 * __useAlertaPagosPendientesQuery__
 *
 * To run a query within a React component, call `useAlertaPagosPendientesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertaPagosPendientesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertaPagosPendientesQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useAlertaPagosPendientesQuery(
    baseOptions: Apollo.QueryHookOptions<AlertaPagosPendientesQuery, AlertaPagosPendientesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<AlertaPagosPendientesQuery, AlertaPagosPendientesQueryVariables>(
        AlertaPagosPendientesDocument,
        options
    )
}
export function useAlertaPagosPendientesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<AlertaPagosPendientesQuery, AlertaPagosPendientesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<AlertaPagosPendientesQuery, AlertaPagosPendientesQueryVariables>(
        AlertaPagosPendientesDocument,
        options
    )
}
export type AlertaPagosPendientesQueryHookResult = ReturnType<typeof useAlertaPagosPendientesQuery>
export type AlertaPagosPendientesLazyQueryHookResult = ReturnType<typeof useAlertaPagosPendientesLazyQuery>
export type AlertaPagosPendientesQueryResult = Apollo.QueryResult<
    AlertaPagosPendientesQuery,
    AlertaPagosPendientesQueryVariables
>
export const GetFajillasDocument = gql`
    query getFajillas {
        fajillas {
            monto
            estatus
            fajilla_id
            fecha_creacion
            fecha_autorizaicion
            usuario_autorizo {
                nombre
                apellido_materno
                apellido_paterno
            }
            usuario_creo_id
            usuario_creo {
                nombre
                apellido_paterno
                apellido_materno
            }
            usuario_autorizo_id
            turno_id
            comentario
            folio
        }
    }
`
export type GetFajillasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetFajillasQuery, GetFajillasQueryVariables>,
    "query"
>

export const GetFajillasComponent = (props: GetFajillasComponentProps) => (
    <ApolloReactComponents.Query<GetFajillasQuery, GetFajillasQueryVariables> query={GetFajillasDocument} {...props} />
)

/**
 * __useGetFajillasQuery__
 *
 * To run a query within a React component, call `useGetFajillasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFajillasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFajillasQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFajillasQuery(
    baseOptions?: Apollo.QueryHookOptions<GetFajillasQuery, GetFajillasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetFajillasQuery, GetFajillasQueryVariables>(GetFajillasDocument, options)
}
export function useGetFajillasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetFajillasQuery, GetFajillasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetFajillasQuery, GetFajillasQueryVariables>(GetFajillasDocument, options)
}
export type GetFajillasQueryHookResult = ReturnType<typeof useGetFajillasQuery>
export type GetFajillasLazyQueryHookResult = ReturnType<typeof useGetFajillasLazyQuery>
export type GetFajillasQueryResult = Apollo.QueryResult<GetFajillasQuery, GetFajillasQueryVariables>
export const GetCorteDocument = gql`
    query getCorte($corte_id: ID!) {
        corte(corte_id: $corte_id) {
            corte_id
            fecha_cierre_corte
            fecha_fin_corte
            fecha_inicio_corte
            efectivo_ingresado
            folio
            turno_id
            efectivo_ingresado
            total_caja
            estatus
            turno {
                nombre
            }
            usuario_cierra_corte
            usuario_realiza_corte
            total_corte
            incidencias {
                incidencia_id
            }
            usuario_crea {
                apellido_materno
                apellido_paterno
                nombre
            }
            usuario_cierra {
                apellido_materno
                apellido_paterno
                nombre
            }
        }
    }
`
export type GetCorteComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetCorteQuery, GetCorteQueryVariables>,
    "query"
> &
    ({ variables: GetCorteQueryVariables; skip?: boolean } | { skip: boolean })

export const GetCorteComponent = (props: GetCorteComponentProps) => (
    <ApolloReactComponents.Query<GetCorteQuery, GetCorteQueryVariables> query={GetCorteDocument} {...props} />
)

/**
 * __useGetCorteQuery__
 *
 * To run a query within a React component, call `useGetCorteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorteQuery({
 *   variables: {
 *      corte_id: // value for 'corte_id'
 *   },
 * });
 */
export function useGetCorteQuery(baseOptions: Apollo.QueryHookOptions<GetCorteQuery, GetCorteQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetCorteQuery, GetCorteQueryVariables>(GetCorteDocument, options)
}
export function useGetCorteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCorteQuery, GetCorteQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetCorteQuery, GetCorteQueryVariables>(GetCorteDocument, options)
}
export type GetCorteQueryHookResult = ReturnType<typeof useGetCorteQuery>
export type GetCorteLazyQueryHookResult = ReturnType<typeof useGetCorteLazyQuery>
export type GetCorteQueryResult = Apollo.QueryResult<GetCorteQuery, GetCorteQueryVariables>
export const EditarMetodoDePagoMovimientoDocument = gql`
    mutation EditarMetodoDePagoMovimiento($editMetodoPagoTicketInput: EditMetodoPagoTicketInput!) {
        editar_metodo_pago(editMetodoPagoTicketInput: $editMetodoPagoTicketInput) {
            ticket_id
        }
    }
`
export type EditarMetodoDePagoMovimientoMutationFn = Apollo.MutationFunction<
    EditarMetodoDePagoMovimientoMutation,
    EditarMetodoDePagoMovimientoMutationVariables
>
export type EditarMetodoDePagoMovimientoComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        EditarMetodoDePagoMovimientoMutation,
        EditarMetodoDePagoMovimientoMutationVariables
    >,
    "mutation"
>

export const EditarMetodoDePagoMovimientoComponent = (props: EditarMetodoDePagoMovimientoComponentProps) => (
    <ApolloReactComponents.Mutation<EditarMetodoDePagoMovimientoMutation, EditarMetodoDePagoMovimientoMutationVariables>
        mutation={EditarMetodoDePagoMovimientoDocument}
        {...props}
    />
)

/**
 * __useEditarMetodoDePagoMovimientoMutation__
 *
 * To run a mutation, you first call `useEditarMetodoDePagoMovimientoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditarMetodoDePagoMovimientoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editarMetodoDePagoMovimientoMutation, { data, loading, error }] = useEditarMetodoDePagoMovimientoMutation({
 *   variables: {
 *      editMetodoPagoTicketInput: // value for 'editMetodoPagoTicketInput'
 *   },
 * });
 */
export function useEditarMetodoDePagoMovimientoMutation(
    baseOptions?: Apollo.MutationHookOptions<
        EditarMetodoDePagoMovimientoMutation,
        EditarMetodoDePagoMovimientoMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<EditarMetodoDePagoMovimientoMutation, EditarMetodoDePagoMovimientoMutationVariables>(
        EditarMetodoDePagoMovimientoDocument,
        options
    )
}
export type EditarMetodoDePagoMovimientoMutationHookResult = ReturnType<typeof useEditarMetodoDePagoMovimientoMutation>
export type EditarMetodoDePagoMovimientoMutationResult = Apollo.MutationResult<EditarMetodoDePagoMovimientoMutation>
export type EditarMetodoDePagoMovimientoMutationOptions = Apollo.BaseMutationOptions<
    EditarMetodoDePagoMovimientoMutation,
    EditarMetodoDePagoMovimientoMutationVariables
>
export const Resumen_Movimientos_Antes_CorteDocument = gql`
    query Resumen_Movimientos_antes_corte($fecha_inicio: DateTime!, $fecha_fin: DateTime!, $hotel_id: ID!) {
        movimientos_antes_corte(fecha_fin: $fecha_fin, fecha_inicio: $fecha_inicio, hotel_id: $hotel_id) {
            numero_total_movimientos
            suma_total_montos
        }
    }
`
export type Resumen_Movimientos_Antes_CorteComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        Resumen_Movimientos_Antes_CorteQuery,
        Resumen_Movimientos_Antes_CorteQueryVariables
    >,
    "query"
> &
    ({ variables: Resumen_Movimientos_Antes_CorteQueryVariables; skip?: boolean } | { skip: boolean })

export const Resumen_Movimientos_Antes_CorteComponent = (props: Resumen_Movimientos_Antes_CorteComponentProps) => (
    <ApolloReactComponents.Query<Resumen_Movimientos_Antes_CorteQuery, Resumen_Movimientos_Antes_CorteQueryVariables>
        query={Resumen_Movimientos_Antes_CorteDocument}
        {...props}
    />
)

/**
 * __useResumen_Movimientos_Antes_CorteQuery__
 *
 * To run a query within a React component, call `useResumen_Movimientos_Antes_CorteQuery` and pass it any options that fit your needs.
 * When your component renders, `useResumen_Movimientos_Antes_CorteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResumen_Movimientos_Antes_CorteQuery({
 *   variables: {
 *      fecha_inicio: // value for 'fecha_inicio'
 *      fecha_fin: // value for 'fecha_fin'
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useResumen_Movimientos_Antes_CorteQuery(
    baseOptions: Apollo.QueryHookOptions<
        Resumen_Movimientos_Antes_CorteQuery,
        Resumen_Movimientos_Antes_CorteQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<Resumen_Movimientos_Antes_CorteQuery, Resumen_Movimientos_Antes_CorteQueryVariables>(
        Resumen_Movimientos_Antes_CorteDocument,
        options
    )
}
export function useResumen_Movimientos_Antes_CorteLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        Resumen_Movimientos_Antes_CorteQuery,
        Resumen_Movimientos_Antes_CorteQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<Resumen_Movimientos_Antes_CorteQuery, Resumen_Movimientos_Antes_CorteQueryVariables>(
        Resumen_Movimientos_Antes_CorteDocument,
        options
    )
}
export type Resumen_Movimientos_Antes_CorteQueryHookResult = ReturnType<typeof useResumen_Movimientos_Antes_CorteQuery>
export type Resumen_Movimientos_Antes_CorteLazyQueryHookResult = ReturnType<
    typeof useResumen_Movimientos_Antes_CorteLazyQuery
>
export type Resumen_Movimientos_Antes_CorteQueryResult = Apollo.QueryResult<
    Resumen_Movimientos_Antes_CorteQuery,
    Resumen_Movimientos_Antes_CorteQueryVariables
>
export const GetCortesDocument = gql`
    query getCortes {
        cortes {
            corte_id
            fecha_cierre_corte
            fecha_fin_corte
            fecha_inicio_corte
            efectivo_ingresado
            folio
            turno_id
            turno {
                nombre
            }
            usuario_cierra_corte
            usuario_realiza_corte
            total_corte
            incidencias {
                incidencia_id
            }
            usuario_crea {
                apellido_materno
                apellido_paterno
                nombre
            }
            usuario_cierra {
                apellido_materno
                apellido_paterno
                nombre
            }
        }
    }
`
export type GetCortesComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetCortesQuery, GetCortesQueryVariables>,
    "query"
>

export const GetCortesComponent = (props: GetCortesComponentProps) => (
    <ApolloReactComponents.Query<GetCortesQuery, GetCortesQueryVariables> query={GetCortesDocument} {...props} />
)

/**
 * __useGetCortesQuery__
 *
 * To run a query within a React component, call `useGetCortesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCortesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCortesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCortesQuery(baseOptions?: Apollo.QueryHookOptions<GetCortesQuery, GetCortesQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetCortesQuery, GetCortesQueryVariables>(GetCortesDocument, options)
}
export function useGetCortesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetCortesQuery, GetCortesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetCortesQuery, GetCortesQueryVariables>(GetCortesDocument, options)
}
export type GetCortesQueryHookResult = ReturnType<typeof useGetCortesQuery>
export type GetCortesLazyQueryHookResult = ReturnType<typeof useGetCortesLazyQuery>
export type GetCortesQueryResult = Apollo.QueryResult<GetCortesQuery, GetCortesQueryVariables>
export const Ultimo_CorteDocument = gql`
    query Ultimo_corte($hotel_id: ID!) {
        ultimo_corte(hotel_id: $hotel_id) {
            corte_id
            fecha_cierre_corte
            fecha_fin_corte
            fecha_inicio_corte
            efectivo_ingresado
            folio
            turno_id
            turno {
                nombre
            }
            usuario_cierra_corte
            usuario_realiza_corte
            total_corte
            incidencias {
                incidencia_id
            }
            usuario_crea {
                apellido_materno
                apellido_paterno
                nombre
            }
            usuario_cierra {
                apellido_materno
                apellido_paterno
                nombre
            }
        }
    }
`
export type Ultimo_CorteComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<Ultimo_CorteQuery, Ultimo_CorteQueryVariables>,
    "query"
> &
    ({ variables: Ultimo_CorteQueryVariables; skip?: boolean } | { skip: boolean })

export const Ultimo_CorteComponent = (props: Ultimo_CorteComponentProps) => (
    <ApolloReactComponents.Query<Ultimo_CorteQuery, Ultimo_CorteQueryVariables>
        query={Ultimo_CorteDocument}
        {...props}
    />
)

/**
 * __useUltimo_CorteQuery__
 *
 * To run a query within a React component, call `useUltimo_CorteQuery` and pass it any options that fit your needs.
 * When your component renders, `useUltimo_CorteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUltimo_CorteQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useUltimo_CorteQuery(
    baseOptions: Apollo.QueryHookOptions<Ultimo_CorteQuery, Ultimo_CorteQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<Ultimo_CorteQuery, Ultimo_CorteQueryVariables>(Ultimo_CorteDocument, options)
}
export function useUltimo_CorteLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<Ultimo_CorteQuery, Ultimo_CorteQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<Ultimo_CorteQuery, Ultimo_CorteQueryVariables>(Ultimo_CorteDocument, options)
}
export type Ultimo_CorteQueryHookResult = ReturnType<typeof useUltimo_CorteQuery>
export type Ultimo_CorteLazyQueryHookResult = ReturnType<typeof useUltimo_CorteLazyQuery>
export type Ultimo_CorteQueryResult = Apollo.QueryResult<Ultimo_CorteQuery, Ultimo_CorteQueryVariables>
export const ArticulosDocument = gql`
    query Articulos($fecha_registro: DateSearchInput, $pagination_options: PageOptionsArgs!) {
        almacenes_articulos(pagination_options: $pagination_options) {
            almacenes_articulos {
                articulo_id
                costo
                precio
                articulo {
                    cantidad_minima
                    cantidad_vendida(fecha_registro: $fecha_registro)
                    categoria_id
                    contenido
                    descripcion
                    eliminado
                    estado
                    fecha_eliminado
                    fecha_registro
                    folio
                    foto
                    tipo
                    marca
                    nombre
                    stock
                    unidad
                }
            }
        }
    }
`
export type ArticulosComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<ArticulosQuery, ArticulosQueryVariables>,
    "query"
> &
    ({ variables: ArticulosQueryVariables; skip?: boolean } | { skip: boolean })

export const ArticulosComponent = (props: ArticulosComponentProps) => (
    <ApolloReactComponents.Query<ArticulosQuery, ArticulosQueryVariables> query={ArticulosDocument} {...props} />
)

/**
 * __useArticulosQuery__
 *
 * To run a query within a React component, call `useArticulosQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticulosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticulosQuery({
 *   variables: {
 *      fecha_registro: // value for 'fecha_registro'
 *      pagination_options: // value for 'pagination_options'
 *   },
 * });
 */
export function useArticulosQuery(baseOptions: Apollo.QueryHookOptions<ArticulosQuery, ArticulosQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<ArticulosQuery, ArticulosQueryVariables>(ArticulosDocument, options)
}
export function useArticulosLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ArticulosQuery, ArticulosQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<ArticulosQuery, ArticulosQueryVariables>(ArticulosDocument, options)
}
export type ArticulosQueryHookResult = ReturnType<typeof useArticulosQuery>
export type ArticulosLazyQueryHookResult = ReturnType<typeof useArticulosLazyQuery>
export type ArticulosQueryResult = Apollo.QueryResult<ArticulosQuery, ArticulosQueryVariables>
export const GetUsuariosDocument = gql`
    query getUsuarios($hotel_id: ID!) {
        usuarios(hotel_id: $hotel_id) {
            nombre
            apellido_materno
            apellido_paterno
            usuario_id
        }
    }
`
export type GetUsuariosComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetUsuariosQuery, GetUsuariosQueryVariables>,
    "query"
> &
    ({ variables: GetUsuariosQueryVariables; skip?: boolean } | { skip: boolean })

export const GetUsuariosComponent = (props: GetUsuariosComponentProps) => (
    <ApolloReactComponents.Query<GetUsuariosQuery, GetUsuariosQueryVariables> query={GetUsuariosDocument} {...props} />
)

/**
 * __useGetUsuariosQuery__
 *
 * To run a query within a React component, call `useGetUsuariosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsuariosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsuariosQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetUsuariosQuery(baseOptions: Apollo.QueryHookOptions<GetUsuariosQuery, GetUsuariosQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetUsuariosQuery, GetUsuariosQueryVariables>(GetUsuariosDocument, options)
}
export function useGetUsuariosLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetUsuariosQuery, GetUsuariosQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetUsuariosQuery, GetUsuariosQueryVariables>(GetUsuariosDocument, options)
}
export type GetUsuariosQueryHookResult = ReturnType<typeof useGetUsuariosQuery>
export type GetUsuariosLazyQueryHookResult = ReturnType<typeof useGetUsuariosLazyQuery>
export type GetUsuariosQueryResult = Apollo.QueryResult<GetUsuariosQuery, GetUsuariosQueryVariables>
export const GetCortesHistorialDocument = gql`
    query GetCortesHistorial(
        $fecha_inicio_corte: DateSearchInput
        $fecha_corte: DaySearchInput
        $hotel_id: ID
        $estatus: EstatusCorte
    ) {
        cortes(
            fecha_inicio_corte: $fecha_inicio_corte
            fecha_corte: $fecha_corte
            hotel_id: $hotel_id
            estatus: $estatus
        ) {
            corte_id
            folio
            total_corte
            total_pagos_pendientes
            fecha_cierre_corte
            fecha_inicio_corte
            fecha_fin_corte
            usuario_cierra_corte
            usuario_realiza_corte
            turno_id
            usuario_crea {
                nombre
                apellido_materno
                apellido_paterno
            }
            usuario_cierra {
                nombre
                apellido_materno
                apellido_paterno
            }
            turno {
                nombre
            }
            incidencias {
                incidencia_id
            }
        }
    }
`
export type GetCortesHistorialComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetCortesHistorialQuery, GetCortesHistorialQueryVariables>,
    "query"
>

export const GetCortesHistorialComponent = (props: GetCortesHistorialComponentProps) => (
    <ApolloReactComponents.Query<GetCortesHistorialQuery, GetCortesHistorialQueryVariables>
        query={GetCortesHistorialDocument}
        {...props}
    />
)

/**
 * __useGetCortesHistorialQuery__
 *
 * To run a query within a React component, call `useGetCortesHistorialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCortesHistorialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCortesHistorialQuery({
 *   variables: {
 *      fecha_inicio_corte: // value for 'fecha_inicio_corte'
 *      fecha_corte: // value for 'fecha_corte'
 *      hotel_id: // value for 'hotel_id'
 *      estatus: // value for 'estatus'
 *   },
 * });
 */
export function useGetCortesHistorialQuery(
    baseOptions?: Apollo.QueryHookOptions<GetCortesHistorialQuery, GetCortesHistorialQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetCortesHistorialQuery, GetCortesHistorialQueryVariables>(
        GetCortesHistorialDocument,
        options
    )
}
export function useGetCortesHistorialLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetCortesHistorialQuery, GetCortesHistorialQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetCortesHistorialQuery, GetCortesHistorialQueryVariables>(
        GetCortesHistorialDocument,
        options
    )
}
export type GetCortesHistorialQueryHookResult = ReturnType<typeof useGetCortesHistorialQuery>
export type GetCortesHistorialLazyQueryHookResult = ReturnType<typeof useGetCortesHistorialLazyQuery>
export type GetCortesHistorialQueryResult = Apollo.QueryResult<
    GetCortesHistorialQuery,
    GetCortesHistorialQueryVariables
>
export const GetTicketForDetailDocument = gql`
    query GetTicketForDetail($ticket_id: ID!) {
        ticket(ticket_id: $ticket_id) {
            cancelado
            consumo_interno
            cortesia
            fecha_cancelacion
            motivo_cancelacion
            data {
                articulos {
                    articulo_id
                    cantidad
                    costo
                    nombre
                }
                extras {
                    cantidad
                    costo
                    tipo
                    __typename
                }
                habitaciones {
                    costo
                    early_checkin
                    numero
                    tipo
                    __typename
                }
                metodos_pago {
                    numero_referencia
                    tipo
                    total
                    ultimos_digitos
                    __typename
                }
                propinas {
                    procedencia
                    tipo_pago
                    total
                    ultimos_digitos
                    __typename
                }
                renta {
                    descripcion
                    habitacion_id
                    numero_habitacion
                    __typename
                }
                nombre_tarifa
                __typename
            }
            fecha_impresion
            folio
            hotel_id
            monto_fajilla
            reserva {
                cliente_id
                codigo_ota
                estado
                estado_pago
                fecha_cancelacion
                fecha_entrada
                fecha_registro
                fecha_salida
                hospedajes_extra
                monto_devuelto_cancelacion
                motivo_cancelacion
                nombre_huesped
                origen
                saldo
                tipo_habitacion_id
                total
                __typename
            }
            reserva_id
            saldo
            ticket_id
            usuario_id
            ordenes {
                orden_id
                origen_orden
                renta_id
                renta {
                    renta_id
                    habitacion_id
                    habitacion {
                        habitacion_id
                        tipo_habitacion_id
                        numero_habitacion
                        tipo_habitacion {
                            tipo_habitacion_id
                            nombre
                        }
                    }
                }
            }
            gasto {
                folio
                caja_chica
                concepto
                categoria
            }
        }
    }
`
export type GetTicketForDetailComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetTicketForDetailQuery, GetTicketForDetailQueryVariables>,
    "query"
> &
    ({ variables: GetTicketForDetailQueryVariables; skip?: boolean } | { skip: boolean })

export const GetTicketForDetailComponent = (props: GetTicketForDetailComponentProps) => (
    <ApolloReactComponents.Query<GetTicketForDetailQuery, GetTicketForDetailQueryVariables>
        query={GetTicketForDetailDocument}
        {...props}
    />
)

/**
 * __useGetTicketForDetailQuery__
 *
 * To run a query within a React component, call `useGetTicketForDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketForDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketForDetailQuery({
 *   variables: {
 *      ticket_id: // value for 'ticket_id'
 *   },
 * });
 */
export function useGetTicketForDetailQuery(
    baseOptions: Apollo.QueryHookOptions<GetTicketForDetailQuery, GetTicketForDetailQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetTicketForDetailQuery, GetTicketForDetailQueryVariables>(
        GetTicketForDetailDocument,
        options
    )
}
export function useGetTicketForDetailLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetTicketForDetailQuery, GetTicketForDetailQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetTicketForDetailQuery, GetTicketForDetailQueryVariables>(
        GetTicketForDetailDocument,
        options
    )
}
export type GetTicketForDetailQueryHookResult = ReturnType<typeof useGetTicketForDetailQuery>
export type GetTicketForDetailLazyQueryHookResult = ReturnType<typeof useGetTicketForDetailLazyQuery>
export type GetTicketForDetailQueryResult = Apollo.QueryResult<
    GetTicketForDetailQuery,
    GetTicketForDetailQueryVariables
>
export const LoginHuellaDocument = gql`
    mutation LoginHuella($template_sample: String!) {
        login_huella(FingerPrintLoginInput: { template_sample: $template_sample }) {
            token
            usuario_id
            ultimo_hotel_id
            colaborador_activo
        }
    }
`
export type LoginHuellaMutationFn = Apollo.MutationFunction<LoginHuellaMutation, LoginHuellaMutationVariables>
export type LoginHuellaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<LoginHuellaMutation, LoginHuellaMutationVariables>,
    "mutation"
>

export const LoginHuellaComponent = (props: LoginHuellaComponentProps) => (
    <ApolloReactComponents.Mutation<LoginHuellaMutation, LoginHuellaMutationVariables>
        mutation={LoginHuellaDocument}
        {...props}
    />
)

/**
 * __useLoginHuellaMutation__
 *
 * To run a mutation, you first call `useLoginHuellaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginHuellaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginHuellaMutation, { data, loading, error }] = useLoginHuellaMutation({
 *   variables: {
 *      template_sample: // value for 'template_sample'
 *   },
 * });
 */
export function useLoginHuellaMutation(
    baseOptions?: Apollo.MutationHookOptions<LoginHuellaMutation, LoginHuellaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<LoginHuellaMutation, LoginHuellaMutationVariables>(LoginHuellaDocument, options)
}
export type LoginHuellaMutationHookResult = ReturnType<typeof useLoginHuellaMutation>
export type LoginHuellaMutationResult = Apollo.MutationResult<LoginHuellaMutation>
export type LoginHuellaMutationOptions = Apollo.BaseMutationOptions<LoginHuellaMutation, LoginHuellaMutationVariables>
export const GetOrdenesEnPreparacionDocument = gql`
    query GetOrdenesEnPreparacion($hotel_id: ID!) {
        ordenes(
            filter_by_detalle_orden_state: [en_preparacion, cancelada, cancelada_edicion]
            panel_no_visible: false
            filter_comanda: true
            hotel_id: $hotel_id
        ) {
            comentario
            corte_id
            estado_orden
            estado_pago
            fecha_cobro
            fecha_modificacion
            fecha_registro
            orden
            orden_id
            consumo_interno_colaborador_id
            colaborador_consumo_interno {
                nombre
                apellido_paterno
                apellido_paterno
            }
            renta_id
            origen_orden
            virtual_comanda_id
            comanda {
                comanda_id
                estado_comanda
                folio
                fecha_modificacion
                fecha_registro
            }
            mesa {
                numero_mesa
            }
            renta {
                habitacion_id
                habitacion {
                    habitacion_id
                    numero_habitacion
                    tipo_habitacion_id
                    usuario_id
                    tipo_habitacion {
                        nombre
                        tipo_habitacion_id
                    }
                }
            }
            detalles_orden(estado: [en_preparacion, cancelada, cancelada_edicion]) {
                almacen_articulo_id
                cantidad
                comanda_id
                comentarios
                detalle_orden_id
                estado
                orden_id
                almacen_articulo {
                    almacen_articulo_id
                    almacen_id
                    articulo_id
                    articulo {
                        articulo_id
                        nombre
                        foto
                        tipo
                        categoria_articulo {
                            categoria_id
                            nombre
                        }
                    }
                }
                extras {
                    almacen_articulo_id
                    cantidad
                    costo_con_iva
                    costo_sin_iva
                    detalle_orden_id
                    extra_detalle_orden_id
                    monto_iva
                    almacen_articulo {
                        almacen_articulo_id
                        articulo_id
                        articulo {
                            articulo_id
                            nombre
                        }
                    }
                }
            }
        }
    }
`
export type GetOrdenesEnPreparacionComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetOrdenesEnPreparacionQuery, GetOrdenesEnPreparacionQueryVariables>,
    "query"
> &
    ({ variables: GetOrdenesEnPreparacionQueryVariables; skip?: boolean } | { skip: boolean })

export const GetOrdenesEnPreparacionComponent = (props: GetOrdenesEnPreparacionComponentProps) => (
    <ApolloReactComponents.Query<GetOrdenesEnPreparacionQuery, GetOrdenesEnPreparacionQueryVariables>
        query={GetOrdenesEnPreparacionDocument}
        {...props}
    />
)

/**
 * __useGetOrdenesEnPreparacionQuery__
 *
 * To run a query within a React component, call `useGetOrdenesEnPreparacionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdenesEnPreparacionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdenesEnPreparacionQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetOrdenesEnPreparacionQuery(
    baseOptions: Apollo.QueryHookOptions<GetOrdenesEnPreparacionQuery, GetOrdenesEnPreparacionQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetOrdenesEnPreparacionQuery, GetOrdenesEnPreparacionQueryVariables>(
        GetOrdenesEnPreparacionDocument,
        options
    )
}
export function useGetOrdenesEnPreparacionLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetOrdenesEnPreparacionQuery, GetOrdenesEnPreparacionQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetOrdenesEnPreparacionQuery, GetOrdenesEnPreparacionQueryVariables>(
        GetOrdenesEnPreparacionDocument,
        options
    )
}
export type GetOrdenesEnPreparacionQueryHookResult = ReturnType<typeof useGetOrdenesEnPreparacionQuery>
export type GetOrdenesEnPreparacionLazyQueryHookResult = ReturnType<typeof useGetOrdenesEnPreparacionLazyQuery>
export type GetOrdenesEnPreparacionQueryResult = Apollo.QueryResult<
    GetOrdenesEnPreparacionQuery,
    GetOrdenesEnPreparacionQueryVariables
>
export const GetOrdenesEnEntregaDocument = gql`
    query GetOrdenesEnEntrega($hotel_id: ID!) {
        ordenes(
            filter_by_detalle_orden_state: [por_entregar, cancelada, cancelada_edicion]
            panel_no_visible: false
            filter_comanda: true
            hotel_id: $hotel_id
        ) {
            comentario
            corte_id
            estado_orden
            estado_pago
            fecha_cobro
            fecha_modificacion
            fecha_registro
            orden
            orden_id
            consumo_interno_colaborador_id
            colaborador_consumo_interno {
                nombre
                apellido_paterno
                apellido_paterno
            }
            renta_id
            origen_orden
            virtual_comanda_id
            comanda {
                comanda_id
                estado_comanda
                folio
                fecha_modificacion
                fecha_registro
            }
            mesa {
                numero_mesa
            }
            renta {
                habitacion_id
                habitacion {
                    habitacion_id
                    numero_habitacion
                    tipo_habitacion_id
                    usuario_id
                    tipo_habitacion {
                        nombre
                        tipo_habitacion_id
                    }
                }
            }
            detalles_orden(estado: [por_entregar, cancelada, cancelada_edicion]) {
                almacen_articulo_id
                cantidad
                comanda_id
                comentarios
                detalle_orden_id
                estado
                orden_id
                almacen_articulo {
                    almacen_articulo_id
                    almacen_id
                    articulo_id
                    articulo {
                        articulo_id
                        nombre
                        foto
                        tipo
                        categoria_articulo {
                            categoria_id
                            nombre
                        }
                    }
                }
                extras {
                    almacen_articulo_id
                    cantidad
                    costo_con_iva
                    costo_sin_iva
                    detalle_orden_id
                    extra_detalle_orden_id
                    monto_iva
                    almacen_articulo {
                        almacen_articulo_id
                        articulo_id
                        articulo {
                            articulo_id
                            nombre
                        }
                    }
                }
            }
        }
    }
`
export type GetOrdenesEnEntregaComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetOrdenesEnEntregaQuery, GetOrdenesEnEntregaQueryVariables>,
    "query"
> &
    ({ variables: GetOrdenesEnEntregaQueryVariables; skip?: boolean } | { skip: boolean })

export const GetOrdenesEnEntregaComponent = (props: GetOrdenesEnEntregaComponentProps) => (
    <ApolloReactComponents.Query<GetOrdenesEnEntregaQuery, GetOrdenesEnEntregaQueryVariables>
        query={GetOrdenesEnEntregaDocument}
        {...props}
    />
)

/**
 * __useGetOrdenesEnEntregaQuery__
 *
 * To run a query within a React component, call `useGetOrdenesEnEntregaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdenesEnEntregaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdenesEnEntregaQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetOrdenesEnEntregaQuery(
    baseOptions: Apollo.QueryHookOptions<GetOrdenesEnEntregaQuery, GetOrdenesEnEntregaQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetOrdenesEnEntregaQuery, GetOrdenesEnEntregaQueryVariables>(
        GetOrdenesEnEntregaDocument,
        options
    )
}
export function useGetOrdenesEnEntregaLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetOrdenesEnEntregaQuery, GetOrdenesEnEntregaQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetOrdenesEnEntregaQuery, GetOrdenesEnEntregaQueryVariables>(
        GetOrdenesEnEntregaDocument,
        options
    )
}
export type GetOrdenesEnEntregaQueryHookResult = ReturnType<typeof useGetOrdenesEnEntregaQuery>
export type GetOrdenesEnEntregaLazyQueryHookResult = ReturnType<typeof useGetOrdenesEnEntregaLazyQuery>
export type GetOrdenesEnEntregaQueryResult = Apollo.QueryResult<
    GetOrdenesEnEntregaQuery,
    GetOrdenesEnEntregaQueryVariables
>
export const ActualizarEstadoOrdenDetalleDocument = gql`
    mutation ActualizarEstadoOrdenDetalle($input: UpdateEstadoOrdenOrDetalleInput!, $usuario_autorizo_id: String) {
        actualizar_estado_orden_o_detalle(update_estado_data: $input, usuario_autorizo_id: $usuario_autorizo_id) {
            estado_origen
            estado_destino
            folio_orden
            nombre_articulo
        }
    }
`
export type ActualizarEstadoOrdenDetalleMutationFn = Apollo.MutationFunction<
    ActualizarEstadoOrdenDetalleMutation,
    ActualizarEstadoOrdenDetalleMutationVariables
>
export type ActualizarEstadoOrdenDetalleComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        ActualizarEstadoOrdenDetalleMutation,
        ActualizarEstadoOrdenDetalleMutationVariables
    >,
    "mutation"
>

export const ActualizarEstadoOrdenDetalleComponent = (props: ActualizarEstadoOrdenDetalleComponentProps) => (
    <ApolloReactComponents.Mutation<ActualizarEstadoOrdenDetalleMutation, ActualizarEstadoOrdenDetalleMutationVariables>
        mutation={ActualizarEstadoOrdenDetalleDocument}
        {...props}
    />
)

/**
 * __useActualizarEstadoOrdenDetalleMutation__
 *
 * To run a mutation, you first call `useActualizarEstadoOrdenDetalleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizarEstadoOrdenDetalleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizarEstadoOrdenDetalleMutation, { data, loading, error }] = useActualizarEstadoOrdenDetalleMutation({
 *   variables: {
 *      input: // value for 'input'
 *      usuario_autorizo_id: // value for 'usuario_autorizo_id'
 *   },
 * });
 */
export function useActualizarEstadoOrdenDetalleMutation(
    baseOptions?: Apollo.MutationHookOptions<
        ActualizarEstadoOrdenDetalleMutation,
        ActualizarEstadoOrdenDetalleMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ActualizarEstadoOrdenDetalleMutation, ActualizarEstadoOrdenDetalleMutationVariables>(
        ActualizarEstadoOrdenDetalleDocument,
        options
    )
}
export type ActualizarEstadoOrdenDetalleMutationHookResult = ReturnType<typeof useActualizarEstadoOrdenDetalleMutation>
export type ActualizarEstadoOrdenDetalleMutationResult = Apollo.MutationResult<ActualizarEstadoOrdenDetalleMutation>
export type ActualizarEstadoOrdenDetalleMutationOptions = Apollo.BaseMutationOptions<
    ActualizarEstadoOrdenDetalleMutation,
    ActualizarEstadoOrdenDetalleMutationVariables
>
export const ListenCheckOrdenesDocument = gql`
    subscription ListenCheckOrdenes($hotel_id: ID!) {
        checkOrdenes(filter_comanda: true, hotel_id: $hotel_id) {
            orden_en_preparacion {
                tipo
                accion
                orden {
                    ...OrdenFields
                    detalles_orden(estado: [en_preparacion, cancelada, cancelada_edicion]) {
                        ...DetallesOrdenFields
                    }
                    consumo_interno_colaborador_id
                    colaborador_consumo_interno {
                        nombre
                        apellido_paterno
                        apellido_paterno
                    }
                    pago {
                        pago_id
                        ticket_id
                    }
                }
            }
            orden_por_entregar {
                tipo
                accion
                orden {
                    ...OrdenFields
                    detalles_orden(estado: [por_entregar, cancelada, cancelada_edicion]) {
                        ...DetallesOrdenFields
                    }
                    consumo_interno_colaborador_id
                    colaborador_consumo_interno {
                        nombre
                        apellido_paterno
                        __typename
                    }
                }
            }
        }
    }
    ${OrdenFieldsFragmentDoc}
    ${DetallesOrdenFieldsFragmentDoc}
`
export type ListenCheckOrdenesComponentProps = Omit<
    ApolloReactComponents.SubscriptionComponentOptions<
        ListenCheckOrdenesSubscription,
        ListenCheckOrdenesSubscriptionVariables
    >,
    "subscription"
>

export const ListenCheckOrdenesComponent = (props: ListenCheckOrdenesComponentProps) => (
    <ApolloReactComponents.Subscription<ListenCheckOrdenesSubscription, ListenCheckOrdenesSubscriptionVariables>
        subscription={ListenCheckOrdenesDocument}
        {...props}
    />
)

/**
 * __useListenCheckOrdenesSubscription__
 *
 * To run a query within a React component, call `useListenCheckOrdenesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenCheckOrdenesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenCheckOrdenesSubscription({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useListenCheckOrdenesSubscription(
    baseOptions: Apollo.SubscriptionHookOptions<ListenCheckOrdenesSubscription, ListenCheckOrdenesSubscriptionVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useSubscription<ListenCheckOrdenesSubscription, ListenCheckOrdenesSubscriptionVariables>(
        ListenCheckOrdenesDocument,
        options
    )
}
export type ListenCheckOrdenesSubscriptionHookResult = ReturnType<typeof useListenCheckOrdenesSubscription>
export type ListenCheckOrdenesSubscriptionResult = Apollo.SubscriptionResult<ListenCheckOrdenesSubscription>
export const GetDisponibilidadHabitacionesDocument = gql`
    query GetDisponibilidadHabitaciones($hotel_id: ID!) {
        disponibilidad_habitaciones(hotel_id: $hotel_id) {
            tipo_habitacion_id
            nombre
            foto
            personas_incluidas
            disponibles
        }
    }
`
export type GetDisponibilidadHabitacionesComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetDisponibilidadHabitacionesQuery,
        GetDisponibilidadHabitacionesQueryVariables
    >,
    "query"
> &
    ({ variables: GetDisponibilidadHabitacionesQueryVariables; skip?: boolean } | { skip: boolean })

export const GetDisponibilidadHabitacionesComponent = (props: GetDisponibilidadHabitacionesComponentProps) => (
    <ApolloReactComponents.Query<GetDisponibilidadHabitacionesQuery, GetDisponibilidadHabitacionesQueryVariables>
        query={GetDisponibilidadHabitacionesDocument}
        {...props}
    />
)

/**
 * __useGetDisponibilidadHabitacionesQuery__
 *
 * To run a query within a React component, call `useGetDisponibilidadHabitacionesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisponibilidadHabitacionesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisponibilidadHabitacionesQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetDisponibilidadHabitacionesQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetDisponibilidadHabitacionesQuery,
        GetDisponibilidadHabitacionesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetDisponibilidadHabitacionesQuery, GetDisponibilidadHabitacionesQueryVariables>(
        GetDisponibilidadHabitacionesDocument,
        options
    )
}
export function useGetDisponibilidadHabitacionesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetDisponibilidadHabitacionesQuery,
        GetDisponibilidadHabitacionesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetDisponibilidadHabitacionesQuery, GetDisponibilidadHabitacionesQueryVariables>(
        GetDisponibilidadHabitacionesDocument,
        options
    )
}
export type GetDisponibilidadHabitacionesQueryHookResult = ReturnType<typeof useGetDisponibilidadHabitacionesQuery>
export type GetDisponibilidadHabitacionesLazyQueryHookResult = ReturnType<
    typeof useGetDisponibilidadHabitacionesLazyQuery
>
export type GetDisponibilidadHabitacionesQueryResult = Apollo.QueryResult<
    GetDisponibilidadHabitacionesQuery,
    GetDisponibilidadHabitacionesQueryVariables
>
export const GetDisponibilidadTarifasDocument = gql`
    query GetDisponibilidadTarifas($hotel_id: ID) {
        tarifas(hotel_id: $hotel_id, eliminado: false, pantalla_disponibilidad: true) {
            nombre
            tarifa_id
            dias_disponibles
            tipo_habitacion_id
            tipo_tarifa
            costo_habitacion
            costo_persona_extra
            costo_reserva
            duracion_renta
            personas_extra_max
            costo_reserva
            tipo_tarifa
            pantalla_disponibilidad
        }
    }
`
export type GetDisponibilidadTarifasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetDisponibilidadTarifasQuery, GetDisponibilidadTarifasQueryVariables>,
    "query"
>

export const GetDisponibilidadTarifasComponent = (props: GetDisponibilidadTarifasComponentProps) => (
    <ApolloReactComponents.Query<GetDisponibilidadTarifasQuery, GetDisponibilidadTarifasQueryVariables>
        query={GetDisponibilidadTarifasDocument}
        {...props}
    />
)

/**
 * __useGetDisponibilidadTarifasQuery__
 *
 * To run a query within a React component, call `useGetDisponibilidadTarifasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisponibilidadTarifasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisponibilidadTarifasQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetDisponibilidadTarifasQuery(
    baseOptions?: Apollo.QueryHookOptions<GetDisponibilidadTarifasQuery, GetDisponibilidadTarifasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetDisponibilidadTarifasQuery, GetDisponibilidadTarifasQueryVariables>(
        GetDisponibilidadTarifasDocument,
        options
    )
}
export function useGetDisponibilidadTarifasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetDisponibilidadTarifasQuery, GetDisponibilidadTarifasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetDisponibilidadTarifasQuery, GetDisponibilidadTarifasQueryVariables>(
        GetDisponibilidadTarifasDocument,
        options
    )
}
export type GetDisponibilidadTarifasQueryHookResult = ReturnType<typeof useGetDisponibilidadTarifasQuery>
export type GetDisponibilidadTarifasLazyQueryHookResult = ReturnType<typeof useGetDisponibilidadTarifasLazyQuery>
export type GetDisponibilidadTarifasQueryResult = Apollo.QueryResult<
    GetDisponibilidadTarifasQuery,
    GetDisponibilidadTarifasQueryVariables
>
export const GetDisponibilidadTurnosAtencionDocument = gql`
    query GetDisponibilidadTurnosAtencion($hotel_id: ID!, $estado: [EstadosTurnosAtencion!]) {
        turnos_atencion(hotel_id: $hotel_id, estado: $estado) {
            tipo_habitacion_id
            tipo_habitacion {
                nombre
            }
            folio
            folio_turno
            estado
        }
    }
`
export type GetDisponibilidadTurnosAtencionComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetDisponibilidadTurnosAtencionQuery,
        GetDisponibilidadTurnosAtencionQueryVariables
    >,
    "query"
> &
    ({ variables: GetDisponibilidadTurnosAtencionQueryVariables; skip?: boolean } | { skip: boolean })

export const GetDisponibilidadTurnosAtencionComponent = (props: GetDisponibilidadTurnosAtencionComponentProps) => (
    <ApolloReactComponents.Query<GetDisponibilidadTurnosAtencionQuery, GetDisponibilidadTurnosAtencionQueryVariables>
        query={GetDisponibilidadTurnosAtencionDocument}
        {...props}
    />
)

/**
 * __useGetDisponibilidadTurnosAtencionQuery__
 *
 * To run a query within a React component, call `useGetDisponibilidadTurnosAtencionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisponibilidadTurnosAtencionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisponibilidadTurnosAtencionQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      estado: // value for 'estado'
 *   },
 * });
 */
export function useGetDisponibilidadTurnosAtencionQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetDisponibilidadTurnosAtencionQuery,
        GetDisponibilidadTurnosAtencionQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetDisponibilidadTurnosAtencionQuery, GetDisponibilidadTurnosAtencionQueryVariables>(
        GetDisponibilidadTurnosAtencionDocument,
        options
    )
}
export function useGetDisponibilidadTurnosAtencionLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetDisponibilidadTurnosAtencionQuery,
        GetDisponibilidadTurnosAtencionQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetDisponibilidadTurnosAtencionQuery, GetDisponibilidadTurnosAtencionQueryVariables>(
        GetDisponibilidadTurnosAtencionDocument,
        options
    )
}
export type GetDisponibilidadTurnosAtencionQueryHookResult = ReturnType<typeof useGetDisponibilidadTurnosAtencionQuery>
export type GetDisponibilidadTurnosAtencionLazyQueryHookResult = ReturnType<
    typeof useGetDisponibilidadTurnosAtencionLazyQuery
>
export type GetDisponibilidadTurnosAtencionQueryResult = Apollo.QueryResult<
    GetDisponibilidadTurnosAtencionQuery,
    GetDisponibilidadTurnosAtencionQueryVariables
>
export const ListenCheckDisponibilidadHabitacionesDocument = gql`
    subscription ListenCheckDisponibilidadHabitaciones($hotel_id: ID!) {
        checkDisponibilidadHabitaciones(hotel_id: $hotel_id) {
            disponibilidad_habitaciones {
                accion
            }
            lista_de_espera {
                turno_en_curso {
                    turno_atencion_id
                    folio
                    folio_turno
                }
                lista {
                    tipo_habitacion_id
                    nombre
                    turnos_atencion(estado: [en_espera, en_curso]) {
                        folio
                        folio_turno
                        estado
                    }
                }
            }
        }
    }
`
export type ListenCheckDisponibilidadHabitacionesComponentProps = Omit<
    ApolloReactComponents.SubscriptionComponentOptions<
        ListenCheckDisponibilidadHabitacionesSubscription,
        ListenCheckDisponibilidadHabitacionesSubscriptionVariables
    >,
    "subscription"
>

export const ListenCheckDisponibilidadHabitacionesComponent = (
    props: ListenCheckDisponibilidadHabitacionesComponentProps
) => (
    <ApolloReactComponents.Subscription<
        ListenCheckDisponibilidadHabitacionesSubscription,
        ListenCheckDisponibilidadHabitacionesSubscriptionVariables
    >
        subscription={ListenCheckDisponibilidadHabitacionesDocument}
        {...props}
    />
)

/**
 * __useListenCheckDisponibilidadHabitacionesSubscription__
 *
 * To run a query within a React component, call `useListenCheckDisponibilidadHabitacionesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenCheckDisponibilidadHabitacionesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenCheckDisponibilidadHabitacionesSubscription({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useListenCheckDisponibilidadHabitacionesSubscription(
    baseOptions: Apollo.SubscriptionHookOptions<
        ListenCheckDisponibilidadHabitacionesSubscription,
        ListenCheckDisponibilidadHabitacionesSubscriptionVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useSubscription<
        ListenCheckDisponibilidadHabitacionesSubscription,
        ListenCheckDisponibilidadHabitacionesSubscriptionVariables
    >(ListenCheckDisponibilidadHabitacionesDocument, options)
}
export type ListenCheckDisponibilidadHabitacionesSubscriptionHookResult = ReturnType<
    typeof useListenCheckDisponibilidadHabitacionesSubscription
>
export type ListenCheckDisponibilidadHabitacionesSubscriptionResult =
    Apollo.SubscriptionResult<ListenCheckDisponibilidadHabitacionesSubscription>
export const GetEasyrewardsDocument = gql`
    query getEasyrewards($easyrewards_id: String!) {
        obten_saldo(easyrewards_id: $easyrewards_id) {
            saldo
        }
    }
`
export type GetEasyrewardsComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetEasyrewardsQuery, GetEasyrewardsQueryVariables>,
    "query"
> &
    ({ variables: GetEasyrewardsQueryVariables; skip?: boolean } | { skip: boolean })

export const GetEasyrewardsComponent = (props: GetEasyrewardsComponentProps) => (
    <ApolloReactComponents.Query<GetEasyrewardsQuery, GetEasyrewardsQueryVariables>
        query={GetEasyrewardsDocument}
        {...props}
    />
)

/**
 * __useGetEasyrewardsQuery__
 *
 * To run a query within a React component, call `useGetEasyrewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEasyrewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEasyrewardsQuery({
 *   variables: {
 *      easyrewards_id: // value for 'easyrewards_id'
 *   },
 * });
 */
export function useGetEasyrewardsQuery(
    baseOptions: Apollo.QueryHookOptions<GetEasyrewardsQuery, GetEasyrewardsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetEasyrewardsQuery, GetEasyrewardsQueryVariables>(GetEasyrewardsDocument, options)
}
export function useGetEasyrewardsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetEasyrewardsQuery, GetEasyrewardsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetEasyrewardsQuery, GetEasyrewardsQueryVariables>(GetEasyrewardsDocument, options)
}
export type GetEasyrewardsQueryHookResult = ReturnType<typeof useGetEasyrewardsQuery>
export type GetEasyrewardsLazyQueryHookResult = ReturnType<typeof useGetEasyrewardsLazyQuery>
export type GetEasyrewardsQueryResult = Apollo.QueryResult<GetEasyrewardsQuery, GetEasyrewardsQueryVariables>
export const AbonarSaldoEasyrewardsDocument = gql`
    mutation AbonarSaldoEasyrewards(
        $easyrewards_id: String!
        $folio_ticket: String!
        $hotel_id: ID!
        $monto_alimentos: Float!
        $monto_bebidas: Float!
        $monto_extras: Float!
        $monto_habitacion: Float!
        $monto_sexspa: Float!
        $origen: Float!
    ) {
        acumula_puntos(
            AcumulaPuntosInput: {
                data: {
                    folio_ticket: $folio_ticket
                    monto_alimentos: $monto_alimentos
                    monto_bebidas: $monto_bebidas
                    monto_extras: $monto_extras
                    monto_habitacion: $monto_habitacion
                    monto_sexspa: $monto_sexspa
                    origen: $origen
                }
                easyrewards_id: $easyrewards_id
                hotel_id: $hotel_id
            }
        ) {
            saldo
        }
    }
`
export type AbonarSaldoEasyrewardsMutationFn = Apollo.MutationFunction<
    AbonarSaldoEasyrewardsMutation,
    AbonarSaldoEasyrewardsMutationVariables
>
export type AbonarSaldoEasyrewardsComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        AbonarSaldoEasyrewardsMutation,
        AbonarSaldoEasyrewardsMutationVariables
    >,
    "mutation"
>

export const AbonarSaldoEasyrewardsComponent = (props: AbonarSaldoEasyrewardsComponentProps) => (
    <ApolloReactComponents.Mutation<AbonarSaldoEasyrewardsMutation, AbonarSaldoEasyrewardsMutationVariables>
        mutation={AbonarSaldoEasyrewardsDocument}
        {...props}
    />
)

/**
 * __useAbonarSaldoEasyrewardsMutation__
 *
 * To run a mutation, you first call `useAbonarSaldoEasyrewardsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbonarSaldoEasyrewardsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [abonarSaldoEasyrewardsMutation, { data, loading, error }] = useAbonarSaldoEasyrewardsMutation({
 *   variables: {
 *      easyrewards_id: // value for 'easyrewards_id'
 *      folio_ticket: // value for 'folio_ticket'
 *      hotel_id: // value for 'hotel_id'
 *      monto_alimentos: // value for 'monto_alimentos'
 *      monto_bebidas: // value for 'monto_bebidas'
 *      monto_extras: // value for 'monto_extras'
 *      monto_habitacion: // value for 'monto_habitacion'
 *      monto_sexspa: // value for 'monto_sexspa'
 *      origen: // value for 'origen'
 *   },
 * });
 */
export function useAbonarSaldoEasyrewardsMutation(
    baseOptions?: Apollo.MutationHookOptions<AbonarSaldoEasyrewardsMutation, AbonarSaldoEasyrewardsMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<AbonarSaldoEasyrewardsMutation, AbonarSaldoEasyrewardsMutationVariables>(
        AbonarSaldoEasyrewardsDocument,
        options
    )
}
export type AbonarSaldoEasyrewardsMutationHookResult = ReturnType<typeof useAbonarSaldoEasyrewardsMutation>
export type AbonarSaldoEasyrewardsMutationResult = Apollo.MutationResult<AbonarSaldoEasyrewardsMutation>
export type AbonarSaldoEasyrewardsMutationOptions = Apollo.BaseMutationOptions<
    AbonarSaldoEasyrewardsMutation,
    AbonarSaldoEasyrewardsMutationVariables
>
export const DescontarSaldoEasyrewardsDocument = gql`
    mutation DescontarSaldoEasyrewards(
        $easyrewards_id: String!
        $folio_ticket: String!
        $hotel_id: ID!
        $puntos_descontar: Float!
    ) {
        descuenta_puntos(
            DescuentaPuntosInput: {
                easyrewards_id: $easyrewards_id
                folio_ticket: $folio_ticket
                hotel_id: $hotel_id
                puntos_descontar: $puntos_descontar
            }
        ) {
            saldo
        }
    }
`
export type DescontarSaldoEasyrewardsMutationFn = Apollo.MutationFunction<
    DescontarSaldoEasyrewardsMutation,
    DescontarSaldoEasyrewardsMutationVariables
>
export type DescontarSaldoEasyrewardsComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        DescontarSaldoEasyrewardsMutation,
        DescontarSaldoEasyrewardsMutationVariables
    >,
    "mutation"
>

export const DescontarSaldoEasyrewardsComponent = (props: DescontarSaldoEasyrewardsComponentProps) => (
    <ApolloReactComponents.Mutation<DescontarSaldoEasyrewardsMutation, DescontarSaldoEasyrewardsMutationVariables>
        mutation={DescontarSaldoEasyrewardsDocument}
        {...props}
    />
)

/**
 * __useDescontarSaldoEasyrewardsMutation__
 *
 * To run a mutation, you first call `useDescontarSaldoEasyrewardsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDescontarSaldoEasyrewardsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [descontarSaldoEasyrewardsMutation, { data, loading, error }] = useDescontarSaldoEasyrewardsMutation({
 *   variables: {
 *      easyrewards_id: // value for 'easyrewards_id'
 *      folio_ticket: // value for 'folio_ticket'
 *      hotel_id: // value for 'hotel_id'
 *      puntos_descontar: // value for 'puntos_descontar'
 *   },
 * });
 */
export function useDescontarSaldoEasyrewardsMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DescontarSaldoEasyrewardsMutation,
        DescontarSaldoEasyrewardsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<DescontarSaldoEasyrewardsMutation, DescontarSaldoEasyrewardsMutationVariables>(
        DescontarSaldoEasyrewardsDocument,
        options
    )
}
export type DescontarSaldoEasyrewardsMutationHookResult = ReturnType<typeof useDescontarSaldoEasyrewardsMutation>
export type DescontarSaldoEasyrewardsMutationResult = Apollo.MutationResult<DescontarSaldoEasyrewardsMutation>
export type DescontarSaldoEasyrewardsMutationOptions = Apollo.BaseMutationOptions<
    DescontarSaldoEasyrewardsMutation,
    DescontarSaldoEasyrewardsMutationVariables
>
export const Categorias_GastoDocument = gql`
    query Categorias_gasto($hotel_id: ID!, $subcat_eliminados: Boolean!) {
        categorias_gasto(hotel_id: $hotel_id, eliminado: false) {
            categoria
            categoria_id
            eliminado
            fecha_registro
            hotel_id
            limite_mensual
            predeterminado
            presupuesto
            usuario_id
            subcategorias_de_categoria(eliminado: $subcat_eliminados) {
                categoria_id
                eliminado
                subcategoria
                subcategoria_gasto_id
            }
        }
    }
`
export type Categorias_GastoComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<Categorias_GastoQuery, Categorias_GastoQueryVariables>,
    "query"
> &
    ({ variables: Categorias_GastoQueryVariables; skip?: boolean } | { skip: boolean })

export const Categorias_GastoComponent = (props: Categorias_GastoComponentProps) => (
    <ApolloReactComponents.Query<Categorias_GastoQuery, Categorias_GastoQueryVariables>
        query={Categorias_GastoDocument}
        {...props}
    />
)

/**
 * __useCategorias_GastoQuery__
 *
 * To run a query within a React component, call `useCategorias_GastoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategorias_GastoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategorias_GastoQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      subcat_eliminados: // value for 'subcat_eliminados'
 *   },
 * });
 */
export function useCategorias_GastoQuery(
    baseOptions: Apollo.QueryHookOptions<Categorias_GastoQuery, Categorias_GastoQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<Categorias_GastoQuery, Categorias_GastoQueryVariables>(Categorias_GastoDocument, options)
}
export function useCategorias_GastoLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<Categorias_GastoQuery, Categorias_GastoQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<Categorias_GastoQuery, Categorias_GastoQueryVariables>(Categorias_GastoDocument, options)
}
export type Categorias_GastoQueryHookResult = ReturnType<typeof useCategorias_GastoQuery>
export type Categorias_GastoLazyQueryHookResult = ReturnType<typeof useCategorias_GastoLazyQuery>
export type Categorias_GastoQueryResult = Apollo.QueryResult<Categorias_GastoQuery, Categorias_GastoQueryVariables>
export const GetGastoUnicoDocument = gql`
    query getGastoUnico($gastoId: ID!) {
        gasto(gasto_id: $gastoId) {
            categoria_id
            fecha_gasto
            fecha_registro
            hotel_id
            metodo_pago
            monto
            folio
            usuario_id
            categoria_gasto {
                categoria
                categoria_id
                subcategorias_gasto {
                    subcategoria
                    subcategoria_gasto_id
                }
            }
        }
    }
`
export type GetGastoUnicoComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetGastoUnicoQuery, GetGastoUnicoQueryVariables>,
    "query"
> &
    ({ variables: GetGastoUnicoQueryVariables; skip?: boolean } | { skip: boolean })

export const GetGastoUnicoComponent = (props: GetGastoUnicoComponentProps) => (
    <ApolloReactComponents.Query<GetGastoUnicoQuery, GetGastoUnicoQueryVariables>
        query={GetGastoUnicoDocument}
        {...props}
    />
)

/**
 * __useGetGastoUnicoQuery__
 *
 * To run a query within a React component, call `useGetGastoUnicoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGastoUnicoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGastoUnicoQuery({
 *   variables: {
 *      gastoId: // value for 'gastoId'
 *   },
 * });
 */
export function useGetGastoUnicoQuery(
    baseOptions: Apollo.QueryHookOptions<GetGastoUnicoQuery, GetGastoUnicoQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetGastoUnicoQuery, GetGastoUnicoQueryVariables>(GetGastoUnicoDocument, options)
}
export function useGetGastoUnicoLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetGastoUnicoQuery, GetGastoUnicoQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetGastoUnicoQuery, GetGastoUnicoQueryVariables>(GetGastoUnicoDocument, options)
}
export type GetGastoUnicoQueryHookResult = ReturnType<typeof useGetGastoUnicoQuery>
export type GetGastoUnicoLazyQueryHookResult = ReturnType<typeof useGetGastoUnicoLazyQuery>
export type GetGastoUnicoQueryResult = Apollo.QueryResult<GetGastoUnicoQuery, GetGastoUnicoQueryVariables>
export const GetCategoriaGastosDocument = gql`
    query getCategoriaGastos($hotel_id: ID!, $predeterminado: Boolean!, $usuario_id: ID!) {
        categorias_gasto(
            eliminado: false
            hotel_id: $hotel_id
            predeterminado: $predeterminado
            usuario_id: $usuario_id
        ) {
            categoria
            categoria_id
            presupuesto
            limite_mensual
            subcategorias_de_categoria {
                subcategoria
                subcategoria_gasto_id
            }
        }
    }
`
export type GetCategoriaGastosComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetCategoriaGastosQuery, GetCategoriaGastosQueryVariables>,
    "query"
> &
    ({ variables: GetCategoriaGastosQueryVariables; skip?: boolean } | { skip: boolean })

export const GetCategoriaGastosComponent = (props: GetCategoriaGastosComponentProps) => (
    <ApolloReactComponents.Query<GetCategoriaGastosQuery, GetCategoriaGastosQueryVariables>
        query={GetCategoriaGastosDocument}
        {...props}
    />
)

/**
 * __useGetCategoriaGastosQuery__
 *
 * To run a query within a React component, call `useGetCategoriaGastosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriaGastosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriaGastosQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      predeterminado: // value for 'predeterminado'
 *      usuario_id: // value for 'usuario_id'
 *   },
 * });
 */
export function useGetCategoriaGastosQuery(
    baseOptions: Apollo.QueryHookOptions<GetCategoriaGastosQuery, GetCategoriaGastosQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetCategoriaGastosQuery, GetCategoriaGastosQueryVariables>(
        GetCategoriaGastosDocument,
        options
    )
}
export function useGetCategoriaGastosLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriaGastosQuery, GetCategoriaGastosQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetCategoriaGastosQuery, GetCategoriaGastosQueryVariables>(
        GetCategoriaGastosDocument,
        options
    )
}
export type GetCategoriaGastosQueryHookResult = ReturnType<typeof useGetCategoriaGastosQuery>
export type GetCategoriaGastosLazyQueryHookResult = ReturnType<typeof useGetCategoriaGastosLazyQuery>
export type GetCategoriaGastosQueryResult = Apollo.QueryResult<
    GetCategoriaGastosQuery,
    GetCategoriaGastosQueryVariables
>
export const GetSubCategoriasDocument = gql`
    query GetSubCategorias {
        subcategorias_gasto(eliminado: false) {
            subcategoria
            subcategoria_gasto_id
            categoria_gasto {
                categoria
                categoria_id
            }
        }
    }
`
export type GetSubCategoriasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetSubCategoriasQuery, GetSubCategoriasQueryVariables>,
    "query"
>

export const GetSubCategoriasComponent = (props: GetSubCategoriasComponentProps) => (
    <ApolloReactComponents.Query<GetSubCategoriasQuery, GetSubCategoriasQueryVariables>
        query={GetSubCategoriasDocument}
        {...props}
    />
)

/**
 * __useGetSubCategoriasQuery__
 *
 * To run a query within a React component, call `useGetSubCategoriasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubCategoriasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubCategoriasQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubCategoriasQuery(
    baseOptions?: Apollo.QueryHookOptions<GetSubCategoriasQuery, GetSubCategoriasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetSubCategoriasQuery, GetSubCategoriasQueryVariables>(GetSubCategoriasDocument, options)
}
export function useGetSubCategoriasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetSubCategoriasQuery, GetSubCategoriasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetSubCategoriasQuery, GetSubCategoriasQueryVariables>(GetSubCategoriasDocument, options)
}
export type GetSubCategoriasQueryHookResult = ReturnType<typeof useGetSubCategoriasQuery>
export type GetSubCategoriasLazyQueryHookResult = ReturnType<typeof useGetSubCategoriasLazyQuery>
export type GetSubCategoriasQueryResult = Apollo.QueryResult<GetSubCategoriasQuery, GetSubCategoriasQueryVariables>
export const CrearGastosDocument = gql`
    mutation CrearGastos($datosGasto: CreateGastoInput!) {
        crear_gasto(datos_gastos: $datosGasto) {
            ticket_id
            gasto {
                fecha_gasto
                gasto_id
            }
        }
    }
`
export type CrearGastosMutationFn = Apollo.MutationFunction<CrearGastosMutation, CrearGastosMutationVariables>
export type CrearGastosComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CrearGastosMutation, CrearGastosMutationVariables>,
    "mutation"
>

export const CrearGastosComponent = (props: CrearGastosComponentProps) => (
    <ApolloReactComponents.Mutation<CrearGastosMutation, CrearGastosMutationVariables>
        mutation={CrearGastosDocument}
        {...props}
    />
)

/**
 * __useCrearGastosMutation__
 *
 * To run a mutation, you first call `useCrearGastosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrearGastosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crearGastosMutation, { data, loading, error }] = useCrearGastosMutation({
 *   variables: {
 *      datosGasto: // value for 'datosGasto'
 *   },
 * });
 */
export function useCrearGastosMutation(
    baseOptions?: Apollo.MutationHookOptions<CrearGastosMutation, CrearGastosMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CrearGastosMutation, CrearGastosMutationVariables>(CrearGastosDocument, options)
}
export type CrearGastosMutationHookResult = ReturnType<typeof useCrearGastosMutation>
export type CrearGastosMutationResult = Apollo.MutationResult<CrearGastosMutation>
export type CrearGastosMutationOptions = Apollo.BaseMutationOptions<CrearGastosMutation, CrearGastosMutationVariables>
export const CrearCategoriaGastoDocument = gql`
    mutation CrearCategoriaGasto($crearCategoriaGasto: CreateCategoriasGastosInput!) {
        crear_categoria_gasto(categoria_gasto_data: $crearCategoriaGasto) {
            categoria
        }
    }
`
export type CrearCategoriaGastoMutationFn = Apollo.MutationFunction<
    CrearCategoriaGastoMutation,
    CrearCategoriaGastoMutationVariables
>
export type CrearCategoriaGastoComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CrearCategoriaGastoMutation, CrearCategoriaGastoMutationVariables>,
    "mutation"
>

export const CrearCategoriaGastoComponent = (props: CrearCategoriaGastoComponentProps) => (
    <ApolloReactComponents.Mutation<CrearCategoriaGastoMutation, CrearCategoriaGastoMutationVariables>
        mutation={CrearCategoriaGastoDocument}
        {...props}
    />
)

/**
 * __useCrearCategoriaGastoMutation__
 *
 * To run a mutation, you first call `useCrearCategoriaGastoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrearCategoriaGastoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crearCategoriaGastoMutation, { data, loading, error }] = useCrearCategoriaGastoMutation({
 *   variables: {
 *      crearCategoriaGasto: // value for 'crearCategoriaGasto'
 *   },
 * });
 */
export function useCrearCategoriaGastoMutation(
    baseOptions?: Apollo.MutationHookOptions<CrearCategoriaGastoMutation, CrearCategoriaGastoMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CrearCategoriaGastoMutation, CrearCategoriaGastoMutationVariables>(
        CrearCategoriaGastoDocument,
        options
    )
}
export type CrearCategoriaGastoMutationHookResult = ReturnType<typeof useCrearCategoriaGastoMutation>
export type CrearCategoriaGastoMutationResult = Apollo.MutationResult<CrearCategoriaGastoMutation>
export type CrearCategoriaGastoMutationOptions = Apollo.BaseMutationOptions<
    CrearCategoriaGastoMutation,
    CrearCategoriaGastoMutationVariables
>
export const CreateSubCategoriDocument = gql`
    mutation CreateSubCategori($subCat: CreateSubcategoriasGastosInput!) {
        crear_subcategoria_gasto(subcategoria_gasto_data: $subCat) {
            subcategoria
            subcategoria_gasto_id
        }
    }
`
export type CreateSubCategoriMutationFn = Apollo.MutationFunction<
    CreateSubCategoriMutation,
    CreateSubCategoriMutationVariables
>
export type CreateSubCategoriComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CreateSubCategoriMutation, CreateSubCategoriMutationVariables>,
    "mutation"
>

export const CreateSubCategoriComponent = (props: CreateSubCategoriComponentProps) => (
    <ApolloReactComponents.Mutation<CreateSubCategoriMutation, CreateSubCategoriMutationVariables>
        mutation={CreateSubCategoriDocument}
        {...props}
    />
)

/**
 * __useCreateSubCategoriMutation__
 *
 * To run a mutation, you first call `useCreateSubCategoriMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubCategoriMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubCategoriMutation, { data, loading, error }] = useCreateSubCategoriMutation({
 *   variables: {
 *      subCat: // value for 'subCat'
 *   },
 * });
 */
export function useCreateSubCategoriMutation(
    baseOptions?: Apollo.MutationHookOptions<CreateSubCategoriMutation, CreateSubCategoriMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CreateSubCategoriMutation, CreateSubCategoriMutationVariables>(
        CreateSubCategoriDocument,
        options
    )
}
export type CreateSubCategoriMutationHookResult = ReturnType<typeof useCreateSubCategoriMutation>
export type CreateSubCategoriMutationResult = Apollo.MutationResult<CreateSubCategoriMutation>
export type CreateSubCategoriMutationOptions = Apollo.BaseMutationOptions<
    CreateSubCategoriMutation,
    CreateSubCategoriMutationVariables
>
export const DeleteCategoriaGastosDocument = gql`
    mutation DeleteCategoriaGastos($deleteGastoCatergoria: DeleteCategoriaGastosInput!) {
        eliminar_categoria_gasto(categoria_gasto_data: $deleteGastoCatergoria) {
            categoria
            categoria_id
        }
    }
`
export type DeleteCategoriaGastosMutationFn = Apollo.MutationFunction<
    DeleteCategoriaGastosMutation,
    DeleteCategoriaGastosMutationVariables
>
export type DeleteCategoriaGastosComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        DeleteCategoriaGastosMutation,
        DeleteCategoriaGastosMutationVariables
    >,
    "mutation"
>

export const DeleteCategoriaGastosComponent = (props: DeleteCategoriaGastosComponentProps) => (
    <ApolloReactComponents.Mutation<DeleteCategoriaGastosMutation, DeleteCategoriaGastosMutationVariables>
        mutation={DeleteCategoriaGastosDocument}
        {...props}
    />
)

/**
 * __useDeleteCategoriaGastosMutation__
 *
 * To run a mutation, you first call `useDeleteCategoriaGastosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCategoriaGastosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCategoriaGastosMutation, { data, loading, error }] = useDeleteCategoriaGastosMutation({
 *   variables: {
 *      deleteGastoCatergoria: // value for 'deleteGastoCatergoria'
 *   },
 * });
 */
export function useDeleteCategoriaGastosMutation(
    baseOptions?: Apollo.MutationHookOptions<DeleteCategoriaGastosMutation, DeleteCategoriaGastosMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<DeleteCategoriaGastosMutation, DeleteCategoriaGastosMutationVariables>(
        DeleteCategoriaGastosDocument,
        options
    )
}
export type DeleteCategoriaGastosMutationHookResult = ReturnType<typeof useDeleteCategoriaGastosMutation>
export type DeleteCategoriaGastosMutationResult = Apollo.MutationResult<DeleteCategoriaGastosMutation>
export type DeleteCategoriaGastosMutationOptions = Apollo.BaseMutationOptions<
    DeleteCategoriaGastosMutation,
    DeleteCategoriaGastosMutationVariables
>
export const DeleteSubCategoriaDocument = gql`
    mutation DeleteSubCategoria($id: DeleteSubcategoriaGastoInput!) {
        eliminar_subcategoria_gasto(subcategoria_gasto_data: $id) {
            subcategoria
            categoria_id
        }
    }
`
export type DeleteSubCategoriaMutationFn = Apollo.MutationFunction<
    DeleteSubCategoriaMutation,
    DeleteSubCategoriaMutationVariables
>
export type DeleteSubCategoriaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<DeleteSubCategoriaMutation, DeleteSubCategoriaMutationVariables>,
    "mutation"
>

export const DeleteSubCategoriaComponent = (props: DeleteSubCategoriaComponentProps) => (
    <ApolloReactComponents.Mutation<DeleteSubCategoriaMutation, DeleteSubCategoriaMutationVariables>
        mutation={DeleteSubCategoriaDocument}
        {...props}
    />
)

/**
 * __useDeleteSubCategoriaMutation__
 *
 * To run a mutation, you first call `useDeleteSubCategoriaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubCategoriaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubCategoriaMutation, { data, loading, error }] = useDeleteSubCategoriaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSubCategoriaMutation(
    baseOptions?: Apollo.MutationHookOptions<DeleteSubCategoriaMutation, DeleteSubCategoriaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<DeleteSubCategoriaMutation, DeleteSubCategoriaMutationVariables>(
        DeleteSubCategoriaDocument,
        options
    )
}
export type DeleteSubCategoriaMutationHookResult = ReturnType<typeof useDeleteSubCategoriaMutation>
export type DeleteSubCategoriaMutationResult = Apollo.MutationResult<DeleteSubCategoriaMutation>
export type DeleteSubCategoriaMutationOptions = Apollo.BaseMutationOptions<
    DeleteSubCategoriaMutation,
    DeleteSubCategoriaMutationVariables
>
export const DeleteGastoDocument = gql`
    mutation DeleteGasto($idGasto: DeleteGastoInput!) {
        borrar_gasto(datos_gasto: $idGasto) {
            gasto_id
        }
    }
`
export type DeleteGastoMutationFn = Apollo.MutationFunction<DeleteGastoMutation, DeleteGastoMutationVariables>
export type DeleteGastoComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<DeleteGastoMutation, DeleteGastoMutationVariables>,
    "mutation"
>

export const DeleteGastoComponent = (props: DeleteGastoComponentProps) => (
    <ApolloReactComponents.Mutation<DeleteGastoMutation, DeleteGastoMutationVariables>
        mutation={DeleteGastoDocument}
        {...props}
    />
)

/**
 * __useDeleteGastoMutation__
 *
 * To run a mutation, you first call `useDeleteGastoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGastoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGastoMutation, { data, loading, error }] = useDeleteGastoMutation({
 *   variables: {
 *      idGasto: // value for 'idGasto'
 *   },
 * });
 */
export function useDeleteGastoMutation(
    baseOptions?: Apollo.MutationHookOptions<DeleteGastoMutation, DeleteGastoMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<DeleteGastoMutation, DeleteGastoMutationVariables>(DeleteGastoDocument, options)
}
export type DeleteGastoMutationHookResult = ReturnType<typeof useDeleteGastoMutation>
export type DeleteGastoMutationResult = Apollo.MutationResult<DeleteGastoMutation>
export type DeleteGastoMutationOptions = Apollo.BaseMutationOptions<DeleteGastoMutation, DeleteGastoMutationVariables>
export const ActualizasGastoDocument = gql`
    mutation ActualizasGasto($ActualizarGasto: UpdateGastoInput!) {
        actualizar_gasto(datos_gastos: $ActualizarGasto) {
            folio
            gasto_id
        }
    }
`
export type ActualizasGastoMutationFn = Apollo.MutationFunction<
    ActualizasGastoMutation,
    ActualizasGastoMutationVariables
>
export type ActualizasGastoComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<ActualizasGastoMutation, ActualizasGastoMutationVariables>,
    "mutation"
>

export const ActualizasGastoComponent = (props: ActualizasGastoComponentProps) => (
    <ApolloReactComponents.Mutation<ActualizasGastoMutation, ActualizasGastoMutationVariables>
        mutation={ActualizasGastoDocument}
        {...props}
    />
)

/**
 * __useActualizasGastoMutation__
 *
 * To run a mutation, you first call `useActualizasGastoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizasGastoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizasGastoMutation, { data, loading, error }] = useActualizasGastoMutation({
 *   variables: {
 *      ActualizarGasto: // value for 'ActualizarGasto'
 *   },
 * });
 */
export function useActualizasGastoMutation(
    baseOptions?: Apollo.MutationHookOptions<ActualizasGastoMutation, ActualizasGastoMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ActualizasGastoMutation, ActualizasGastoMutationVariables>(
        ActualizasGastoDocument,
        options
    )
}
export type ActualizasGastoMutationHookResult = ReturnType<typeof useActualizasGastoMutation>
export type ActualizasGastoMutationResult = Apollo.MutationResult<ActualizasGastoMutation>
export type ActualizasGastoMutationOptions = Apollo.BaseMutationOptions<
    ActualizasGastoMutation,
    ActualizasGastoMutationVariables
>
export const GetGastosDelMesDocument = gql`
    query GetGastosDelMes($hotel_id: ID, $month: String!, $caja_chica: Boolean) {
        gastos_por_mes(hotel_id: $hotel_id, month: $month, caja_chica: $caja_chica) {
            total_gasto
            gastos {
                gasto_id
                metodo_pago
                usuario_id
                folio
                monto
                comentarios
                categoria_id
                usuario {
                    nombre
                    apellido_materno
                    apellido_paterno
                }
                hotel_id
                subcategoria_id
                categoria_id
                categoria_gasto {
                    categoria
                    categoria_id
                    subcategorias_gasto {
                        subcategoria
                        subcategoria_gasto_id
                    }
                }
                fecha_gasto
                fecha_registro
            }
        }
    }
`
export type GetGastosDelMesComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetGastosDelMesQuery, GetGastosDelMesQueryVariables>,
    "query"
> &
    ({ variables: GetGastosDelMesQueryVariables; skip?: boolean } | { skip: boolean })

export const GetGastosDelMesComponent = (props: GetGastosDelMesComponentProps) => (
    <ApolloReactComponents.Query<GetGastosDelMesQuery, GetGastosDelMesQueryVariables>
        query={GetGastosDelMesDocument}
        {...props}
    />
)

/**
 * __useGetGastosDelMesQuery__
 *
 * To run a query within a React component, call `useGetGastosDelMesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGastosDelMesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGastosDelMesQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      month: // value for 'month'
 *      caja_chica: // value for 'caja_chica'
 *   },
 * });
 */
export function useGetGastosDelMesQuery(
    baseOptions: Apollo.QueryHookOptions<GetGastosDelMesQuery, GetGastosDelMesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetGastosDelMesQuery, GetGastosDelMesQueryVariables>(GetGastosDelMesDocument, options)
}
export function useGetGastosDelMesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetGastosDelMesQuery, GetGastosDelMesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetGastosDelMesQuery, GetGastosDelMesQueryVariables>(GetGastosDelMesDocument, options)
}
export type GetGastosDelMesQueryHookResult = ReturnType<typeof useGetGastosDelMesQuery>
export type GetGastosDelMesLazyQueryHookResult = ReturnType<typeof useGetGastosDelMesLazyQuery>
export type GetGastosDelMesQueryResult = Apollo.QueryResult<GetGastosDelMesQuery, GetGastosDelMesQueryVariables>
export const GetGastosCategorasPorMesDocument = gql`
    query getGastosCategorasPorMes($gastosCategoria: String!, $hotel_id: ID!) {
        gastos_categoria_por_mes(month: $gastosCategoria, hotel_id: $hotel_id) {
            porcentaje
            total_gasto
            categoria {
                categoria
                presupuesto
                subcategorias_de_categoria {
                    subcategoria
                    subcategoria_gasto_id
                }
            }
            subcategorias {
                monto
                subcategoria
                subcategoria_gasto_id
            }
        }
    }
`
export type GetGastosCategorasPorMesComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetGastosCategorasPorMesQuery, GetGastosCategorasPorMesQueryVariables>,
    "query"
> &
    ({ variables: GetGastosCategorasPorMesQueryVariables; skip?: boolean } | { skip: boolean })

export const GetGastosCategorasPorMesComponent = (props: GetGastosCategorasPorMesComponentProps) => (
    <ApolloReactComponents.Query<GetGastosCategorasPorMesQuery, GetGastosCategorasPorMesQueryVariables>
        query={GetGastosCategorasPorMesDocument}
        {...props}
    />
)

/**
 * __useGetGastosCategorasPorMesQuery__
 *
 * To run a query within a React component, call `useGetGastosCategorasPorMesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGastosCategorasPorMesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGastosCategorasPorMesQuery({
 *   variables: {
 *      gastosCategoria: // value for 'gastosCategoria'
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetGastosCategorasPorMesQuery(
    baseOptions: Apollo.QueryHookOptions<GetGastosCategorasPorMesQuery, GetGastosCategorasPorMesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetGastosCategorasPorMesQuery, GetGastosCategorasPorMesQueryVariables>(
        GetGastosCategorasPorMesDocument,
        options
    )
}
export function useGetGastosCategorasPorMesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetGastosCategorasPorMesQuery, GetGastosCategorasPorMesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetGastosCategorasPorMesQuery, GetGastosCategorasPorMesQueryVariables>(
        GetGastosCategorasPorMesDocument,
        options
    )
}
export type GetGastosCategorasPorMesQueryHookResult = ReturnType<typeof useGetGastosCategorasPorMesQuery>
export type GetGastosCategorasPorMesLazyQueryHookResult = ReturnType<typeof useGetGastosCategorasPorMesLazyQuery>
export type GetGastosCategorasPorMesQueryResult = Apollo.QueryResult<
    GetGastosCategorasPorMesQuery,
    GetGastosCategorasPorMesQueryVariables
>
export const GetGastosCategorasPorMesCardsDocument = gql`
    query getGastosCategorasPorMesCards($gastosCategoria: String!, $hotel_id: ID!, $mes_y_anio: String!) {
        gastos_categoria_por_mes(month: $gastosCategoria, hotel_id: $hotel_id, mes_y_anio: $mes_y_anio) {
            porcentaje
            total_gasto
            categoria {
                categoria
                presupuesto
            }
        }
    }
`
export type GetGastosCategorasPorMesCardsComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetGastosCategorasPorMesCardsQuery,
        GetGastosCategorasPorMesCardsQueryVariables
    >,
    "query"
> &
    ({ variables: GetGastosCategorasPorMesCardsQueryVariables; skip?: boolean } | { skip: boolean })

export const GetGastosCategorasPorMesCardsComponent = (props: GetGastosCategorasPorMesCardsComponentProps) => (
    <ApolloReactComponents.Query<GetGastosCategorasPorMesCardsQuery, GetGastosCategorasPorMesCardsQueryVariables>
        query={GetGastosCategorasPorMesCardsDocument}
        {...props}
    />
)

/**
 * __useGetGastosCategorasPorMesCardsQuery__
 *
 * To run a query within a React component, call `useGetGastosCategorasPorMesCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGastosCategorasPorMesCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGastosCategorasPorMesCardsQuery({
 *   variables: {
 *      gastosCategoria: // value for 'gastosCategoria'
 *      hotel_id: // value for 'hotel_id'
 *      mes_y_anio: // value for 'mes_y_anio'
 *   },
 * });
 */
export function useGetGastosCategorasPorMesCardsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetGastosCategorasPorMesCardsQuery,
        GetGastosCategorasPorMesCardsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetGastosCategorasPorMesCardsQuery, GetGastosCategorasPorMesCardsQueryVariables>(
        GetGastosCategorasPorMesCardsDocument,
        options
    )
}
export function useGetGastosCategorasPorMesCardsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetGastosCategorasPorMesCardsQuery,
        GetGastosCategorasPorMesCardsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetGastosCategorasPorMesCardsQuery, GetGastosCategorasPorMesCardsQueryVariables>(
        GetGastosCategorasPorMesCardsDocument,
        options
    )
}
export type GetGastosCategorasPorMesCardsQueryHookResult = ReturnType<typeof useGetGastosCategorasPorMesCardsQuery>
export type GetGastosCategorasPorMesCardsLazyQueryHookResult = ReturnType<
    typeof useGetGastosCategorasPorMesCardsLazyQuery
>
export type GetGastosCategorasPorMesCardsQueryResult = Apollo.QueryResult<
    GetGastosCategorasPorMesCardsQuery,
    GetGastosCategorasPorMesCardsQueryVariables
>
export const TotalesGastosSubcategoriaPorCategoriaCardsDocument = gql`
    query TotalesGastosSubcategoriaPorCategoriaCards(
        $hotel_id: ID!
        $mes_y_anio: String!
        $categoria_id: ID!
        $cantidad_categorias: Int!
    ) {
        totales_gastos_subcategoria_por_categoria(
            hotel_id: $hotel_id
            mes_y_anio: $mes_y_anio
            categoria_id: $categoria_id
            cantidad_categorias: $cantidad_categorias
        ) {
            total_gasto
            porcentaje
            categoria {
                categoria_id
                categoria
            }
            subcategorias {
                subcategoria_gasto_id
                subcategoria
                monto
                porcentaje
            }
        }
    }
`
export type TotalesGastosSubcategoriaPorCategoriaCardsComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        TotalesGastosSubcategoriaPorCategoriaCardsQuery,
        TotalesGastosSubcategoriaPorCategoriaCardsQueryVariables
    >,
    "query"
> &
    ({ variables: TotalesGastosSubcategoriaPorCategoriaCardsQueryVariables; skip?: boolean } | { skip: boolean })

export const TotalesGastosSubcategoriaPorCategoriaCardsComponent = (
    props: TotalesGastosSubcategoriaPorCategoriaCardsComponentProps
) => (
    <ApolloReactComponents.Query<
        TotalesGastosSubcategoriaPorCategoriaCardsQuery,
        TotalesGastosSubcategoriaPorCategoriaCardsQueryVariables
    >
        query={TotalesGastosSubcategoriaPorCategoriaCardsDocument}
        {...props}
    />
)

/**
 * __useTotalesGastosSubcategoriaPorCategoriaCardsQuery__
 *
 * To run a query within a React component, call `useTotalesGastosSubcategoriaPorCategoriaCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalesGastosSubcategoriaPorCategoriaCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalesGastosSubcategoriaPorCategoriaCardsQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      mes_y_anio: // value for 'mes_y_anio'
 *      categoria_id: // value for 'categoria_id'
 *      cantidad_categorias: // value for 'cantidad_categorias'
 *   },
 * });
 */
export function useTotalesGastosSubcategoriaPorCategoriaCardsQuery(
    baseOptions: Apollo.QueryHookOptions<
        TotalesGastosSubcategoriaPorCategoriaCardsQuery,
        TotalesGastosSubcategoriaPorCategoriaCardsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        TotalesGastosSubcategoriaPorCategoriaCardsQuery,
        TotalesGastosSubcategoriaPorCategoriaCardsQueryVariables
    >(TotalesGastosSubcategoriaPorCategoriaCardsDocument, options)
}
export function useTotalesGastosSubcategoriaPorCategoriaCardsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        TotalesGastosSubcategoriaPorCategoriaCardsQuery,
        TotalesGastosSubcategoriaPorCategoriaCardsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        TotalesGastosSubcategoriaPorCategoriaCardsQuery,
        TotalesGastosSubcategoriaPorCategoriaCardsQueryVariables
    >(TotalesGastosSubcategoriaPorCategoriaCardsDocument, options)
}
export type TotalesGastosSubcategoriaPorCategoriaCardsQueryHookResult = ReturnType<
    typeof useTotalesGastosSubcategoriaPorCategoriaCardsQuery
>
export type TotalesGastosSubcategoriaPorCategoriaCardsLazyQueryHookResult = ReturnType<
    typeof useTotalesGastosSubcategoriaPorCategoriaCardsLazyQuery
>
export type TotalesGastosSubcategoriaPorCategoriaCardsQueryResult = Apollo.QueryResult<
    TotalesGastosSubcategoriaPorCategoriaCardsQuery,
    TotalesGastosSubcategoriaPorCategoriaCardsQueryVariables
>
export const Total_Gastos_Por_Dia_RecepcionistaDocument = gql`
    query Total_gastos_por_dia_recepcionista($category_id: ID, $hotel_id: ID!) {
        total_gastos_por_dia_recepcionista(categoria_id: $category_id, hotel_id: $hotel_id) {
            total_gasto
        }
    }
`
export type Total_Gastos_Por_Dia_RecepcionistaComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        Total_Gastos_Por_Dia_RecepcionistaQuery,
        Total_Gastos_Por_Dia_RecepcionistaQueryVariables
    >,
    "query"
> &
    ({ variables: Total_Gastos_Por_Dia_RecepcionistaQueryVariables; skip?: boolean } | { skip: boolean })

export const Total_Gastos_Por_Dia_RecepcionistaComponent = (
    props: Total_Gastos_Por_Dia_RecepcionistaComponentProps
) => (
    <ApolloReactComponents.Query<
        Total_Gastos_Por_Dia_RecepcionistaQuery,
        Total_Gastos_Por_Dia_RecepcionistaQueryVariables
    >
        query={Total_Gastos_Por_Dia_RecepcionistaDocument}
        {...props}
    />
)

/**
 * __useTotal_Gastos_Por_Dia_RecepcionistaQuery__
 *
 * To run a query within a React component, call `useTotal_Gastos_Por_Dia_RecepcionistaQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotal_Gastos_Por_Dia_RecepcionistaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotal_Gastos_Por_Dia_RecepcionistaQuery({
 *   variables: {
 *      category_id: // value for 'category_id'
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useTotal_Gastos_Por_Dia_RecepcionistaQuery(
    baseOptions: Apollo.QueryHookOptions<
        Total_Gastos_Por_Dia_RecepcionistaQuery,
        Total_Gastos_Por_Dia_RecepcionistaQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<Total_Gastos_Por_Dia_RecepcionistaQuery, Total_Gastos_Por_Dia_RecepcionistaQueryVariables>(
        Total_Gastos_Por_Dia_RecepcionistaDocument,
        options
    )
}
export function useTotal_Gastos_Por_Dia_RecepcionistaLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        Total_Gastos_Por_Dia_RecepcionistaQuery,
        Total_Gastos_Por_Dia_RecepcionistaQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        Total_Gastos_Por_Dia_RecepcionistaQuery,
        Total_Gastos_Por_Dia_RecepcionistaQueryVariables
    >(Total_Gastos_Por_Dia_RecepcionistaDocument, options)
}
export type Total_Gastos_Por_Dia_RecepcionistaQueryHookResult = ReturnType<
    typeof useTotal_Gastos_Por_Dia_RecepcionistaQuery
>
export type Total_Gastos_Por_Dia_RecepcionistaLazyQueryHookResult = ReturnType<
    typeof useTotal_Gastos_Por_Dia_RecepcionistaLazyQuery
>
export type Total_Gastos_Por_Dia_RecepcionistaQueryResult = Apollo.QueryResult<
    Total_Gastos_Por_Dia_RecepcionistaQuery,
    Total_Gastos_Por_Dia_RecepcionistaQueryVariables
>
export const Categorias_Gasto_Con_EliminadasDocument = gql`
    query Categorias_gasto_Con_eliminadas($hotel_id: ID!, $mes_y_anio: String!) {
        categorias_gasto(hotel_id: $hotel_id) {
            categoria
            categoria_id
            eliminado
            fecha_registro
            hotel_id
            limite_mensual
            predeterminado
            presupuesto
            usuario_id
            subcategorias_de_categoria(mes_y_anio: { mes_y_anio: $mes_y_anio }, eliminado: false) {
                categoria_id
                eliminado
                subcategoria
                subcategoria_gasto_id
            }
        }
    }
`
export type Categorias_Gasto_Con_EliminadasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        Categorias_Gasto_Con_EliminadasQuery,
        Categorias_Gasto_Con_EliminadasQueryVariables
    >,
    "query"
> &
    ({ variables: Categorias_Gasto_Con_EliminadasQueryVariables; skip?: boolean } | { skip: boolean })

export const Categorias_Gasto_Con_EliminadasComponent = (props: Categorias_Gasto_Con_EliminadasComponentProps) => (
    <ApolloReactComponents.Query<Categorias_Gasto_Con_EliminadasQuery, Categorias_Gasto_Con_EliminadasQueryVariables>
        query={Categorias_Gasto_Con_EliminadasDocument}
        {...props}
    />
)

/**
 * __useCategorias_Gasto_Con_EliminadasQuery__
 *
 * To run a query within a React component, call `useCategorias_Gasto_Con_EliminadasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategorias_Gasto_Con_EliminadasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategorias_Gasto_Con_EliminadasQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      mes_y_anio: // value for 'mes_y_anio'
 *   },
 * });
 */
export function useCategorias_Gasto_Con_EliminadasQuery(
    baseOptions: Apollo.QueryHookOptions<
        Categorias_Gasto_Con_EliminadasQuery,
        Categorias_Gasto_Con_EliminadasQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<Categorias_Gasto_Con_EliminadasQuery, Categorias_Gasto_Con_EliminadasQueryVariables>(
        Categorias_Gasto_Con_EliminadasDocument,
        options
    )
}
export function useCategorias_Gasto_Con_EliminadasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        Categorias_Gasto_Con_EliminadasQuery,
        Categorias_Gasto_Con_EliminadasQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<Categorias_Gasto_Con_EliminadasQuery, Categorias_Gasto_Con_EliminadasQueryVariables>(
        Categorias_Gasto_Con_EliminadasDocument,
        options
    )
}
export type Categorias_Gasto_Con_EliminadasQueryHookResult = ReturnType<typeof useCategorias_Gasto_Con_EliminadasQuery>
export type Categorias_Gasto_Con_EliminadasLazyQueryHookResult = ReturnType<
    typeof useCategorias_Gasto_Con_EliminadasLazyQuery
>
export type Categorias_Gasto_Con_EliminadasQueryResult = Apollo.QueryResult<
    Categorias_Gasto_Con_EliminadasQuery,
    Categorias_Gasto_Con_EliminadasQueryVariables
>
export const Categorias_Gasto_Sin_EliminadasDocument = gql`
    query Categorias_gasto_Sin_eliminadas($hotel_id: ID!) {
        categorias_gasto(hotel_id: $hotel_id) {
            categoria
            categoria_id
            eliminado
            fecha_registro
            hotel_id
            limite_mensual
            predeterminado
            presupuesto
            usuario_id
            subcategorias_de_categoria(eliminado: false) {
                categoria_id
                eliminado
                subcategoria
                subcategoria_gasto_id
            }
        }
    }
`
export type Categorias_Gasto_Sin_EliminadasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        Categorias_Gasto_Sin_EliminadasQuery,
        Categorias_Gasto_Sin_EliminadasQueryVariables
    >,
    "query"
> &
    ({ variables: Categorias_Gasto_Sin_EliminadasQueryVariables; skip?: boolean } | { skip: boolean })

export const Categorias_Gasto_Sin_EliminadasComponent = (props: Categorias_Gasto_Sin_EliminadasComponentProps) => (
    <ApolloReactComponents.Query<Categorias_Gasto_Sin_EliminadasQuery, Categorias_Gasto_Sin_EliminadasQueryVariables>
        query={Categorias_Gasto_Sin_EliminadasDocument}
        {...props}
    />
)

/**
 * __useCategorias_Gasto_Sin_EliminadasQuery__
 *
 * To run a query within a React component, call `useCategorias_Gasto_Sin_EliminadasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategorias_Gasto_Sin_EliminadasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategorias_Gasto_Sin_EliminadasQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useCategorias_Gasto_Sin_EliminadasQuery(
    baseOptions: Apollo.QueryHookOptions<
        Categorias_Gasto_Sin_EliminadasQuery,
        Categorias_Gasto_Sin_EliminadasQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<Categorias_Gasto_Sin_EliminadasQuery, Categorias_Gasto_Sin_EliminadasQueryVariables>(
        Categorias_Gasto_Sin_EliminadasDocument,
        options
    )
}
export function useCategorias_Gasto_Sin_EliminadasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        Categorias_Gasto_Sin_EliminadasQuery,
        Categorias_Gasto_Sin_EliminadasQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<Categorias_Gasto_Sin_EliminadasQuery, Categorias_Gasto_Sin_EliminadasQueryVariables>(
        Categorias_Gasto_Sin_EliminadasDocument,
        options
    )
}
export type Categorias_Gasto_Sin_EliminadasQueryHookResult = ReturnType<typeof useCategorias_Gasto_Sin_EliminadasQuery>
export type Categorias_Gasto_Sin_EliminadasLazyQueryHookResult = ReturnType<
    typeof useCategorias_Gasto_Sin_EliminadasLazyQuery
>
export type Categorias_Gasto_Sin_EliminadasQueryResult = Apollo.QueryResult<
    Categorias_Gasto_Sin_EliminadasQuery,
    Categorias_Gasto_Sin_EliminadasQueryVariables
>
export const GetCategorasGastosPorMesDocument = gql`
    query getCategorasGastosPorMes($gastosCategoria: String!, $hotel_id: ID!, $mes_y_anio: String!) {
        gastos_categoria_por_mes(month: $gastosCategoria, hotel_id: $hotel_id, mes_y_anio: $mes_y_anio) {
            porcentaje
            total_gasto
            categoria {
                categoria
                presupuesto
                subcategorias_de_categoria {
                    subcategoria
                    subcategoria_gasto_id
                }
            }
            subcategorias {
                monto
                subcategoria
                subcategoria_gasto_id
            }
        }
    }
`
export type GetCategorasGastosPorMesComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetCategorasGastosPorMesQuery, GetCategorasGastosPorMesQueryVariables>,
    "query"
> &
    ({ variables: GetCategorasGastosPorMesQueryVariables; skip?: boolean } | { skip: boolean })

export const GetCategorasGastosPorMesComponent = (props: GetCategorasGastosPorMesComponentProps) => (
    <ApolloReactComponents.Query<GetCategorasGastosPorMesQuery, GetCategorasGastosPorMesQueryVariables>
        query={GetCategorasGastosPorMesDocument}
        {...props}
    />
)

/**
 * __useGetCategorasGastosPorMesQuery__
 *
 * To run a query within a React component, call `useGetCategorasGastosPorMesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategorasGastosPorMesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategorasGastosPorMesQuery({
 *   variables: {
 *      gastosCategoria: // value for 'gastosCategoria'
 *      hotel_id: // value for 'hotel_id'
 *      mes_y_anio: // value for 'mes_y_anio'
 *   },
 * });
 */
export function useGetCategorasGastosPorMesQuery(
    baseOptions: Apollo.QueryHookOptions<GetCategorasGastosPorMesQuery, GetCategorasGastosPorMesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetCategorasGastosPorMesQuery, GetCategorasGastosPorMesQueryVariables>(
        GetCategorasGastosPorMesDocument,
        options
    )
}
export function useGetCategorasGastosPorMesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetCategorasGastosPorMesQuery, GetCategorasGastosPorMesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetCategorasGastosPorMesQuery, GetCategorasGastosPorMesQueryVariables>(
        GetCategorasGastosPorMesDocument,
        options
    )
}
export type GetCategorasGastosPorMesQueryHookResult = ReturnType<typeof useGetCategorasGastosPorMesQuery>
export type GetCategorasGastosPorMesLazyQueryHookResult = ReturnType<typeof useGetCategorasGastosPorMesLazyQuery>
export type GetCategorasGastosPorMesQueryResult = Apollo.QueryResult<
    GetCategorasGastosPorMesQuery,
    GetCategorasGastosPorMesQueryVariables
>
export const Categorias_GastoFilterDocument = gql`
    query Categorias_gastoFilter($hotel_id: ID!) {
        categorias_gasto(hotel_id: $hotel_id, eliminado: false) {
            categoria
            categoria_id
        }
    }
`
export type Categorias_GastoFilterComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<Categorias_GastoFilterQuery, Categorias_GastoFilterQueryVariables>,
    "query"
> &
    ({ variables: Categorias_GastoFilterQueryVariables; skip?: boolean } | { skip: boolean })

export const Categorias_GastoFilterComponent = (props: Categorias_GastoFilterComponentProps) => (
    <ApolloReactComponents.Query<Categorias_GastoFilterQuery, Categorias_GastoFilterQueryVariables>
        query={Categorias_GastoFilterDocument}
        {...props}
    />
)

/**
 * __useCategorias_GastoFilterQuery__
 *
 * To run a query within a React component, call `useCategorias_GastoFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategorias_GastoFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategorias_GastoFilterQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useCategorias_GastoFilterQuery(
    baseOptions: Apollo.QueryHookOptions<Categorias_GastoFilterQuery, Categorias_GastoFilterQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<Categorias_GastoFilterQuery, Categorias_GastoFilterQueryVariables>(
        Categorias_GastoFilterDocument,
        options
    )
}
export function useCategorias_GastoFilterLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<Categorias_GastoFilterQuery, Categorias_GastoFilterQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<Categorias_GastoFilterQuery, Categorias_GastoFilterQueryVariables>(
        Categorias_GastoFilterDocument,
        options
    )
}
export type Categorias_GastoFilterQueryHookResult = ReturnType<typeof useCategorias_GastoFilterQuery>
export type Categorias_GastoFilterLazyQueryHookResult = ReturnType<typeof useCategorias_GastoFilterLazyQuery>
export type Categorias_GastoFilterQueryResult = Apollo.QueryResult<
    Categorias_GastoFilterQuery,
    Categorias_GastoFilterQueryVariables
>
export const GetGastosListDocument = gql`
    query getGastosList(
        $categoria_id: ID
        $hotel_id: ID
        $subcategoria_id: ID
        $search_text: String
        $caja_chica: Boolean
        $rol_name: String
        $fecha_gasto: DateSearchInput
        $pagination_options: PageOptionsArgs!
    ) {
        gastos(
            search_text: $search_text
            categoria_id: $categoria_id
            rol: $rol_name
            hotel_id: $hotel_id
            subcategoria_id: $subcategoria_id
            caja_chica: $caja_chica
            fecha_gasto: $fecha_gasto
            pagination_options: $pagination_options
        ) {
            paginacion {
                total_paginas
                pagina_actual
            }
            gastos {
                caja_chica
                gasto_id
                metodo_pago
                usuario_id
                eliminado
                folio
                monto
                comentarios
                corte_id
                usuario {
                    apellido_materno
                    apellido_paterno
                    nombre
                    usuario_id
                    roles {
                        eliminado
                        grupo_hotel_id
                        nombre
                        rol_id
                    }
                }
                subcategoria_id
                categoria_id
                categoria_gasto {
                    categoria
                    categoria_id
                }
                subcategoria_gasto {
                    subcategoria
                }
                fecha_gasto
                fecha_registro
            }
        }
    }
`
export type GetGastosListComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetGastosListQuery, GetGastosListQueryVariables>,
    "query"
> &
    ({ variables: GetGastosListQueryVariables; skip?: boolean } | { skip: boolean })

export const GetGastosListComponent = (props: GetGastosListComponentProps) => (
    <ApolloReactComponents.Query<GetGastosListQuery, GetGastosListQueryVariables>
        query={GetGastosListDocument}
        {...props}
    />
)

/**
 * __useGetGastosListQuery__
 *
 * To run a query within a React component, call `useGetGastosListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGastosListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGastosListQuery({
 *   variables: {
 *      categoria_id: // value for 'categoria_id'
 *      hotel_id: // value for 'hotel_id'
 *      subcategoria_id: // value for 'subcategoria_id'
 *      search_text: // value for 'search_text'
 *      caja_chica: // value for 'caja_chica'
 *      rol_name: // value for 'rol_name'
 *      fecha_gasto: // value for 'fecha_gasto'
 *      pagination_options: // value for 'pagination_options'
 *   },
 * });
 */
export function useGetGastosListQuery(
    baseOptions: Apollo.QueryHookOptions<GetGastosListQuery, GetGastosListQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetGastosListQuery, GetGastosListQueryVariables>(GetGastosListDocument, options)
}
export function useGetGastosListLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetGastosListQuery, GetGastosListQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetGastosListQuery, GetGastosListQueryVariables>(GetGastosListDocument, options)
}
export type GetGastosListQueryHookResult = ReturnType<typeof useGetGastosListQuery>
export type GetGastosListLazyQueryHookResult = ReturnType<typeof useGetGastosListLazyQuery>
export type GetGastosListQueryResult = Apollo.QueryResult<GetGastosListQuery, GetGastosListQueryVariables>
export const HabitacionesConfigDocument = gql`
    query HabitacionesConfig($hotel_id: ID!) {
        habitaciones(hotel_id: $hotel_id) {
            habitacion_id
            numero_habitacion
            tipo_habitacion_id
            tipo_habitacion {
                nombre
            }
        }
    }
`
export type HabitacionesConfigComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<HabitacionesConfigQuery, HabitacionesConfigQueryVariables>,
    "query"
> &
    ({ variables: HabitacionesConfigQueryVariables; skip?: boolean } | { skip: boolean })

export const HabitacionesConfigComponent = (props: HabitacionesConfigComponentProps) => (
    <ApolloReactComponents.Query<HabitacionesConfigQuery, HabitacionesConfigQueryVariables>
        query={HabitacionesConfigDocument}
        {...props}
    />
)

/**
 * __useHabitacionesConfigQuery__
 *
 * To run a query within a React component, call `useHabitacionesConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useHabitacionesConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHabitacionesConfigQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useHabitacionesConfigQuery(
    baseOptions: Apollo.QueryHookOptions<HabitacionesConfigQuery, HabitacionesConfigQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<HabitacionesConfigQuery, HabitacionesConfigQueryVariables>(
        HabitacionesConfigDocument,
        options
    )
}
export function useHabitacionesConfigLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<HabitacionesConfigQuery, HabitacionesConfigQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<HabitacionesConfigQuery, HabitacionesConfigQueryVariables>(
        HabitacionesConfigDocument,
        options
    )
}
export type HabitacionesConfigQueryHookResult = ReturnType<typeof useHabitacionesConfigQuery>
export type HabitacionesConfigLazyQueryHookResult = ReturnType<typeof useHabitacionesConfigLazyQuery>
export type HabitacionesConfigQueryResult = Apollo.QueryResult<
    HabitacionesConfigQuery,
    HabitacionesConfigQueryVariables
>
export const UpdatePosicionHabitacionDocument = gql`
    mutation UpdatePosicionHabitacion($updatePosicionHabitacionInput: UpdatePosicionHabitacionInput!) {
        actualizar_posicion_habitacion(updatePosicionHabitacionRequest: $updatePosicionHabitacionInput) {
            habitacion_id
            posicion {
                x
                y
                tamano
            }
        }
    }
`
export type UpdatePosicionHabitacionMutationFn = Apollo.MutationFunction<
    UpdatePosicionHabitacionMutation,
    UpdatePosicionHabitacionMutationVariables
>
export type UpdatePosicionHabitacionComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        UpdatePosicionHabitacionMutation,
        UpdatePosicionHabitacionMutationVariables
    >,
    "mutation"
>

export const UpdatePosicionHabitacionComponent = (props: UpdatePosicionHabitacionComponentProps) => (
    <ApolloReactComponents.Mutation<UpdatePosicionHabitacionMutation, UpdatePosicionHabitacionMutationVariables>
        mutation={UpdatePosicionHabitacionDocument}
        {...props}
    />
)

/**
 * __useUpdatePosicionHabitacionMutation__
 *
 * To run a mutation, you first call `useUpdatePosicionHabitacionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePosicionHabitacionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePosicionHabitacionMutation, { data, loading, error }] = useUpdatePosicionHabitacionMutation({
 *   variables: {
 *      updatePosicionHabitacionInput: // value for 'updatePosicionHabitacionInput'
 *   },
 * });
 */
export function useUpdatePosicionHabitacionMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdatePosicionHabitacionMutation,
        UpdatePosicionHabitacionMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<UpdatePosicionHabitacionMutation, UpdatePosicionHabitacionMutationVariables>(
        UpdatePosicionHabitacionDocument,
        options
    )
}
export type UpdatePosicionHabitacionMutationHookResult = ReturnType<typeof useUpdatePosicionHabitacionMutation>
export type UpdatePosicionHabitacionMutationResult = Apollo.MutationResult<UpdatePosicionHabitacionMutation>
export type UpdatePosicionHabitacionMutationOptions = Apollo.BaseMutationOptions<
    UpdatePosicionHabitacionMutation,
    UpdatePosicionHabitacionMutationVariables
>
export const ActualizarHotelMinimalDocument = gql`
    mutation ActualizarHotelMinimal($datos_hotel: UpdateHotelInput!) {
        actualizar_hotel(datos_hotel: $datos_hotel) {
            hotel_id
            nombre_hotel
            configurations {
                cardHabitacion {
                    tamano_fijo
                    tamano
                }
            }
        }
    }
`
export type ActualizarHotelMinimalMutationFn = Apollo.MutationFunction<
    ActualizarHotelMinimalMutation,
    ActualizarHotelMinimalMutationVariables
>
export type ActualizarHotelMinimalComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        ActualizarHotelMinimalMutation,
        ActualizarHotelMinimalMutationVariables
    >,
    "mutation"
>

export const ActualizarHotelMinimalComponent = (props: ActualizarHotelMinimalComponentProps) => (
    <ApolloReactComponents.Mutation<ActualizarHotelMinimalMutation, ActualizarHotelMinimalMutationVariables>
        mutation={ActualizarHotelMinimalDocument}
        {...props}
    />
)

/**
 * __useActualizarHotelMinimalMutation__
 *
 * To run a mutation, you first call `useActualizarHotelMinimalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizarHotelMinimalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizarHotelMinimalMutation, { data, loading, error }] = useActualizarHotelMinimalMutation({
 *   variables: {
 *      datos_hotel: // value for 'datos_hotel'
 *   },
 * });
 */
export function useActualizarHotelMinimalMutation(
    baseOptions?: Apollo.MutationHookOptions<ActualizarHotelMinimalMutation, ActualizarHotelMinimalMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ActualizarHotelMinimalMutation, ActualizarHotelMinimalMutationVariables>(
        ActualizarHotelMinimalDocument,
        options
    )
}
export type ActualizarHotelMinimalMutationHookResult = ReturnType<typeof useActualizarHotelMinimalMutation>
export type ActualizarHotelMinimalMutationResult = Apollo.MutationResult<ActualizarHotelMinimalMutation>
export type ActualizarHotelMinimalMutationOptions = Apollo.BaseMutationOptions<
    ActualizarHotelMinimalMutation,
    ActualizarHotelMinimalMutationVariables
>
export const CrearColaboradorTareaDocument = gql`
    mutation CrearColaboradorTarea($datos_colaborador_tarea: CreateColaboradorTareaInput!) {
        crear_colaborador_tarea(datos_colaborador_tarea: $datos_colaborador_tarea) {
            colaborador {
                apellido_materno
                apellido_paterno
                nombre
            }
            colaborador_id
            colaborador_tarea_id
            fecha_inicio
            fecha_termino
            tarea_id
            tipo_limpieza
        }
    }
`
export type CrearColaboradorTareaMutationFn = Apollo.MutationFunction<
    CrearColaboradorTareaMutation,
    CrearColaboradorTareaMutationVariables
>
export type CrearColaboradorTareaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        CrearColaboradorTareaMutation,
        CrearColaboradorTareaMutationVariables
    >,
    "mutation"
>

export const CrearColaboradorTareaComponent = (props: CrearColaboradorTareaComponentProps) => (
    <ApolloReactComponents.Mutation<CrearColaboradorTareaMutation, CrearColaboradorTareaMutationVariables>
        mutation={CrearColaboradorTareaDocument}
        {...props}
    />
)

/**
 * __useCrearColaboradorTareaMutation__
 *
 * To run a mutation, you first call `useCrearColaboradorTareaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrearColaboradorTareaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crearColaboradorTareaMutation, { data, loading, error }] = useCrearColaboradorTareaMutation({
 *   variables: {
 *      datos_colaborador_tarea: // value for 'datos_colaborador_tarea'
 *   },
 * });
 */
export function useCrearColaboradorTareaMutation(
    baseOptions?: Apollo.MutationHookOptions<CrearColaboradorTareaMutation, CrearColaboradorTareaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CrearColaboradorTareaMutation, CrearColaboradorTareaMutationVariables>(
        CrearColaboradorTareaDocument,
        options
    )
}
export type CrearColaboradorTareaMutationHookResult = ReturnType<typeof useCrearColaboradorTareaMutation>
export type CrearColaboradorTareaMutationResult = Apollo.MutationResult<CrearColaboradorTareaMutation>
export type CrearColaboradorTareaMutationOptions = Apollo.BaseMutationOptions<
    CrearColaboradorTareaMutation,
    CrearColaboradorTareaMutationVariables
>
export const Actualizar_Colaboradores_TareasDocument = gql`
    mutation Actualizar_colaboradores_tareas($datos_tarea: CloseTaskInput!) {
        actualizar_colaboradores_tareas(datos_tarea: $datos_tarea) {
            colaborador {
                apellido_materno
                apellido_paterno
                nombre
            }
            colaborador_id
            colaborador_tarea_id
            fecha_inicio
            fecha_termino
            tarea_id
            tipo_limpieza
            comentarios {
                comentario
            }
        }
    }
`
export type Actualizar_Colaboradores_TareasMutationFn = Apollo.MutationFunction<
    Actualizar_Colaboradores_TareasMutation,
    Actualizar_Colaboradores_TareasMutationVariables
>
export type Actualizar_Colaboradores_TareasComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        Actualizar_Colaboradores_TareasMutation,
        Actualizar_Colaboradores_TareasMutationVariables
    >,
    "mutation"
>

export const Actualizar_Colaboradores_TareasComponent = (props: Actualizar_Colaboradores_TareasComponentProps) => (
    <ApolloReactComponents.Mutation<
        Actualizar_Colaboradores_TareasMutation,
        Actualizar_Colaboradores_TareasMutationVariables
    >
        mutation={Actualizar_Colaboradores_TareasDocument}
        {...props}
    />
)

/**
 * __useActualizar_Colaboradores_TareasMutation__
 *
 * To run a mutation, you first call `useActualizar_Colaboradores_TareasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizar_Colaboradores_TareasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizarColaboradoresTareasMutation, { data, loading, error }] = useActualizar_Colaboradores_TareasMutation({
 *   variables: {
 *      datos_tarea: // value for 'datos_tarea'
 *   },
 * });
 */
export function useActualizar_Colaboradores_TareasMutation(
    baseOptions?: Apollo.MutationHookOptions<
        Actualizar_Colaboradores_TareasMutation,
        Actualizar_Colaboradores_TareasMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        Actualizar_Colaboradores_TareasMutation,
        Actualizar_Colaboradores_TareasMutationVariables
    >(Actualizar_Colaboradores_TareasDocument, options)
}
export type Actualizar_Colaboradores_TareasMutationHookResult = ReturnType<
    typeof useActualizar_Colaboradores_TareasMutation
>
export type Actualizar_Colaboradores_TareasMutationResult =
    Apollo.MutationResult<Actualizar_Colaboradores_TareasMutation>
export type Actualizar_Colaboradores_TareasMutationOptions = Apollo.BaseMutationOptions<
    Actualizar_Colaboradores_TareasMutation,
    Actualizar_Colaboradores_TareasMutationVariables
>
export const CancelarReservaDocument = gql`
    mutation CancelarReserva(
        $cancelar_reserva_input: CancelReservaInput!
        $codigo: String!
        $template_sample: String!
    ) {
        cancelar_reserva(
            cancelar_reserva_input: $cancelar_reserva_input
            codigo: $codigo
            template_sample: $template_sample
        ) {
            ticket_ids
        }
    }
`
export type CancelarReservaMutationFn = Apollo.MutationFunction<
    CancelarReservaMutation,
    CancelarReservaMutationVariables
>
export type CancelarReservaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CancelarReservaMutation, CancelarReservaMutationVariables>,
    "mutation"
>

export const CancelarReservaComponent = (props: CancelarReservaComponentProps) => (
    <ApolloReactComponents.Mutation<CancelarReservaMutation, CancelarReservaMutationVariables>
        mutation={CancelarReservaDocument}
        {...props}
    />
)

/**
 * __useCancelarReservaMutation__
 *
 * To run a mutation, you first call `useCancelarReservaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelarReservaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelarReservaMutation, { data, loading, error }] = useCancelarReservaMutation({
 *   variables: {
 *      cancelar_reserva_input: // value for 'cancelar_reserva_input'
 *      codigo: // value for 'codigo'
 *      template_sample: // value for 'template_sample'
 *   },
 * });
 */
export function useCancelarReservaMutation(
    baseOptions?: Apollo.MutationHookOptions<CancelarReservaMutation, CancelarReservaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CancelarReservaMutation, CancelarReservaMutationVariables>(
        CancelarReservaDocument,
        options
    )
}
export type CancelarReservaMutationHookResult = ReturnType<typeof useCancelarReservaMutation>
export type CancelarReservaMutationResult = Apollo.MutationResult<CancelarReservaMutation>
export type CancelarReservaMutationOptions = Apollo.BaseMutationOptions<
    CancelarReservaMutation,
    CancelarReservaMutationVariables
>
export const AgregarComentarioHabitacionDocument = gql`
    mutation AgregarComentarioHabitacion($input: AddComentarioHabitacionInput!) {
        agregar_comentario_habitacion(agregar_comentario_habitacion_input: $input) {
            habitacion_id
            comentarios {
                comentario_id
                usuario_id
                comentario
                fecha
            }
        }
    }
`
export type AgregarComentarioHabitacionMutationFn = Apollo.MutationFunction<
    AgregarComentarioHabitacionMutation,
    AgregarComentarioHabitacionMutationVariables
>
export type AgregarComentarioHabitacionComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        AgregarComentarioHabitacionMutation,
        AgregarComentarioHabitacionMutationVariables
    >,
    "mutation"
>

export const AgregarComentarioHabitacionComponent = (props: AgregarComentarioHabitacionComponentProps) => (
    <ApolloReactComponents.Mutation<AgregarComentarioHabitacionMutation, AgregarComentarioHabitacionMutationVariables>
        mutation={AgregarComentarioHabitacionDocument}
        {...props}
    />
)

/**
 * __useAgregarComentarioHabitacionMutation__
 *
 * To run a mutation, you first call `useAgregarComentarioHabitacionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgregarComentarioHabitacionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agregarComentarioHabitacionMutation, { data, loading, error }] = useAgregarComentarioHabitacionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAgregarComentarioHabitacionMutation(
    baseOptions?: Apollo.MutationHookOptions<
        AgregarComentarioHabitacionMutation,
        AgregarComentarioHabitacionMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<AgregarComentarioHabitacionMutation, AgregarComentarioHabitacionMutationVariables>(
        AgregarComentarioHabitacionDocument,
        options
    )
}
export type AgregarComentarioHabitacionMutationHookResult = ReturnType<typeof useAgregarComentarioHabitacionMutation>
export type AgregarComentarioHabitacionMutationResult = Apollo.MutationResult<AgregarComentarioHabitacionMutation>
export type AgregarComentarioHabitacionMutationOptions = Apollo.BaseMutationOptions<
    AgregarComentarioHabitacionMutation,
    AgregarComentarioHabitacionMutationVariables
>
export const ActualizarComentarioHabitacionDocument = gql`
    mutation ActualizarComentarioHabitacion($input: UpdateComentarioHabitacionInput!) {
        actualizar_comentario_habitacion(actualizar_comentario_habitacion_input: $input) {
            habitacion_id
            comentarios {
                comentario_id
                usuario_id
                comentario
                fecha
            }
        }
    }
`
export type ActualizarComentarioHabitacionMutationFn = Apollo.MutationFunction<
    ActualizarComentarioHabitacionMutation,
    ActualizarComentarioHabitacionMutationVariables
>
export type ActualizarComentarioHabitacionComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        ActualizarComentarioHabitacionMutation,
        ActualizarComentarioHabitacionMutationVariables
    >,
    "mutation"
>

export const ActualizarComentarioHabitacionComponent = (props: ActualizarComentarioHabitacionComponentProps) => (
    <ApolloReactComponents.Mutation<
        ActualizarComentarioHabitacionMutation,
        ActualizarComentarioHabitacionMutationVariables
    >
        mutation={ActualizarComentarioHabitacionDocument}
        {...props}
    />
)

/**
 * __useActualizarComentarioHabitacionMutation__
 *
 * To run a mutation, you first call `useActualizarComentarioHabitacionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizarComentarioHabitacionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizarComentarioHabitacionMutation, { data, loading, error }] = useActualizarComentarioHabitacionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActualizarComentarioHabitacionMutation(
    baseOptions?: Apollo.MutationHookOptions<
        ActualizarComentarioHabitacionMutation,
        ActualizarComentarioHabitacionMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ActualizarComentarioHabitacionMutation, ActualizarComentarioHabitacionMutationVariables>(
        ActualizarComentarioHabitacionDocument,
        options
    )
}
export type ActualizarComentarioHabitacionMutationHookResult = ReturnType<
    typeof useActualizarComentarioHabitacionMutation
>
export type ActualizarComentarioHabitacionMutationResult = Apollo.MutationResult<ActualizarComentarioHabitacionMutation>
export type ActualizarComentarioHabitacionMutationOptions = Apollo.BaseMutationOptions<
    ActualizarComentarioHabitacionMutation,
    ActualizarComentarioHabitacionMutationVariables
>
export const EliminarComentarioHabitacionDocument = gql`
    mutation EliminarComentarioHabitacion($input: DeleteComentarioHabitacionInput!) {
        eliminar_comentario_habitacion(eliminar_comentario_habitacion_input: $input) {
            habitacion_id
            comentarios {
                comentario_id
                usuario_id
                comentario
                fecha
            }
        }
    }
`
export type EliminarComentarioHabitacionMutationFn = Apollo.MutationFunction<
    EliminarComentarioHabitacionMutation,
    EliminarComentarioHabitacionMutationVariables
>
export type EliminarComentarioHabitacionComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        EliminarComentarioHabitacionMutation,
        EliminarComentarioHabitacionMutationVariables
    >,
    "mutation"
>

export const EliminarComentarioHabitacionComponent = (props: EliminarComentarioHabitacionComponentProps) => (
    <ApolloReactComponents.Mutation<EliminarComentarioHabitacionMutation, EliminarComentarioHabitacionMutationVariables>
        mutation={EliminarComentarioHabitacionDocument}
        {...props}
    />
)

/**
 * __useEliminarComentarioHabitacionMutation__
 *
 * To run a mutation, you first call `useEliminarComentarioHabitacionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEliminarComentarioHabitacionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eliminarComentarioHabitacionMutation, { data, loading, error }] = useEliminarComentarioHabitacionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEliminarComentarioHabitacionMutation(
    baseOptions?: Apollo.MutationHookOptions<
        EliminarComentarioHabitacionMutation,
        EliminarComentarioHabitacionMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<EliminarComentarioHabitacionMutation, EliminarComentarioHabitacionMutationVariables>(
        EliminarComentarioHabitacionDocument,
        options
    )
}
export type EliminarComentarioHabitacionMutationHookResult = ReturnType<typeof useEliminarComentarioHabitacionMutation>
export type EliminarComentarioHabitacionMutationResult = Apollo.MutationResult<EliminarComentarioHabitacionMutation>
export type EliminarComentarioHabitacionMutationOptions = Apollo.BaseMutationOptions<
    EliminarComentarioHabitacionMutation,
    EliminarComentarioHabitacionMutationVariables
>
export const AgregarNochesExtraDocument = gql`
    mutation AgregarNochesExtra($datos_extra: AddHospedajesExtrasRentaInput!) {
        agregar_hospedajes_renta(AddHospedajesExtrasRentaInput: $datos_extra) {
            extra_id
            ticket_id
        }
    }
`
export type AgregarNochesExtraMutationFn = Apollo.MutationFunction<
    AgregarNochesExtraMutation,
    AgregarNochesExtraMutationVariables
>
export type AgregarNochesExtraComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<AgregarNochesExtraMutation, AgregarNochesExtraMutationVariables>,
    "mutation"
>

export const AgregarNochesExtraComponent = (props: AgregarNochesExtraComponentProps) => (
    <ApolloReactComponents.Mutation<AgregarNochesExtraMutation, AgregarNochesExtraMutationVariables>
        mutation={AgregarNochesExtraDocument}
        {...props}
    />
)

/**
 * __useAgregarNochesExtraMutation__
 *
 * To run a mutation, you first call `useAgregarNochesExtraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgregarNochesExtraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agregarNochesExtraMutation, { data, loading, error }] = useAgregarNochesExtraMutation({
 *   variables: {
 *      datos_extra: // value for 'datos_extra'
 *   },
 * });
 */
export function useAgregarNochesExtraMutation(
    baseOptions?: Apollo.MutationHookOptions<AgregarNochesExtraMutation, AgregarNochesExtraMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<AgregarNochesExtraMutation, AgregarNochesExtraMutationVariables>(
        AgregarNochesExtraDocument,
        options
    )
}
export type AgregarNochesExtraMutationHookResult = ReturnType<typeof useAgregarNochesExtraMutation>
export type AgregarNochesExtraMutationResult = Apollo.MutationResult<AgregarNochesExtraMutation>
export type AgregarNochesExtraMutationOptions = Apollo.BaseMutationOptions<
    AgregarNochesExtraMutation,
    AgregarNochesExtraMutationVariables
>
export const Agregar_Horas_RentaDocument = gql`
    mutation Agregar_horas_renta($addHorasExtrasRentaInput: AddHorasExtrasRentaInput!) {
        agregar_horas_renta(AddHorasExtrasRentaInput: $addHorasExtrasRentaInput) {
            extra_id
            ticket_id
        }
    }
`
export type Agregar_Horas_RentaMutationFn = Apollo.MutationFunction<
    Agregar_Horas_RentaMutation,
    Agregar_Horas_RentaMutationVariables
>
export type Agregar_Horas_RentaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<Agregar_Horas_RentaMutation, Agregar_Horas_RentaMutationVariables>,
    "mutation"
>

export const Agregar_Horas_RentaComponent = (props: Agregar_Horas_RentaComponentProps) => (
    <ApolloReactComponents.Mutation<Agregar_Horas_RentaMutation, Agregar_Horas_RentaMutationVariables>
        mutation={Agregar_Horas_RentaDocument}
        {...props}
    />
)

/**
 * __useAgregar_Horas_RentaMutation__
 *
 * To run a mutation, you first call `useAgregar_Horas_RentaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgregar_Horas_RentaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agregarHorasRentaMutation, { data, loading, error }] = useAgregar_Horas_RentaMutation({
 *   variables: {
 *      addHorasExtrasRentaInput: // value for 'addHorasExtrasRentaInput'
 *   },
 * });
 */
export function useAgregar_Horas_RentaMutation(
    baseOptions?: Apollo.MutationHookOptions<Agregar_Horas_RentaMutation, Agregar_Horas_RentaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<Agregar_Horas_RentaMutation, Agregar_Horas_RentaMutationVariables>(
        Agregar_Horas_RentaDocument,
        options
    )
}
export type Agregar_Horas_RentaMutationHookResult = ReturnType<typeof useAgregar_Horas_RentaMutation>
export type Agregar_Horas_RentaMutationResult = Apollo.MutationResult<Agregar_Horas_RentaMutation>
export type Agregar_Horas_RentaMutationOptions = Apollo.BaseMutationOptions<
    Agregar_Horas_RentaMutation,
    Agregar_Horas_RentaMutationVariables
>
export const AgregarPersonasExtraDocument = gql`
    mutation AgregarPersonasExtra($datos_renta: AddPersonasExtrasRentaInput!) {
        agregar_personas_renta(AddPersonasExtrasRentaInput: $datos_renta) {
            extra_id
            ticket_id
        }
    }
`
export type AgregarPersonasExtraMutationFn = Apollo.MutationFunction<
    AgregarPersonasExtraMutation,
    AgregarPersonasExtraMutationVariables
>
export type AgregarPersonasExtraComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<AgregarPersonasExtraMutation, AgregarPersonasExtraMutationVariables>,
    "mutation"
>

export const AgregarPersonasExtraComponent = (props: AgregarPersonasExtraComponentProps) => (
    <ApolloReactComponents.Mutation<AgregarPersonasExtraMutation, AgregarPersonasExtraMutationVariables>
        mutation={AgregarPersonasExtraDocument}
        {...props}
    />
)

/**
 * __useAgregarPersonasExtraMutation__
 *
 * To run a mutation, you first call `useAgregarPersonasExtraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgregarPersonasExtraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agregarPersonasExtraMutation, { data, loading, error }] = useAgregarPersonasExtraMutation({
 *   variables: {
 *      datos_renta: // value for 'datos_renta'
 *   },
 * });
 */
export function useAgregarPersonasExtraMutation(
    baseOptions?: Apollo.MutationHookOptions<AgregarPersonasExtraMutation, AgregarPersonasExtraMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<AgregarPersonasExtraMutation, AgregarPersonasExtraMutationVariables>(
        AgregarPersonasExtraDocument,
        options
    )
}
export type AgregarPersonasExtraMutationHookResult = ReturnType<typeof useAgregarPersonasExtraMutation>
export type AgregarPersonasExtraMutationResult = Apollo.MutationResult<AgregarPersonasExtraMutation>
export type AgregarPersonasExtraMutationOptions = Apollo.BaseMutationOptions<
    AgregarPersonasExtraMutation,
    AgregarPersonasExtraMutationVariables
>
export const CambiarRentaDeHabitacionDocument = gql`
    mutation CambiarRentaDeHabitacion($datos_renta: UpdateHabitacionInRentaInput!) {
        actualizar_habitacion_en_renta(datos_renta: $datos_renta) {
            habitacion_id
        }
    }
`
export type CambiarRentaDeHabitacionMutationFn = Apollo.MutationFunction<
    CambiarRentaDeHabitacionMutation,
    CambiarRentaDeHabitacionMutationVariables
>
export type CambiarRentaDeHabitacionComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        CambiarRentaDeHabitacionMutation,
        CambiarRentaDeHabitacionMutationVariables
    >,
    "mutation"
>

export const CambiarRentaDeHabitacionComponent = (props: CambiarRentaDeHabitacionComponentProps) => (
    <ApolloReactComponents.Mutation<CambiarRentaDeHabitacionMutation, CambiarRentaDeHabitacionMutationVariables>
        mutation={CambiarRentaDeHabitacionDocument}
        {...props}
    />
)

/**
 * __useCambiarRentaDeHabitacionMutation__
 *
 * To run a mutation, you first call `useCambiarRentaDeHabitacionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCambiarRentaDeHabitacionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cambiarRentaDeHabitacionMutation, { data, loading, error }] = useCambiarRentaDeHabitacionMutation({
 *   variables: {
 *      datos_renta: // value for 'datos_renta'
 *   },
 * });
 */
export function useCambiarRentaDeHabitacionMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CambiarRentaDeHabitacionMutation,
        CambiarRentaDeHabitacionMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CambiarRentaDeHabitacionMutation, CambiarRentaDeHabitacionMutationVariables>(
        CambiarRentaDeHabitacionDocument,
        options
    )
}
export type CambiarRentaDeHabitacionMutationHookResult = ReturnType<typeof useCambiarRentaDeHabitacionMutation>
export type CambiarRentaDeHabitacionMutationResult = Apollo.MutationResult<CambiarRentaDeHabitacionMutation>
export type CambiarRentaDeHabitacionMutationOptions = Apollo.BaseMutationOptions<
    CambiarRentaDeHabitacionMutation,
    CambiarRentaDeHabitacionMutationVariables
>
export const CancelarRentaHabitacionDocument = gql`
    mutation CancelarRentaHabitacion($datos_cancelar: CancelOperationsRentaInput!) {
        cancelar_operaciones_renta(cancelar_renta_input: $datos_cancelar) {
            ticket_id
            renta {
                cliente_id
            }
            extras_cancelled {
                extra_id
                ticket_id
            }
        }
    }
`
export type CancelarRentaHabitacionMutationFn = Apollo.MutationFunction<
    CancelarRentaHabitacionMutation,
    CancelarRentaHabitacionMutationVariables
>
export type CancelarRentaHabitacionComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        CancelarRentaHabitacionMutation,
        CancelarRentaHabitacionMutationVariables
    >,
    "mutation"
>

export const CancelarRentaHabitacionComponent = (props: CancelarRentaHabitacionComponentProps) => (
    <ApolloReactComponents.Mutation<CancelarRentaHabitacionMutation, CancelarRentaHabitacionMutationVariables>
        mutation={CancelarRentaHabitacionDocument}
        {...props}
    />
)

/**
 * __useCancelarRentaHabitacionMutation__
 *
 * To run a mutation, you first call `useCancelarRentaHabitacionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelarRentaHabitacionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelarRentaHabitacionMutation, { data, loading, error }] = useCancelarRentaHabitacionMutation({
 *   variables: {
 *      datos_cancelar: // value for 'datos_cancelar'
 *   },
 * });
 */
export function useCancelarRentaHabitacionMutation(
    baseOptions?: Apollo.MutationHookOptions<CancelarRentaHabitacionMutation, CancelarRentaHabitacionMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CancelarRentaHabitacionMutation, CancelarRentaHabitacionMutationVariables>(
        CancelarRentaHabitacionDocument,
        options
    )
}
export type CancelarRentaHabitacionMutationHookResult = ReturnType<typeof useCancelarRentaHabitacionMutation>
export type CancelarRentaHabitacionMutationResult = Apollo.MutationResult<CancelarRentaHabitacionMutation>
export type CancelarRentaHabitacionMutationOptions = Apollo.BaseMutationOptions<
    CancelarRentaHabitacionMutation,
    CancelarRentaHabitacionMutationVariables
>
export const CheckoutDocument = gql`
    mutation Checkout($checkOutInput: CheckOutInput!) {
        CheckOut(checkOutInput: $checkOutInput) {
            ticket_id
        }
    }
`
export type CheckoutMutationFn = Apollo.MutationFunction<CheckoutMutation, CheckoutMutationVariables>
export type CheckoutComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CheckoutMutation, CheckoutMutationVariables>,
    "mutation"
>

export const CheckoutComponent = (props: CheckoutComponentProps) => (
    <ApolloReactComponents.Mutation<CheckoutMutation, CheckoutMutationVariables>
        mutation={CheckoutDocument}
        {...props}
    />
)

/**
 * __useCheckoutMutation__
 *
 * To run a mutation, you first call `useCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutMutation, { data, loading, error }] = useCheckoutMutation({
 *   variables: {
 *      checkOutInput: // value for 'checkOutInput'
 *   },
 * });
 */
export function useCheckoutMutation(
    baseOptions?: Apollo.MutationHookOptions<CheckoutMutation, CheckoutMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CheckoutMutation, CheckoutMutationVariables>(CheckoutDocument, options)
}
export type CheckoutMutationHookResult = ReturnType<typeof useCheckoutMutation>
export type CheckoutMutationResult = Apollo.MutationResult<CheckoutMutation>
export type CheckoutMutationOptions = Apollo.BaseMutationOptions<CheckoutMutation, CheckoutMutationVariables>
export const GetColaboradoresDocument = gql`
    query getColaboradores($hotel_id: ID!, $en_turno: Boolean) {
        colaboradores(hotel_id: $hotel_id, en_turno: $en_turno, eliminado: false) {
            apellido_materno
            apellido_paterno
            nombre
            colaborador_id
            colaborador_in_hotel {
                puesto {
                    puesto_id
                    nombre
                }
            }
            en_turno
            ultima_tarea {
                fecha_inicio
                fecha_termino
                colaborador_tarea_id
                habitacion_id
                habitacion {
                    numero_habitacion
                    tipo_habitacion_id
                    tipo_habitacion {
                        nombre
                    }
                }
            }
            puesto {
                puesto_id
                nombre
                area {
                    area_id
                    nombre
                }
            }
            area {
                area_id
                nombre
            }
            usuario_id
        }
    }
`
export type GetColaboradoresComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetColaboradoresQuery, GetColaboradoresQueryVariables>,
    "query"
> &
    ({ variables: GetColaboradoresQueryVariables; skip?: boolean } | { skip: boolean })

export const GetColaboradoresComponent = (props: GetColaboradoresComponentProps) => (
    <ApolloReactComponents.Query<GetColaboradoresQuery, GetColaboradoresQueryVariables>
        query={GetColaboradoresDocument}
        {...props}
    />
)

/**
 * __useGetColaboradoresQuery__
 *
 * To run a query within a React component, call `useGetColaboradoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetColaboradoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetColaboradoresQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      en_turno: // value for 'en_turno'
 *   },
 * });
 */
export function useGetColaboradoresQuery(
    baseOptions: Apollo.QueryHookOptions<GetColaboradoresQuery, GetColaboradoresQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetColaboradoresQuery, GetColaboradoresQueryVariables>(GetColaboradoresDocument, options)
}
export function useGetColaboradoresLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetColaboradoresQuery, GetColaboradoresQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetColaboradoresQuery, GetColaboradoresQueryVariables>(GetColaboradoresDocument, options)
}
export type GetColaboradoresQueryHookResult = ReturnType<typeof useGetColaboradoresQuery>
export type GetColaboradoresLazyQueryHookResult = ReturnType<typeof useGetColaboradoresLazyQuery>
export type GetColaboradoresQueryResult = Apollo.QueryResult<GetColaboradoresQuery, GetColaboradoresQueryVariables>
export const GetColaboradoresForValidationDocument = gql`
    query getColaboradoresForValidation($hotel_id: ID!, $en_turno: Boolean) {
        colaboradores(hotel_id: $hotel_id, en_turno: $en_turno, eliminado: false) {
            colaborador_id
            en_turno
            puesto {
                puesto_id
                nombre
                area {
                    area_id
                    nombre
                }
            }
        }
    }
`
export type GetColaboradoresForValidationComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetColaboradoresForValidationQuery,
        GetColaboradoresForValidationQueryVariables
    >,
    "query"
> &
    ({ variables: GetColaboradoresForValidationQueryVariables; skip?: boolean } | { skip: boolean })

export const GetColaboradoresForValidationComponent = (props: GetColaboradoresForValidationComponentProps) => (
    <ApolloReactComponents.Query<GetColaboradoresForValidationQuery, GetColaboradoresForValidationQueryVariables>
        query={GetColaboradoresForValidationDocument}
        {...props}
    />
)

/**
 * __useGetColaboradoresForValidationQuery__
 *
 * To run a query within a React component, call `useGetColaboradoresForValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetColaboradoresForValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetColaboradoresForValidationQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      en_turno: // value for 'en_turno'
 *   },
 * });
 */
export function useGetColaboradoresForValidationQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetColaboradoresForValidationQuery,
        GetColaboradoresForValidationQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetColaboradoresForValidationQuery, GetColaboradoresForValidationQueryVariables>(
        GetColaboradoresForValidationDocument,
        options
    )
}
export function useGetColaboradoresForValidationLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetColaboradoresForValidationQuery,
        GetColaboradoresForValidationQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetColaboradoresForValidationQuery, GetColaboradoresForValidationQueryVariables>(
        GetColaboradoresForValidationDocument,
        options
    )
}
export type GetColaboradoresForValidationQueryHookResult = ReturnType<typeof useGetColaboradoresForValidationQuery>
export type GetColaboradoresForValidationLazyQueryHookResult = ReturnType<
    typeof useGetColaboradoresForValidationLazyQuery
>
export type GetColaboradoresForValidationQueryResult = Apollo.QueryResult<
    GetColaboradoresForValidationQuery,
    GetColaboradoresForValidationQueryVariables
>
export const GetColaboradoresByAreasDocument = gql`
    query GetColaboradoresByAreas($hotel_id: ID, $area_id: [ID!]) {
        colaboradores_by_area(hotel_id: $hotel_id, area_id: $area_id, en_turno: true) {
            colaboradores {
                colaborador_id
                nombre
                apellido_materno
                apellido_paterno
                foto
            }
        }
    }
`
export type GetColaboradoresByAreasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetColaboradoresByAreasQuery, GetColaboradoresByAreasQueryVariables>,
    "query"
>

export const GetColaboradoresByAreasComponent = (props: GetColaboradoresByAreasComponentProps) => (
    <ApolloReactComponents.Query<GetColaboradoresByAreasQuery, GetColaboradoresByAreasQueryVariables>
        query={GetColaboradoresByAreasDocument}
        {...props}
    />
)

/**
 * __useGetColaboradoresByAreasQuery__
 *
 * To run a query within a React component, call `useGetColaboradoresByAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetColaboradoresByAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetColaboradoresByAreasQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      area_id: // value for 'area_id'
 *   },
 * });
 */
export function useGetColaboradoresByAreasQuery(
    baseOptions?: Apollo.QueryHookOptions<GetColaboradoresByAreasQuery, GetColaboradoresByAreasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetColaboradoresByAreasQuery, GetColaboradoresByAreasQueryVariables>(
        GetColaboradoresByAreasDocument,
        options
    )
}
export function useGetColaboradoresByAreasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetColaboradoresByAreasQuery, GetColaboradoresByAreasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetColaboradoresByAreasQuery, GetColaboradoresByAreasQueryVariables>(
        GetColaboradoresByAreasDocument,
        options
    )
}
export type GetColaboradoresByAreasQueryHookResult = ReturnType<typeof useGetColaboradoresByAreasQuery>
export type GetColaboradoresByAreasLazyQueryHookResult = ReturnType<typeof useGetColaboradoresByAreasLazyQuery>
export type GetColaboradoresByAreasQueryResult = Apollo.QueryResult<
    GetColaboradoresByAreasQuery,
    GetColaboradoresByAreasQueryVariables
>
export const CurrentDateDocument = gql`
    query currentDate {
        serverDate
    }
`
export type CurrentDateComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<CurrentDateQuery, CurrentDateQueryVariables>,
    "query"
>

export const CurrentDateComponent = (props: CurrentDateComponentProps) => (
    <ApolloReactComponents.Query<CurrentDateQuery, CurrentDateQueryVariables> query={CurrentDateDocument} {...props} />
)

/**
 * __useCurrentDateQuery__
 *
 * To run a query within a React component, call `useCurrentDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentDateQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentDateQuery(
    baseOptions?: Apollo.QueryHookOptions<CurrentDateQuery, CurrentDateQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<CurrentDateQuery, CurrentDateQueryVariables>(CurrentDateDocument, options)
}
export function useCurrentDateLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<CurrentDateQuery, CurrentDateQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<CurrentDateQuery, CurrentDateQueryVariables>(CurrentDateDocument, options)
}
export type CurrentDateQueryHookResult = ReturnType<typeof useCurrentDateQuery>
export type CurrentDateLazyQueryHookResult = ReturnType<typeof useCurrentDateLazyQuery>
export type CurrentDateQueryResult = Apollo.QueryResult<CurrentDateQuery, CurrentDateQueryVariables>
export const GetExperienciasDocument = gql`
    query GetExperiencias($hotel_id: ID!, $experiencia_id: [ID!]) {
        experiencias(hotel_id: $hotel_id, experiencia_id: $experiencia_id, estado: disponible, eliminado: false) {
            experiencia_id
            nombre
            precio
            descripcion
            estado
            hotel_id
            fecha_registro
        }
    }
`
export type GetExperienciasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetExperienciasQuery, GetExperienciasQueryVariables>,
    "query"
> &
    ({ variables: GetExperienciasQueryVariables; skip?: boolean } | { skip: boolean })

export const GetExperienciasComponent = (props: GetExperienciasComponentProps) => (
    <ApolloReactComponents.Query<GetExperienciasQuery, GetExperienciasQueryVariables>
        query={GetExperienciasDocument}
        {...props}
    />
)

/**
 * __useGetExperienciasQuery__
 *
 * To run a query within a React component, call `useGetExperienciasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExperienciasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExperienciasQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      experiencia_id: // value for 'experiencia_id'
 *   },
 * });
 */
export function useGetExperienciasQuery(
    baseOptions: Apollo.QueryHookOptions<GetExperienciasQuery, GetExperienciasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetExperienciasQuery, GetExperienciasQueryVariables>(GetExperienciasDocument, options)
}
export function useGetExperienciasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetExperienciasQuery, GetExperienciasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetExperienciasQuery, GetExperienciasQueryVariables>(GetExperienciasDocument, options)
}
export type GetExperienciasQueryHookResult = ReturnType<typeof useGetExperienciasQuery>
export type GetExperienciasLazyQueryHookResult = ReturnType<typeof useGetExperienciasLazyQuery>
export type GetExperienciasQueryResult = Apollo.QueryResult<GetExperienciasQuery, GetExperienciasQueryVariables>
export const TiposBloqueoDocument = gql`
    query TiposBloqueo($hotel_id: ID!) {
        tipos_bloqueo(hotel_id: $hotel_id) {
            tipo_bloqueo_id
            nombre
            claves {
                tamano
                clave
            }
        }
    }
`
export type TiposBloqueoComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<TiposBloqueoQuery, TiposBloqueoQueryVariables>,
    "query"
> &
    ({ variables: TiposBloqueoQueryVariables; skip?: boolean } | { skip: boolean })

export const TiposBloqueoComponent = (props: TiposBloqueoComponentProps) => (
    <ApolloReactComponents.Query<TiposBloqueoQuery, TiposBloqueoQueryVariables>
        query={TiposBloqueoDocument}
        {...props}
    />
)

/**
 * __useTiposBloqueoQuery__
 *
 * To run a query within a React component, call `useTiposBloqueoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTiposBloqueoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTiposBloqueoQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useTiposBloqueoQuery(
    baseOptions: Apollo.QueryHookOptions<TiposBloqueoQuery, TiposBloqueoQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<TiposBloqueoQuery, TiposBloqueoQueryVariables>(TiposBloqueoDocument, options)
}
export function useTiposBloqueoLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<TiposBloqueoQuery, TiposBloqueoQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<TiposBloqueoQuery, TiposBloqueoQueryVariables>(TiposBloqueoDocument, options)
}
export type TiposBloqueoQueryHookResult = ReturnType<typeof useTiposBloqueoQuery>
export type TiposBloqueoLazyQueryHookResult = ReturnType<typeof useTiposBloqueoLazyQuery>
export type TiposBloqueoQueryResult = Apollo.QueryResult<TiposBloqueoQuery, TiposBloqueoQueryVariables>
export const GetReservasDelDiaSinAsignarDocument = gql`
    query getReservasDelDiaSinAsignar($hotel_id: String!, $fecha_entrada: DateTime!) {
        reservas_sin_asignar_del_dia(hotel_id: $hotel_id, fecha_entrada: $fecha_entrada) {
            codigo_ota
            folio
            habitacion_id
            nombre_huesped
            tipo_habitacion_id
            reserva_id
            estado
            fecha_entrada
        }
    }
`
export type GetReservasDelDiaSinAsignarComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetReservasDelDiaSinAsignarQuery,
        GetReservasDelDiaSinAsignarQueryVariables
    >,
    "query"
> &
    ({ variables: GetReservasDelDiaSinAsignarQueryVariables; skip?: boolean } | { skip: boolean })

export const GetReservasDelDiaSinAsignarComponent = (props: GetReservasDelDiaSinAsignarComponentProps) => (
    <ApolloReactComponents.Query<GetReservasDelDiaSinAsignarQuery, GetReservasDelDiaSinAsignarQueryVariables>
        query={GetReservasDelDiaSinAsignarDocument}
        {...props}
    />
)

/**
 * __useGetReservasDelDiaSinAsignarQuery__
 *
 * To run a query within a React component, call `useGetReservasDelDiaSinAsignarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservasDelDiaSinAsignarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservasDelDiaSinAsignarQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      fecha_entrada: // value for 'fecha_entrada'
 *   },
 * });
 */
export function useGetReservasDelDiaSinAsignarQuery(
    baseOptions: Apollo.QueryHookOptions<GetReservasDelDiaSinAsignarQuery, GetReservasDelDiaSinAsignarQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetReservasDelDiaSinAsignarQuery, GetReservasDelDiaSinAsignarQueryVariables>(
        GetReservasDelDiaSinAsignarDocument,
        options
    )
}
export function useGetReservasDelDiaSinAsignarLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetReservasDelDiaSinAsignarQuery,
        GetReservasDelDiaSinAsignarQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetReservasDelDiaSinAsignarQuery, GetReservasDelDiaSinAsignarQueryVariables>(
        GetReservasDelDiaSinAsignarDocument,
        options
    )
}
export type GetReservasDelDiaSinAsignarQueryHookResult = ReturnType<typeof useGetReservasDelDiaSinAsignarQuery>
export type GetReservasDelDiaSinAsignarLazyQueryHookResult = ReturnType<typeof useGetReservasDelDiaSinAsignarLazyQuery>
export type GetReservasDelDiaSinAsignarQueryResult = Apollo.QueryResult<
    GetReservasDelDiaSinAsignarQuery,
    GetReservasDelDiaSinAsignarQueryVariables
>
export const GetHabitacionDocument = gql`
    query GetHabitacion($habitacion_id: ID!, $usuario_id: ID!) {
        habitacion(habitacion_id: $habitacion_id) {
            comentario_estado
            eliminado
            estado
            incidencias_activas
            incidencias_activas_usuario(usuario_id: $usuario_id)
            fecha_estado
            habitacion_id
            hotel_id
            numero_habitacion
            rentas_today
            reservas_today
            piso
            usuario_id
            tipo_habitacion_id
            tipo_habitacion {
                clave
                descripcion
                eliminado
                hotel_id
                camas {
                    numero
                    tipo
                }
                minutos_entrada
                minutos_limpieza_detallada
                minutos_limpieza_normal
                minutos_limpieza_retoque
                nombre
                minutos_supervision
                personas_incluidas
                tipo_habitacion_id
            }
            ultima_reserva {
                reserva {
                    reserva_id
                    folio
                    estado
                    fecha_cancelacion
                    fecha_salida
                    fecha_entrada
                    origen
                    tipo_habitacion_id
                    tipo_de_habitacion {
                        nombre
                    }
                    habitacion_id
                    habitacion {
                        numero_habitacion
                        habitacion_id
                        tipo_habitacion {
                            nombre
                        }
                    }
                    tarifa_id
                    tarifa {
                        nombre
                        personas_extra_max
                        costo_persona_extra
                        tipo_alojamiento
                        tarifa_id
                        nombre
                    }
                    correo_huesped
                    nombre_huesped
                    telefono_huesped
                    numero_personas
                    personas_extras
                    usuario {
                        nombre
                    }
                    estado_pago
                    total
                    easyrewards_id
                    pagos {
                        pago_id
                        total
                        detalles_pago {
                            detalle_pago_id
                            subtotal
                            tipo_pago
                            ultimos_digitos
                            numero_referencia
                            easyrewards_id
                        }
                        extras {
                            monto_devuelto_cancelacion
                            fecha_cancelacion
                            fecha_pago
                            fecha_solicitud
                            monto_extra
                            motivo_cancelacion
                            numero
                            tipo_extra
                        }
                    }
                    experiencias_reserva {
                        experiencia_reserva_id
                        experiencia_id
                        total
                        estado
                        experiencia {
                            nombre
                        }
                    }
                    comentarios {
                        comentario
                    }
                }
            }
            ultima_renta {
                horas_extra
                ticket_id
                fecha_fin
                estado
                fecha_condensada
                nombre_huesped
                hospedajes_extra
                fecha_registro
                fecha_salida
                nombre_huesped
                total
                renta_id
                folio
                vehiculo {
                    matricula
                }
                comentarios {
                    comentario
                    fecha
                }
                numero_personas
                personas_extra
                cliente_id
                nombre_huesped
                reserva_id
                tipo_entrada
                reserva {
                    nombre_huesped
                    origen
                    correo_huesped
                    telefono_huesped
                    easyrewards_id
                    pagos {
                        pago_id
                        detalles_pago {
                            subtotal
                            numero_referencia
                            easyrewards_id
                        }
                    }
                }
                extras {
                    tipo_extra
                    monto_extra
                    numero
                    extra_id
                    fecha_pago
                }
                easyrewards_id
                pagos {
                    fecha_pago
                    pago_id
                    extras {
                        tipo_extra
                        monto_extra
                        numero
                        extra_id
                    }
                    total
                    detalles_pago {
                        subtotal
                        ultimos_digitos
                        tipo_pago
                        numero_referencia
                        easyrewards_id
                    }
                }
                tarifa_id
                tarifa {
                    nombre
                    costo_persona_extra
                    costo_hora_extra
                    costo_hospedaje_extra
                    personas_extra_max
                    duracion_renta
                    horas_extra_max
                    costo_habitacion
                    hospedajes_extra_max
                    costo_early_checkin
                }
                tipo_alojamiento
                propinas {
                    total
                    detalles_pago {
                        tipo_pago
                        ultimos_digitos
                        subtotal
                        numero_referencia
                    }
                }
                ordenes {
                    orden
                    orden_id
                    fecha_registro
                    total_con_iva
                    total_sin_iva
                    estado_orden
                    propina {
                        propina_id
                        total
                    }
                    pago_id
                    pago {
                        ticket_id
                        pago_id
                        detalles_pago {
                            ultimos_digitos
                            tipo_pago
                            subtotal
                            numero_referencia
                            easyrewards_id
                        }
                    }
                    detalles_orden(estado: [en_preparacion, en_entrega, por_entregar, entregada]) {
                        detalle_orden_id
                        estado
                        almacen_articulo_id
                        cantidad
                        costo_con_iva
                        almacen_articulo {
                            articulo_id
                            almacen_id
                            precio
                            categoria_id
                            categoria_articulo {
                                nombre
                            }
                            articulo {
                                nombre
                                contenido
                                descripcion
                                unidad
                                articulo_id
                                categoria_id
                                tipo
                                extra
                                categoria_articulo {
                                    nombre
                                }
                            }
                        }
                        extras {
                            extra_detalle_orden_id
                            detalle_orden_id
                            almacen_articulo_id
                            costo_con_iva
                            cantidad
                            almacen_articulo {
                                almacen_articulo_id
                                articulo_id
                                precio
                                articulo {
                                    nombre
                                    contenido
                                    descripcion
                                    unidad
                                    articulo_id
                                    categoria_id
                                    tipo
                                    extra
                                    categoria_articulo {
                                        nombre
                                    }
                                }
                            }
                        }
                        comentarios
                    }
                    easyrewards_id
                }
                subtotales {
                    total_early_checkin
                    total_habitacion
                    total_horas_extra
                    total_hospedajes_extra
                    total_personas_extra
                }
            }
            ultimas_rentas {
                cliente_id
                horas_extra
            }
            colaborador_tareas_sin_finalizar {
                tarea_id
                colaborador_tarea_id
                descripcion_tarea
                fecha_inicio
                fecha_termino
                tipo_limpieza
                colaborador_id
                colaborador {
                    foto
                    colaborador_in_hotel {
                        puesto {
                            descripcion
                            nombre
                            descripcion
                            puesto_id
                        }
                    }
                    nombre
                    foto
                    apellido_materno
                    apellido_paterno
                }
            }
            ultimos_datos {
                ultima_limpieza {
                    colaborador_id
                    colaborador {
                        apellido_materno
                        apellido_paterno
                        nombre
                        foto
                    }
                    fecha_termino
                    tipo_limpieza
                    fecha_inicio
                    colaborador_tarea_id
                    colaborador_id
                    comentarios {
                        comentario
                        fecha
                    }
                }
                ultimo_mantenimiento {
                    colaborador_id
                    colaborador {
                        apellido_materno
                        apellido_paterno
                        nombre
                        foto
                    }
                    fecha_termino
                }
                ultima_supervision {
                    colaborador_id
                    colaborador {
                        apellido_materno
                        apellido_paterno
                        nombre
                        foto
                    }
                }
            }
            tarea_en_curso {
                tarea_id
                fecha_inicio
                colaborador_tarea_id
                tipo_tarea
                reportada_por {
                    nombre
                    apellido_paterno
                    apellido_materno
                }
            }
        }
    }
`
export type GetHabitacionComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetHabitacionQuery, GetHabitacionQueryVariables>,
    "query"
> &
    ({ variables: GetHabitacionQueryVariables; skip?: boolean } | { skip: boolean })

export const GetHabitacionComponent = (props: GetHabitacionComponentProps) => (
    <ApolloReactComponents.Query<GetHabitacionQuery, GetHabitacionQueryVariables>
        query={GetHabitacionDocument}
        {...props}
    />
)

/**
 * __useGetHabitacionQuery__
 *
 * To run a query within a React component, call `useGetHabitacionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHabitacionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHabitacionQuery({
 *   variables: {
 *      habitacion_id: // value for 'habitacion_id'
 *      usuario_id: // value for 'usuario_id'
 *   },
 * });
 */
export function useGetHabitacionQuery(
    baseOptions: Apollo.QueryHookOptions<GetHabitacionQuery, GetHabitacionQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetHabitacionQuery, GetHabitacionQueryVariables>(GetHabitacionDocument, options)
}
export function useGetHabitacionLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetHabitacionQuery, GetHabitacionQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetHabitacionQuery, GetHabitacionQueryVariables>(GetHabitacionDocument, options)
}
export type GetHabitacionQueryHookResult = ReturnType<typeof useGetHabitacionQuery>
export type GetHabitacionLazyQueryHookResult = ReturnType<typeof useGetHabitacionLazyQuery>
export type GetHabitacionQueryResult = Apollo.QueryResult<GetHabitacionQuery, GetHabitacionQueryVariables>
export const TiposMantenimientoDocument = gql`
    query TiposMantenimiento($eliminado: Boolean, $hotel_id: ID) {
        tipos_mantenimiento(eliminado: $eliminado, hotel_id: $hotel_id) {
            nombre
            claves {
                clave
                tamano
            }
            tipo_mantenimiento_id
        }
    }
`
export type TiposMantenimientoComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<TiposMantenimientoQuery, TiposMantenimientoQueryVariables>,
    "query"
>

export const TiposMantenimientoComponent = (props: TiposMantenimientoComponentProps) => (
    <ApolloReactComponents.Query<TiposMantenimientoQuery, TiposMantenimientoQueryVariables>
        query={TiposMantenimientoDocument}
        {...props}
    />
)

/**
 * __useTiposMantenimientoQuery__
 *
 * To run a query within a React component, call `useTiposMantenimientoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTiposMantenimientoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTiposMantenimientoQuery({
 *   variables: {
 *      eliminado: // value for 'eliminado'
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useTiposMantenimientoQuery(
    baseOptions?: Apollo.QueryHookOptions<TiposMantenimientoQuery, TiposMantenimientoQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<TiposMantenimientoQuery, TiposMantenimientoQueryVariables>(
        TiposMantenimientoDocument,
        options
    )
}
export function useTiposMantenimientoLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<TiposMantenimientoQuery, TiposMantenimientoQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<TiposMantenimientoQuery, TiposMantenimientoQueryVariables>(
        TiposMantenimientoDocument,
        options
    )
}
export type TiposMantenimientoQueryHookResult = ReturnType<typeof useTiposMantenimientoQuery>
export type TiposMantenimientoLazyQueryHookResult = ReturnType<typeof useTiposMantenimientoLazyQuery>
export type TiposMantenimientoQueryResult = Apollo.QueryResult<
    TiposMantenimientoQuery,
    TiposMantenimientoQueryVariables
>
export const ListenHabitacionesDocument = gql`
    subscription ListenHabitaciones($hotelIdFilter: ID!, $usuario_id: ID!) {
        checkHabitaciones(hotel_id_filter: $hotelIdFilter) {
            numero_habitacion
            estado
            comentario_estado
            alerta_incidencia(tipo_incidencia: [mal_comportamiento, limpieza, mantenimiento, objeto_olvidado]) {
                incidencia_id
                severidad
            }
            posicion {
                tamano
                x
                y
            }
            incidencias_activas
            incidencias_activas_usuario(usuario_id: $usuario_id)
            incidencias(estado: activa) {
                severidad
            }
            fecha_estado
            habitacion_id
            hotel_id
            tipo_habitacion_id
            tipo_habitacion {
                minutos_limpieza_detallada
                minutos_limpieza_normal
                minutos_limpieza_retoque
                minutos_pendiente_supervision
                minutos_sucia
                minutos_supervision
                nombre
            }
            ultima_reserva {
                reserva {
                    nombre_huesped
                    fecha_entrada
                    fecha_salida
                    numero_personas
                    reserva_id
                    comentarios {
                        comentario
                    }
                    tarifa_id
                    tarifa {
                        hora_checkin
                        hora_checkout
                    }
                    experiencias_reserva {
                        experiencia_reserva_id
                        experiencia_id
                        total
                        estado
                        experiencia {
                            nombre
                        }
                    }
                }
            }
            ultima_renta {
                fecha_antigua_por_entregar
                ultimos_conceptos_pendientes {
                    renta_id
                    renta {
                        fecha_registro
                    }
                    extra_id
                    extra {
                        tipo_extra
                        fecha_solicitud
                    }
                    orden_id
                    orden {
                        orden
                        deposito
                        estado_pago
                        fecha_registro
                    }
                }
                fecha_registro
                fecha_fin
                horas_extra
                estado
                ultima_orden {
                    orden_activa
                    orden {
                        fecha_registro
                        estado_pago
                        estado_orden
                    }
                }
                nombre_huesped
                numero_personas
                hospedajes_extra
                cliente_id
                vehiculo {
                    matricula
                    color
                    marca
                    modelo
                }
                fecha_condensada
                renta_id
                folio
                reserva_id
                tipo_entrada
                tarifa_id
                tarifa {
                    duracion_renta
                }
                easyrewards_id
                pagos {
                    pago_id
                    detalles_pago {
                        easyrewards_id
                    }
                }
                subtotales {
                    total_early_checkin
                    total_habitacion
                    total_hospedajes_extra
                    total_horas_extra
                    total_personas_extra
                }
            }
            colaborador_tareas_sin_finalizar {
                tarea_id
                descripcion_tarea
                tarea_id
                fecha_inicio
                fecha_termino
                tipo_limpieza
                colaborador_tarea_id
                colaborador_id
                colaborador {
                    foto
                    nombre
                    apellido_materno
                    apellido_paterno
                }
            }
        }
    }
`
export type ListenHabitacionesComponentProps = Omit<
    ApolloReactComponents.SubscriptionComponentOptions<
        ListenHabitacionesSubscription,
        ListenHabitacionesSubscriptionVariables
    >,
    "subscription"
>

export const ListenHabitacionesComponent = (props: ListenHabitacionesComponentProps) => (
    <ApolloReactComponents.Subscription<ListenHabitacionesSubscription, ListenHabitacionesSubscriptionVariables>
        subscription={ListenHabitacionesDocument}
        {...props}
    />
)

/**
 * __useListenHabitacionesSubscription__
 *
 * To run a query within a React component, call `useListenHabitacionesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenHabitacionesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenHabitacionesSubscription({
 *   variables: {
 *      hotelIdFilter: // value for 'hotelIdFilter'
 *      usuario_id: // value for 'usuario_id'
 *   },
 * });
 */
export function useListenHabitacionesSubscription(
    baseOptions: Apollo.SubscriptionHookOptions<ListenHabitacionesSubscription, ListenHabitacionesSubscriptionVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useSubscription<ListenHabitacionesSubscription, ListenHabitacionesSubscriptionVariables>(
        ListenHabitacionesDocument,
        options
    )
}
export type ListenHabitacionesSubscriptionHookResult = ReturnType<typeof useListenHabitacionesSubscription>
export type ListenHabitacionesSubscriptionResult = Apollo.SubscriptionResult<ListenHabitacionesSubscription>
export const GetModalTurnosAtencionDocument = gql`
    query GetModalTurnosAtencion($hotel_id: ID!, $tipo_habitacion_id: [ID!]) {
        turnos_atencion(hotel_id: $hotel_id, tipo_habitacion_id: $tipo_habitacion_id, estado: en_espera) {
            tipo_habitacion_id
            folio
            folio_turno
            turno_atencion_id
        }
    }
`
export type GetModalTurnosAtencionComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetModalTurnosAtencionQuery, GetModalTurnosAtencionQueryVariables>,
    "query"
> &
    ({ variables: GetModalTurnosAtencionQueryVariables; skip?: boolean } | { skip: boolean })

export const GetModalTurnosAtencionComponent = (props: GetModalTurnosAtencionComponentProps) => (
    <ApolloReactComponents.Query<GetModalTurnosAtencionQuery, GetModalTurnosAtencionQueryVariables>
        query={GetModalTurnosAtencionDocument}
        {...props}
    />
)

/**
 * __useGetModalTurnosAtencionQuery__
 *
 * To run a query within a React component, call `useGetModalTurnosAtencionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModalTurnosAtencionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModalTurnosAtencionQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      tipo_habitacion_id: // value for 'tipo_habitacion_id'
 *   },
 * });
 */
export function useGetModalTurnosAtencionQuery(
    baseOptions: Apollo.QueryHookOptions<GetModalTurnosAtencionQuery, GetModalTurnosAtencionQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetModalTurnosAtencionQuery, GetModalTurnosAtencionQueryVariables>(
        GetModalTurnosAtencionDocument,
        options
    )
}
export function useGetModalTurnosAtencionLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetModalTurnosAtencionQuery, GetModalTurnosAtencionQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetModalTurnosAtencionQuery, GetModalTurnosAtencionQueryVariables>(
        GetModalTurnosAtencionDocument,
        options
    )
}
export type GetModalTurnosAtencionQueryHookResult = ReturnType<typeof useGetModalTurnosAtencionQuery>
export type GetModalTurnosAtencionLazyQueryHookResult = ReturnType<typeof useGetModalTurnosAtencionLazyQuery>
export type GetModalTurnosAtencionQueryResult = Apollo.QueryResult<
    GetModalTurnosAtencionQuery,
    GetModalTurnosAtencionQueryVariables
>
export const GetHabitacionTurnosAtencionDocument = gql`
    query GetHabitacionTurnosAtencion($hotel_id: ID!, $turno_atencion_id: [ID!]) {
        turnos_atencion(hotel_id: $hotel_id, turno_atencion_id: $turno_atencion_id) {
            tipo_habitacion_id
            folio
            folio_turno
            nombre_o_matricula
            estado
        }
    }
`
export type GetHabitacionTurnosAtencionComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetHabitacionTurnosAtencionQuery,
        GetHabitacionTurnosAtencionQueryVariables
    >,
    "query"
> &
    ({ variables: GetHabitacionTurnosAtencionQueryVariables; skip?: boolean } | { skip: boolean })

export const GetHabitacionTurnosAtencionComponent = (props: GetHabitacionTurnosAtencionComponentProps) => (
    <ApolloReactComponents.Query<GetHabitacionTurnosAtencionQuery, GetHabitacionTurnosAtencionQueryVariables>
        query={GetHabitacionTurnosAtencionDocument}
        {...props}
    />
)

/**
 * __useGetHabitacionTurnosAtencionQuery__
 *
 * To run a query within a React component, call `useGetHabitacionTurnosAtencionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHabitacionTurnosAtencionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHabitacionTurnosAtencionQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      turno_atencion_id: // value for 'turno_atencion_id'
 *   },
 * });
 */
export function useGetHabitacionTurnosAtencionQuery(
    baseOptions: Apollo.QueryHookOptions<GetHabitacionTurnosAtencionQuery, GetHabitacionTurnosAtencionQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetHabitacionTurnosAtencionQuery, GetHabitacionTurnosAtencionQueryVariables>(
        GetHabitacionTurnosAtencionDocument,
        options
    )
}
export function useGetHabitacionTurnosAtencionLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetHabitacionTurnosAtencionQuery,
        GetHabitacionTurnosAtencionQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetHabitacionTurnosAtencionQuery, GetHabitacionTurnosAtencionQueryVariables>(
        GetHabitacionTurnosAtencionDocument,
        options
    )
}
export type GetHabitacionTurnosAtencionQueryHookResult = ReturnType<typeof useGetHabitacionTurnosAtencionQuery>
export type GetHabitacionTurnosAtencionLazyQueryHookResult = ReturnType<typeof useGetHabitacionTurnosAtencionLazyQuery>
export type GetHabitacionTurnosAtencionQueryResult = Apollo.QueryResult<
    GetHabitacionTurnosAtencionQuery,
    GetHabitacionTurnosAtencionQueryVariables
>
export const Transacciones_RentaDocument = gql`
    query Transacciones_renta($renta_id: ID!) {
        transacciones_renta(renta_id: $renta_id) {
            renta {
                estado
                folio
                early_checkin
                es_renta_cancelable
                montos_cancelacion {
                    total
                    parcial
                }
                habitacion {
                    tipo_habitacion {
                        nombre
                    }
                }
                renta_id
                corte_id
                ticket_id
                tarifa {
                    nombre
                }
                tipo_alojamiento
                total
            }
            transacciones_checkin {
                extras {
                    extra_id
                    corte_id
                    tipo_extra
                    numero
                    monto_extra
                }
                ticket {
                    ticket_id
                    folio
                    fecha_impresion
                }
            }
            transacciones {
                ticket {
                    ticket_id
                    folio
                    fecha_impresion
                }
                extras {
                    extra_id
                    corte_id
                    tipo_extra
                    numero
                    monto_extra
                    total_con_propina
                }
            }
            ordenes {
                ticket_id
                orden_id
                orden {
                    orden
                    orden_id
                    corte_id
                    total_con_iva
                    fecha_registro
                    detalles_orden {
                        detalle_orden_id
                        cantidad
                        almacen_articulo_id
                        almacen_articulo {
                            almacen_articulo_id
                            articulo_id
                            articulo {
                                articulo_id
                                nombre
                                categoria_id
                                categoria_articulo {
                                    categoria_id
                                    nombre
                                }
                            }
                        }
                        extras {
                            extra_detalle_orden_id
                            cantidad
                            almacen_articulo_id
                            almacen_articulo {
                                almacen_articulo_id
                                articulo_id
                                articulo {
                                    articulo_id
                                    nombre
                                    categoria_id
                                    categoria_articulo {
                                        categoria_id
                                        nombre
                                    }
                                }
                            }
                        }
                    }
                }
                ticket {
                    ticket_id
                    folio
                }
            }
        }
    }
`
export type Transacciones_RentaComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<Transacciones_RentaQuery, Transacciones_RentaQueryVariables>,
    "query"
> &
    ({ variables: Transacciones_RentaQueryVariables; skip?: boolean } | { skip: boolean })

export const Transacciones_RentaComponent = (props: Transacciones_RentaComponentProps) => (
    <ApolloReactComponents.Query<Transacciones_RentaQuery, Transacciones_RentaQueryVariables>
        query={Transacciones_RentaDocument}
        {...props}
    />
)

/**
 * __useTransacciones_RentaQuery__
 *
 * To run a query within a React component, call `useTransacciones_RentaQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransacciones_RentaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransacciones_RentaQuery({
 *   variables: {
 *      renta_id: // value for 'renta_id'
 *   },
 * });
 */
export function useTransacciones_RentaQuery(
    baseOptions: Apollo.QueryHookOptions<Transacciones_RentaQuery, Transacciones_RentaQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<Transacciones_RentaQuery, Transacciones_RentaQueryVariables>(
        Transacciones_RentaDocument,
        options
    )
}
export function useTransacciones_RentaLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<Transacciones_RentaQuery, Transacciones_RentaQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<Transacciones_RentaQuery, Transacciones_RentaQueryVariables>(
        Transacciones_RentaDocument,
        options
    )
}
export type Transacciones_RentaQueryHookResult = ReturnType<typeof useTransacciones_RentaQuery>
export type Transacciones_RentaLazyQueryHookResult = ReturnType<typeof useTransacciones_RentaLazyQuery>
export type Transacciones_RentaQueryResult = Apollo.QueryResult<
    Transacciones_RentaQuery,
    Transacciones_RentaQueryVariables
>
export const Cambiar_Tipo_LimpiezaDocument = gql`
    mutation cambiar_tipo_limpieza($updateTipoLimpiezaInput: UpdateTipoLimpiezaInput!) {
        actualizar_tipo_limpieza(updateTipoLimpiezaInput: $updateTipoLimpiezaInput) {
            tarea_id
            fecha_registro
        }
    }
`
export type Cambiar_Tipo_LimpiezaMutationFn = Apollo.MutationFunction<
    Cambiar_Tipo_LimpiezaMutation,
    Cambiar_Tipo_LimpiezaMutationVariables
>
export type Cambiar_Tipo_LimpiezaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        Cambiar_Tipo_LimpiezaMutation,
        Cambiar_Tipo_LimpiezaMutationVariables
    >,
    "mutation"
>

export const Cambiar_Tipo_LimpiezaComponent = (props: Cambiar_Tipo_LimpiezaComponentProps) => (
    <ApolloReactComponents.Mutation<Cambiar_Tipo_LimpiezaMutation, Cambiar_Tipo_LimpiezaMutationVariables>
        mutation={Cambiar_Tipo_LimpiezaDocument}
        {...props}
    />
)

/**
 * __useCambiar_Tipo_LimpiezaMutation__
 *
 * To run a mutation, you first call `useCambiar_Tipo_LimpiezaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCambiar_Tipo_LimpiezaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cambiarTipoLimpiezaMutation, { data, loading, error }] = useCambiar_Tipo_LimpiezaMutation({
 *   variables: {
 *      updateTipoLimpiezaInput: // value for 'updateTipoLimpiezaInput'
 *   },
 * });
 */
export function useCambiar_Tipo_LimpiezaMutation(
    baseOptions?: Apollo.MutationHookOptions<Cambiar_Tipo_LimpiezaMutation, Cambiar_Tipo_LimpiezaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<Cambiar_Tipo_LimpiezaMutation, Cambiar_Tipo_LimpiezaMutationVariables>(
        Cambiar_Tipo_LimpiezaDocument,
        options
    )
}
export type Cambiar_Tipo_LimpiezaMutationHookResult = ReturnType<typeof useCambiar_Tipo_LimpiezaMutation>
export type Cambiar_Tipo_LimpiezaMutationResult = Apollo.MutationResult<Cambiar_Tipo_LimpiezaMutation>
export type Cambiar_Tipo_LimpiezaMutationOptions = Apollo.BaseMutationOptions<
    Cambiar_Tipo_LimpiezaMutation,
    Cambiar_Tipo_LimpiezaMutationVariables
>
export const GetComentariosColaboradorDocument = gql`
    query GetComentariosColaborador($colaborador_tarea_id: ID!) {
        colaborador_tarea(colaborador_tarea_id: $colaborador_tarea_id) {
            colaborador_tarea_id
            comentarios {
                comentario
                fecha
            }
        }
    }
`
export type GetComentariosColaboradorComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetComentariosColaboradorQuery,
        GetComentariosColaboradorQueryVariables
    >,
    "query"
> &
    ({ variables: GetComentariosColaboradorQueryVariables; skip?: boolean } | { skip: boolean })

export const GetComentariosColaboradorComponent = (props: GetComentariosColaboradorComponentProps) => (
    <ApolloReactComponents.Query<GetComentariosColaboradorQuery, GetComentariosColaboradorQueryVariables>
        query={GetComentariosColaboradorDocument}
        {...props}
    />
)

/**
 * __useGetComentariosColaboradorQuery__
 *
 * To run a query within a React component, call `useGetComentariosColaboradorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComentariosColaboradorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComentariosColaboradorQuery({
 *   variables: {
 *      colaborador_tarea_id: // value for 'colaborador_tarea_id'
 *   },
 * });
 */
export function useGetComentariosColaboradorQuery(
    baseOptions: Apollo.QueryHookOptions<GetComentariosColaboradorQuery, GetComentariosColaboradorQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetComentariosColaboradorQuery, GetComentariosColaboradorQueryVariables>(
        GetComentariosColaboradorDocument,
        options
    )
}
export function useGetComentariosColaboradorLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetComentariosColaboradorQuery, GetComentariosColaboradorQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetComentariosColaboradorQuery, GetComentariosColaboradorQueryVariables>(
        GetComentariosColaboradorDocument,
        options
    )
}
export type GetComentariosColaboradorQueryHookResult = ReturnType<typeof useGetComentariosColaboradorQuery>
export type GetComentariosColaboradorLazyQueryHookResult = ReturnType<typeof useGetComentariosColaboradorLazyQuery>
export type GetComentariosColaboradorQueryResult = Apollo.QueryResult<
    GetComentariosColaboradorQuery,
    GetComentariosColaboradorQueryVariables
>
export const AgregarComentarioATareaDocument = gql`
    mutation AgregarComentarioATarea($comentarios: AddCommentToTaskInput!) {
        agregar_comentarios_a_tarea(comentarios: $comentarios) {
            comentarios {
                comentario
                fecha
            }
        }
    }
`
export type AgregarComentarioATareaMutationFn = Apollo.MutationFunction<
    AgregarComentarioATareaMutation,
    AgregarComentarioATareaMutationVariables
>
export type AgregarComentarioATareaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        AgregarComentarioATareaMutation,
        AgregarComentarioATareaMutationVariables
    >,
    "mutation"
>

export const AgregarComentarioATareaComponent = (props: AgregarComentarioATareaComponentProps) => (
    <ApolloReactComponents.Mutation<AgregarComentarioATareaMutation, AgregarComentarioATareaMutationVariables>
        mutation={AgregarComentarioATareaDocument}
        {...props}
    />
)

/**
 * __useAgregarComentarioATareaMutation__
 *
 * To run a mutation, you first call `useAgregarComentarioATareaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgregarComentarioATareaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agregarComentarioATareaMutation, { data, loading, error }] = useAgregarComentarioATareaMutation({
 *   variables: {
 *      comentarios: // value for 'comentarios'
 *   },
 * });
 */
export function useAgregarComentarioATareaMutation(
    baseOptions?: Apollo.MutationHookOptions<AgregarComentarioATareaMutation, AgregarComentarioATareaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<AgregarComentarioATareaMutation, AgregarComentarioATareaMutationVariables>(
        AgregarComentarioATareaDocument,
        options
    )
}
export type AgregarComentarioATareaMutationHookResult = ReturnType<typeof useAgregarComentarioATareaMutation>
export type AgregarComentarioATareaMutationResult = Apollo.MutationResult<AgregarComentarioATareaMutation>
export type AgregarComentarioATareaMutationOptions = Apollo.BaseMutationOptions<
    AgregarComentarioATareaMutation,
    AgregarComentarioATareaMutationVariables
>
export const EditarDatosVehiculoDocument = gql`
    mutation EditarDatosVehiculo($editVehiculoInput: EditVehiculoDataInput!) {
        editar_datos_vehiculo(EditVehiculoDataInput: $editVehiculoInput) {
            matricula
            color
            marca
            modelo
        }
    }
`
export type EditarDatosVehiculoMutationFn = Apollo.MutationFunction<
    EditarDatosVehiculoMutation,
    EditarDatosVehiculoMutationVariables
>
export type EditarDatosVehiculoComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<EditarDatosVehiculoMutation, EditarDatosVehiculoMutationVariables>,
    "mutation"
>

export const EditarDatosVehiculoComponent = (props: EditarDatosVehiculoComponentProps) => (
    <ApolloReactComponents.Mutation<EditarDatosVehiculoMutation, EditarDatosVehiculoMutationVariables>
        mutation={EditarDatosVehiculoDocument}
        {...props}
    />
)

/**
 * __useEditarDatosVehiculoMutation__
 *
 * To run a mutation, you first call `useEditarDatosVehiculoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditarDatosVehiculoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editarDatosVehiculoMutation, { data, loading, error }] = useEditarDatosVehiculoMutation({
 *   variables: {
 *      editVehiculoInput: // value for 'editVehiculoInput'
 *   },
 * });
 */
export function useEditarDatosVehiculoMutation(
    baseOptions?: Apollo.MutationHookOptions<EditarDatosVehiculoMutation, EditarDatosVehiculoMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<EditarDatosVehiculoMutation, EditarDatosVehiculoMutationVariables>(
        EditarDatosVehiculoDocument,
        options
    )
}
export type EditarDatosVehiculoMutationHookResult = ReturnType<typeof useEditarDatosVehiculoMutation>
export type EditarDatosVehiculoMutationResult = Apollo.MutationResult<EditarDatosVehiculoMutation>
export type EditarDatosVehiculoMutationOptions = Apollo.BaseMutationOptions<
    EditarDatosVehiculoMutation,
    EditarDatosVehiculoMutationVariables
>
export const GetReservacionByIdDocument = gql`
    query GetReservacionById($id: [ID!]!) {
        reservas(reserva_id: $id) {
            reserva_id
            codigo_ota
            corte_id
            folio
            estado
            fecha_cancelacion
            fecha_salida
            fecha_entrada
            origen
            personas_extras
            comentarios {
                comentario
            }
            tipo_habitacion_id
            tipo_de_habitacion {
                nombre
            }
            habitacion_id
            habitacion {
                numero_habitacion
                habitacion_id
                tipo_habitacion {
                    nombre
                }
            }
            hospedajes_extra
            tarifa_id
            tarifa {
                nombre
                personas_extra_max
                costo_persona_extra
                tipo_alojamiento
                costo_habitacion
                tarifa_id
                nombre
            }
            correo_huesped
            nombre_huesped
            telefono_huesped
            numero_personas
            usuario {
                nombre
            }
            estado_pago
            total
            easyrewards_id
            pagos {
                pago_id
                total
                detalles_pago {
                    detalle_pago_id
                    subtotal
                    tipo_pago
                    ultimos_digitos
                    numero_referencia
                    easyrewards_id
                }
                fecha_pago
                extras {
                    monto_devuelto_cancelacion
                    fecha_cancelacion
                    fecha_pago
                    fecha_solicitud
                    monto_extra
                    motivo_cancelacion
                    numero
                    tipo_extra
                }
            }
            experiencias_reserva {
                experiencia_reserva_id
                experiencia_id
                total
                estado
                experiencia {
                    nombre
                }
            }
        }
    }
`
export type GetReservacionByIdComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetReservacionByIdQuery, GetReservacionByIdQueryVariables>,
    "query"
> &
    ({ variables: GetReservacionByIdQueryVariables; skip?: boolean } | { skip: boolean })

export const GetReservacionByIdComponent = (props: GetReservacionByIdComponentProps) => (
    <ApolloReactComponents.Query<GetReservacionByIdQuery, GetReservacionByIdQueryVariables>
        query={GetReservacionByIdDocument}
        {...props}
    />
)

/**
 * __useGetReservacionByIdQuery__
 *
 * To run a query within a React component, call `useGetReservacionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservacionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservacionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReservacionByIdQuery(
    baseOptions: Apollo.QueryHookOptions<GetReservacionByIdQuery, GetReservacionByIdQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetReservacionByIdQuery, GetReservacionByIdQueryVariables>(
        GetReservacionByIdDocument,
        options
    )
}
export function useGetReservacionByIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetReservacionByIdQuery, GetReservacionByIdQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetReservacionByIdQuery, GetReservacionByIdQueryVariables>(
        GetReservacionByIdDocument,
        options
    )
}
export type GetReservacionByIdQueryHookResult = ReturnType<typeof useGetReservacionByIdQuery>
export type GetReservacionByIdLazyQueryHookResult = ReturnType<typeof useGetReservacionByIdLazyQuery>
export type GetReservacionByIdQueryResult = Apollo.QueryResult<
    GetReservacionByIdQuery,
    GetReservacionByIdQueryVariables
>
export const RemoverReservaHabitacionDocument = gql`
    mutation RemoverReservaHabitacion($input: RemoveBookingFromRoomInput!) {
        remover_reserva_de_habitacion(remover_reserva_de_habitacion_input: $input)
    }
`
export type RemoverReservaHabitacionMutationFn = Apollo.MutationFunction<
    RemoverReservaHabitacionMutation,
    RemoverReservaHabitacionMutationVariables
>
export type RemoverReservaHabitacionComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        RemoverReservaHabitacionMutation,
        RemoverReservaHabitacionMutationVariables
    >,
    "mutation"
>

export const RemoverReservaHabitacionComponent = (props: RemoverReservaHabitacionComponentProps) => (
    <ApolloReactComponents.Mutation<RemoverReservaHabitacionMutation, RemoverReservaHabitacionMutationVariables>
        mutation={RemoverReservaHabitacionDocument}
        {...props}
    />
)

/**
 * __useRemoverReservaHabitacionMutation__
 *
 * To run a mutation, you first call `useRemoverReservaHabitacionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoverReservaHabitacionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removerReservaHabitacionMutation, { data, loading, error }] = useRemoverReservaHabitacionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoverReservaHabitacionMutation(
    baseOptions?: Apollo.MutationHookOptions<
        RemoverReservaHabitacionMutation,
        RemoverReservaHabitacionMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<RemoverReservaHabitacionMutation, RemoverReservaHabitacionMutationVariables>(
        RemoverReservaHabitacionDocument,
        options
    )
}
export type RemoverReservaHabitacionMutationHookResult = ReturnType<typeof useRemoverReservaHabitacionMutation>
export type RemoverReservaHabitacionMutationResult = Apollo.MutationResult<RemoverReservaHabitacionMutation>
export type RemoverReservaHabitacionMutationOptions = Apollo.BaseMutationOptions<
    RemoverReservaHabitacionMutation,
    RemoverReservaHabitacionMutationVariables
>
export const GetIncidenciasDocument = gql`
    query GetIncidencias($hotel_id: ID!, $fecha_operacion: DateSearchInput, $search: String) {
        incidencias(hotel_id: $hotel_id, fecha_operacion: $fecha_operacion, search: $search) {
            incidencia_id
            detalle
            habitacion_id
            folio
            fecha_registro
            fecha_cierre
            colaborador_id_reporta
            estado
            huesped
            matricula
            tipo_incidencia
            colaborador_reporta {
                nombre
                apellido_paterno
                apellido_materno
                puesto {
                    nombre
                }
            }
            colaborador_id_cierra
            colaborador_cierra {
                nombre
                apellido_paterno
                apellido_materno
            }
            area
            severidad
            turno_id
            turno {
                nombre
            }
            habitacion {
                habitacion_id
                numero_habitacion
                tipo_habitacion_id
                tipo_habitacion {
                    tipo_habitacion_id
                    nombre
                }
            }
        }
    }
`
export type GetIncidenciasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetIncidenciasQuery, GetIncidenciasQueryVariables>,
    "query"
> &
    ({ variables: GetIncidenciasQueryVariables; skip?: boolean } | { skip: boolean })

export const GetIncidenciasComponent = (props: GetIncidenciasComponentProps) => (
    <ApolloReactComponents.Query<GetIncidenciasQuery, GetIncidenciasQueryVariables>
        query={GetIncidenciasDocument}
        {...props}
    />
)

/**
 * __useGetIncidenciasQuery__
 *
 * To run a query within a React component, call `useGetIncidenciasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncidenciasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncidenciasQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      fecha_operacion: // value for 'fecha_operacion'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetIncidenciasQuery(
    baseOptions: Apollo.QueryHookOptions<GetIncidenciasQuery, GetIncidenciasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetIncidenciasQuery, GetIncidenciasQueryVariables>(GetIncidenciasDocument, options)
}
export function useGetIncidenciasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetIncidenciasQuery, GetIncidenciasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetIncidenciasQuery, GetIncidenciasQueryVariables>(GetIncidenciasDocument, options)
}
export type GetIncidenciasQueryHookResult = ReturnType<typeof useGetIncidenciasQuery>
export type GetIncidenciasLazyQueryHookResult = ReturnType<typeof useGetIncidenciasLazyQuery>
export type GetIncidenciasQueryResult = Apollo.QueryResult<GetIncidenciasQuery, GetIncidenciasQueryVariables>
export const GetIncidenciaByIdDocument = gql`
    query GetIncidenciaById($incidencia_id: ID!) {
        incidencias(incidencia_id: $incidencia_id) {
            incidencia_id
            detalle
            habitacion_id
            folio
            fecha_registro
            fecha_cierre
            colaborador_id_reporta
            estado
            huesped
            matricula
            vehiculo {
                color
                marca
                modelo
            }
            tipo_incidencia
            colaborador_reporta {
                nombre
                apellido_paterno
                apellido_materno
            }
            colaborador_id_cierra
            colaborador_cierra {
                nombre
                apellido_paterno
                apellido_materno
            }
            area
            severidad
            turno_id
            turno {
                nombre
            }
            habitacion {
                habitacion_id
                numero_habitacion
                tipo_habitacion_id
                tipo_habitacion {
                    tipo_habitacion_id
                    nombre
                }
            }
            comentario_cierre
            imagenes {
                id
                imagen
            }
        }
    }
`
export type GetIncidenciaByIdComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetIncidenciaByIdQuery, GetIncidenciaByIdQueryVariables>,
    "query"
> &
    ({ variables: GetIncidenciaByIdQueryVariables; skip?: boolean } | { skip: boolean })

export const GetIncidenciaByIdComponent = (props: GetIncidenciaByIdComponentProps) => (
    <ApolloReactComponents.Query<GetIncidenciaByIdQuery, GetIncidenciaByIdQueryVariables>
        query={GetIncidenciaByIdDocument}
        {...props}
    />
)

/**
 * __useGetIncidenciaByIdQuery__
 *
 * To run a query within a React component, call `useGetIncidenciaByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncidenciaByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncidenciaByIdQuery({
 *   variables: {
 *      incidencia_id: // value for 'incidencia_id'
 *   },
 * });
 */
export function useGetIncidenciaByIdQuery(
    baseOptions: Apollo.QueryHookOptions<GetIncidenciaByIdQuery, GetIncidenciaByIdQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetIncidenciaByIdQuery, GetIncidenciaByIdQueryVariables>(GetIncidenciaByIdDocument, options)
}
export function useGetIncidenciaByIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetIncidenciaByIdQuery, GetIncidenciaByIdQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetIncidenciaByIdQuery, GetIncidenciaByIdQueryVariables>(
        GetIncidenciaByIdDocument,
        options
    )
}
export type GetIncidenciaByIdQueryHookResult = ReturnType<typeof useGetIncidenciaByIdQuery>
export type GetIncidenciaByIdLazyQueryHookResult = ReturnType<typeof useGetIncidenciaByIdLazyQuery>
export type GetIncidenciaByIdQueryResult = Apollo.QueryResult<GetIncidenciaByIdQuery, GetIncidenciaByIdQueryVariables>
export const ReabrirIncidenciaDocument = gql`
    mutation ReabrirIncidencia($datos_incidencia: OpenIncidenciaInput!) {
        reabrir_incidencia(datos_incidencia: $datos_incidencia) {
            incidencia_id
        }
    }
`
export type ReabrirIncidenciaMutationFn = Apollo.MutationFunction<
    ReabrirIncidenciaMutation,
    ReabrirIncidenciaMutationVariables
>
export type ReabrirIncidenciaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<ReabrirIncidenciaMutation, ReabrirIncidenciaMutationVariables>,
    "mutation"
>

export const ReabrirIncidenciaComponent = (props: ReabrirIncidenciaComponentProps) => (
    <ApolloReactComponents.Mutation<ReabrirIncidenciaMutation, ReabrirIncidenciaMutationVariables>
        mutation={ReabrirIncidenciaDocument}
        {...props}
    />
)

/**
 * __useReabrirIncidenciaMutation__
 *
 * To run a mutation, you first call `useReabrirIncidenciaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReabrirIncidenciaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reabrirIncidenciaMutation, { data, loading, error }] = useReabrirIncidenciaMutation({
 *   variables: {
 *      datos_incidencia: // value for 'datos_incidencia'
 *   },
 * });
 */
export function useReabrirIncidenciaMutation(
    baseOptions?: Apollo.MutationHookOptions<ReabrirIncidenciaMutation, ReabrirIncidenciaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ReabrirIncidenciaMutation, ReabrirIncidenciaMutationVariables>(
        ReabrirIncidenciaDocument,
        options
    )
}
export type ReabrirIncidenciaMutationHookResult = ReturnType<typeof useReabrirIncidenciaMutation>
export type ReabrirIncidenciaMutationResult = Apollo.MutationResult<ReabrirIncidenciaMutation>
export type ReabrirIncidenciaMutationOptions = Apollo.BaseMutationOptions<
    ReabrirIncidenciaMutation,
    ReabrirIncidenciaMutationVariables
>
export const GetIncidenciaByFiltersDocument = gql`
    query GetIncidenciaByFilters($hotel_id: ID!, $matricula: String, $huesped: String) {
        incidencias(hotel_id: $hotel_id, matricula: $matricula, huesped: $huesped) {
            incidencia_id
            folio
            huesped
            matricula
        }
    }
`
export type GetIncidenciaByFiltersComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetIncidenciaByFiltersQuery, GetIncidenciaByFiltersQueryVariables>,
    "query"
> &
    ({ variables: GetIncidenciaByFiltersQueryVariables; skip?: boolean } | { skip: boolean })

export const GetIncidenciaByFiltersComponent = (props: GetIncidenciaByFiltersComponentProps) => (
    <ApolloReactComponents.Query<GetIncidenciaByFiltersQuery, GetIncidenciaByFiltersQueryVariables>
        query={GetIncidenciaByFiltersDocument}
        {...props}
    />
)

/**
 * __useGetIncidenciaByFiltersQuery__
 *
 * To run a query within a React component, call `useGetIncidenciaByFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncidenciaByFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncidenciaByFiltersQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      matricula: // value for 'matricula'
 *      huesped: // value for 'huesped'
 *   },
 * });
 */
export function useGetIncidenciaByFiltersQuery(
    baseOptions: Apollo.QueryHookOptions<GetIncidenciaByFiltersQuery, GetIncidenciaByFiltersQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetIncidenciaByFiltersQuery, GetIncidenciaByFiltersQueryVariables>(
        GetIncidenciaByFiltersDocument,
        options
    )
}
export function useGetIncidenciaByFiltersLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetIncidenciaByFiltersQuery, GetIncidenciaByFiltersQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetIncidenciaByFiltersQuery, GetIncidenciaByFiltersQueryVariables>(
        GetIncidenciaByFiltersDocument,
        options
    )
}
export type GetIncidenciaByFiltersQueryHookResult = ReturnType<typeof useGetIncidenciaByFiltersQuery>
export type GetIncidenciaByFiltersLazyQueryHookResult = ReturnType<typeof useGetIncidenciaByFiltersLazyQuery>
export type GetIncidenciaByFiltersQueryResult = Apollo.QueryResult<
    GetIncidenciaByFiltersQuery,
    GetIncidenciaByFiltersQueryVariables
>
export const TableArticulosDocument = gql`
    query TableArticulos(
        $hotel_id: ID!
        $almacen_id: [ID!]
        $filter_tipo_articulo: [TipoArticulo!]
        $pagination_options: PageOptionsArgs!
        $nombreArticuloFilterOrder: TipoOrdenamiento
        $filterEstadoArticulo: EstadosArticulo
        $filterEstadoAlmacenArticulo: [EstadosAlmacenesArticulos!]
    ) {
        almacenes_articulos(
            hotel_id: $hotel_id
            almacen_id: $almacen_id
            eliminado: false
            estado_almacen_articulo: $filterEstadoAlmacenArticulo
            filter_estado_articulo: $filterEstadoArticulo
            folio_articulo_filters: { order: ASC }
            nombre_articulo_filters: { order: $nombreArticuloFilterOrder }
            filter_tipo_articulo: $filter_tipo_articulo
            filter_producciones: true
            pagination_options: $pagination_options
        ) {
            paginacion {
                pagina_actual
                total_paginas
            }
            almacenes_articulos {
                almacen_articulo_id
                almacen_id
                articulo_id
                cantidad
                costo
                eliminado
                estado
                fecha_movimiento
                hotel_id
                precio
                articulo {
                    articulo_id
                    cantidad_minima
                    cantidad_vendida
                    categoria_id
                    contenido
                    descripcion
                    eliminado
                    estado
                    extra
                    fecha_eliminado
                    fecha_registro
                    folio
                    folio_articulo
                    foto
                    marca
                    nombre
                    sku
                    stock
                    tipo
                    unidad
                }
                almacen {
                    almacen_id
                    nombre
                }
                ultimo_surtido {
                    almacen_articulo_id
                    cantidad
                    colaborador_id
                    comentario
                    costo_total
                    costo_unitario
                    fecha_ingreso
                    folio
                    hotel_id
                    numero_orden_factura
                    surtido_id
                    tipo
                }
            }
        }
    }
`
export type TableArticulosComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<TableArticulosQuery, TableArticulosQueryVariables>,
    "query"
> &
    ({ variables: TableArticulosQueryVariables; skip?: boolean } | { skip: boolean })

export const TableArticulosComponent = (props: TableArticulosComponentProps) => (
    <ApolloReactComponents.Query<TableArticulosQuery, TableArticulosQueryVariables>
        query={TableArticulosDocument}
        {...props}
    />
)

/**
 * __useTableArticulosQuery__
 *
 * To run a query within a React component, call `useTableArticulosQuery` and pass it any options that fit your needs.
 * When your component renders, `useTableArticulosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTableArticulosQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      almacen_id: // value for 'almacen_id'
 *      filter_tipo_articulo: // value for 'filter_tipo_articulo'
 *      pagination_options: // value for 'pagination_options'
 *      nombreArticuloFilterOrder: // value for 'nombreArticuloFilterOrder'
 *      filterEstadoArticulo: // value for 'filterEstadoArticulo'
 *      filterEstadoAlmacenArticulo: // value for 'filterEstadoAlmacenArticulo'
 *   },
 * });
 */
export function useTableArticulosQuery(
    baseOptions: Apollo.QueryHookOptions<TableArticulosQuery, TableArticulosQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<TableArticulosQuery, TableArticulosQueryVariables>(TableArticulosDocument, options)
}
export function useTableArticulosLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<TableArticulosQuery, TableArticulosQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<TableArticulosQuery, TableArticulosQueryVariables>(TableArticulosDocument, options)
}
export type TableArticulosQueryHookResult = ReturnType<typeof useTableArticulosQuery>
export type TableArticulosLazyQueryHookResult = ReturnType<typeof useTableArticulosLazyQuery>
export type TableArticulosQueryResult = Apollo.QueryResult<TableArticulosQuery, TableArticulosQueryVariables>
export const CrearConfiguracionInventarioDocument = gql`
    mutation CrearConfiguracionInventario($create_configuracion_inventario: CreateConfiguracionInventarioInput!) {
        crear_configuracion_inventario(create_configuracion_inventario: $create_configuracion_inventario) {
            configuracion_inventario_id
            hotel_id
            inventario_negativo
        }
    }
`
export type CrearConfiguracionInventarioMutationFn = Apollo.MutationFunction<
    CrearConfiguracionInventarioMutation,
    CrearConfiguracionInventarioMutationVariables
>
export type CrearConfiguracionInventarioComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        CrearConfiguracionInventarioMutation,
        CrearConfiguracionInventarioMutationVariables
    >,
    "mutation"
>

export const CrearConfiguracionInventarioComponent = (props: CrearConfiguracionInventarioComponentProps) => (
    <ApolloReactComponents.Mutation<CrearConfiguracionInventarioMutation, CrearConfiguracionInventarioMutationVariables>
        mutation={CrearConfiguracionInventarioDocument}
        {...props}
    />
)

/**
 * __useCrearConfiguracionInventarioMutation__
 *
 * To run a mutation, you first call `useCrearConfiguracionInventarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrearConfiguracionInventarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crearConfiguracionInventarioMutation, { data, loading, error }] = useCrearConfiguracionInventarioMutation({
 *   variables: {
 *      create_configuracion_inventario: // value for 'create_configuracion_inventario'
 *   },
 * });
 */
export function useCrearConfiguracionInventarioMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CrearConfiguracionInventarioMutation,
        CrearConfiguracionInventarioMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CrearConfiguracionInventarioMutation, CrearConfiguracionInventarioMutationVariables>(
        CrearConfiguracionInventarioDocument,
        options
    )
}
export type CrearConfiguracionInventarioMutationHookResult = ReturnType<typeof useCrearConfiguracionInventarioMutation>
export type CrearConfiguracionInventarioMutationResult = Apollo.MutationResult<CrearConfiguracionInventarioMutation>
export type CrearConfiguracionInventarioMutationOptions = Apollo.BaseMutationOptions<
    CrearConfiguracionInventarioMutation,
    CrearConfiguracionInventarioMutationVariables
>
export const ActualizarConfiguracionInventarioInputDocument = gql`
    mutation ActualizarConfiguracionInventarioInput(
        $update_configuracion_inventario: UpdateConfiguracionInventarioInput!
    ) {
        actualizar_configuracion_inventario(update_configuracion_inventario: $update_configuracion_inventario) {
            configuracion_inventario_id
            hotel_id
            inventario_negativo
        }
    }
`
export type ActualizarConfiguracionInventarioInputMutationFn = Apollo.MutationFunction<
    ActualizarConfiguracionInventarioInputMutation,
    ActualizarConfiguracionInventarioInputMutationVariables
>
export type ActualizarConfiguracionInventarioInputComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        ActualizarConfiguracionInventarioInputMutation,
        ActualizarConfiguracionInventarioInputMutationVariables
    >,
    "mutation"
>

export const ActualizarConfiguracionInventarioInputComponent = (
    props: ActualizarConfiguracionInventarioInputComponentProps
) => (
    <ApolloReactComponents.Mutation<
        ActualizarConfiguracionInventarioInputMutation,
        ActualizarConfiguracionInventarioInputMutationVariables
    >
        mutation={ActualizarConfiguracionInventarioInputDocument}
        {...props}
    />
)

/**
 * __useActualizarConfiguracionInventarioInputMutation__
 *
 * To run a mutation, you first call `useActualizarConfiguracionInventarioInputMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizarConfiguracionInventarioInputMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizarConfiguracionInventarioInputMutation, { data, loading, error }] = useActualizarConfiguracionInventarioInputMutation({
 *   variables: {
 *      update_configuracion_inventario: // value for 'update_configuracion_inventario'
 *   },
 * });
 */
export function useActualizarConfiguracionInventarioInputMutation(
    baseOptions?: Apollo.MutationHookOptions<
        ActualizarConfiguracionInventarioInputMutation,
        ActualizarConfiguracionInventarioInputMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        ActualizarConfiguracionInventarioInputMutation,
        ActualizarConfiguracionInventarioInputMutationVariables
    >(ActualizarConfiguracionInventarioInputDocument, options)
}
export type ActualizarConfiguracionInventarioInputMutationHookResult = ReturnType<
    typeof useActualizarConfiguracionInventarioInputMutation
>
export type ActualizarConfiguracionInventarioInputMutationResult =
    Apollo.MutationResult<ActualizarConfiguracionInventarioInputMutation>
export type ActualizarConfiguracionInventarioInputMutationOptions = Apollo.BaseMutationOptions<
    ActualizarConfiguracionInventarioInputMutation,
    ActualizarConfiguracionInventarioInputMutationVariables
>
export const CrearCategoriaArticuloDocument = gql`
    mutation CrearCategoriaArticulo($datos_categoria: CreateCategoriaArticuloInput!) {
        crear_categoria_articulo(datos_categoria: $datos_categoria) {
            hotel_id
            nombre
            descripcion
        }
    }
`
export type CrearCategoriaArticuloMutationFn = Apollo.MutationFunction<
    CrearCategoriaArticuloMutation,
    CrearCategoriaArticuloMutationVariables
>
export type CrearCategoriaArticuloComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        CrearCategoriaArticuloMutation,
        CrearCategoriaArticuloMutationVariables
    >,
    "mutation"
>

export const CrearCategoriaArticuloComponent = (props: CrearCategoriaArticuloComponentProps) => (
    <ApolloReactComponents.Mutation<CrearCategoriaArticuloMutation, CrearCategoriaArticuloMutationVariables>
        mutation={CrearCategoriaArticuloDocument}
        {...props}
    />
)

/**
 * __useCrearCategoriaArticuloMutation__
 *
 * To run a mutation, you first call `useCrearCategoriaArticuloMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrearCategoriaArticuloMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crearCategoriaArticuloMutation, { data, loading, error }] = useCrearCategoriaArticuloMutation({
 *   variables: {
 *      datos_categoria: // value for 'datos_categoria'
 *   },
 * });
 */
export function useCrearCategoriaArticuloMutation(
    baseOptions?: Apollo.MutationHookOptions<CrearCategoriaArticuloMutation, CrearCategoriaArticuloMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CrearCategoriaArticuloMutation, CrearCategoriaArticuloMutationVariables>(
        CrearCategoriaArticuloDocument,
        options
    )
}
export type CrearCategoriaArticuloMutationHookResult = ReturnType<typeof useCrearCategoriaArticuloMutation>
export type CrearCategoriaArticuloMutationResult = Apollo.MutationResult<CrearCategoriaArticuloMutation>
export type CrearCategoriaArticuloMutationOptions = Apollo.BaseMutationOptions<
    CrearCategoriaArticuloMutation,
    CrearCategoriaArticuloMutationVariables
>
export const ActualizarCategoriaArticuloDocument = gql`
    mutation ActualizarCategoriaArticulo($datos_categoria: UpdateCategoriaArticuloInput!) {
        actualizar_categoria_articulo(datos_categoria: $datos_categoria) {
            categoria_id
            hotel_id
            nombre
            descripcion
        }
    }
`
export type ActualizarCategoriaArticuloMutationFn = Apollo.MutationFunction<
    ActualizarCategoriaArticuloMutation,
    ActualizarCategoriaArticuloMutationVariables
>
export type ActualizarCategoriaArticuloComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        ActualizarCategoriaArticuloMutation,
        ActualizarCategoriaArticuloMutationVariables
    >,
    "mutation"
>

export const ActualizarCategoriaArticuloComponent = (props: ActualizarCategoriaArticuloComponentProps) => (
    <ApolloReactComponents.Mutation<ActualizarCategoriaArticuloMutation, ActualizarCategoriaArticuloMutationVariables>
        mutation={ActualizarCategoriaArticuloDocument}
        {...props}
    />
)

/**
 * __useActualizarCategoriaArticuloMutation__
 *
 * To run a mutation, you first call `useActualizarCategoriaArticuloMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizarCategoriaArticuloMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizarCategoriaArticuloMutation, { data, loading, error }] = useActualizarCategoriaArticuloMutation({
 *   variables: {
 *      datos_categoria: // value for 'datos_categoria'
 *   },
 * });
 */
export function useActualizarCategoriaArticuloMutation(
    baseOptions?: Apollo.MutationHookOptions<
        ActualizarCategoriaArticuloMutation,
        ActualizarCategoriaArticuloMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ActualizarCategoriaArticuloMutation, ActualizarCategoriaArticuloMutationVariables>(
        ActualizarCategoriaArticuloDocument,
        options
    )
}
export type ActualizarCategoriaArticuloMutationHookResult = ReturnType<typeof useActualizarCategoriaArticuloMutation>
export type ActualizarCategoriaArticuloMutationResult = Apollo.MutationResult<ActualizarCategoriaArticuloMutation>
export type ActualizarCategoriaArticuloMutationOptions = Apollo.BaseMutationOptions<
    ActualizarCategoriaArticuloMutation,
    ActualizarCategoriaArticuloMutationVariables
>
export const EliminarCategoriaArticuloDocument = gql`
    mutation EliminarCategoriaArticulo($datos_categoria: DeleteCategoriaArticuloInput!) {
        eliminar_categoria_articulo(datos_categoria: $datos_categoria) {
            categoria_id
        }
    }
`
export type EliminarCategoriaArticuloMutationFn = Apollo.MutationFunction<
    EliminarCategoriaArticuloMutation,
    EliminarCategoriaArticuloMutationVariables
>
export type EliminarCategoriaArticuloComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        EliminarCategoriaArticuloMutation,
        EliminarCategoriaArticuloMutationVariables
    >,
    "mutation"
>

export const EliminarCategoriaArticuloComponent = (props: EliminarCategoriaArticuloComponentProps) => (
    <ApolloReactComponents.Mutation<EliminarCategoriaArticuloMutation, EliminarCategoriaArticuloMutationVariables>
        mutation={EliminarCategoriaArticuloDocument}
        {...props}
    />
)

/**
 * __useEliminarCategoriaArticuloMutation__
 *
 * To run a mutation, you first call `useEliminarCategoriaArticuloMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEliminarCategoriaArticuloMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eliminarCategoriaArticuloMutation, { data, loading, error }] = useEliminarCategoriaArticuloMutation({
 *   variables: {
 *      datos_categoria: // value for 'datos_categoria'
 *   },
 * });
 */
export function useEliminarCategoriaArticuloMutation(
    baseOptions?: Apollo.MutationHookOptions<
        EliminarCategoriaArticuloMutation,
        EliminarCategoriaArticuloMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<EliminarCategoriaArticuloMutation, EliminarCategoriaArticuloMutationVariables>(
        EliminarCategoriaArticuloDocument,
        options
    )
}
export type EliminarCategoriaArticuloMutationHookResult = ReturnType<typeof useEliminarCategoriaArticuloMutation>
export type EliminarCategoriaArticuloMutationResult = Apollo.MutationResult<EliminarCategoriaArticuloMutation>
export type EliminarCategoriaArticuloMutationOptions = Apollo.BaseMutationOptions<
    EliminarCategoriaArticuloMutation,
    EliminarCategoriaArticuloMutationVariables
>
export const CrearAlmacenDocument = gql`
    mutation CrearAlmacen($createAlmacenInput: CreateAlmacenInput!) {
        crear_almacen(createAlmacenInput: $createAlmacenInput) {
            almacen_id
            descripcion
            hotel_id
            nombre
            tipo_almacen
            usuario_modifico_id
        }
    }
`
export type CrearAlmacenMutationFn = Apollo.MutationFunction<CrearAlmacenMutation, CrearAlmacenMutationVariables>
export type CrearAlmacenComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CrearAlmacenMutation, CrearAlmacenMutationVariables>,
    "mutation"
>

export const CrearAlmacenComponent = (props: CrearAlmacenComponentProps) => (
    <ApolloReactComponents.Mutation<CrearAlmacenMutation, CrearAlmacenMutationVariables>
        mutation={CrearAlmacenDocument}
        {...props}
    />
)

/**
 * __useCrearAlmacenMutation__
 *
 * To run a mutation, you first call `useCrearAlmacenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrearAlmacenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crearAlmacenMutation, { data, loading, error }] = useCrearAlmacenMutation({
 *   variables: {
 *      createAlmacenInput: // value for 'createAlmacenInput'
 *   },
 * });
 */
export function useCrearAlmacenMutation(
    baseOptions?: Apollo.MutationHookOptions<CrearAlmacenMutation, CrearAlmacenMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CrearAlmacenMutation, CrearAlmacenMutationVariables>(CrearAlmacenDocument, options)
}
export type CrearAlmacenMutationHookResult = ReturnType<typeof useCrearAlmacenMutation>
export type CrearAlmacenMutationResult = Apollo.MutationResult<CrearAlmacenMutation>
export type CrearAlmacenMutationOptions = Apollo.BaseMutationOptions<
    CrearAlmacenMutation,
    CrearAlmacenMutationVariables
>
export const ActualizarAlmacenDocument = gql`
    mutation ActualizarAlmacen($updateAlmacenInput: UpdateAlmacenInput!) {
        actualizar_almacen(updateAlmacenInput: $updateAlmacenInput) {
            almacen_id
            descripcion
            hotel_id
            nombre
            tipo_almacen
            usuario_modifico_id
        }
    }
`
export type ActualizarAlmacenMutationFn = Apollo.MutationFunction<
    ActualizarAlmacenMutation,
    ActualizarAlmacenMutationVariables
>
export type ActualizarAlmacenComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<ActualizarAlmacenMutation, ActualizarAlmacenMutationVariables>,
    "mutation"
>

export const ActualizarAlmacenComponent = (props: ActualizarAlmacenComponentProps) => (
    <ApolloReactComponents.Mutation<ActualizarAlmacenMutation, ActualizarAlmacenMutationVariables>
        mutation={ActualizarAlmacenDocument}
        {...props}
    />
)

/**
 * __useActualizarAlmacenMutation__
 *
 * To run a mutation, you first call `useActualizarAlmacenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizarAlmacenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizarAlmacenMutation, { data, loading, error }] = useActualizarAlmacenMutation({
 *   variables: {
 *      updateAlmacenInput: // value for 'updateAlmacenInput'
 *   },
 * });
 */
export function useActualizarAlmacenMutation(
    baseOptions?: Apollo.MutationHookOptions<ActualizarAlmacenMutation, ActualizarAlmacenMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ActualizarAlmacenMutation, ActualizarAlmacenMutationVariables>(
        ActualizarAlmacenDocument,
        options
    )
}
export type ActualizarAlmacenMutationHookResult = ReturnType<typeof useActualizarAlmacenMutation>
export type ActualizarAlmacenMutationResult = Apollo.MutationResult<ActualizarAlmacenMutation>
export type ActualizarAlmacenMutationOptions = Apollo.BaseMutationOptions<
    ActualizarAlmacenMutation,
    ActualizarAlmacenMutationVariables
>
export const EliminarAlmacenDocument = gql`
    mutation EliminarAlmacen($deleteAlmacenInput: DeleteAlmacenInput!) {
        eliminar_almacen(deleteAlmacenInput: $deleteAlmacenInput)
    }
`
export type EliminarAlmacenMutationFn = Apollo.MutationFunction<
    EliminarAlmacenMutation,
    EliminarAlmacenMutationVariables
>
export type EliminarAlmacenComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<EliminarAlmacenMutation, EliminarAlmacenMutationVariables>,
    "mutation"
>

export const EliminarAlmacenComponent = (props: EliminarAlmacenComponentProps) => (
    <ApolloReactComponents.Mutation<EliminarAlmacenMutation, EliminarAlmacenMutationVariables>
        mutation={EliminarAlmacenDocument}
        {...props}
    />
)

/**
 * __useEliminarAlmacenMutation__
 *
 * To run a mutation, you first call `useEliminarAlmacenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEliminarAlmacenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eliminarAlmacenMutation, { data, loading, error }] = useEliminarAlmacenMutation({
 *   variables: {
 *      deleteAlmacenInput: // value for 'deleteAlmacenInput'
 *   },
 * });
 */
export function useEliminarAlmacenMutation(
    baseOptions?: Apollo.MutationHookOptions<EliminarAlmacenMutation, EliminarAlmacenMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<EliminarAlmacenMutation, EliminarAlmacenMutationVariables>(
        EliminarAlmacenDocument,
        options
    )
}
export type EliminarAlmacenMutationHookResult = ReturnType<typeof useEliminarAlmacenMutation>
export type EliminarAlmacenMutationResult = Apollo.MutationResult<EliminarAlmacenMutation>
export type EliminarAlmacenMutationOptions = Apollo.BaseMutationOptions<
    EliminarAlmacenMutation,
    EliminarAlmacenMutationVariables
>
export const ConfiguracionInventarioDocument = gql`
    query ConfiguracionInventario($hotel_id: ID!) {
        configuraciones_inventario(hotel_id: $hotel_id) {
            configuracion_inventario_id
            inventario_negativo
            configuraciones {
                cardRSNegativo
            }
        }
    }
`
export type ConfiguracionInventarioComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<ConfiguracionInventarioQuery, ConfiguracionInventarioQueryVariables>,
    "query"
> &
    ({ variables: ConfiguracionInventarioQueryVariables; skip?: boolean } | { skip: boolean })

export const ConfiguracionInventarioComponent = (props: ConfiguracionInventarioComponentProps) => (
    <ApolloReactComponents.Query<ConfiguracionInventarioQuery, ConfiguracionInventarioQueryVariables>
        query={ConfiguracionInventarioDocument}
        {...props}
    />
)

/**
 * __useConfiguracionInventarioQuery__
 *
 * To run a query within a React component, call `useConfiguracionInventarioQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracionInventarioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracionInventarioQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useConfiguracionInventarioQuery(
    baseOptions: Apollo.QueryHookOptions<ConfiguracionInventarioQuery, ConfiguracionInventarioQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<ConfiguracionInventarioQuery, ConfiguracionInventarioQueryVariables>(
        ConfiguracionInventarioDocument,
        options
    )
}
export function useConfiguracionInventarioLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ConfiguracionInventarioQuery, ConfiguracionInventarioQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<ConfiguracionInventarioQuery, ConfiguracionInventarioQueryVariables>(
        ConfiguracionInventarioDocument,
        options
    )
}
export type ConfiguracionInventarioQueryHookResult = ReturnType<typeof useConfiguracionInventarioQuery>
export type ConfiguracionInventarioLazyQueryHookResult = ReturnType<typeof useConfiguracionInventarioLazyQuery>
export type ConfiguracionInventarioQueryResult = Apollo.QueryResult<
    ConfiguracionInventarioQuery,
    ConfiguracionInventarioQueryVariables
>
export const AlmacenesDocument = gql`
    query Almacenes($hotel_id: ID, $eliminado: Boolean, $tipos_articulos: [TipoArticulo!]!) {
        almacenes(almacen_id: [], hotel_id: $hotel_id, eliminado: $eliminado) {
            almacen_id
            nombre
            descripcion
            stock(tipo_articulo: $tipos_articulos)
            tipo_almacen
            categorias_almacenes {
                categoria_id
                nombre
                total_articulos
            }
            general
        }
    }
`
export type AlmacenesComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<AlmacenesQuery, AlmacenesQueryVariables>,
    "query"
> &
    ({ variables: AlmacenesQueryVariables; skip?: boolean } | { skip: boolean })

export const AlmacenesComponent = (props: AlmacenesComponentProps) => (
    <ApolloReactComponents.Query<AlmacenesQuery, AlmacenesQueryVariables> query={AlmacenesDocument} {...props} />
)

/**
 * __useAlmacenesQuery__
 *
 * To run a query within a React component, call `useAlmacenesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlmacenesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlmacenesQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      eliminado: // value for 'eliminado'
 *      tipos_articulos: // value for 'tipos_articulos'
 *   },
 * });
 */
export function useAlmacenesQuery(baseOptions: Apollo.QueryHookOptions<AlmacenesQuery, AlmacenesQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<AlmacenesQuery, AlmacenesQueryVariables>(AlmacenesDocument, options)
}
export function useAlmacenesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<AlmacenesQuery, AlmacenesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<AlmacenesQuery, AlmacenesQueryVariables>(AlmacenesDocument, options)
}
export type AlmacenesQueryHookResult = ReturnType<typeof useAlmacenesQuery>
export type AlmacenesLazyQueryHookResult = ReturnType<typeof useAlmacenesLazyQuery>
export type AlmacenesQueryResult = Apollo.QueryResult<AlmacenesQuery, AlmacenesQueryVariables>
export const Almacenes_ArticulosDocument = gql`
    query Almacenes_articulos($pagination_options: PageOptionsArgs!) {
        almacenes_articulos(almacen_id: [], articulo_id: [], pagination_options: $pagination_options) {
            paginacion {
                pagina_actual
                total_paginas
                total_registros
            }
            almacenes_articulos {
                almacen_articulo_id
                almacen_id
                articulo_id
                cantidad
                costo
                fecha_movimiento
                hotel_id
                precio
                estado
            }
        }
    }
`
export type Almacenes_ArticulosComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<Almacenes_ArticulosQuery, Almacenes_ArticulosQueryVariables>,
    "query"
> &
    ({ variables: Almacenes_ArticulosQueryVariables; skip?: boolean } | { skip: boolean })

export const Almacenes_ArticulosComponent = (props: Almacenes_ArticulosComponentProps) => (
    <ApolloReactComponents.Query<Almacenes_ArticulosQuery, Almacenes_ArticulosQueryVariables>
        query={Almacenes_ArticulosDocument}
        {...props}
    />
)

/**
 * __useAlmacenes_ArticulosQuery__
 *
 * To run a query within a React component, call `useAlmacenes_ArticulosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlmacenes_ArticulosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlmacenes_ArticulosQuery({
 *   variables: {
 *      pagination_options: // value for 'pagination_options'
 *   },
 * });
 */
export function useAlmacenes_ArticulosQuery(
    baseOptions: Apollo.QueryHookOptions<Almacenes_ArticulosQuery, Almacenes_ArticulosQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<Almacenes_ArticulosQuery, Almacenes_ArticulosQueryVariables>(
        Almacenes_ArticulosDocument,
        options
    )
}
export function useAlmacenes_ArticulosLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<Almacenes_ArticulosQuery, Almacenes_ArticulosQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<Almacenes_ArticulosQuery, Almacenes_ArticulosQueryVariables>(
        Almacenes_ArticulosDocument,
        options
    )
}
export type Almacenes_ArticulosQueryHookResult = ReturnType<typeof useAlmacenes_ArticulosQuery>
export type Almacenes_ArticulosLazyQueryHookResult = ReturnType<typeof useAlmacenes_ArticulosLazyQuery>
export type Almacenes_ArticulosQueryResult = Apollo.QueryResult<
    Almacenes_ArticulosQuery,
    Almacenes_ArticulosQueryVariables
>
export const GetAlmacenArticuloMedidasDocument = gql`
    query getAlmacenArticuloMedidas($almacen_articulo_id: ID!) {
        almacen_articulo(almacen_articulo_id: $almacen_articulo_id) {
            articulo {
                unidades_disponibles
            }
        }
    }
`
export type GetAlmacenArticuloMedidasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetAlmacenArticuloMedidasQuery,
        GetAlmacenArticuloMedidasQueryVariables
    >,
    "query"
> &
    ({ variables: GetAlmacenArticuloMedidasQueryVariables; skip?: boolean } | { skip: boolean })

export const GetAlmacenArticuloMedidasComponent = (props: GetAlmacenArticuloMedidasComponentProps) => (
    <ApolloReactComponents.Query<GetAlmacenArticuloMedidasQuery, GetAlmacenArticuloMedidasQueryVariables>
        query={GetAlmacenArticuloMedidasDocument}
        {...props}
    />
)

/**
 * __useGetAlmacenArticuloMedidasQuery__
 *
 * To run a query within a React component, call `useGetAlmacenArticuloMedidasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlmacenArticuloMedidasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlmacenArticuloMedidasQuery({
 *   variables: {
 *      almacen_articulo_id: // value for 'almacen_articulo_id'
 *   },
 * });
 */
export function useGetAlmacenArticuloMedidasQuery(
    baseOptions: Apollo.QueryHookOptions<GetAlmacenArticuloMedidasQuery, GetAlmacenArticuloMedidasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetAlmacenArticuloMedidasQuery, GetAlmacenArticuloMedidasQueryVariables>(
        GetAlmacenArticuloMedidasDocument,
        options
    )
}
export function useGetAlmacenArticuloMedidasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetAlmacenArticuloMedidasQuery, GetAlmacenArticuloMedidasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetAlmacenArticuloMedidasQuery, GetAlmacenArticuloMedidasQueryVariables>(
        GetAlmacenArticuloMedidasDocument,
        options
    )
}
export type GetAlmacenArticuloMedidasQueryHookResult = ReturnType<typeof useGetAlmacenArticuloMedidasQuery>
export type GetAlmacenArticuloMedidasLazyQueryHookResult = ReturnType<typeof useGetAlmacenArticuloMedidasLazyQuery>
export type GetAlmacenArticuloMedidasQueryResult = Apollo.QueryResult<
    GetAlmacenArticuloMedidasQuery,
    GetAlmacenArticuloMedidasQueryVariables
>
export const CrearArticuloDocument = gql`
    mutation CrearArticulo($createArticuloInput: CreateArticuloInput!) {
        crear_articulo(createArticuloInput: $createArticuloInput) {
            articulo_id
        }
    }
`
export type CrearArticuloMutationFn = Apollo.MutationFunction<CrearArticuloMutation, CrearArticuloMutationVariables>
export type CrearArticuloComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CrearArticuloMutation, CrearArticuloMutationVariables>,
    "mutation"
>

export const CrearArticuloComponent = (props: CrearArticuloComponentProps) => (
    <ApolloReactComponents.Mutation<CrearArticuloMutation, CrearArticuloMutationVariables>
        mutation={CrearArticuloDocument}
        {...props}
    />
)

/**
 * __useCrearArticuloMutation__
 *
 * To run a mutation, you first call `useCrearArticuloMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrearArticuloMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crearArticuloMutation, { data, loading, error }] = useCrearArticuloMutation({
 *   variables: {
 *      createArticuloInput: // value for 'createArticuloInput'
 *   },
 * });
 */
export function useCrearArticuloMutation(
    baseOptions?: Apollo.MutationHookOptions<CrearArticuloMutation, CrearArticuloMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CrearArticuloMutation, CrearArticuloMutationVariables>(CrearArticuloDocument, options)
}
export type CrearArticuloMutationHookResult = ReturnType<typeof useCrearArticuloMutation>
export type CrearArticuloMutationResult = Apollo.MutationResult<CrearArticuloMutation>
export type CrearArticuloMutationOptions = Apollo.BaseMutationOptions<
    CrearArticuloMutation,
    CrearArticuloMutationVariables
>
export const GetAlmacenArticuloByArrayIdDocument = gql`
    query GetAlmacenArticuloByArrayId($articulo_id: [ID!], $pagination_options: PageOptionsArgs!) {
        almacenes_articulos(articulo_id: $articulo_id, pagination_options: $pagination_options) {
            paginacion {
                pagina_actual
                total_paginas
                total_registros
            }
            almacenes_articulos {
                almacen_articulo_id
                almacen_id
                articulo_id
                costo
                precio
                articulo {
                    articulo_id
                    categoria_id
                    foto
                    marca
                    nombre
                    unidad
                    contenido
                    cantidad_minima
                    stock
                    estado
                    tipo
                    extra
                    sku
                }
            }
        }
    }
`
export type GetAlmacenArticuloByArrayIdComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetAlmacenArticuloByArrayIdQuery,
        GetAlmacenArticuloByArrayIdQueryVariables
    >,
    "query"
> &
    ({ variables: GetAlmacenArticuloByArrayIdQueryVariables; skip?: boolean } | { skip: boolean })

export const GetAlmacenArticuloByArrayIdComponent = (props: GetAlmacenArticuloByArrayIdComponentProps) => (
    <ApolloReactComponents.Query<GetAlmacenArticuloByArrayIdQuery, GetAlmacenArticuloByArrayIdQueryVariables>
        query={GetAlmacenArticuloByArrayIdDocument}
        {...props}
    />
)

/**
 * __useGetAlmacenArticuloByArrayIdQuery__
 *
 * To run a query within a React component, call `useGetAlmacenArticuloByArrayIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlmacenArticuloByArrayIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlmacenArticuloByArrayIdQuery({
 *   variables: {
 *      articulo_id: // value for 'articulo_id'
 *      pagination_options: // value for 'pagination_options'
 *   },
 * });
 */
export function useGetAlmacenArticuloByArrayIdQuery(
    baseOptions: Apollo.QueryHookOptions<GetAlmacenArticuloByArrayIdQuery, GetAlmacenArticuloByArrayIdQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetAlmacenArticuloByArrayIdQuery, GetAlmacenArticuloByArrayIdQueryVariables>(
        GetAlmacenArticuloByArrayIdDocument,
        options
    )
}
export function useGetAlmacenArticuloByArrayIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAlmacenArticuloByArrayIdQuery,
        GetAlmacenArticuloByArrayIdQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetAlmacenArticuloByArrayIdQuery, GetAlmacenArticuloByArrayIdQueryVariables>(
        GetAlmacenArticuloByArrayIdDocument,
        options
    )
}
export type GetAlmacenArticuloByArrayIdQueryHookResult = ReturnType<typeof useGetAlmacenArticuloByArrayIdQuery>
export type GetAlmacenArticuloByArrayIdLazyQueryHookResult = ReturnType<typeof useGetAlmacenArticuloByArrayIdLazyQuery>
export type GetAlmacenArticuloByArrayIdQueryResult = Apollo.QueryResult<
    GetAlmacenArticuloByArrayIdQuery,
    GetAlmacenArticuloByArrayIdQueryVariables
>
export const GetAlmacenArticuloForEditDocument = gql`
    query GetAlmacenArticuloForEdit($almacen_articulo_id: ID!) {
        almacen_articulo(almacen_articulo_id: $almacen_articulo_id) {
            almacen_articulo_id
            almacen_id
            articulo_id
            costo
            precio
            articulo {
                articulo_id
                categoria_id
                foto
                marca
                nombre
                unidad
                contenido
                cantidad_minima
                stock
                estado
                tipo
                extra
                sku
            }
        }
    }
`
export type GetAlmacenArticuloForEditComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetAlmacenArticuloForEditQuery,
        GetAlmacenArticuloForEditQueryVariables
    >,
    "query"
> &
    ({ variables: GetAlmacenArticuloForEditQueryVariables; skip?: boolean } | { skip: boolean })

export const GetAlmacenArticuloForEditComponent = (props: GetAlmacenArticuloForEditComponentProps) => (
    <ApolloReactComponents.Query<GetAlmacenArticuloForEditQuery, GetAlmacenArticuloForEditQueryVariables>
        query={GetAlmacenArticuloForEditDocument}
        {...props}
    />
)

/**
 * __useGetAlmacenArticuloForEditQuery__
 *
 * To run a query within a React component, call `useGetAlmacenArticuloForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlmacenArticuloForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlmacenArticuloForEditQuery({
 *   variables: {
 *      almacen_articulo_id: // value for 'almacen_articulo_id'
 *   },
 * });
 */
export function useGetAlmacenArticuloForEditQuery(
    baseOptions: Apollo.QueryHookOptions<GetAlmacenArticuloForEditQuery, GetAlmacenArticuloForEditQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetAlmacenArticuloForEditQuery, GetAlmacenArticuloForEditQueryVariables>(
        GetAlmacenArticuloForEditDocument,
        options
    )
}
export function useGetAlmacenArticuloForEditLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetAlmacenArticuloForEditQuery, GetAlmacenArticuloForEditQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetAlmacenArticuloForEditQuery, GetAlmacenArticuloForEditQueryVariables>(
        GetAlmacenArticuloForEditDocument,
        options
    )
}
export type GetAlmacenArticuloForEditQueryHookResult = ReturnType<typeof useGetAlmacenArticuloForEditQuery>
export type GetAlmacenArticuloForEditLazyQueryHookResult = ReturnType<typeof useGetAlmacenArticuloForEditLazyQuery>
export type GetAlmacenArticuloForEditQueryResult = Apollo.QueryResult<
    GetAlmacenArticuloForEditQuery,
    GetAlmacenArticuloForEditQueryVariables
>
export const ActualizarArticuloDocument = gql`
    mutation ActualizarArticulo($updateArticuloInput: UpdateArticuloInput!) {
        actualizar_articulo(updateArticuloInput: $updateArticuloInput) {
            articulo_id
        }
    }
`
export type ActualizarArticuloMutationFn = Apollo.MutationFunction<
    ActualizarArticuloMutation,
    ActualizarArticuloMutationVariables
>
export type ActualizarArticuloComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<ActualizarArticuloMutation, ActualizarArticuloMutationVariables>,
    "mutation"
>

export const ActualizarArticuloComponent = (props: ActualizarArticuloComponentProps) => (
    <ApolloReactComponents.Mutation<ActualizarArticuloMutation, ActualizarArticuloMutationVariables>
        mutation={ActualizarArticuloDocument}
        {...props}
    />
)

/**
 * __useActualizarArticuloMutation__
 *
 * To run a mutation, you first call `useActualizarArticuloMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizarArticuloMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizarArticuloMutation, { data, loading, error }] = useActualizarArticuloMutation({
 *   variables: {
 *      updateArticuloInput: // value for 'updateArticuloInput'
 *   },
 * });
 */
export function useActualizarArticuloMutation(
    baseOptions?: Apollo.MutationHookOptions<ActualizarArticuloMutation, ActualizarArticuloMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ActualizarArticuloMutation, ActualizarArticuloMutationVariables>(
        ActualizarArticuloDocument,
        options
    )
}
export type ActualizarArticuloMutationHookResult = ReturnType<typeof useActualizarArticuloMutation>
export type ActualizarArticuloMutationResult = Apollo.MutationResult<ActualizarArticuloMutation>
export type ActualizarArticuloMutationOptions = Apollo.BaseMutationOptions<
    ActualizarArticuloMutation,
    ActualizarArticuloMutationVariables
>
export const GetAlmacenesForDropDocument = gql`
    query GetAlmacenesForDrop($hotel_id: ID) {
        almacenes(hotel_id: $hotel_id, eliminado: false, estado: activado) {
            almacen_id
            nombre
            tipo_almacen
            categorias_almacenes {
                categoria_id
                nombre
            }
        }
    }
`
export type GetAlmacenesForDropComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetAlmacenesForDropQuery, GetAlmacenesForDropQueryVariables>,
    "query"
>

export const GetAlmacenesForDropComponent = (props: GetAlmacenesForDropComponentProps) => (
    <ApolloReactComponents.Query<GetAlmacenesForDropQuery, GetAlmacenesForDropQueryVariables>
        query={GetAlmacenesForDropDocument}
        {...props}
    />
)

/**
 * __useGetAlmacenesForDropQuery__
 *
 * To run a query within a React component, call `useGetAlmacenesForDropQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlmacenesForDropQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlmacenesForDropQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetAlmacenesForDropQuery(
    baseOptions?: Apollo.QueryHookOptions<GetAlmacenesForDropQuery, GetAlmacenesForDropQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetAlmacenesForDropQuery, GetAlmacenesForDropQueryVariables>(
        GetAlmacenesForDropDocument,
        options
    )
}
export function useGetAlmacenesForDropLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetAlmacenesForDropQuery, GetAlmacenesForDropQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetAlmacenesForDropQuery, GetAlmacenesForDropQueryVariables>(
        GetAlmacenesForDropDocument,
        options
    )
}
export type GetAlmacenesForDropQueryHookResult = ReturnType<typeof useGetAlmacenesForDropQuery>
export type GetAlmacenesForDropLazyQueryHookResult = ReturnType<typeof useGetAlmacenesForDropLazyQuery>
export type GetAlmacenesForDropQueryResult = Apollo.QueryResult<
    GetAlmacenesForDropQuery,
    GetAlmacenesForDropQueryVariables
>
export const CrearRecetaProcesoDocument = gql`
    mutation CrearRecetaProceso($createRecetaInput: CreateRecetaInput!) {
        crear_receta(createRecetaInput: $createRecetaInput) {
            articulo_id
        }
    }
`
export type CrearRecetaProcesoMutationFn = Apollo.MutationFunction<
    CrearRecetaProcesoMutation,
    CrearRecetaProcesoMutationVariables
>
export type CrearRecetaProcesoComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CrearRecetaProcesoMutation, CrearRecetaProcesoMutationVariables>,
    "mutation"
>

export const CrearRecetaProcesoComponent = (props: CrearRecetaProcesoComponentProps) => (
    <ApolloReactComponents.Mutation<CrearRecetaProcesoMutation, CrearRecetaProcesoMutationVariables>
        mutation={CrearRecetaProcesoDocument}
        {...props}
    />
)

/**
 * __useCrearRecetaProcesoMutation__
 *
 * To run a mutation, you first call `useCrearRecetaProcesoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrearRecetaProcesoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crearRecetaProcesoMutation, { data, loading, error }] = useCrearRecetaProcesoMutation({
 *   variables: {
 *      createRecetaInput: // value for 'createRecetaInput'
 *   },
 * });
 */
export function useCrearRecetaProcesoMutation(
    baseOptions?: Apollo.MutationHookOptions<CrearRecetaProcesoMutation, CrearRecetaProcesoMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CrearRecetaProcesoMutation, CrearRecetaProcesoMutationVariables>(
        CrearRecetaProcesoDocument,
        options
    )
}
export type CrearRecetaProcesoMutationHookResult = ReturnType<typeof useCrearRecetaProcesoMutation>
export type CrearRecetaProcesoMutationResult = Apollo.MutationResult<CrearRecetaProcesoMutation>
export type CrearRecetaProcesoMutationOptions = Apollo.BaseMutationOptions<
    CrearRecetaProcesoMutation,
    CrearRecetaProcesoMutationVariables
>
export const CategoriasArticulosNuevaRecetaProcesoDocument = gql`
    query categoriasArticulosNuevaRecetaProceso($hotel_id: ID!) {
        categorias_articulos(hotel_id: $hotel_id, eliminado: false) {
            categoria_id
            nombre
        }
    }
`
export type CategoriasArticulosNuevaRecetaProcesoComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        CategoriasArticulosNuevaRecetaProcesoQuery,
        CategoriasArticulosNuevaRecetaProcesoQueryVariables
    >,
    "query"
> &
    ({ variables: CategoriasArticulosNuevaRecetaProcesoQueryVariables; skip?: boolean } | { skip: boolean })

export const CategoriasArticulosNuevaRecetaProcesoComponent = (
    props: CategoriasArticulosNuevaRecetaProcesoComponentProps
) => (
    <ApolloReactComponents.Query<
        CategoriasArticulosNuevaRecetaProcesoQuery,
        CategoriasArticulosNuevaRecetaProcesoQueryVariables
    >
        query={CategoriasArticulosNuevaRecetaProcesoDocument}
        {...props}
    />
)

/**
 * __useCategoriasArticulosNuevaRecetaProcesoQuery__
 *
 * To run a query within a React component, call `useCategoriasArticulosNuevaRecetaProcesoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriasArticulosNuevaRecetaProcesoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriasArticulosNuevaRecetaProcesoQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useCategoriasArticulosNuevaRecetaProcesoQuery(
    baseOptions: Apollo.QueryHookOptions<
        CategoriasArticulosNuevaRecetaProcesoQuery,
        CategoriasArticulosNuevaRecetaProcesoQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        CategoriasArticulosNuevaRecetaProcesoQuery,
        CategoriasArticulosNuevaRecetaProcesoQueryVariables
    >(CategoriasArticulosNuevaRecetaProcesoDocument, options)
}
export function useCategoriasArticulosNuevaRecetaProcesoLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        CategoriasArticulosNuevaRecetaProcesoQuery,
        CategoriasArticulosNuevaRecetaProcesoQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        CategoriasArticulosNuevaRecetaProcesoQuery,
        CategoriasArticulosNuevaRecetaProcesoQueryVariables
    >(CategoriasArticulosNuevaRecetaProcesoDocument, options)
}
export type CategoriasArticulosNuevaRecetaProcesoQueryHookResult = ReturnType<
    typeof useCategoriasArticulosNuevaRecetaProcesoQuery
>
export type CategoriasArticulosNuevaRecetaProcesoLazyQueryHookResult = ReturnType<
    typeof useCategoriasArticulosNuevaRecetaProcesoLazyQuery
>
export type CategoriasArticulosNuevaRecetaProcesoQueryResult = Apollo.QueryResult<
    CategoriasArticulosNuevaRecetaProcesoQuery,
    CategoriasArticulosNuevaRecetaProcesoQueryVariables
>
export const ArticulosNuevaRecetaProcesoDocument = gql`
    query articulosNuevaRecetaProceso($hotel_id: ID, $pagination_options: PageOptionsArgs!, $nameFilter: String!) {
        almacenes_articulos(
            hotel_id: $hotel_id
            eliminado: false
            nombre_articulo_filters: { like: $nameFilter }
            filter_estado_articulo: activado
            filter_tipo_articulo: [venta, receta, insumo, proceso]
            filter_duplicados: true
            filter_producciones: true
            pagination_options: $pagination_options
        ) {
            paginacion {
                pagina_actual
                total_paginas
            }
            almacenes_articulos {
                almacen_articulo_id
                articulo_id
                almacen_id
                cantidad
                costo
                almacen {
                    nombre
                }
                articulo {
                    nombre
                    tipo
                    foto
                    contenido
                    unidad
                    unidades_disponibles
                }
            }
        }
    }
`
export type ArticulosNuevaRecetaProcesoComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        ArticulosNuevaRecetaProcesoQuery,
        ArticulosNuevaRecetaProcesoQueryVariables
    >,
    "query"
> &
    ({ variables: ArticulosNuevaRecetaProcesoQueryVariables; skip?: boolean } | { skip: boolean })

export const ArticulosNuevaRecetaProcesoComponent = (props: ArticulosNuevaRecetaProcesoComponentProps) => (
    <ApolloReactComponents.Query<ArticulosNuevaRecetaProcesoQuery, ArticulosNuevaRecetaProcesoQueryVariables>
        query={ArticulosNuevaRecetaProcesoDocument}
        {...props}
    />
)

/**
 * __useArticulosNuevaRecetaProcesoQuery__
 *
 * To run a query within a React component, call `useArticulosNuevaRecetaProcesoQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticulosNuevaRecetaProcesoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticulosNuevaRecetaProcesoQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      pagination_options: // value for 'pagination_options'
 *      nameFilter: // value for 'nameFilter'
 *   },
 * });
 */
export function useArticulosNuevaRecetaProcesoQuery(
    baseOptions: Apollo.QueryHookOptions<ArticulosNuevaRecetaProcesoQuery, ArticulosNuevaRecetaProcesoQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<ArticulosNuevaRecetaProcesoQuery, ArticulosNuevaRecetaProcesoQueryVariables>(
        ArticulosNuevaRecetaProcesoDocument,
        options
    )
}
export function useArticulosNuevaRecetaProcesoLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ArticulosNuevaRecetaProcesoQuery,
        ArticulosNuevaRecetaProcesoQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<ArticulosNuevaRecetaProcesoQuery, ArticulosNuevaRecetaProcesoQueryVariables>(
        ArticulosNuevaRecetaProcesoDocument,
        options
    )
}
export type ArticulosNuevaRecetaProcesoQueryHookResult = ReturnType<typeof useArticulosNuevaRecetaProcesoQuery>
export type ArticulosNuevaRecetaProcesoLazyQueryHookResult = ReturnType<typeof useArticulosNuevaRecetaProcesoLazyQuery>
export type ArticulosNuevaRecetaProcesoQueryResult = Apollo.QueryResult<
    ArticulosNuevaRecetaProcesoQuery,
    ArticulosNuevaRecetaProcesoQueryVariables
>
export const ActualizarRecetaProcesoDocument = gql`
    mutation ActualizarRecetaProceso($updateRecetaInput: UpdateRecetaInput!) {
        actualizar_receta(updateRecetaInput: $updateRecetaInput) {
            articulo_id
        }
    }
`
export type ActualizarRecetaProcesoMutationFn = Apollo.MutationFunction<
    ActualizarRecetaProcesoMutation,
    ActualizarRecetaProcesoMutationVariables
>
export type ActualizarRecetaProcesoComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        ActualizarRecetaProcesoMutation,
        ActualizarRecetaProcesoMutationVariables
    >,
    "mutation"
>

export const ActualizarRecetaProcesoComponent = (props: ActualizarRecetaProcesoComponentProps) => (
    <ApolloReactComponents.Mutation<ActualizarRecetaProcesoMutation, ActualizarRecetaProcesoMutationVariables>
        mutation={ActualizarRecetaProcesoDocument}
        {...props}
    />
)

/**
 * __useActualizarRecetaProcesoMutation__
 *
 * To run a mutation, you first call `useActualizarRecetaProcesoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizarRecetaProcesoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizarRecetaProcesoMutation, { data, loading, error }] = useActualizarRecetaProcesoMutation({
 *   variables: {
 *      updateRecetaInput: // value for 'updateRecetaInput'
 *   },
 * });
 */
export function useActualizarRecetaProcesoMutation(
    baseOptions?: Apollo.MutationHookOptions<ActualizarRecetaProcesoMutation, ActualizarRecetaProcesoMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ActualizarRecetaProcesoMutation, ActualizarRecetaProcesoMutationVariables>(
        ActualizarRecetaProcesoDocument,
        options
    )
}
export type ActualizarRecetaProcesoMutationHookResult = ReturnType<typeof useActualizarRecetaProcesoMutation>
export type ActualizarRecetaProcesoMutationResult = Apollo.MutationResult<ActualizarRecetaProcesoMutation>
export type ActualizarRecetaProcesoMutationOptions = Apollo.BaseMutationOptions<
    ActualizarRecetaProcesoMutation,
    ActualizarRecetaProcesoMutationVariables
>
export const GetRecetaForDetailDocument = gql`
    query GetRecetaForDetail($articulo_id: ID!, $hotel_id: ID!) {
        receta(articulo_id: $articulo_id) {
            articulo_id
            almacen_articulo(hotel_id: $hotel_id) {
                costo
                precio
            }
            articulo {
                nombre
                extra
                estado
                foto
                unidad
                contenido
            }
            ingredientes_recetas {
                almacen_articulo_id
                cantidad
                ingrediente_receta_id
                receta_id
                unidad
                disponible_inventario
                costo_por_cantidad_ingrediente
                cantidad_equivalente
                articulo {
                    nombre
                    unidad
                    contenido
                }
                almacen_articulo {
                    almacen_articulo_id
                    costo
                    cantidad
                    estado
                }
            }
        }
    }
`
export type GetRecetaForDetailComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetRecetaForDetailQuery, GetRecetaForDetailQueryVariables>,
    "query"
> &
    ({ variables: GetRecetaForDetailQueryVariables; skip?: boolean } | { skip: boolean })

export const GetRecetaForDetailComponent = (props: GetRecetaForDetailComponentProps) => (
    <ApolloReactComponents.Query<GetRecetaForDetailQuery, GetRecetaForDetailQueryVariables>
        query={GetRecetaForDetailDocument}
        {...props}
    />
)

/**
 * __useGetRecetaForDetailQuery__
 *
 * To run a query within a React component, call `useGetRecetaForDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecetaForDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecetaForDetailQuery({
 *   variables: {
 *      articulo_id: // value for 'articulo_id'
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetRecetaForDetailQuery(
    baseOptions: Apollo.QueryHookOptions<GetRecetaForDetailQuery, GetRecetaForDetailQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetRecetaForDetailQuery, GetRecetaForDetailQueryVariables>(
        GetRecetaForDetailDocument,
        options
    )
}
export function useGetRecetaForDetailLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetRecetaForDetailQuery, GetRecetaForDetailQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetRecetaForDetailQuery, GetRecetaForDetailQueryVariables>(
        GetRecetaForDetailDocument,
        options
    )
}
export type GetRecetaForDetailQueryHookResult = ReturnType<typeof useGetRecetaForDetailQuery>
export type GetRecetaForDetailLazyQueryHookResult = ReturnType<typeof useGetRecetaForDetailLazyQuery>
export type GetRecetaForDetailQueryResult = Apollo.QueryResult<
    GetRecetaForDetailQuery,
    GetRecetaForDetailQueryVariables
>
export const GetRecetaToEditDocument = gql`
    query getRecetaToEdit($articulo_id: ID!, $hotel_id: ID!) {
        receta(articulo_id: $articulo_id) {
            articulo_id
            almacen_articulo(hotel_id: $hotel_id) {
                categoria_id
                precio
                categoria_articulo {
                    nombre
                }
            }
            articulo {
                nombre
                extra
                estado
                foto
                unidad
                contenido
                categoria_id
                categoria_articulo {
                    nombre
                }
            }
            ingredientes_recetas {
                almacen_articulo_id
                cantidad
                unidad
                ingrediente_receta_id
                receta_id
                almacen_articulo {
                    costo
                }
                articulo {
                    unidad
                    nombre
                }
            }
        }
    }
`
export type GetRecetaToEditComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetRecetaToEditQuery, GetRecetaToEditQueryVariables>,
    "query"
> &
    ({ variables: GetRecetaToEditQueryVariables; skip?: boolean } | { skip: boolean })

export const GetRecetaToEditComponent = (props: GetRecetaToEditComponentProps) => (
    <ApolloReactComponents.Query<GetRecetaToEditQuery, GetRecetaToEditQueryVariables>
        query={GetRecetaToEditDocument}
        {...props}
    />
)

/**
 * __useGetRecetaToEditQuery__
 *
 * To run a query within a React component, call `useGetRecetaToEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecetaToEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecetaToEditQuery({
 *   variables: {
 *      articulo_id: // value for 'articulo_id'
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetRecetaToEditQuery(
    baseOptions: Apollo.QueryHookOptions<GetRecetaToEditQuery, GetRecetaToEditQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetRecetaToEditQuery, GetRecetaToEditQueryVariables>(GetRecetaToEditDocument, options)
}
export function useGetRecetaToEditLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetRecetaToEditQuery, GetRecetaToEditQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetRecetaToEditQuery, GetRecetaToEditQueryVariables>(GetRecetaToEditDocument, options)
}
export type GetRecetaToEditQueryHookResult = ReturnType<typeof useGetRecetaToEditQuery>
export type GetRecetaToEditLazyQueryHookResult = ReturnType<typeof useGetRecetaToEditLazyQuery>
export type GetRecetaToEditQueryResult = Apollo.QueryResult<GetRecetaToEditQuery, GetRecetaToEditQueryVariables>
export const GetRecetasProcesosDocument = gql`
    query GetRecetasProcesos(
        $filter_tipo_articulo: [TipoArticulo!]!
        $pagination_options: PageOptionsArgs!
        $filterEstadoArticulo: EstadosArticulo
        $categoria_articulo_ids: [ID!]
        $hotel_id: ID!
        $nombreArticuloFilterOrder: TipoOrdenamiento
    ) {
        almacenes_articulos(
            hotel_id: $hotel_id
            categoria_articulo_filters: { in: $categoria_articulo_ids }
            filter_tipo_articulo: $filter_tipo_articulo
            eliminado: false
            filter_articulo_eliminado: true
            filter_estado_articulo: $filterEstadoArticulo
            pagination_options: $pagination_options
            nombre_articulo_filters: { order: $nombreArticuloFilterOrder }
            filter_duplicados: true
        ) {
            paginacion {
                pagina_actual
                total_paginas
                total_registros
            }
            almacenes_articulos {
                almacen_id
                almacen_articulo_id
                articulo_id
                estado
                ultima_preparacion
                cantidad
                precio
                costo
                articulo {
                    nombre
                    foto
                    categoria_id
                    contenido
                    stock
                    categoria_articulo {
                        nombre
                    }
                    folio
                    tipo
                    unidad
                    estado
                    extra
                }
            }
        }
    }
`
export type GetRecetasProcesosComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetRecetasProcesosQuery, GetRecetasProcesosQueryVariables>,
    "query"
> &
    ({ variables: GetRecetasProcesosQueryVariables; skip?: boolean } | { skip: boolean })

export const GetRecetasProcesosComponent = (props: GetRecetasProcesosComponentProps) => (
    <ApolloReactComponents.Query<GetRecetasProcesosQuery, GetRecetasProcesosQueryVariables>
        query={GetRecetasProcesosDocument}
        {...props}
    />
)

/**
 * __useGetRecetasProcesosQuery__
 *
 * To run a query within a React component, call `useGetRecetasProcesosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecetasProcesosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecetasProcesosQuery({
 *   variables: {
 *      filter_tipo_articulo: // value for 'filter_tipo_articulo'
 *      pagination_options: // value for 'pagination_options'
 *      filterEstadoArticulo: // value for 'filterEstadoArticulo'
 *      categoria_articulo_ids: // value for 'categoria_articulo_ids'
 *      hotel_id: // value for 'hotel_id'
 *      nombreArticuloFilterOrder: // value for 'nombreArticuloFilterOrder'
 *   },
 * });
 */
export function useGetRecetasProcesosQuery(
    baseOptions: Apollo.QueryHookOptions<GetRecetasProcesosQuery, GetRecetasProcesosQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetRecetasProcesosQuery, GetRecetasProcesosQueryVariables>(
        GetRecetasProcesosDocument,
        options
    )
}
export function useGetRecetasProcesosLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetRecetasProcesosQuery, GetRecetasProcesosQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetRecetasProcesosQuery, GetRecetasProcesosQueryVariables>(
        GetRecetasProcesosDocument,
        options
    )
}
export type GetRecetasProcesosQueryHookResult = ReturnType<typeof useGetRecetasProcesosQuery>
export type GetRecetasProcesosLazyQueryHookResult = ReturnType<typeof useGetRecetasProcesosLazyQuery>
export type GetRecetasProcesosQueryResult = Apollo.QueryResult<
    GetRecetasProcesosQuery,
    GetRecetasProcesosQueryVariables
>
export const UnidadesConversionArticulosDocument = gql`
    query UnidadesConversionArticulos {
        unidades_conversion_articulos {
            unidad_origen
            unidad_destino
            factor_conversion
        }
    }
`
export type UnidadesConversionArticulosComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        UnidadesConversionArticulosQuery,
        UnidadesConversionArticulosQueryVariables
    >,
    "query"
>

export const UnidadesConversionArticulosComponent = (props: UnidadesConversionArticulosComponentProps) => (
    <ApolloReactComponents.Query<UnidadesConversionArticulosQuery, UnidadesConversionArticulosQueryVariables>
        query={UnidadesConversionArticulosDocument}
        {...props}
    />
)

/**
 * __useUnidadesConversionArticulosQuery__
 *
 * To run a query within a React component, call `useUnidadesConversionArticulosQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnidadesConversionArticulosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnidadesConversionArticulosQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnidadesConversionArticulosQuery(
    baseOptions?: Apollo.QueryHookOptions<UnidadesConversionArticulosQuery, UnidadesConversionArticulosQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<UnidadesConversionArticulosQuery, UnidadesConversionArticulosQueryVariables>(
        UnidadesConversionArticulosDocument,
        options
    )
}
export function useUnidadesConversionArticulosLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        UnidadesConversionArticulosQuery,
        UnidadesConversionArticulosQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<UnidadesConversionArticulosQuery, UnidadesConversionArticulosQueryVariables>(
        UnidadesConversionArticulosDocument,
        options
    )
}
export type UnidadesConversionArticulosQueryHookResult = ReturnType<typeof useUnidadesConversionArticulosQuery>
export type UnidadesConversionArticulosLazyQueryHookResult = ReturnType<typeof useUnidadesConversionArticulosLazyQuery>
export type UnidadesConversionArticulosQueryResult = Apollo.QueryResult<
    UnidadesConversionArticulosQuery,
    UnidadesConversionArticulosQueryVariables
>
export const AgregacionesAlmacenesArticulosDocument = gql`
    query AgregacionesAlmacenesArticulos($hotel_id: ID!) {
        agregaciones_almacenes_articulos(hotel_id: $hotel_id) {
            total_procesos
            total_recetas_alimentos
            total_recetas_bebidas
            total_recetas_procesos
        }
    }
`
export type AgregacionesAlmacenesArticulosComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        AgregacionesAlmacenesArticulosQuery,
        AgregacionesAlmacenesArticulosQueryVariables
    >,
    "query"
> &
    ({ variables: AgregacionesAlmacenesArticulosQueryVariables; skip?: boolean } | { skip: boolean })

export const AgregacionesAlmacenesArticulosComponent = (props: AgregacionesAlmacenesArticulosComponentProps) => (
    <ApolloReactComponents.Query<AgregacionesAlmacenesArticulosQuery, AgregacionesAlmacenesArticulosQueryVariables>
        query={AgregacionesAlmacenesArticulosDocument}
        {...props}
    />
)

/**
 * __useAgregacionesAlmacenesArticulosQuery__
 *
 * To run a query within a React component, call `useAgregacionesAlmacenesArticulosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgregacionesAlmacenesArticulosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgregacionesAlmacenesArticulosQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useAgregacionesAlmacenesArticulosQuery(
    baseOptions: Apollo.QueryHookOptions<
        AgregacionesAlmacenesArticulosQuery,
        AgregacionesAlmacenesArticulosQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<AgregacionesAlmacenesArticulosQuery, AgregacionesAlmacenesArticulosQueryVariables>(
        AgregacionesAlmacenesArticulosDocument,
        options
    )
}
export function useAgregacionesAlmacenesArticulosLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        AgregacionesAlmacenesArticulosQuery,
        AgregacionesAlmacenesArticulosQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<AgregacionesAlmacenesArticulosQuery, AgregacionesAlmacenesArticulosQueryVariables>(
        AgregacionesAlmacenesArticulosDocument,
        options
    )
}
export type AgregacionesAlmacenesArticulosQueryHookResult = ReturnType<typeof useAgregacionesAlmacenesArticulosQuery>
export type AgregacionesAlmacenesArticulosLazyQueryHookResult = ReturnType<
    typeof useAgregacionesAlmacenesArticulosLazyQuery
>
export type AgregacionesAlmacenesArticulosQueryResult = Apollo.QueryResult<
    AgregacionesAlmacenesArticulosQuery,
    AgregacionesAlmacenesArticulosQueryVariables
>
export const SearchRecipesProcessDocument = gql`
    query SearchRecipesProcess($hotel_id: ID!, $nameFilter: String!, $pagination_options: PageOptionsArgs!) {
        almacenes_articulos(
            hotel_id: $hotel_id
            filter_tipo_articulo: [receta, proceso]
            eliminado: false
            nombre_articulo_filters: { like: $nameFilter }
            pagination_options: $pagination_options
        ) {
            paginacion {
                pagina_actual
                total_paginas
                total_registros
            }
            almacenes_articulos {
                almacen_id
                almacen_articulo_id
                articulo_id
                ultima_preparacion
                cantidad
                precio
                costo
                articulo {
                    nombre
                    foto
                    categoria_id
                    contenido
                    stock
                    descripcion
                    categoria_articulo {
                        nombre
                    }
                    folio
                    tipo
                    unidad
                    estado
                    extra
                }
            }
        }
    }
`
export type SearchRecipesProcessComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<SearchRecipesProcessQuery, SearchRecipesProcessQueryVariables>,
    "query"
> &
    ({ variables: SearchRecipesProcessQueryVariables; skip?: boolean } | { skip: boolean })

export const SearchRecipesProcessComponent = (props: SearchRecipesProcessComponentProps) => (
    <ApolloReactComponents.Query<SearchRecipesProcessQuery, SearchRecipesProcessQueryVariables>
        query={SearchRecipesProcessDocument}
        {...props}
    />
)

/**
 * __useSearchRecipesProcessQuery__
 *
 * To run a query within a React component, call `useSearchRecipesProcessQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchRecipesProcessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchRecipesProcessQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      nameFilter: // value for 'nameFilter'
 *      pagination_options: // value for 'pagination_options'
 *   },
 * });
 */
export function useSearchRecipesProcessQuery(
    baseOptions: Apollo.QueryHookOptions<SearchRecipesProcessQuery, SearchRecipesProcessQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<SearchRecipesProcessQuery, SearchRecipesProcessQueryVariables>(
        SearchRecipesProcessDocument,
        options
    )
}
export function useSearchRecipesProcessLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<SearchRecipesProcessQuery, SearchRecipesProcessQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<SearchRecipesProcessQuery, SearchRecipesProcessQueryVariables>(
        SearchRecipesProcessDocument,
        options
    )
}
export type SearchRecipesProcessQueryHookResult = ReturnType<typeof useSearchRecipesProcessQuery>
export type SearchRecipesProcessLazyQueryHookResult = ReturnType<typeof useSearchRecipesProcessLazyQuery>
export type SearchRecipesProcessQueryResult = Apollo.QueryResult<
    SearchRecipesProcessQuery,
    SearchRecipesProcessQueryVariables
>
export const CrearProduccionProcesoDocument = gql`
    mutation CrearProduccionProceso($createProductionProceso: CreateProductionProcesoInput!) {
        crear_produccion_proceso(createProductionProceso: $createProductionProceso) {
            cantidad_produccion_final
        }
    }
`
export type CrearProduccionProcesoMutationFn = Apollo.MutationFunction<
    CrearProduccionProcesoMutation,
    CrearProduccionProcesoMutationVariables
>
export type CrearProduccionProcesoComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        CrearProduccionProcesoMutation,
        CrearProduccionProcesoMutationVariables
    >,
    "mutation"
>

export const CrearProduccionProcesoComponent = (props: CrearProduccionProcesoComponentProps) => (
    <ApolloReactComponents.Mutation<CrearProduccionProcesoMutation, CrearProduccionProcesoMutationVariables>
        mutation={CrearProduccionProcesoDocument}
        {...props}
    />
)

/**
 * __useCrearProduccionProcesoMutation__
 *
 * To run a mutation, you first call `useCrearProduccionProcesoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrearProduccionProcesoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crearProduccionProcesoMutation, { data, loading, error }] = useCrearProduccionProcesoMutation({
 *   variables: {
 *      createProductionProceso: // value for 'createProductionProceso'
 *   },
 * });
 */
export function useCrearProduccionProcesoMutation(
    baseOptions?: Apollo.MutationHookOptions<CrearProduccionProcesoMutation, CrearProduccionProcesoMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CrearProduccionProcesoMutation, CrearProduccionProcesoMutationVariables>(
        CrearProduccionProcesoDocument,
        options
    )
}
export type CrearProduccionProcesoMutationHookResult = ReturnType<typeof useCrearProduccionProcesoMutation>
export type CrearProduccionProcesoMutationResult = Apollo.MutationResult<CrearProduccionProcesoMutation>
export type CrearProduccionProcesoMutationOptions = Apollo.BaseMutationOptions<
    CrearProduccionProcesoMutation,
    CrearProduccionProcesoMutationVariables
>
export const GetArticuloForProductionDocument = gql`
    query GetArticuloForProduction($almacen_articulo_id: ID!) {
        almacen_articulo(almacen_articulo_id: $almacen_articulo_id) {
            almacen_articulo_id
            almacen_id
            articulo_id
            costo
            articulo {
                articulo_id
                nombre
                unidad
                contenido
            }
        }
    }
`
export type GetArticuloForProductionComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetArticuloForProductionQuery, GetArticuloForProductionQueryVariables>,
    "query"
> &
    ({ variables: GetArticuloForProductionQueryVariables; skip?: boolean } | { skip: boolean })

export const GetArticuloForProductionComponent = (props: GetArticuloForProductionComponentProps) => (
    <ApolloReactComponents.Query<GetArticuloForProductionQuery, GetArticuloForProductionQueryVariables>
        query={GetArticuloForProductionDocument}
        {...props}
    />
)

/**
 * __useGetArticuloForProductionQuery__
 *
 * To run a query within a React component, call `useGetArticuloForProductionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticuloForProductionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticuloForProductionQuery({
 *   variables: {
 *      almacen_articulo_id: // value for 'almacen_articulo_id'
 *   },
 * });
 */
export function useGetArticuloForProductionQuery(
    baseOptions: Apollo.QueryHookOptions<GetArticuloForProductionQuery, GetArticuloForProductionQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetArticuloForProductionQuery, GetArticuloForProductionQueryVariables>(
        GetArticuloForProductionDocument,
        options
    )
}
export function useGetArticuloForProductionLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetArticuloForProductionQuery, GetArticuloForProductionQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetArticuloForProductionQuery, GetArticuloForProductionQueryVariables>(
        GetArticuloForProductionDocument,
        options
    )
}
export type GetArticuloForProductionQueryHookResult = ReturnType<typeof useGetArticuloForProductionQuery>
export type GetArticuloForProductionLazyQueryHookResult = ReturnType<typeof useGetArticuloForProductionLazyQuery>
export type GetArticuloForProductionQueryResult = Apollo.QueryResult<
    GetArticuloForProductionQuery,
    GetArticuloForProductionQueryVariables
>
export const HistorialProduccionInventarioDocument = gql`
    query HistorialProduccionInventario($hotel_id: ID, $articulo_id: [ID!], $fecha_produccion: MonthSearchInput) {
        historial_producciones_inventarios(
            hotel_id: $hotel_id
            articulo_id: $articulo_id
            fecha_produccion: $fecha_produccion
        ) {
            historial_produccion_inventario_id
            articulo_id
            folio
            fecha_produccion
            cantidad_producida
            unidad
            costo_produccion
            costo_unidad_minima_produccion
            colaborador_id
            responsable {
                apellido_materno
                apellido_paterno
                nombre
                usuario_id
            }
        }
    }
`
export type HistorialProduccionInventarioComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        HistorialProduccionInventarioQuery,
        HistorialProduccionInventarioQueryVariables
    >,
    "query"
>

export const HistorialProduccionInventarioComponent = (props: HistorialProduccionInventarioComponentProps) => (
    <ApolloReactComponents.Query<HistorialProduccionInventarioQuery, HistorialProduccionInventarioQueryVariables>
        query={HistorialProduccionInventarioDocument}
        {...props}
    />
)

/**
 * __useHistorialProduccionInventarioQuery__
 *
 * To run a query within a React component, call `useHistorialProduccionInventarioQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistorialProduccionInventarioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistorialProduccionInventarioQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      articulo_id: // value for 'articulo_id'
 *      fecha_produccion: // value for 'fecha_produccion'
 *   },
 * });
 */
export function useHistorialProduccionInventarioQuery(
    baseOptions?: Apollo.QueryHookOptions<
        HistorialProduccionInventarioQuery,
        HistorialProduccionInventarioQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<HistorialProduccionInventarioQuery, HistorialProduccionInventarioQueryVariables>(
        HistorialProduccionInventarioDocument,
        options
    )
}
export function useHistorialProduccionInventarioLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        HistorialProduccionInventarioQuery,
        HistorialProduccionInventarioQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<HistorialProduccionInventarioQuery, HistorialProduccionInventarioQueryVariables>(
        HistorialProduccionInventarioDocument,
        options
    )
}
export type HistorialProduccionInventarioQueryHookResult = ReturnType<typeof useHistorialProduccionInventarioQuery>
export type HistorialProduccionInventarioLazyQueryHookResult = ReturnType<
    typeof useHistorialProduccionInventarioLazyQuery
>
export type HistorialProduccionInventarioQueryResult = Apollo.QueryResult<
    HistorialProduccionInventarioQuery,
    HistorialProduccionInventarioQueryVariables
>
export const KpisHistorialProduccionDocument = gql`
    query KPISHistorialProduccion($hotel_id: ID, $articulo_id: ID!) {
        kpis_historial_producciones_inventarios(hotel_id: $hotel_id, articulo_id: $articulo_id) {
            articulo_id
            costo_total_inventario
            costo_unitario_promedio
            fecha_ultima_produccion
            produccion_receta
            unidades_inventario
            unidad
        }
    }
`
export type KpisHistorialProduccionComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<KpisHistorialProduccionQuery, KpisHistorialProduccionQueryVariables>,
    "query"
> &
    ({ variables: KpisHistorialProduccionQueryVariables; skip?: boolean } | { skip: boolean })

export const KpisHistorialProduccionComponent = (props: KpisHistorialProduccionComponentProps) => (
    <ApolloReactComponents.Query<KpisHistorialProduccionQuery, KpisHistorialProduccionQueryVariables>
        query={KpisHistorialProduccionDocument}
        {...props}
    />
)

/**
 * __useKpisHistorialProduccionQuery__
 *
 * To run a query within a React component, call `useKpisHistorialProduccionQuery` and pass it any options that fit your needs.
 * When your component renders, `useKpisHistorialProduccionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpisHistorialProduccionQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      articulo_id: // value for 'articulo_id'
 *   },
 * });
 */
export function useKpisHistorialProduccionQuery(
    baseOptions: Apollo.QueryHookOptions<KpisHistorialProduccionQuery, KpisHistorialProduccionQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<KpisHistorialProduccionQuery, KpisHistorialProduccionQueryVariables>(
        KpisHistorialProduccionDocument,
        options
    )
}
export function useKpisHistorialProduccionLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<KpisHistorialProduccionQuery, KpisHistorialProduccionQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<KpisHistorialProduccionQuery, KpisHistorialProduccionQueryVariables>(
        KpisHistorialProduccionDocument,
        options
    )
}
export type KpisHistorialProduccionQueryHookResult = ReturnType<typeof useKpisHistorialProduccionQuery>
export type KpisHistorialProduccionLazyQueryHookResult = ReturnType<typeof useKpisHistorialProduccionLazyQuery>
export type KpisHistorialProduccionQueryResult = Apollo.QueryResult<
    KpisHistorialProduccionQuery,
    KpisHistorialProduccionQueryVariables
>
export const GetSurtidosByAlmacenArtIdDocument = gql`
    query GetSurtidosByAlmacenArtId($almacen_articulo_id: ID, $fecha_ingreso: DateSearchInput) {
        surtidos(almacen_articulo_id: $almacen_articulo_id, fecha_ingreso: $fecha_ingreso) {
            surtido_id
            almacen_articulo_id
            cantidad
            colaborador_id
            costo_total
            costo_unitario
            fecha_ingreso
            folio
            numero_orden_factura
            tipo
            colaborador {
                nombre
                apellido_paterno
                apellido_materno
            }
        }
    }
`
export type GetSurtidosByAlmacenArtIdComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetSurtidosByAlmacenArtIdQuery,
        GetSurtidosByAlmacenArtIdQueryVariables
    >,
    "query"
>

export const GetSurtidosByAlmacenArtIdComponent = (props: GetSurtidosByAlmacenArtIdComponentProps) => (
    <ApolloReactComponents.Query<GetSurtidosByAlmacenArtIdQuery, GetSurtidosByAlmacenArtIdQueryVariables>
        query={GetSurtidosByAlmacenArtIdDocument}
        {...props}
    />
)

/**
 * __useGetSurtidosByAlmacenArtIdQuery__
 *
 * To run a query within a React component, call `useGetSurtidosByAlmacenArtIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurtidosByAlmacenArtIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurtidosByAlmacenArtIdQuery({
 *   variables: {
 *      almacen_articulo_id: // value for 'almacen_articulo_id'
 *      fecha_ingreso: // value for 'fecha_ingreso'
 *   },
 * });
 */
export function useGetSurtidosByAlmacenArtIdQuery(
    baseOptions?: Apollo.QueryHookOptions<GetSurtidosByAlmacenArtIdQuery, GetSurtidosByAlmacenArtIdQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetSurtidosByAlmacenArtIdQuery, GetSurtidosByAlmacenArtIdQueryVariables>(
        GetSurtidosByAlmacenArtIdDocument,
        options
    )
}
export function useGetSurtidosByAlmacenArtIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetSurtidosByAlmacenArtIdQuery, GetSurtidosByAlmacenArtIdQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetSurtidosByAlmacenArtIdQuery, GetSurtidosByAlmacenArtIdQueryVariables>(
        GetSurtidosByAlmacenArtIdDocument,
        options
    )
}
export type GetSurtidosByAlmacenArtIdQueryHookResult = ReturnType<typeof useGetSurtidosByAlmacenArtIdQuery>
export type GetSurtidosByAlmacenArtIdLazyQueryHookResult = ReturnType<typeof useGetSurtidosByAlmacenArtIdLazyQuery>
export type GetSurtidosByAlmacenArtIdQueryResult = Apollo.QueryResult<
    GetSurtidosByAlmacenArtIdQuery,
    GetSurtidosByAlmacenArtIdQueryVariables
>
export const GetAlmacenArticuloForSurtidoDocument = gql`
    query GetAlmacenArticuloForSurtido($almacen_articulo_id: ID!) {
        almacen_articulo(almacen_articulo_id: $almacen_articulo_id) {
            almacen_articulo_id
            almacen_id
            articulo_id
            costo
            precio
            cantidad
            almacen {
                almacen_id
                nombre
            }
            articulo {
                articulo_id
                marca
                nombre
                cantidad_minima
                stock
            }
            ultimo_surtido {
                fecha_ingreso
            }
        }
    }
`
export type GetAlmacenArticuloForSurtidoComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetAlmacenArticuloForSurtidoQuery,
        GetAlmacenArticuloForSurtidoQueryVariables
    >,
    "query"
> &
    ({ variables: GetAlmacenArticuloForSurtidoQueryVariables; skip?: boolean } | { skip: boolean })

export const GetAlmacenArticuloForSurtidoComponent = (props: GetAlmacenArticuloForSurtidoComponentProps) => (
    <ApolloReactComponents.Query<GetAlmacenArticuloForSurtidoQuery, GetAlmacenArticuloForSurtidoQueryVariables>
        query={GetAlmacenArticuloForSurtidoDocument}
        {...props}
    />
)

/**
 * __useGetAlmacenArticuloForSurtidoQuery__
 *
 * To run a query within a React component, call `useGetAlmacenArticuloForSurtidoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlmacenArticuloForSurtidoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlmacenArticuloForSurtidoQuery({
 *   variables: {
 *      almacen_articulo_id: // value for 'almacen_articulo_id'
 *   },
 * });
 */
export function useGetAlmacenArticuloForSurtidoQuery(
    baseOptions: Apollo.QueryHookOptions<GetAlmacenArticuloForSurtidoQuery, GetAlmacenArticuloForSurtidoQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetAlmacenArticuloForSurtidoQuery, GetAlmacenArticuloForSurtidoQueryVariables>(
        GetAlmacenArticuloForSurtidoDocument,
        options
    )
}
export function useGetAlmacenArticuloForSurtidoLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAlmacenArticuloForSurtidoQuery,
        GetAlmacenArticuloForSurtidoQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetAlmacenArticuloForSurtidoQuery, GetAlmacenArticuloForSurtidoQueryVariables>(
        GetAlmacenArticuloForSurtidoDocument,
        options
    )
}
export type GetAlmacenArticuloForSurtidoQueryHookResult = ReturnType<typeof useGetAlmacenArticuloForSurtidoQuery>
export type GetAlmacenArticuloForSurtidoLazyQueryHookResult = ReturnType<
    typeof useGetAlmacenArticuloForSurtidoLazyQuery
>
export type GetAlmacenArticuloForSurtidoQueryResult = Apollo.QueryResult<
    GetAlmacenArticuloForSurtidoQuery,
    GetAlmacenArticuloForSurtidoQueryVariables
>
export const CrearSurtidosDocument = gql`
    mutation CrearSurtidos($createManySurtidosInput: CreateManySurtidosInput!) {
        crear_surtidos(createManySurtidosInput: $createManySurtidosInput) {
            numero_articulos_surtidos
            surtidos {
                surtido_id
            }
        }
    }
`
export type CrearSurtidosMutationFn = Apollo.MutationFunction<CrearSurtidosMutation, CrearSurtidosMutationVariables>
export type CrearSurtidosComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CrearSurtidosMutation, CrearSurtidosMutationVariables>,
    "mutation"
>

export const CrearSurtidosComponent = (props: CrearSurtidosComponentProps) => (
    <ApolloReactComponents.Mutation<CrearSurtidosMutation, CrearSurtidosMutationVariables>
        mutation={CrearSurtidosDocument}
        {...props}
    />
)

/**
 * __useCrearSurtidosMutation__
 *
 * To run a mutation, you first call `useCrearSurtidosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrearSurtidosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crearSurtidosMutation, { data, loading, error }] = useCrearSurtidosMutation({
 *   variables: {
 *      createManySurtidosInput: // value for 'createManySurtidosInput'
 *   },
 * });
 */
export function useCrearSurtidosMutation(
    baseOptions?: Apollo.MutationHookOptions<CrearSurtidosMutation, CrearSurtidosMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CrearSurtidosMutation, CrearSurtidosMutationVariables>(CrearSurtidosDocument, options)
}
export type CrearSurtidosMutationHookResult = ReturnType<typeof useCrearSurtidosMutation>
export type CrearSurtidosMutationResult = Apollo.MutationResult<CrearSurtidosMutation>
export type CrearSurtidosMutationOptions = Apollo.BaseMutationOptions<
    CrearSurtidosMutation,
    CrearSurtidosMutationVariables
>
export const GetAlmacenArticulosMosaicDocument = gql`
    query getAlmacenArticulosMosaic(
        $hotel_id: ID!
        $pagination_options: PageOptionsArgs!
        $almacen_id: [ID!]
        $filterEstadoArticulo: EstadosArticulo
        $filterEstadoAlmacenArticulo: [EstadosAlmacenesArticulos!]
    ) {
        almacenes_articulos(
            hotel_id: $hotel_id
            eliminado: false
            almacen_id: $almacen_id
            filter_tipo_articulo: [insumo, proceso, venta]
            filter_producciones: true
            pagination_options: $pagination_options
            estado_almacen_articulo: $filterEstadoAlmacenArticulo
            filter_estado_articulo: $filterEstadoArticulo
            folio_articulo_filters: { order: ASC }
        ) {
            paginacion {
                pagina_actual
                total_paginas
                total_registros
            }
            almacenes_articulos {
                estado
                almacen_articulo_id
                articulo_id
                precio
                cantidad
                almacen_id
                articulo {
                    articulo_id
                    categoria_id
                    cantidad_minima
                    nombre
                    foto
                    marca
                    folio
                    eliminado
                    foto
                    estado
                    tipo
                    unidad
                    contenido
                }
            }
        }
    }
`
export type GetAlmacenArticulosMosaicComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetAlmacenArticulosMosaicQuery,
        GetAlmacenArticulosMosaicQueryVariables
    >,
    "query"
> &
    ({ variables: GetAlmacenArticulosMosaicQueryVariables; skip?: boolean } | { skip: boolean })

export const GetAlmacenArticulosMosaicComponent = (props: GetAlmacenArticulosMosaicComponentProps) => (
    <ApolloReactComponents.Query<GetAlmacenArticulosMosaicQuery, GetAlmacenArticulosMosaicQueryVariables>
        query={GetAlmacenArticulosMosaicDocument}
        {...props}
    />
)

/**
 * __useGetAlmacenArticulosMosaicQuery__
 *
 * To run a query within a React component, call `useGetAlmacenArticulosMosaicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlmacenArticulosMosaicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlmacenArticulosMosaicQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      pagination_options: // value for 'pagination_options'
 *      almacen_id: // value for 'almacen_id'
 *      filterEstadoArticulo: // value for 'filterEstadoArticulo'
 *      filterEstadoAlmacenArticulo: // value for 'filterEstadoAlmacenArticulo'
 *   },
 * });
 */
export function useGetAlmacenArticulosMosaicQuery(
    baseOptions: Apollo.QueryHookOptions<GetAlmacenArticulosMosaicQuery, GetAlmacenArticulosMosaicQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetAlmacenArticulosMosaicQuery, GetAlmacenArticulosMosaicQueryVariables>(
        GetAlmacenArticulosMosaicDocument,
        options
    )
}
export function useGetAlmacenArticulosMosaicLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetAlmacenArticulosMosaicQuery, GetAlmacenArticulosMosaicQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetAlmacenArticulosMosaicQuery, GetAlmacenArticulosMosaicQueryVariables>(
        GetAlmacenArticulosMosaicDocument,
        options
    )
}
export type GetAlmacenArticulosMosaicQueryHookResult = ReturnType<typeof useGetAlmacenArticulosMosaicQuery>
export type GetAlmacenArticulosMosaicLazyQueryHookResult = ReturnType<typeof useGetAlmacenArticulosMosaicLazyQuery>
export type GetAlmacenArticulosMosaicQueryResult = Apollo.QueryResult<
    GetAlmacenArticulosMosaicQuery,
    GetAlmacenArticulosMosaicQueryVariables
>
export const GetArticuloByIdDocument = gql`
    query getArticuloById($articulo_id: ID!) {
        almacenes_articulos(articulo_id: [$articulo_id]) {
            almacenes_articulos {
                almacen_articulo_id
                almacen_id
                costo
                precio
                articulo_id
                articulo {
                    articulo_id
                    categoria_id
                    foto
                    marca
                    nombre
                    unidad
                    contenido
                    cantidad_minima
                    stock
                    estado
                    tipo
                    extra
                    sku
                    fecha_registro
                    fecha_eliminado
                    cantidad_minima
                    folio
                }
            }
        }
    }
`
export type GetArticuloByIdComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetArticuloByIdQuery, GetArticuloByIdQueryVariables>,
    "query"
> &
    ({ variables: GetArticuloByIdQueryVariables; skip?: boolean } | { skip: boolean })

export const GetArticuloByIdComponent = (props: GetArticuloByIdComponentProps) => (
    <ApolloReactComponents.Query<GetArticuloByIdQuery, GetArticuloByIdQueryVariables>
        query={GetArticuloByIdDocument}
        {...props}
    />
)

/**
 * __useGetArticuloByIdQuery__
 *
 * To run a query within a React component, call `useGetArticuloByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticuloByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticuloByIdQuery({
 *   variables: {
 *      articulo_id: // value for 'articulo_id'
 *   },
 * });
 */
export function useGetArticuloByIdQuery(
    baseOptions: Apollo.QueryHookOptions<GetArticuloByIdQuery, GetArticuloByIdQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetArticuloByIdQuery, GetArticuloByIdQueryVariables>(GetArticuloByIdDocument, options)
}
export function useGetArticuloByIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetArticuloByIdQuery, GetArticuloByIdQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetArticuloByIdQuery, GetArticuloByIdQueryVariables>(GetArticuloByIdDocument, options)
}
export type GetArticuloByIdQueryHookResult = ReturnType<typeof useGetArticuloByIdQuery>
export type GetArticuloByIdLazyQueryHookResult = ReturnType<typeof useGetArticuloByIdLazyQuery>
export type GetArticuloByIdQueryResult = Apollo.QueryResult<GetArticuloByIdQuery, GetArticuloByIdQueryVariables>
export const GetAlmacenArticuloByArticuloIdDocument = gql`
    query getAlmacenArticuloByArticuloId($articulo_id: ID!) {
        almacenes_articulos(articulo_id: [$articulo_id]) {
            almacenes_articulos {
                almacen_articulo_id
                almacen_id
                articulo_id
                costo
                precio
                almacen {
                    almacen_id
                    nombre
                }
                articulo {
                    articulo_id
                    categoria_id
                    foto
                    marca
                    nombre
                    unidad
                    contenido
                    cantidad_minima
                    stock
                    estado
                    tipo
                    extra
                    sku
                    fecha_registro
                    fecha_eliminado
                    cantidad_minima
                    folio
                    descripcion
                }
                eliminado
                estado
            }
        }
    }
`
export type GetAlmacenArticuloByArticuloIdComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetAlmacenArticuloByArticuloIdQuery,
        GetAlmacenArticuloByArticuloIdQueryVariables
    >,
    "query"
> &
    ({ variables: GetAlmacenArticuloByArticuloIdQueryVariables; skip?: boolean } | { skip: boolean })

export const GetAlmacenArticuloByArticuloIdComponent = (props: GetAlmacenArticuloByArticuloIdComponentProps) => (
    <ApolloReactComponents.Query<GetAlmacenArticuloByArticuloIdQuery, GetAlmacenArticuloByArticuloIdQueryVariables>
        query={GetAlmacenArticuloByArticuloIdDocument}
        {...props}
    />
)

/**
 * __useGetAlmacenArticuloByArticuloIdQuery__
 *
 * To run a query within a React component, call `useGetAlmacenArticuloByArticuloIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlmacenArticuloByArticuloIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlmacenArticuloByArticuloIdQuery({
 *   variables: {
 *      articulo_id: // value for 'articulo_id'
 *   },
 * });
 */
export function useGetAlmacenArticuloByArticuloIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAlmacenArticuloByArticuloIdQuery,
        GetAlmacenArticuloByArticuloIdQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetAlmacenArticuloByArticuloIdQuery, GetAlmacenArticuloByArticuloIdQueryVariables>(
        GetAlmacenArticuloByArticuloIdDocument,
        options
    )
}
export function useGetAlmacenArticuloByArticuloIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAlmacenArticuloByArticuloIdQuery,
        GetAlmacenArticuloByArticuloIdQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetAlmacenArticuloByArticuloIdQuery, GetAlmacenArticuloByArticuloIdQueryVariables>(
        GetAlmacenArticuloByArticuloIdDocument,
        options
    )
}
export type GetAlmacenArticuloByArticuloIdQueryHookResult = ReturnType<typeof useGetAlmacenArticuloByArticuloIdQuery>
export type GetAlmacenArticuloByArticuloIdLazyQueryHookResult = ReturnType<
    typeof useGetAlmacenArticuloByArticuloIdLazyQuery
>
export type GetAlmacenArticuloByArticuloIdQueryResult = Apollo.QueryResult<
    GetAlmacenArticuloByArticuloIdQuery,
    GetAlmacenArticuloByArticuloIdQueryVariables
>
export const GetAlmacenArticuloByIdDocument = gql`
    query getAlmacenArticuloById($almacen_articulo_id: ID!) {
        almacen_articulo(almacen_articulo_id: $almacen_articulo_id) {
            precio
            estado
            es_parte_receta
            almacen_id
            almacen {
                nombre
            }
            almacen_articulo_id
            almacen_id
            articulo_id
            fecha_movimiento
            cantidad
            ultima_preparacion
            costo
            almacen {
                nombre
            }
            articulo {
                articulo_id
                categoria_id
                categoria_articulo {
                    categoria_id
                    nombre
                }
                descripcion
                cantidad_minima
                nombre
                foto
                marca
                eliminado
                estado
                fecha_eliminado
                fecha_registro
                folio
                tipo
                unidad
                unidades_disponibles
                contenido
                stock
                sku
            }
            ultimo_surtido {
                fecha_ingreso
            }
        }
    }
`
export type GetAlmacenArticuloByIdComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetAlmacenArticuloByIdQuery, GetAlmacenArticuloByIdQueryVariables>,
    "query"
> &
    ({ variables: GetAlmacenArticuloByIdQueryVariables; skip?: boolean } | { skip: boolean })

export const GetAlmacenArticuloByIdComponent = (props: GetAlmacenArticuloByIdComponentProps) => (
    <ApolloReactComponents.Query<GetAlmacenArticuloByIdQuery, GetAlmacenArticuloByIdQueryVariables>
        query={GetAlmacenArticuloByIdDocument}
        {...props}
    />
)

/**
 * __useGetAlmacenArticuloByIdQuery__
 *
 * To run a query within a React component, call `useGetAlmacenArticuloByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlmacenArticuloByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlmacenArticuloByIdQuery({
 *   variables: {
 *      almacen_articulo_id: // value for 'almacen_articulo_id'
 *   },
 * });
 */
export function useGetAlmacenArticuloByIdQuery(
    baseOptions: Apollo.QueryHookOptions<GetAlmacenArticuloByIdQuery, GetAlmacenArticuloByIdQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetAlmacenArticuloByIdQuery, GetAlmacenArticuloByIdQueryVariables>(
        GetAlmacenArticuloByIdDocument,
        options
    )
}
export function useGetAlmacenArticuloByIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetAlmacenArticuloByIdQuery, GetAlmacenArticuloByIdQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetAlmacenArticuloByIdQuery, GetAlmacenArticuloByIdQueryVariables>(
        GetAlmacenArticuloByIdDocument,
        options
    )
}
export type GetAlmacenArticuloByIdQueryHookResult = ReturnType<typeof useGetAlmacenArticuloByIdQuery>
export type GetAlmacenArticuloByIdLazyQueryHookResult = ReturnType<typeof useGetAlmacenArticuloByIdLazyQuery>
export type GetAlmacenArticuloByIdQueryResult = Apollo.QueryResult<
    GetAlmacenArticuloByIdQuery,
    GetAlmacenArticuloByIdQueryVariables
>
export const ActualizarProductoDocument = gql`
    mutation actualizarProducto($articulo_input: UpdateArticuloInput!) {
        actualizar_articulo(updateArticuloInput: $articulo_input) {
            articulo_id
        }
    }
`
export type ActualizarProductoMutationFn = Apollo.MutationFunction<
    ActualizarProductoMutation,
    ActualizarProductoMutationVariables
>
export type ActualizarProductoComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<ActualizarProductoMutation, ActualizarProductoMutationVariables>,
    "mutation"
>

export const ActualizarProductoComponent = (props: ActualizarProductoComponentProps) => (
    <ApolloReactComponents.Mutation<ActualizarProductoMutation, ActualizarProductoMutationVariables>
        mutation={ActualizarProductoDocument}
        {...props}
    />
)

/**
 * __useActualizarProductoMutation__
 *
 * To run a mutation, you first call `useActualizarProductoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizarProductoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizarProductoMutation, { data, loading, error }] = useActualizarProductoMutation({
 *   variables: {
 *      articulo_input: // value for 'articulo_input'
 *   },
 * });
 */
export function useActualizarProductoMutation(
    baseOptions?: Apollo.MutationHookOptions<ActualizarProductoMutation, ActualizarProductoMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ActualizarProductoMutation, ActualizarProductoMutationVariables>(
        ActualizarProductoDocument,
        options
    )
}
export type ActualizarProductoMutationHookResult = ReturnType<typeof useActualizarProductoMutation>
export type ActualizarProductoMutationResult = Apollo.MutationResult<ActualizarProductoMutation>
export type ActualizarProductoMutationOptions = Apollo.BaseMutationOptions<
    ActualizarProductoMutation,
    ActualizarProductoMutationVariables
>
export const EliminarArticuloDocument = gql`
    mutation eliminarArticulo($almacen_articulo_input: DeleteAlmacenesArticulosInput!) {
        eliminar_almacen_articulo(deleteAlmacenArticuloInput: $almacen_articulo_input)
    }
`
export type EliminarArticuloMutationFn = Apollo.MutationFunction<
    EliminarArticuloMutation,
    EliminarArticuloMutationVariables
>
export type EliminarArticuloComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<EliminarArticuloMutation, EliminarArticuloMutationVariables>,
    "mutation"
>

export const EliminarArticuloComponent = (props: EliminarArticuloComponentProps) => (
    <ApolloReactComponents.Mutation<EliminarArticuloMutation, EliminarArticuloMutationVariables>
        mutation={EliminarArticuloDocument}
        {...props}
    />
)

/**
 * __useEliminarArticuloMutation__
 *
 * To run a mutation, you first call `useEliminarArticuloMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEliminarArticuloMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eliminarArticuloMutation, { data, loading, error }] = useEliminarArticuloMutation({
 *   variables: {
 *      almacen_articulo_input: // value for 'almacen_articulo_input'
 *   },
 * });
 */
export function useEliminarArticuloMutation(
    baseOptions?: Apollo.MutationHookOptions<EliminarArticuloMutation, EliminarArticuloMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<EliminarArticuloMutation, EliminarArticuloMutationVariables>(
        EliminarArticuloDocument,
        options
    )
}
export type EliminarArticuloMutationHookResult = ReturnType<typeof useEliminarArticuloMutation>
export type EliminarArticuloMutationResult = Apollo.MutationResult<EliminarArticuloMutation>
export type EliminarArticuloMutationOptions = Apollo.BaseMutationOptions<
    EliminarArticuloMutation,
    EliminarArticuloMutationVariables
>
export const EliminarRecetaDocument = gql`
    mutation EliminarReceta($deleteRecetaInput: DeleteRecetaInput!) {
        eliminar_receta(deleteRecetaInput: $deleteRecetaInput)
    }
`
export type EliminarRecetaMutationFn = Apollo.MutationFunction<EliminarRecetaMutation, EliminarRecetaMutationVariables>
export type EliminarRecetaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<EliminarRecetaMutation, EliminarRecetaMutationVariables>,
    "mutation"
>

export const EliminarRecetaComponent = (props: EliminarRecetaComponentProps) => (
    <ApolloReactComponents.Mutation<EliminarRecetaMutation, EliminarRecetaMutationVariables>
        mutation={EliminarRecetaDocument}
        {...props}
    />
)

/**
 * __useEliminarRecetaMutation__
 *
 * To run a mutation, you first call `useEliminarRecetaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEliminarRecetaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eliminarRecetaMutation, { data, loading, error }] = useEliminarRecetaMutation({
 *   variables: {
 *      deleteRecetaInput: // value for 'deleteRecetaInput'
 *   },
 * });
 */
export function useEliminarRecetaMutation(
    baseOptions?: Apollo.MutationHookOptions<EliminarRecetaMutation, EliminarRecetaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<EliminarRecetaMutation, EliminarRecetaMutationVariables>(EliminarRecetaDocument, options)
}
export type EliminarRecetaMutationHookResult = ReturnType<typeof useEliminarRecetaMutation>
export type EliminarRecetaMutationResult = Apollo.MutationResult<EliminarRecetaMutation>
export type EliminarRecetaMutationOptions = Apollo.BaseMutationOptions<
    EliminarRecetaMutation,
    EliminarRecetaMutationVariables
>
export const Categorias_ArticulosDocument = gql`
    query Categorias_articulos($categoria_id: [ID!]!) {
        categorias_articulos(categoria_id: $categoria_id, eliminado: false) {
            categoria_id
            hotel_id
            nombre
            total_articulos
        }
    }
`
export type Categorias_ArticulosComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<Categorias_ArticulosQuery, Categorias_ArticulosQueryVariables>,
    "query"
> &
    ({ variables: Categorias_ArticulosQueryVariables; skip?: boolean } | { skip: boolean })

export const Categorias_ArticulosComponent = (props: Categorias_ArticulosComponentProps) => (
    <ApolloReactComponents.Query<Categorias_ArticulosQuery, Categorias_ArticulosQueryVariables>
        query={Categorias_ArticulosDocument}
        {...props}
    />
)

/**
 * __useCategorias_ArticulosQuery__
 *
 * To run a query within a React component, call `useCategorias_ArticulosQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategorias_ArticulosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategorias_ArticulosQuery({
 *   variables: {
 *      categoria_id: // value for 'categoria_id'
 *   },
 * });
 */
export function useCategorias_ArticulosQuery(
    baseOptions: Apollo.QueryHookOptions<Categorias_ArticulosQuery, Categorias_ArticulosQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<Categorias_ArticulosQuery, Categorias_ArticulosQueryVariables>(
        Categorias_ArticulosDocument,
        options
    )
}
export function useCategorias_ArticulosLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<Categorias_ArticulosQuery, Categorias_ArticulosQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<Categorias_ArticulosQuery, Categorias_ArticulosQueryVariables>(
        Categorias_ArticulosDocument,
        options
    )
}
export type Categorias_ArticulosQueryHookResult = ReturnType<typeof useCategorias_ArticulosQuery>
export type Categorias_ArticulosLazyQueryHookResult = ReturnType<typeof useCategorias_ArticulosLazyQuery>
export type Categorias_ArticulosQueryResult = Apollo.QueryResult<
    Categorias_ArticulosQuery,
    Categorias_ArticulosQueryVariables
>
export const Historial_Movimientos_InventarioDocument = gql`
    query Historial_movimientos_inventario(
        $fecha_registro: MonthSearchInput
        $hotel_id: ID!
        $pagination_options: PageOptionsArgs!
        $nombre_articulo: String
        $tipo_articulo: TipoArticulo
        $movimiento: MovimientoHistorialInventario
        $tipo: TipoMovimientoHistorialInventario
    ) {
        historial_movimientos_inventario(
            fecha_registro: $fecha_registro
            hotel_id: $hotel_id
            pagination_options: $pagination_options
            nombre_articulo: $nombre_articulo
            tipo_articulo: $tipo_articulo
            movimiento: $movimiento
            tipo: $tipo
        ) {
            paginacion {
                pagina_actual
                total_paginas
            }
            historial_movimientos_inventario {
                historial_movimiento_inventario_id
                articulo_id
                cantidad
                costo_actual
                fecha_registro
                folio
                hotel_id
                movimiento
                nombre_articulo
                precio
                salida_id
                surtido_id
                tipo
                almacen_articulo_id
                articulo {
                    unidad
                    folio
                    tipo
                }
                origen_destino
                responsable {
                    nombre
                    apellido_paterno
                    apellido_materno
                }
            }
        }
    }
`
export type Historial_Movimientos_InventarioComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        Historial_Movimientos_InventarioQuery,
        Historial_Movimientos_InventarioQueryVariables
    >,
    "query"
> &
    ({ variables: Historial_Movimientos_InventarioQueryVariables; skip?: boolean } | { skip: boolean })

export const Historial_Movimientos_InventarioComponent = (props: Historial_Movimientos_InventarioComponentProps) => (
    <ApolloReactComponents.Query<Historial_Movimientos_InventarioQuery, Historial_Movimientos_InventarioQueryVariables>
        query={Historial_Movimientos_InventarioDocument}
        {...props}
    />
)

/**
 * __useHistorial_Movimientos_InventarioQuery__
 *
 * To run a query within a React component, call `useHistorial_Movimientos_InventarioQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistorial_Movimientos_InventarioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistorial_Movimientos_InventarioQuery({
 *   variables: {
 *      fecha_registro: // value for 'fecha_registro'
 *      hotel_id: // value for 'hotel_id'
 *      pagination_options: // value for 'pagination_options'
 *      nombre_articulo: // value for 'nombre_articulo'
 *      tipo_articulo: // value for 'tipo_articulo'
 *      movimiento: // value for 'movimiento'
 *      tipo: // value for 'tipo'
 *   },
 * });
 */
export function useHistorial_Movimientos_InventarioQuery(
    baseOptions: Apollo.QueryHookOptions<
        Historial_Movimientos_InventarioQuery,
        Historial_Movimientos_InventarioQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<Historial_Movimientos_InventarioQuery, Historial_Movimientos_InventarioQueryVariables>(
        Historial_Movimientos_InventarioDocument,
        options
    )
}
export function useHistorial_Movimientos_InventarioLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        Historial_Movimientos_InventarioQuery,
        Historial_Movimientos_InventarioQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<Historial_Movimientos_InventarioQuery, Historial_Movimientos_InventarioQueryVariables>(
        Historial_Movimientos_InventarioDocument,
        options
    )
}
export type Historial_Movimientos_InventarioQueryHookResult = ReturnType<
    typeof useHistorial_Movimientos_InventarioQuery
>
export type Historial_Movimientos_InventarioLazyQueryHookResult = ReturnType<
    typeof useHistorial_Movimientos_InventarioLazyQuery
>
export type Historial_Movimientos_InventarioQueryResult = Apollo.QueryResult<
    Historial_Movimientos_InventarioQuery,
    Historial_Movimientos_InventarioQueryVariables
>
export const SurtidoDocument = gql`
    query Surtido($surtido_id: ID!) {
        surtido(surtido_id: $surtido_id) {
            almacen {
                almacen_id
            }
            articulo {
                articulo_id
            }
            cantidad
            colaborador_id
            costo_total
            costo_unitario
            fecha_ingreso
            hotel_id
            surtido_id
        }
    }
`
export type SurtidoComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<SurtidoQuery, SurtidoQueryVariables>,
    "query"
> &
    ({ variables: SurtidoQueryVariables; skip?: boolean } | { skip: boolean })

export const SurtidoComponent = (props: SurtidoComponentProps) => (
    <ApolloReactComponents.Query<SurtidoQuery, SurtidoQueryVariables> query={SurtidoDocument} {...props} />
)

/**
 * __useSurtidoQuery__
 *
 * To run a query within a React component, call `useSurtidoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurtidoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurtidoQuery({
 *   variables: {
 *      surtido_id: // value for 'surtido_id'
 *   },
 * });
 */
export function useSurtidoQuery(baseOptions: Apollo.QueryHookOptions<SurtidoQuery, SurtidoQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<SurtidoQuery, SurtidoQueryVariables>(SurtidoDocument, options)
}
export function useSurtidoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurtidoQuery, SurtidoQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<SurtidoQuery, SurtidoQueryVariables>(SurtidoDocument, options)
}
export type SurtidoQueryHookResult = ReturnType<typeof useSurtidoQuery>
export type SurtidoLazyQueryHookResult = ReturnType<typeof useSurtidoLazyQuery>
export type SurtidoQueryResult = Apollo.QueryResult<SurtidoQuery, SurtidoQueryVariables>
export const ColaboradorDocument = gql`
    query Colaborador($colaborador_id: ID!) {
        colaborador(colaborador_id: $colaborador_id) {
            apellido_materno
            apellido_paterno
            nombre
        }
    }
`
export type ColaboradorComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<ColaboradorQuery, ColaboradorQueryVariables>,
    "query"
> &
    ({ variables: ColaboradorQueryVariables; skip?: boolean } | { skip: boolean })

export const ColaboradorComponent = (props: ColaboradorComponentProps) => (
    <ApolloReactComponents.Query<ColaboradorQuery, ColaboradorQueryVariables> query={ColaboradorDocument} {...props} />
)

/**
 * __useColaboradorQuery__
 *
 * To run a query within a React component, call `useColaboradorQuery` and pass it any options that fit your needs.
 * When your component renders, `useColaboradorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useColaboradorQuery({
 *   variables: {
 *      colaborador_id: // value for 'colaborador_id'
 *   },
 * });
 */
export function useColaboradorQuery(baseOptions: Apollo.QueryHookOptions<ColaboradorQuery, ColaboradorQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<ColaboradorQuery, ColaboradorQueryVariables>(ColaboradorDocument, options)
}
export function useColaboradorLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ColaboradorQuery, ColaboradorQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<ColaboradorQuery, ColaboradorQueryVariables>(ColaboradorDocument, options)
}
export type ColaboradorQueryHookResult = ReturnType<typeof useColaboradorQuery>
export type ColaboradorLazyQueryHookResult = ReturnType<typeof useColaboradorLazyQuery>
export type ColaboradorQueryResult = Apollo.QueryResult<ColaboradorQuery, ColaboradorQueryVariables>
export const Salida_InventarioDocument = gql`
    query Salida_inventario($salida_id: ID!) {
        salida_inventario(salida_id: $salida_id) {
            almacen_articulo_id
            articulo {
                articulo_id
            }
            cantidad
            colaborador_id
            comentario
            fecha_salida
            hotel_id
            motivo
            salida_id
        }
    }
`
export type Salida_InventarioComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<Salida_InventarioQuery, Salida_InventarioQueryVariables>,
    "query"
> &
    ({ variables: Salida_InventarioQueryVariables; skip?: boolean } | { skip: boolean })

export const Salida_InventarioComponent = (props: Salida_InventarioComponentProps) => (
    <ApolloReactComponents.Query<Salida_InventarioQuery, Salida_InventarioQueryVariables>
        query={Salida_InventarioDocument}
        {...props}
    />
)

/**
 * __useSalida_InventarioQuery__
 *
 * To run a query within a React component, call `useSalida_InventarioQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalida_InventarioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalida_InventarioQuery({
 *   variables: {
 *      salida_id: // value for 'salida_id'
 *   },
 * });
 */
export function useSalida_InventarioQuery(
    baseOptions: Apollo.QueryHookOptions<Salida_InventarioQuery, Salida_InventarioQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<Salida_InventarioQuery, Salida_InventarioQueryVariables>(Salida_InventarioDocument, options)
}
export function useSalida_InventarioLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<Salida_InventarioQuery, Salida_InventarioQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<Salida_InventarioQuery, Salida_InventarioQueryVariables>(
        Salida_InventarioDocument,
        options
    )
}
export type Salida_InventarioQueryHookResult = ReturnType<typeof useSalida_InventarioQuery>
export type Salida_InventarioLazyQueryHookResult = ReturnType<typeof useSalida_InventarioLazyQuery>
export type Salida_InventarioQueryResult = Apollo.QueryResult<Salida_InventarioQuery, Salida_InventarioQueryVariables>
export const Informe_InventarioDocument = gql`
    query Informe_inventario($hotel_id: ID!, $almacen_id: ID) {
        informe_inventario(hotel_id: $hotel_id, almacen_id: $almacen_id) {
            cantidad_articulos
            costo_total_inventario
            articulos_agotados
            articulos_por_agotarse
            valor_comercial
        }
    }
`
export type Informe_InventarioComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<Informe_InventarioQuery, Informe_InventarioQueryVariables>,
    "query"
> &
    ({ variables: Informe_InventarioQueryVariables; skip?: boolean } | { skip: boolean })

export const Informe_InventarioComponent = (props: Informe_InventarioComponentProps) => (
    <ApolloReactComponents.Query<Informe_InventarioQuery, Informe_InventarioQueryVariables>
        query={Informe_InventarioDocument}
        {...props}
    />
)

/**
 * __useInforme_InventarioQuery__
 *
 * To run a query within a React component, call `useInforme_InventarioQuery` and pass it any options that fit your needs.
 * When your component renders, `useInforme_InventarioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInforme_InventarioQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      almacen_id: // value for 'almacen_id'
 *   },
 * });
 */
export function useInforme_InventarioQuery(
    baseOptions: Apollo.QueryHookOptions<Informe_InventarioQuery, Informe_InventarioQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<Informe_InventarioQuery, Informe_InventarioQueryVariables>(
        Informe_InventarioDocument,
        options
    )
}
export function useInforme_InventarioLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<Informe_InventarioQuery, Informe_InventarioQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<Informe_InventarioQuery, Informe_InventarioQueryVariables>(
        Informe_InventarioDocument,
        options
    )
}
export type Informe_InventarioQueryHookResult = ReturnType<typeof useInforme_InventarioQuery>
export type Informe_InventarioLazyQueryHookResult = ReturnType<typeof useInforme_InventarioLazyQuery>
export type Informe_InventarioQueryResult = Apollo.QueryResult<
    Informe_InventarioQuery,
    Informe_InventarioQueryVariables
>
export const Informe_Historial_Movimientos_InventarioDocument = gql`
    query Informe_historial_movimientos_inventario($hotel_id: ID!, $fecha_registro: DateSearchInput) {
        informe_historial_movimientos_inventario(hotel_id: $hotel_id, fecha_registro: $fecha_registro) {
            salidas_venta {
                total
                unidades
            }
            salidas_insumos {
                total
                unidades
            }
            merma {
                total
                unidades
            }
            entradas_productos {
                total
                unidades
            }
            entradas_insumos {
                total
                unidades
            }
        }
    }
`
export type Informe_Historial_Movimientos_InventarioComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        Informe_Historial_Movimientos_InventarioQuery,
        Informe_Historial_Movimientos_InventarioQueryVariables
    >,
    "query"
> &
    ({ variables: Informe_Historial_Movimientos_InventarioQueryVariables; skip?: boolean } | { skip: boolean })

export const Informe_Historial_Movimientos_InventarioComponent = (
    props: Informe_Historial_Movimientos_InventarioComponentProps
) => (
    <ApolloReactComponents.Query<
        Informe_Historial_Movimientos_InventarioQuery,
        Informe_Historial_Movimientos_InventarioQueryVariables
    >
        query={Informe_Historial_Movimientos_InventarioDocument}
        {...props}
    />
)

/**
 * __useInforme_Historial_Movimientos_InventarioQuery__
 *
 * To run a query within a React component, call `useInforme_Historial_Movimientos_InventarioQuery` and pass it any options that fit your needs.
 * When your component renders, `useInforme_Historial_Movimientos_InventarioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInforme_Historial_Movimientos_InventarioQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      fecha_registro: // value for 'fecha_registro'
 *   },
 * });
 */
export function useInforme_Historial_Movimientos_InventarioQuery(
    baseOptions: Apollo.QueryHookOptions<
        Informe_Historial_Movimientos_InventarioQuery,
        Informe_Historial_Movimientos_InventarioQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        Informe_Historial_Movimientos_InventarioQuery,
        Informe_Historial_Movimientos_InventarioQueryVariables
    >(Informe_Historial_Movimientos_InventarioDocument, options)
}
export function useInforme_Historial_Movimientos_InventarioLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        Informe_Historial_Movimientos_InventarioQuery,
        Informe_Historial_Movimientos_InventarioQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        Informe_Historial_Movimientos_InventarioQuery,
        Informe_Historial_Movimientos_InventarioQueryVariables
    >(Informe_Historial_Movimientos_InventarioDocument, options)
}
export type Informe_Historial_Movimientos_InventarioQueryHookResult = ReturnType<
    typeof useInforme_Historial_Movimientos_InventarioQuery
>
export type Informe_Historial_Movimientos_InventarioLazyQueryHookResult = ReturnType<
    typeof useInforme_Historial_Movimientos_InventarioLazyQuery
>
export type Informe_Historial_Movimientos_InventarioQueryResult = Apollo.QueryResult<
    Informe_Historial_Movimientos_InventarioQuery,
    Informe_Historial_Movimientos_InventarioQueryVariables
>
export const SurtirArticuloDocument = gql`
    mutation surtirArticulo($crear_surtido_input: CreateSurtidoInput!) {
        crear_surtido(createSurtidoInput: $crear_surtido_input) {
            almacen_articulo {
                cantidad
                estado
            }
            articulo {
                estado
            }
        }
    }
`
export type SurtirArticuloMutationFn = Apollo.MutationFunction<SurtirArticuloMutation, SurtirArticuloMutationVariables>
export type SurtirArticuloComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<SurtirArticuloMutation, SurtirArticuloMutationVariables>,
    "mutation"
>

export const SurtirArticuloComponent = (props: SurtirArticuloComponentProps) => (
    <ApolloReactComponents.Mutation<SurtirArticuloMutation, SurtirArticuloMutationVariables>
        mutation={SurtirArticuloDocument}
        {...props}
    />
)

/**
 * __useSurtirArticuloMutation__
 *
 * To run a mutation, you first call `useSurtirArticuloMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSurtirArticuloMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [surtirArticuloMutation, { data, loading, error }] = useSurtirArticuloMutation({
 *   variables: {
 *      crear_surtido_input: // value for 'crear_surtido_input'
 *   },
 * });
 */
export function useSurtirArticuloMutation(
    baseOptions?: Apollo.MutationHookOptions<SurtirArticuloMutation, SurtirArticuloMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<SurtirArticuloMutation, SurtirArticuloMutationVariables>(SurtirArticuloDocument, options)
}
export type SurtirArticuloMutationHookResult = ReturnType<typeof useSurtirArticuloMutation>
export type SurtirArticuloMutationResult = Apollo.MutationResult<SurtirArticuloMutation>
export type SurtirArticuloMutationOptions = Apollo.BaseMutationOptions<
    SurtirArticuloMutation,
    SurtirArticuloMutationVariables
>
export const Crear_SalidaDocument = gql`
    mutation Crear_salida($salidaInventarioInput: CreateSalidaInput!) {
        crear_salida_inventario(createSalidaInput: $salidaInventarioInput) {
            almacen_articulo {
                cantidad
                estado
            }
            articulo {
                estado
            }
        }
    }
`
export type Crear_SalidaMutationFn = Apollo.MutationFunction<Crear_SalidaMutation, Crear_SalidaMutationVariables>
export type Crear_SalidaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<Crear_SalidaMutation, Crear_SalidaMutationVariables>,
    "mutation"
>

export const Crear_SalidaComponent = (props: Crear_SalidaComponentProps) => (
    <ApolloReactComponents.Mutation<Crear_SalidaMutation, Crear_SalidaMutationVariables>
        mutation={Crear_SalidaDocument}
        {...props}
    />
)

/**
 * __useCrear_SalidaMutation__
 *
 * To run a mutation, you first call `useCrear_SalidaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrear_SalidaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crearSalidaMutation, { data, loading, error }] = useCrear_SalidaMutation({
 *   variables: {
 *      salidaInventarioInput: // value for 'salidaInventarioInput'
 *   },
 * });
 */
export function useCrear_SalidaMutation(
    baseOptions?: Apollo.MutationHookOptions<Crear_SalidaMutation, Crear_SalidaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<Crear_SalidaMutation, Crear_SalidaMutationVariables>(Crear_SalidaDocument, options)
}
export type Crear_SalidaMutationHookResult = ReturnType<typeof useCrear_SalidaMutation>
export type Crear_SalidaMutationResult = Apollo.MutationResult<Crear_SalidaMutation>
export type Crear_SalidaMutationOptions = Apollo.BaseMutationOptions<
    Crear_SalidaMutation,
    Crear_SalidaMutationVariables
>
export const GetAlmacenesArticulosForSearchDocument = gql`
    query GetAlmacenesArticulosForSearch($hotel_id: ID, $pagination_options: PageOptionsArgs!) {
        almacenes_articulos(hotel_id: $hotel_id, eliminado: false, pagination_options: $pagination_options) {
            almacenes_articulos {
                almacen_articulo_id
                almacen_id
                articulo_id
                precio
                cantidad
                almacen {
                    almacen_id
                    nombre
                }
                articulo {
                    articulo_id
                    categoria_id
                    foto
                    nombre
                    marca
                    contenido
                    unidad
                    descripcion
                }
            }
        }
    }
`
export type GetAlmacenesArticulosForSearchComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetAlmacenesArticulosForSearchQuery,
        GetAlmacenesArticulosForSearchQueryVariables
    >,
    "query"
> &
    ({ variables: GetAlmacenesArticulosForSearchQueryVariables; skip?: boolean } | { skip: boolean })

export const GetAlmacenesArticulosForSearchComponent = (props: GetAlmacenesArticulosForSearchComponentProps) => (
    <ApolloReactComponents.Query<GetAlmacenesArticulosForSearchQuery, GetAlmacenesArticulosForSearchQueryVariables>
        query={GetAlmacenesArticulosForSearchDocument}
        {...props}
    />
)

/**
 * __useGetAlmacenesArticulosForSearchQuery__
 *
 * To run a query within a React component, call `useGetAlmacenesArticulosForSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlmacenesArticulosForSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlmacenesArticulosForSearchQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      pagination_options: // value for 'pagination_options'
 *   },
 * });
 */
export function useGetAlmacenesArticulosForSearchQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAlmacenesArticulosForSearchQuery,
        GetAlmacenesArticulosForSearchQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetAlmacenesArticulosForSearchQuery, GetAlmacenesArticulosForSearchQueryVariables>(
        GetAlmacenesArticulosForSearchDocument,
        options
    )
}
export function useGetAlmacenesArticulosForSearchLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAlmacenesArticulosForSearchQuery,
        GetAlmacenesArticulosForSearchQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetAlmacenesArticulosForSearchQuery, GetAlmacenesArticulosForSearchQueryVariables>(
        GetAlmacenesArticulosForSearchDocument,
        options
    )
}
export type GetAlmacenesArticulosForSearchQueryHookResult = ReturnType<typeof useGetAlmacenesArticulosForSearchQuery>
export type GetAlmacenesArticulosForSearchLazyQueryHookResult = ReturnType<
    typeof useGetAlmacenesArticulosForSearchLazyQuery
>
export type GetAlmacenesArticulosForSearchQueryResult = Apollo.QueryResult<
    GetAlmacenesArticulosForSearchQuery,
    GetAlmacenesArticulosForSearchQueryVariables
>
export const TransferirArticulosDocument = gql`
    mutation TransferirArticulos($transferArticulosInput: TransferArticulosInput!) {
        transferir_articulos(transferArticulosInput: $transferArticulosInput) {
            numero_articulos_transferidos
        }
    }
`
export type TransferirArticulosMutationFn = Apollo.MutationFunction<
    TransferirArticulosMutation,
    TransferirArticulosMutationVariables
>
export type TransferirArticulosComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<TransferirArticulosMutation, TransferirArticulosMutationVariables>,
    "mutation"
>

export const TransferirArticulosComponent = (props: TransferirArticulosComponentProps) => (
    <ApolloReactComponents.Mutation<TransferirArticulosMutation, TransferirArticulosMutationVariables>
        mutation={TransferirArticulosDocument}
        {...props}
    />
)

/**
 * __useTransferirArticulosMutation__
 *
 * To run a mutation, you first call `useTransferirArticulosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferirArticulosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferirArticulosMutation, { data, loading, error }] = useTransferirArticulosMutation({
 *   variables: {
 *      transferArticulosInput: // value for 'transferArticulosInput'
 *   },
 * });
 */
export function useTransferirArticulosMutation(
    baseOptions?: Apollo.MutationHookOptions<TransferirArticulosMutation, TransferirArticulosMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<TransferirArticulosMutation, TransferirArticulosMutationVariables>(
        TransferirArticulosDocument,
        options
    )
}
export type TransferirArticulosMutationHookResult = ReturnType<typeof useTransferirArticulosMutation>
export type TransferirArticulosMutationResult = Apollo.MutationResult<TransferirArticulosMutation>
export type TransferirArticulosMutationOptions = Apollo.BaseMutationOptions<
    TransferirArticulosMutation,
    TransferirArticulosMutationVariables
>
export const GetArticuloForSearchDocument = gql`
    query GetArticuloForSearch($articulo_id: ID!, $hotel_id: ID!) {
        almacenes_articulos(articulo_id: [$articulo_id], hotel_id: $hotel_id) {
            almacenes_articulos {
                almacen_articulo_id
                almacen_id
                articulo_id
                articulo {
                    nombre
                    descripcion
                }
            }
        }
    }
`
export type GetArticuloForSearchComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetArticuloForSearchQuery, GetArticuloForSearchQueryVariables>,
    "query"
> &
    ({ variables: GetArticuloForSearchQueryVariables; skip?: boolean } | { skip: boolean })

export const GetArticuloForSearchComponent = (props: GetArticuloForSearchComponentProps) => (
    <ApolloReactComponents.Query<GetArticuloForSearchQuery, GetArticuloForSearchQueryVariables>
        query={GetArticuloForSearchDocument}
        {...props}
    />
)

/**
 * __useGetArticuloForSearchQuery__
 *
 * To run a query within a React component, call `useGetArticuloForSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticuloForSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticuloForSearchQuery({
 *   variables: {
 *      articulo_id: // value for 'articulo_id'
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetArticuloForSearchQuery(
    baseOptions: Apollo.QueryHookOptions<GetArticuloForSearchQuery, GetArticuloForSearchQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetArticuloForSearchQuery, GetArticuloForSearchQueryVariables>(
        GetArticuloForSearchDocument,
        options
    )
}
export function useGetArticuloForSearchLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetArticuloForSearchQuery, GetArticuloForSearchQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetArticuloForSearchQuery, GetArticuloForSearchQueryVariables>(
        GetArticuloForSearchDocument,
        options
    )
}
export type GetArticuloForSearchQueryHookResult = ReturnType<typeof useGetArticuloForSearchQuery>
export type GetArticuloForSearchLazyQueryHookResult = ReturnType<typeof useGetArticuloForSearchLazyQuery>
export type GetArticuloForSearchQueryResult = Apollo.QueryResult<
    GetArticuloForSearchQuery,
    GetArticuloForSearchQueryVariables
>
export const GetEnergeticosDocument = gql`
    query GetEnergeticos($fecha_registro: DateSearchInput!, $hotel_id: ID!) {
        mantenimientos(fecha_registro: $fecha_registro, hotel_id: $hotel_id) {
            agua
            gas
            mantenimiento_id
            luz
            colaborador_id
            colaborador {
                nombre
                apellido_paterno
                apellido_materno
            }
            turno_id
            turno {
                nombre
            }
            fecha_registro
            corte_id
            corte {
                estatus
                folio
            }
        }
    }
`
export type GetEnergeticosComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetEnergeticosQuery, GetEnergeticosQueryVariables>,
    "query"
> &
    ({ variables: GetEnergeticosQueryVariables; skip?: boolean } | { skip: boolean })

export const GetEnergeticosComponent = (props: GetEnergeticosComponentProps) => (
    <ApolloReactComponents.Query<GetEnergeticosQuery, GetEnergeticosQueryVariables>
        query={GetEnergeticosDocument}
        {...props}
    />
)

/**
 * __useGetEnergeticosQuery__
 *
 * To run a query within a React component, call `useGetEnergeticosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnergeticosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnergeticosQuery({
 *   variables: {
 *      fecha_registro: // value for 'fecha_registro'
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetEnergeticosQuery(
    baseOptions: Apollo.QueryHookOptions<GetEnergeticosQuery, GetEnergeticosQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetEnergeticosQuery, GetEnergeticosQueryVariables>(GetEnergeticosDocument, options)
}
export function useGetEnergeticosLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetEnergeticosQuery, GetEnergeticosQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetEnergeticosQuery, GetEnergeticosQueryVariables>(GetEnergeticosDocument, options)
}
export type GetEnergeticosQueryHookResult = ReturnType<typeof useGetEnergeticosQuery>
export type GetEnergeticosLazyQueryHookResult = ReturnType<typeof useGetEnergeticosLazyQuery>
export type GetEnergeticosQueryResult = Apollo.QueryResult<GetEnergeticosQuery, GetEnergeticosQueryVariables>
export const RegistrarEnergeticosDocument = gql`
    mutation RegistrarEnergeticos($datos_mantenimiento: CreateMantenimientoInput!) {
        crear_mantenimiento(datos_mantenimiento: $datos_mantenimiento) {
            agua
            gas
            luz
            colaborador_id
            turno_id
            fecha_registro
        }
    }
`
export type RegistrarEnergeticosMutationFn = Apollo.MutationFunction<
    RegistrarEnergeticosMutation,
    RegistrarEnergeticosMutationVariables
>
export type RegistrarEnergeticosComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<RegistrarEnergeticosMutation, RegistrarEnergeticosMutationVariables>,
    "mutation"
>

export const RegistrarEnergeticosComponent = (props: RegistrarEnergeticosComponentProps) => (
    <ApolloReactComponents.Mutation<RegistrarEnergeticosMutation, RegistrarEnergeticosMutationVariables>
        mutation={RegistrarEnergeticosDocument}
        {...props}
    />
)

/**
 * __useRegistrarEnergeticosMutation__
 *
 * To run a mutation, you first call `useRegistrarEnergeticosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegistrarEnergeticosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registrarEnergeticosMutation, { data, loading, error }] = useRegistrarEnergeticosMutation({
 *   variables: {
 *      datos_mantenimiento: // value for 'datos_mantenimiento'
 *   },
 * });
 */
export function useRegistrarEnergeticosMutation(
    baseOptions?: Apollo.MutationHookOptions<RegistrarEnergeticosMutation, RegistrarEnergeticosMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<RegistrarEnergeticosMutation, RegistrarEnergeticosMutationVariables>(
        RegistrarEnergeticosDocument,
        options
    )
}
export type RegistrarEnergeticosMutationHookResult = ReturnType<typeof useRegistrarEnergeticosMutation>
export type RegistrarEnergeticosMutationResult = Apollo.MutationResult<RegistrarEnergeticosMutation>
export type RegistrarEnergeticosMutationOptions = Apollo.BaseMutationOptions<
    RegistrarEnergeticosMutation,
    RegistrarEnergeticosMutationVariables
>
export const ActualizarEnergeticosDocument = gql`
    mutation ActualizarEnergeticos($datos_mantenimiento: UpdateMantenimientoInput!) {
        actualizar_mantenimiento(datos_mantenimiento: $datos_mantenimiento) {
            agua
            gas
            luz
            colaborador_id
            turno_id
            fecha_registro
        }
    }
`
export type ActualizarEnergeticosMutationFn = Apollo.MutationFunction<
    ActualizarEnergeticosMutation,
    ActualizarEnergeticosMutationVariables
>
export type ActualizarEnergeticosComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        ActualizarEnergeticosMutation,
        ActualizarEnergeticosMutationVariables
    >,
    "mutation"
>

export const ActualizarEnergeticosComponent = (props: ActualizarEnergeticosComponentProps) => (
    <ApolloReactComponents.Mutation<ActualizarEnergeticosMutation, ActualizarEnergeticosMutationVariables>
        mutation={ActualizarEnergeticosDocument}
        {...props}
    />
)

/**
 * __useActualizarEnergeticosMutation__
 *
 * To run a mutation, you first call `useActualizarEnergeticosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizarEnergeticosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizarEnergeticosMutation, { data, loading, error }] = useActualizarEnergeticosMutation({
 *   variables: {
 *      datos_mantenimiento: // value for 'datos_mantenimiento'
 *   },
 * });
 */
export function useActualizarEnergeticosMutation(
    baseOptions?: Apollo.MutationHookOptions<ActualizarEnergeticosMutation, ActualizarEnergeticosMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ActualizarEnergeticosMutation, ActualizarEnergeticosMutationVariables>(
        ActualizarEnergeticosDocument,
        options
    )
}
export type ActualizarEnergeticosMutationHookResult = ReturnType<typeof useActualizarEnergeticosMutation>
export type ActualizarEnergeticosMutationResult = Apollo.MutationResult<ActualizarEnergeticosMutation>
export type ActualizarEnergeticosMutationOptions = Apollo.BaseMutationOptions<
    ActualizarEnergeticosMutation,
    ActualizarEnergeticosMutationVariables
>
export const GetKpisMantenimientoDocument = gql`
    query GetKpisMantenimiento($fecha_registro: DateSearchInput!, $hotel_id: ID!) {
        kpis_mantenimientos(fecha_registro: $fecha_registro, hotel_id: $hotel_id) {
            incidencias_cerradas
            incidencias_pendientes
            habitaciones_bloqueadas
            total_agua
            total_gas
            total_luz
        }
    }
`
export type GetKpisMantenimientoComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetKpisMantenimientoQuery, GetKpisMantenimientoQueryVariables>,
    "query"
> &
    ({ variables: GetKpisMantenimientoQueryVariables; skip?: boolean } | { skip: boolean })

export const GetKpisMantenimientoComponent = (props: GetKpisMantenimientoComponentProps) => (
    <ApolloReactComponents.Query<GetKpisMantenimientoQuery, GetKpisMantenimientoQueryVariables>
        query={GetKpisMantenimientoDocument}
        {...props}
    />
)

/**
 * __useGetKpisMantenimientoQuery__
 *
 * To run a query within a React component, call `useGetKpisMantenimientoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKpisMantenimientoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKpisMantenimientoQuery({
 *   variables: {
 *      fecha_registro: // value for 'fecha_registro'
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetKpisMantenimientoQuery(
    baseOptions: Apollo.QueryHookOptions<GetKpisMantenimientoQuery, GetKpisMantenimientoQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetKpisMantenimientoQuery, GetKpisMantenimientoQueryVariables>(
        GetKpisMantenimientoDocument,
        options
    )
}
export function useGetKpisMantenimientoLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetKpisMantenimientoQuery, GetKpisMantenimientoQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetKpisMantenimientoQuery, GetKpisMantenimientoQueryVariables>(
        GetKpisMantenimientoDocument,
        options
    )
}
export type GetKpisMantenimientoQueryHookResult = ReturnType<typeof useGetKpisMantenimientoQuery>
export type GetKpisMantenimientoLazyQueryHookResult = ReturnType<typeof useGetKpisMantenimientoLazyQuery>
export type GetKpisMantenimientoQueryResult = Apollo.QueryResult<
    GetKpisMantenimientoQuery,
    GetKpisMantenimientoQueryVariables
>
export const Eliminar_HuellaDocument = gql`
    mutation Eliminar_huella($input: DeleteCredencialInput!) {
        eliminar_huella(DeleteCredencialInput: $input)
    }
`
export type Eliminar_HuellaMutationFn = Apollo.MutationFunction<
    Eliminar_HuellaMutation,
    Eliminar_HuellaMutationVariables
>
export type Eliminar_HuellaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<Eliminar_HuellaMutation, Eliminar_HuellaMutationVariables>,
    "mutation"
>

export const Eliminar_HuellaComponent = (props: Eliminar_HuellaComponentProps) => (
    <ApolloReactComponents.Mutation<Eliminar_HuellaMutation, Eliminar_HuellaMutationVariables>
        mutation={Eliminar_HuellaDocument}
        {...props}
    />
)

/**
 * __useEliminar_HuellaMutation__
 *
 * To run a mutation, you first call `useEliminar_HuellaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEliminar_HuellaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eliminarHuellaMutation, { data, loading, error }] = useEliminar_HuellaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEliminar_HuellaMutation(
    baseOptions?: Apollo.MutationHookOptions<Eliminar_HuellaMutation, Eliminar_HuellaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<Eliminar_HuellaMutation, Eliminar_HuellaMutationVariables>(
        Eliminar_HuellaDocument,
        options
    )
}
export type Eliminar_HuellaMutationHookResult = ReturnType<typeof useEliminar_HuellaMutation>
export type Eliminar_HuellaMutationResult = Apollo.MutationResult<Eliminar_HuellaMutation>
export type Eliminar_HuellaMutationOptions = Apollo.BaseMutationOptions<
    Eliminar_HuellaMutation,
    Eliminar_HuellaMutationVariables
>
export const HabitacionesToCleanDocument = gql`
    query HabitacionesToClean($hotel_id: ID!, $estado: estados_habitaciones!) {
        habitaciones(hotel_id: $hotel_id, estado: $estado) {
            habitacion_id
            numero_habitacion
            ultimos_datos {
                ultima_limpieza {
                    fecha_inicio
                }
            }
            tipo_habitacion_id
            tipo_habitacion {
                nombre
                minutos_limpieza_retoque
                minutos_limpieza_detallada
                minutos_limpieza_normal
            }
        }
    }
`
export type HabitacionesToCleanComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<HabitacionesToCleanQuery, HabitacionesToCleanQueryVariables>,
    "query"
> &
    ({ variables: HabitacionesToCleanQueryVariables; skip?: boolean } | { skip: boolean })

export const HabitacionesToCleanComponent = (props: HabitacionesToCleanComponentProps) => (
    <ApolloReactComponents.Query<HabitacionesToCleanQuery, HabitacionesToCleanQueryVariables>
        query={HabitacionesToCleanDocument}
        {...props}
    />
)

/**
 * __useHabitacionesToCleanQuery__
 *
 * To run a query within a React component, call `useHabitacionesToCleanQuery` and pass it any options that fit your needs.
 * When your component renders, `useHabitacionesToCleanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHabitacionesToCleanQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      estado: // value for 'estado'
 *   },
 * });
 */
export function useHabitacionesToCleanQuery(
    baseOptions: Apollo.QueryHookOptions<HabitacionesToCleanQuery, HabitacionesToCleanQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<HabitacionesToCleanQuery, HabitacionesToCleanQueryVariables>(
        HabitacionesToCleanDocument,
        options
    )
}
export function useHabitacionesToCleanLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<HabitacionesToCleanQuery, HabitacionesToCleanQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<HabitacionesToCleanQuery, HabitacionesToCleanQueryVariables>(
        HabitacionesToCleanDocument,
        options
    )
}
export type HabitacionesToCleanQueryHookResult = ReturnType<typeof useHabitacionesToCleanQuery>
export type HabitacionesToCleanLazyQueryHookResult = ReturnType<typeof useHabitacionesToCleanLazyQuery>
export type HabitacionesToCleanQueryResult = Apollo.QueryResult<
    HabitacionesToCleanQuery,
    HabitacionesToCleanQueryVariables
>
export const HabitacionesToMaintenanceOrCleanDocument = gql`
    query HabitacionesToMaintenanceOrClean($hotel_id: ID!) {
        habitaciones(hotel_id: $hotel_id) {
            habitacion_id
            estado
            numero_habitacion
            colaborador_tareas_sin_finalizar {
                tarea_id
                colaborador_tarea_id
                fecha_termino
            }
            numero_habitacion
            ultimos_datos {
                ultima_limpieza {
                    fecha_inicio
                }
            }
            tipo_habitacion_id
            tipo_habitacion {
                nombre
                minutos_limpieza_retoque
                minutos_limpieza_detallada
                minutos_limpieza_normal
            }
        }
    }
`
export type HabitacionesToMaintenanceOrCleanComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        HabitacionesToMaintenanceOrCleanQuery,
        HabitacionesToMaintenanceOrCleanQueryVariables
    >,
    "query"
> &
    ({ variables: HabitacionesToMaintenanceOrCleanQueryVariables; skip?: boolean } | { skip: boolean })

export const HabitacionesToMaintenanceOrCleanComponent = (props: HabitacionesToMaintenanceOrCleanComponentProps) => (
    <ApolloReactComponents.Query<HabitacionesToMaintenanceOrCleanQuery, HabitacionesToMaintenanceOrCleanQueryVariables>
        query={HabitacionesToMaintenanceOrCleanDocument}
        {...props}
    />
)

/**
 * __useHabitacionesToMaintenanceOrCleanQuery__
 *
 * To run a query within a React component, call `useHabitacionesToMaintenanceOrCleanQuery` and pass it any options that fit your needs.
 * When your component renders, `useHabitacionesToMaintenanceOrCleanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHabitacionesToMaintenanceOrCleanQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useHabitacionesToMaintenanceOrCleanQuery(
    baseOptions: Apollo.QueryHookOptions<
        HabitacionesToMaintenanceOrCleanQuery,
        HabitacionesToMaintenanceOrCleanQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<HabitacionesToMaintenanceOrCleanQuery, HabitacionesToMaintenanceOrCleanQueryVariables>(
        HabitacionesToMaintenanceOrCleanDocument,
        options
    )
}
export function useHabitacionesToMaintenanceOrCleanLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        HabitacionesToMaintenanceOrCleanQuery,
        HabitacionesToMaintenanceOrCleanQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<HabitacionesToMaintenanceOrCleanQuery, HabitacionesToMaintenanceOrCleanQueryVariables>(
        HabitacionesToMaintenanceOrCleanDocument,
        options
    )
}
export type HabitacionesToMaintenanceOrCleanQueryHookResult = ReturnType<
    typeof useHabitacionesToMaintenanceOrCleanQuery
>
export type HabitacionesToMaintenanceOrCleanLazyQueryHookResult = ReturnType<
    typeof useHabitacionesToMaintenanceOrCleanLazyQuery
>
export type HabitacionesToMaintenanceOrCleanQueryResult = Apollo.QueryResult<
    HabitacionesToMaintenanceOrCleanQuery,
    HabitacionesToMaintenanceOrCleanQueryVariables
>
export const Cambiar_EstadoDocument = gql`
    mutation Cambiar_estado($actualizar_habitacion_estado_input: UpdateEstadoHabitacionInput!) {
        actualizar_habitacion_estado(actualizar_habitacion_estado_input: $actualizar_habitacion_estado_input) {
            posicion {
                x
                y
                tamano
            }
            estado
            fecha_estado
            colaborador_tareas_sin_finalizar {
                tarea_id
                colaborador_tarea_id
                descripcion_tarea
                fecha_inicio
                tipo_limpieza
                colaborador {
                    nombre
                    apellido_materno
                    apellido_paterno
                }
            }
            ultimos_datos {
                ultima_limpieza {
                    colaborador {
                        apellido_materno
                        apellido_paterno
                        nombre
                    }
                    fecha_termino
                    comentarios {
                        comentario
                        fecha
                    }
                }
                ultimo_mantenimiento {
                    colaborador {
                        apellido_materno
                        apellido_paterno
                        nombre
                    }
                    fecha_termino
                }
                ultima_supervision {
                    colaborador {
                        apellido_materno
                        apellido_paterno
                        nombre
                    }
                }
            }
        }
    }
`
export type Cambiar_EstadoMutationFn = Apollo.MutationFunction<Cambiar_EstadoMutation, Cambiar_EstadoMutationVariables>
export type Cambiar_EstadoComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<Cambiar_EstadoMutation, Cambiar_EstadoMutationVariables>,
    "mutation"
>

export const Cambiar_EstadoComponent = (props: Cambiar_EstadoComponentProps) => (
    <ApolloReactComponents.Mutation<Cambiar_EstadoMutation, Cambiar_EstadoMutationVariables>
        mutation={Cambiar_EstadoDocument}
        {...props}
    />
)

/**
 * __useCambiar_EstadoMutation__
 *
 * To run a mutation, you first call `useCambiar_EstadoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCambiar_EstadoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cambiarEstadoMutation, { data, loading, error }] = useCambiar_EstadoMutation({
 *   variables: {
 *      actualizar_habitacion_estado_input: // value for 'actualizar_habitacion_estado_input'
 *   },
 * });
 */
export function useCambiar_EstadoMutation(
    baseOptions?: Apollo.MutationHookOptions<Cambiar_EstadoMutation, Cambiar_EstadoMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<Cambiar_EstadoMutation, Cambiar_EstadoMutationVariables>(Cambiar_EstadoDocument, options)
}
export type Cambiar_EstadoMutationHookResult = ReturnType<typeof useCambiar_EstadoMutation>
export type Cambiar_EstadoMutationResult = Apollo.MutationResult<Cambiar_EstadoMutation>
export type Cambiar_EstadoMutationOptions = Apollo.BaseMutationOptions<
    Cambiar_EstadoMutation,
    Cambiar_EstadoMutationVariables
>
export const GetTurnosDocument = gql`
    query getTurnos($hotel_id: [ID!]!) {
        turnos(hotel_id: $hotel_id) {
            nombre
            hora_entrada
            hora_salida
            hotel_id
            turno_id
            estado
        }
    }
`
export type GetTurnosComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetTurnosQuery, GetTurnosQueryVariables>,
    "query"
> &
    ({ variables: GetTurnosQueryVariables; skip?: boolean } | { skip: boolean })

export const GetTurnosComponent = (props: GetTurnosComponentProps) => (
    <ApolloReactComponents.Query<GetTurnosQuery, GetTurnosQueryVariables> query={GetTurnosDocument} {...props} />
)

/**
 * __useGetTurnosQuery__
 *
 * To run a query within a React component, call `useGetTurnosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTurnosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTurnosQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetTurnosQuery(baseOptions: Apollo.QueryHookOptions<GetTurnosQuery, GetTurnosQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetTurnosQuery, GetTurnosQueryVariables>(GetTurnosDocument, options)
}
export function useGetTurnosLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetTurnosQuery, GetTurnosQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetTurnosQuery, GetTurnosQueryVariables>(GetTurnosDocument, options)
}
export type GetTurnosQueryHookResult = ReturnType<typeof useGetTurnosQuery>
export type GetTurnosLazyQueryHookResult = ReturnType<typeof useGetTurnosLazyQuery>
export type GetTurnosQueryResult = Apollo.QueryResult<GetTurnosQuery, GetTurnosQueryVariables>
export const ColaboradoresIdNumDocument = gql`
    query ColaboradoresIDNum($hotel_id: ID!) {
        colaboradores(hotel_id: $hotel_id, eliminado: false) {
            numero_id
            numero_colaborador
            colaborador_id
            turno_id
            ultima_orden {
                orden_id
            }
            cantidad_ordenes
            usuario_id
            __typename
        }
    }
`
export type ColaboradoresIdNumComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<ColaboradoresIdNumQuery, ColaboradoresIdNumQueryVariables>,
    "query"
> &
    ({ variables: ColaboradoresIdNumQueryVariables; skip?: boolean } | { skip: boolean })

export const ColaboradoresIdNumComponent = (props: ColaboradoresIdNumComponentProps) => (
    <ApolloReactComponents.Query<ColaboradoresIdNumQuery, ColaboradoresIdNumQueryVariables>
        query={ColaboradoresIdNumDocument}
        {...props}
    />
)

/**
 * __useColaboradoresIdNumQuery__
 *
 * To run a query within a React component, call `useColaboradoresIdNumQuery` and pass it any options that fit your needs.
 * When your component renders, `useColaboradoresIdNumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useColaboradoresIdNumQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useColaboradoresIdNumQuery(
    baseOptions: Apollo.QueryHookOptions<ColaboradoresIdNumQuery, ColaboradoresIdNumQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<ColaboradoresIdNumQuery, ColaboradoresIdNumQueryVariables>(
        ColaboradoresIdNumDocument,
        options
    )
}
export function useColaboradoresIdNumLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ColaboradoresIdNumQuery, ColaboradoresIdNumQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<ColaboradoresIdNumQuery, ColaboradoresIdNumQueryVariables>(
        ColaboradoresIdNumDocument,
        options
    )
}
export type ColaboradoresIdNumQueryHookResult = ReturnType<typeof useColaboradoresIdNumQuery>
export type ColaboradoresIdNumLazyQueryHookResult = ReturnType<typeof useColaboradoresIdNumLazyQuery>
export type ColaboradoresIdNumQueryResult = Apollo.QueryResult<
    ColaboradoresIdNumQuery,
    ColaboradoresIdNumQueryVariables
>
export const ColaboradoresPorHotelDocument = gql`
    query ColaboradoresPorHotel($hotel_id: ID!) {
        colaboradores(hotel_id: $hotel_id, eliminado: false) {
            apellido_materno
            apellido_paterno
            nombre
            foto
            usuario_id
            usuario {
                tiene_huella
            }
            es_supervisor(hotel_id: $hotel_id)
            fecha_registro
            telefono_personal
            fecha_cumpleanios
            numero_id
            sueldo
            numero_colaborador
            colaborador_id
            correo
            direccion
            estado
            fecha_baja
            eliminado
            telefono_emergencia
            en_turno
            ultima_tarea {
                tarea_id
                descripcion_tarea
                fecha_inicio
                fecha_termino
                colaborador_tarea_id
                habitacion_id
                habitacion {
                    numero_habitacion
                    tipo_habitacion_id
                    tipo_habitacion {
                        nombre
                    }
                }
            }
            area {
                area_id
                nombre
            }
            colaborador_in_hotel {
                area_id
                puesto_id
                puesto {
                    descripcion
                    nombre
                    descripcion
                    puesto_id
                }
            }
            turno_id
            turno {
                hora_entrada
                hora_salida
                nombre
                turno_id
                estado
            }
            asistencia_abierta {
                asistencia_id
                fecha_entrada
                fecha_salida
            }
            ultima_orden {
                orden_id
                orden
                fecha_registro
            }
            cantidad_ordenes
        }
    }
`
export type ColaboradoresPorHotelComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<ColaboradoresPorHotelQuery, ColaboradoresPorHotelQueryVariables>,
    "query"
> &
    ({ variables: ColaboradoresPorHotelQueryVariables; skip?: boolean } | { skip: boolean })

export const ColaboradoresPorHotelComponent = (props: ColaboradoresPorHotelComponentProps) => (
    <ApolloReactComponents.Query<ColaboradoresPorHotelQuery, ColaboradoresPorHotelQueryVariables>
        query={ColaboradoresPorHotelDocument}
        {...props}
    />
)

/**
 * __useColaboradoresPorHotelQuery__
 *
 * To run a query within a React component, call `useColaboradoresPorHotelQuery` and pass it any options that fit your needs.
 * When your component renders, `useColaboradoresPorHotelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useColaboradoresPorHotelQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useColaboradoresPorHotelQuery(
    baseOptions: Apollo.QueryHookOptions<ColaboradoresPorHotelQuery, ColaboradoresPorHotelQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<ColaboradoresPorHotelQuery, ColaboradoresPorHotelQueryVariables>(
        ColaboradoresPorHotelDocument,
        options
    )
}
export function useColaboradoresPorHotelLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ColaboradoresPorHotelQuery, ColaboradoresPorHotelQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<ColaboradoresPorHotelQuery, ColaboradoresPorHotelQueryVariables>(
        ColaboradoresPorHotelDocument,
        options
    )
}
export type ColaboradoresPorHotelQueryHookResult = ReturnType<typeof useColaboradoresPorHotelQuery>
export type ColaboradoresPorHotelLazyQueryHookResult = ReturnType<typeof useColaboradoresPorHotelLazyQuery>
export type ColaboradoresPorHotelQueryResult = Apollo.QueryResult<
    ColaboradoresPorHotelQuery,
    ColaboradoresPorHotelQueryVariables
>
export const ActualizarColaboradorTurnoDocument = gql`
    mutation ActualizarColaboradorTurno($datos_turno_colaborador: UpdateColaboradorTurnoInput!) {
        actualizar_colaborador_turno(updateColaboradorTurnoInput: $datos_turno_colaborador) {
            colaborador_id
        }
    }
`
export type ActualizarColaboradorTurnoMutationFn = Apollo.MutationFunction<
    ActualizarColaboradorTurnoMutation,
    ActualizarColaboradorTurnoMutationVariables
>
export type ActualizarColaboradorTurnoComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        ActualizarColaboradorTurnoMutation,
        ActualizarColaboradorTurnoMutationVariables
    >,
    "mutation"
>

export const ActualizarColaboradorTurnoComponent = (props: ActualizarColaboradorTurnoComponentProps) => (
    <ApolloReactComponents.Mutation<ActualizarColaboradorTurnoMutation, ActualizarColaboradorTurnoMutationVariables>
        mutation={ActualizarColaboradorTurnoDocument}
        {...props}
    />
)

/**
 * __useActualizarColaboradorTurnoMutation__
 *
 * To run a mutation, you first call `useActualizarColaboradorTurnoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizarColaboradorTurnoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizarColaboradorTurnoMutation, { data, loading, error }] = useActualizarColaboradorTurnoMutation({
 *   variables: {
 *      datos_turno_colaborador: // value for 'datos_turno_colaborador'
 *   },
 * });
 */
export function useActualizarColaboradorTurnoMutation(
    baseOptions?: Apollo.MutationHookOptions<
        ActualizarColaboradorTurnoMutation,
        ActualizarColaboradorTurnoMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ActualizarColaboradorTurnoMutation, ActualizarColaboradorTurnoMutationVariables>(
        ActualizarColaboradorTurnoDocument,
        options
    )
}
export type ActualizarColaboradorTurnoMutationHookResult = ReturnType<typeof useActualizarColaboradorTurnoMutation>
export type ActualizarColaboradorTurnoMutationResult = Apollo.MutationResult<ActualizarColaboradorTurnoMutation>
export type ActualizarColaboradorTurnoMutationOptions = Apollo.BaseMutationOptions<
    ActualizarColaboradorTurnoMutation,
    ActualizarColaboradorTurnoMutationVariables
>
export const GetPuestosByHotelIdDocument = gql`
    query getPuestosByHotelId {
        puestos(eliminado: false) {
            puesto_id
            nombre
            area {
                area_id
                nombre
            }
        }
    }
`
export type GetPuestosByHotelIdComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetPuestosByHotelIdQuery, GetPuestosByHotelIdQueryVariables>,
    "query"
>

export const GetPuestosByHotelIdComponent = (props: GetPuestosByHotelIdComponentProps) => (
    <ApolloReactComponents.Query<GetPuestosByHotelIdQuery, GetPuestosByHotelIdQueryVariables>
        query={GetPuestosByHotelIdDocument}
        {...props}
    />
)

/**
 * __useGetPuestosByHotelIdQuery__
 *
 * To run a query within a React component, call `useGetPuestosByHotelIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPuestosByHotelIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPuestosByHotelIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPuestosByHotelIdQuery(
    baseOptions?: Apollo.QueryHookOptions<GetPuestosByHotelIdQuery, GetPuestosByHotelIdQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetPuestosByHotelIdQuery, GetPuestosByHotelIdQueryVariables>(
        GetPuestosByHotelIdDocument,
        options
    )
}
export function useGetPuestosByHotelIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetPuestosByHotelIdQuery, GetPuestosByHotelIdQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetPuestosByHotelIdQuery, GetPuestosByHotelIdQueryVariables>(
        GetPuestosByHotelIdDocument,
        options
    )
}
export type GetPuestosByHotelIdQueryHookResult = ReturnType<typeof useGetPuestosByHotelIdQuery>
export type GetPuestosByHotelIdLazyQueryHookResult = ReturnType<typeof useGetPuestosByHotelIdLazyQuery>
export type GetPuestosByHotelIdQueryResult = Apollo.QueryResult<
    GetPuestosByHotelIdQuery,
    GetPuestosByHotelIdQueryVariables
>
export const EliminarColaboradorDocument = gql`
    mutation EliminarColaborador($colaborador: DeleteColaboradorInput!) {
        eliminar_colaborador(colaborador: $colaborador) {
            colaborador_id
        }
    }
`
export type EliminarColaboradorMutationFn = Apollo.MutationFunction<
    EliminarColaboradorMutation,
    EliminarColaboradorMutationVariables
>
export type EliminarColaboradorComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<EliminarColaboradorMutation, EliminarColaboradorMutationVariables>,
    "mutation"
>

export const EliminarColaboradorComponent = (props: EliminarColaboradorComponentProps) => (
    <ApolloReactComponents.Mutation<EliminarColaboradorMutation, EliminarColaboradorMutationVariables>
        mutation={EliminarColaboradorDocument}
        {...props}
    />
)

/**
 * __useEliminarColaboradorMutation__
 *
 * To run a mutation, you first call `useEliminarColaboradorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEliminarColaboradorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eliminarColaboradorMutation, { data, loading, error }] = useEliminarColaboradorMutation({
 *   variables: {
 *      colaborador: // value for 'colaborador'
 *   },
 * });
 */
export function useEliminarColaboradorMutation(
    baseOptions?: Apollo.MutationHookOptions<EliminarColaboradorMutation, EliminarColaboradorMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<EliminarColaboradorMutation, EliminarColaboradorMutationVariables>(
        EliminarColaboradorDocument,
        options
    )
}
export type EliminarColaboradorMutationHookResult = ReturnType<typeof useEliminarColaboradorMutation>
export type EliminarColaboradorMutationResult = Apollo.MutationResult<EliminarColaboradorMutation>
export type EliminarColaboradorMutationOptions = Apollo.BaseMutationOptions<
    EliminarColaboradorMutation,
    EliminarColaboradorMutationVariables
>
export const GetAreasDocument = gql`
    query getAreas($hotel_id: ID!) {
        areas(hotel_id: $hotel_id, eliminado: false) {
            nombre
            area_id
            puestos {
                puesto_id
                nombre
            }
        }
    }
`
export type GetAreasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetAreasQuery, GetAreasQueryVariables>,
    "query"
> &
    ({ variables: GetAreasQueryVariables; skip?: boolean } | { skip: boolean })

export const GetAreasComponent = (props: GetAreasComponentProps) => (
    <ApolloReactComponents.Query<GetAreasQuery, GetAreasQueryVariables> query={GetAreasDocument} {...props} />
)

/**
 * __useGetAreasQuery__
 *
 * To run a query within a React component, call `useGetAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreasQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetAreasQuery(baseOptions: Apollo.QueryHookOptions<GetAreasQuery, GetAreasQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetAreasQuery, GetAreasQueryVariables>(GetAreasDocument, options)
}
export function useGetAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAreasQuery, GetAreasQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetAreasQuery, GetAreasQueryVariables>(GetAreasDocument, options)
}
export type GetAreasQueryHookResult = ReturnType<typeof useGetAreasQuery>
export type GetAreasLazyQueryHookResult = ReturnType<typeof useGetAreasLazyQuery>
export type GetAreasQueryResult = Apollo.QueryResult<GetAreasQuery, GetAreasQueryVariables>
export const CrearColaboradorDocument = gql`
    mutation CrearColaborador($ColaboradorInput: CreateColaboradorInput!) {
        crear_colaborador(datos_colaborador: $ColaboradorInput) {
            apellido_materno
            colaborador_id
        }
    }
`
export type CrearColaboradorMutationFn = Apollo.MutationFunction<
    CrearColaboradorMutation,
    CrearColaboradorMutationVariables
>
export type CrearColaboradorComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CrearColaboradorMutation, CrearColaboradorMutationVariables>,
    "mutation"
>

export const CrearColaboradorComponent = (props: CrearColaboradorComponentProps) => (
    <ApolloReactComponents.Mutation<CrearColaboradorMutation, CrearColaboradorMutationVariables>
        mutation={CrearColaboradorDocument}
        {...props}
    />
)

/**
 * __useCrearColaboradorMutation__
 *
 * To run a mutation, you first call `useCrearColaboradorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrearColaboradorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crearColaboradorMutation, { data, loading, error }] = useCrearColaboradorMutation({
 *   variables: {
 *      ColaboradorInput: // value for 'ColaboradorInput'
 *   },
 * });
 */
export function useCrearColaboradorMutation(
    baseOptions?: Apollo.MutationHookOptions<CrearColaboradorMutation, CrearColaboradorMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CrearColaboradorMutation, CrearColaboradorMutationVariables>(
        CrearColaboradorDocument,
        options
    )
}
export type CrearColaboradorMutationHookResult = ReturnType<typeof useCrearColaboradorMutation>
export type CrearColaboradorMutationResult = Apollo.MutationResult<CrearColaboradorMutation>
export type CrearColaboradorMutationOptions = Apollo.BaseMutationOptions<
    CrearColaboradorMutation,
    CrearColaboradorMutationVariables
>
export const CrearColaboradorConUsuarioDocument = gql`
    mutation CrearColaboradorConUsuario($ColaboradorInput: CreateColaboradorUsuarioInput!) {
        crear_colaborador_usuario(datos_colaborador: $ColaboradorInput) {
            apellido_materno
            colaborador_id
        }
    }
`
export type CrearColaboradorConUsuarioMutationFn = Apollo.MutationFunction<
    CrearColaboradorConUsuarioMutation,
    CrearColaboradorConUsuarioMutationVariables
>
export type CrearColaboradorConUsuarioComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        CrearColaboradorConUsuarioMutation,
        CrearColaboradorConUsuarioMutationVariables
    >,
    "mutation"
>

export const CrearColaboradorConUsuarioComponent = (props: CrearColaboradorConUsuarioComponentProps) => (
    <ApolloReactComponents.Mutation<CrearColaboradorConUsuarioMutation, CrearColaboradorConUsuarioMutationVariables>
        mutation={CrearColaboradorConUsuarioDocument}
        {...props}
    />
)

/**
 * __useCrearColaboradorConUsuarioMutation__
 *
 * To run a mutation, you first call `useCrearColaboradorConUsuarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrearColaboradorConUsuarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crearColaboradorConUsuarioMutation, { data, loading, error }] = useCrearColaboradorConUsuarioMutation({
 *   variables: {
 *      ColaboradorInput: // value for 'ColaboradorInput'
 *   },
 * });
 */
export function useCrearColaboradorConUsuarioMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CrearColaboradorConUsuarioMutation,
        CrearColaboradorConUsuarioMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CrearColaboradorConUsuarioMutation, CrearColaboradorConUsuarioMutationVariables>(
        CrearColaboradorConUsuarioDocument,
        options
    )
}
export type CrearColaboradorConUsuarioMutationHookResult = ReturnType<typeof useCrearColaboradorConUsuarioMutation>
export type CrearColaboradorConUsuarioMutationResult = Apollo.MutationResult<CrearColaboradorConUsuarioMutation>
export type CrearColaboradorConUsuarioMutationOptions = Apollo.BaseMutationOptions<
    CrearColaboradorConUsuarioMutation,
    CrearColaboradorConUsuarioMutationVariables
>
export const ActualizarColaboradorDocument = gql`
    mutation ActualizarColaborador($datos_colaborador: UpdateColaboradorInput!) {
        editar_colaborador(datos_colaborador: $datos_colaborador) {
            colaborador_id
            usuario_id
            nombre
            apellido_paterno
            apellido_materno
            numero_colaborador
            estado
            en_turno
            fecha_registro
            eliminado
        }
    }
`
export type ActualizarColaboradorMutationFn = Apollo.MutationFunction<
    ActualizarColaboradorMutation,
    ActualizarColaboradorMutationVariables
>
export type ActualizarColaboradorComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        ActualizarColaboradorMutation,
        ActualizarColaboradorMutationVariables
    >,
    "mutation"
>

export const ActualizarColaboradorComponent = (props: ActualizarColaboradorComponentProps) => (
    <ApolloReactComponents.Mutation<ActualizarColaboradorMutation, ActualizarColaboradorMutationVariables>
        mutation={ActualizarColaboradorDocument}
        {...props}
    />
)

/**
 * __useActualizarColaboradorMutation__
 *
 * To run a mutation, you first call `useActualizarColaboradorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizarColaboradorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizarColaboradorMutation, { data, loading, error }] = useActualizarColaboradorMutation({
 *   variables: {
 *      datos_colaborador: // value for 'datos_colaborador'
 *   },
 * });
 */
export function useActualizarColaboradorMutation(
    baseOptions?: Apollo.MutationHookOptions<ActualizarColaboradorMutation, ActualizarColaboradorMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ActualizarColaboradorMutation, ActualizarColaboradorMutationVariables>(
        ActualizarColaboradorDocument,
        options
    )
}
export type ActualizarColaboradorMutationHookResult = ReturnType<typeof useActualizarColaboradorMutation>
export type ActualizarColaboradorMutationResult = Apollo.MutationResult<ActualizarColaboradorMutation>
export type ActualizarColaboradorMutationOptions = Apollo.BaseMutationOptions<
    ActualizarColaboradorMutation,
    ActualizarColaboradorMutationVariables
>
export const AbrirTurnoColaboradorDocument = gql`
    mutation AbrirTurnoColaborador($turnOnTurnoColaboradorInput: TurnOnTurnoColaboradorInput!) {
        abrir_turno_colaborador(turnOnTurnoColaboradorInput: $turnOnTurnoColaboradorInput) {
            estado
            asistencia_abierta {
                asistencia_id
                fecha_entrada
                fecha_salida
            }
        }
    }
`
export type AbrirTurnoColaboradorMutationFn = Apollo.MutationFunction<
    AbrirTurnoColaboradorMutation,
    AbrirTurnoColaboradorMutationVariables
>
export type AbrirTurnoColaboradorComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        AbrirTurnoColaboradorMutation,
        AbrirTurnoColaboradorMutationVariables
    >,
    "mutation"
>

export const AbrirTurnoColaboradorComponent = (props: AbrirTurnoColaboradorComponentProps) => (
    <ApolloReactComponents.Mutation<AbrirTurnoColaboradorMutation, AbrirTurnoColaboradorMutationVariables>
        mutation={AbrirTurnoColaboradorDocument}
        {...props}
    />
)

/**
 * __useAbrirTurnoColaboradorMutation__
 *
 * To run a mutation, you first call `useAbrirTurnoColaboradorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbrirTurnoColaboradorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [abrirTurnoColaboradorMutation, { data, loading, error }] = useAbrirTurnoColaboradorMutation({
 *   variables: {
 *      turnOnTurnoColaboradorInput: // value for 'turnOnTurnoColaboradorInput'
 *   },
 * });
 */
export function useAbrirTurnoColaboradorMutation(
    baseOptions?: Apollo.MutationHookOptions<AbrirTurnoColaboradorMutation, AbrirTurnoColaboradorMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<AbrirTurnoColaboradorMutation, AbrirTurnoColaboradorMutationVariables>(
        AbrirTurnoColaboradorDocument,
        options
    )
}
export type AbrirTurnoColaboradorMutationHookResult = ReturnType<typeof useAbrirTurnoColaboradorMutation>
export type AbrirTurnoColaboradorMutationResult = Apollo.MutationResult<AbrirTurnoColaboradorMutation>
export type AbrirTurnoColaboradorMutationOptions = Apollo.BaseMutationOptions<
    AbrirTurnoColaboradorMutation,
    AbrirTurnoColaboradorMutationVariables
>
export const CerrarTurnoColaboradorDocument = gql`
    mutation CerrarTurnoColaborador($turnOffColaboradoresInput: TurnOffTurnoColaboradoresInput!) {
        cerrar_turno_colaborador(turnOffColaboradorInput: $turnOffColaboradoresInput) {
            estado
            asistencia_abierta {
                asistencia_id
                fecha_entrada
                fecha_salida
            }
        }
    }
`
export type CerrarTurnoColaboradorMutationFn = Apollo.MutationFunction<
    CerrarTurnoColaboradorMutation,
    CerrarTurnoColaboradorMutationVariables
>
export type CerrarTurnoColaboradorComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        CerrarTurnoColaboradorMutation,
        CerrarTurnoColaboradorMutationVariables
    >,
    "mutation"
>

export const CerrarTurnoColaboradorComponent = (props: CerrarTurnoColaboradorComponentProps) => (
    <ApolloReactComponents.Mutation<CerrarTurnoColaboradorMutation, CerrarTurnoColaboradorMutationVariables>
        mutation={CerrarTurnoColaboradorDocument}
        {...props}
    />
)

/**
 * __useCerrarTurnoColaboradorMutation__
 *
 * To run a mutation, you first call `useCerrarTurnoColaboradorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCerrarTurnoColaboradorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cerrarTurnoColaboradorMutation, { data, loading, error }] = useCerrarTurnoColaboradorMutation({
 *   variables: {
 *      turnOffColaboradoresInput: // value for 'turnOffColaboradoresInput'
 *   },
 * });
 */
export function useCerrarTurnoColaboradorMutation(
    baseOptions?: Apollo.MutationHookOptions<CerrarTurnoColaboradorMutation, CerrarTurnoColaboradorMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CerrarTurnoColaboradorMutation, CerrarTurnoColaboradorMutationVariables>(
        CerrarTurnoColaboradorDocument,
        options
    )
}
export type CerrarTurnoColaboradorMutationHookResult = ReturnType<typeof useCerrarTurnoColaboradorMutation>
export type CerrarTurnoColaboradorMutationResult = Apollo.MutationResult<CerrarTurnoColaboradorMutation>
export type CerrarTurnoColaboradorMutationOptions = Apollo.BaseMutationOptions<
    CerrarTurnoColaboradorMutation,
    CerrarTurnoColaboradorMutationVariables
>
export const AbrirTurnoDocument = gql`
    mutation AbrirTurno($open_turno_input: OpenTurnoInput!) {
        abrir_turno(open_turno_input: $open_turno_input)
    }
`
export type AbrirTurnoMutationFn = Apollo.MutationFunction<AbrirTurnoMutation, AbrirTurnoMutationVariables>
export type AbrirTurnoComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<AbrirTurnoMutation, AbrirTurnoMutationVariables>,
    "mutation"
>

export const AbrirTurnoComponent = (props: AbrirTurnoComponentProps) => (
    <ApolloReactComponents.Mutation<AbrirTurnoMutation, AbrirTurnoMutationVariables>
        mutation={AbrirTurnoDocument}
        {...props}
    />
)

/**
 * __useAbrirTurnoMutation__
 *
 * To run a mutation, you first call `useAbrirTurnoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbrirTurnoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [abrirTurnoMutation, { data, loading, error }] = useAbrirTurnoMutation({
 *   variables: {
 *      open_turno_input: // value for 'open_turno_input'
 *   },
 * });
 */
export function useAbrirTurnoMutation(
    baseOptions?: Apollo.MutationHookOptions<AbrirTurnoMutation, AbrirTurnoMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<AbrirTurnoMutation, AbrirTurnoMutationVariables>(AbrirTurnoDocument, options)
}
export type AbrirTurnoMutationHookResult = ReturnType<typeof useAbrirTurnoMutation>
export type AbrirTurnoMutationResult = Apollo.MutationResult<AbrirTurnoMutation>
export type AbrirTurnoMutationOptions = Apollo.BaseMutationOptions<AbrirTurnoMutation, AbrirTurnoMutationVariables>
export const CerrarTurnoDocument = gql`
    mutation CerrarTurno($cerrar_turno_input: CloseTurnoInput!) {
        cerrar_turno(close_turno_input: $cerrar_turno_input)
    }
`
export type CerrarTurnoMutationFn = Apollo.MutationFunction<CerrarTurnoMutation, CerrarTurnoMutationVariables>
export type CerrarTurnoComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CerrarTurnoMutation, CerrarTurnoMutationVariables>,
    "mutation"
>

export const CerrarTurnoComponent = (props: CerrarTurnoComponentProps) => (
    <ApolloReactComponents.Mutation<CerrarTurnoMutation, CerrarTurnoMutationVariables>
        mutation={CerrarTurnoDocument}
        {...props}
    />
)

/**
 * __useCerrarTurnoMutation__
 *
 * To run a mutation, you first call `useCerrarTurnoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCerrarTurnoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cerrarTurnoMutation, { data, loading, error }] = useCerrarTurnoMutation({
 *   variables: {
 *      cerrar_turno_input: // value for 'cerrar_turno_input'
 *   },
 * });
 */
export function useCerrarTurnoMutation(
    baseOptions?: Apollo.MutationHookOptions<CerrarTurnoMutation, CerrarTurnoMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CerrarTurnoMutation, CerrarTurnoMutationVariables>(CerrarTurnoDocument, options)
}
export type CerrarTurnoMutationHookResult = ReturnType<typeof useCerrarTurnoMutation>
export type CerrarTurnoMutationResult = Apollo.MutationResult<CerrarTurnoMutation>
export type CerrarTurnoMutationOptions = Apollo.BaseMutationOptions<CerrarTurnoMutation, CerrarTurnoMutationVariables>
export const CambiarTurnoDocument = gql`
    mutation CambiarTurno($cambiar_turno_input: ChangeTurnoInput!) {
        cambiar_turno(cambiar_turno_input: $cambiar_turno_input)
    }
`
export type CambiarTurnoMutationFn = Apollo.MutationFunction<CambiarTurnoMutation, CambiarTurnoMutationVariables>
export type CambiarTurnoComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CambiarTurnoMutation, CambiarTurnoMutationVariables>,
    "mutation"
>

export const CambiarTurnoComponent = (props: CambiarTurnoComponentProps) => (
    <ApolloReactComponents.Mutation<CambiarTurnoMutation, CambiarTurnoMutationVariables>
        mutation={CambiarTurnoDocument}
        {...props}
    />
)

/**
 * __useCambiarTurnoMutation__
 *
 * To run a mutation, you first call `useCambiarTurnoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCambiarTurnoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cambiarTurnoMutation, { data, loading, error }] = useCambiarTurnoMutation({
 *   variables: {
 *      cambiar_turno_input: // value for 'cambiar_turno_input'
 *   },
 * });
 */
export function useCambiarTurnoMutation(
    baseOptions?: Apollo.MutationHookOptions<CambiarTurnoMutation, CambiarTurnoMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CambiarTurnoMutation, CambiarTurnoMutationVariables>(CambiarTurnoDocument, options)
}
export type CambiarTurnoMutationHookResult = ReturnType<typeof useCambiarTurnoMutation>
export type CambiarTurnoMutationResult = Apollo.MutationResult<CambiarTurnoMutation>
export type CambiarTurnoMutationOptions = Apollo.BaseMutationOptions<
    CambiarTurnoMutation,
    CambiarTurnoMutationVariables
>
export const ColaboradoresPorHotelTableDocument = gql`
    query ColaboradoresPorHotelTable(
        $hotel_id: ID!
        $date_asignaciones: DateSearchInput!
        $pagination_options: PageOptionsArgs
        $areas_filter: [ID!]
        $puesto_id: [ID!]
        $nombre: String
    ) {
        colaboradores_by_area(
            hotel_id: $hotel_id
            pagination_options: $pagination_options
            area_id: $areas_filter
            puesto_id: $puesto_id
            nombre_colaborador_filter: { like: $nombre }
        ) {
            paginacion {
                total_paginas
            }
            colaboradores {
                ultima_asistencia_cerrada {
                    asistencia_id
                    fecha_entrada
                }
                apellido_materno
                apellido_paterno
                nombre
                numero_id
                usuario_id
                colaborador_id
                estado
                en_turno
                foto
                es_supervisor(hotel_id: $hotel_id)
                ultima_tarea {
                    tarea_id
                    fecha_inicio
                    fecha_termino
                    colaborador_tarea_id
                    habitacion_id
                    habitacion {
                        numero_habitacion
                        estado
                        tipo_habitacion_id
                        tipo_habitacion {
                            nombre
                        }
                    }
                }
                mesa_asignada_activa {
                    has_mesa_activa
                }
                colaborador_in_hotel {
                    puesto_id
                    puesto {
                        descripcion
                        nombre
                        descripcion
                        puesto_id
                    }
                }
                turno_id
                turno {
                    nombre
                    estado
                }
                asistencia_abierta {
                    asistencia_id
                    fecha_entrada
                    fecha_salida
                }
                ultima_orden {
                    orden_id
                    orden
                    fecha_registro
                }
                cantidad_ordenes
                numero_asignaciones(DateSearchInput: $date_asignaciones)
            }
        }
    }
`
export type ColaboradoresPorHotelTableComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        ColaboradoresPorHotelTableQuery,
        ColaboradoresPorHotelTableQueryVariables
    >,
    "query"
> &
    ({ variables: ColaboradoresPorHotelTableQueryVariables; skip?: boolean } | { skip: boolean })

export const ColaboradoresPorHotelTableComponent = (props: ColaboradoresPorHotelTableComponentProps) => (
    <ApolloReactComponents.Query<ColaboradoresPorHotelTableQuery, ColaboradoresPorHotelTableQueryVariables>
        query={ColaboradoresPorHotelTableDocument}
        {...props}
    />
)

/**
 * __useColaboradoresPorHotelTableQuery__
 *
 * To run a query within a React component, call `useColaboradoresPorHotelTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useColaboradoresPorHotelTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useColaboradoresPorHotelTableQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      date_asignaciones: // value for 'date_asignaciones'
 *      pagination_options: // value for 'pagination_options'
 *      areas_filter: // value for 'areas_filter'
 *      puesto_id: // value for 'puesto_id'
 *      nombre: // value for 'nombre'
 *   },
 * });
 */
export function useColaboradoresPorHotelTableQuery(
    baseOptions: Apollo.QueryHookOptions<ColaboradoresPorHotelTableQuery, ColaboradoresPorHotelTableQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<ColaboradoresPorHotelTableQuery, ColaboradoresPorHotelTableQueryVariables>(
        ColaboradoresPorHotelTableDocument,
        options
    )
}
export function useColaboradoresPorHotelTableLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ColaboradoresPorHotelTableQuery, ColaboradoresPorHotelTableQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<ColaboradoresPorHotelTableQuery, ColaboradoresPorHotelTableQueryVariables>(
        ColaboradoresPorHotelTableDocument,
        options
    )
}
export type ColaboradoresPorHotelTableQueryHookResult = ReturnType<typeof useColaboradoresPorHotelTableQuery>
export type ColaboradoresPorHotelTableLazyQueryHookResult = ReturnType<typeof useColaboradoresPorHotelTableLazyQuery>
export type ColaboradoresPorHotelTableQueryResult = Apollo.QueryResult<
    ColaboradoresPorHotelTableQuery,
    ColaboradoresPorHotelTableQueryVariables
>
export const ColaboradoresCountPorAreaDocument = gql`
    query ColaboradoresCountPorArea($hotel_id: ID!, $areas_filter: [ID!]) {
        colaboradores_by_area(hotel_id: $hotel_id, area_id: $areas_filter) {
            paginacion {
                total_registros
            }
        }
    }
`
export type ColaboradoresCountPorAreaComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        ColaboradoresCountPorAreaQuery,
        ColaboradoresCountPorAreaQueryVariables
    >,
    "query"
> &
    ({ variables: ColaboradoresCountPorAreaQueryVariables; skip?: boolean } | { skip: boolean })

export const ColaboradoresCountPorAreaComponent = (props: ColaboradoresCountPorAreaComponentProps) => (
    <ApolloReactComponents.Query<ColaboradoresCountPorAreaQuery, ColaboradoresCountPorAreaQueryVariables>
        query={ColaboradoresCountPorAreaDocument}
        {...props}
    />
)

/**
 * __useColaboradoresCountPorAreaQuery__
 *
 * To run a query within a React component, call `useColaboradoresCountPorAreaQuery` and pass it any options that fit your needs.
 * When your component renders, `useColaboradoresCountPorAreaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useColaboradoresCountPorAreaQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      areas_filter: // value for 'areas_filter'
 *   },
 * });
 */
export function useColaboradoresCountPorAreaQuery(
    baseOptions: Apollo.QueryHookOptions<ColaboradoresCountPorAreaQuery, ColaboradoresCountPorAreaQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<ColaboradoresCountPorAreaQuery, ColaboradoresCountPorAreaQueryVariables>(
        ColaboradoresCountPorAreaDocument,
        options
    )
}
export function useColaboradoresCountPorAreaLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ColaboradoresCountPorAreaQuery, ColaboradoresCountPorAreaQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<ColaboradoresCountPorAreaQuery, ColaboradoresCountPorAreaQueryVariables>(
        ColaboradoresCountPorAreaDocument,
        options
    )
}
export type ColaboradoresCountPorAreaQueryHookResult = ReturnType<typeof useColaboradoresCountPorAreaQuery>
export type ColaboradoresCountPorAreaLazyQueryHookResult = ReturnType<typeof useColaboradoresCountPorAreaLazyQuery>
export type ColaboradoresCountPorAreaQueryResult = Apollo.QueryResult<
    ColaboradoresCountPorAreaQuery,
    ColaboradoresCountPorAreaQueryVariables
>
export const EliminarHuellaDocument = gql`
    mutation eliminarHuella($input: DeleteCredentialHuellaPinInput!) {
        eliminar_huella_pin(deleteCredentialhuellaPinInput: $input)
    }
`
export type EliminarHuellaMutationFn = Apollo.MutationFunction<EliminarHuellaMutation, EliminarHuellaMutationVariables>
export type EliminarHuellaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<EliminarHuellaMutation, EliminarHuellaMutationVariables>,
    "mutation"
>

export const EliminarHuellaComponent = (props: EliminarHuellaComponentProps) => (
    <ApolloReactComponents.Mutation<EliminarHuellaMutation, EliminarHuellaMutationVariables>
        mutation={EliminarHuellaDocument}
        {...props}
    />
)

/**
 * __useEliminarHuellaMutation__
 *
 * To run a mutation, you first call `useEliminarHuellaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEliminarHuellaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eliminarHuellaMutation, { data, loading, error }] = useEliminarHuellaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEliminarHuellaMutation(
    baseOptions?: Apollo.MutationHookOptions<EliminarHuellaMutation, EliminarHuellaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<EliminarHuellaMutation, EliminarHuellaMutationVariables>(EliminarHuellaDocument, options)
}
export type EliminarHuellaMutationHookResult = ReturnType<typeof useEliminarHuellaMutation>
export type EliminarHuellaMutationResult = Apollo.MutationResult<EliminarHuellaMutation>
export type EliminarHuellaMutationOptions = Apollo.BaseMutationOptions<
    EliminarHuellaMutation,
    EliminarHuellaMutationVariables
>
export const GenerarPinDocument = gql`
    query generarPin {
        generar_pin
    }
`
export type GenerarPinComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GenerarPinQuery, GenerarPinQueryVariables>,
    "query"
>

export const GenerarPinComponent = (props: GenerarPinComponentProps) => (
    <ApolloReactComponents.Query<GenerarPinQuery, GenerarPinQueryVariables> query={GenerarPinDocument} {...props} />
)

/**
 * __useGenerarPinQuery__
 *
 * To run a query within a React component, call `useGenerarPinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerarPinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerarPinQuery({
 *   variables: {
 *   },
 * });
 */
export function useGenerarPinQuery(baseOptions?: Apollo.QueryHookOptions<GenerarPinQuery, GenerarPinQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GenerarPinQuery, GenerarPinQueryVariables>(GenerarPinDocument, options)
}
export function useGenerarPinLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GenerarPinQuery, GenerarPinQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GenerarPinQuery, GenerarPinQueryVariables>(GenerarPinDocument, options)
}
export type GenerarPinQueryHookResult = ReturnType<typeof useGenerarPinQuery>
export type GenerarPinLazyQueryHookResult = ReturnType<typeof useGenerarPinLazyQuery>
export type GenerarPinQueryResult = Apollo.QueryResult<GenerarPinQuery, GenerarPinQueryVariables>
export const RegistrarHuellaDocument = gql`
    mutation RegistrarHuella($input: CreateCredencialInput!) {
        registrar_huella(CreateCredencialInput: $input)
    }
`
export type RegistrarHuellaMutationFn = Apollo.MutationFunction<
    RegistrarHuellaMutation,
    RegistrarHuellaMutationVariables
>
export type RegistrarHuellaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<RegistrarHuellaMutation, RegistrarHuellaMutationVariables>,
    "mutation"
>

export const RegistrarHuellaComponent = (props: RegistrarHuellaComponentProps) => (
    <ApolloReactComponents.Mutation<RegistrarHuellaMutation, RegistrarHuellaMutationVariables>
        mutation={RegistrarHuellaDocument}
        {...props}
    />
)

/**
 * __useRegistrarHuellaMutation__
 *
 * To run a mutation, you first call `useRegistrarHuellaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegistrarHuellaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registrarHuellaMutation, { data, loading, error }] = useRegistrarHuellaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegistrarHuellaMutation(
    baseOptions?: Apollo.MutationHookOptions<RegistrarHuellaMutation, RegistrarHuellaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<RegistrarHuellaMutation, RegistrarHuellaMutationVariables>(
        RegistrarHuellaDocument,
        options
    )
}
export type RegistrarHuellaMutationHookResult = ReturnType<typeof useRegistrarHuellaMutation>
export type RegistrarHuellaMutationResult = Apollo.MutationResult<RegistrarHuellaMutation>
export type RegistrarHuellaMutationOptions = Apollo.BaseMutationOptions<
    RegistrarHuellaMutation,
    RegistrarHuellaMutationVariables
>
export const GetConfigPagoPropinasDocument = gql`
    query getConfigPagoPropinas {
        puestos(eliminado: false, estado: "ACTIVO", esquema_propinas_activo: true) {
            puesto_id
            nombre
            porcentaje_propina
            area {
                nombre
            }
        }
    }
`
export type GetConfigPagoPropinasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetConfigPagoPropinasQuery, GetConfigPagoPropinasQueryVariables>,
    "query"
>

export const GetConfigPagoPropinasComponent = (props: GetConfigPagoPropinasComponentProps) => (
    <ApolloReactComponents.Query<GetConfigPagoPropinasQuery, GetConfigPagoPropinasQueryVariables>
        query={GetConfigPagoPropinasDocument}
        {...props}
    />
)

/**
 * __useGetConfigPagoPropinasQuery__
 *
 * To run a query within a React component, call `useGetConfigPagoPropinasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigPagoPropinasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigPagoPropinasQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConfigPagoPropinasQuery(
    baseOptions?: Apollo.QueryHookOptions<GetConfigPagoPropinasQuery, GetConfigPagoPropinasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetConfigPagoPropinasQuery, GetConfigPagoPropinasQueryVariables>(
        GetConfigPagoPropinasDocument,
        options
    )
}
export function useGetConfigPagoPropinasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetConfigPagoPropinasQuery, GetConfigPagoPropinasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetConfigPagoPropinasQuery, GetConfigPagoPropinasQueryVariables>(
        GetConfigPagoPropinasDocument,
        options
    )
}
export type GetConfigPagoPropinasQueryHookResult = ReturnType<typeof useGetConfigPagoPropinasQuery>
export type GetConfigPagoPropinasLazyQueryHookResult = ReturnType<typeof useGetConfigPagoPropinasLazyQuery>
export type GetConfigPagoPropinasQueryResult = Apollo.QueryResult<
    GetConfigPagoPropinasQuery,
    GetConfigPagoPropinasQueryVariables
>
export const GetPuestosPropinasDocument = gql`
    query getPuestosPropinas {
        puestos(eliminado: false, estado: "ACTIVO") {
            nombre
            porcentaje_propina
            puesto_id
        }
    }
`
export type GetPuestosPropinasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetPuestosPropinasQuery, GetPuestosPropinasQueryVariables>,
    "query"
>

export const GetPuestosPropinasComponent = (props: GetPuestosPropinasComponentProps) => (
    <ApolloReactComponents.Query<GetPuestosPropinasQuery, GetPuestosPropinasQueryVariables>
        query={GetPuestosPropinasDocument}
        {...props}
    />
)

/**
 * __useGetPuestosPropinasQuery__
 *
 * To run a query within a React component, call `useGetPuestosPropinasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPuestosPropinasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPuestosPropinasQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPuestosPropinasQuery(
    baseOptions?: Apollo.QueryHookOptions<GetPuestosPropinasQuery, GetPuestosPropinasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetPuestosPropinasQuery, GetPuestosPropinasQueryVariables>(
        GetPuestosPropinasDocument,
        options
    )
}
export function useGetPuestosPropinasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetPuestosPropinasQuery, GetPuestosPropinasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetPuestosPropinasQuery, GetPuestosPropinasQueryVariables>(
        GetPuestosPropinasDocument,
        options
    )
}
export type GetPuestosPropinasQueryHookResult = ReturnType<typeof useGetPuestosPropinasQuery>
export type GetPuestosPropinasLazyQueryHookResult = ReturnType<typeof useGetPuestosPropinasLazyQuery>
export type GetPuestosPropinasQueryResult = Apollo.QueryResult<
    GetPuestosPropinasQuery,
    GetPuestosPropinasQueryVariables
>
export const ModificarEsquemaPropinasDocument = gql`
    mutation modificarEsquemaPropinas($propinas_esquema: [PropinaEsquemaItemInput!]!) {
        modificar_esquema_propinas(propinas_esquema: { propinas_esquema: $propinas_esquema }) {
            descripcion
            eliminado
            estado
            nombre
            porcentaje_propina
            puesto_id
        }
    }
`
export type ModificarEsquemaPropinasMutationFn = Apollo.MutationFunction<
    ModificarEsquemaPropinasMutation,
    ModificarEsquemaPropinasMutationVariables
>
export type ModificarEsquemaPropinasComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        ModificarEsquemaPropinasMutation,
        ModificarEsquemaPropinasMutationVariables
    >,
    "mutation"
>

export const ModificarEsquemaPropinasComponent = (props: ModificarEsquemaPropinasComponentProps) => (
    <ApolloReactComponents.Mutation<ModificarEsquemaPropinasMutation, ModificarEsquemaPropinasMutationVariables>
        mutation={ModificarEsquemaPropinasDocument}
        {...props}
    />
)

/**
 * __useModificarEsquemaPropinasMutation__
 *
 * To run a mutation, you first call `useModificarEsquemaPropinasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModificarEsquemaPropinasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modificarEsquemaPropinasMutation, { data, loading, error }] = useModificarEsquemaPropinasMutation({
 *   variables: {
 *      propinas_esquema: // value for 'propinas_esquema'
 *   },
 * });
 */
export function useModificarEsquemaPropinasMutation(
    baseOptions?: Apollo.MutationHookOptions<
        ModificarEsquemaPropinasMutation,
        ModificarEsquemaPropinasMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ModificarEsquemaPropinasMutation, ModificarEsquemaPropinasMutationVariables>(
        ModificarEsquemaPropinasDocument,
        options
    )
}
export type ModificarEsquemaPropinasMutationHookResult = ReturnType<typeof useModificarEsquemaPropinasMutation>
export type ModificarEsquemaPropinasMutationResult = Apollo.MutationResult<ModificarEsquemaPropinasMutation>
export type ModificarEsquemaPropinasMutationOptions = Apollo.BaseMutationOptions<
    ModificarEsquemaPropinasMutation,
    ModificarEsquemaPropinasMutationVariables
>
export const GetCategoriasArticulosPropinasDocument = gql`
    query GetCategoriasArticulosPropinas($hotel_id: ID) {
        categorias_articulos(eliminado: false, hotel_id: $hotel_id) {
            categoria_id
            nombre
            porcentaje_aportacion_propinas
        }
    }
`
export type GetCategoriasArticulosPropinasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetCategoriasArticulosPropinasQuery,
        GetCategoriasArticulosPropinasQueryVariables
    >,
    "query"
>

export const GetCategoriasArticulosPropinasComponent = (props: GetCategoriasArticulosPropinasComponentProps) => (
    <ApolloReactComponents.Query<GetCategoriasArticulosPropinasQuery, GetCategoriasArticulosPropinasQueryVariables>
        query={GetCategoriasArticulosPropinasDocument}
        {...props}
    />
)

/**
 * __useGetCategoriasArticulosPropinasQuery__
 *
 * To run a query within a React component, call `useGetCategoriasArticulosPropinasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriasArticulosPropinasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriasArticulosPropinasQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetCategoriasArticulosPropinasQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetCategoriasArticulosPropinasQuery,
        GetCategoriasArticulosPropinasQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetCategoriasArticulosPropinasQuery, GetCategoriasArticulosPropinasQueryVariables>(
        GetCategoriasArticulosPropinasDocument,
        options
    )
}
export function useGetCategoriasArticulosPropinasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetCategoriasArticulosPropinasQuery,
        GetCategoriasArticulosPropinasQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetCategoriasArticulosPropinasQuery, GetCategoriasArticulosPropinasQueryVariables>(
        GetCategoriasArticulosPropinasDocument,
        options
    )
}
export type GetCategoriasArticulosPropinasQueryHookResult = ReturnType<typeof useGetCategoriasArticulosPropinasQuery>
export type GetCategoriasArticulosPropinasLazyQueryHookResult = ReturnType<
    typeof useGetCategoriasArticulosPropinasLazyQuery
>
export type GetCategoriasArticulosPropinasQueryResult = Apollo.QueryResult<
    GetCategoriasArticulosPropinasQuery,
    GetCategoriasArticulosPropinasQueryVariables
>
export const GetConfiguracionesPropinaDocument = gql`
    query GetConfiguracionesPropina($hotel_id: ID) {
        configuraciones_propina(hotel_id: $hotel_id) {
            configuracion_propina_id
            fecha_registro
            porcentaje_venta_efectivo
            porcentaje_venta_tarjeta
            porcentaje_aportacion_vendedores
            porcentaje_comision_por_puntos
            paga_propina_en_turno
        }
    }
`
export type GetConfiguracionesPropinaComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetConfiguracionesPropinaQuery,
        GetConfiguracionesPropinaQueryVariables
    >,
    "query"
>

export const GetConfiguracionesPropinaComponent = (props: GetConfiguracionesPropinaComponentProps) => (
    <ApolloReactComponents.Query<GetConfiguracionesPropinaQuery, GetConfiguracionesPropinaQueryVariables>
        query={GetConfiguracionesPropinaDocument}
        {...props}
    />
)

/**
 * __useGetConfiguracionesPropinaQuery__
 *
 * To run a query within a React component, call `useGetConfiguracionesPropinaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfiguracionesPropinaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfiguracionesPropinaQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetConfiguracionesPropinaQuery(
    baseOptions?: Apollo.QueryHookOptions<GetConfiguracionesPropinaQuery, GetConfiguracionesPropinaQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetConfiguracionesPropinaQuery, GetConfiguracionesPropinaQueryVariables>(
        GetConfiguracionesPropinaDocument,
        options
    )
}
export function useGetConfiguracionesPropinaLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetConfiguracionesPropinaQuery, GetConfiguracionesPropinaQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetConfiguracionesPropinaQuery, GetConfiguracionesPropinaQueryVariables>(
        GetConfiguracionesPropinaDocument,
        options
    )
}
export type GetConfiguracionesPropinaQueryHookResult = ReturnType<typeof useGetConfiguracionesPropinaQuery>
export type GetConfiguracionesPropinaLazyQueryHookResult = ReturnType<typeof useGetConfiguracionesPropinaLazyQuery>
export type GetConfiguracionesPropinaQueryResult = Apollo.QueryResult<
    GetConfiguracionesPropinaQuery,
    GetConfiguracionesPropinaQueryVariables
>
export const ActualizarConfiguracionPropinaDocument = gql`
    mutation ActualizarConfiguracionPropina($UpdateConfiguracionPropinaInput: UpdateConfiguracionPropinaInput!) {
        actualizar_configuracion_propina(UpdateConfiguracionPropinaInput: $UpdateConfiguracionPropinaInput) {
            configuracion_propina_id
        }
    }
`
export type ActualizarConfiguracionPropinaMutationFn = Apollo.MutationFunction<
    ActualizarConfiguracionPropinaMutation,
    ActualizarConfiguracionPropinaMutationVariables
>
export type ActualizarConfiguracionPropinaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        ActualizarConfiguracionPropinaMutation,
        ActualizarConfiguracionPropinaMutationVariables
    >,
    "mutation"
>

export const ActualizarConfiguracionPropinaComponent = (props: ActualizarConfiguracionPropinaComponentProps) => (
    <ApolloReactComponents.Mutation<
        ActualizarConfiguracionPropinaMutation,
        ActualizarConfiguracionPropinaMutationVariables
    >
        mutation={ActualizarConfiguracionPropinaDocument}
        {...props}
    />
)

/**
 * __useActualizarConfiguracionPropinaMutation__
 *
 * To run a mutation, you first call `useActualizarConfiguracionPropinaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizarConfiguracionPropinaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizarConfiguracionPropinaMutation, { data, loading, error }] = useActualizarConfiguracionPropinaMutation({
 *   variables: {
 *      UpdateConfiguracionPropinaInput: // value for 'UpdateConfiguracionPropinaInput'
 *   },
 * });
 */
export function useActualizarConfiguracionPropinaMutation(
    baseOptions?: Apollo.MutationHookOptions<
        ActualizarConfiguracionPropinaMutation,
        ActualizarConfiguracionPropinaMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ActualizarConfiguracionPropinaMutation, ActualizarConfiguracionPropinaMutationVariables>(
        ActualizarConfiguracionPropinaDocument,
        options
    )
}
export type ActualizarConfiguracionPropinaMutationHookResult = ReturnType<
    typeof useActualizarConfiguracionPropinaMutation
>
export type ActualizarConfiguracionPropinaMutationResult = Apollo.MutationResult<ActualizarConfiguracionPropinaMutation>
export type ActualizarConfiguracionPropinaMutationOptions = Apollo.BaseMutationOptions<
    ActualizarConfiguracionPropinaMutation,
    ActualizarConfiguracionPropinaMutationVariables
>
export const ActualizarAportacionesPropinasPorCategoriaDocument = gql`
    mutation ActualizarAportacionesPropinasPorCategoria($aportaciones_roomservice: UpdateAportacionesPropinasRsInput!) {
        actualizar_aportaciones_propinas_por_categoria(aportaciones_roomservice: $aportaciones_roomservice) {
            categoria_id
        }
    }
`
export type ActualizarAportacionesPropinasPorCategoriaMutationFn = Apollo.MutationFunction<
    ActualizarAportacionesPropinasPorCategoriaMutation,
    ActualizarAportacionesPropinasPorCategoriaMutationVariables
>
export type ActualizarAportacionesPropinasPorCategoriaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        ActualizarAportacionesPropinasPorCategoriaMutation,
        ActualizarAportacionesPropinasPorCategoriaMutationVariables
    >,
    "mutation"
>

export const ActualizarAportacionesPropinasPorCategoriaComponent = (
    props: ActualizarAportacionesPropinasPorCategoriaComponentProps
) => (
    <ApolloReactComponents.Mutation<
        ActualizarAportacionesPropinasPorCategoriaMutation,
        ActualizarAportacionesPropinasPorCategoriaMutationVariables
    >
        mutation={ActualizarAportacionesPropinasPorCategoriaDocument}
        {...props}
    />
)

/**
 * __useActualizarAportacionesPropinasPorCategoriaMutation__
 *
 * To run a mutation, you first call `useActualizarAportacionesPropinasPorCategoriaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizarAportacionesPropinasPorCategoriaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizarAportacionesPropinasPorCategoriaMutation, { data, loading, error }] = useActualizarAportacionesPropinasPorCategoriaMutation({
 *   variables: {
 *      aportaciones_roomservice: // value for 'aportaciones_roomservice'
 *   },
 * });
 */
export function useActualizarAportacionesPropinasPorCategoriaMutation(
    baseOptions?: Apollo.MutationHookOptions<
        ActualizarAportacionesPropinasPorCategoriaMutation,
        ActualizarAportacionesPropinasPorCategoriaMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        ActualizarAportacionesPropinasPorCategoriaMutation,
        ActualizarAportacionesPropinasPorCategoriaMutationVariables
    >(ActualizarAportacionesPropinasPorCategoriaDocument, options)
}
export type ActualizarAportacionesPropinasPorCategoriaMutationHookResult = ReturnType<
    typeof useActualizarAportacionesPropinasPorCategoriaMutation
>
export type ActualizarAportacionesPropinasPorCategoriaMutationResult =
    Apollo.MutationResult<ActualizarAportacionesPropinasPorCategoriaMutation>
export type ActualizarAportacionesPropinasPorCategoriaMutationOptions = Apollo.BaseMutationOptions<
    ActualizarAportacionesPropinasPorCategoriaMutation,
    ActualizarAportacionesPropinasPorCategoriaMutationVariables
>
export const Pagos_PropinasDocument = gql`
    query Pagos_propinas($pago_propinas_input: MonthSearchInput!, $hotel_id: ID!) {
        pagos_propinas(fecha_registro: $pago_propinas_input, hotel_id: $hotel_id) {
            asignacion_propina_id
            asignacion_propina {
                monto_pagado: fondo_propina_a_repartir
            }
            fecha_registro
            folio
            hotel_id
            pago_propina_id
            periodo_pago
            personal {
                colaborador_id
                apellido_materno
                apellido_paterno
                nombre
                area {
                    nombre
                }
                puesto {
                    nombre
                }
            }
        }
    }
`
export type Pagos_PropinasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<Pagos_PropinasQuery, Pagos_PropinasQueryVariables>,
    "query"
> &
    ({ variables: Pagos_PropinasQueryVariables; skip?: boolean } | { skip: boolean })

export const Pagos_PropinasComponent = (props: Pagos_PropinasComponentProps) => (
    <ApolloReactComponents.Query<Pagos_PropinasQuery, Pagos_PropinasQueryVariables>
        query={Pagos_PropinasDocument}
        {...props}
    />
)

/**
 * __usePagos_PropinasQuery__
 *
 * To run a query within a React component, call `usePagos_PropinasQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagos_PropinasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagos_PropinasQuery({
 *   variables: {
 *      pago_propinas_input: // value for 'pago_propinas_input'
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function usePagos_PropinasQuery(
    baseOptions: Apollo.QueryHookOptions<Pagos_PropinasQuery, Pagos_PropinasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<Pagos_PropinasQuery, Pagos_PropinasQueryVariables>(Pagos_PropinasDocument, options)
}
export function usePagos_PropinasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<Pagos_PropinasQuery, Pagos_PropinasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<Pagos_PropinasQuery, Pagos_PropinasQueryVariables>(Pagos_PropinasDocument, options)
}
export type Pagos_PropinasQueryHookResult = ReturnType<typeof usePagos_PropinasQuery>
export type Pagos_PropinasLazyQueryHookResult = ReturnType<typeof usePagos_PropinasLazyQuery>
export type Pagos_PropinasQueryResult = Apollo.QueryResult<Pagos_PropinasQuery, Pagos_PropinasQueryVariables>
export const AjustarAsignacionPropinaDocument = gql`
    mutation AjustarAsignacionPropina($ajustarAsignacionPropinaInput: AjustarAsignacionPropinaInput!) {
        ajustar_asignacion_propina(ajustarAsignacionPropinaInput: $ajustarAsignacionPropinaInput) {
            limite_disponible
            monto_recaudado
            propinas_ajustadas {
                asignacion_propina_id
                asignacion_propina {
                    monto_ajuste: penalizacion
                    remanente_por_ajuste
                    ingreso_hotel
                    fondo_original
                }
                colaborador {
                    colaborador_id
                    nombre
                    apellido_materno
                    apellido_paterno
                    foto
                    puesto {
                        puesto_id
                        nombre
                    }
                }
                propina_por_ventas
                fondo_de_propinas
                comision_bancaria_sobre_fondo
                pago_correspondiente
            }
        }
    }
`
export type AjustarAsignacionPropinaMutationFn = Apollo.MutationFunction<
    AjustarAsignacionPropinaMutation,
    AjustarAsignacionPropinaMutationVariables
>
export type AjustarAsignacionPropinaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        AjustarAsignacionPropinaMutation,
        AjustarAsignacionPropinaMutationVariables
    >,
    "mutation"
>

export const AjustarAsignacionPropinaComponent = (props: AjustarAsignacionPropinaComponentProps) => (
    <ApolloReactComponents.Mutation<AjustarAsignacionPropinaMutation, AjustarAsignacionPropinaMutationVariables>
        mutation={AjustarAsignacionPropinaDocument}
        {...props}
    />
)

/**
 * __useAjustarAsignacionPropinaMutation__
 *
 * To run a mutation, you first call `useAjustarAsignacionPropinaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAjustarAsignacionPropinaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ajustarAsignacionPropinaMutation, { data, loading, error }] = useAjustarAsignacionPropinaMutation({
 *   variables: {
 *      ajustarAsignacionPropinaInput: // value for 'ajustarAsignacionPropinaInput'
 *   },
 * });
 */
export function useAjustarAsignacionPropinaMutation(
    baseOptions?: Apollo.MutationHookOptions<
        AjustarAsignacionPropinaMutation,
        AjustarAsignacionPropinaMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<AjustarAsignacionPropinaMutation, AjustarAsignacionPropinaMutationVariables>(
        AjustarAsignacionPropinaDocument,
        options
    )
}
export type AjustarAsignacionPropinaMutationHookResult = ReturnType<typeof useAjustarAsignacionPropinaMutation>
export type AjustarAsignacionPropinaMutationResult = Apollo.MutationResult<AjustarAsignacionPropinaMutation>
export type AjustarAsignacionPropinaMutationOptions = Apollo.BaseMutationOptions<
    AjustarAsignacionPropinaMutation,
    AjustarAsignacionPropinaMutationVariables
>
export const Detalle_Reparto_PropinasDocument = gql`
    query Detalle_reparto_propinas($hotel_id: ID!) {
        detalle_reparto_propinas(hotel_id: $hotel_id) {
            monto_recaudado
            detalle_reparto_propinas {
                colaborador {
                    colaborador_id
                    nombre
                    apellido_materno
                    apellido_paterno
                    puesto {
                        nombre
                    }
                }
                desglose_propina_recolectada {
                    categoria
                    monto
                }
                desglose_aportacion_a_fondo {
                    categoria
                    monto
                    aportacion
                }
                propina_recolectada
                comision_bancaria_propina_por_venta
                aportacion_a_fondo
                subtotal_propina_por_ventas
                neto_propina_por_ventas
                fondo_de_propina
                comision_bancaria_sobre_fondo
                pago_correspondiente
            }
            totales {
                total_propinas_recolectadas
                total_aportaciones_a_fondo
                total_subtotales_propina_por_ventas
                total_comisiones_bancarias_propinas_por_ventas
                total_neto_propinas_por_ventas
                total_fondos_de_propina
                total_comisiones_bancarias_sobre_fondo
                total_pagos_correspondientes
            }
        }
    }
`
export type Detalle_Reparto_PropinasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<Detalle_Reparto_PropinasQuery, Detalle_Reparto_PropinasQueryVariables>,
    "query"
> &
    ({ variables: Detalle_Reparto_PropinasQueryVariables; skip?: boolean } | { skip: boolean })

export const Detalle_Reparto_PropinasComponent = (props: Detalle_Reparto_PropinasComponentProps) => (
    <ApolloReactComponents.Query<Detalle_Reparto_PropinasQuery, Detalle_Reparto_PropinasQueryVariables>
        query={Detalle_Reparto_PropinasDocument}
        {...props}
    />
)

/**
 * __useDetalle_Reparto_PropinasQuery__
 *
 * To run a query within a React component, call `useDetalle_Reparto_PropinasQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetalle_Reparto_PropinasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetalle_Reparto_PropinasQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useDetalle_Reparto_PropinasQuery(
    baseOptions: Apollo.QueryHookOptions<Detalle_Reparto_PropinasQuery, Detalle_Reparto_PropinasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<Detalle_Reparto_PropinasQuery, Detalle_Reparto_PropinasQueryVariables>(
        Detalle_Reparto_PropinasDocument,
        options
    )
}
export function useDetalle_Reparto_PropinasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<Detalle_Reparto_PropinasQuery, Detalle_Reparto_PropinasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<Detalle_Reparto_PropinasQuery, Detalle_Reparto_PropinasQueryVariables>(
        Detalle_Reparto_PropinasDocument,
        options
    )
}
export type Detalle_Reparto_PropinasQueryHookResult = ReturnType<typeof useDetalle_Reparto_PropinasQuery>
export type Detalle_Reparto_PropinasLazyQueryHookResult = ReturnType<typeof useDetalle_Reparto_PropinasLazyQuery>
export type Detalle_Reparto_PropinasQueryResult = Apollo.QueryResult<
    Detalle_Reparto_PropinasQuery,
    Detalle_Reparto_PropinasQueryVariables
>
export const Pagar_PropinasDocument = gql`
    mutation Pagar_propinas($pagar_propinas_input: CreateManyPagosPropinasInput!) {
        pagar_propinas(pagos_propinas: $pagar_propinas_input) {
            asignacion_propina_id
            asignacion_propina {
                monto_pagado: fondo_propina_a_repartir
            }
            fecha_registro
            folio
            hotel_id
            pago_propina_id
            periodo_pago
            personal {
                colaborador_id
                apellido_materno
                apellido_paterno
                nombre
                area {
                    nombre
                }
                puesto {
                    nombre
                }
            }
        }
    }
`
export type Pagar_PropinasMutationFn = Apollo.MutationFunction<Pagar_PropinasMutation, Pagar_PropinasMutationVariables>
export type Pagar_PropinasComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<Pagar_PropinasMutation, Pagar_PropinasMutationVariables>,
    "mutation"
>

export const Pagar_PropinasComponent = (props: Pagar_PropinasComponentProps) => (
    <ApolloReactComponents.Mutation<Pagar_PropinasMutation, Pagar_PropinasMutationVariables>
        mutation={Pagar_PropinasDocument}
        {...props}
    />
)

/**
 * __usePagar_PropinasMutation__
 *
 * To run a mutation, you first call `usePagar_PropinasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePagar_PropinasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pagarPropinasMutation, { data, loading, error }] = usePagar_PropinasMutation({
 *   variables: {
 *      pagar_propinas_input: // value for 'pagar_propinas_input'
 *   },
 * });
 */
export function usePagar_PropinasMutation(
    baseOptions?: Apollo.MutationHookOptions<Pagar_PropinasMutation, Pagar_PropinasMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<Pagar_PropinasMutation, Pagar_PropinasMutationVariables>(Pagar_PropinasDocument, options)
}
export type Pagar_PropinasMutationHookResult = ReturnType<typeof usePagar_PropinasMutation>
export type Pagar_PropinasMutationResult = Apollo.MutationResult<Pagar_PropinasMutation>
export type Pagar_PropinasMutationOptions = Apollo.BaseMutationOptions<
    Pagar_PropinasMutation,
    Pagar_PropinasMutationVariables
>
export const Calcular_Pagos_PropinasDocument = gql`
    query Calcular_pagos_propinas($hotel_id: ID!) {
        calcular_reparto_propinas(hotel_id: $hotel_id) {
            limite_disponible
            monto_recaudado
            reparto_propinas {
                asignacion_propina_id
                asignacion_propina {
                    monto_ajuste: penalizacion
                    remanente_por_ajuste
                    ingreso_hotel
                    fondo_original
                }
                colaborador {
                    colaborador_id
                    nombre
                    apellido_materno
                    apellido_paterno
                    foto
                    puesto {
                        puesto_id
                        nombre
                    }
                }
                propina_por_ventas
                fondo_de_propinas
                comision_bancaria_sobre_fondo
                pago_correspondiente
            }
        }
    }
`
export type Calcular_Pagos_PropinasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<Calcular_Pagos_PropinasQuery, Calcular_Pagos_PropinasQueryVariables>,
    "query"
> &
    ({ variables: Calcular_Pagos_PropinasQueryVariables; skip?: boolean } | { skip: boolean })

export const Calcular_Pagos_PropinasComponent = (props: Calcular_Pagos_PropinasComponentProps) => (
    <ApolloReactComponents.Query<Calcular_Pagos_PropinasQuery, Calcular_Pagos_PropinasQueryVariables>
        query={Calcular_Pagos_PropinasDocument}
        {...props}
    />
)

/**
 * __useCalcular_Pagos_PropinasQuery__
 *
 * To run a query within a React component, call `useCalcular_Pagos_PropinasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalcular_Pagos_PropinasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalcular_Pagos_PropinasQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useCalcular_Pagos_PropinasQuery(
    baseOptions: Apollo.QueryHookOptions<Calcular_Pagos_PropinasQuery, Calcular_Pagos_PropinasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<Calcular_Pagos_PropinasQuery, Calcular_Pagos_PropinasQueryVariables>(
        Calcular_Pagos_PropinasDocument,
        options
    )
}
export function useCalcular_Pagos_PropinasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<Calcular_Pagos_PropinasQuery, Calcular_Pagos_PropinasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<Calcular_Pagos_PropinasQuery, Calcular_Pagos_PropinasQueryVariables>(
        Calcular_Pagos_PropinasDocument,
        options
    )
}
export type Calcular_Pagos_PropinasQueryHookResult = ReturnType<typeof useCalcular_Pagos_PropinasQuery>
export type Calcular_Pagos_PropinasLazyQueryHookResult = ReturnType<typeof useCalcular_Pagos_PropinasLazyQuery>
export type Calcular_Pagos_PropinasQueryResult = Apollo.QueryResult<
    Calcular_Pagos_PropinasQuery,
    Calcular_Pagos_PropinasQueryVariables
>
export const ReiniciarAsignacionesPropinasDocument = gql`
    mutation ReiniciarAsignacionesPropinas($hotel_id: ID!) {
        reiniciar_asignaciones_propinas(hotel_id: $hotel_id)
    }
`
export type ReiniciarAsignacionesPropinasMutationFn = Apollo.MutationFunction<
    ReiniciarAsignacionesPropinasMutation,
    ReiniciarAsignacionesPropinasMutationVariables
>
export type ReiniciarAsignacionesPropinasComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        ReiniciarAsignacionesPropinasMutation,
        ReiniciarAsignacionesPropinasMutationVariables
    >,
    "mutation"
>

export const ReiniciarAsignacionesPropinasComponent = (props: ReiniciarAsignacionesPropinasComponentProps) => (
    <ApolloReactComponents.Mutation<
        ReiniciarAsignacionesPropinasMutation,
        ReiniciarAsignacionesPropinasMutationVariables
    >
        mutation={ReiniciarAsignacionesPropinasDocument}
        {...props}
    />
)

/**
 * __useReiniciarAsignacionesPropinasMutation__
 *
 * To run a mutation, you first call `useReiniciarAsignacionesPropinasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReiniciarAsignacionesPropinasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reiniciarAsignacionesPropinasMutation, { data, loading, error }] = useReiniciarAsignacionesPropinasMutation({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useReiniciarAsignacionesPropinasMutation(
    baseOptions?: Apollo.MutationHookOptions<
        ReiniciarAsignacionesPropinasMutation,
        ReiniciarAsignacionesPropinasMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ReiniciarAsignacionesPropinasMutation, ReiniciarAsignacionesPropinasMutationVariables>(
        ReiniciarAsignacionesPropinasDocument,
        options
    )
}
export type ReiniciarAsignacionesPropinasMutationHookResult = ReturnType<
    typeof useReiniciarAsignacionesPropinasMutation
>
export type ReiniciarAsignacionesPropinasMutationResult = Apollo.MutationResult<ReiniciarAsignacionesPropinasMutation>
export type ReiniciarAsignacionesPropinasMutationOptions = Apollo.BaseMutationOptions<
    ReiniciarAsignacionesPropinasMutation,
    ReiniciarAsignacionesPropinasMutationVariables
>
export const ReportePropinasDocument = gql`
    query ReportePropinas($hotel_id: ID!) {
        reporte_propinas(hotel_id: $hotel_id) {
            reporte_propinas {
                puesto_id
                puesto {
                    nombre
                }
                reporte_colaboradores {
                    colaborador_id
                    colaborador {
                        nombre
                        apellido_paterno
                        apellido_materno
                    }
                    ventas_por_categoria {
                        categoria
                        monto
                    }
                    propinas_tarjetas_por_venta_rs
                    puntos_a_pagar
                    comision_bancaria_tarjeta
                    total_a_repartir
                }
            }
        }
    }
`
export type ReportePropinasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<ReportePropinasQuery, ReportePropinasQueryVariables>,
    "query"
> &
    ({ variables: ReportePropinasQueryVariables; skip?: boolean } | { skip: boolean })

export const ReportePropinasComponent = (props: ReportePropinasComponentProps) => (
    <ApolloReactComponents.Query<ReportePropinasQuery, ReportePropinasQueryVariables>
        query={ReportePropinasDocument}
        {...props}
    />
)

/**
 * __useReportePropinasQuery__
 *
 * To run a query within a React component, call `useReportePropinasQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportePropinasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportePropinasQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useReportePropinasQuery(
    baseOptions: Apollo.QueryHookOptions<ReportePropinasQuery, ReportePropinasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<ReportePropinasQuery, ReportePropinasQueryVariables>(ReportePropinasDocument, options)
}
export function useReportePropinasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ReportePropinasQuery, ReportePropinasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<ReportePropinasQuery, ReportePropinasQueryVariables>(ReportePropinasDocument, options)
}
export type ReportePropinasQueryHookResult = ReturnType<typeof useReportePropinasQuery>
export type ReportePropinasLazyQueryHookResult = ReturnType<typeof useReportePropinasLazyQuery>
export type ReportePropinasQueryResult = Apollo.QueryResult<ReportePropinasQuery, ReportePropinasQueryVariables>
export const ConsultarReportePropinasVentasDocument = gql`
    query ConsultarReportePropinasVentas($reporte_propina_venta_id: ID, $corte_id: ID) {
        consultar_reporte_propinas(reporte_propina_venta_id: $reporte_propina_venta_id, corte_id: $corte_id) {
            reporte_propinas {
                puesto_id
                puesto {
                    nombre
                }
                reporte_colaboradores {
                    colaborador_id
                    colaborador {
                        nombre
                        apellido_paterno
                        apellido_materno
                    }
                    ventas_por_categoria {
                        categoria
                        monto
                    }
                    propinas_tarjetas_por_venta_rs
                    puntos_a_pagar
                    comision_bancaria_tarjeta
                    total_a_repartir
                }
            }
        }
    }
`
export type ConsultarReportePropinasVentasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        ConsultarReportePropinasVentasQuery,
        ConsultarReportePropinasVentasQueryVariables
    >,
    "query"
>

export const ConsultarReportePropinasVentasComponent = (props: ConsultarReportePropinasVentasComponentProps) => (
    <ApolloReactComponents.Query<ConsultarReportePropinasVentasQuery, ConsultarReportePropinasVentasQueryVariables>
        query={ConsultarReportePropinasVentasDocument}
        {...props}
    />
)

/**
 * __useConsultarReportePropinasVentasQuery__
 *
 * To run a query within a React component, call `useConsultarReportePropinasVentasQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultarReportePropinasVentasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultarReportePropinasVentasQuery({
 *   variables: {
 *      reporte_propina_venta_id: // value for 'reporte_propina_venta_id'
 *      corte_id: // value for 'corte_id'
 *   },
 * });
 */
export function useConsultarReportePropinasVentasQuery(
    baseOptions?: Apollo.QueryHookOptions<
        ConsultarReportePropinasVentasQuery,
        ConsultarReportePropinasVentasQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<ConsultarReportePropinasVentasQuery, ConsultarReportePropinasVentasQueryVariables>(
        ConsultarReportePropinasVentasDocument,
        options
    )
}
export function useConsultarReportePropinasVentasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ConsultarReportePropinasVentasQuery,
        ConsultarReportePropinasVentasQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<ConsultarReportePropinasVentasQuery, ConsultarReportePropinasVentasQueryVariables>(
        ConsultarReportePropinasVentasDocument,
        options
    )
}
export type ConsultarReportePropinasVentasQueryHookResult = ReturnType<typeof useConsultarReportePropinasVentasQuery>
export type ConsultarReportePropinasVentasLazyQueryHookResult = ReturnType<
    typeof useConsultarReportePropinasVentasLazyQuery
>
export type ConsultarReportePropinasVentasQueryResult = Apollo.QueryResult<
    ConsultarReportePropinasVentasQuery,
    ConsultarReportePropinasVentasQueryVariables
>
export const PagarPropinasVentasDocument = gql`
    mutation PagarPropinasVentas($payPropinasVentasInput: PayPropinasVentasInput!) {
        pagar_propinas_ventas(payPropinasVentasInput: $payPropinasVentasInput) {
            reporte_propina_venta_id
        }
    }
`
export type PagarPropinasVentasMutationFn = Apollo.MutationFunction<
    PagarPropinasVentasMutation,
    PagarPropinasVentasMutationVariables
>
export type PagarPropinasVentasComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<PagarPropinasVentasMutation, PagarPropinasVentasMutationVariables>,
    "mutation"
>

export const PagarPropinasVentasComponent = (props: PagarPropinasVentasComponentProps) => (
    <ApolloReactComponents.Mutation<PagarPropinasVentasMutation, PagarPropinasVentasMutationVariables>
        mutation={PagarPropinasVentasDocument}
        {...props}
    />
)

/**
 * __usePagarPropinasVentasMutation__
 *
 * To run a mutation, you first call `usePagarPropinasVentasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePagarPropinasVentasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pagarPropinasVentasMutation, { data, loading, error }] = usePagarPropinasVentasMutation({
 *   variables: {
 *      payPropinasVentasInput: // value for 'payPropinasVentasInput'
 *   },
 * });
 */
export function usePagarPropinasVentasMutation(
    baseOptions?: Apollo.MutationHookOptions<PagarPropinasVentasMutation, PagarPropinasVentasMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<PagarPropinasVentasMutation, PagarPropinasVentasMutationVariables>(
        PagarPropinasVentasDocument,
        options
    )
}
export type PagarPropinasVentasMutationHookResult = ReturnType<typeof usePagarPropinasVentasMutation>
export type PagarPropinasVentasMutationResult = Apollo.MutationResult<PagarPropinasVentasMutation>
export type PagarPropinasVentasMutationOptions = Apollo.BaseMutationOptions<
    PagarPropinasVentasMutation,
    PagarPropinasVentasMutationVariables
>
export const AreasForReportDocument = gql`
    query AreasForReport($hotel_id: ID!) {
        areas(hotel_id: $hotel_id, eliminado: false) {
            area_id
            nombre
        }
    }
`
export type AreasForReportComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<AreasForReportQuery, AreasForReportQueryVariables>,
    "query"
> &
    ({ variables: AreasForReportQueryVariables; skip?: boolean } | { skip: boolean })

export const AreasForReportComponent = (props: AreasForReportComponentProps) => (
    <ApolloReactComponents.Query<AreasForReportQuery, AreasForReportQueryVariables>
        query={AreasForReportDocument}
        {...props}
    />
)

/**
 * __useAreasForReportQuery__
 *
 * To run a query within a React component, call `useAreasForReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useAreasForReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAreasForReportQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useAreasForReportQuery(
    baseOptions: Apollo.QueryHookOptions<AreasForReportQuery, AreasForReportQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<AreasForReportQuery, AreasForReportQueryVariables>(AreasForReportDocument, options)
}
export function useAreasForReportLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<AreasForReportQuery, AreasForReportQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<AreasForReportQuery, AreasForReportQueryVariables>(AreasForReportDocument, options)
}
export type AreasForReportQueryHookResult = ReturnType<typeof useAreasForReportQuery>
export type AreasForReportLazyQueryHookResult = ReturnType<typeof useAreasForReportLazyQuery>
export type AreasForReportQueryResult = Apollo.QueryResult<AreasForReportQuery, AreasForReportQueryVariables>
export const CategoriasArticulosForReportDocument = gql`
    query categoriasArticulosForReport($hotel_id: ID!) {
        categorias_articulos(hotel_id: $hotel_id) {
            categoria_id
            nombre
        }
    }
`
export type CategoriasArticulosForReportComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        CategoriasArticulosForReportQuery,
        CategoriasArticulosForReportQueryVariables
    >,
    "query"
> &
    ({ variables: CategoriasArticulosForReportQueryVariables; skip?: boolean } | { skip: boolean })

export const CategoriasArticulosForReportComponent = (props: CategoriasArticulosForReportComponentProps) => (
    <ApolloReactComponents.Query<CategoriasArticulosForReportQuery, CategoriasArticulosForReportQueryVariables>
        query={CategoriasArticulosForReportDocument}
        {...props}
    />
)

/**
 * __useCategoriasArticulosForReportQuery__
 *
 * To run a query within a React component, call `useCategoriasArticulosForReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriasArticulosForReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriasArticulosForReportQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useCategoriasArticulosForReportQuery(
    baseOptions: Apollo.QueryHookOptions<CategoriasArticulosForReportQuery, CategoriasArticulosForReportQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<CategoriasArticulosForReportQuery, CategoriasArticulosForReportQueryVariables>(
        CategoriasArticulosForReportDocument,
        options
    )
}
export function useCategoriasArticulosForReportLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        CategoriasArticulosForReportQuery,
        CategoriasArticulosForReportQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<CategoriasArticulosForReportQuery, CategoriasArticulosForReportQueryVariables>(
        CategoriasArticulosForReportDocument,
        options
    )
}
export type CategoriasArticulosForReportQueryHookResult = ReturnType<typeof useCategoriasArticulosForReportQuery>
export type CategoriasArticulosForReportLazyQueryHookResult = ReturnType<
    typeof useCategoriasArticulosForReportLazyQuery
>
export type CategoriasArticulosForReportQueryResult = Apollo.QueryResult<
    CategoriasArticulosForReportQuery,
    CategoriasArticulosForReportQueryVariables
>
export const CategoriasGastosForReportDocument = gql`
    query CategoriasGastosForReport($hotel_id: ID!) {
        categorias_gasto(hotel_id: $hotel_id, eliminado: false) {
            categoria_id
            categoria
        }
    }
`
export type CategoriasGastosForReportComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        CategoriasGastosForReportQuery,
        CategoriasGastosForReportQueryVariables
    >,
    "query"
> &
    ({ variables: CategoriasGastosForReportQueryVariables; skip?: boolean } | { skip: boolean })

export const CategoriasGastosForReportComponent = (props: CategoriasGastosForReportComponentProps) => (
    <ApolloReactComponents.Query<CategoriasGastosForReportQuery, CategoriasGastosForReportQueryVariables>
        query={CategoriasGastosForReportDocument}
        {...props}
    />
)

/**
 * __useCategoriasGastosForReportQuery__
 *
 * To run a query within a React component, call `useCategoriasGastosForReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriasGastosForReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriasGastosForReportQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useCategoriasGastosForReportQuery(
    baseOptions: Apollo.QueryHookOptions<CategoriasGastosForReportQuery, CategoriasGastosForReportQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<CategoriasGastosForReportQuery, CategoriasGastosForReportQueryVariables>(
        CategoriasGastosForReportDocument,
        options
    )
}
export function useCategoriasGastosForReportLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<CategoriasGastosForReportQuery, CategoriasGastosForReportQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<CategoriasGastosForReportQuery, CategoriasGastosForReportQueryVariables>(
        CategoriasGastosForReportDocument,
        options
    )
}
export type CategoriasGastosForReportQueryHookResult = ReturnType<typeof useCategoriasGastosForReportQuery>
export type CategoriasGastosForReportLazyQueryHookResult = ReturnType<typeof useCategoriasGastosForReportLazyQuery>
export type CategoriasGastosForReportQueryResult = Apollo.QueryResult<
    CategoriasGastosForReportQuery,
    CategoriasGastosForReportQueryVariables
>
export const ColaboradoresPorHotelForReportDocument = gql`
    query ColaboradoresPorHotelForReport($hotel_id: ID!) {
        colaboradores(hotel_id: $hotel_id, eliminado: false) {
            apellido_materno
            apellido_paterno
            nombre
            usuario_id
            colaborador_id
        }
    }
`
export type ColaboradoresPorHotelForReportComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        ColaboradoresPorHotelForReportQuery,
        ColaboradoresPorHotelForReportQueryVariables
    >,
    "query"
> &
    ({ variables: ColaboradoresPorHotelForReportQueryVariables; skip?: boolean } | { skip: boolean })

export const ColaboradoresPorHotelForReportComponent = (props: ColaboradoresPorHotelForReportComponentProps) => (
    <ApolloReactComponents.Query<ColaboradoresPorHotelForReportQuery, ColaboradoresPorHotelForReportQueryVariables>
        query={ColaboradoresPorHotelForReportDocument}
        {...props}
    />
)

/**
 * __useColaboradoresPorHotelForReportQuery__
 *
 * To run a query within a React component, call `useColaboradoresPorHotelForReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useColaboradoresPorHotelForReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useColaboradoresPorHotelForReportQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useColaboradoresPorHotelForReportQuery(
    baseOptions: Apollo.QueryHookOptions<
        ColaboradoresPorHotelForReportQuery,
        ColaboradoresPorHotelForReportQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<ColaboradoresPorHotelForReportQuery, ColaboradoresPorHotelForReportQueryVariables>(
        ColaboradoresPorHotelForReportDocument,
        options
    )
}
export function useColaboradoresPorHotelForReportLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ColaboradoresPorHotelForReportQuery,
        ColaboradoresPorHotelForReportQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<ColaboradoresPorHotelForReportQuery, ColaboradoresPorHotelForReportQueryVariables>(
        ColaboradoresPorHotelForReportDocument,
        options
    )
}
export type ColaboradoresPorHotelForReportQueryHookResult = ReturnType<typeof useColaboradoresPorHotelForReportQuery>
export type ColaboradoresPorHotelForReportLazyQueryHookResult = ReturnType<
    typeof useColaboradoresPorHotelForReportLazyQuery
>
export type ColaboradoresPorHotelForReportQueryResult = Apollo.QueryResult<
    ColaboradoresPorHotelForReportQuery,
    ColaboradoresPorHotelForReportQueryVariables
>
export const PuestosForReportDocument = gql`
    query PuestosForReport {
        puestos(eliminado: false) {
            puesto_id
            nombre
        }
    }
`
export type PuestosForReportComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<PuestosForReportQuery, PuestosForReportQueryVariables>,
    "query"
>

export const PuestosForReportComponent = (props: PuestosForReportComponentProps) => (
    <ApolloReactComponents.Query<PuestosForReportQuery, PuestosForReportQueryVariables>
        query={PuestosForReportDocument}
        {...props}
    />
)

/**
 * __usePuestosForReportQuery__
 *
 * To run a query within a React component, call `usePuestosForReportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePuestosForReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePuestosForReportQuery({
 *   variables: {
 *   },
 * });
 */
export function usePuestosForReportQuery(
    baseOptions?: Apollo.QueryHookOptions<PuestosForReportQuery, PuestosForReportQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<PuestosForReportQuery, PuestosForReportQueryVariables>(PuestosForReportDocument, options)
}
export function usePuestosForReportLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<PuestosForReportQuery, PuestosForReportQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<PuestosForReportQuery, PuestosForReportQueryVariables>(PuestosForReportDocument, options)
}
export type PuestosForReportQueryHookResult = ReturnType<typeof usePuestosForReportQuery>
export type PuestosForReportLazyQueryHookResult = ReturnType<typeof usePuestosForReportLazyQuery>
export type PuestosForReportQueryResult = Apollo.QueryResult<PuestosForReportQuery, PuestosForReportQueryVariables>
export const HabitacionesForReportDocument = gql`
    query habitacionesForReport($hotel_id: ID!) {
        habitaciones(hotel_id: $hotel_id) {
            numero_habitacion
            habitacion_id
        }
    }
`
export type HabitacionesForReportComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<HabitacionesForReportQuery, HabitacionesForReportQueryVariables>,
    "query"
> &
    ({ variables: HabitacionesForReportQueryVariables; skip?: boolean } | { skip: boolean })

export const HabitacionesForReportComponent = (props: HabitacionesForReportComponentProps) => (
    <ApolloReactComponents.Query<HabitacionesForReportQuery, HabitacionesForReportQueryVariables>
        query={HabitacionesForReportDocument}
        {...props}
    />
)

/**
 * __useHabitacionesForReportQuery__
 *
 * To run a query within a React component, call `useHabitacionesForReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useHabitacionesForReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHabitacionesForReportQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useHabitacionesForReportQuery(
    baseOptions: Apollo.QueryHookOptions<HabitacionesForReportQuery, HabitacionesForReportQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<HabitacionesForReportQuery, HabitacionesForReportQueryVariables>(
        HabitacionesForReportDocument,
        options
    )
}
export function useHabitacionesForReportLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<HabitacionesForReportQuery, HabitacionesForReportQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<HabitacionesForReportQuery, HabitacionesForReportQueryVariables>(
        HabitacionesForReportDocument,
        options
    )
}
export type HabitacionesForReportQueryHookResult = ReturnType<typeof useHabitacionesForReportQuery>
export type HabitacionesForReportLazyQueryHookResult = ReturnType<typeof useHabitacionesForReportLazyQuery>
export type HabitacionesForReportQueryResult = Apollo.QueryResult<
    HabitacionesForReportQuery,
    HabitacionesForReportQueryVariables
>
export const MesasForReportDocument = gql`
    query mesasForReport($hotel_id: ID!) {
        mesas(hotel_id: $hotel_id) {
            numero_mesa
            mesa_id
        }
    }
`
export type MesasForReportComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<MesasForReportQuery, MesasForReportQueryVariables>,
    "query"
> &
    ({ variables: MesasForReportQueryVariables; skip?: boolean } | { skip: boolean })

export const MesasForReportComponent = (props: MesasForReportComponentProps) => (
    <ApolloReactComponents.Query<MesasForReportQuery, MesasForReportQueryVariables>
        query={MesasForReportDocument}
        {...props}
    />
)

/**
 * __useMesasForReportQuery__
 *
 * To run a query within a React component, call `useMesasForReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMesasForReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMesasForReportQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useMesasForReportQuery(
    baseOptions: Apollo.QueryHookOptions<MesasForReportQuery, MesasForReportQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<MesasForReportQuery, MesasForReportQueryVariables>(MesasForReportDocument, options)
}
export function useMesasForReportLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<MesasForReportQuery, MesasForReportQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<MesasForReportQuery, MesasForReportQueryVariables>(MesasForReportDocument, options)
}
export type MesasForReportQueryHookResult = ReturnType<typeof useMesasForReportQuery>
export type MesasForReportLazyQueryHookResult = ReturnType<typeof useMesasForReportLazyQuery>
export type MesasForReportQueryResult = Apollo.QueryResult<MesasForReportQuery, MesasForReportQueryVariables>
export const SearchArticuloForReportDocument = gql`
    query searchArticuloForReport($hotel_id: ID, $pagination_options: PageOptionsArgs!, $nameFilter: String) {
        almacenes_articulos(
            hotel_id: $hotel_id
            eliminado: false
            nombre_articulo_filters: { like: $nameFilter, order: ASC }
            filter_estado_articulo: activado
            filter_tipo_articulo: [venta, receta, insumo, proceso]
            filter_duplicados: true
            pagination_options: $pagination_options
        ) {
            paginacion {
                pagina_actual
                total_paginas
            }
            almacenes_articulos {
                articulo_id
                articulo {
                    nombre
                }
            }
        }
    }
`
export type SearchArticuloForReportComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<SearchArticuloForReportQuery, SearchArticuloForReportQueryVariables>,
    "query"
> &
    ({ variables: SearchArticuloForReportQueryVariables; skip?: boolean } | { skip: boolean })

export const SearchArticuloForReportComponent = (props: SearchArticuloForReportComponentProps) => (
    <ApolloReactComponents.Query<SearchArticuloForReportQuery, SearchArticuloForReportQueryVariables>
        query={SearchArticuloForReportDocument}
        {...props}
    />
)

/**
 * __useSearchArticuloForReportQuery__
 *
 * To run a query within a React component, call `useSearchArticuloForReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchArticuloForReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchArticuloForReportQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      pagination_options: // value for 'pagination_options'
 *      nameFilter: // value for 'nameFilter'
 *   },
 * });
 */
export function useSearchArticuloForReportQuery(
    baseOptions: Apollo.QueryHookOptions<SearchArticuloForReportQuery, SearchArticuloForReportQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<SearchArticuloForReportQuery, SearchArticuloForReportQueryVariables>(
        SearchArticuloForReportDocument,
        options
    )
}
export function useSearchArticuloForReportLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<SearchArticuloForReportQuery, SearchArticuloForReportQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<SearchArticuloForReportQuery, SearchArticuloForReportQueryVariables>(
        SearchArticuloForReportDocument,
        options
    )
}
export type SearchArticuloForReportQueryHookResult = ReturnType<typeof useSearchArticuloForReportQuery>
export type SearchArticuloForReportLazyQueryHookResult = ReturnType<typeof useSearchArticuloForReportLazyQuery>
export type SearchArticuloForReportQueryResult = Apollo.QueryResult<
    SearchArticuloForReportQuery,
    SearchArticuloForReportQueryVariables
>
export const SubcategoriasGastosForReportDocument = gql`
    query SubcategoriasGastosForReport($hotel_id: ID!, $eliminado: Boolean = false) {
        categorias_gasto(hotel_id: $hotel_id, eliminado: $eliminado) {
            categoria_id
            categoria
            subcategorias_de_categoria(eliminado: $eliminado) {
                subcategoria_gasto_id
                subcategoria
            }
        }
    }
`
export type SubcategoriasGastosForReportComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        SubcategoriasGastosForReportQuery,
        SubcategoriasGastosForReportQueryVariables
    >,
    "query"
> &
    ({ variables: SubcategoriasGastosForReportQueryVariables; skip?: boolean } | { skip: boolean })

export const SubcategoriasGastosForReportComponent = (props: SubcategoriasGastosForReportComponentProps) => (
    <ApolloReactComponents.Query<SubcategoriasGastosForReportQuery, SubcategoriasGastosForReportQueryVariables>
        query={SubcategoriasGastosForReportDocument}
        {...props}
    />
)

/**
 * __useSubcategoriasGastosForReportQuery__
 *
 * To run a query within a React component, call `useSubcategoriasGastosForReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubcategoriasGastosForReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubcategoriasGastosForReportQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      eliminado: // value for 'eliminado'
 *   },
 * });
 */
export function useSubcategoriasGastosForReportQuery(
    baseOptions: Apollo.QueryHookOptions<SubcategoriasGastosForReportQuery, SubcategoriasGastosForReportQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<SubcategoriasGastosForReportQuery, SubcategoriasGastosForReportQueryVariables>(
        SubcategoriasGastosForReportDocument,
        options
    )
}
export function useSubcategoriasGastosForReportLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        SubcategoriasGastosForReportQuery,
        SubcategoriasGastosForReportQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<SubcategoriasGastosForReportQuery, SubcategoriasGastosForReportQueryVariables>(
        SubcategoriasGastosForReportDocument,
        options
    )
}
export type SubcategoriasGastosForReportQueryHookResult = ReturnType<typeof useSubcategoriasGastosForReportQuery>
export type SubcategoriasGastosForReportLazyQueryHookResult = ReturnType<
    typeof useSubcategoriasGastosForReportLazyQuery
>
export type SubcategoriasGastosForReportQueryResult = Apollo.QueryResult<
    SubcategoriasGastosForReportQuery,
    SubcategoriasGastosForReportQueryVariables
>
export const Tipos_HabitacionesForReportDocument = gql`
    query tipos_habitacionesForReport($hotel_id: ID!) {
        tipo_habitaciones(hotel_id: $hotel_id) {
            nombre
            tipo_habitacion_id
        }
    }
`
export type Tipos_HabitacionesForReportComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        Tipos_HabitacionesForReportQuery,
        Tipos_HabitacionesForReportQueryVariables
    >,
    "query"
> &
    ({ variables: Tipos_HabitacionesForReportQueryVariables; skip?: boolean } | { skip: boolean })

export const Tipos_HabitacionesForReportComponent = (props: Tipos_HabitacionesForReportComponentProps) => (
    <ApolloReactComponents.Query<Tipos_HabitacionesForReportQuery, Tipos_HabitacionesForReportQueryVariables>
        query={Tipos_HabitacionesForReportDocument}
        {...props}
    />
)

/**
 * __useTipos_HabitacionesForReportQuery__
 *
 * To run a query within a React component, call `useTipos_HabitacionesForReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipos_HabitacionesForReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipos_HabitacionesForReportQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useTipos_HabitacionesForReportQuery(
    baseOptions: Apollo.QueryHookOptions<Tipos_HabitacionesForReportQuery, Tipos_HabitacionesForReportQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<Tipos_HabitacionesForReportQuery, Tipos_HabitacionesForReportQueryVariables>(
        Tipos_HabitacionesForReportDocument,
        options
    )
}
export function useTipos_HabitacionesForReportLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        Tipos_HabitacionesForReportQuery,
        Tipos_HabitacionesForReportQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<Tipos_HabitacionesForReportQuery, Tipos_HabitacionesForReportQueryVariables>(
        Tipos_HabitacionesForReportDocument,
        options
    )
}
export type Tipos_HabitacionesForReportQueryHookResult = ReturnType<typeof useTipos_HabitacionesForReportQuery>
export type Tipos_HabitacionesForReportLazyQueryHookResult = ReturnType<typeof useTipos_HabitacionesForReportLazyQuery>
export type Tipos_HabitacionesForReportQueryResult = Apollo.QueryResult<
    Tipos_HabitacionesForReportQuery,
    Tipos_HabitacionesForReportQueryVariables
>
export const TiposMttoForReportDocument = gql`
    query tiposMttoForReport($hotel_id: ID!) {
        tipos_mantenimiento(hotel_id: $hotel_id, eliminado: false) {
            tipo_mantenimiento_id
            nombre
        }
    }
`
export type TiposMttoForReportComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<TiposMttoForReportQuery, TiposMttoForReportQueryVariables>,
    "query"
> &
    ({ variables: TiposMttoForReportQueryVariables; skip?: boolean } | { skip: boolean })

export const TiposMttoForReportComponent = (props: TiposMttoForReportComponentProps) => (
    <ApolloReactComponents.Query<TiposMttoForReportQuery, TiposMttoForReportQueryVariables>
        query={TiposMttoForReportDocument}
        {...props}
    />
)

/**
 * __useTiposMttoForReportQuery__
 *
 * To run a query within a React component, call `useTiposMttoForReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTiposMttoForReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTiposMttoForReportQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useTiposMttoForReportQuery(
    baseOptions: Apollo.QueryHookOptions<TiposMttoForReportQuery, TiposMttoForReportQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<TiposMttoForReportQuery, TiposMttoForReportQueryVariables>(
        TiposMttoForReportDocument,
        options
    )
}
export function useTiposMttoForReportLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<TiposMttoForReportQuery, TiposMttoForReportQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<TiposMttoForReportQuery, TiposMttoForReportQueryVariables>(
        TiposMttoForReportDocument,
        options
    )
}
export type TiposMttoForReportQueryHookResult = ReturnType<typeof useTiposMttoForReportQuery>
export type TiposMttoForReportLazyQueryHookResult = ReturnType<typeof useTiposMttoForReportLazyQuery>
export type TiposMttoForReportQueryResult = Apollo.QueryResult<
    TiposMttoForReportQuery,
    TiposMttoForReportQueryVariables
>
export const TurnosForReportDocument = gql`
    query turnosForReport($hotel_id: [ID!]) {
        turnos(hotel_id: $hotel_id) {
            turno_id
            nombre
        }
    }
`
export type TurnosForReportComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<TurnosForReportQuery, TurnosForReportQueryVariables>,
    "query"
>

export const TurnosForReportComponent = (props: TurnosForReportComponentProps) => (
    <ApolloReactComponents.Query<TurnosForReportQuery, TurnosForReportQueryVariables>
        query={TurnosForReportDocument}
        {...props}
    />
)

/**
 * __useTurnosForReportQuery__
 *
 * To run a query within a React component, call `useTurnosForReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTurnosForReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTurnosForReportQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useTurnosForReportQuery(
    baseOptions?: Apollo.QueryHookOptions<TurnosForReportQuery, TurnosForReportQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<TurnosForReportQuery, TurnosForReportQueryVariables>(TurnosForReportDocument, options)
}
export function useTurnosForReportLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<TurnosForReportQuery, TurnosForReportQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<TurnosForReportQuery, TurnosForReportQueryVariables>(TurnosForReportDocument, options)
}
export type TurnosForReportQueryHookResult = ReturnType<typeof useTurnosForReportQuery>
export type TurnosForReportLazyQueryHookResult = ReturnType<typeof useTurnosForReportLazyQuery>
export type TurnosForReportQueryResult = Apollo.QueryResult<TurnosForReportQuery, TurnosForReportQueryVariables>
export const UsuariosPorHotelForReportDocument = gql`
    query UsuariosPorHotelForReport($hotel_id: ID!) {
        usuarios(hotel_id: $hotel_id, eliminado: false) {
            apellido_materno
            apellido_paterno
            nombre
            usuario_id
        }
    }
`
export type UsuariosPorHotelForReportComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        UsuariosPorHotelForReportQuery,
        UsuariosPorHotelForReportQueryVariables
    >,
    "query"
> &
    ({ variables: UsuariosPorHotelForReportQueryVariables; skip?: boolean } | { skip: boolean })

export const UsuariosPorHotelForReportComponent = (props: UsuariosPorHotelForReportComponentProps) => (
    <ApolloReactComponents.Query<UsuariosPorHotelForReportQuery, UsuariosPorHotelForReportQueryVariables>
        query={UsuariosPorHotelForReportDocument}
        {...props}
    />
)

/**
 * __useUsuariosPorHotelForReportQuery__
 *
 * To run a query within a React component, call `useUsuariosPorHotelForReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsuariosPorHotelForReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsuariosPorHotelForReportQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useUsuariosPorHotelForReportQuery(
    baseOptions: Apollo.QueryHookOptions<UsuariosPorHotelForReportQuery, UsuariosPorHotelForReportQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<UsuariosPorHotelForReportQuery, UsuariosPorHotelForReportQueryVariables>(
        UsuariosPorHotelForReportDocument,
        options
    )
}
export function useUsuariosPorHotelForReportLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<UsuariosPorHotelForReportQuery, UsuariosPorHotelForReportQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<UsuariosPorHotelForReportQuery, UsuariosPorHotelForReportQueryVariables>(
        UsuariosPorHotelForReportDocument,
        options
    )
}
export type UsuariosPorHotelForReportQueryHookResult = ReturnType<typeof useUsuariosPorHotelForReportQuery>
export type UsuariosPorHotelForReportLazyQueryHookResult = ReturnType<typeof useUsuariosPorHotelForReportLazyQuery>
export type UsuariosPorHotelForReportQueryResult = Apollo.QueryResult<
    UsuariosPorHotelForReportQuery,
    UsuariosPorHotelForReportQueryVariables
>
export const GetComentariosIncidenciaForReportDocument = gql`
    query GetComentariosIncidenciaForReport($hotel_id: ID!, $folio: Int!) {
        incidencias(hotel_id: $hotel_id, folio: $folio) {
            incidencia_id
            folio
            comentarios {
                comentario
                fecha
                usuario_id
            }
        }
    }
`
export type GetComentariosIncidenciaForReportComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetComentariosIncidenciaForReportQuery,
        GetComentariosIncidenciaForReportQueryVariables
    >,
    "query"
> &
    ({ variables: GetComentariosIncidenciaForReportQueryVariables; skip?: boolean } | { skip: boolean })

export const GetComentariosIncidenciaForReportComponent = (props: GetComentariosIncidenciaForReportComponentProps) => (
    <ApolloReactComponents.Query<
        GetComentariosIncidenciaForReportQuery,
        GetComentariosIncidenciaForReportQueryVariables
    >
        query={GetComentariosIncidenciaForReportDocument}
        {...props}
    />
)

/**
 * __useGetComentariosIncidenciaForReportQuery__
 *
 * To run a query within a React component, call `useGetComentariosIncidenciaForReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComentariosIncidenciaForReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComentariosIncidenciaForReportQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      folio: // value for 'folio'
 *   },
 * });
 */
export function useGetComentariosIncidenciaForReportQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetComentariosIncidenciaForReportQuery,
        GetComentariosIncidenciaForReportQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetComentariosIncidenciaForReportQuery, GetComentariosIncidenciaForReportQueryVariables>(
        GetComentariosIncidenciaForReportDocument,
        options
    )
}
export function useGetComentariosIncidenciaForReportLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetComentariosIncidenciaForReportQuery,
        GetComentariosIncidenciaForReportQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetComentariosIncidenciaForReportQuery, GetComentariosIncidenciaForReportQueryVariables>(
        GetComentariosIncidenciaForReportDocument,
        options
    )
}
export type GetComentariosIncidenciaForReportQueryHookResult = ReturnType<
    typeof useGetComentariosIncidenciaForReportQuery
>
export type GetComentariosIncidenciaForReportLazyQueryHookResult = ReturnType<
    typeof useGetComentariosIncidenciaForReportLazyQuery
>
export type GetComentariosIncidenciaForReportQueryResult = Apollo.QueryResult<
    GetComentariosIncidenciaForReportQuery,
    GetComentariosIncidenciaForReportQueryVariables
>
export const BorrarHistorialVehiculoDocument = gql`
    mutation BorrarHistorialVehiculo($historial_vehiculo_id: ID!) {
        borrar_historial_vehiculo(historial_vehiculo_id: $historial_vehiculo_id)
    }
`
export type BorrarHistorialVehiculoMutationFn = Apollo.MutationFunction<
    BorrarHistorialVehiculoMutation,
    BorrarHistorialVehiculoMutationVariables
>
export type BorrarHistorialVehiculoComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        BorrarHistorialVehiculoMutation,
        BorrarHistorialVehiculoMutationVariables
    >,
    "mutation"
>

export const BorrarHistorialVehiculoComponent = (props: BorrarHistorialVehiculoComponentProps) => (
    <ApolloReactComponents.Mutation<BorrarHistorialVehiculoMutation, BorrarHistorialVehiculoMutationVariables>
        mutation={BorrarHistorialVehiculoDocument}
        {...props}
    />
)

/**
 * __useBorrarHistorialVehiculoMutation__
 *
 * To run a mutation, you first call `useBorrarHistorialVehiculoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBorrarHistorialVehiculoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [borrarHistorialVehiculoMutation, { data, loading, error }] = useBorrarHistorialVehiculoMutation({
 *   variables: {
 *      historial_vehiculo_id: // value for 'historial_vehiculo_id'
 *   },
 * });
 */
export function useBorrarHistorialVehiculoMutation(
    baseOptions?: Apollo.MutationHookOptions<BorrarHistorialVehiculoMutation, BorrarHistorialVehiculoMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<BorrarHistorialVehiculoMutation, BorrarHistorialVehiculoMutationVariables>(
        BorrarHistorialVehiculoDocument,
        options
    )
}
export type BorrarHistorialVehiculoMutationHookResult = ReturnType<typeof useBorrarHistorialVehiculoMutation>
export type BorrarHistorialVehiculoMutationResult = Apollo.MutationResult<BorrarHistorialVehiculoMutation>
export type BorrarHistorialVehiculoMutationOptions = Apollo.BaseMutationOptions<
    BorrarHistorialVehiculoMutation,
    BorrarHistorialVehiculoMutationVariables
>
export const GetFiltrosMatriculasDocument = gql`
    query GetFiltrosMatriculas($limit: Float, $filter_text: String) {
        filtros_reportes {
            matriculas(limit: $limit, buscar: $filter_text)
        }
    }
`
export type GetFiltrosMatriculasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetFiltrosMatriculasQuery, GetFiltrosMatriculasQueryVariables>,
    "query"
>

export const GetFiltrosMatriculasComponent = (props: GetFiltrosMatriculasComponentProps) => (
    <ApolloReactComponents.Query<GetFiltrosMatriculasQuery, GetFiltrosMatriculasQueryVariables>
        query={GetFiltrosMatriculasDocument}
        {...props}
    />
)

/**
 * __useGetFiltrosMatriculasQuery__
 *
 * To run a query within a React component, call `useGetFiltrosMatriculasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFiltrosMatriculasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFiltrosMatriculasQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      filter_text: // value for 'filter_text'
 *   },
 * });
 */
export function useGetFiltrosMatriculasQuery(
    baseOptions?: Apollo.QueryHookOptions<GetFiltrosMatriculasQuery, GetFiltrosMatriculasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetFiltrosMatriculasQuery, GetFiltrosMatriculasQueryVariables>(
        GetFiltrosMatriculasDocument,
        options
    )
}
export function useGetFiltrosMatriculasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetFiltrosMatriculasQuery, GetFiltrosMatriculasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetFiltrosMatriculasQuery, GetFiltrosMatriculasQueryVariables>(
        GetFiltrosMatriculasDocument,
        options
    )
}
export type GetFiltrosMatriculasQueryHookResult = ReturnType<typeof useGetFiltrosMatriculasQuery>
export type GetFiltrosMatriculasLazyQueryHookResult = ReturnType<typeof useGetFiltrosMatriculasLazyQuery>
export type GetFiltrosMatriculasQueryResult = Apollo.QueryResult<
    GetFiltrosMatriculasQuery,
    GetFiltrosMatriculasQueryVariables
>
export const GetFiltrosColoresDocument = gql`
    query GetFiltrosColores($limit: Float, $filter_text: String) {
        filtros_reportes {
            colores(limit: $limit, buscar: $filter_text)
        }
    }
`
export type GetFiltrosColoresComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetFiltrosColoresQuery, GetFiltrosColoresQueryVariables>,
    "query"
>

export const GetFiltrosColoresComponent = (props: GetFiltrosColoresComponentProps) => (
    <ApolloReactComponents.Query<GetFiltrosColoresQuery, GetFiltrosColoresQueryVariables>
        query={GetFiltrosColoresDocument}
        {...props}
    />
)

/**
 * __useGetFiltrosColoresQuery__
 *
 * To run a query within a React component, call `useGetFiltrosColoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFiltrosColoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFiltrosColoresQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      filter_text: // value for 'filter_text'
 *   },
 * });
 */
export function useGetFiltrosColoresQuery(
    baseOptions?: Apollo.QueryHookOptions<GetFiltrosColoresQuery, GetFiltrosColoresQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetFiltrosColoresQuery, GetFiltrosColoresQueryVariables>(GetFiltrosColoresDocument, options)
}
export function useGetFiltrosColoresLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetFiltrosColoresQuery, GetFiltrosColoresQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetFiltrosColoresQuery, GetFiltrosColoresQueryVariables>(
        GetFiltrosColoresDocument,
        options
    )
}
export type GetFiltrosColoresQueryHookResult = ReturnType<typeof useGetFiltrosColoresQuery>
export type GetFiltrosColoresLazyQueryHookResult = ReturnType<typeof useGetFiltrosColoresLazyQuery>
export type GetFiltrosColoresQueryResult = Apollo.QueryResult<GetFiltrosColoresQuery, GetFiltrosColoresQueryVariables>
export const GetFiltrosMarcasDocument = gql`
    query GetFiltrosMarcas($filter_text: String) {
        filtros_reportes {
            marca(buscar: $filter_text)
        }
    }
`
export type GetFiltrosMarcasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetFiltrosMarcasQuery, GetFiltrosMarcasQueryVariables>,
    "query"
>

export const GetFiltrosMarcasComponent = (props: GetFiltrosMarcasComponentProps) => (
    <ApolloReactComponents.Query<GetFiltrosMarcasQuery, GetFiltrosMarcasQueryVariables>
        query={GetFiltrosMarcasDocument}
        {...props}
    />
)

/**
 * __useGetFiltrosMarcasQuery__
 *
 * To run a query within a React component, call `useGetFiltrosMarcasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFiltrosMarcasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFiltrosMarcasQuery({
 *   variables: {
 *      filter_text: // value for 'filter_text'
 *   },
 * });
 */
export function useGetFiltrosMarcasQuery(
    baseOptions?: Apollo.QueryHookOptions<GetFiltrosMarcasQuery, GetFiltrosMarcasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetFiltrosMarcasQuery, GetFiltrosMarcasQueryVariables>(GetFiltrosMarcasDocument, options)
}
export function useGetFiltrosMarcasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetFiltrosMarcasQuery, GetFiltrosMarcasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetFiltrosMarcasQuery, GetFiltrosMarcasQueryVariables>(GetFiltrosMarcasDocument, options)
}
export type GetFiltrosMarcasQueryHookResult = ReturnType<typeof useGetFiltrosMarcasQuery>
export type GetFiltrosMarcasLazyQueryHookResult = ReturnType<typeof useGetFiltrosMarcasLazyQuery>
export type GetFiltrosMarcasQueryResult = Apollo.QueryResult<GetFiltrosMarcasQuery, GetFiltrosMarcasQueryVariables>
export const GetFiltrosModelosDocument = gql`
    query GetFiltrosModelos($limit: Float, $filter_text: String) {
        filtros_reportes {
            modelo(limit: $limit, buscar: $filter_text)
        }
    }
`
export type GetFiltrosModelosComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetFiltrosModelosQuery, GetFiltrosModelosQueryVariables>,
    "query"
>

export const GetFiltrosModelosComponent = (props: GetFiltrosModelosComponentProps) => (
    <ApolloReactComponents.Query<GetFiltrosModelosQuery, GetFiltrosModelosQueryVariables>
        query={GetFiltrosModelosDocument}
        {...props}
    />
)

/**
 * __useGetFiltrosModelosQuery__
 *
 * To run a query within a React component, call `useGetFiltrosModelosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFiltrosModelosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFiltrosModelosQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      filter_text: // value for 'filter_text'
 *   },
 * });
 */
export function useGetFiltrosModelosQuery(
    baseOptions?: Apollo.QueryHookOptions<GetFiltrosModelosQuery, GetFiltrosModelosQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetFiltrosModelosQuery, GetFiltrosModelosQueryVariables>(GetFiltrosModelosDocument, options)
}
export function useGetFiltrosModelosLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetFiltrosModelosQuery, GetFiltrosModelosQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetFiltrosModelosQuery, GetFiltrosModelosQueryVariables>(
        GetFiltrosModelosDocument,
        options
    )
}
export type GetFiltrosModelosQueryHookResult = ReturnType<typeof useGetFiltrosModelosQuery>
export type GetFiltrosModelosLazyQueryHookResult = ReturnType<typeof useGetFiltrosModelosLazyQuery>
export type GetFiltrosModelosQueryResult = Apollo.QueryResult<GetFiltrosModelosQuery, GetFiltrosModelosQueryVariables>
export const EditarHistorialVehiculoDocument = gql`
    mutation EditarHistorialVehiculo($input: UpdateHistorialVehiculoInput!) {
        editar_historial_vehiculo(input: $input)
    }
`
export type EditarHistorialVehiculoMutationFn = Apollo.MutationFunction<
    EditarHistorialVehiculoMutation,
    EditarHistorialVehiculoMutationVariables
>
export type EditarHistorialVehiculoComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        EditarHistorialVehiculoMutation,
        EditarHistorialVehiculoMutationVariables
    >,
    "mutation"
>

export const EditarHistorialVehiculoComponent = (props: EditarHistorialVehiculoComponentProps) => (
    <ApolloReactComponents.Mutation<EditarHistorialVehiculoMutation, EditarHistorialVehiculoMutationVariables>
        mutation={EditarHistorialVehiculoDocument}
        {...props}
    />
)

/**
 * __useEditarHistorialVehiculoMutation__
 *
 * To run a mutation, you first call `useEditarHistorialVehiculoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditarHistorialVehiculoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editarHistorialVehiculoMutation, { data, loading, error }] = useEditarHistorialVehiculoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditarHistorialVehiculoMutation(
    baseOptions?: Apollo.MutationHookOptions<EditarHistorialVehiculoMutation, EditarHistorialVehiculoMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<EditarHistorialVehiculoMutation, EditarHistorialVehiculoMutationVariables>(
        EditarHistorialVehiculoDocument,
        options
    )
}
export type EditarHistorialVehiculoMutationHookResult = ReturnType<typeof useEditarHistorialVehiculoMutation>
export type EditarHistorialVehiculoMutationResult = Apollo.MutationResult<EditarHistorialVehiculoMutation>
export type EditarHistorialVehiculoMutationOptions = Apollo.BaseMutationOptions<
    EditarHistorialVehiculoMutation,
    EditarHistorialVehiculoMutationVariables
>
export const MotivosIngresoDocument = gql`
    query MotivosIngreso($hotel_id: ID!) {
        motivos_ingreso_vehiculos(hotel_id: $hotel_id) {
            motivo_ingreso_id
            nombre
            hotel_id
        }
    }
`
export type MotivosIngresoComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<MotivosIngresoQuery, MotivosIngresoQueryVariables>,
    "query"
> &
    ({ variables: MotivosIngresoQueryVariables; skip?: boolean } | { skip: boolean })

export const MotivosIngresoComponent = (props: MotivosIngresoComponentProps) => (
    <ApolloReactComponents.Query<MotivosIngresoQuery, MotivosIngresoQueryVariables>
        query={MotivosIngresoDocument}
        {...props}
    />
)

/**
 * __useMotivosIngresoQuery__
 *
 * To run a query within a React component, call `useMotivosIngresoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMotivosIngresoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMotivosIngresoQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useMotivosIngresoQuery(
    baseOptions: Apollo.QueryHookOptions<MotivosIngresoQuery, MotivosIngresoQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<MotivosIngresoQuery, MotivosIngresoQueryVariables>(MotivosIngresoDocument, options)
}
export function useMotivosIngresoLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<MotivosIngresoQuery, MotivosIngresoQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<MotivosIngresoQuery, MotivosIngresoQueryVariables>(MotivosIngresoDocument, options)
}
export type MotivosIngresoQueryHookResult = ReturnType<typeof useMotivosIngresoQuery>
export type MotivosIngresoLazyQueryHookResult = ReturnType<typeof useMotivosIngresoLazyQuery>
export type MotivosIngresoQueryResult = Apollo.QueryResult<MotivosIngresoQuery, MotivosIngresoQueryVariables>
export const Crear_ReservaDocument = gql`
    mutation Crear_reserva($crearReservaInput: CreateReservaInput!) {
        crear_reserva(crear_reserva_input: $crearReservaInput) {
            reserva {
                folio
            }
            ticket {
                ticket_id
            }
        }
    }
`
export type Crear_ReservaMutationFn = Apollo.MutationFunction<Crear_ReservaMutation, Crear_ReservaMutationVariables>
export type Crear_ReservaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<Crear_ReservaMutation, Crear_ReservaMutationVariables>,
    "mutation"
>

export const Crear_ReservaComponent = (props: Crear_ReservaComponentProps) => (
    <ApolloReactComponents.Mutation<Crear_ReservaMutation, Crear_ReservaMutationVariables>
        mutation={Crear_ReservaDocument}
        {...props}
    />
)

/**
 * __useCrear_ReservaMutation__
 *
 * To run a mutation, you first call `useCrear_ReservaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrear_ReservaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crearReservaMutation, { data, loading, error }] = useCrear_ReservaMutation({
 *   variables: {
 *      crearReservaInput: // value for 'crearReservaInput'
 *   },
 * });
 */
export function useCrear_ReservaMutation(
    baseOptions?: Apollo.MutationHookOptions<Crear_ReservaMutation, Crear_ReservaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<Crear_ReservaMutation, Crear_ReservaMutationVariables>(Crear_ReservaDocument, options)
}
export type Crear_ReservaMutationHookResult = ReturnType<typeof useCrear_ReservaMutation>
export type Crear_ReservaMutationResult = Apollo.MutationResult<Crear_ReservaMutation>
export type Crear_ReservaMutationOptions = Apollo.BaseMutationOptions<
    Crear_ReservaMutation,
    Crear_ReservaMutationVariables
>
export const GetHabitacionesDisponiblesDrawerDocument = gql`
    query GetHabitacionesDisponiblesDrawer($hotel_id: ID!) {
        habitaciones(hotel_id: $hotel_id) {
            numero_habitacion
            habitacion_id
            estado
            ultima_renta {
                horas_extra
            }
            tipo_habitacion_id
            tipo_habitacion {
                nombre
            }
            ultima_reserva {
                reserva {
                    fecha_registro
                }
            }
        }
    }
`
export type GetHabitacionesDisponiblesDrawerComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetHabitacionesDisponiblesDrawerQuery,
        GetHabitacionesDisponiblesDrawerQueryVariables
    >,
    "query"
> &
    ({ variables: GetHabitacionesDisponiblesDrawerQueryVariables; skip?: boolean } | { skip: boolean })

export const GetHabitacionesDisponiblesDrawerComponent = (props: GetHabitacionesDisponiblesDrawerComponentProps) => (
    <ApolloReactComponents.Query<GetHabitacionesDisponiblesDrawerQuery, GetHabitacionesDisponiblesDrawerQueryVariables>
        query={GetHabitacionesDisponiblesDrawerDocument}
        {...props}
    />
)

/**
 * __useGetHabitacionesDisponiblesDrawerQuery__
 *
 * To run a query within a React component, call `useGetHabitacionesDisponiblesDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHabitacionesDisponiblesDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHabitacionesDisponiblesDrawerQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetHabitacionesDisponiblesDrawerQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetHabitacionesDisponiblesDrawerQuery,
        GetHabitacionesDisponiblesDrawerQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetHabitacionesDisponiblesDrawerQuery, GetHabitacionesDisponiblesDrawerQueryVariables>(
        GetHabitacionesDisponiblesDrawerDocument,
        options
    )
}
export function useGetHabitacionesDisponiblesDrawerLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetHabitacionesDisponiblesDrawerQuery,
        GetHabitacionesDisponiblesDrawerQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetHabitacionesDisponiblesDrawerQuery, GetHabitacionesDisponiblesDrawerQueryVariables>(
        GetHabitacionesDisponiblesDrawerDocument,
        options
    )
}
export type GetHabitacionesDisponiblesDrawerQueryHookResult = ReturnType<
    typeof useGetHabitacionesDisponiblesDrawerQuery
>
export type GetHabitacionesDisponiblesDrawerLazyQueryHookResult = ReturnType<
    typeof useGetHabitacionesDisponiblesDrawerLazyQuery
>
export type GetHabitacionesDisponiblesDrawerQueryResult = Apollo.QueryResult<
    GetHabitacionesDisponiblesDrawerQuery,
    GetHabitacionesDisponiblesDrawerQueryVariables
>
export const AsignarReservaDocument = gql`
    mutation AsignarReserva($asignacion: AddRoomToBookingInput!) {
        asignar_habitacion_a_reserva(datos_reserva: $asignacion) {
            habitacion {
                numero_habitacion
            }
        }
    }
`
export type AsignarReservaMutationFn = Apollo.MutationFunction<AsignarReservaMutation, AsignarReservaMutationVariables>
export type AsignarReservaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<AsignarReservaMutation, AsignarReservaMutationVariables>,
    "mutation"
>

export const AsignarReservaComponent = (props: AsignarReservaComponentProps) => (
    <ApolloReactComponents.Mutation<AsignarReservaMutation, AsignarReservaMutationVariables>
        mutation={AsignarReservaDocument}
        {...props}
    />
)

/**
 * __useAsignarReservaMutation__
 *
 * To run a mutation, you first call `useAsignarReservaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAsignarReservaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [asignarReservaMutation, { data, loading, error }] = useAsignarReservaMutation({
 *   variables: {
 *      asignacion: // value for 'asignacion'
 *   },
 * });
 */
export function useAsignarReservaMutation(
    baseOptions?: Apollo.MutationHookOptions<AsignarReservaMutation, AsignarReservaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<AsignarReservaMutation, AsignarReservaMutationVariables>(AsignarReservaDocument, options)
}
export type AsignarReservaMutationHookResult = ReturnType<typeof useAsignarReservaMutation>
export type AsignarReservaMutationResult = Apollo.MutationResult<AsignarReservaMutation>
export type AsignarReservaMutationOptions = Apollo.BaseMutationOptions<
    AsignarReservaMutation,
    AsignarReservaMutationVariables
>
export const CambiarHabitacionReservaDocument = gql`
    mutation cambiarHabitacionReserva($cambiarHabReservaInput: ChangeHabitacionReservaInput!) {
        cambiar_habitacion_reserva(cambiar_habitacion_reserva_input: $cambiarHabReservaInput)
    }
`
export type CambiarHabitacionReservaMutationFn = Apollo.MutationFunction<
    CambiarHabitacionReservaMutation,
    CambiarHabitacionReservaMutationVariables
>
export type CambiarHabitacionReservaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        CambiarHabitacionReservaMutation,
        CambiarHabitacionReservaMutationVariables
    >,
    "mutation"
>

export const CambiarHabitacionReservaComponent = (props: CambiarHabitacionReservaComponentProps) => (
    <ApolloReactComponents.Mutation<CambiarHabitacionReservaMutation, CambiarHabitacionReservaMutationVariables>
        mutation={CambiarHabitacionReservaDocument}
        {...props}
    />
)

/**
 * __useCambiarHabitacionReservaMutation__
 *
 * To run a mutation, you first call `useCambiarHabitacionReservaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCambiarHabitacionReservaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cambiarHabitacionReservaMutation, { data, loading, error }] = useCambiarHabitacionReservaMutation({
 *   variables: {
 *      cambiarHabReservaInput: // value for 'cambiarHabReservaInput'
 *   },
 * });
 */
export function useCambiarHabitacionReservaMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CambiarHabitacionReservaMutation,
        CambiarHabitacionReservaMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CambiarHabitacionReservaMutation, CambiarHabitacionReservaMutationVariables>(
        CambiarHabitacionReservaDocument,
        options
    )
}
export type CambiarHabitacionReservaMutationHookResult = ReturnType<typeof useCambiarHabitacionReservaMutation>
export type CambiarHabitacionReservaMutationResult = Apollo.MutationResult<CambiarHabitacionReservaMutation>
export type CambiarHabitacionReservaMutationOptions = Apollo.BaseMutationOptions<
    CambiarHabitacionReservaMutation,
    CambiarHabitacionReservaMutationVariables
>
export const GetNumeroHabitacionDocument = gql`
    query GetNumeroHabitacion($habitacion_id: ID!) {
        habitacion(habitacion_id: $habitacion_id) {
            numero_habitacion
        }
    }
`
export type GetNumeroHabitacionComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetNumeroHabitacionQuery, GetNumeroHabitacionQueryVariables>,
    "query"
> &
    ({ variables: GetNumeroHabitacionQueryVariables; skip?: boolean } | { skip: boolean })

export const GetNumeroHabitacionComponent = (props: GetNumeroHabitacionComponentProps) => (
    <ApolloReactComponents.Query<GetNumeroHabitacionQuery, GetNumeroHabitacionQueryVariables>
        query={GetNumeroHabitacionDocument}
        {...props}
    />
)

/**
 * __useGetNumeroHabitacionQuery__
 *
 * To run a query within a React component, call `useGetNumeroHabitacionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumeroHabitacionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumeroHabitacionQuery({
 *   variables: {
 *      habitacion_id: // value for 'habitacion_id'
 *   },
 * });
 */
export function useGetNumeroHabitacionQuery(
    baseOptions: Apollo.QueryHookOptions<GetNumeroHabitacionQuery, GetNumeroHabitacionQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetNumeroHabitacionQuery, GetNumeroHabitacionQueryVariables>(
        GetNumeroHabitacionDocument,
        options
    )
}
export function useGetNumeroHabitacionLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetNumeroHabitacionQuery, GetNumeroHabitacionQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetNumeroHabitacionQuery, GetNumeroHabitacionQueryVariables>(
        GetNumeroHabitacionDocument,
        options
    )
}
export type GetNumeroHabitacionQueryHookResult = ReturnType<typeof useGetNumeroHabitacionQuery>
export type GetNumeroHabitacionLazyQueryHookResult = ReturnType<typeof useGetNumeroHabitacionLazyQuery>
export type GetNumeroHabitacionQueryResult = Apollo.QueryResult<
    GetNumeroHabitacionQuery,
    GetNumeroHabitacionQueryVariables
>
export const GetReservacionesTableDocument = gql`
    query GetReservacionesTable($id: [ID!]!, $hotel_id: ID!, $fecha_entrada: DateSearchInput, $search: String) {
        reservas(reserva_id: $id, hotel_id: $hotel_id, fecha_entrada: $fecha_entrada, search: $search) {
            reserva_id
            codigo_ota
            corte_id
            folio
            estado
            fecha_cancelacion
            fecha_registro
            fecha_salida
            motivo_cancelacion
            fecha_entrada
            personas_extras
            origen
            tipo_habitacion_id
            tipo_de_habitacion {
                nombre
            }
            habitacion_id
            habitacion {
                numero_habitacion
                habitacion_id
                tipo_habitacion {
                    nombre
                }
            }
            tarifa_id
            tarifa {
                nombre
                personas_extra_max
                costo_persona_extra
                costo_habitacion
                hora_checkin
                hora_checkout
            }
            correo_huesped
            nombre_huesped
            telefono_huesped
            numero_personas
            usuario {
                nombre
            }
            estado_pago
            total
            pagos {
                pago_id
                total
                fecha_pago
                detalles_pago {
                    detalle_pago_id
                    subtotal
                    tipo_pago
                    ultimos_digitos
                    numero_referencia
                    easyrewards_id
                }
                extras {
                    monto_devuelto_cancelacion
                    fecha_cancelacion
                    fecha_pago
                    fecha_solicitud
                    monto_extra
                    motivo_cancelacion
                    numero
                    tipo_extra
                }
            }
            experiencias_reserva {
                experiencia_reserva_id
                experiencia_id
                total
                estado
                experiencia {
                    nombre
                }
            }
            comentarios {
                comentario
                fecha
            }
        }
    }
`
export type GetReservacionesTableComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetReservacionesTableQuery, GetReservacionesTableQueryVariables>,
    "query"
> &
    ({ variables: GetReservacionesTableQueryVariables; skip?: boolean } | { skip: boolean })

export const GetReservacionesTableComponent = (props: GetReservacionesTableComponentProps) => (
    <ApolloReactComponents.Query<GetReservacionesTableQuery, GetReservacionesTableQueryVariables>
        query={GetReservacionesTableDocument}
        {...props}
    />
)

/**
 * __useGetReservacionesTableQuery__
 *
 * To run a query within a React component, call `useGetReservacionesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservacionesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservacionesTableQuery({
 *   variables: {
 *      id: // value for 'id'
 *      hotel_id: // value for 'hotel_id'
 *      fecha_entrada: // value for 'fecha_entrada'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetReservacionesTableQuery(
    baseOptions: Apollo.QueryHookOptions<GetReservacionesTableQuery, GetReservacionesTableQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetReservacionesTableQuery, GetReservacionesTableQueryVariables>(
        GetReservacionesTableDocument,
        options
    )
}
export function useGetReservacionesTableLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetReservacionesTableQuery, GetReservacionesTableQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetReservacionesTableQuery, GetReservacionesTableQueryVariables>(
        GetReservacionesTableDocument,
        options
    )
}
export type GetReservacionesTableQueryHookResult = ReturnType<typeof useGetReservacionesTableQuery>
export type GetReservacionesTableLazyQueryHookResult = ReturnType<typeof useGetReservacionesTableLazyQuery>
export type GetReservacionesTableQueryResult = Apollo.QueryResult<
    GetReservacionesTableQuery,
    GetReservacionesTableQueryVariables
>
export const GetHabitacionTableDocument = gql`
    query GetHabitacionTable($idHabitacin: ID!) {
        habitacion(habitacion_id: $idHabitacin) {
            numero_habitacion
            tipo_habitacion {
                nombre
            }
        }
    }
`
export type GetHabitacionTableComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetHabitacionTableQuery, GetHabitacionTableQueryVariables>,
    "query"
> &
    ({ variables: GetHabitacionTableQueryVariables; skip?: boolean } | { skip: boolean })

export const GetHabitacionTableComponent = (props: GetHabitacionTableComponentProps) => (
    <ApolloReactComponents.Query<GetHabitacionTableQuery, GetHabitacionTableQueryVariables>
        query={GetHabitacionTableDocument}
        {...props}
    />
)

/**
 * __useGetHabitacionTableQuery__
 *
 * To run a query within a React component, call `useGetHabitacionTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHabitacionTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHabitacionTableQuery({
 *   variables: {
 *      idHabitacin: // value for 'idHabitacin'
 *   },
 * });
 */
export function useGetHabitacionTableQuery(
    baseOptions: Apollo.QueryHookOptions<GetHabitacionTableQuery, GetHabitacionTableQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetHabitacionTableQuery, GetHabitacionTableQueryVariables>(
        GetHabitacionTableDocument,
        options
    )
}
export function useGetHabitacionTableLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetHabitacionTableQuery, GetHabitacionTableQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetHabitacionTableQuery, GetHabitacionTableQueryVariables>(
        GetHabitacionTableDocument,
        options
    )
}
export type GetHabitacionTableQueryHookResult = ReturnType<typeof useGetHabitacionTableQuery>
export type GetHabitacionTableLazyQueryHookResult = ReturnType<typeof useGetHabitacionTableLazyQuery>
export type GetHabitacionTableQueryResult = Apollo.QueryResult<
    GetHabitacionTableQuery,
    GetHabitacionTableQueryVariables
>
export const GetClienteResTableDocument = gql`
    query GetClienteResTable($idCliente: ID!) {
        cliente(cliente_id: $idCliente) {
            nombre
        }
    }
`
export type GetClienteResTableComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetClienteResTableQuery, GetClienteResTableQueryVariables>,
    "query"
> &
    ({ variables: GetClienteResTableQueryVariables; skip?: boolean } | { skip: boolean })

export const GetClienteResTableComponent = (props: GetClienteResTableComponentProps) => (
    <ApolloReactComponents.Query<GetClienteResTableQuery, GetClienteResTableQueryVariables>
        query={GetClienteResTableDocument}
        {...props}
    />
)

/**
 * __useGetClienteResTableQuery__
 *
 * To run a query within a React component, call `useGetClienteResTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClienteResTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClienteResTableQuery({
 *   variables: {
 *      idCliente: // value for 'idCliente'
 *   },
 * });
 */
export function useGetClienteResTableQuery(
    baseOptions: Apollo.QueryHookOptions<GetClienteResTableQuery, GetClienteResTableQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetClienteResTableQuery, GetClienteResTableQueryVariables>(
        GetClienteResTableDocument,
        options
    )
}
export function useGetClienteResTableLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetClienteResTableQuery, GetClienteResTableQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetClienteResTableQuery, GetClienteResTableQueryVariables>(
        GetClienteResTableDocument,
        options
    )
}
export type GetClienteResTableQueryHookResult = ReturnType<typeof useGetClienteResTableQuery>
export type GetClienteResTableLazyQueryHookResult = ReturnType<typeof useGetClienteResTableLazyQuery>
export type GetClienteResTableQueryResult = Apollo.QueryResult<
    GetClienteResTableQuery,
    GetClienteResTableQueryVariables
>
export const Actualizar_ReservaDocument = gql`
    mutation Actualizar_reserva($actualizarReservaInput: UpdateReservaInput!) {
        actualizar_reserva(actualizar_reserva_input: $actualizarReservaInput) {
            reserva {
                reserva_id
                folio
            }
        }
    }
`
export type Actualizar_ReservaMutationFn = Apollo.MutationFunction<
    Actualizar_ReservaMutation,
    Actualizar_ReservaMutationVariables
>
export type Actualizar_ReservaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<Actualizar_ReservaMutation, Actualizar_ReservaMutationVariables>,
    "mutation"
>

export const Actualizar_ReservaComponent = (props: Actualizar_ReservaComponentProps) => (
    <ApolloReactComponents.Mutation<Actualizar_ReservaMutation, Actualizar_ReservaMutationVariables>
        mutation={Actualizar_ReservaDocument}
        {...props}
    />
)

/**
 * __useActualizar_ReservaMutation__
 *
 * To run a mutation, you first call `useActualizar_ReservaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizar_ReservaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizarReservaMutation, { data, loading, error }] = useActualizar_ReservaMutation({
 *   variables: {
 *      actualizarReservaInput: // value for 'actualizarReservaInput'
 *   },
 * });
 */
export function useActualizar_ReservaMutation(
    baseOptions?: Apollo.MutationHookOptions<Actualizar_ReservaMutation, Actualizar_ReservaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<Actualizar_ReservaMutation, Actualizar_ReservaMutationVariables>(
        Actualizar_ReservaDocument,
        options
    )
}
export type Actualizar_ReservaMutationHookResult = ReturnType<typeof useActualizar_ReservaMutation>
export type Actualizar_ReservaMutationResult = Apollo.MutationResult<Actualizar_ReservaMutation>
export type Actualizar_ReservaMutationOptions = Apollo.BaseMutationOptions<
    Actualizar_ReservaMutation,
    Actualizar_ReservaMutationVariables
>
export const GetTiposHabitacionDocument = gql`
    query GetTiposHabitacion($hotel_id: ID!) {
        tipo_habitaciones(hotel_id: $hotel_id) {
            nombre
            personas_incluidas
            tipo_habitacion_id
        }
    }
`
export type GetTiposHabitacionComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetTiposHabitacionQuery, GetTiposHabitacionQueryVariables>,
    "query"
> &
    ({ variables: GetTiposHabitacionQueryVariables; skip?: boolean } | { skip: boolean })

export const GetTiposHabitacionComponent = (props: GetTiposHabitacionComponentProps) => (
    <ApolloReactComponents.Query<GetTiposHabitacionQuery, GetTiposHabitacionQueryVariables>
        query={GetTiposHabitacionDocument}
        {...props}
    />
)

/**
 * __useGetTiposHabitacionQuery__
 *
 * To run a query within a React component, call `useGetTiposHabitacionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTiposHabitacionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTiposHabitacionQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetTiposHabitacionQuery(
    baseOptions: Apollo.QueryHookOptions<GetTiposHabitacionQuery, GetTiposHabitacionQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetTiposHabitacionQuery, GetTiposHabitacionQueryVariables>(
        GetTiposHabitacionDocument,
        options
    )
}
export function useGetTiposHabitacionLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetTiposHabitacionQuery, GetTiposHabitacionQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetTiposHabitacionQuery, GetTiposHabitacionQueryVariables>(
        GetTiposHabitacionDocument,
        options
    )
}
export type GetTiposHabitacionQueryHookResult = ReturnType<typeof useGetTiposHabitacionQuery>
export type GetTiposHabitacionLazyQueryHookResult = ReturnType<typeof useGetTiposHabitacionLazyQuery>
export type GetTiposHabitacionQueryResult = Apollo.QueryResult<
    GetTiposHabitacionQuery,
    GetTiposHabitacionQueryVariables
>
export const GetServiciosResewrvaDocument = gql`
    query GetServiciosResewrva {
        servicios {
            nombre
            servicio_id
        }
    }
`
export type GetServiciosResewrvaComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetServiciosResewrvaQuery, GetServiciosResewrvaQueryVariables>,
    "query"
>

export const GetServiciosResewrvaComponent = (props: GetServiciosResewrvaComponentProps) => (
    <ApolloReactComponents.Query<GetServiciosResewrvaQuery, GetServiciosResewrvaQueryVariables>
        query={GetServiciosResewrvaDocument}
        {...props}
    />
)

/**
 * __useGetServiciosResewrvaQuery__
 *
 * To run a query within a React component, call `useGetServiciosResewrvaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiciosResewrvaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiciosResewrvaQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetServiciosResewrvaQuery(
    baseOptions?: Apollo.QueryHookOptions<GetServiciosResewrvaQuery, GetServiciosResewrvaQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetServiciosResewrvaQuery, GetServiciosResewrvaQueryVariables>(
        GetServiciosResewrvaDocument,
        options
    )
}
export function useGetServiciosResewrvaLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetServiciosResewrvaQuery, GetServiciosResewrvaQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetServiciosResewrvaQuery, GetServiciosResewrvaQueryVariables>(
        GetServiciosResewrvaDocument,
        options
    )
}
export type GetServiciosResewrvaQueryHookResult = ReturnType<typeof useGetServiciosResewrvaQuery>
export type GetServiciosResewrvaLazyQueryHookResult = ReturnType<typeof useGetServiciosResewrvaLazyQuery>
export type GetServiciosResewrvaQueryResult = Apollo.QueryResult<
    GetServiciosResewrvaQuery,
    GetServiciosResewrvaQueryVariables
>
export const AddPayReservaDocument = gql`
    mutation AddPayReserva($pago: PayReservaInput!) {
        pagar_reserva(datos_reserva: $pago)
    }
`
export type AddPayReservaMutationFn = Apollo.MutationFunction<AddPayReservaMutation, AddPayReservaMutationVariables>
export type AddPayReservaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<AddPayReservaMutation, AddPayReservaMutationVariables>,
    "mutation"
>

export const AddPayReservaComponent = (props: AddPayReservaComponentProps) => (
    <ApolloReactComponents.Mutation<AddPayReservaMutation, AddPayReservaMutationVariables>
        mutation={AddPayReservaDocument}
        {...props}
    />
)

/**
 * __useAddPayReservaMutation__
 *
 * To run a mutation, you first call `useAddPayReservaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPayReservaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPayReservaMutation, { data, loading, error }] = useAddPayReservaMutation({
 *   variables: {
 *      pago: // value for 'pago'
 *   },
 * });
 */
export function useAddPayReservaMutation(
    baseOptions?: Apollo.MutationHookOptions<AddPayReservaMutation, AddPayReservaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<AddPayReservaMutation, AddPayReservaMutationVariables>(AddPayReservaDocument, options)
}
export type AddPayReservaMutationHookResult = ReturnType<typeof useAddPayReservaMutation>
export type AddPayReservaMutationResult = Apollo.MutationResult<AddPayReservaMutation>
export type AddPayReservaMutationOptions = Apollo.BaseMutationOptions<
    AddPayReservaMutation,
    AddPayReservaMutationVariables
>
export const AgregarPersonaExtraReservaDocument = gql`
    mutation AgregarPersonaExtraReserva($add_extras_reserva_input: AddExtrasReservaInput!) {
        agregar_extras_reserva(add_extras_reserva_input: $add_extras_reserva_input)
    }
`
export type AgregarPersonaExtraReservaMutationFn = Apollo.MutationFunction<
    AgregarPersonaExtraReservaMutation,
    AgregarPersonaExtraReservaMutationVariables
>
export type AgregarPersonaExtraReservaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        AgregarPersonaExtraReservaMutation,
        AgregarPersonaExtraReservaMutationVariables
    >,
    "mutation"
>

export const AgregarPersonaExtraReservaComponent = (props: AgregarPersonaExtraReservaComponentProps) => (
    <ApolloReactComponents.Mutation<AgregarPersonaExtraReservaMutation, AgregarPersonaExtraReservaMutationVariables>
        mutation={AgregarPersonaExtraReservaDocument}
        {...props}
    />
)

/**
 * __useAgregarPersonaExtraReservaMutation__
 *
 * To run a mutation, you first call `useAgregarPersonaExtraReservaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgregarPersonaExtraReservaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agregarPersonaExtraReservaMutation, { data, loading, error }] = useAgregarPersonaExtraReservaMutation({
 *   variables: {
 *      add_extras_reserva_input: // value for 'add_extras_reserva_input'
 *   },
 * });
 */
export function useAgregarPersonaExtraReservaMutation(
    baseOptions?: Apollo.MutationHookOptions<
        AgregarPersonaExtraReservaMutation,
        AgregarPersonaExtraReservaMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<AgregarPersonaExtraReservaMutation, AgregarPersonaExtraReservaMutationVariables>(
        AgregarPersonaExtraReservaDocument,
        options
    )
}
export type AgregarPersonaExtraReservaMutationHookResult = ReturnType<typeof useAgregarPersonaExtraReservaMutation>
export type AgregarPersonaExtraReservaMutationResult = Apollo.MutationResult<AgregarPersonaExtraReservaMutation>
export type AgregarPersonaExtraReservaMutationOptions = Apollo.BaseMutationOptions<
    AgregarPersonaExtraReservaMutation,
    AgregarPersonaExtraReservaMutationVariables
>
export const AddComenDocument = gql`
    mutation AddComen($commentReserva: AddComentarioReservaInput!) {
        agregar_comentario_reserva(AddComentarioReservaInput: $commentReserva)
    }
`
export type AddComenMutationFn = Apollo.MutationFunction<AddComenMutation, AddComenMutationVariables>
export type AddComenComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<AddComenMutation, AddComenMutationVariables>,
    "mutation"
>

export const AddComenComponent = (props: AddComenComponentProps) => (
    <ApolloReactComponents.Mutation<AddComenMutation, AddComenMutationVariables>
        mutation={AddComenDocument}
        {...props}
    />
)

/**
 * __useAddComenMutation__
 *
 * To run a mutation, you first call `useAddComenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddComenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addComenMutation, { data, loading, error }] = useAddComenMutation({
 *   variables: {
 *      commentReserva: // value for 'commentReserva'
 *   },
 * });
 */
export function useAddComenMutation(
    baseOptions?: Apollo.MutationHookOptions<AddComenMutation, AddComenMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<AddComenMutation, AddComenMutationVariables>(AddComenDocument, options)
}
export type AddComenMutationHookResult = ReturnType<typeof useAddComenMutation>
export type AddComenMutationResult = Apollo.MutationResult<AddComenMutation>
export type AddComenMutationOptions = Apollo.BaseMutationOptions<AddComenMutation, AddComenMutationVariables>
export const GetReservacionesCalendarDocument = gql`
    query GetReservacionesCalendar($id: [ID!]!, $hotel_id: ID!) {
        reservas(reserva_id: $id, hotel_id: $hotel_id) {
            fecha_entrada
            fecha_salida
        }
    }
`
export type GetReservacionesCalendarComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetReservacionesCalendarQuery, GetReservacionesCalendarQueryVariables>,
    "query"
> &
    ({ variables: GetReservacionesCalendarQueryVariables; skip?: boolean } | { skip: boolean })

export const GetReservacionesCalendarComponent = (props: GetReservacionesCalendarComponentProps) => (
    <ApolloReactComponents.Query<GetReservacionesCalendarQuery, GetReservacionesCalendarQueryVariables>
        query={GetReservacionesCalendarDocument}
        {...props}
    />
)

/**
 * __useGetReservacionesCalendarQuery__
 *
 * To run a query within a React component, call `useGetReservacionesCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservacionesCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservacionesCalendarQuery({
 *   variables: {
 *      id: // value for 'id'
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetReservacionesCalendarQuery(
    baseOptions: Apollo.QueryHookOptions<GetReservacionesCalendarQuery, GetReservacionesCalendarQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetReservacionesCalendarQuery, GetReservacionesCalendarQueryVariables>(
        GetReservacionesCalendarDocument,
        options
    )
}
export function useGetReservacionesCalendarLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetReservacionesCalendarQuery, GetReservacionesCalendarQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetReservacionesCalendarQuery, GetReservacionesCalendarQueryVariables>(
        GetReservacionesCalendarDocument,
        options
    )
}
export type GetReservacionesCalendarQueryHookResult = ReturnType<typeof useGetReservacionesCalendarQuery>
export type GetReservacionesCalendarLazyQueryHookResult = ReturnType<typeof useGetReservacionesCalendarLazyQuery>
export type GetReservacionesCalendarQueryResult = Apollo.QueryResult<
    GetReservacionesCalendarQuery,
    GetReservacionesCalendarQueryVariables
>
export const UpdateReservaDocument = gql`
    mutation UpdateReserva($AddPersonas: UpdateReservaInput!) {
        actualizar_reserva(actualizar_reserva_input: $AddPersonas) {
            reserva {
                reserva_id
            }
        }
    }
`
export type UpdateReservaMutationFn = Apollo.MutationFunction<UpdateReservaMutation, UpdateReservaMutationVariables>
export type UpdateReservaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<UpdateReservaMutation, UpdateReservaMutationVariables>,
    "mutation"
>

export const UpdateReservaComponent = (props: UpdateReservaComponentProps) => (
    <ApolloReactComponents.Mutation<UpdateReservaMutation, UpdateReservaMutationVariables>
        mutation={UpdateReservaDocument}
        {...props}
    />
)

/**
 * __useUpdateReservaMutation__
 *
 * To run a mutation, you first call `useUpdateReservaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReservaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReservaMutation, { data, loading, error }] = useUpdateReservaMutation({
 *   variables: {
 *      AddPersonas: // value for 'AddPersonas'
 *   },
 * });
 */
export function useUpdateReservaMutation(
    baseOptions?: Apollo.MutationHookOptions<UpdateReservaMutation, UpdateReservaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<UpdateReservaMutation, UpdateReservaMutationVariables>(UpdateReservaDocument, options)
}
export type UpdateReservaMutationHookResult = ReturnType<typeof useUpdateReservaMutation>
export type UpdateReservaMutationResult = Apollo.MutationResult<UpdateReservaMutation>
export type UpdateReservaMutationOptions = Apollo.BaseMutationOptions<
    UpdateReservaMutation,
    UpdateReservaMutationVariables
>
export const GetHabitacionReservaDocument = gql`
    query GetHabitacionReserva($habitacion_id: ID!) {
        habitacion(habitacion_id: $habitacion_id) {
            ultima_renta {
                reserva_id
            }
        }
    }
`
export type GetHabitacionReservaComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetHabitacionReservaQuery, GetHabitacionReservaQueryVariables>,
    "query"
> &
    ({ variables: GetHabitacionReservaQueryVariables; skip?: boolean } | { skip: boolean })

export const GetHabitacionReservaComponent = (props: GetHabitacionReservaComponentProps) => (
    <ApolloReactComponents.Query<GetHabitacionReservaQuery, GetHabitacionReservaQueryVariables>
        query={GetHabitacionReservaDocument}
        {...props}
    />
)

/**
 * __useGetHabitacionReservaQuery__
 *
 * To run a query within a React component, call `useGetHabitacionReservaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHabitacionReservaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHabitacionReservaQuery({
 *   variables: {
 *      habitacion_id: // value for 'habitacion_id'
 *   },
 * });
 */
export function useGetHabitacionReservaQuery(
    baseOptions: Apollo.QueryHookOptions<GetHabitacionReservaQuery, GetHabitacionReservaQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetHabitacionReservaQuery, GetHabitacionReservaQueryVariables>(
        GetHabitacionReservaDocument,
        options
    )
}
export function useGetHabitacionReservaLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetHabitacionReservaQuery, GetHabitacionReservaQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetHabitacionReservaQuery, GetHabitacionReservaQueryVariables>(
        GetHabitacionReservaDocument,
        options
    )
}
export type GetHabitacionReservaQueryHookResult = ReturnType<typeof useGetHabitacionReservaQuery>
export type GetHabitacionReservaLazyQueryHookResult = ReturnType<typeof useGetHabitacionReservaLazyQuery>
export type GetHabitacionReservaQueryResult = Apollo.QueryResult<
    GetHabitacionReservaQuery,
    GetHabitacionReservaQueryVariables
>
export const GetComandaDocument = gql`
    query GetComanda($comanda_id: ID!) {
        comanda(comanda_id: $comanda_id) {
            comanda_id
            estado_comanda
            orden_id
            folio
            orden {
                orden
            }
            detalles_orden(estado: [en_preparacion, por_entregar, en_entrega]) {
                detalle_orden_id
                comanda_id
                orden_id
                cantidad
                estado
                costo_con_iva
                costo_sin_iva
                monto_iva
                comentarios
                almacen_articulo_id
                almacen_articulo {
                    almacen_articulo_id
                    precio
                    articulo_id
                    articulo {
                        articulo_id
                        nombre
                        contenido
                        unidad
                        descripcion
                        tipo
                        extra
                        categoria_id
                        categoria_articulo {
                            nombre
                        }
                    }
                }
                extras {
                    extra_detalle_orden_id
                    detalle_orden_id
                    almacen_articulo_id
                    costo_con_iva
                    costo_sin_iva
                    monto_iva
                    cantidad
                    almacen_articulo {
                        almacen_articulo_id
                        articulo_id
                        precio
                        articulo {
                            nombre
                            contenido
                            unidad
                            descripcion
                            categoria_id
                            tipo
                            extra
                            categoria_articulo {
                                nombre
                            }
                        }
                    }
                }
            }
        }
    }
`
export type GetComandaComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetComandaQuery, GetComandaQueryVariables>,
    "query"
> &
    ({ variables: GetComandaQueryVariables; skip?: boolean } | { skip: boolean })

export const GetComandaComponent = (props: GetComandaComponentProps) => (
    <ApolloReactComponents.Query<GetComandaQuery, GetComandaQueryVariables> query={GetComandaDocument} {...props} />
)

/**
 * __useGetComandaQuery__
 *
 * To run a query within a React component, call `useGetComandaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComandaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComandaQuery({
 *   variables: {
 *      comanda_id: // value for 'comanda_id'
 *   },
 * });
 */
export function useGetComandaQuery(baseOptions: Apollo.QueryHookOptions<GetComandaQuery, GetComandaQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetComandaQuery, GetComandaQueryVariables>(GetComandaDocument, options)
}
export function useGetComandaLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetComandaQuery, GetComandaQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetComandaQuery, GetComandaQueryVariables>(GetComandaDocument, options)
}
export type GetComandaQueryHookResult = ReturnType<typeof useGetComandaQuery>
export type GetComandaLazyQueryHookResult = ReturnType<typeof useGetComandaLazyQuery>
export type GetComandaQueryResult = Apollo.QueryResult<GetComandaQuery, GetComandaQueryVariables>
export const EditarComandaDocument = gql`
    mutation EditarComanda($input: EditComandaInput!) {
        editar_comanda(editComandaInput: $input) {
            comanda_id
        }
    }
`
export type EditarComandaMutationFn = Apollo.MutationFunction<EditarComandaMutation, EditarComandaMutationVariables>
export type EditarComandaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<EditarComandaMutation, EditarComandaMutationVariables>,
    "mutation"
>

export const EditarComandaComponent = (props: EditarComandaComponentProps) => (
    <ApolloReactComponents.Mutation<EditarComandaMutation, EditarComandaMutationVariables>
        mutation={EditarComandaDocument}
        {...props}
    />
)

/**
 * __useEditarComandaMutation__
 *
 * To run a mutation, you first call `useEditarComandaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditarComandaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editarComandaMutation, { data, loading, error }] = useEditarComandaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditarComandaMutation(
    baseOptions?: Apollo.MutationHookOptions<EditarComandaMutation, EditarComandaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<EditarComandaMutation, EditarComandaMutationVariables>(EditarComandaDocument, options)
}
export type EditarComandaMutationHookResult = ReturnType<typeof useEditarComandaMutation>
export type EditarComandaMutationResult = Apollo.MutationResult<EditarComandaMutation>
export type EditarComandaMutationOptions = Apollo.BaseMutationOptions<
    EditarComandaMutation,
    EditarComandaMutationVariables
>
export const UpdatePosicionMesaDocument = gql`
    mutation UpdatePosicionMesa($updatePosicionMesaInput: UpdatePosicionMesaInput!) {
        actualizar_posicion_mesa(updatePosicionMesaRequest: $updatePosicionMesaInput) {
            mesa_id
            posicion {
                x
                y
                tamano
            }
        }
    }
`
export type UpdatePosicionMesaMutationFn = Apollo.MutationFunction<
    UpdatePosicionMesaMutation,
    UpdatePosicionMesaMutationVariables
>
export type UpdatePosicionMesaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<UpdatePosicionMesaMutation, UpdatePosicionMesaMutationVariables>,
    "mutation"
>

export const UpdatePosicionMesaComponent = (props: UpdatePosicionMesaComponentProps) => (
    <ApolloReactComponents.Mutation<UpdatePosicionMesaMutation, UpdatePosicionMesaMutationVariables>
        mutation={UpdatePosicionMesaDocument}
        {...props}
    />
)

/**
 * __useUpdatePosicionMesaMutation__
 *
 * To run a mutation, you first call `useUpdatePosicionMesaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePosicionMesaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePosicionMesaMutation, { data, loading, error }] = useUpdatePosicionMesaMutation({
 *   variables: {
 *      updatePosicionMesaInput: // value for 'updatePosicionMesaInput'
 *   },
 * });
 */
export function useUpdatePosicionMesaMutation(
    baseOptions?: Apollo.MutationHookOptions<UpdatePosicionMesaMutation, UpdatePosicionMesaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<UpdatePosicionMesaMutation, UpdatePosicionMesaMutationVariables>(
        UpdatePosicionMesaDocument,
        options
    )
}
export type UpdatePosicionMesaMutationHookResult = ReturnType<typeof useUpdatePosicionMesaMutation>
export type UpdatePosicionMesaMutationResult = Apollo.MutationResult<UpdatePosicionMesaMutation>
export type UpdatePosicionMesaMutationOptions = Apollo.BaseMutationOptions<
    UpdatePosicionMesaMutation,
    UpdatePosicionMesaMutationVariables
>
export const GetMesasConfigDocument = gql`
    query getMesasConfig($hotel_id: ID!) {
        mesas(hotel_id: $hotel_id, eliminado: false) {
            mesa_id
            numero_mesa
        }
    }
`
export type GetMesasConfigComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetMesasConfigQuery, GetMesasConfigQueryVariables>,
    "query"
> &
    ({ variables: GetMesasConfigQueryVariables; skip?: boolean } | { skip: boolean })

export const GetMesasConfigComponent = (props: GetMesasConfigComponentProps) => (
    <ApolloReactComponents.Query<GetMesasConfigQuery, GetMesasConfigQueryVariables>
        query={GetMesasConfigDocument}
        {...props}
    />
)

/**
 * __useGetMesasConfigQuery__
 *
 * To run a query within a React component, call `useGetMesasConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMesasConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMesasConfigQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetMesasConfigQuery(
    baseOptions: Apollo.QueryHookOptions<GetMesasConfigQuery, GetMesasConfigQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetMesasConfigQuery, GetMesasConfigQueryVariables>(GetMesasConfigDocument, options)
}
export function useGetMesasConfigLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetMesasConfigQuery, GetMesasConfigQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetMesasConfigQuery, GetMesasConfigQueryVariables>(GetMesasConfigDocument, options)
}
export type GetMesasConfigQueryHookResult = ReturnType<typeof useGetMesasConfigQuery>
export type GetMesasConfigLazyQueryHookResult = ReturnType<typeof useGetMesasConfigLazyQuery>
export type GetMesasConfigQueryResult = Apollo.QueryResult<GetMesasConfigQuery, GetMesasConfigQueryVariables>
export const CrearMesaAsignadaDocument = gql`
    mutation CrearMesaAsignada($input: CreateMesaAsignadaInput!) {
        crear_mesa_asignada(CreateMesaAsignadaInput: $input) {
            mesa_id
        }
    }
`
export type CrearMesaAsignadaMutationFn = Apollo.MutationFunction<
    CrearMesaAsignadaMutation,
    CrearMesaAsignadaMutationVariables
>
export type CrearMesaAsignadaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CrearMesaAsignadaMutation, CrearMesaAsignadaMutationVariables>,
    "mutation"
>

export const CrearMesaAsignadaComponent = (props: CrearMesaAsignadaComponentProps) => (
    <ApolloReactComponents.Mutation<CrearMesaAsignadaMutation, CrearMesaAsignadaMutationVariables>
        mutation={CrearMesaAsignadaDocument}
        {...props}
    />
)

/**
 * __useCrearMesaAsignadaMutation__
 *
 * To run a mutation, you first call `useCrearMesaAsignadaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrearMesaAsignadaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crearMesaAsignadaMutation, { data, loading, error }] = useCrearMesaAsignadaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCrearMesaAsignadaMutation(
    baseOptions?: Apollo.MutationHookOptions<CrearMesaAsignadaMutation, CrearMesaAsignadaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CrearMesaAsignadaMutation, CrearMesaAsignadaMutationVariables>(
        CrearMesaAsignadaDocument,
        options
    )
}
export type CrearMesaAsignadaMutationHookResult = ReturnType<typeof useCrearMesaAsignadaMutation>
export type CrearMesaAsignadaMutationResult = Apollo.MutationResult<CrearMesaAsignadaMutation>
export type CrearMesaAsignadaMutationOptions = Apollo.BaseMutationOptions<
    CrearMesaAsignadaMutation,
    CrearMesaAsignadaMutationVariables
>
export const GetRestaurantAreaColaboradoresDocument = gql`
    query GetRestaurantAreaColaboradores($hotel_id: ID, $area_id: ID) {
        colaboradores(en_turno: true, eliminado: false, hotel_id: $hotel_id, area_id: $area_id) {
            colaborador_id
            nombre
            apellido_materno
            apellido_paterno
            foto
        }
    }
`
export type GetRestaurantAreaColaboradoresComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetRestaurantAreaColaboradoresQuery,
        GetRestaurantAreaColaboradoresQueryVariables
    >,
    "query"
>

export const GetRestaurantAreaColaboradoresComponent = (props: GetRestaurantAreaColaboradoresComponentProps) => (
    <ApolloReactComponents.Query<GetRestaurantAreaColaboradoresQuery, GetRestaurantAreaColaboradoresQueryVariables>
        query={GetRestaurantAreaColaboradoresDocument}
        {...props}
    />
)

/**
 * __useGetRestaurantAreaColaboradoresQuery__
 *
 * To run a query within a React component, call `useGetRestaurantAreaColaboradoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantAreaColaboradoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantAreaColaboradoresQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      area_id: // value for 'area_id'
 *   },
 * });
 */
export function useGetRestaurantAreaColaboradoresQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetRestaurantAreaColaboradoresQuery,
        GetRestaurantAreaColaboradoresQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetRestaurantAreaColaboradoresQuery, GetRestaurantAreaColaboradoresQueryVariables>(
        GetRestaurantAreaColaboradoresDocument,
        options
    )
}
export function useGetRestaurantAreaColaboradoresLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetRestaurantAreaColaboradoresQuery,
        GetRestaurantAreaColaboradoresQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetRestaurantAreaColaboradoresQuery, GetRestaurantAreaColaboradoresQueryVariables>(
        GetRestaurantAreaColaboradoresDocument,
        options
    )
}
export type GetRestaurantAreaColaboradoresQueryHookResult = ReturnType<typeof useGetRestaurantAreaColaboradoresQuery>
export type GetRestaurantAreaColaboradoresLazyQueryHookResult = ReturnType<
    typeof useGetRestaurantAreaColaboradoresLazyQuery
>
export type GetRestaurantAreaColaboradoresQueryResult = Apollo.QueryResult<
    GetRestaurantAreaColaboradoresQuery,
    GetRestaurantAreaColaboradoresQueryVariables
>
export const GetAreaRestauranteDocument = gql`
    query GetAreaRestaurante($nombre: String, $hotel_id: ID) {
        areas(hotel_id: $hotel_id, nombre: $nombre, eliminado: false) {
            area_id
        }
    }
`
export type GetAreaRestauranteComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetAreaRestauranteQuery, GetAreaRestauranteQueryVariables>,
    "query"
>

export const GetAreaRestauranteComponent = (props: GetAreaRestauranteComponentProps) => (
    <ApolloReactComponents.Query<GetAreaRestauranteQuery, GetAreaRestauranteQueryVariables>
        query={GetAreaRestauranteDocument}
        {...props}
    />
)

/**
 * __useGetAreaRestauranteQuery__
 *
 * To run a query within a React component, call `useGetAreaRestauranteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreaRestauranteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreaRestauranteQuery({
 *   variables: {
 *      nombre: // value for 'nombre'
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetAreaRestauranteQuery(
    baseOptions?: Apollo.QueryHookOptions<GetAreaRestauranteQuery, GetAreaRestauranteQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetAreaRestauranteQuery, GetAreaRestauranteQueryVariables>(
        GetAreaRestauranteDocument,
        options
    )
}
export function useGetAreaRestauranteLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetAreaRestauranteQuery, GetAreaRestauranteQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetAreaRestauranteQuery, GetAreaRestauranteQueryVariables>(
        GetAreaRestauranteDocument,
        options
    )
}
export type GetAreaRestauranteQueryHookResult = ReturnType<typeof useGetAreaRestauranteQuery>
export type GetAreaRestauranteLazyQueryHookResult = ReturnType<typeof useGetAreaRestauranteLazyQuery>
export type GetAreaRestauranteQueryResult = Apollo.QueryResult<
    GetAreaRestauranteQuery,
    GetAreaRestauranteQueryVariables
>
export const CambiarMesaAsignadaDocument = gql`
    mutation CambiarMesaAsignada($input: CambiarMesaAsignadaInput!, $template_sample: String, $codigo: String) {
        cambiar_mesa_asignada(CambiarMesaAsignadaInput: $input, codigo: $codigo, template_sample: $template_sample) {
            mesa_id
        }
    }
`
export type CambiarMesaAsignadaMutationFn = Apollo.MutationFunction<
    CambiarMesaAsignadaMutation,
    CambiarMesaAsignadaMutationVariables
>
export type CambiarMesaAsignadaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CambiarMesaAsignadaMutation, CambiarMesaAsignadaMutationVariables>,
    "mutation"
>

export const CambiarMesaAsignadaComponent = (props: CambiarMesaAsignadaComponentProps) => (
    <ApolloReactComponents.Mutation<CambiarMesaAsignadaMutation, CambiarMesaAsignadaMutationVariables>
        mutation={CambiarMesaAsignadaDocument}
        {...props}
    />
)

/**
 * __useCambiarMesaAsignadaMutation__
 *
 * To run a mutation, you first call `useCambiarMesaAsignadaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCambiarMesaAsignadaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cambiarMesaAsignadaMutation, { data, loading, error }] = useCambiarMesaAsignadaMutation({
 *   variables: {
 *      input: // value for 'input'
 *      template_sample: // value for 'template_sample'
 *      codigo: // value for 'codigo'
 *   },
 * });
 */
export function useCambiarMesaAsignadaMutation(
    baseOptions?: Apollo.MutationHookOptions<CambiarMesaAsignadaMutation, CambiarMesaAsignadaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CambiarMesaAsignadaMutation, CambiarMesaAsignadaMutationVariables>(
        CambiarMesaAsignadaDocument,
        options
    )
}
export type CambiarMesaAsignadaMutationHookResult = ReturnType<typeof useCambiarMesaAsignadaMutation>
export type CambiarMesaAsignadaMutationResult = Apollo.MutationResult<CambiarMesaAsignadaMutation>
export type CambiarMesaAsignadaMutationOptions = Apollo.BaseMutationOptions<
    CambiarMesaAsignadaMutation,
    CambiarMesaAsignadaMutationVariables
>
export const ActualizarMesaAsignadaDocument = gql`
    mutation ActualizarMesaAsignada($input: UpdateMesaAsignadaInput!) {
        actualizar_mesa_asignada(UpdateMesaAsignadaInput: $input) {
            mesa_id
        }
    }
`
export type ActualizarMesaAsignadaMutationFn = Apollo.MutationFunction<
    ActualizarMesaAsignadaMutation,
    ActualizarMesaAsignadaMutationVariables
>
export type ActualizarMesaAsignadaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        ActualizarMesaAsignadaMutation,
        ActualizarMesaAsignadaMutationVariables
    >,
    "mutation"
>

export const ActualizarMesaAsignadaComponent = (props: ActualizarMesaAsignadaComponentProps) => (
    <ApolloReactComponents.Mutation<ActualizarMesaAsignadaMutation, ActualizarMesaAsignadaMutationVariables>
        mutation={ActualizarMesaAsignadaDocument}
        {...props}
    />
)

/**
 * __useActualizarMesaAsignadaMutation__
 *
 * To run a mutation, you first call `useActualizarMesaAsignadaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizarMesaAsignadaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizarMesaAsignadaMutation, { data, loading, error }] = useActualizarMesaAsignadaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActualizarMesaAsignadaMutation(
    baseOptions?: Apollo.MutationHookOptions<ActualizarMesaAsignadaMutation, ActualizarMesaAsignadaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ActualizarMesaAsignadaMutation, ActualizarMesaAsignadaMutationVariables>(
        ActualizarMesaAsignadaDocument,
        options
    )
}
export type ActualizarMesaAsignadaMutationHookResult = ReturnType<typeof useActualizarMesaAsignadaMutation>
export type ActualizarMesaAsignadaMutationResult = Apollo.MutationResult<ActualizarMesaAsignadaMutation>
export type ActualizarMesaAsignadaMutationOptions = Apollo.BaseMutationOptions<
    ActualizarMesaAsignadaMutation,
    ActualizarMesaAsignadaMutationVariables
>
export const CerrarCuentaMesaAsignadaDocument = gql`
    mutation CerrarCuentaMesaAsignada($cerrarCuentaMesaAsignadaInput: CloseBillMesaAsignadaInput!) {
        cerrar_cuenta_mesa_asignada(cerrarCuentaMesaAsignadaInput: $cerrarCuentaMesaAsignadaInput) {
            mesa_asignada_id
            mesa_id
            orden_id
            fecha_cuenta_cerrada
            fecha_registro
            fecha_salida
            colaborador_asignado_id
            colaborador_atendio {
                nombre
                apellido_paterno
                apellido_materno
            }
        }
    }
`
export type CerrarCuentaMesaAsignadaMutationFn = Apollo.MutationFunction<
    CerrarCuentaMesaAsignadaMutation,
    CerrarCuentaMesaAsignadaMutationVariables
>
export type CerrarCuentaMesaAsignadaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        CerrarCuentaMesaAsignadaMutation,
        CerrarCuentaMesaAsignadaMutationVariables
    >,
    "mutation"
>

export const CerrarCuentaMesaAsignadaComponent = (props: CerrarCuentaMesaAsignadaComponentProps) => (
    <ApolloReactComponents.Mutation<CerrarCuentaMesaAsignadaMutation, CerrarCuentaMesaAsignadaMutationVariables>
        mutation={CerrarCuentaMesaAsignadaDocument}
        {...props}
    />
)

/**
 * __useCerrarCuentaMesaAsignadaMutation__
 *
 * To run a mutation, you first call `useCerrarCuentaMesaAsignadaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCerrarCuentaMesaAsignadaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cerrarCuentaMesaAsignadaMutation, { data, loading, error }] = useCerrarCuentaMesaAsignadaMutation({
 *   variables: {
 *      cerrarCuentaMesaAsignadaInput: // value for 'cerrarCuentaMesaAsignadaInput'
 *   },
 * });
 */
export function useCerrarCuentaMesaAsignadaMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CerrarCuentaMesaAsignadaMutation,
        CerrarCuentaMesaAsignadaMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CerrarCuentaMesaAsignadaMutation, CerrarCuentaMesaAsignadaMutationVariables>(
        CerrarCuentaMesaAsignadaDocument,
        options
    )
}
export type CerrarCuentaMesaAsignadaMutationHookResult = ReturnType<typeof useCerrarCuentaMesaAsignadaMutation>
export type CerrarCuentaMesaAsignadaMutationResult = Apollo.MutationResult<CerrarCuentaMesaAsignadaMutation>
export type CerrarCuentaMesaAsignadaMutationOptions = Apollo.BaseMutationOptions<
    CerrarCuentaMesaAsignadaMutation,
    CerrarCuentaMesaAsignadaMutationVariables
>
export const GetRestaurantOrdenDocument = gql`
    query GetRestaurantOrden($orden_id: ID!) {
        orden(orden_id: $orden_id) {
            orden_id
            orden
            total_con_iva
            total_sin_iva
            pago_id
            pagos {
                pago_id
                detalles_pago {
                    subtotal
                    easyrewards_id
                }
            }
            pago {
                pago_id
                total
            }
            comandas {
                comanda_id
                estado_comanda
                orden_id
                folio
                detalles_orden(estado: [en_preparacion, por_entregar, en_entrega, entregada]) {
                    detalle_orden_id
                    comanda_id
                    cantidad
                    estado
                    costo_con_iva
                    monto_iva
                    almacen_articulo_id
                    almacen_articulo {
                        almacen_articulo_id
                        precio
                        articulo_id
                        categoria_id
                        categoria_articulo {
                            nombre
                        }
                        articulo {
                            articulo_id
                            nombre
                            contenido
                            unidad
                            descripcion
                            tipo
                            extra
                            categoria_id
                            categoria_articulo {
                                nombre
                            }
                        }
                    }
                    extras {
                        extra_detalle_orden_id
                        detalle_orden_id
                        almacen_articulo_id
                        costo_con_iva
                        monto_iva
                        cantidad
                        almacen_articulo {
                            almacen_articulo_id
                            articulo_id
                            precio
                            articulo {
                                nombre
                                contenido
                                unidad
                                descripcion
                                categoria_id
                                tipo
                                extra
                                categoria_articulo {
                                    nombre
                                }
                            }
                        }
                    }
                }
                total_comanda
            }
        }
    }
`
export type GetRestaurantOrdenComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetRestaurantOrdenQuery, GetRestaurantOrdenQueryVariables>,
    "query"
> &
    ({ variables: GetRestaurantOrdenQueryVariables; skip?: boolean } | { skip: boolean })

export const GetRestaurantOrdenComponent = (props: GetRestaurantOrdenComponentProps) => (
    <ApolloReactComponents.Query<GetRestaurantOrdenQuery, GetRestaurantOrdenQueryVariables>
        query={GetRestaurantOrdenDocument}
        {...props}
    />
)

/**
 * __useGetRestaurantOrdenQuery__
 *
 * To run a query within a React component, call `useGetRestaurantOrdenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantOrdenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantOrdenQuery({
 *   variables: {
 *      orden_id: // value for 'orden_id'
 *   },
 * });
 */
export function useGetRestaurantOrdenQuery(
    baseOptions: Apollo.QueryHookOptions<GetRestaurantOrdenQuery, GetRestaurantOrdenQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetRestaurantOrdenQuery, GetRestaurantOrdenQueryVariables>(
        GetRestaurantOrdenDocument,
        options
    )
}
export function useGetRestaurantOrdenLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantOrdenQuery, GetRestaurantOrdenQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetRestaurantOrdenQuery, GetRestaurantOrdenQueryVariables>(
        GetRestaurantOrdenDocument,
        options
    )
}
export type GetRestaurantOrdenQueryHookResult = ReturnType<typeof useGetRestaurantOrdenQuery>
export type GetRestaurantOrdenLazyQueryHookResult = ReturnType<typeof useGetRestaurantOrdenLazyQuery>
export type GetRestaurantOrdenQueryResult = Apollo.QueryResult<
    GetRestaurantOrdenQuery,
    GetRestaurantOrdenQueryVariables
>
export const GetRestaurantColaboradoresDocument = gql`
    query GetRestaurantColaboradores($datos_busqueda: SearchColaboradoresForTaskInput!) {
        colaboradores_disponibles_por_puesto(datos_busqueda: $datos_busqueda) {
            apellido_materno
            apellido_paterno
            nombre
            foto
            colaborador_id
            colaborador_in_hotel {
                puesto {
                    puesto_id
                    nombre
                }
            }
            en_turno
            ultima_tarea {
                fecha_inicio
                fecha_termino
                colaborador_tarea_id
            }
        }
    }
`
export type GetRestaurantColaboradoresComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetRestaurantColaboradoresQuery,
        GetRestaurantColaboradoresQueryVariables
    >,
    "query"
> &
    ({ variables: GetRestaurantColaboradoresQueryVariables; skip?: boolean } | { skip: boolean })

export const GetRestaurantColaboradoresComponent = (props: GetRestaurantColaboradoresComponentProps) => (
    <ApolloReactComponents.Query<GetRestaurantColaboradoresQuery, GetRestaurantColaboradoresQueryVariables>
        query={GetRestaurantColaboradoresDocument}
        {...props}
    />
)

/**
 * __useGetRestaurantColaboradoresQuery__
 *
 * To run a query within a React component, call `useGetRestaurantColaboradoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantColaboradoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantColaboradoresQuery({
 *   variables: {
 *      datos_busqueda: // value for 'datos_busqueda'
 *   },
 * });
 */
export function useGetRestaurantColaboradoresQuery(
    baseOptions: Apollo.QueryHookOptions<GetRestaurantColaboradoresQuery, GetRestaurantColaboradoresQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetRestaurantColaboradoresQuery, GetRestaurantColaboradoresQueryVariables>(
        GetRestaurantColaboradoresDocument,
        options
    )
}
export function useGetRestaurantColaboradoresLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantColaboradoresQuery, GetRestaurantColaboradoresQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetRestaurantColaboradoresQuery, GetRestaurantColaboradoresQueryVariables>(
        GetRestaurantColaboradoresDocument,
        options
    )
}
export type GetRestaurantColaboradoresQueryHookResult = ReturnType<typeof useGetRestaurantColaboradoresQuery>
export type GetRestaurantColaboradoresLazyQueryHookResult = ReturnType<typeof useGetRestaurantColaboradoresLazyQuery>
export type GetRestaurantColaboradoresQueryResult = Apollo.QueryResult<
    GetRestaurantColaboradoresQuery,
    GetRestaurantColaboradoresQueryVariables
>
export const UsuarioDocument = gql`
    query Usuario($usuario_id: ID!) {
        usuario(usuario_id: $usuario_id) {
            apellido_materno
            apellido_paterno
            nombre
        }
    }
`
export type UsuarioComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<UsuarioQuery, UsuarioQueryVariables>,
    "query"
> &
    ({ variables: UsuarioQueryVariables; skip?: boolean } | { skip: boolean })

export const UsuarioComponent = (props: UsuarioComponentProps) => (
    <ApolloReactComponents.Query<UsuarioQuery, UsuarioQueryVariables> query={UsuarioDocument} {...props} />
)

/**
 * __useUsuarioQuery__
 *
 * To run a query within a React component, call `useUsuarioQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsuarioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsuarioQuery({
 *   variables: {
 *      usuario_id: // value for 'usuario_id'
 *   },
 * });
 */
export function useUsuarioQuery(baseOptions: Apollo.QueryHookOptions<UsuarioQuery, UsuarioQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<UsuarioQuery, UsuarioQueryVariables>(UsuarioDocument, options)
}
export function useUsuarioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsuarioQuery, UsuarioQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<UsuarioQuery, UsuarioQueryVariables>(UsuarioDocument, options)
}
export type UsuarioQueryHookResult = ReturnType<typeof useUsuarioQuery>
export type UsuarioLazyQueryHookResult = ReturnType<typeof useUsuarioLazyQuery>
export type UsuarioQueryResult = Apollo.QueryResult<UsuarioQuery, UsuarioQueryVariables>
export const GetMesasDocument = gql`
    query GetMesas($hotel_id: ID!) {
        mesas(hotel_id: $hotel_id, eliminado: false) {
            cantidad_personas
            eliminado
            posicion {
                x
                y
            }
            estado
            fecha_modificacion
            fecha_registro
            hotel_id
            mesa_id
            motivo_bloqueo
            numero_mesa
            usuario_modifico_id
            ultima_asignacion {
                fecha_salida
                colaborador_asignado_id
                colaborador_atendio {
                    nombre
                    apellido_paterno
                    apellido_materno
                }
            }
            asignacion_actual {
                colaborador_asignado_id
                fecha_registro
                fecha_cuenta_cerrada
                fecha_salida
                mesa_asignada_id
                mesa_id
                orden_id
                colaborador_atendio {
                    nombre
                    apellido_paterno
                    apellido_materno
                }
            }
            estado_dinamico {
                estado_activo
                comanda_activa {
                    comanda_id
                    estado_comanda
                    fecha_modificacion
                    fecha_registro
                    folio
                    orden_id
                    total_comanda
                    usuario_id
                    orden {
                        pago {
                            hotel_id
                            pago_id
                            ticket_id
                            usuario_id
                            detalles_pago {
                                detalle_pago_id
                                fecha_pago
                                numero_referencia
                                origen_orden
                                pago_id
                                subtotal
                                tipo_pago
                                ultimos_digitos
                            }
                        }
                    }
                }
            }
        }
    }
`
export type GetMesasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetMesasQuery, GetMesasQueryVariables>,
    "query"
> &
    ({ variables: GetMesasQueryVariables; skip?: boolean } | { skip: boolean })

export const GetMesasComponent = (props: GetMesasComponentProps) => (
    <ApolloReactComponents.Query<GetMesasQuery, GetMesasQueryVariables> query={GetMesasDocument} {...props} />
)

/**
 * __useGetMesasQuery__
 *
 * To run a query within a React component, call `useGetMesasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMesasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMesasQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetMesasQuery(baseOptions: Apollo.QueryHookOptions<GetMesasQuery, GetMesasQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetMesasQuery, GetMesasQueryVariables>(GetMesasDocument, options)
}
export function useGetMesasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMesasQuery, GetMesasQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetMesasQuery, GetMesasQueryVariables>(GetMesasDocument, options)
}
export type GetMesasQueryHookResult = ReturnType<typeof useGetMesasQuery>
export type GetMesasLazyQueryHookResult = ReturnType<typeof useGetMesasLazyQuery>
export type GetMesasQueryResult = Apollo.QueryResult<GetMesasQuery, GetMesasQueryVariables>
export const ActualizarMesaDocument = gql`
    mutation ActualizarMesa($updateMesaInput: UpdateMesaInput!) {
        actualizar_mesa(UpdateMesaInput: $updateMesaInput) {
            hotel_id
            mesa_id
            numero_mesa
            cantidad_personas
            eliminado
            estado
            motivo_bloqueo
            fecha_modificacion
            usuario_modifico_id
            ultima_asignacion {
                colaborador_asignado_id
                colaborador_atendio {
                    nombre
                    apellido_paterno
                    apellido_materno
                }
            }
        }
    }
`
export type ActualizarMesaMutationFn = Apollo.MutationFunction<ActualizarMesaMutation, ActualizarMesaMutationVariables>
export type ActualizarMesaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<ActualizarMesaMutation, ActualizarMesaMutationVariables>,
    "mutation"
>

export const ActualizarMesaComponent = (props: ActualizarMesaComponentProps) => (
    <ApolloReactComponents.Mutation<ActualizarMesaMutation, ActualizarMesaMutationVariables>
        mutation={ActualizarMesaDocument}
        {...props}
    />
)

/**
 * __useActualizarMesaMutation__
 *
 * To run a mutation, you first call `useActualizarMesaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizarMesaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizarMesaMutation, { data, loading, error }] = useActualizarMesaMutation({
 *   variables: {
 *      updateMesaInput: // value for 'updateMesaInput'
 *   },
 * });
 */
export function useActualizarMesaMutation(
    baseOptions?: Apollo.MutationHookOptions<ActualizarMesaMutation, ActualizarMesaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ActualizarMesaMutation, ActualizarMesaMutationVariables>(ActualizarMesaDocument, options)
}
export type ActualizarMesaMutationHookResult = ReturnType<typeof useActualizarMesaMutation>
export type ActualizarMesaMutationResult = Apollo.MutationResult<ActualizarMesaMutation>
export type ActualizarMesaMutationOptions = Apollo.BaseMutationOptions<
    ActualizarMesaMutation,
    ActualizarMesaMutationVariables
>
export const ListenCheckMesasDocument = gql`
    subscription ListenCheckMesas {
        checkMesas {
            hotel_id
            mesa_id
            numero_mesa
            cantidad_personas
            posicion {
                x
                y
            }
            eliminado
            estado
            motivo_bloqueo
            fecha_modificacion
            usuario_modifico_id
            ultima_asignacion {
                fecha_salida
                colaborador_asignado_id
                colaborador_atendio {
                    nombre
                    apellido_paterno
                    apellido_materno
                }
            }
            asignacion_actual {
                colaborador_asignado_id
                fecha_registro
                fecha_cuenta_cerrada
                mesa_asignada_id
                mesa_id
                orden_id
                colaborador_atendio {
                    nombre
                    apellido_paterno
                    apellido_materno
                }
            }
            estado_dinamico {
                estado_activo
                comanda_activa {
                    comanda_id
                    estado_comanda
                    fecha_modificacion
                    fecha_registro
                    folio
                    orden_id
                    total_comanda
                    usuario_id
                }
            }
        }
    }
`
export type ListenCheckMesasComponentProps = Omit<
    ApolloReactComponents.SubscriptionComponentOptions<
        ListenCheckMesasSubscription,
        ListenCheckMesasSubscriptionVariables
    >,
    "subscription"
>

export const ListenCheckMesasComponent = (props: ListenCheckMesasComponentProps) => (
    <ApolloReactComponents.Subscription<ListenCheckMesasSubscription, ListenCheckMesasSubscriptionVariables>
        subscription={ListenCheckMesasDocument}
        {...props}
    />
)

/**
 * __useListenCheckMesasSubscription__
 *
 * To run a query within a React component, call `useListenCheckMesasSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenCheckMesasSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenCheckMesasSubscription({
 *   variables: {
 *   },
 * });
 */
export function useListenCheckMesasSubscription(
    baseOptions?: Apollo.SubscriptionHookOptions<ListenCheckMesasSubscription, ListenCheckMesasSubscriptionVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useSubscription<ListenCheckMesasSubscription, ListenCheckMesasSubscriptionVariables>(
        ListenCheckMesasDocument,
        options
    )
}
export type ListenCheckMesasSubscriptionHookResult = ReturnType<typeof useListenCheckMesasSubscription>
export type ListenCheckMesasSubscriptionResult = Apollo.SubscriptionResult<ListenCheckMesasSubscription>
export const CancelarOrdenDocument = gql`
    mutation CancelarOrden($cancel_orden_input: CancelOrdenInput!) {
        cancelar_orden(cancel_orden_input: $cancel_orden_input) {
            ticket_id
            orden {
                colaborador_id
                comentario
                corte_id
                easyrewards_id
                estado_orden
                estado_pago
                fecha_cobro
                fecha_modificacion
                fecha_registro
                hotel_id
                monto_iva
                orden
                orden_id
                origen_orden
                pago_id
                panel_no_visible
                renta_id
                total_con_iva
                total_productos
                total_sin_iva
                turno_id
                usuario_id
            }
        }
    }
`
export type CancelarOrdenMutationFn = Apollo.MutationFunction<CancelarOrdenMutation, CancelarOrdenMutationVariables>
export type CancelarOrdenComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CancelarOrdenMutation, CancelarOrdenMutationVariables>,
    "mutation"
>

export const CancelarOrdenComponent = (props: CancelarOrdenComponentProps) => (
    <ApolloReactComponents.Mutation<CancelarOrdenMutation, CancelarOrdenMutationVariables>
        mutation={CancelarOrdenDocument}
        {...props}
    />
)

/**
 * __useCancelarOrdenMutation__
 *
 * To run a mutation, you first call `useCancelarOrdenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelarOrdenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelarOrdenMutation, { data, loading, error }] = useCancelarOrdenMutation({
 *   variables: {
 *      cancel_orden_input: // value for 'cancel_orden_input'
 *   },
 * });
 */
export function useCancelarOrdenMutation(
    baseOptions?: Apollo.MutationHookOptions<CancelarOrdenMutation, CancelarOrdenMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CancelarOrdenMutation, CancelarOrdenMutationVariables>(CancelarOrdenDocument, options)
}
export type CancelarOrdenMutationHookResult = ReturnType<typeof useCancelarOrdenMutation>
export type CancelarOrdenMutationResult = Apollo.MutationResult<CancelarOrdenMutation>
export type CancelarOrdenMutationOptions = Apollo.BaseMutationOptions<
    CancelarOrdenMutation,
    CancelarOrdenMutationVariables
>
export const CancelarComandaDocument = gql`
    mutation CancelarComanda($cancelar_comanda: CancelComandaInput!) {
        cancelar_comanda(CancelComandaInput: $cancelar_comanda) {
            ticket_id
            comanda {
                comanda_id
                orden_id
            }
        }
    }
`
export type CancelarComandaMutationFn = Apollo.MutationFunction<
    CancelarComandaMutation,
    CancelarComandaMutationVariables
>
export type CancelarComandaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CancelarComandaMutation, CancelarComandaMutationVariables>,
    "mutation"
>

export const CancelarComandaComponent = (props: CancelarComandaComponentProps) => (
    <ApolloReactComponents.Mutation<CancelarComandaMutation, CancelarComandaMutationVariables>
        mutation={CancelarComandaDocument}
        {...props}
    />
)

/**
 * __useCancelarComandaMutation__
 *
 * To run a mutation, you first call `useCancelarComandaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelarComandaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelarComandaMutation, { data, loading, error }] = useCancelarComandaMutation({
 *   variables: {
 *      cancelar_comanda: // value for 'cancelar_comanda'
 *   },
 * });
 */
export function useCancelarComandaMutation(
    baseOptions?: Apollo.MutationHookOptions<CancelarComandaMutation, CancelarComandaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CancelarComandaMutation, CancelarComandaMutationVariables>(
        CancelarComandaDocument,
        options
    )
}
export type CancelarComandaMutationHookResult = ReturnType<typeof useCancelarComandaMutation>
export type CancelarComandaMutationResult = Apollo.MutationResult<CancelarComandaMutation>
export type CancelarComandaMutationOptions = Apollo.BaseMutationOptions<
    CancelarComandaMutation,
    CancelarComandaMutationVariables
>
export const GetComandaCancelacionDocument = gql`
    query getComandaCancelacion($comanda_id: ID!) {
        comanda(comanda_id: $comanda_id) {
            orden {
                orden
            }
            folio
            comanda_id
            detalles_orden {
                motivo_cancelacion
                fecha_cancelacion
                reembolso
                detalle_orden_id
                comentarios
                almacen_articulo_id
                cantidad
                costo_con_iva
                monto_iva
                almacen_articulo {
                    precio
                    articulo_id
                    categoria_id
                    articulo {
                        articulo_id
                        nombre
                        contenido
                        unidad
                        descripcion
                        tipo
                        extra
                        categoria_id
                        categoria_articulo {
                            nombre
                        }
                    }
                }
                extras {
                    extra_detalle_orden_id
                    detalle_orden_id
                    almacen_articulo_id
                    costo_con_iva
                    monto_iva
                    cantidad
                    almacen_articulo {
                        almacen_articulo_id
                        articulo_id
                        precio
                        articulo {
                            nombre
                            contenido
                            unidad
                            descripcion
                            categoria_id
                            tipo
                            extra
                            categoria_articulo {
                                nombre
                            }
                        }
                    }
                }
            }
        }
    }
`
export type GetComandaCancelacionComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetComandaCancelacionQuery, GetComandaCancelacionQueryVariables>,
    "query"
> &
    ({ variables: GetComandaCancelacionQueryVariables; skip?: boolean } | { skip: boolean })

export const GetComandaCancelacionComponent = (props: GetComandaCancelacionComponentProps) => (
    <ApolloReactComponents.Query<GetComandaCancelacionQuery, GetComandaCancelacionQueryVariables>
        query={GetComandaCancelacionDocument}
        {...props}
    />
)

/**
 * __useGetComandaCancelacionQuery__
 *
 * To run a query within a React component, call `useGetComandaCancelacionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComandaCancelacionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComandaCancelacionQuery({
 *   variables: {
 *      comanda_id: // value for 'comanda_id'
 *   },
 * });
 */
export function useGetComandaCancelacionQuery(
    baseOptions: Apollo.QueryHookOptions<GetComandaCancelacionQuery, GetComandaCancelacionQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetComandaCancelacionQuery, GetComandaCancelacionQueryVariables>(
        GetComandaCancelacionDocument,
        options
    )
}
export function useGetComandaCancelacionLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetComandaCancelacionQuery, GetComandaCancelacionQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetComandaCancelacionQuery, GetComandaCancelacionQueryVariables>(
        GetComandaCancelacionDocument,
        options
    )
}
export type GetComandaCancelacionQueryHookResult = ReturnType<typeof useGetComandaCancelacionQuery>
export type GetComandaCancelacionLazyQueryHookResult = ReturnType<typeof useGetComandaCancelacionLazyQuery>
export type GetComandaCancelacionQueryResult = Apollo.QueryResult<
    GetComandaCancelacionQuery,
    GetComandaCancelacionQueryVariables
>
export const CancelacionOrdenesDocument = gql`
    query CancelacionOrdenes($orden_id: [ID!]!, $hotel_id: ID!, $fecha_registro: DateSearchInput) {
        ordenes(orden_id: $orden_id, hotel_id: $hotel_id, fecha_registro: $fecha_registro) {
            orden
            orden_id
            estado_pago
            estado_orden
            origen_orden
            fecha_registro
            fecha_modificacion
            total_con_iva
            total_sin_iva
            colaborador_id
            renta_id
            turno_id
            turno {
                nombre
            }
            colaborador_entrega {
                nombre
                apellido_materno
                apellido_paterno
            }
            renta {
                habitacion_id
                habitacion {
                    numero_habitacion
                    tipo_habitacion_id
                    tipo_habitacion {
                        nombre
                    }
                }
            }
            detalles_orden {
                motivo_cancelacion
                fecha_cancelacion
                reembolso
                detalle_orden_id
                comentarios
                almacen_articulo_id
                cantidad
                costo_con_iva
                monto_iva
                almacen_articulo {
                    categoria_id
                    categoria_articulo {
                        nombre
                    }
                    precio
                    articulo_id
                    articulo {
                        articulo_id
                        nombre
                        contenido
                        unidad
                        descripcion
                        tipo
                        extra
                        categoria_id
                        categoria_articulo {
                            nombre
                        }
                    }
                }
                extras {
                    extra_detalle_orden_id
                    detalle_orden_id
                    almacen_articulo_id
                    costo_con_iva
                    monto_iva
                    cantidad
                    almacen_articulo {
                        almacen_articulo_id
                        articulo_id
                        precio
                        articulo {
                            nombre
                            contenido
                            unidad
                            descripcion
                            categoria_id
                            tipo
                            extra
                            categoria_articulo {
                                nombre
                            }
                        }
                    }
                }
            }
            easyrewards_id
            pago_id
            pago {
                pago_id
                fecha_pago
                total
                ticket_id
                detalles_pago {
                    detalle_pago_id
                    pago_id
                    ultimos_digitos
                    subtotal
                    tipo_pago
                    numero_referencia
                    easyrewards_id
                }
            }
            propina {
                total
                propina_id
                detalles_pago {
                    ultimos_digitos
                    tipo_pago
                    subtotal
                }
            }
            mesa {
                numero_mesa
            }
        }
    }
`
export type CancelacionOrdenesComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<CancelacionOrdenesQuery, CancelacionOrdenesQueryVariables>,
    "query"
> &
    ({ variables: CancelacionOrdenesQueryVariables; skip?: boolean } | { skip: boolean })

export const CancelacionOrdenesComponent = (props: CancelacionOrdenesComponentProps) => (
    <ApolloReactComponents.Query<CancelacionOrdenesQuery, CancelacionOrdenesQueryVariables>
        query={CancelacionOrdenesDocument}
        {...props}
    />
)

/**
 * __useCancelacionOrdenesQuery__
 *
 * To run a query within a React component, call `useCancelacionOrdenesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCancelacionOrdenesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCancelacionOrdenesQuery({
 *   variables: {
 *      orden_id: // value for 'orden_id'
 *      hotel_id: // value for 'hotel_id'
 *      fecha_registro: // value for 'fecha_registro'
 *   },
 * });
 */
export function useCancelacionOrdenesQuery(
    baseOptions: Apollo.QueryHookOptions<CancelacionOrdenesQuery, CancelacionOrdenesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<CancelacionOrdenesQuery, CancelacionOrdenesQueryVariables>(
        CancelacionOrdenesDocument,
        options
    )
}
export function useCancelacionOrdenesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<CancelacionOrdenesQuery, CancelacionOrdenesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<CancelacionOrdenesQuery, CancelacionOrdenesQueryVariables>(
        CancelacionOrdenesDocument,
        options
    )
}
export type CancelacionOrdenesQueryHookResult = ReturnType<typeof useCancelacionOrdenesQuery>
export type CancelacionOrdenesLazyQueryHookResult = ReturnType<typeof useCancelacionOrdenesLazyQuery>
export type CancelacionOrdenesQueryResult = Apollo.QueryResult<
    CancelacionOrdenesQuery,
    CancelacionOrdenesQueryVariables
>
export const CategoriasArticulosDocument = gql`
    query CategoriasArticulos($hotel_id: ID!) {
        categorias_articulos(hotel_id: $hotel_id, eliminado: false) {
            nombre
            descripcion
            hotel_id
            categoria_id
            total_articulos
            eliminado
            porcentaje_aportacion_propinas
        }
    }
`
export type CategoriasArticulosComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<CategoriasArticulosQuery, CategoriasArticulosQueryVariables>,
    "query"
> &
    ({ variables: CategoriasArticulosQueryVariables; skip?: boolean } | { skip: boolean })

export const CategoriasArticulosComponent = (props: CategoriasArticulosComponentProps) => (
    <ApolloReactComponents.Query<CategoriasArticulosQuery, CategoriasArticulosQueryVariables>
        query={CategoriasArticulosDocument}
        {...props}
    />
)

/**
 * __useCategoriasArticulosQuery__
 *
 * To run a query within a React component, call `useCategoriasArticulosQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriasArticulosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriasArticulosQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useCategoriasArticulosQuery(
    baseOptions: Apollo.QueryHookOptions<CategoriasArticulosQuery, CategoriasArticulosQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<CategoriasArticulosQuery, CategoriasArticulosQueryVariables>(
        CategoriasArticulosDocument,
        options
    )
}
export function useCategoriasArticulosLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<CategoriasArticulosQuery, CategoriasArticulosQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<CategoriasArticulosQuery, CategoriasArticulosQueryVariables>(
        CategoriasArticulosDocument,
        options
    )
}
export type CategoriasArticulosQueryHookResult = ReturnType<typeof useCategoriasArticulosQuery>
export type CategoriasArticulosLazyQueryHookResult = ReturnType<typeof useCategoriasArticulosLazyQuery>
export type CategoriasArticulosQueryResult = Apollo.QueryResult<
    CategoriasArticulosQuery,
    CategoriasArticulosQueryVariables
>
export const CrearOrdenDocument = gql`
    mutation CrearOrden($create_orden_input: CreateOrdenInput!) {
        crear_orden(create_orden_input: $create_orden_input) {
            orden {
                orden
                orden_id
                virtual_comanda_id
                consumo_interno_colaborador_id
                comanda {
                    folio
                }
                pago_id
                pago {
                    ticket_id
                    detalles_pago {
                        easyrewards_id
                        __typename
                    }
                    __typename
                }
                easyrewards_id
                __typename
            }
            __typename
        }
    }
`
export type CrearOrdenMutationFn = Apollo.MutationFunction<CrearOrdenMutation, CrearOrdenMutationVariables>
export type CrearOrdenComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CrearOrdenMutation, CrearOrdenMutationVariables>,
    "mutation"
>

export const CrearOrdenComponent = (props: CrearOrdenComponentProps) => (
    <ApolloReactComponents.Mutation<CrearOrdenMutation, CrearOrdenMutationVariables>
        mutation={CrearOrdenDocument}
        {...props}
    />
)

/**
 * __useCrearOrdenMutation__
 *
 * To run a mutation, you first call `useCrearOrdenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrearOrdenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crearOrdenMutation, { data, loading, error }] = useCrearOrdenMutation({
 *   variables: {
 *      create_orden_input: // value for 'create_orden_input'
 *   },
 * });
 */
export function useCrearOrdenMutation(
    baseOptions?: Apollo.MutationHookOptions<CrearOrdenMutation, CrearOrdenMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CrearOrdenMutation, CrearOrdenMutationVariables>(CrearOrdenDocument, options)
}
export type CrearOrdenMutationHookResult = ReturnType<typeof useCrearOrdenMutation>
export type CrearOrdenMutationResult = Apollo.MutationResult<CrearOrdenMutation>
export type CrearOrdenMutationOptions = Apollo.BaseMutationOptions<CrearOrdenMutation, CrearOrdenMutationVariables>
export const ActualizarOrdenDocument = gql`
    mutation ActualizarOrden($update_orden_input: UpdateOrdenInput!) {
        actualizar_orden(UpdateOrdenInput: $update_orden_input)
    }
`
export type ActualizarOrdenMutationFn = Apollo.MutationFunction<
    ActualizarOrdenMutation,
    ActualizarOrdenMutationVariables
>
export type ActualizarOrdenComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<ActualizarOrdenMutation, ActualizarOrdenMutationVariables>,
    "mutation"
>

export const ActualizarOrdenComponent = (props: ActualizarOrdenComponentProps) => (
    <ApolloReactComponents.Mutation<ActualizarOrdenMutation, ActualizarOrdenMutationVariables>
        mutation={ActualizarOrdenDocument}
        {...props}
    />
)

/**
 * __useActualizarOrdenMutation__
 *
 * To run a mutation, you first call `useActualizarOrdenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizarOrdenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizarOrdenMutation, { data, loading, error }] = useActualizarOrdenMutation({
 *   variables: {
 *      update_orden_input: // value for 'update_orden_input'
 *   },
 * });
 */
export function useActualizarOrdenMutation(
    baseOptions?: Apollo.MutationHookOptions<ActualizarOrdenMutation, ActualizarOrdenMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ActualizarOrdenMutation, ActualizarOrdenMutationVariables>(
        ActualizarOrdenDocument,
        options
    )
}
export type ActualizarOrdenMutationHookResult = ReturnType<typeof useActualizarOrdenMutation>
export type ActualizarOrdenMutationResult = Apollo.MutationResult<ActualizarOrdenMutation>
export type ActualizarOrdenMutationOptions = Apollo.BaseMutationOptions<
    ActualizarOrdenMutation,
    ActualizarOrdenMutationVariables
>
export const GetOrdenEditDocument = gql`
    query getOrdenEdit($input: ID!) {
        orden(orden_id: $input) {
            orden_id
            orden
            detalles_orden {
                costo_con_iva
                costo_sin_iva
                comanda_id
                comentarios
                detalle_orden_id
                cantidad
                comentarios
                extras {
                    extra_detalle_orden_id
                    cantidad
                    almacen_articulo_id
                    almacen_articulo {
                        costo
                        precio
                        articulo {
                            nombre
                            categoria_id
                            categoria_articulo {
                                nombre
                            }
                        }
                    }
                }
                almacen_articulo_id
                almacen_articulo {
                    almacen_articulo_id
                    articulo_id
                    costo
                    precio
                    articulo {
                        articulo_id
                        nombre
                        categoria_id
                        categoria_articulo {
                            categoria_id
                            nombre
                        }
                    }
                }
            }
        }
    }
`
export type GetOrdenEditComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetOrdenEditQuery, GetOrdenEditQueryVariables>,
    "query"
> &
    ({ variables: GetOrdenEditQueryVariables; skip?: boolean } | { skip: boolean })

export const GetOrdenEditComponent = (props: GetOrdenEditComponentProps) => (
    <ApolloReactComponents.Query<GetOrdenEditQuery, GetOrdenEditQueryVariables>
        query={GetOrdenEditDocument}
        {...props}
    />
)

/**
 * __useGetOrdenEditQuery__
 *
 * To run a query within a React component, call `useGetOrdenEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdenEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdenEditQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrdenEditQuery(
    baseOptions: Apollo.QueryHookOptions<GetOrdenEditQuery, GetOrdenEditQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetOrdenEditQuery, GetOrdenEditQueryVariables>(GetOrdenEditDocument, options)
}
export function useGetOrdenEditLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetOrdenEditQuery, GetOrdenEditQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetOrdenEditQuery, GetOrdenEditQueryVariables>(GetOrdenEditDocument, options)
}
export type GetOrdenEditQueryHookResult = ReturnType<typeof useGetOrdenEditQuery>
export type GetOrdenEditLazyQueryHookResult = ReturnType<typeof useGetOrdenEditLazyQuery>
export type GetOrdenEditQueryResult = Apollo.QueryResult<GetOrdenEditQuery, GetOrdenEditQueryVariables>
export const GetOrdenForUpdateDocument = gql`
    query GetOrdenForUpdate($orden_id: ID!) {
        orden(orden_id: $orden_id) {
            orden
            estado_orden
            orden_id
            detalles_orden(estado: [en_preparacion, por_entregar, en_entrega]) {
                detalle_orden_id
                comanda_id
                orden_id
                cantidad
                estado
                costo_con_iva
                costo_sin_iva
                monto_iva
                comentarios
                almacen_articulo_id
                almacen_articulo {
                    almacen_articulo_id
                    precio
                    articulo_id
                    articulo {
                        articulo_id
                        nombre
                        contenido
                        unidad
                        descripcion
                        tipo
                        extra
                        categoria_id
                        categoria_articulo {
                            nombre
                        }
                    }
                }
                extras {
                    extra_detalle_orden_id
                    detalle_orden_id
                    almacen_articulo_id
                    costo_con_iva
                    costo_sin_iva
                    monto_iva
                    cantidad
                    almacen_articulo {
                        almacen_articulo_id
                        articulo_id
                        precio
                        articulo {
                            nombre
                            contenido
                            unidad
                            descripcion
                            categoria_id
                            tipo
                            extra
                            categoria_articulo {
                                nombre
                            }
                        }
                    }
                }
            }
        }
    }
`
export type GetOrdenForUpdateComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetOrdenForUpdateQuery, GetOrdenForUpdateQueryVariables>,
    "query"
> &
    ({ variables: GetOrdenForUpdateQueryVariables; skip?: boolean } | { skip: boolean })

export const GetOrdenForUpdateComponent = (props: GetOrdenForUpdateComponentProps) => (
    <ApolloReactComponents.Query<GetOrdenForUpdateQuery, GetOrdenForUpdateQueryVariables>
        query={GetOrdenForUpdateDocument}
        {...props}
    />
)

/**
 * __useGetOrdenForUpdateQuery__
 *
 * To run a query within a React component, call `useGetOrdenForUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdenForUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdenForUpdateQuery({
 *   variables: {
 *      orden_id: // value for 'orden_id'
 *   },
 * });
 */
export function useGetOrdenForUpdateQuery(
    baseOptions: Apollo.QueryHookOptions<GetOrdenForUpdateQuery, GetOrdenForUpdateQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetOrdenForUpdateQuery, GetOrdenForUpdateQueryVariables>(GetOrdenForUpdateDocument, options)
}
export function useGetOrdenForUpdateLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetOrdenForUpdateQuery, GetOrdenForUpdateQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetOrdenForUpdateQuery, GetOrdenForUpdateQueryVariables>(
        GetOrdenForUpdateDocument,
        options
    )
}
export type GetOrdenForUpdateQueryHookResult = ReturnType<typeof useGetOrdenForUpdateQuery>
export type GetOrdenForUpdateLazyQueryHookResult = ReturnType<typeof useGetOrdenForUpdateLazyQuery>
export type GetOrdenForUpdateQueryResult = Apollo.QueryResult<GetOrdenForUpdateQuery, GetOrdenForUpdateQueryVariables>
export const EditarOrdenDocument = gql`
    mutation EditarOrden($input: EditOrdenInput!) {
        editar_orden(EditOrdenInput: $input) {
            orden_id
        }
    }
`
export type EditarOrdenMutationFn = Apollo.MutationFunction<EditarOrdenMutation, EditarOrdenMutationVariables>
export type EditarOrdenComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<EditarOrdenMutation, EditarOrdenMutationVariables>,
    "mutation"
>

export const EditarOrdenComponent = (props: EditarOrdenComponentProps) => (
    <ApolloReactComponents.Mutation<EditarOrdenMutation, EditarOrdenMutationVariables>
        mutation={EditarOrdenDocument}
        {...props}
    />
)

/**
 * __useEditarOrdenMutation__
 *
 * To run a mutation, you first call `useEditarOrdenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditarOrdenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editarOrdenMutation, { data, loading, error }] = useEditarOrdenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditarOrdenMutation(
    baseOptions?: Apollo.MutationHookOptions<EditarOrdenMutation, EditarOrdenMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<EditarOrdenMutation, EditarOrdenMutationVariables>(EditarOrdenDocument, options)
}
export type EditarOrdenMutationHookResult = ReturnType<typeof useEditarOrdenMutation>
export type EditarOrdenMutationResult = Apollo.MutationResult<EditarOrdenMutation>
export type EditarOrdenMutationOptions = Apollo.BaseMutationOptions<EditarOrdenMutation, EditarOrdenMutationVariables>
export const GetOrdenesHistorialDocument = gql`
    query GetOrdenesHistorial(
        $hotel_id: ID
        $fecha_registro: DateSearchInput
        $pagination_options: PageOptionsArgs!
        $tipo_orden: TipoOrden!
        $numero_orden: String
    ) {
        historial_estados_orden(
            hotel_id: $hotel_id
            fecha_registro: $fecha_registro
            pagination_options: $pagination_options
            tipo_orden: $tipo_orden
            numero_orden: $numero_orden
        ) {
            paginacion {
                pagina_actual
                total_paginas
                total_registros
            }
            historial_estados_orden {
                estado_orden
                fecha_registro
                historial_estado_orden_id
                orden_id
                tiempo_en_entrega
                tiempo_en_preparacion
                tiempo_por_entregar
                tiempo_total
                orden {
                    orden_id
                    orden
                    turno_id
                    estado_orden
                    estado_pago
                    origen_orden
                    renta_id
                    turno {
                        nombre
                    }
                    renta {
                        habitacion_id
                        habitacion {
                            numero_habitacion
                            tipo_habitacion_id
                            tipo_habitacion {
                                nombre
                            }
                        }
                    }
                    fecha_cobro
                    fecha_registro
                    colaborador_id
                    colaborador_entrega {
                        nombre
                        apellido_paterno
                        apellido_materno
                    }
                    total_con_iva
                    pago_id
                    pago {
                        pago_id
                        total
                        detalles_pago {
                            tipo_pago
                        }
                    }
                    comanda {
                        folio
                    }
                    mesa {
                        numero_mesa
                    }
                }
            }
        }
    }
`
export type GetOrdenesHistorialComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetOrdenesHistorialQuery, GetOrdenesHistorialQueryVariables>,
    "query"
> &
    ({ variables: GetOrdenesHistorialQueryVariables; skip?: boolean } | { skip: boolean })

export const GetOrdenesHistorialComponent = (props: GetOrdenesHistorialComponentProps) => (
    <ApolloReactComponents.Query<GetOrdenesHistorialQuery, GetOrdenesHistorialQueryVariables>
        query={GetOrdenesHistorialDocument}
        {...props}
    />
)

/**
 * __useGetOrdenesHistorialQuery__
 *
 * To run a query within a React component, call `useGetOrdenesHistorialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdenesHistorialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdenesHistorialQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      fecha_registro: // value for 'fecha_registro'
 *      pagination_options: // value for 'pagination_options'
 *      tipo_orden: // value for 'tipo_orden'
 *      numero_orden: // value for 'numero_orden'
 *   },
 * });
 */
export function useGetOrdenesHistorialQuery(
    baseOptions: Apollo.QueryHookOptions<GetOrdenesHistorialQuery, GetOrdenesHistorialQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetOrdenesHistorialQuery, GetOrdenesHistorialQueryVariables>(
        GetOrdenesHistorialDocument,
        options
    )
}
export function useGetOrdenesHistorialLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetOrdenesHistorialQuery, GetOrdenesHistorialQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetOrdenesHistorialQuery, GetOrdenesHistorialQueryVariables>(
        GetOrdenesHistorialDocument,
        options
    )
}
export type GetOrdenesHistorialQueryHookResult = ReturnType<typeof useGetOrdenesHistorialQuery>
export type GetOrdenesHistorialLazyQueryHookResult = ReturnType<typeof useGetOrdenesHistorialLazyQuery>
export type GetOrdenesHistorialQueryResult = Apollo.QueryResult<
    GetOrdenesHistorialQuery,
    GetOrdenesHistorialQueryVariables
>
export const GetComandasHistorialDocument = gql`
    query GetComandasHistorial(
        $hotel_id: ID
        $fecha_registro: DateSearchInput
        $pagination_options: PageOptionsArgs!
        $numero_orden: String
        $numero_mesa: [String!]
    ) {
        historial_estados_comanda(
            hotel_id: $hotel_id
            fecha_registro: $fecha_registro
            pagination_options: $pagination_options
            numero_orden: $numero_orden
            numero_mesa: $numero_mesa
        ) {
            paginacion {
                pagina_actual
                total_paginas
                total_registros
            }
            historial_estados_comanda {
                historial_estado_comanda_id
                comanda_id
                comanda {
                    orden_id
                    comanda_id
                    fecha_registro
                    folio
                    total_comanda
                    orden {
                        orden_id
                        orden
                        colaborador_id
                        estado_pago
                        estado_orden
                        origen_orden
                        colaborador_entrega {
                            nombre
                            apellido_paterno
                            apellido_materno
                        }
                        mesa {
                            numero_mesa
                        }
                        pago_id
                        pago {
                            pago_id
                            detalles_pago {
                                tipo_pago
                            }
                        }
                        turno_id
                        turno {
                            nombre
                        }
                    }
                }
                hotel_id
                tiempo_en_preparacion
                tiempo_por_entregar
                tiempo_total
            }
        }
    }
`
export type GetComandasHistorialComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetComandasHistorialQuery, GetComandasHistorialQueryVariables>,
    "query"
> &
    ({ variables: GetComandasHistorialQueryVariables; skip?: boolean } | { skip: boolean })

export const GetComandasHistorialComponent = (props: GetComandasHistorialComponentProps) => (
    <ApolloReactComponents.Query<GetComandasHistorialQuery, GetComandasHistorialQueryVariables>
        query={GetComandasHistorialDocument}
        {...props}
    />
)

/**
 * __useGetComandasHistorialQuery__
 *
 * To run a query within a React component, call `useGetComandasHistorialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComandasHistorialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComandasHistorialQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      fecha_registro: // value for 'fecha_registro'
 *      pagination_options: // value for 'pagination_options'
 *      numero_orden: // value for 'numero_orden'
 *      numero_mesa: // value for 'numero_mesa'
 *   },
 * });
 */
export function useGetComandasHistorialQuery(
    baseOptions: Apollo.QueryHookOptions<GetComandasHistorialQuery, GetComandasHistorialQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetComandasHistorialQuery, GetComandasHistorialQueryVariables>(
        GetComandasHistorialDocument,
        options
    )
}
export function useGetComandasHistorialLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetComandasHistorialQuery, GetComandasHistorialQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetComandasHistorialQuery, GetComandasHistorialQueryVariables>(
        GetComandasHistorialDocument,
        options
    )
}
export type GetComandasHistorialQueryHookResult = ReturnType<typeof useGetComandasHistorialQuery>
export type GetComandasHistorialLazyQueryHookResult = ReturnType<typeof useGetComandasHistorialLazyQuery>
export type GetComandasHistorialQueryResult = Apollo.QueryResult<
    GetComandasHistorialQuery,
    GetComandasHistorialQueryVariables
>
export const GetOrdenesHistorialCountDocument = gql`
    query GetOrdenesHistorialCount($hotel_id: ID, $fecha_registro: DateSearchInput!, $tipo_orden: TipoOrden!) {
        historial_estados_orden(hotel_id: $hotel_id, fecha_registro: $fecha_registro, tipo_orden: $tipo_orden) {
            paginacion {
                total_registros
            }
        }
    }
`
export type GetOrdenesHistorialCountComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetOrdenesHistorialCountQuery, GetOrdenesHistorialCountQueryVariables>,
    "query"
> &
    ({ variables: GetOrdenesHistorialCountQueryVariables; skip?: boolean } | { skip: boolean })

export const GetOrdenesHistorialCountComponent = (props: GetOrdenesHistorialCountComponentProps) => (
    <ApolloReactComponents.Query<GetOrdenesHistorialCountQuery, GetOrdenesHistorialCountQueryVariables>
        query={GetOrdenesHistorialCountDocument}
        {...props}
    />
)

/**
 * __useGetOrdenesHistorialCountQuery__
 *
 * To run a query within a React component, call `useGetOrdenesHistorialCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdenesHistorialCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdenesHistorialCountQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      fecha_registro: // value for 'fecha_registro'
 *      tipo_orden: // value for 'tipo_orden'
 *   },
 * });
 */
export function useGetOrdenesHistorialCountQuery(
    baseOptions: Apollo.QueryHookOptions<GetOrdenesHistorialCountQuery, GetOrdenesHistorialCountQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetOrdenesHistorialCountQuery, GetOrdenesHistorialCountQueryVariables>(
        GetOrdenesHistorialCountDocument,
        options
    )
}
export function useGetOrdenesHistorialCountLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetOrdenesHistorialCountQuery, GetOrdenesHistorialCountQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetOrdenesHistorialCountQuery, GetOrdenesHistorialCountQueryVariables>(
        GetOrdenesHistorialCountDocument,
        options
    )
}
export type GetOrdenesHistorialCountQueryHookResult = ReturnType<typeof useGetOrdenesHistorialCountQuery>
export type GetOrdenesHistorialCountLazyQueryHookResult = ReturnType<typeof useGetOrdenesHistorialCountLazyQuery>
export type GetOrdenesHistorialCountQueryResult = Apollo.QueryResult<
    GetOrdenesHistorialCountQuery,
    GetOrdenesHistorialCountQueryVariables
>
export const GetComandasHistorialCountDocument = gql`
    query GetComandasHistorialCount($hotel_id: ID, $fecha_registro: DateSearchInput!) {
        historial_estados_comanda(hotel_id: $hotel_id, fecha_registro: $fecha_registro) {
            paginacion {
                total_registros
            }
        }
    }
`
export type GetComandasHistorialCountComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetComandasHistorialCountQuery,
        GetComandasHistorialCountQueryVariables
    >,
    "query"
> &
    ({ variables: GetComandasHistorialCountQueryVariables; skip?: boolean } | { skip: boolean })

export const GetComandasHistorialCountComponent = (props: GetComandasHistorialCountComponentProps) => (
    <ApolloReactComponents.Query<GetComandasHistorialCountQuery, GetComandasHistorialCountQueryVariables>
        query={GetComandasHistorialCountDocument}
        {...props}
    />
)

/**
 * __useGetComandasHistorialCountQuery__
 *
 * To run a query within a React component, call `useGetComandasHistorialCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComandasHistorialCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComandasHistorialCountQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      fecha_registro: // value for 'fecha_registro'
 *   },
 * });
 */
export function useGetComandasHistorialCountQuery(
    baseOptions: Apollo.QueryHookOptions<GetComandasHistorialCountQuery, GetComandasHistorialCountQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetComandasHistorialCountQuery, GetComandasHistorialCountQueryVariables>(
        GetComandasHistorialCountDocument,
        options
    )
}
export function useGetComandasHistorialCountLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetComandasHistorialCountQuery, GetComandasHistorialCountQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetComandasHistorialCountQuery, GetComandasHistorialCountQueryVariables>(
        GetComandasHistorialCountDocument,
        options
    )
}
export type GetComandasHistorialCountQueryHookResult = ReturnType<typeof useGetComandasHistorialCountQuery>
export type GetComandasHistorialCountLazyQueryHookResult = ReturnType<typeof useGetComandasHistorialCountLazyQuery>
export type GetComandasHistorialCountQueryResult = Apollo.QueryResult<
    GetComandasHistorialCountQuery,
    GetComandasHistorialCountQueryVariables
>
export const GetNumeroMesasDocument = gql`
    query GetNumeroMesas($hotel_id: ID!) {
        mesas(hotel_id: $hotel_id) {
            mesa_id
            numero_mesa
        }
    }
`
export type GetNumeroMesasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetNumeroMesasQuery, GetNumeroMesasQueryVariables>,
    "query"
> &
    ({ variables: GetNumeroMesasQueryVariables; skip?: boolean } | { skip: boolean })

export const GetNumeroMesasComponent = (props: GetNumeroMesasComponentProps) => (
    <ApolloReactComponents.Query<GetNumeroMesasQuery, GetNumeroMesasQueryVariables>
        query={GetNumeroMesasDocument}
        {...props}
    />
)

/**
 * __useGetNumeroMesasQuery__
 *
 * To run a query within a React component, call `useGetNumeroMesasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumeroMesasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumeroMesasQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetNumeroMesasQuery(
    baseOptions: Apollo.QueryHookOptions<GetNumeroMesasQuery, GetNumeroMesasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetNumeroMesasQuery, GetNumeroMesasQueryVariables>(GetNumeroMesasDocument, options)
}
export function useGetNumeroMesasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetNumeroMesasQuery, GetNumeroMesasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetNumeroMesasQuery, GetNumeroMesasQueryVariables>(GetNumeroMesasDocument, options)
}
export type GetNumeroMesasQueryHookResult = ReturnType<typeof useGetNumeroMesasQuery>
export type GetNumeroMesasLazyQueryHookResult = ReturnType<typeof useGetNumeroMesasLazyQuery>
export type GetNumeroMesasQueryResult = Apollo.QueryResult<GetNumeroMesasQuery, GetNumeroMesasQueryVariables>
export const OrdenesDocument = gql`
    query Ordenes($orden_id: [ID!]!, $hotel_id: ID!, $fecha_registro: DateSearchInput) {
        ordenes(orden_id: $orden_id, hotel_id: $hotel_id, fecha_registro: $fecha_registro) {
            orden
            orden_id
            estado_pago
            estado_orden
            origen_orden
            fecha_registro
            fecha_modificacion
            total_con_iva
            total_sin_iva
            colaborador_id
            renta_id
            turno_id
            turno {
                nombre
            }
            consumo_interno_colaborador_id
            usuario_id
            usuario {
                nombre
            }
            colaborador_entrega {
                nombre
                apellido_materno
                apellido_paterno
            }
            renta {
                habitacion_id
                habitacion {
                    numero_habitacion
                    tipo_habitacion_id
                    tipo_habitacion {
                        nombre
                    }
                }
            }
            detalles_orden {
                detalle_orden_id
                estado
                motivo_cancelacion
                fecha_cancelacion
                reembolso
                comentarios
                almacen_articulo_id
                cantidad
                costo_con_iva
                monto_iva
                almacen_articulo {
                    precio
                    articulo_id
                    articulo {
                        articulo_id
                        nombre
                        contenido
                        unidad
                        descripcion
                        tipo
                        extra
                        categoria_id
                        categoria_articulo {
                            nombre
                        }
                    }
                }
                extras {
                    extra_detalle_orden_id
                    detalle_orden_id
                    almacen_articulo_id
                    costo_con_iva
                    monto_iva
                    cantidad
                    almacen_articulo {
                        almacen_articulo_id
                        articulo_id
                        precio
                        articulo {
                            nombre
                            contenido
                            unidad
                            descripcion
                            categoria_id
                            tipo
                            extra
                            categoria_articulo {
                                nombre
                            }
                        }
                    }
                }
            }
            easyrewards_id
            pago_id
            pagos {
                pago_id
                fecha_pago
                total
                ticket_id
                detalles_pago {
                    detalle_pago_id
                    pago_id
                    ultimos_digitos
                    subtotal
                    tipo_pago
                    numero_referencia
                    easyrewards_id
                }
            }
            propina {
                total
                propina_id
                detalles_pago {
                    numero_referencia
                    ultimos_digitos
                    tipo_pago
                    subtotal
                }
            }
            mesa {
                numero_mesa
            }
        }
    }
`
export type OrdenesComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<OrdenesQuery, OrdenesQueryVariables>,
    "query"
> &
    ({ variables: OrdenesQueryVariables; skip?: boolean } | { skip: boolean })

export const OrdenesComponent = (props: OrdenesComponentProps) => (
    <ApolloReactComponents.Query<OrdenesQuery, OrdenesQueryVariables> query={OrdenesDocument} {...props} />
)

/**
 * __useOrdenesQuery__
 *
 * To run a query within a React component, call `useOrdenesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdenesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdenesQuery({
 *   variables: {
 *      orden_id: // value for 'orden_id'
 *      hotel_id: // value for 'hotel_id'
 *      fecha_registro: // value for 'fecha_registro'
 *   },
 * });
 */
export function useOrdenesQuery(baseOptions: Apollo.QueryHookOptions<OrdenesQuery, OrdenesQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<OrdenesQuery, OrdenesQueryVariables>(OrdenesDocument, options)
}
export function useOrdenesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdenesQuery, OrdenesQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<OrdenesQuery, OrdenesQueryVariables>(OrdenesDocument, options)
}
export type OrdenesQueryHookResult = ReturnType<typeof useOrdenesQuery>
export type OrdenesLazyQueryHookResult = ReturnType<typeof useOrdenesLazyQuery>
export type OrdenesQueryResult = Apollo.QueryResult<OrdenesQuery, OrdenesQueryVariables>
export const OrdenDocument = gql`
    query Orden($orden_id: ID!) {
        orden(orden_id: $orden_id) {
            orden
            orden_id
            estado_pago
            estado_orden
            origen_orden
            fecha_registro
            fecha_modificacion
            total_con_iva
            total_sin_iva
            colaborador_id
            renta_id
            corte_id
            turno_id
            turno {
                nombre
            }
            consumo_interno_colaborador_id
            colaborador_consumo_interno {
                nombre
                apellido_paterno
                apellido_paterno
            }
            colaborador_entrega {
                nombre
                apellido_materno
                apellido_paterno
            }
            renta {
                habitacion_id
                habitacion {
                    numero_habitacion
                    tipo_habitacion_id
                    tipo_habitacion {
                        nombre
                    }
                }
            }
            detalles_orden {
                detalle_orden_id
                estado
                motivo_cancelacion
                fecha_cancelacion
                reembolso
                comentarios
                almacen_articulo_id
                cantidad
                costo_con_iva
                monto_iva
                almacen_articulo {
                    precio
                    articulo_id
                    almacen_articulo_id
                    articulo {
                        articulo_id
                        nombre
                        contenido
                        unidad
                        descripcion
                        tipo
                        extra
                        categoria_id
                        categoria_articulo {
                            nombre
                        }
                    }
                }
                extras {
                    extra_detalle_orden_id
                    detalle_orden_id
                    almacen_articulo_id
                    costo_con_iva
                    monto_iva
                    cantidad
                    almacen_articulo {
                        almacen_articulo_id
                        articulo_id
                        precio
                        articulo {
                            nombre
                            contenido
                            unidad
                            descripcion
                            categoria_id
                            tipo
                            extra
                            categoria_articulo {
                                nombre
                            }
                        }
                    }
                }
            }
            easyrewards_id
            pago_id
            pagos {
                pago_id
                fecha_pago
                total
                ticket_id
                detalles_pago {
                    detalle_pago_id
                    pago_id
                    ultimos_digitos
                    subtotal
                    tipo_pago
                    numero_referencia
                    easyrewards_id
                }
            }
            propina {
                total
                propina_id
                detalles_pago {
                    numero_referencia
                    ultimos_digitos
                    tipo_pago
                    subtotal
                }
            }
            usuario_id
            usuario {
                nombre
                apellido_materno
                apellido_paterno
            }
            mesa {
                mesa_id
                numero_mesa
                asignacion_actual {
                    mesa_asignada_id
                    orden_id
                    colaborador_asignado_id
                    fecha_cuenta_cerrada
                }
            }
            comandas {
                comanda_id
                estado_comanda
                orden_id
                folio
                detalles_orden(estado: [en_preparacion, por_entregar, entregada, en_entrega]) {
                    detalle_orden_id
                    comanda_id
                    cantidad
                    estado
                    costo_con_iva
                    monto_iva
                    almacen_articulo_id
                    almacen_articulo {
                        almacen_articulo_id
                        precio
                        articulo_id
                        articulo {
                            articulo_id
                            nombre
                            contenido
                            unidad
                            descripcion
                            tipo
                            extra
                            categoria_id
                            categoria_articulo {
                                nombre
                            }
                        }
                    }
                    extras {
                        extra_detalle_orden_id
                        detalle_orden_id
                        almacen_articulo_id
                        costo_con_iva
                        monto_iva
                        cantidad
                        almacen_articulo {
                            almacen_articulo_id
                            articulo_id
                            precio
                            articulo {
                                nombre
                                contenido
                                unidad
                                descripcion
                                categoria_id
                                tipo
                                extra
                                categoria_articulo {
                                    nombre
                                }
                            }
                        }
                    }
                }
                total_comanda
            }
        }
    }
`
export type OrdenComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<OrdenQuery, OrdenQueryVariables>,
    "query"
> &
    ({ variables: OrdenQueryVariables; skip?: boolean } | { skip: boolean })

export const OrdenComponent = (props: OrdenComponentProps) => (
    <ApolloReactComponents.Query<OrdenQuery, OrdenQueryVariables> query={OrdenDocument} {...props} />
)

/**
 * __useOrdenQuery__
 *
 * To run a query within a React component, call `useOrdenQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdenQuery({
 *   variables: {
 *      orden_id: // value for 'orden_id'
 *   },
 * });
 */
export function useOrdenQuery(baseOptions: Apollo.QueryHookOptions<OrdenQuery, OrdenQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<OrdenQuery, OrdenQueryVariables>(OrdenDocument, options)
}
export function useOrdenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdenQuery, OrdenQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<OrdenQuery, OrdenQueryVariables>(OrdenDocument, options)
}
export type OrdenQueryHookResult = ReturnType<typeof useOrdenQuery>
export type OrdenLazyQueryHookResult = ReturnType<typeof useOrdenLazyQuery>
export type OrdenQueryResult = Apollo.QueryResult<OrdenQuery, OrdenQueryVariables>
export const OrdenesPaginadasDocument = gql`
    query OrdenesPaginadas(
        $hotel_id: ID!
        $fecha_registro: DateSearchInput
        $pagination_options: PageOptionsArgs
        $estado: [EstadosOrdenHistorial!]
        $estado_pago: [EstadoPagoOrdenes!]
        $origen: [OrigenesOrden!]
        $turno_id: [ID!]
        $metodo_pago: [TiposPagos!]
        $orden: String
    ) {
        ordenes_paginadas(
            hotel_id: $hotel_id
            fecha_registro: $fecha_registro
            pagination_options: $pagination_options
            estado: $estado
            estado_pago: $estado_pago
            origen: $origen
            turno_id: $turno_id
            metodo_pago: $metodo_pago
            orden: $orden
        ) {
            paginacion {
                pagina_actual
                total_paginas
                total_registros
            }
            conteos {
                total
                room_service
                mostrador
                restaurante
            }
            ordenes {
                orden
                orden_id
                estado_pago
                estado_orden
                origen_orden
                fecha_registro
                fecha_modificacion
                total_con_iva
                total_sin_iva
                colaborador_id
                renta_id
                turno_id
                turno {
                    nombre
                }
                consumo_interno_colaborador_id
                colaborador_entrega {
                    nombre
                    apellido_materno
                    apellido_paterno
                }
                usuario_id
                usuario {
                    nombre
                }
                renta {
                    habitacion_id
                    habitacion {
                        numero_habitacion
                        tipo_habitacion_id
                        tipo_habitacion {
                            nombre
                        }
                    }
                }
                detalles_orden {
                    detalle_orden_id
                    estado
                    motivo_cancelacion
                    fecha_cancelacion
                    reembolso
                    comentarios
                    almacen_articulo_id
                    cantidad
                    costo_con_iva
                    monto_iva
                    almacen_articulo {
                        precio
                        articulo_id
                        articulo {
                            articulo_id
                            nombre
                            contenido
                            unidad
                            descripcion
                            tipo
                            extra
                            categoria_id
                            categoria_articulo {
                                nombre
                            }
                        }
                    }
                    extras {
                        extra_detalle_orden_id
                        detalle_orden_id
                        almacen_articulo_id
                        costo_con_iva
                        monto_iva
                        cantidad
                        almacen_articulo {
                            almacen_articulo_id
                            articulo_id
                            precio
                            articulo {
                                nombre
                                contenido
                                unidad
                                descripcion
                                categoria_id
                                tipo
                                extra
                                categoria_articulo {
                                    nombre
                                }
                            }
                        }
                    }
                }
                easyrewards_id
                pago_id
                pagos {
                    pago_id
                    fecha_pago
                    total
                    ticket_id
                    detalles_pago {
                        detalle_pago_id
                        pago_id
                        ultimos_digitos
                        subtotal
                        tipo_pago
                        numero_referencia
                        easyrewards_id
                    }
                }
                propina {
                    total
                    propina_id
                    detalles_pago {
                        numero_referencia
                        ultimos_digitos
                        tipo_pago
                        subtotal
                    }
                }
                mesa {
                    numero_mesa
                }
            }
        }
    }
`
export type OrdenesPaginadasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<OrdenesPaginadasQuery, OrdenesPaginadasQueryVariables>,
    "query"
> &
    ({ variables: OrdenesPaginadasQueryVariables; skip?: boolean } | { skip: boolean })

export const OrdenesPaginadasComponent = (props: OrdenesPaginadasComponentProps) => (
    <ApolloReactComponents.Query<OrdenesPaginadasQuery, OrdenesPaginadasQueryVariables>
        query={OrdenesPaginadasDocument}
        {...props}
    />
)

/**
 * __useOrdenesPaginadasQuery__
 *
 * To run a query within a React component, call `useOrdenesPaginadasQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdenesPaginadasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdenesPaginadasQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      fecha_registro: // value for 'fecha_registro'
 *      pagination_options: // value for 'pagination_options'
 *      estado: // value for 'estado'
 *      estado_pago: // value for 'estado_pago'
 *      origen: // value for 'origen'
 *      turno_id: // value for 'turno_id'
 *      metodo_pago: // value for 'metodo_pago'
 *      orden: // value for 'orden'
 *   },
 * });
 */
export function useOrdenesPaginadasQuery(
    baseOptions: Apollo.QueryHookOptions<OrdenesPaginadasQuery, OrdenesPaginadasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<OrdenesPaginadasQuery, OrdenesPaginadasQueryVariables>(OrdenesPaginadasDocument, options)
}
export function useOrdenesPaginadasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<OrdenesPaginadasQuery, OrdenesPaginadasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<OrdenesPaginadasQuery, OrdenesPaginadasQueryVariables>(OrdenesPaginadasDocument, options)
}
export type OrdenesPaginadasQueryHookResult = ReturnType<typeof useOrdenesPaginadasQuery>
export type OrdenesPaginadasLazyQueryHookResult = ReturnType<typeof useOrdenesPaginadasLazyQuery>
export type OrdenesPaginadasQueryResult = Apollo.QueryResult<OrdenesPaginadasQuery, OrdenesPaginadasQueryVariables>
export const GetRentaForPagosPendientesDocument = gql`
    query GetRentaForPagosPendientes($renta_id: ID!) {
        renta(renta_id: $renta_id) {
            renta_id
            usuario_id
            estado
            conceptos_pendientes {
                estancia_pendiente {
                    usuario_id
                    folio
                    detalle
                    precio
                    cantidad
                    iva
                    total
                    easyrewards_id
                    extras_checkin {
                        extra_id
                        detalle
                        precio
                        cantidad
                        iva
                        total
                    }
                    colaborador {
                        colaborador_id
                        nombre
                    }
                }
                extras_pendientes {
                    venta_id
                    usuario_id
                    folio
                    conceptos {
                        extra_id
                        detalle
                        precio
                        cantidad
                        iva
                        total
                    }
                    colaborador {
                        colaborador_id
                        nombre
                    }
                }
            }
            saldo_pendiente_estancia
            saldo_pendiente_ordenes
            habitacion_id
            easyrewards_id
            habitacion {
                numero_habitacion
                tipo_habitacion_id
                tipo_habitacion {
                    nombre
                }
            }
            tarifa_id
            tarifa {
                costo_early_checkin
            }
        }
    }
`
export type GetRentaForPagosPendientesComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetRentaForPagosPendientesQuery,
        GetRentaForPagosPendientesQueryVariables
    >,
    "query"
> &
    ({ variables: GetRentaForPagosPendientesQueryVariables; skip?: boolean } | { skip: boolean })

export const GetRentaForPagosPendientesComponent = (props: GetRentaForPagosPendientesComponentProps) => (
    <ApolloReactComponents.Query<GetRentaForPagosPendientesQuery, GetRentaForPagosPendientesQueryVariables>
        query={GetRentaForPagosPendientesDocument}
        {...props}
    />
)

/**
 * __useGetRentaForPagosPendientesQuery__
 *
 * To run a query within a React component, call `useGetRentaForPagosPendientesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentaForPagosPendientesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentaForPagosPendientesQuery({
 *   variables: {
 *      renta_id: // value for 'renta_id'
 *   },
 * });
 */
export function useGetRentaForPagosPendientesQuery(
    baseOptions: Apollo.QueryHookOptions<GetRentaForPagosPendientesQuery, GetRentaForPagosPendientesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetRentaForPagosPendientesQuery, GetRentaForPagosPendientesQueryVariables>(
        GetRentaForPagosPendientesDocument,
        options
    )
}
export function useGetRentaForPagosPendientesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetRentaForPagosPendientesQuery, GetRentaForPagosPendientesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetRentaForPagosPendientesQuery, GetRentaForPagosPendientesQueryVariables>(
        GetRentaForPagosPendientesDocument,
        options
    )
}
export type GetRentaForPagosPendientesQueryHookResult = ReturnType<typeof useGetRentaForPagosPendientesQuery>
export type GetRentaForPagosPendientesLazyQueryHookResult = ReturnType<typeof useGetRentaForPagosPendientesLazyQuery>
export type GetRentaForPagosPendientesQueryResult = Apollo.QueryResult<
    GetRentaForPagosPendientesQuery,
    GetRentaForPagosPendientesQueryVariables
>
export const GetOrdenesPagosPendientesDocument = gql`
    query GetOrdenesPagosPendientes($renta_id: ID, $orden_id: [ID!], $estado_pago: [EstadoPagoOrdenes!]) {
        ordenes(renta_id: $renta_id, orden_id: $orden_id, estado_pago: $estado_pago) {
            orden_id
            orden
            total_con_iva
            saldo_pendiente
            estado_pago
            estado_orden
            usuario_id
            colaborador_id
            colaborador_entrega {
                colaborador_id
                nombre
                apellido_materno
                apellido_paterno
                __typename
            }
            detalles_orden(estado: [en_preparacion, en_entrega, por_entregar, entregada]) {
                detalle_orden_id
                estado
                almacen_articulo_id
                cantidad
                almacen_articulo {
                    almacen_articulo_id
                    articulo_id
                    articulo {
                        nombre
                        contenido
                        unidad
                        descripcion
                        tipo
                        extra
                        categoria_id
                        categoria_articulo {
                            nombre
                            __typename
                        }
                        __typename
                    }
                    __typename
                }
                extras {
                    extra_detalle_orden_id
                    detalle_orden_id
                    almacen_articulo_id
                    costo_con_iva
                    monto_iva
                    cantidad
                    almacen_articulo {
                        almacen_articulo_id
                        articulo_id
                        articulo {
                            nombre
                            contenido
                            unidad
                            descripcion
                            categoria_id
                            categoria_articulo {
                                nombre
                                __typename
                            }
                            __typename
                        }
                        __typename
                    }
                    __typename
                }
                costo_con_iva
                monto_iva
                __typename
            }
            detalle_pago_pre_cargado {
                subtotal
                tipo_pago
                ultimos_digitos
                numero_referencia
            }
            easyrewards_id
            __typename
        }
    }
`
export type GetOrdenesPagosPendientesComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetOrdenesPagosPendientesQuery,
        GetOrdenesPagosPendientesQueryVariables
    >,
    "query"
>

export const GetOrdenesPagosPendientesComponent = (props: GetOrdenesPagosPendientesComponentProps) => (
    <ApolloReactComponents.Query<GetOrdenesPagosPendientesQuery, GetOrdenesPagosPendientesQueryVariables>
        query={GetOrdenesPagosPendientesDocument}
        {...props}
    />
)

/**
 * __useGetOrdenesPagosPendientesQuery__
 *
 * To run a query within a React component, call `useGetOrdenesPagosPendientesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdenesPagosPendientesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdenesPagosPendientesQuery({
 *   variables: {
 *      renta_id: // value for 'renta_id'
 *      orden_id: // value for 'orden_id'
 *      estado_pago: // value for 'estado_pago'
 *   },
 * });
 */
export function useGetOrdenesPagosPendientesQuery(
    baseOptions?: Apollo.QueryHookOptions<GetOrdenesPagosPendientesQuery, GetOrdenesPagosPendientesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetOrdenesPagosPendientesQuery, GetOrdenesPagosPendientesQueryVariables>(
        GetOrdenesPagosPendientesDocument,
        options
    )
}
export function useGetOrdenesPagosPendientesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetOrdenesPagosPendientesQuery, GetOrdenesPagosPendientesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetOrdenesPagosPendientesQuery, GetOrdenesPagosPendientesQueryVariables>(
        GetOrdenesPagosPendientesDocument,
        options
    )
}
export type GetOrdenesPagosPendientesQueryHookResult = ReturnType<typeof useGetOrdenesPagosPendientesQuery>
export type GetOrdenesPagosPendientesLazyQueryHookResult = ReturnType<typeof useGetOrdenesPagosPendientesLazyQuery>
export type GetOrdenesPagosPendientesQueryResult = Apollo.QueryResult<
    GetOrdenesPagosPendientesQuery,
    GetOrdenesPagosPendientesQueryVariables
>
export const PagarOrdenesDocument = gql`
    mutation PagarOrdenes($pay_orden_input: PayRentaInput!) {
        pagar_ordenes_pendientes(PayOrdenInput: $pay_orden_input)
    }
`
export type PagarOrdenesMutationFn = Apollo.MutationFunction<PagarOrdenesMutation, PagarOrdenesMutationVariables>
export type PagarOrdenesComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<PagarOrdenesMutation, PagarOrdenesMutationVariables>,
    "mutation"
>

export const PagarOrdenesComponent = (props: PagarOrdenesComponentProps) => (
    <ApolloReactComponents.Mutation<PagarOrdenesMutation, PagarOrdenesMutationVariables>
        mutation={PagarOrdenesDocument}
        {...props}
    />
)

/**
 * __usePagarOrdenesMutation__
 *
 * To run a mutation, you first call `usePagarOrdenesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePagarOrdenesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pagarOrdenesMutation, { data, loading, error }] = usePagarOrdenesMutation({
 *   variables: {
 *      pay_orden_input: // value for 'pay_orden_input'
 *   },
 * });
 */
export function usePagarOrdenesMutation(
    baseOptions?: Apollo.MutationHookOptions<PagarOrdenesMutation, PagarOrdenesMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<PagarOrdenesMutation, PagarOrdenesMutationVariables>(PagarOrdenesDocument, options)
}
export type PagarOrdenesMutationHookResult = ReturnType<typeof usePagarOrdenesMutation>
export type PagarOrdenesMutationResult = Apollo.MutationResult<PagarOrdenesMutation>
export type PagarOrdenesMutationOptions = Apollo.BaseMutationOptions<
    PagarOrdenesMutation,
    PagarOrdenesMutationVariables
>
export const GetCategoriasRsDocument = gql`
    query GetCategoriasRS($hotel_id: ID!) {
        categorias_articulos(hotel_id: $hotel_id, eliminado: false) {
            categoria_id
            nombre
        }
    }
`
export type GetCategoriasRsComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetCategoriasRsQuery, GetCategoriasRsQueryVariables>,
    "query"
> &
    ({ variables: GetCategoriasRsQueryVariables; skip?: boolean } | { skip: boolean })

export const GetCategoriasRsComponent = (props: GetCategoriasRsComponentProps) => (
    <ApolloReactComponents.Query<GetCategoriasRsQuery, GetCategoriasRsQueryVariables>
        query={GetCategoriasRsDocument}
        {...props}
    />
)

/**
 * __useGetCategoriasRsQuery__
 *
 * To run a query within a React component, call `useGetCategoriasRsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriasRsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriasRsQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetCategoriasRsQuery(
    baseOptions: Apollo.QueryHookOptions<GetCategoriasRsQuery, GetCategoriasRsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetCategoriasRsQuery, GetCategoriasRsQueryVariables>(GetCategoriasRsDocument, options)
}
export function useGetCategoriasRsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriasRsQuery, GetCategoriasRsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetCategoriasRsQuery, GetCategoriasRsQueryVariables>(GetCategoriasRsDocument, options)
}
export type GetCategoriasRsQueryHookResult = ReturnType<typeof useGetCategoriasRsQuery>
export type GetCategoriasRsLazyQueryHookResult = ReturnType<typeof useGetCategoriasRsLazyQuery>
export type GetCategoriasRsQueryResult = Apollo.QueryResult<GetCategoriasRsQuery, GetCategoriasRsQueryVariables>
export const GetArticulosRoomServiceDocument = gql`
    query GetArticulosRoomService(
        $hotel_id: ID!
        $pagination_options: PageOptionsArgs!
        $filter_in_categories: [ID!]
        $nombre_articulo: String
    ) {
        almacenes_articulos(
            hotel_id: $hotel_id
            eliminado: false
            filter_estado_articulo: activado
            filter_tipo_articulo: [venta, receta]
            filter_tipo_almacen: suministro
            categoria_articulo_filters: { in: $filter_in_categories }
            filter_duplicados: true
            nombre_articulo_filters: { like: $nombre_articulo }
            pagination_options: $pagination_options
            estado_almacen_articulo: [activado, disponible, por_agotarse, agotado]
        ) {
            paginacion {
                pagina_actual
                total_paginas
            }
            almacenes_articulos {
                costo
                almacen_articulo_id
                almacen_id
                articulo_id
                precio
                estado
                cantidad
                categoria_id
                categoria_articulo {
                    categoria_id
                    nombre
                }
                almacen {
                    almacen_id
                    nombre
                }
                articulo {
                    articulo_id
                    cantidad_minima
                    categoria_id
                    contenido
                    descripcion
                    tipo
                    extra
                    foto
                    fecha_registro
                    marca
                    nombre
                    unidad
                    ingredientes_recetas {
                        almacen_articulo_id
                        articulo {
                            nombre
                        }
                        almacen_articulo {
                            estado
                        }
                    }
                    sku
                    categoria_articulo {
                        categoria_id
                        nombre
                    }
                }
            }
        }
    }
`
export type GetArticulosRoomServiceComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetArticulosRoomServiceQuery, GetArticulosRoomServiceQueryVariables>,
    "query"
> &
    ({ variables: GetArticulosRoomServiceQueryVariables; skip?: boolean } | { skip: boolean })

export const GetArticulosRoomServiceComponent = (props: GetArticulosRoomServiceComponentProps) => (
    <ApolloReactComponents.Query<GetArticulosRoomServiceQuery, GetArticulosRoomServiceQueryVariables>
        query={GetArticulosRoomServiceDocument}
        {...props}
    />
)

/**
 * __useGetArticulosRoomServiceQuery__
 *
 * To run a query within a React component, call `useGetArticulosRoomServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticulosRoomServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticulosRoomServiceQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      pagination_options: // value for 'pagination_options'
 *      filter_in_categories: // value for 'filter_in_categories'
 *      nombre_articulo: // value for 'nombre_articulo'
 *   },
 * });
 */
export function useGetArticulosRoomServiceQuery(
    baseOptions: Apollo.QueryHookOptions<GetArticulosRoomServiceQuery, GetArticulosRoomServiceQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetArticulosRoomServiceQuery, GetArticulosRoomServiceQueryVariables>(
        GetArticulosRoomServiceDocument,
        options
    )
}
export function useGetArticulosRoomServiceLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetArticulosRoomServiceQuery, GetArticulosRoomServiceQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetArticulosRoomServiceQuery, GetArticulosRoomServiceQueryVariables>(
        GetArticulosRoomServiceDocument,
        options
    )
}
export type GetArticulosRoomServiceQueryHookResult = ReturnType<typeof useGetArticulosRoomServiceQuery>
export type GetArticulosRoomServiceLazyQueryHookResult = ReturnType<typeof useGetArticulosRoomServiceLazyQuery>
export type GetArticulosRoomServiceQueryResult = Apollo.QueryResult<
    GetArticulosRoomServiceQuery,
    GetArticulosRoomServiceQueryVariables
>
export const CreateRentaDocument = gql`
    mutation CreateRenta($datos_renta: CreateRentaInput!) {
        crear_renta(datos_renta: $datos_renta) {
            renta {
                renta_id
                folio
                horas_extra
                fecha_fin
                fecha_registro
                fecha_salida
                numero_personas
                saldo
            }
            ticket {
                ticket_id
            }
        }
    }
`
export type CreateRentaMutationFn = Apollo.MutationFunction<CreateRentaMutation, CreateRentaMutationVariables>
export type CreateRentaComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CreateRentaMutation, CreateRentaMutationVariables>,
    "mutation"
>

export const CreateRentaComponent = (props: CreateRentaComponentProps) => (
    <ApolloReactComponents.Mutation<CreateRentaMutation, CreateRentaMutationVariables>
        mutation={CreateRentaDocument}
        {...props}
    />
)

/**
 * __useCreateRentaMutation__
 *
 * To run a mutation, you first call `useCreateRentaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRentaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRentaMutation, { data, loading, error }] = useCreateRentaMutation({
 *   variables: {
 *      datos_renta: // value for 'datos_renta'
 *   },
 * });
 */
export function useCreateRentaMutation(
    baseOptions?: Apollo.MutationHookOptions<CreateRentaMutation, CreateRentaMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CreateRentaMutation, CreateRentaMutationVariables>(CreateRentaDocument, options)
}
export type CreateRentaMutationHookResult = ReturnType<typeof useCreateRentaMutation>
export type CreateRentaMutationResult = Apollo.MutationResult<CreateRentaMutation>
export type CreateRentaMutationOptions = Apollo.BaseMutationOptions<CreateRentaMutation, CreateRentaMutationVariables>
export const CheckInDocument = gql`
    mutation CheckIn($datos_checkIn: CheckInInput!) {
        checkIn(ChekInInput: $datos_checkIn)
    }
`
export type CheckInMutationFn = Apollo.MutationFunction<CheckInMutation, CheckInMutationVariables>
export type CheckInComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CheckInMutation, CheckInMutationVariables>,
    "mutation"
>

export const CheckInComponent = (props: CheckInComponentProps) => (
    <ApolloReactComponents.Mutation<CheckInMutation, CheckInMutationVariables> mutation={CheckInDocument} {...props} />
)

/**
 * __useCheckInMutation__
 *
 * To run a mutation, you first call `useCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkInMutation, { data, loading, error }] = useCheckInMutation({
 *   variables: {
 *      datos_checkIn: // value for 'datos_checkIn'
 *   },
 * });
 */
export function useCheckInMutation(
    baseOptions?: Apollo.MutationHookOptions<CheckInMutation, CheckInMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CheckInMutation, CheckInMutationVariables>(CheckInDocument, options)
}
export type CheckInMutationHookResult = ReturnType<typeof useCheckInMutation>
export type CheckInMutationResult = Apollo.MutationResult<CheckInMutation>
export type CheckInMutationOptions = Apollo.BaseMutationOptions<CheckInMutation, CheckInMutationVariables>
export const TarifasDocument = gql`
    query Tarifas($tipo_habitacion_id: ID!, $hotel_id: ID!) {
        tarifas(tipo_habitacion_id: $tipo_habitacion_id, hotel_id: $hotel_id, eliminado: false, visible_venta: true) {
            tarifa_id
            nombre
            eliminado
            estatus
            duracion_renta
            costo_habitacion
            costo_persona_extra
            costo_early_checkin
            costo_hospedaje_extra
            costo_hora_extra
            personas_extra_max
            tipo_habitacion_id
            horas_extra_max
            hora_checkin
            hora_checkout
            tipo_alojamiento
            tipo_tarifa
            fecha_final
            fecha_inicio
            hora_final
            hora_inicio
            dias_disponibles
        }
    }
`
export type TarifasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<TarifasQuery, TarifasQueryVariables>,
    "query"
> &
    ({ variables: TarifasQueryVariables; skip?: boolean } | { skip: boolean })

export const TarifasComponent = (props: TarifasComponentProps) => (
    <ApolloReactComponents.Query<TarifasQuery, TarifasQueryVariables> query={TarifasDocument} {...props} />
)

/**
 * __useTarifasQuery__
 *
 * To run a query within a React component, call `useTarifasQuery` and pass it any options that fit your needs.
 * When your component renders, `useTarifasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTarifasQuery({
 *   variables: {
 *      tipo_habitacion_id: // value for 'tipo_habitacion_id'
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useTarifasQuery(baseOptions: Apollo.QueryHookOptions<TarifasQuery, TarifasQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<TarifasQuery, TarifasQueryVariables>(TarifasDocument, options)
}
export function useTarifasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TarifasQuery, TarifasQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<TarifasQuery, TarifasQueryVariables>(TarifasDocument, options)
}
export type TarifasQueryHookResult = ReturnType<typeof useTarifasQuery>
export type TarifasLazyQueryHookResult = ReturnType<typeof useTarifasLazyQuery>
export type TarifasQueryResult = Apollo.QueryResult<TarifasQuery, TarifasQueryVariables>
export const GetVehiculoDataDocument = gql`
    query GetVehiculoData($placaInput: GetVehiculoDataByPlacaInput!) {
        getVehiculoDataByPlaca(placa: $placaInput) {
            vehiculo {
                matricula
                marca
                modelo
                color
            }
        }
    }
`
export type GetVehiculoDataComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetVehiculoDataQuery, GetVehiculoDataQueryVariables>,
    "query"
> &
    ({ variables: GetVehiculoDataQueryVariables; skip?: boolean } | { skip: boolean })

export const GetVehiculoDataComponent = (props: GetVehiculoDataComponentProps) => (
    <ApolloReactComponents.Query<GetVehiculoDataQuery, GetVehiculoDataQueryVariables>
        query={GetVehiculoDataDocument}
        {...props}
    />
)

/**
 * __useGetVehiculoDataQuery__
 *
 * To run a query within a React component, call `useGetVehiculoDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehiculoDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehiculoDataQuery({
 *   variables: {
 *      placaInput: // value for 'placaInput'
 *   },
 * });
 */
export function useGetVehiculoDataQuery(
    baseOptions: Apollo.QueryHookOptions<GetVehiculoDataQuery, GetVehiculoDataQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetVehiculoDataQuery, GetVehiculoDataQueryVariables>(GetVehiculoDataDocument, options)
}
export function useGetVehiculoDataLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetVehiculoDataQuery, GetVehiculoDataQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetVehiculoDataQuery, GetVehiculoDataQueryVariables>(GetVehiculoDataDocument, options)
}
export type GetVehiculoDataQueryHookResult = ReturnType<typeof useGetVehiculoDataQuery>
export type GetVehiculoDataLazyQueryHookResult = ReturnType<typeof useGetVehiculoDataLazyQuery>
export type GetVehiculoDataQueryResult = Apollo.QueryResult<GetVehiculoDataQuery, GetVehiculoDataQueryVariables>
export const PlacasPendientesDocument = gql`
    query PlacasPendientes($hotel_id: ID!, $matricula: String!, $limite: Int) {
        placas_pendientes(hotel_id: $hotel_id, matricula: $matricula, limite: $limite) {
            historial_vehiculo_id
            vehiculo_id
            vehiculo {
                data {
                    matricula
                    marca
                    color
                    modelo
                }
            }
        }
    }
`
export type PlacasPendientesComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<PlacasPendientesQuery, PlacasPendientesQueryVariables>,
    "query"
> &
    ({ variables: PlacasPendientesQueryVariables; skip?: boolean } | { skip: boolean })

export const PlacasPendientesComponent = (props: PlacasPendientesComponentProps) => (
    <ApolloReactComponents.Query<PlacasPendientesQuery, PlacasPendientesQueryVariables>
        query={PlacasPendientesDocument}
        {...props}
    />
)

/**
 * __usePlacasPendientesQuery__
 *
 * To run a query within a React component, call `usePlacasPendientesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlacasPendientesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlacasPendientesQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      matricula: // value for 'matricula'
 *      limite: // value for 'limite'
 *   },
 * });
 */
export function usePlacasPendientesQuery(
    baseOptions: Apollo.QueryHookOptions<PlacasPendientesQuery, PlacasPendientesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<PlacasPendientesQuery, PlacasPendientesQueryVariables>(PlacasPendientesDocument, options)
}
export function usePlacasPendientesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<PlacasPendientesQuery, PlacasPendientesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<PlacasPendientesQuery, PlacasPendientesQueryVariables>(PlacasPendientesDocument, options)
}
export type PlacasPendientesQueryHookResult = ReturnType<typeof usePlacasPendientesQuery>
export type PlacasPendientesLazyQueryHookResult = ReturnType<typeof usePlacasPendientesLazyQuery>
export type PlacasPendientesQueryResult = Apollo.QueryResult<PlacasPendientesQuery, PlacasPendientesQueryVariables>
export const GetArticulosSearchTableDocument = gql`
    query GetArticulosSearchTable($hotel_id: ID!, $pagination_options: PageOptionsArgs!, $nameFilter: String!) {
        almacenes_articulos(
            hotel_id: $hotel_id
            eliminado: false
            nombre_articulo_filters: { like: $nameFilter }
            filter_estado_articulo: activado
            filter_tipo_articulo: [venta, insumo]
            filter_duplicados: true
            pagination_options: $pagination_options
        ) {
            paginacion {
                pagina_actual
                total_paginas
            }
            almacenes_articulos {
                costo
                almacen_articulo_id
                almacen_id
                articulo_id
                precio
                estado
                cantidad
                eliminado
                fecha_movimiento
                hotel_id
                almacen {
                    almacen_id
                    nombre
                }
                articulo {
                    articulo_id
                    cantidad_minima
                    categoria_id
                    contenido
                    descripcion
                    eliminado
                    estado
                    extra
                    fecha_eliminado
                    fecha_registro
                    folio
                    folio_articulo
                    foto
                    marca
                    nombre
                    sku
                    stock
                    tipo
                    unidad
                    categoria_articulo {
                        categoria_id
                        nombre
                    }
                    almacenes_articulos(hotel_id: $hotel_id) {
                        almacen_articulo_id
                        almacen_id
                        cantidad
                    }
                }
                ultimo_surtido {
                    almacen_articulo_id
                    cantidad
                    colaborador_id
                    comentario
                    costo_total
                    costo_unitario
                    fecha_ingreso
                    folio
                    hotel_id
                    numero_orden_factura
                    surtido_id
                    tipo
                }
            }
        }
    }
`
export type GetArticulosSearchTableComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetArticulosSearchTableQuery, GetArticulosSearchTableQueryVariables>,
    "query"
> &
    ({ variables: GetArticulosSearchTableQueryVariables; skip?: boolean } | { skip: boolean })

export const GetArticulosSearchTableComponent = (props: GetArticulosSearchTableComponentProps) => (
    <ApolloReactComponents.Query<GetArticulosSearchTableQuery, GetArticulosSearchTableQueryVariables>
        query={GetArticulosSearchTableDocument}
        {...props}
    />
)

/**
 * __useGetArticulosSearchTableQuery__
 *
 * To run a query within a React component, call `useGetArticulosSearchTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticulosSearchTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticulosSearchTableQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      pagination_options: // value for 'pagination_options'
 *      nameFilter: // value for 'nameFilter'
 *   },
 * });
 */
export function useGetArticulosSearchTableQuery(
    baseOptions: Apollo.QueryHookOptions<GetArticulosSearchTableQuery, GetArticulosSearchTableQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetArticulosSearchTableQuery, GetArticulosSearchTableQueryVariables>(
        GetArticulosSearchTableDocument,
        options
    )
}
export function useGetArticulosSearchTableLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetArticulosSearchTableQuery, GetArticulosSearchTableQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetArticulosSearchTableQuery, GetArticulosSearchTableQueryVariables>(
        GetArticulosSearchTableDocument,
        options
    )
}
export type GetArticulosSearchTableQueryHookResult = ReturnType<typeof useGetArticulosSearchTableQuery>
export type GetArticulosSearchTableLazyQueryHookResult = ReturnType<typeof useGetArticulosSearchTableLazyQuery>
export type GetArticulosSearchTableQueryResult = Apollo.QueryResult<
    GetArticulosSearchTableQuery,
    GetArticulosSearchTableQueryVariables
>
export const GetTurnosAtencionDocument = gql`
    query GetTurnosAtencion($hotel_id: ID!, $estado: [EstadosTurnosAtencion!]) {
        turnos_atencion(hotel_id: $hotel_id, estado: $estado) {
            turno_atencion_id
            usuario_id
            fecha_registro
            folio
            nombre_o_matricula
            folio_turno
            tipo_habitacion_id
            tipo_habitacion {
                tipo_habitacion_id
                nombre
            }
            colaborador {
                nombre
            }
        }
    }
`
export type GetTurnosAtencionComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<GetTurnosAtencionQuery, GetTurnosAtencionQueryVariables>,
    "query"
> &
    ({ variables: GetTurnosAtencionQueryVariables; skip?: boolean } | { skip: boolean })

export const GetTurnosAtencionComponent = (props: GetTurnosAtencionComponentProps) => (
    <ApolloReactComponents.Query<GetTurnosAtencionQuery, GetTurnosAtencionQueryVariables>
        query={GetTurnosAtencionDocument}
        {...props}
    />
)

/**
 * __useGetTurnosAtencionQuery__
 *
 * To run a query within a React component, call `useGetTurnosAtencionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTurnosAtencionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTurnosAtencionQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      estado: // value for 'estado'
 *   },
 * });
 */
export function useGetTurnosAtencionQuery(
    baseOptions: Apollo.QueryHookOptions<GetTurnosAtencionQuery, GetTurnosAtencionQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetTurnosAtencionQuery, GetTurnosAtencionQueryVariables>(GetTurnosAtencionDocument, options)
}
export function useGetTurnosAtencionLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetTurnosAtencionQuery, GetTurnosAtencionQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetTurnosAtencionQuery, GetTurnosAtencionQueryVariables>(
        GetTurnosAtencionDocument,
        options
    )
}
export type GetTurnosAtencionQueryHookResult = ReturnType<typeof useGetTurnosAtencionQuery>
export type GetTurnosAtencionLazyQueryHookResult = ReturnType<typeof useGetTurnosAtencionLazyQuery>
export type GetTurnosAtencionQueryResult = Apollo.QueryResult<GetTurnosAtencionQuery, GetTurnosAtencionQueryVariables>
export const CrearTurnoAtencionDocument = gql`
    mutation CrearTurnoAtencion($input: CreateTurnoAtencionInput!) {
        crear_turno_atencion(crear_turno_atencion_input: $input) {
            turno_atencion_id
            folio_turno
        }
    }
`
export type CrearTurnoAtencionMutationFn = Apollo.MutationFunction<
    CrearTurnoAtencionMutation,
    CrearTurnoAtencionMutationVariables
>
export type CrearTurnoAtencionComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CrearTurnoAtencionMutation, CrearTurnoAtencionMutationVariables>,
    "mutation"
>

export const CrearTurnoAtencionComponent = (props: CrearTurnoAtencionComponentProps) => (
    <ApolloReactComponents.Mutation<CrearTurnoAtencionMutation, CrearTurnoAtencionMutationVariables>
        mutation={CrearTurnoAtencionDocument}
        {...props}
    />
)

/**
 * __useCrearTurnoAtencionMutation__
 *
 * To run a mutation, you first call `useCrearTurnoAtencionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrearTurnoAtencionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crearTurnoAtencionMutation, { data, loading, error }] = useCrearTurnoAtencionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCrearTurnoAtencionMutation(
    baseOptions?: Apollo.MutationHookOptions<CrearTurnoAtencionMutation, CrearTurnoAtencionMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CrearTurnoAtencionMutation, CrearTurnoAtencionMutationVariables>(
        CrearTurnoAtencionDocument,
        options
    )
}
export type CrearTurnoAtencionMutationHookResult = ReturnType<typeof useCrearTurnoAtencionMutation>
export type CrearTurnoAtencionMutationResult = Apollo.MutationResult<CrearTurnoAtencionMutation>
export type CrearTurnoAtencionMutationOptions = Apollo.BaseMutationOptions<
    CrearTurnoAtencionMutation,
    CrearTurnoAtencionMutationVariables
>
export const EliminarTurnoAtencionDocument = gql`
    mutation EliminarTurnoAtencion($input: DeleteTurnoAtencionInput!) {
        eliminar_turno_atencion(eliminar_turno_atencion_input: $input)
    }
`
export type EliminarTurnoAtencionMutationFn = Apollo.MutationFunction<
    EliminarTurnoAtencionMutation,
    EliminarTurnoAtencionMutationVariables
>
export type EliminarTurnoAtencionComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        EliminarTurnoAtencionMutation,
        EliminarTurnoAtencionMutationVariables
    >,
    "mutation"
>

export const EliminarTurnoAtencionComponent = (props: EliminarTurnoAtencionComponentProps) => (
    <ApolloReactComponents.Mutation<EliminarTurnoAtencionMutation, EliminarTurnoAtencionMutationVariables>
        mutation={EliminarTurnoAtencionDocument}
        {...props}
    />
)

/**
 * __useEliminarTurnoAtencionMutation__
 *
 * To run a mutation, you first call `useEliminarTurnoAtencionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEliminarTurnoAtencionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eliminarTurnoAtencionMutation, { data, loading, error }] = useEliminarTurnoAtencionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEliminarTurnoAtencionMutation(
    baseOptions?: Apollo.MutationHookOptions<EliminarTurnoAtencionMutation, EliminarTurnoAtencionMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<EliminarTurnoAtencionMutation, EliminarTurnoAtencionMutationVariables>(
        EliminarTurnoAtencionDocument,
        options
    )
}
export type EliminarTurnoAtencionMutationHookResult = ReturnType<typeof useEliminarTurnoAtencionMutation>
export type EliminarTurnoAtencionMutationResult = Apollo.MutationResult<EliminarTurnoAtencionMutation>
export type EliminarTurnoAtencionMutationOptions = Apollo.BaseMutationOptions<
    EliminarTurnoAtencionMutation,
    EliminarTurnoAtencionMutationVariables
>
export const ActualizarTurnoAtencionDocument = gql`
    mutation ActualizarTurnoAtencion($input: UpdateTurnoAtencionInput!) {
        actualizar_turno_atencion(actualizar_turno_atencion_input: $input) {
            turno_atencion_id
            folio_turno
            estado
        }
    }
`
export type ActualizarTurnoAtencionMutationFn = Apollo.MutationFunction<
    ActualizarTurnoAtencionMutation,
    ActualizarTurnoAtencionMutationVariables
>
export type ActualizarTurnoAtencionComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        ActualizarTurnoAtencionMutation,
        ActualizarTurnoAtencionMutationVariables
    >,
    "mutation"
>

export const ActualizarTurnoAtencionComponent = (props: ActualizarTurnoAtencionComponentProps) => (
    <ApolloReactComponents.Mutation<ActualizarTurnoAtencionMutation, ActualizarTurnoAtencionMutationVariables>
        mutation={ActualizarTurnoAtencionDocument}
        {...props}
    />
)

/**
 * __useActualizarTurnoAtencionMutation__
 *
 * To run a mutation, you first call `useActualizarTurnoAtencionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActualizarTurnoAtencionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actualizarTurnoAtencionMutation, { data, loading, error }] = useActualizarTurnoAtencionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActualizarTurnoAtencionMutation(
    baseOptions?: Apollo.MutationHookOptions<ActualizarTurnoAtencionMutation, ActualizarTurnoAtencionMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ActualizarTurnoAtencionMutation, ActualizarTurnoAtencionMutationVariables>(
        ActualizarTurnoAtencionDocument,
        options
    )
}
export type ActualizarTurnoAtencionMutationHookResult = ReturnType<typeof useActualizarTurnoAtencionMutation>
export type ActualizarTurnoAtencionMutationResult = Apollo.MutationResult<ActualizarTurnoAtencionMutation>
export type ActualizarTurnoAtencionMutationOptions = Apollo.BaseMutationOptions<
    ActualizarTurnoAtencionMutation,
    ActualizarTurnoAtencionMutationVariables
>
export const Auth_UserDocument = gql`
    mutation auth_user($codigo: String, $template_sample: String) {
        validar_codigo_huella_autorizacion(codigo: $codigo) {
            usuario {
                apellido_materno
                apellido_paterno
                fecha_registro
                nombre
                origen
                pais
                puesto_rol
                telefono
                tiene_huella
                usuario
                usuario_id
                verificado
                roles {
                    nombre
                    __typename
                }
            }
            usuario_autorizado
        }
    }
`
export type Auth_UserMutationFn = Apollo.MutationFunction<Auth_UserMutation, Auth_UserMutationVariables>
export type Auth_UserComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<Auth_UserMutation, Auth_UserMutationVariables>,
    "mutation"
>

export const Auth_UserComponent = (props: Auth_UserComponentProps) => (
    <ApolloReactComponents.Mutation<Auth_UserMutation, Auth_UserMutationVariables>
        mutation={Auth_UserDocument}
        {...props}
    />
)

/**
 * __useAuth_UserMutation__
 *
 * To run a mutation, you first call `useAuth_UserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuth_UserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authUserMutation, { data, loading, error }] = useAuth_UserMutation({
 *   variables: {
 *      codigo: // value for 'codigo'
 *      template_sample: // value for 'template_sample'
 *   },
 * });
 */
export function useAuth_UserMutation(
    baseOptions?: Apollo.MutationHookOptions<Auth_UserMutation, Auth_UserMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<Auth_UserMutation, Auth_UserMutationVariables>(Auth_UserDocument, options)
}
export type Auth_UserMutationHookResult = ReturnType<typeof useAuth_UserMutation>
export type Auth_UserMutationResult = Apollo.MutationResult<Auth_UserMutation>
export type Auth_UserMutationOptions = Apollo.BaseMutationOptions<Auth_UserMutation, Auth_UserMutationVariables>
export const GetColaboradoresForPropinaDropDocument = gql`
    query GetColaboradoresForPropinaDrop($hotel_id: ID) {
        hotel_colaboradores(hotel_id: $hotel_id, eliminado: false) {
            colaborador_id
            colaborador {
                colaborador_id
                nombre
                apellido_paterno
                apellido_materno
                area {
                    area_id
                    nombre
                }
            }
        }
    }
`
export type GetColaboradoresForPropinaDropComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetColaboradoresForPropinaDropQuery,
        GetColaboradoresForPropinaDropQueryVariables
    >,
    "query"
>

export const GetColaboradoresForPropinaDropComponent = (props: GetColaboradoresForPropinaDropComponentProps) => (
    <ApolloReactComponents.Query<GetColaboradoresForPropinaDropQuery, GetColaboradoresForPropinaDropQueryVariables>
        query={GetColaboradoresForPropinaDropDocument}
        {...props}
    />
)

/**
 * __useGetColaboradoresForPropinaDropQuery__
 *
 * To run a query within a React component, call `useGetColaboradoresForPropinaDropQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetColaboradoresForPropinaDropQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetColaboradoresForPropinaDropQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *   },
 * });
 */
export function useGetColaboradoresForPropinaDropQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetColaboradoresForPropinaDropQuery,
        GetColaboradoresForPropinaDropQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetColaboradoresForPropinaDropQuery, GetColaboradoresForPropinaDropQueryVariables>(
        GetColaboradoresForPropinaDropDocument,
        options
    )
}
export function useGetColaboradoresForPropinaDropLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetColaboradoresForPropinaDropQuery,
        GetColaboradoresForPropinaDropQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetColaboradoresForPropinaDropQuery, GetColaboradoresForPropinaDropQueryVariables>(
        GetColaboradoresForPropinaDropDocument,
        options
    )
}
export type GetColaboradoresForPropinaDropQueryHookResult = ReturnType<typeof useGetColaboradoresForPropinaDropQuery>
export type GetColaboradoresForPropinaDropLazyQueryHookResult = ReturnType<
    typeof useGetColaboradoresForPropinaDropLazyQuery
>
export type GetColaboradoresForPropinaDropQueryResult = Apollo.QueryResult<
    GetColaboradoresForPropinaDropQuery,
    GetColaboradoresForPropinaDropQueryVariables
>
export const GetAlmacenesArticulosSuggetionsDocument = gql`
    query GetAlmacenesArticulosSuggetions(
        $hotel_id: ID
        $pagination_options: PageOptionsArgs!
        $nameFilter: String!
        $filter_tipo_articulo: [TipoArticulo!]
    ) {
        almacenes_articulos(
            hotel_id: $hotel_id
            eliminado: false
            filter_duplicados: true
            pagination_options: $pagination_options
            nombre_articulo_filters: { like: $nameFilter }
            filter_tipo_articulo: $filter_tipo_articulo
        ) {
            almacenes_articulos {
                almacen_articulo_id
                almacen_id
                articulo_id
                hotel_id
                articulo {
                    articulo_id
                    nombre
                }
            }
        }
    }
`
export type GetAlmacenesArticulosSuggetionsComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetAlmacenesArticulosSuggetionsQuery,
        GetAlmacenesArticulosSuggetionsQueryVariables
    >,
    "query"
> &
    ({ variables: GetAlmacenesArticulosSuggetionsQueryVariables; skip?: boolean } | { skip: boolean })

export const GetAlmacenesArticulosSuggetionsComponent = (props: GetAlmacenesArticulosSuggetionsComponentProps) => (
    <ApolloReactComponents.Query<GetAlmacenesArticulosSuggetionsQuery, GetAlmacenesArticulosSuggetionsQueryVariables>
        query={GetAlmacenesArticulosSuggetionsDocument}
        {...props}
    />
)

/**
 * __useGetAlmacenesArticulosSuggetionsQuery__
 *
 * To run a query within a React component, call `useGetAlmacenesArticulosSuggetionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlmacenesArticulosSuggetionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlmacenesArticulosSuggetionsQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      pagination_options: // value for 'pagination_options'
 *      nameFilter: // value for 'nameFilter'
 *      filter_tipo_articulo: // value for 'filter_tipo_articulo'
 *   },
 * });
 */
export function useGetAlmacenesArticulosSuggetionsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAlmacenesArticulosSuggetionsQuery,
        GetAlmacenesArticulosSuggetionsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetAlmacenesArticulosSuggetionsQuery, GetAlmacenesArticulosSuggetionsQueryVariables>(
        GetAlmacenesArticulosSuggetionsDocument,
        options
    )
}
export function useGetAlmacenesArticulosSuggetionsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAlmacenesArticulosSuggetionsQuery,
        GetAlmacenesArticulosSuggetionsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetAlmacenesArticulosSuggetionsQuery, GetAlmacenesArticulosSuggetionsQueryVariables>(
        GetAlmacenesArticulosSuggetionsDocument,
        options
    )
}
export type GetAlmacenesArticulosSuggetionsQueryHookResult = ReturnType<typeof useGetAlmacenesArticulosSuggetionsQuery>
export type GetAlmacenesArticulosSuggetionsLazyQueryHookResult = ReturnType<
    typeof useGetAlmacenesArticulosSuggetionsLazyQuery
>
export type GetAlmacenesArticulosSuggetionsQueryResult = Apollo.QueryResult<
    GetAlmacenesArticulosSuggetionsQuery,
    GetAlmacenesArticulosSuggetionsQueryVariables
>
export const GetArticulosSearchRoomServiceDocument = gql`
    query GetArticulosSearchRoomService(
        $hotel_id: ID!
        $pagination_options: PageOptionsArgs!
        $nameFilter: String!
        $filter_tipo_articulo: [TipoArticulo!]!
        $filter_tipo_almacen: TipoAlmacen
        $filter_estado_articulo: EstadosArticulo
    ) {
        almacenes_articulos(
            hotel_id: $hotel_id
            eliminado: false
            nombre_articulo_filters: { like: $nameFilter }
            filter_estado_articulo: $filter_estado_articulo
            filter_tipo_articulo: $filter_tipo_articulo
            filter_tipo_almacen: $filter_tipo_almacen
            filter_duplicados: true
            filter_producciones: true
            pagination_options: $pagination_options
        ) {
            paginacion {
                pagina_actual
                total_paginas
            }
            almacenes_articulos {
                costo
                almacen_articulo_id
                almacen_id
                articulo_id
                precio
                estado
                cantidad
                eliminado
                fecha_movimiento
                hotel_id
                almacen {
                    almacen_id
                    nombre
                }
                articulo {
                    articulo_id
                    cantidad_minima
                    categoria_id
                    contenido
                    descripcion
                    eliminado
                    estado
                    extra
                    fecha_eliminado
                    fecha_registro
                    folio
                    folio_articulo
                    foto
                    marca
                    nombre
                    sku
                    stock
                    tipo
                    unidad
                    categoria_articulo {
                        categoria_id
                        nombre
                    }
                }
                ultimo_surtido {
                    almacen_articulo_id
                    cantidad
                    colaborador_id
                    comentario
                    costo_total
                    costo_unitario
                    fecha_ingreso
                    folio
                    hotel_id
                    numero_orden_factura
                    surtido_id
                    tipo
                }
            }
        }
    }
`
export type GetArticulosSearchRoomServiceComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetArticulosSearchRoomServiceQuery,
        GetArticulosSearchRoomServiceQueryVariables
    >,
    "query"
> &
    ({ variables: GetArticulosSearchRoomServiceQueryVariables; skip?: boolean } | { skip: boolean })

export const GetArticulosSearchRoomServiceComponent = (props: GetArticulosSearchRoomServiceComponentProps) => (
    <ApolloReactComponents.Query<GetArticulosSearchRoomServiceQuery, GetArticulosSearchRoomServiceQueryVariables>
        query={GetArticulosSearchRoomServiceDocument}
        {...props}
    />
)

/**
 * __useGetArticulosSearchRoomServiceQuery__
 *
 * To run a query within a React component, call `useGetArticulosSearchRoomServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticulosSearchRoomServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticulosSearchRoomServiceQuery({
 *   variables: {
 *      hotel_id: // value for 'hotel_id'
 *      pagination_options: // value for 'pagination_options'
 *      nameFilter: // value for 'nameFilter'
 *      filter_tipo_articulo: // value for 'filter_tipo_articulo'
 *      filter_tipo_almacen: // value for 'filter_tipo_almacen'
 *      filter_estado_articulo: // value for 'filter_estado_articulo'
 *   },
 * });
 */
export function useGetArticulosSearchRoomServiceQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetArticulosSearchRoomServiceQuery,
        GetArticulosSearchRoomServiceQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetArticulosSearchRoomServiceQuery, GetArticulosSearchRoomServiceQueryVariables>(
        GetArticulosSearchRoomServiceDocument,
        options
    )
}
export function useGetArticulosSearchRoomServiceLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetArticulosSearchRoomServiceQuery,
        GetArticulosSearchRoomServiceQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetArticulosSearchRoomServiceQuery, GetArticulosSearchRoomServiceQueryVariables>(
        GetArticulosSearchRoomServiceDocument,
        options
    )
}
export type GetArticulosSearchRoomServiceQueryHookResult = ReturnType<typeof useGetArticulosSearchRoomServiceQuery>
export type GetArticulosSearchRoomServiceLazyQueryHookResult = ReturnType<
    typeof useGetArticulosSearchRoomServiceLazyQuery
>
export type GetArticulosSearchRoomServiceQueryResult = Apollo.QueryResult<
    GetArticulosSearchRoomServiceQuery,
    GetArticulosSearchRoomServiceQueryVariables
>
export const Obtener_VentasDocument = gql`
    query Obtener_ventas($get_today_sales_input: GetTodaySalesInput!) {
        obtener_ventas(get_today_sales_input: $get_today_sales_input) {
            nombre
            total_extras
            total_ordenes
            total_restaurante
            total_propinas
            total_rentas
            total_reservas
        }
    }
`
export type Obtener_VentasComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<Obtener_VentasQuery, Obtener_VentasQueryVariables>,
    "query"
> &
    ({ variables: Obtener_VentasQueryVariables; skip?: boolean } | { skip: boolean })

export const Obtener_VentasComponent = (props: Obtener_VentasComponentProps) => (
    <ApolloReactComponents.Query<Obtener_VentasQuery, Obtener_VentasQueryVariables>
        query={Obtener_VentasDocument}
        {...props}
    />
)

/**
 * __useObtener_VentasQuery__
 *
 * To run a query within a React component, call `useObtener_VentasQuery` and pass it any options that fit your needs.
 * When your component renders, `useObtener_VentasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObtener_VentasQuery({
 *   variables: {
 *      get_today_sales_input: // value for 'get_today_sales_input'
 *   },
 * });
 */
export function useObtener_VentasQuery(
    baseOptions: Apollo.QueryHookOptions<Obtener_VentasQuery, Obtener_VentasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<Obtener_VentasQuery, Obtener_VentasQueryVariables>(Obtener_VentasDocument, options)
}
export function useObtener_VentasLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<Obtener_VentasQuery, Obtener_VentasQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<Obtener_VentasQuery, Obtener_VentasQueryVariables>(Obtener_VentasDocument, options)
}
export type Obtener_VentasQueryHookResult = ReturnType<typeof useObtener_VentasQuery>
export type Obtener_VentasLazyQueryHookResult = ReturnType<typeof useObtener_VentasLazyQuery>
export type Obtener_VentasQueryResult = Apollo.QueryResult<Obtener_VentasQuery, Obtener_VentasQueryVariables>
export const VentasHabitacionesPorTurnoDocument = gql`
    query VentasHabitacionesPorTurno($sales_rooms_count_by_turnos_input: SalesRoomsCountByTurnosInput!) {
        ventas_habitaciones_por_turno(sales_rooms_count_by_turnos_input: $sales_rooms_count_by_turnos_input) {
            turno_id
            turno {
                hora_entrada
                hora_salida
            }
            nombre
            count_rentas
            count_reservas
            accumulated_sale
        }
    }
`
export type VentasHabitacionesPorTurnoComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        VentasHabitacionesPorTurnoQuery,
        VentasHabitacionesPorTurnoQueryVariables
    >,
    "query"
> &
    ({ variables: VentasHabitacionesPorTurnoQueryVariables; skip?: boolean } | { skip: boolean })

export const VentasHabitacionesPorTurnoComponent = (props: VentasHabitacionesPorTurnoComponentProps) => (
    <ApolloReactComponents.Query<VentasHabitacionesPorTurnoQuery, VentasHabitacionesPorTurnoQueryVariables>
        query={VentasHabitacionesPorTurnoDocument}
        {...props}
    />
)

/**
 * __useVentasHabitacionesPorTurnoQuery__
 *
 * To run a query within a React component, call `useVentasHabitacionesPorTurnoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVentasHabitacionesPorTurnoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVentasHabitacionesPorTurnoQuery({
 *   variables: {
 *      sales_rooms_count_by_turnos_input: // value for 'sales_rooms_count_by_turnos_input'
 *   },
 * });
 */
export function useVentasHabitacionesPorTurnoQuery(
    baseOptions: Apollo.QueryHookOptions<VentasHabitacionesPorTurnoQuery, VentasHabitacionesPorTurnoQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<VentasHabitacionesPorTurnoQuery, VentasHabitacionesPorTurnoQueryVariables>(
        VentasHabitacionesPorTurnoDocument,
        options
    )
}
export function useVentasHabitacionesPorTurnoLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<VentasHabitacionesPorTurnoQuery, VentasHabitacionesPorTurnoQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<VentasHabitacionesPorTurnoQuery, VentasHabitacionesPorTurnoQueryVariables>(
        VentasHabitacionesPorTurnoDocument,
        options
    )
}
export type VentasHabitacionesPorTurnoQueryHookResult = ReturnType<typeof useVentasHabitacionesPorTurnoQuery>
export type VentasHabitacionesPorTurnoLazyQueryHookResult = ReturnType<typeof useVentasHabitacionesPorTurnoLazyQuery>
export type VentasHabitacionesPorTurnoQueryResult = Apollo.QueryResult<
    VentasHabitacionesPorTurnoQuery,
    VentasHabitacionesPorTurnoQueryVariables
>
